{
  "reporting.title": "Export de données personnalisé",
  "reporting.description": "Choisissez votre rapport, la période et les colonnes, puis téléchargez un fichier CSV prêt pour un tableur.",
  "reporting.builder": "Retour au générateur de rapports",
  "reporting.queue": "Ma file de rapports",
  "reporting.queueEmpty": "Vos rapports générés apparaîtront ici.",
  "reporting.design.emptyQueuePage": "Aucun rapport sur cette page.",
  "reporting.design.firstQueuePage": "Revenir à la première page",
  "reporting.reportType": "Type de rapport",
  "reporting.layout": "Disposition du CSV",
  "reporting.layout.SPREADSHEET": "Tableur : analyses en colonnes",
  "reporting.layout.RESULT_LIST": "Liste détaillée : résultats en lignes",
  "reporting.layout.TABLE": "Tableau",
  "reporting.meaning.SPREADSHEET": "Les analyses apparaissent en colonnes pour chaque échantillon. Les résultats répétés utilisent des lignes supplémentaires ; les lectures répétées sans lien restent séparées.",
  "reporting.meaning.RESULT_LIST": "Chaque résultat indépendant apparaît sur sa propre ligne. Les résultats répétés sont conservés.",
  "reporting.meaning.TABLE": "Chaque occurrence enregistrée apparaît sur sa propre ligne.",
  "reporting.dateFrom": "Date de début",
  "reporting.dateTo": "Date de fin",
  "reporting.dates.required": "Obligatoire",
  "reporting.dates.requiredFrom": "Choisissez une date de début.",
  "reporting.dates.requiredTo": "Choisissez une date de fin.",
  "reporting.dates.invalid": "Choisissez une date valide.",
  "reporting.dates.reversed": "La date de fin doit être égale ou postérieure à la date de début.",
  "reporting.dates.tooLong": "Choisissez une période de {days} jours ou moins, les deux dates incluses.",
  "reporting.dates.range": "Choisissez une période ordonnée dans la limite maximale indiquée ci-dessus.",
  "reporting.periodHelp": "Utilise les {dateMeaning} dans le fuseau horaire {timezone}, les deux dates incluses. Période maximale : {days} jours.",
  "reporting.dateAnchor.collectionDate": "dates de prélèvement des échantillons",
  "reporting.dateAnchor.requestDate": "dates de demande d'envoi",
  "reporting.dateAnchor.sentDate": "dates d'envoi au laboratoire de référence",
  "reporting.dateAnchor.eventOrRecordedDate": "dates des événements si connues, sinon dates d'enregistrement (identifiées par Base de date)",
  "reporting.dateAnchor.dateOfEvent": "dates des événements non conformes",
  "reporting.dateAnchor.enteredDate": "dates de rejet enregistrées",
  "reporting.labSections": "Unités de laboratoire",
  "reporting.allAccessibleSections": "Toutes les unités de laboratoire accessibles",
  "reporting.tests": "Analyses",
  "reporting.allTests": "Toutes les analyses",
  "reporting.resultStatuses": "Statuts des résultats",
  "reporting.finalized": "Finalisé",
  "reporting.all": "Tous",
  "reporting.available": "Colonnes disponibles",
  "reporting.search": "Rechercher des colonnes",
  "reporting.selected": "Colonnes sélectionnées",
  "reporting.selectedCount": "Colonnes sélectionnées ({count})",
  "reporting.group.sample": "Échantillon et demande",
  "reporting.group.referrals": "Références",
  "reporting.group.nonConformance": "Non-conformités / Rejets",
  "reporting.group.patient": "Patient",
  "reporting.group.result": "Détails du résultat",
  "reporting.group.tests": "Analyses configurées",
  "reporting.group.components": "Composants de résultat configurés",
  "reporting.group.turnaround": "Délai de traitement",
  "reporting.group.testTurnaround": "Délai par analyse",
  "reporting.group.componentTurnaround": "Délai par composant de résultat",
  "reporting.group.observations": "Questions supplémentaires",
  "reporting.headerPreview": "Aperçu de l'en-tête CSV",
  "reporting.moveUp": "Monter {field}",
  "reporting.moveDown": "Descendre {field}",
  "reporting.remove": "Retirer {field}",
  "reporting.position": "{field} : position {position} sur {count}",
  "reporting.review": "Vérifier le rapport",
  "reporting.edit": "Modifier le rapport",
  "reporting.generate": "Générer un fichier CSV",
  "reporting.submitting": "Soumission du rapport…",
  "reporting.generating": "Préparation de votre CSV…",
  "reporting.download": "Télécharger le CSV",
  "reporting.loading": "Chargement des options du rapport…",
  "reporting.currentReport": "Votre rapport actuel",
  "reporting.previous": "Précédent",
  "reporting.next": "Suivante",
  "reporting.rows": "{count, plural, one {# ligne} many {# lignes} other {# lignes}}",
  "reporting.state.QUEUED": "En file d'attente",
  "reporting.state.GENERATING": "Génération en cours",
  "reporting.state.READY": "Prêt à télécharger",
  "reporting.state.FAILED": "Failed",
  "reporting.state.EXPIRED": "Expiré",
  "reporting.state.CANCELLED": "Annulé",
  "reporting.loadError": "Impossible de charger les informations des rapports",
  "reporting.submitError": "Impossible de générer le rapport",
  "reporting.requestError": "La requête n'a pas pu aboutir. Vos choix ont été conservés ; réessayez.",
  "reporting.networkError": "Le serveur est injoignable. Vos choix ont été conservés ; réessayez.",
  "reporting.request.invalid": "Vérifiez la période, les filtres et les colonnes sélectionnées, puis réessayez.",
  "reporting.request.conflict": "Cet identifiant de soumission a déjà été utilisé pour d'autres choix de rapport. Démarrez un nouveau rapport.",
  "reporting.columns.stale": "Certaines colonnes sélectionnées ne sont plus disponibles. Supprimez-les et choisissez dans le catalogue actuel.",
  "reporting.jobs.limit": "Vous avez atteint la limite de rapports actifs. Attendez la fin d'un rapport, puis réessayez.",
  "reporting.access.denied": "Votre accès OpenELIS actuel ne permet pas de consulter ce rapport.",
  "reporting.access.scopeChanged": "Votre accès aux unités de laboratoire sélectionnées a changé. Vérifiez le rapport avec votre accès actuel.",
  "reporting.access.noSections": "Aucune unité de laboratoire accessible n'est disponible pour ce rapport.",
  "reporting.access.signIn": "Connectez-vous à OpenELIS pour continuer.",
  "reporting.definition.changed": "La définition du rapport a changé. Vérifiez les options actuelles du rapport avant de le relancer.",
  "reporting.definition.unavailable": "Ce type de rapport n'est plus disponible.",
  "reporting.tests.stale": "Certaines analyses sélectionnées ne sont plus disponibles. Vérifiez votre sélection d'analyses.",
  "reporting.status.invalid": "Choisissez un statut de résultat disponible.",
  "reporting.filters.unsupported": "Certains filtres demandés ne sont pas disponibles pour ce rapport. Vérifiez les options actuelles du rapport.",
  "reporting.filters.unavailable": "Certains filtres précédents ne sont pas disponibles pour ce rapport. Vérifiez les filtres actuels avant de générer.",
  "reporting.job.generationFailed": "Le CSV n'a pas pu être généré. Votre demande de rapport a été conservée.",
  "reporting.job.outputUnavailable": "Le serveur ne peut pas enregistrer les fichiers d'export. Demandez à votre administrateur de rendre le dossier d'export accessible en écriture, puis relancez ce rapport.",
  "reporting.job.expired": "Ce fichier a expiré. Relancez le rapport avec une nouvelle période.",
  "reporting.job.notReady": "Ce rapport n'est pas encore prêt à être téléchargé.",
  "reporting.job.notFound": "Ce rapport est introuvable.",
  "reporting.saved.library": "Rapports partagés",
  "reporting.saved.search": "Rechercher des rapports partagés",
  "reporting.saved.loading": "Chargement des rapports partagés…",
  "reporting.saved.loadError": "Impossible de charger les rapports partagés",
  "reporting.saved.empty": "Aucun rapport partagé n'a encore été enregistré.",
  "reporting.saved.shared": "Disponible pour tous les utilisateurs ayant accès aux rapports.",
  "reporting.saved.open": "Ouvert",
  "reporting.saved.save": "Enregistrer le rapport",
  "reporting.saved.update": "Mettre à jour le rapport partagé",
  "reporting.saved.copy": "Enregistrer une copie",
  "reporting.saved.delete": "Supprimer le rapport partagé",
  "reporting.saved.name": "Nom du rapport",
  "reporting.saved.confirmSave": "Enregistrer le rapport partagé",
  "reporting.saved.confirmDelete": "Supprimer",
  "reporting.saved.confirmUpdate": "Mettre à jour",
  "reporting.saved.cancel": "Annuler",
  "reporting.saved.copyName": "Copie de {name}",
  "reporting.saved.created": "Enregistré sous {name}.",
  "reporting.saved.updated": "{name} mis à jour.",
  "reporting.saved.freshDates": "Choisissez de nouvelles dates avant d'exécuter ce rapport.",
  "reporting.saved.deleteHelp": "Supprimer {name} de la bibliothèque de rapports partagés ? Les fichiers déjà générés sont conservés.",
  "reporting.saved.updateHelp": "Remplacer {name} par les choix actuellement affichés dans le générateur ?",
  "reporting.saved.changed": "Quelqu'un a modifié ce rapport partagé après son ouverture. Vos choix sont conservés ; rouvrez le rapport enregistré actuel ou enregistrez une copie.",
  "reporting.saved.invalid": "Vérifiez les choix du rapport avant d'enregistrer.",
  "reporting.saved.nameInvalid": "Saisissez un nom de rapport de 200 caractères maximum.",
  "reporting.saved.notFound": "Ce rapport partagé n'est plus disponible.",
  "reporting.saved.pageInvalid": "La requête de liste des rapports partagés n'était pas valide.",
  "accept.action.button": "Valider",
  "accessDenied.message": "Vous n'avez pas accès à ce module, veuillez contacter votre administrateur système",
  "accessDenied.okButton": "D'ACCORD",
  "accessDenied.title": "Accès refusé",
  "accession.entry": "Saisie du numéro de laboratoire",
  "activityReportByPanel": "Rapport d'activités par panel",
  "activityReportByTest": "Rapport d'activité par test",
  "activityReportByTestSection": "Rapport d'activités par section de test",
  "add.age.range": "Ajouter une autre tranche d'âge +",
  "add.aliquot": "Ajouter un Aliquote",
  "add.new.dictionary.menu": "Ajouter un nouveau menu de dictionnaire",
  "address.search.label": "Recherche rapide d’adresse",
  "address.level.provinsi": "Province",
  "address.level.kabupaten": "Régence/Ville",
  "address.level.kecamatan": "District",
  "address.level.kelurahan": "Village",
  "adjustment.button": "Ajuster la quantité",
  "adjustment.newQuantity": "Nouvelle quantité",
  "adjustment.notes": "Remarques",
  "adjustment.notes.placeholder": "Veuillez fournir des détails concernant cet ajustement.",
  "adjustment.reason": "Raison de l'ajustement",
  "adjustment.reason.select": "Sélectionnez une raison",
  "adjustment.success": "Quantité de lot ajustée avec succès",
  "adjustment.title": "Ajuster la quantité de lot",
  "admin.dashboard.subtitle": "Choisissez une zone d’administration pour configurer OpenELIS.",
  "admin.dashboard.title": "Tableau de bord d’administration ",
  "admin.formEntryConfig": "Configurations générales",
  "admin.programs.title": "Programmes",
  "admin.programs.subtitle": "Les initiatives auxquelles les demandes sont rattachées, chacune avec un domaine, une ou plusieurs unités de laboratoire et un questionnaire de saisie de demande facultatif.",
  "admin.programs.add": "Ajouter un programme",
  "admin.programs.search": "Rechercher par nom",
  "admin.programs.selector.new": "Nouveau programme",
  "admin.programs.row.expand.aria": "Modifier le programme",
  "admin.programs.row.actions.aria": "Actions sur le programme",
  "admin.programs.list.column.name": "Nom",
  "admin.programs.list.column.domain": "Domaine",
  "admin.programs.list.column.active": "Statut",
  "admin.programs.list.column.units": "Unité(s) de laboratoire",
  "admin.programs.list.status.active": "Active",
  "admin.programs.list.status.inactive": "Inactif",
  "admin.programs.list.filter.domain.label": "Domaine",
  "admin.programs.list.filter.domain.all": "Tous les domaines",
  "admin.programs.list.toggle.showDeactivated": "Affichage désactivé",
  "admin.programs.action.deactivate": "Désactiver",
  "admin.programs.action.reactivate": "Réactiver",
  "admin.programs.deactivate.modal.title": "Désactiver ce programme ?",
  "admin.programs.deactivate.modal.body.noOrders": "« {programName} » n'a aucune demande et n'apparaîtra simplement plus pour les nouvelles demandes. Vous pouvez le réactiver à tout moment depuis la liste des programmes.",
  "admin.programs.deactivate.modal.confirm": "Désactiver",
  "admin.programs.deactivate.modal.cancel": "Annuler",
  "admin.programs.reactivate.success": "{programName} réactivé",
  "admin.programs.deactivate.success": "{programName} désactivé",
  "admin.programs.domain.confirm.heading": "Modifier le domaine du programme ?",
  "admin.programs.domain.confirm.body": "Les demandes historiques ont été évaluées selon les règles du domaine {from}. Le passage à {to} ne vaut que pour l'avenir : les demandes existantes conservent leur codage de programme sans être recodées, et le programme ne sera proposé désormais que sur les demandes {to}.",
  "admin.programs.list.empty": "Aucun programme ne correspond à la recherche et aux filtres actuels.",
  "admin.programs.basicInfo.labUnits.selectAll": "Tout sélectionner",
  "admin.programs.basicInfo.labUnits.placeholder": "Saisissez du texte pour filtrer les unités de laboratoire",
  "orderEntry.programPicker.empty": "Aucun programme n'est actuellement actif. Un administrateur peut en activer un dans Admin › Programmes.",
  "orderEntry.programPicker.empty.domain": "Aucun programme {domain} n'est actuellement actif. Un administrateur peut en activer un dans Admin › Programmes.",
  "admin.programs.basicInfo.programName.label": "Nom du programme",
  "admin.programs.basicInfo.programName.placeholder": "p. ex. Dépistage prénatal de l'hépatite B",
  "admin.programs.basicInfo.code.label": "Code du programme",
  "admin.programs.basicInfo.code.placeholder": "p. ex. HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Utilisez uniquement des lettres, des chiffres, des espaces ou des traits de soulignement.",
  "admin.programs.basicInfo.programName.tooLong": "Utilisez au maximum {max} caractères.",
  "admin.programs.basicInfo.labUnits.label": "Unité(s) de laboratoire",
  "admin.programs.basicInfo.showOnMicroCase.off": "Off",
  "admin.programs.basicInfo.showOnMicroCase.on": "On",
  "admin.programs.basicInfo.showOnMicroCase.label": "Afficher sur le dossier de microbiologie",
  "admin.programs.basicInfo.showOnMicroCase.helper": "Autoriser ce programme sur les dossiers de microbiologie. Les nouveaux dossiers en héritent depuis la demande ; cela ne modifie pas l'acheminement du travail.",
  "admin.programs.basicInfo.domain.label": "Domaine",
  "admin.programs.basicInfo.domain.required": "Le champ « Domaine » est obligatoire",
  "admin.programs.editor.status.label": "Statut :",
  "admin.programs.guidance.domain.toggle.show": "Que signifie chaque domaine ?",
  "admin.programs.guidance.domain.toggle.hide": "Masquer",
  "admin.programs.guidance.domain.clinical": "Analyses de patients : le formulaire recueille les identifiants du patient, le prescripteur et les antécédents.",
  "admin.programs.guidance.domain.environmental": "Prélèvements de conformité/surveillance (eau, aliments, air). Aucun champ patient.",
  "admin.programs.guidance.domain.vector": "Surveillance de spécimens (moustique, tique) : espèce, manifeste de pool.",
  "admin.programs.guidance.gui.emptyState.body": "Aucune question pour l'instant. Ajoutez les questions une par une ou collez un Questionnaire en mode JSON.",
  "admin.programs.guidance.gui.emptyState.action": "Ajouter la première question",
  "admin.programs.guidance.json.referenceCard.format": "Format : Questionnaire FHIR R4",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "– item.type autorisés : {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Constructeur visuel",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Texte de la question",
  "admin.programs.questionnaire.question.type.label": "Type de question",
  "admin.programs.questionnaire.question.addNew": "Ajouter une nouvelle question",
  "admin.programs.questionnaire.question.actions.aria": "Actions sur la question",
  "admin.programs.questionnaire.question.actions.delete": "Supprimer la question",
  "admin.programs.questionnaire.answerOptions.section.title": "Options de réponse",
  "admin.programs.questionnaire.answerOptions.addOption": "Ajouter une option",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Supprimer l'option",
  "admin.programs.questionnaire.answerOptions.empty": "Aucune option pour l'instant. Ajoutez-en au moins une pour que la réception puisse choisir une valeur.",
  "admin.programs.questionnaire.answerOptions.coded": "codée",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Les options codées proviennent d'une terminologie et sont affichées ici en lecture seule. Modifiez-les en mode JSON.",
  "admin.programs.questionnaire.preview.label": "Exemple",
  "admin.programs.questionnaire.preview.empty": "Aucune question pour l'instant. Commencez à ajouter des questions pour voir l'aperçu.",
  "admin.programs.questionnaire.preview.untitled": "(sans titre)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Oui ◯ Non",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "nombre",
  "admin.programs.questionnaire.preview.quantity.unit": "unité",
  "admin.programs.questionnaire.json.validate": "Valider le JSON",
  "admin.programs.questionnaire.json.reformat": "Reformater",
  "admin.programs.questionnaire.json.validated": "Validé : {count} question(s)",
  "admin.programs.questionnaire.json.error.title": "Questionnaire non valide",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType doit être \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item doit être un tableau",
  "admin.programs.questionnaire.json.error.itemShape": "chaque élément doit avoir linkId, text et un type parmi [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "linkId « {linkId} » en double : chaque élément doit avoir un linkId unique",
  "admin.programs.guidance.json.referenceCard.advanced": "Les fonctions avancées (enableWhen, unités de Quantity via unit/unitOption, éléments imbriqués) se modifient ici en JSON ; le constructeur visuel les conserve mais ne les affiche pas.",
  "admin.programs.basicInfo.domain.helper": "Détermine où ce programme apparaît : la réception ne voit que les programmes correspondant au domaine de la demande.",
  "admin.programs.editor.status.noHardDelete": "Pas de suppression définitive : la désactivation conserve l'historique.",
  "admin.programs.deactivate.modal.body": "« {programName} » n'apparaîtra plus dans la liste des programmes de la saisie des demandes pour les nouvelles demandes. {orderCount, plural, one {Sa # demande historique conserve son codage de programme} other {Ses # demandes historiques conservent leur codage de programme}} et tous les comptages d'indicateurs sont préservés. Vous pouvez le réactiver à tout moment depuis la liste des programmes.",
  "admin.programs.deactivate.modal.body.unknownCount": "« {programName} » n'apparaîtra plus dans la liste des programmes de la saisie des demandes pour les nouvelles demandes. Les demandes historiques conservent leur codage de programme et tous les comptages d'indicateurs sont préservés. Vous pouvez le réactiver à tout moment depuis la liste des programmes.",
  "admin.programs.questionnaire.question.unsupported": "Il s'agit d'un élément « {type} », que ce constructeur ne modifie pas. Il est conservé tel quel lors de l'enregistrement. Modifiez-le en mode JSON.",
  "admin.programs.questionnaire.question.type.boolean": "Oui / Non",
  "admin.programs.questionnaire.question.type.choice": "Choix",
  "admin.programs.questionnaire.question.type.checkbox": "Case à cocher",
  "admin.programs.questionnaire.question.type.integer": "Nombre entier",
  "admin.programs.questionnaire.question.type.decimal": "Nombre décimal",
  "admin.programs.questionnaire.question.type.date": "Date",
  "admin.programs.questionnaire.question.type.time": "Heure",
  "admin.programs.questionnaire.question.type.string": "Texte court",
  "admin.programs.questionnaire.question.type.text": "Texte long",
  "admin.programs.questionnaire.question.type.quantity": "Quantité",
  "admin.programs.questionnaire.question.typeExample.boolean": "Réponse oui/non. Exemple : « Première consultation prénatale ? »",
  "admin.programs.questionnaire.question.typeExample.choice": "Une option dans une liste fixe. Exemple : « État de l'échantillon ».",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Plusieurs options peuvent être sélectionnées. Exemple : « Symptômes présents ».",
  "admin.programs.questionnaire.question.typeExample.integer": "Nombres entiers uniquement. Exemple : « Âge gestationnel (semaines) ».",
  "admin.programs.questionnaire.question.typeExample.decimal": "Nombres décimaux. Exemple : « Poids maternel (kg) ».",
  "admin.programs.questionnaire.question.typeExample.date": "Date du calendrier. Exemple : « Date des dernières règles ».",
  "admin.programs.questionnaire.question.typeExample.time": "Heure de la journée. Exemple : « Heure du prélèvement ».",
  "admin.programs.questionnaire.question.typeExample.string": "Texte libre court. Exemple : « Nom du prescripteur ».",
  "admin.programs.questionnaire.question.typeExample.text": "Texte libre long. Exemple : « Notes cliniques ».",
  "admin.programs.questionnaire.question.typeExample.quantity": "Un nombre accompagné d'une unité (p. ex. « Volume prélevé : 5 mL »). Les unités autorisées proviennent d'une extension FHIR définie en mode JSON ; une Quantity créée uniquement dans l'interface accepte toute unité.",
  "admin.config.logo.error.fileTooLarge": "L’image est trop volumineuse. Taille maximale : 2 Mo.",
  "admin.config.logo.formats": "Formats : JPG, PNG, GIF (max 2 Mo)",
  "admin.label": "Administrateur",
  "admin.labUnit.basicInfo.domain.clinical": "Clinique",
  "admin.labUnit.basicInfo.domain.environmental": "Environnemental",
  "admin.labUnit.basicInfo.domain.label": "Domaine",
  "admin.labUnit.basicInfo.domain.vector": "Vecteur",
  "admin.labUnit.domain.confirm.body": "Les commandes/résultats historiques ont été évalués selon les règles de l’ancien domaine. Les nouvelles commandes utiliseront les règles du nouveau domaine",
  "admin.labUnit.domain.confirm.heading": "Modifier le domaine de l’unité de laboratoire?",
  "admin.labUnit.edit.select": "Sélectionner les unités de laboratoire...",
  "admin.labUnit.edit.title": "Modifier le domaine de l’unité de laboratoire",
  "admin.labUnit.list.filter.domain": "Filtrer par domaine",
  "admin.legacy": "Administration héritée",
  "button.back": "← Retour à la liste",
  "button.labUnit.add": "Ajouter une unité de labo",
  "button.labUnit.create": "Créer une unité de laboratoire",
  "button.labUnit.creating": "Création...",
  "button.labUnit.tests.assign": "Assigner des tests",
  "button.labUnit.tests.assign.confirm": "Assigner {count, plural, one {# analyse} other {# analyses}}",
  "button.labUnit.tests.reassign": "Réaffecter les éléments sélectionnés ({count})",
  "button.labUnit.tests.reassign.confirm": "Réaffecter {count, plural, one {# analyse} other {# analyses}}",
  "configuration.labUnit.manage": "Gestion des unités de laboratoire",
  "error.labUnit.description.maxLength": "La description doit comporter au plus {max} de caractères.",
  "error.labUnit.domain.required": "Le champ « Domaine » est obligatoire",
  "error.labUnit.list.load": "Erreur lors du chargement des unités de laboratoire",
  "error.labUnit.name.duplicate": "Ce nom d'unité de laboratoire existe déjà",
  "error.labUnit.name.maxLength": "Le nom doit comporter au maximum {max} de caractères",
  "error.request.unreadable": "Rien n'a été enregistré : le serveur n'a pas accepté l'une des valeurs envoyées. Vérifiez le formulaire et réessayez.",
  "error.labUnit.name.required": "Le nom est obligatoire",
  "heading.labUnit.add": "Ajouter une unité de laboratoire",
  "heading.labUnit.editing": "Modification : {name}",
  "heading.labUnit.filtered": "Affichage d'{filtered} sur les unités de test de l'{total}",
  "heading.labUnit.management": "Gestion des unités de laboratoire",
  "heading.labUnit.subtitle": "Configurez les unités de test (sections de travaux pratiques), la classification par domaine, l'attribution des exercices et l'ordre d'affichage.",
  "heading.labUnit.total": "Total : unités de laboratoire « {total} »",
  "helper.labUnit.description": "Brève description interne de l'unité de laboratoire, à l'intention du personnel du laboratoire",
  "helper.labUnit.domain": "Détermine quels champs relatifs à la saisie des demandes et au prélèvement d'échantillons s'appliquent aux demandes transmises à cette unité de laboratoire.",
  "helper.labUnit.name": "Veuillez saisir un nom unique pour cette unité de laboratoire (par exemple, « Hématologie », « Microbiologie »)",
  "label.labUnit.actions": "Actions",
  "label.labUnit.active": "Active",
  "label.labUnit.description": "Description",
  "label.labUnit.displayOrder": "Position",
  "label.labUnit.displayOrder.addHint": "Enregistrez d'abord cette unité de laboratoire, puis définissez son ordre d'affichage.",
  "label.labUnit.displayOrder.current": "Actuel",
  "label.labUnit.displayOrder.intro": "Placez cette unité de laboratoire dans les menus et listes déroulantes des unités de laboratoire à l'échelle du système. Indiquez une position et enregistrez : les autres unités de laboratoire sont renumérotées automatiquement.",
  "label.labUnit.displayOrder.loading": "Chargement de l'ordre d'affichage...",
  "label.labUnit.displayOrder.saved": "L'ordre d'affichage a été enregistré",
  "label.labUnit.displayOrder.saveError": "Échec de l'enregistrement de l'ordre d'affichage",
  "label.labUnit.domain": "Domaine",
  "label.labUnit.filterStatus": "Filtrer par statut",
  "label.labUnit.list.loading": "Chargement des unités de laboratoire…",
  "label.labUnit.loading": "Chargement de l'unité de laboratoire...",
  "label.labUnit.notFound": "Cette unité de laboratoire n'existe pas. Revenez à la liste pour en choisir une autre.",
  "label.labUnit.editorLoadError": "Impossible de charger les unités de laboratoire. Actualisez la page pour réessayer.",
  "label.labUnit.name": "Nom",
  "label.labUnit.nameInLocale": "Nom ({language})",
  "error.labUnit.tests.action": "Échec de l'action d'attribution des tests",
  "error.labUnit.deactivate.failed": "L'unité de laboratoire n'a pas été désactivée. Vérifiez les options et réessayez.",
  "error.labUnit.deactivate.destinationInactive": "L'unité de laboratoire de destination est inactive. Choisissez une unité active, ou réactivez-la d'abord.",
  "heading.labUnit.tests.assign": "Assigner des tests à cette unité de laboratoire",
  "heading.labUnit.tests.reassign": "Réattribuer des analyses",
  "label.labUnit.tests.assign.explain": "Chaque test appartient à une seule et même unité de laboratoire. L'attribution d'un test à un autre lieu entraîne son retrait de son unité de laboratoire actuelle (indiquée à côté de chaque test).",
  "label.labUnit.tests.assign.none": "Aucune analyse attribuable n'a été trouvée.",
  "label.labUnit.tests.reassign.destination": "Unité de laboratoire de destination",
  "label.labUnit.tests.reassign.explain": "La réaffectation prend effet immédiatement. Les nouvelles demandes sont transmises à l'unité de laboratoire de destination ; les résultats déjà terminés conservent leurs données d'origine.",
  "label.labUnit.tests.reassign.inactiveDestination": "Cette unité de laboratoire est inactive : les analyses déplacées ne pourront pas être demandées tant qu'elle n'aura pas été réactivée. Les résultats terminés conservent leurs données d'origine.",
  "label.labUnit.inactiveOption": "{name} (inactive)",
  "label.labUnit.tests.reassign.moving": "{count, plural, one {# analyse sera déplacée :} many {# analyses seront déplacées :} other {# analyses seront déplacées :}} will be moved:",
  "message.labUnit.tests.assigned": "Exercices prévus dans le cadre de ce module de travaux pratiques.",
  "message.labUnit.tests.reassigned": "Les analyses ont été réattribuées avec succès.",
  "placeholder.labUnit.tests.reassign.destination": "Sélectionnez une destination...",
  "placeholder.labUnit.tests.search": "Rechercher des tests...",
  "label.labUnit.section.assigned-tests": "Tests assignés",
  "label.labUnit.section.basic-info": "Informations de base",
  "label.labUnit.section.display-order": "Ordre d'affichage",
  "label.labUnit.status": "Statut",
  "label.labUnit.testCount": "Analyses",
  "label.labUnit.tests.addHint": "Enregistrez d'abord cette unité de laboratoire, puis attribuez-lui des tests.",
  "label.labUnit.tests.count": "{count, plural, one {# analyse assignée} many {# analyses assignées} other {# analyses assignées}}",
  "label.labUnit.tests.loadError": "Impossible de charger les tests assignés",
  "label.labUnit.tests.loading": "Chargement des tests assignés...",
  "label.labUnit.tests.none": "Aucun examen n'a encore été attribué à cette unité de laboratoire.",
  "label.labUnit.tests.testName": "Nom du test ",
  "message.labUnit.add.success": "L'unité de laboratoire a été créée avec succès.",
  "message.labUnit.edit.success": "L'unité de laboratoire a été enregistrée avec succès.",
  "message.labUnit.noResults": "Aucune unité de laboratoire ne correspond à vos critères",
  "placeholder.labUnit.filter.domain": "Tous les domaines",
  "placeholder.labUnit.filter.status": "Tous les statuts",
  "placeholder.labUnit.search": "Rechercher des unités de laboratoire...",
  "sidenav.label.admin.labUnit.addingNew": "Ajout d'une nouvelle unité de laboratoire",
  "sidenav.label.admin.labUnit.backToList": "← Toutes les unités de laboratoire",
  "sidenav.label.admin.labUnit.editing": "Modification : {name}",
  "sidenav.label.admin.labUnit.editingGeneric": "Unité de laboratoire de traitement de texte",
  "sidenav.label.admin.labUnit.sectionsHelper": "Cliquez sur une unité de laboratoire pour modifier ses sections",
  "sidenav.label.admin.labUnitManagement": "Unités de laboratoire",
  "warning.labUnit.deactivateInUse": "{count, plural, one {# active test is assigned to this lab unit. Deactivating hides it from ordering but keeps the assignment.} other {# active tests are assigned to this lab unit. Deactivating hides it from ordering but keeps the assignments.}}",
  "heading.labUnit.deactivate": "Désactiver l'unité de laboratoire",
  "button.labUnit.deactivate.confirm": "Désactiver l'unité de laboratoire",
  "label.labUnit.deactivate.loading": "Vérification de l'impact…",
  "label.labUnit.deactivate.impact": "Cette unité de laboratoire contient actuellement :",
  "label.labUnit.deactivate.impact.tests": "{count} analyses assignées ({active} actives)",
  "label.labUnit.deactivate.impact.pending": "{count} analyses en attente",
  "label.labUnit.deactivate.impact.historical": "{count} analyses terminées (l'historique n'est jamais supprimé)",
  "info.labUnit.deactivate.pending": "Cette unité de laboratoire reste sur les listes de travail jusqu'à ce que ses {count} analyses en attente soient terminées.",
  "label.labUnit.deactivate.option": "Que doit-il advenir des analyses assignées ?",
  "label.labUnit.deactivate.option.keep": "Conserver les attributions : les analyses restent assignées, l'unité ne reçoit plus de nouvelles demandes",
  "label.labUnit.deactivate.option.deactivateAll": "Désactiver également toutes les analyses assignées",
  "label.labUnit.deactivate.option.reassign": "Réattribuer d'abord les analyses à une autre unité de laboratoire",
  "label.labUnit.deactivate.confirm": "Tapez DEACTIVATE pour confirmer",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Ajouter",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Désactiver",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Sortie",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modifier",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Sauvegarder",
  "admin.page.configuration.formEntryConfigMenu.description": "Description",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Modifier l'enregistrement",
  "admin.page.configuration.formEntryConfigMenu.name": "Nom",
  "admin.page.configuration.formEntryConfigMenu.select": "Sélectionner",
  "admin.page.configuration.formEntryConfigMenu.value": "Valeur",
  "admin.labelPresets.title": "Modèles d’étiquettes",
  "admin.labelPresets.addButton": "Ajouter un modèle",
  "admin.labelPresets.search.placeholder": "Rechercher des modèles…",
  "admin.labelPresets.col.name": "Nom",
  "admin.labelPresets.col.barcodeType": "Type de code-barre",
  "admin.labelPresets.col.dimensions": "Dimensions",
  "admin.labelPresets.col.scope": "Portée",
  "admin.labelPresets.col.status": "Statut",
  "admin.labelPresets.col.actions": "Actions",
  "admin.labelPresets.systemTag": "Système",
  "admin.labelPresets.status.active": "Active",
  "admin.labelPresets.status.inactive": "Inactif",
  "admin.labelPresets.scope.order": "Demande d'examen",
  "admin.labelPresets.scope.sample": "Échantillon",
  "admin.labelPresets.action.edit": "Modifier",
  "admin.labelPresets.action.duplicate": "Dupliquer",
  "admin.labelPresets.action.activate": "Activer",
  "admin.labelPresets.action.deactivate": "Désactiver",
  "admin.labelPresets.duplicateName": "Copie de {name}",
  "admin.labelPresets.duplicated": "Modèle dupliqué",
  "admin.labelPresets.duplicateFailed": "Échec de la duplication",
  "admin.labelPresets.activated": "Modèle activé",
  "admin.labelPresets.deactivated": "Modèle désactivé",
  "admin.labelPresets.toggleFailed": "Échec de la modification du statut",
  "admin.labelPresets.saveFailed": "Échec de l'enregistrement",
  "admin.labelPresets.saveFailed.detail": "Le serveur a répondu {status} : {message}",
  "admin.labelPresets.saveFailed.noResponse": "Aucune réponse du serveur. Vérifiez la connexion et réessayez.",
  "error.labelpreset.fields.unique": "Chaque champ de contenu et chaque position d'affichage ne peuvent être utilisés qu'une seule fois par préréglage.",
  "error.labelpreset.field.required": "Chaque entrée de champ de contenu doit indiquer un champ.",
  "admin.labelPresets.created": "Modèle créé",
  "admin.labelPresets.updated": "Modèle mis à jour",
  "admin.labelPresets.editor.titleAdd": "Ajouter un modèle d’étiquette",
  "admin.labelPresets.editor.titleEdit": "Modifier le modèle d’étiquette",
  "admin.labelPresets.editor.section.basicInfo": "Informations de base",
  "admin.labelPresets.editor.section.dimensions": "Dimensions (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Gestion des codes à barres",
  "admin.labelPresets.editor.section.printScope": "Portée d’impression et quantités",
  "admin.labelPresets.field.name": "Nom du modèle",
  "admin.labelPresets.field.isActive": "Active",
  "admin.labelPresets.field.heightMm": "Hauteur (mm)",
  "admin.labelPresets.field.widthMm": "Largeur (mm)",
  "admin.labelPresets.field.barcodeType": "Type de code-barre",
  "admin.labelPresets.field.defaultPerOrder": "Défaut par demande",
  "admin.labelPresets.field.maxPerOrder": "Maximum par commande",
  "admin.labelPresets.field.defaultPerSample": "Défaut par l'échantillon",
  "admin.labelPresets.field.maxPerSample": "Maximum par échantillon",
  "admin.labelPresets.validation.name.required": "Le nom est obligatoire",
  "admin.labelPresets.validation.name.toolong": "Le nom ne doit pas dépasser 120 caractères",
  "admin.labelPresets.validation.dimension.range": "La dimension doit être comprise entre 5 et 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Le type de code-barres est requis",
  "admin.labelPresets.validation.scope.required": "Au moins un périmètre d’impression (Commande ou Échantillon) doit être sélectionné",
  "admin.labelPresets.validation.max.lte": "Le maximum doit être supérieur ou égal à la valeur par défaut",
  "admin.labelPresets.editor.section.fields": "Champs de contenu",
  "admin.labelPresets.fields.helper": "Les champs imprimés au-dessus du code-barres, dans cet ordre. Le numéro de laboratoire est toujours en premier.",
  "admin.labelPresets.fields.locked": "Toujours en premier",
  "admin.labelPresets.fields.required": "Obligatoire",
  "admin.labelPresets.fields.required.aria": "Obligatoire : {field}",
  "admin.labelPresets.fields.moveUp": "Monter {field}",
  "admin.labelPresets.fields.moveDown": "Descendre {field}",
  "admin.labelPresets.fields.remove": "Retirer « {field} »",
  "admin.labelPresets.fields.add.label": "Ajouter un champ",
  "admin.labelPresets.fields.add.placeholder": "Choisir un champ",
  "admin.labelPresets.fields.add.button": "Ajouter",
  "admin.labelPresets.fields.allAdded": "Tous les champs disponibles figurent sur cette étiquette.",
  "admin.labelPresets.fields.fitHint": "{count, plural, one {Le champ sélectionné risque} other {Les # champs sélectionnés risquent}} de ne pas tenir sur une étiquette de {height} mm ; environ {rows, plural, one {# ligne tient} other {# lignes tiennent}} au-dessus du code-barres. Vous pouvez tout de même enregistrer.",
  "admin.labelPresets.fields.position": "Position {position}",
  "admin.labelPresets.fieldKey.LAB_NUMBER": "Numéro laboratoire",
  "admin.labelPresets.fieldKey.PATIENT_NAME": "Nom du patient",
  "admin.labelPresets.fieldKey.PATIENT_ID": "Identifiant du Patient",
  "admin.labelPresets.fieldKey.PATIENT_DOB": "Date de Naissance du Patient",
  "admin.labelPresets.fieldKey.PATIENT_SEX": "Sexe du Patient",
  "admin.labelPresets.fieldKey.SITE_ID": "ID du Site",
  "admin.labelPresets.fieldKey.COLLECTION_DATETIME": "Date et Heure de Prélèvement",
  "admin.labelPresets.fieldKey.COLLECTED_BY": "Collecté Par",
  "admin.labelPresets.fieldKey.TESTS": "Analyses",
  "admin.labelPresets.fieldKey.SPECIMEN_TYPE": "Type d'échantillon",
  "admin.labelPresets.fieldKey.BLOCK_ID": "ID du bloc",
  "admin.labelPresets.fieldKey.SLIDE_ID": "ID de la lame",
  "admin.labelPresets.fieldKey.STAIN_TYPE": "Type de coloration",
  "admin.labelPresets.fieldKey.CASE_NUMBER": "Numéro de dossier",
  "admin.labelPresets.fieldKey.STORAGE_LOCATION": "Emplacement de stockage",
  "admin.labelPresets.fieldKey.EXPIRY_DATE": "Date d'Expiration",
  "error.labelpreset.field.key.unknown": "Champ de contenu inconnu.",
  "admin.labelPresets.siteWide.title": "Paramètres de code-barres de l'ensemble du site",
  "admin.labelPresets.siteWide.scope": "S'applique à l'ensemble du laboratoire",
  "admin.labelPresets.siteWide.prePrint.legend": "Les numéros d'étiquettes pré-imprimées proviennent de",
  "admin.labelPresets.siteWide.prePrint.orderEntry": "Le même format et la même série de numéros que la saisie des demandes",
  "admin.labelPresets.siteWide.prePrint.separate": "Une série pré-imprimée distincte",
  "admin.labelPresets.siteWide.prefix.label": "Préfixe",
  "admin.labelPresets.siteWide.prefix.helper": "Exactement 4 lettres ou chiffres. Les numéros pré-imprimés commencent par ce préfixe, suivi de l'année et d'un numéro séquentiel.",
  "admin.labelPresets.siteWide.prefix.invalid": "Le préfixe doit comporter exactement 4 lettres ou chiffres",
  "admin.labelPresets.siteWide.save": "Enregistrer les paramètres",
  "admin.labelPresets.siteWide.saved": "Paramètres de code-barres de l'ensemble du site enregistrés",
  "admin.labelPresets.siteWide.saveFailed": "Les paramètres de code-barres de l'ensemble du site n'ont pas été enregistrés",
  "admin.labelPresets.siteWide.loadFailed": "Impossible de charger les paramètres de code-barres de l'ensemble du site. Rechargez la page pour réessayer.",
  "error.sitesettings.barcode.prefix.format": "Le préfixe pré-imprimé doit comporter exactement 4 lettres ou chiffres lorsqu'une série distincte est utilisée",
  "advanced.search": "Lancer la recherche",
  "alert.expired.title": "Elément expiré",
  "alert.expiring.title": "Bientôt Expiration",
  "alert.lowStock.title": "Alerte de stock faible",
  "alerts.acknowledge.button": "Accuser réception",
  "alerts.acknowledge.comment": "Commentaire de résolution",
  "alerts.acknowledge.comment.placeholder": "Décrivez comment cette alerte a été traitée...",
  "alerts.acknowledge.comment.required": "Le commentaire de résolution est requis pour les alertes critiques",
  "alerts.acknowledge.error": "Échec de l'acquittement de l'alerte",
  "alerts.acknowledge.success": "Alerte acquittée avec succès",
  "alerts.acknowledge.title": "Acquitter l'alerte",
  "alerts.autoRefresh": "Actualisation automatique toutes les 60 secondes",
  "alerts.dashboard.title": "Tableau de bord des alertes",
  "alerts.empty": "Aucune alerte à afficher",
  "alerts.eqaDeadlineSummary.critical": "Critique",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} échéances à venir",
  "alerts.eqaDeadlineSummary.subtitle": "Échéances de soumission EEQ à venir regroupées par prestataire",
  "alerts.eqaDeadlineSummary.title": "Résumé des échéances EQA",
  "alerts.eqaDeadlineSummary.viewAll": "Voir tout",
  "alerts.filter.myAlerts": "Mes alertes",
  "alerts.filter.search": "Rechercher des alertes...",
  "alerts.filter.severity": "Gravité",
  "alerts.filter.status": "Statut",
  "alerts.filter.type": "Alert Type",
  "alerts.severity.critical": "Critique",
  "alerts.severity.warning": "Avertissement",
  "alerts.status.acknowledged": "Accusé de réception",
  "alerts.status.open": "Ouvert",
  "alerts.status.resolved": "Résolu",
  "alerts.summary.critical": "Alertes critiques",
  "alerts.summary.eqaDeadlines": "Échéances EQA",
  "alerts.summary.sampleExpiration": "Échantillons expirant",
  "alerts.summary.statOverdue": "Commandes STAT en retard",
  "alerts.summary.totalOpen": "Total ouvertes",
  "alerts.table.actions": "Actions",
  "alerts.table.created": "Créé",
  "alerts.table.message": "Message",
  "alerts.table.severity": "Gravité",
  "alerts.table.status": "Statut",
  "alerts.table.type": "Type",
  "alerts.type.critical_result": "Résultat critique",
  "alerts.type.equipment_failure": "Equipment Failure",
  "alerts.type.freezer_humidity": "Humidité du congélateur",
  "alerts.type.freezer_offline": "Congélateur hors ligne",
  "alerts.type.freezer_temperature": "Température du congélateur",
  "alerts.type.inventory_low": "Stock faible",
  "alerts.type.other": "Autre",
  "alerts.type.referral_critical_result": "Résultat critique du laboratoire de référence",
  "alerts.type.referral_rejected": "Envoi au laboratoire de référence rejeté",
  "alerts.type.sample_tracking": "Suivi des échantillons",
  "alerts.type.critical_unacknowledged": "Critique non acquitté",
  "alerts.type.eqa_deadline": "Échéance EQA",
  "alerts.type.eqa_submission_failed": "Échec de la soumission EEQ",
  "alerts.type.microbiology_critical": "Microbiologie : points essentiels",
  "alerts.type.required_by_deadline": "Date limite requise",
  "alerts.type.sample_expiration": "Expiration d'échantillon",
  "alerts.type.stat_overdue": "STAT en retard",
  "alerts.type.stat_upcoming": "STAT à venir",
  "aliquot": "Aliquote",
  "aliquot.analyses.count": "Analyses: {count}",
  "aliquot.id": "Identifiant de l'aliquote",
  "aliquot.quantity": "Quantité d'aliquote",
  "aliquot.quantity.not.balanced": "Quantité non équilibrée pour le type d'échantillon",
  "aliquot.save.error": "Erreur lors de l'enregistrement des données d'aliquotage.",
  "aliquot.save.success": "Les données aliquotes ont été enregistrées avec succès.",
  "aliquot.tests.not.assigned": "Tests non attribués pour le type d'échantillon",
  "aliquot.validation.errors": "Erreurs de validation",
  "aliquoting": "Aliquotage",
  "aliquoting.section": "Section d'aliquotage",
  "all.label": "Tous",
  "all.tests.assigned": "Tous les tests attribués",
  "allocated.to.aliquots": "Alloué à Aliquots",
  "analysis.count": "Nombre d'analyses",
  "analysis.details": "Détails de l'analyse",
  "analyzer.adoption.error.heldResults": "{record} a encore des résultats retenus de la révision {revision}. Traitez-les avant l'adoption.",
  "analyzer.adoption.error.inactiveTest": "{record} est associé à une analyse qui n'est plus active. Choisissez une autre analyse avant l'adoption.",
  "analyzer.adoption.error.missingAnswers": "{record} nécessite une décision pour chacune de ses réponses. Manquantes : {answers}.",
  "analyzer.adoption.error.missingDecisions": "Chaque enregistrement conservé par la nouvelle révision nécessite une décision. Manquants : {records}.",
  "analyzer.adoption.error.notNewer": "L'adoption fait passer un analyseur à une révision plus récente que la révision {revision}.",
  "analyzer.adoption.error.revisionInactive": "La révision {revision} de ce type d'analyseur n'est pas active.",
  "analyzer.bridge.connection.httpStatus": "L'Analyzer Bridge a refusé la requête.",
  "analyzer.bridge.connection.invalidEvidence": "L'Analyzer Bridge a répondu pour un autre analyseur ou un autre type d'analyseur.",
  "analyzer.bridge.connection.invalidRequest": "La requête envoyée à l'Analyzer Bridge était incomplète.",
  "analyzer.bridge.connection.notConfigured": "Aucun Analyzer Bridge n'est configuré pour ce serveur.",
  "analyzer.bridge.connection.reconcileRequired": "OpenELIS a conservé la correspondance précédente de l'analyseur, mais l'Analyzer Bridge utilise peut-être encore la nouvelle. Appliquez de nouveau la correspondance lorsque le Bridge est joignable pour les resynchroniser.",
  "analyzer.bridge.connection.referenceNotStored": "La connexion à l'Analyzer Bridge n'a pas pu être enregistrée avec cet analyseur.",
  "analyzer.bridge.connection.unreachable": "Impossible de joindre l'Analyzer Bridge.",
  "analyzer.mapping.error.catalogNotCurrent": "Une analyse ou une réponse associée n'est plus active dans le catalogue de tests. Choisissez-en une autre avant de confirmer.",
  "analyzer.mapping.error.changedSinceLoaded": "La correspondance de cet analyseur a changé après le chargement de cette page. Rechargez la page pour voir la correspondance actuelle.",
  "analyzer.mapping.error.componentRequired": "{record} aboutit à un composant de son analyse. Choisissez ce composant, ou laissez l'enregistrement non résolu.",
  "analyzer.mapping.error.confirmBeforeApply": "Confirmez la correspondance actuelle de l'analyseur avant de l'appliquer.",
  "analyzer.mapping.error.recognitionChanged": "La reconnaissance des contrôles du type d'analyseur a changé après le chargement de cette page. Rechargez la page avant de confirmer.",
  "analyzer.mapping.error.resultNotCurrent": "Une réponse associée n'est plus active pour son analyse. Choisissez une autre réponse.",
  "analyzer.mapping.error.testNotCurrent": "Une analyse associée n'est plus active dans le catalogue de tests. Choisissez une autre analyse.",
  "analyzer.setup.assays.continue": "Continuer la vérification",
  "analyzer.setup.assays.count": "{on} dosages activés sur {total}",
  "analyzer.setup.assays.help": "Activez les dosages effectués par cet instrument, comme dans ses propres paramètres de codes d'analyse de l'hôte. La vérification n'associe que les dosages activés. Le résultat d'un dosage désactivé est retenu, jamais perdu.",
  "analyzer.setup.assays.loadError": "Les dosages de l'analyseur n'ont pas pu être chargés.",
  "analyzer.setup.assays.loading": "Chargement des dosages",
  "analyzer.setup.assays.match.ambiguous": "Plusieurs analyses du catalogue de ce laboratoire correspondent",
  "analyzer.setup.assays.match.bound": "Correspond à {name}",
  "analyzer.setup.assays.match.excluded": "Paramétré pour ne pas être reçu",
  "analyzer.setup.assays.match.incompatible": "Une analyse correspond mais ne peut pas recevoir ces résultats",
  "analyzer.setup.assays.match.noMatch": "Aucune analyse dans le catalogue de ce laboratoire",
  "analyzer.setup.assays.none": "Ce type d'analyseur ne déclare aucun dosage, il n'y a donc rien à associer. Les résultats qu'il envoie sont retenus comme analyses inconnues et peuvent être associés depuis le résultat retenu.",
  "analyzer.setup.assays.saveError": "Les dosages n'ont pas pu être enregistrés.",
  "analyzer.setup.assays.title": "Dosages",
  "analyzer.setup.error.adoptToMove": "Pour faire passer cet analyseur à la révision {revision}, adoptez-la depuis la page du type d'analyseur.",
  "analyzer.setup.error.profileKept": "Un analyseur configuré conserve son type d'analyseur.",
  "analyzer.reset.error.profileAvailable": "Le type de cet analyseur est encore disponible. Adoptez une révision plus récente pour le déplacer.",
  "analyzer.setup.connect.reset": "Réinitialiser le type d'analyseur",
  "analyzer.setup.connect.reset.failed": "Le type d'analyseur n'a pas pu être réinitialisé. Réessayez.",
  "analyzer.action.activate": "Activer",
  "analyzer.action.add": "Ajouter un analyseur",
  "analyzer.action.configureConnection": "Configurer la connexion",
  "analyzer.action.deactivate": "Désactiver",
  "analyzer.action.editSetup": "Modifier la configuration",
  "analyzer.action.qualityControl": "Contrôle qualité",
  "analyzer.action.reactivate": "Réactiver",
  "analyzer.bridgePairing.automatic": "OpenELIS s'appaire automatiquement avec le code configuré. Vous pouvez aussi saisir le code ici.",
  "analyzer.bridgePairing.cancel": "Annuler",
  "analyzer.bridgePairing.code.label": "Code d'appairage",
  "analyzer.bridgePairing.error.certificateMismatch": "Le Bridge a répondu pour un certificat différent de celui qu'il a présenté ; OpenELIS ne s'est donc pas appairé avec lui.",
  "analyzer.bridgePairing.error.closed": "Le Bridge n'accepte pas d'appairage. Configurez un nouveau code d'appairage sur le Bridge, redémarrez-le, puis appairez de nouveau.",
  "analyzer.bridgePairing.error.codeRequired": "Saisissez le code d'appairage.",
  "analyzer.bridgePairing.error.identity": "OpenELIS n'a pas pu créer ou lire sa clé pour le Bridge.",
  "analyzer.bridgePairing.error.invalidAnswer": "La réponse du Bridge n'a pas pu être lue.",
  "analyzer.bridgePairing.error.notConfigured": "Aucune adresse d'Analyzer Bridge n'est configurée pour OpenELIS.",
  "analyzer.bridgePairing.error.refused": "Le Bridge a refusé l'appairage.",
  "analyzer.bridgePairing.error.unreachable": "OpenELIS n'a pas pu joindre l'Analyzer Bridge.",
  "analyzer.bridgePairing.error.wrongCode": "Le Bridge n'a pas accepté ce code.",
  "analyzer.bridgePairing.pair": "Appairer",
  "analyzer.bridgePairing.pairAgain": "Appairer de nouveau",
  "analyzer.bridgePairing.paired.detail": "{url} · Certificat du Bridge {fingerprint} · appairé le {pairedAt}",
  "analyzer.bridgePairing.paired.title": "Appairé avec l'Analyzer Bridge",
  "analyzer.bridgePairing.unpaired.subtitle": "Saisissez le code d'appairage affiché par le Bridge dans son journal, ou celui avec lequel il a été configuré. Les résultats restent en attente dans le Bridge jusqu'à l'appairage.",
  "analyzer.bridgePairing.unpaired.title": "L'Analyzer Bridge n'est pas appairé",
  "analyzer.combinationName.notification": "Notification de combinaison de nom d'automate",
  "analyzer.fhirImport.error.importFailed": "Échec de l'import du bundle FHIR",
  "analyzer.fhirImport.error.invalidBundleType": "Le type de bundle doit être 'transaction' ou 'batch', reçu : {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Le bundle ne contient aucune ressource Observation avec résultats",
  "analyzer.deliveryIssues.attention.review": "Revoir les résultats non transmis",
  "analyzer.deliveryIssues.attention.subtitle": "L'Analyzer Bridge retient des résultats qu'il n'a pas pu transmettre à OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, one {# résultat d'analyseur n'a pas été transmis} many {# résultats d'analyseur n'ont pas été transmis} other {# résultats d'analyseur n'ont pas été transmis}} not delivered",
  "analyzer.deliveryIssues.column.actions": "Actions",
  "analyzer.deliveryIssues.column.analyzer": "Analyseur",
  "analyzer.deliveryIssues.column.detail": "Détails",
  "analyzer.deliveryIssues.column.reason": "Motif",
  "analyzer.deliveryIssues.column.received": "Reçu",
  "analyzer.deliveryIssues.column.status": "Statut",
  "analyzer.deliveryIssues.description": "Résultats reçus par l'Analyzer Bridge mais non transmis à OpenELIS. Réessayer renvoie un résultat une fois sa cause corrigée ; Ignorer le masque et le conserve dans le Bridge pour l'audit.",
  "analyzer.deliveryIssues.dismiss": "Ignorer",
  "analyzer.deliveryIssues.empty": "Le Bridge n'a aucun résultat non transmis.",
  "analyzer.deliveryIssues.error.actionFailed": "L'action n'a pas pu être effectuée. Rechargez la page et réessayez.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "L'Analyzer Bridge a envoyé une réponse qu'OpenELIS n'a pas pu lire.",
  "analyzer.deliveryIssues.error.incompleteList": "L'Analyzer Bridge a plus de résultats non transmis que cette vue ne peut en charger. Consultez directement la boîte d'envoi du Bridge.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "Aucune adresse d'Analyzer Bridge n'est configurée dans OpenELIS.",
  "analyzer.deliveryIssues.error.bridgeRefused": "Le Bridge a refusé cette action ({reason}). Rechargez la page pour voir son état actuel.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "Impossible de joindre l'Analyzer Bridge.",
  "analyzer.deliveryIssues.error.invalidId": "Cette référence de résultat n'est pas valide.",
  "analyzer.deliveryIssues.loadFailed": "Impossible de charger les résultats non transmis depuis l'Analyzer Bridge.",
  "analyzer.deliveryIssues.loading": "Recherche des résultats non transmis dans l'Analyzer Bridge",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "Plusieurs connexions d'analyseur pourraient correspondre à ce message. Attribuez une adresse distincte à chaque analyseur, puis réessayez.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "L'analyseur a envoyé via un type de connexion que sa configuration n'accepte pas.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS a refusé le résultat en raison de sa propre configuration. Corrigez la configuration de l'analyseur, puis réessayez.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS a rejeté le résultat.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS a répondu par une redirection, le résultat n'a donc pas été transmis. Vérifiez l'adresse OpenELIS configurée dans le Bridge.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "Le message ne contenait aucun résultat à transmettre.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "Le Bridge n'a pas pu convertir le message pour OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS est resté injoignable jusqu'à épuisement des tentatives. Le résultat est intact ; réessayez lorsque OpenELIS sera joignable.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "La connexion de l'analyseur n'a aucune révision de type d'analyseur, ses résultats ne peuvent donc pas être lus.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "L'expéditeur ne correspond à aucune connexion d'analyseur enregistrée. Configurez l'analyseur, puis réessayez.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS n'a pas encore accepté le résultat ; le Bridge continue de réessayer.",
  "analyzer.deliveryIssues.reason.unknown": "Le Bridge n'a pas pu transmettre ce résultat ({code}).",
  "analyzer.deliveryIssues.retry": "Réessayer",
  "analyzer.deliveryIssues.state.deadLettered": "Non transmis",
  "analyzer.deliveryIssues.state.retrying": "Nouvelle tentative en cours",
  "analyzer.deliveryIssues.title": "Résultats d'analyseur non transmis",
  "analyzer.deliveryIssues.unrecognizedSender": "Expéditeur non reconnu {source}",
  "analyzer.importIssues.accession": "Numéro d'Accession",
  "analyzer.importIssues.action": "Action",
  "analyzer.importIssues.description": "Vérifiez les événements liés aux analyseurs microbiologiques qui n'ont pas pu être mis en correspondance ou traités. Les résultats en attente sont examinés dans la liste de travail des résultats de chaque analyseur.",
  "analyzer.importIssues.empty": "Il n'y a pas d'incident lié à une défaillance de l'analyseur microbiologique qui nécessite une intervention",
  "analyzer.importIssues.event": "Événement",
  "analyzer.importIssues.event.astQcFail": "Défaillance du contrôle qualité de l'AST",
  "analyzer.importIssues.event.astResultAvailable": "Résultats de l'AST disponibles",
  "analyzer.importIssues.event.unknown": "Événement « Analyseur » ({code})",
  "analyzer.importIssues.events.description": "Veuillez corriger le mappage de l'analyseur ou les informations relatives à la cible avant que la source n'envoie à nouveau le résultat.",
  "analyzer.importIssues.events.title": "Événements de l'analyseur bloqués",
  "analyzer.importIssues.failure.astRunNotMatched": "Non, aucune exécution AST ne correspondait aux identifiants de l'analyseur et de la carte.",
  "analyzer.importIssues.failure.processingFailed": "L'événement de l'analyseur n'a pas pu être traité.",
  "analyzer.importIssues.failure.unknown": "L'événement de l'analyseur n'a pas pu être traité ({code}).",
  "analyzer.importIssues.loadFailed": "Problèmes d'importation de l'analyseur : impossible de charger les données",
  "analyzer.importIssues.loading": "Problèmes liés à l'importation de l'analyseur de chargement",
  "analyzer.importIssues.openMappings": "Correspondances ouvertes",
  "analyzer.importIssues.openResults": "Consulter les résultats de l'analyseur",
  "analyzer.importIssues.reason": "Motif de l'échec",
  "analyzer.importIssues.received": "Reçu",
  "analyzer.importIssues.result": "Résultat ",
  "analyzer.importIssues.source": "IDENTIFIANT DE LA SOURCE",
  "analyzer.importIssues.staging.description": "Ces lignes de résultats importées nécessitent une configuration correcte de l'analyseur avant leur validation.",
  "analyzer.importIssues.staging.title": "Problèmes liés aux résultats par étapes",
  "analyzer.importIssues.target": "Référence cible",
  "analyzer.importIssues.test": "Test",
  "analyzer.importIssues.title": "Problèmes d'importation dans les Analyseurs",
  "analyzer.fieldCreation.acceptedUnits.label": "Unités acceptées",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Sélectionnez les unités acceptées",
  "analyzer.fieldCreation.cancel": "Annuler",
  "analyzer.fieldCreation.confirmation": "Je comprends que ce champ sera disponible pour le mappage immédiatement après sa création",
  "analyzer.fieldCreation.create": "Créer le champ",
  "analyzer.fieldCreation.createNew": "Créer un nouveau champ",
  "analyzer.fieldCreation.description.label": "Description (Optionnel)",
  "analyzer.fieldCreation.description.placeholder": "Entrez la description du champ",
  "analyzer.fieldCreation.entityType.label": "Type d’entité",
  "analyzer.fieldCreation.entityType.placeholder": "Sélectionnez le type d'entité",
  "analyzer.fieldCreation.error.generic": "Échec de la création du champ",
  "analyzer.fieldCreation.error.title": "Erreur lors de la création du champ",
  "analyzer.fieldCreation.fieldName.label": "Nom du champ",
  "analyzer.fieldCreation.fieldName.placeholder": "Entrez le nom du champ",
  "analyzer.fieldCreation.fieldType.label": "Type de champ",
  "analyzer.fieldCreation.fieldType.placeholder": "Sélectionnez le type de champ",
  "analyzer.fieldCreation.loincCode.label": "Code LOINC (Optionnel)",
  "analyzer.fieldCreation.loincCode.placeholder": "Entrez le code LOINC",
  "analyzer.fieldCreation.modal.subtitle": "Créer un nouveau champ qui sera disponible pour le mappage immédiatement",
  "analyzer.fieldCreation.modal.title": "Créer un nouveau champ OpenELIS",
  "analyzer.fieldCreation.success.message": "Le champ est maintenant disponible pour le mappage",
  "analyzer.fieldCreation.success.title": "Champ créé avec succès",
  "analyzer.fieldCreation.validation.entityType.required": "Le type d'entité est requis",
  "analyzer.fieldCreation.validation.fieldName.required": "Le nom du champ est requis",
  "analyzer.fieldCreation.validation.unique": "Un champ avec ce nom existe déjà",
  "analyzer.fieldCreation.validation.units.required": "Les unités acceptées sont requises pour les champs numériques",
  "analyzer.filter.lifecycleStage.all": "All Lifecycle Stages",
  "analyzer.filter.lifecycleStage.label": "Lifecycle Stage",
  "analyzer.filter.status": "Statut",
  "analyzer.filter.status.all": "Tous les statuts",
  "analyzer.filter.status.label": "Statut",
  "analyzer.filter.testUnit": "Test Unit",
  "analyzer.filter.type": "Type d’analyseur ",
  "analyzer.form.activeStatus": "Active Status",
  "analyzer.form.activeStatus.description": "Enable this analyzer for data collection",
  "analyzer.form.addTitle": "Ajouter un nouvel analyseur",
  "analyzer.form.cancel": "Annuler",
  "analyzer.form.communicationMode": "Mode de communication",
  "analyzer.form.communicationMode.analyzerInitiated": "Analyseur → SIL (l'analyseur se connecte à OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidirectionnel (les deux directions)",
  "analyzer.form.communicationMode.help": "Qui initie la connexion. La plupart des analyseurs utilisent Analyseur → SIL.",
  "analyzer.form.communicationMode.lisInitiated": "SIL → Analyseur (OpenELIS se connecte à l'analyseur)",
  "analyzer.form.createdBy": "Created By",
  "analyzer.form.createdDate": "Created Date/Time",
  "analyzer.form.defaults.error": "Failed to load default configuration",
  "analyzer.form.defaults.loaded": "Default configuration loaded",
  "analyzer.form.defaults.loaded.subtitle": "Template for {name} has been loaded. Customize as needed before saving.",
  "analyzer.form.editTitle": "Edit Analyzer",
  "analyzer.form.error.invalidCommunicationMode": "Mode de communication invalide : {value}. Valeurs valides : {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Version de protocole invalide : {value}. Valeurs valides : {validValues}",
  "analyzer.form.error.save": "Failed to save analyzer",
  "analyzer.form.error.unknown": "An unknown error occurred",
  "analyzer.form.fileProtocol.description": "This analyzer imports results from files. File import settings will be configured after saving.",
  "analyzer.form.fileProtocol.title": "File Import Protocol",
  "analyzer.form.identifierPattern": "Modèle d’identifiant",
  "analyzer.form.identifierPattern.helperText": "Regex pattern to match incoming message identifiers for routing",
  "analyzer.form.identifierPattern.placeholder": "e.g., ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "Adresse IP",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Date/Heure de dernière modification",
  "analyzer.form.loadDefaultConfig": "Charger la configuration par défaut",
  "analyzer.form.loadDefaultConfig.helperText": "Configuration rapide à l'aide de modèles préconfigurés pour les plugins GenericASTM et GenericHL7",
  "analyzer.form.loadDefaultConfig.placeholder": "Sélectionner un modèle d'analyseur préconfiguré",
  "analyzer.form.name": "Nom de l’analyseur",
  "analyzer.form.name.placeholder": "ex: Analyseur d'hématologie 1",
  "analyzer.form.pluginType": "Type de plugin",
  "analyzer.form.pluginType.helperText": "Le plugin analyseur qui traitera les messages entrants",
  "analyzer.form.pluginType.placeholder": "Sélectionner le type de plugin...",
  "analyzer.form.port": "Numéro de port",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Version du protocole",
  "analyzer.form.save": "Sauvegarder",
  "analyzer.form.status": "Statut",
  "analyzer.form.status.helperText": "Le statut change automatiquement selon l'état de l'analyseur. Remplacement manuel vers INACTIF, CONFIGURATION ou VALIDATION uniquement.",
  "analyzer.form.subtitle": "Configurer les paramètres de connexion et les unités de test de l'analyseur",
  "analyzer.form.success.save": "Analyseur enregistré avec succès",
  "analyzer.form.testConnection": "Test de connexion",
  "analyzer.form.testConnection.error": "Échec de la connexion",
  "analyzer.form.testUnits": "Affectation des unités de test",
  "analyzer.form.testUnits.helper": "Sélectionner une ou plusieurs unités de test pour cet analyseur",
  "analyzer.form.testUnits.placeholder": "Sélectionner les unités de test...",
  "analyzer.form.type": "Type d’analyseur ",
  "analyzer.form.type.helperText": "Sélectionnez le type d'analyseur réutilisable pour cette connexion installée.",
  "analyzer.form.type.invalidSelection": "Ce type d'analyseur n'est pas disponible ou est désactivé",
  "analyzer.form.type.loadError": "Impossible de charger les types d’analyseurs",
  "analyzer.form.type.other": "Autre",
  "analyzer.form.type.placeholder": "Sélectionner le type d'analyseur",
  "analyzer.form.type.revision": "{name}, version {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "Invalid IP address format",
  "analyzer.form.validation.name.required": "Analyzer name is required",
  "analyzer.form.validation.type.required": "Analyzer type is required",
  "analyzer.hl7.insertError": "Erreur d'insertion HL7",
  "analyzer.hl7.parseError": "Erreur d'analyse HL7",
  "analyzer.hl7.unknownAnalyzer": "Impossible d'identifier l'analyseur à partir du MSH HL7 (application/établissement émetteur)",
  "analyzer.list.subtitle": "Gérer les analyseurs de laboratoire et les correspondances de champs",
  "analyzer.list.title": "Analyseurs",
  "analyzer.lifecycle.activate.blockedMessage": "Remplissez ces conditions de configuration avant l'activation. Ouvrez « Modifier la configuration » sur cet analyseur pour vérifier ses correspondances et sa connexion.",
  "analyzer.lifecycle.activate.blockedTitle": "L'analyseur n'est pas prêt",
  "analyzer.lifecycle.activate.cancel": "Annuler l'activation",
  "analyzer.lifecycle.activate.confirm": "Activer l'analyseur",
  "analyzer.lifecycle.activate.error": "L'analyseur n'a pas pu être activé.",
  "analyzer.lifecycle.activate.errorTitle": "Échec de l'activation",
  "analyzer.lifecycle.activate.message": "Activer {name} ? Sa configuration sera vérifiée avant qu'il puisse être utilisé.",
  "analyzer.lifecycle.activate.title": "Activer l'analyseur",
  "analyzer.lifecycle.deactivate.cancel": "Annuler la désactivation",
  "analyzer.lifecycle.deactivate.confirm": "Désactiver l'analyseur",
  "analyzer.lifecycle.deactivate.error": "Il n'a pas été possible de désactiver l'analyseur.",
  "analyzer.lifecycle.deactivate.errorTitle": "Échec de la désactivation",
  "analyzer.lifecycle.deactivate.message": "Désactiver « {name} » ? Toute nouvelle utilisation de l'environnement d'exécution sera interrompue. Sa configuration et son historique seront conservés, et il pourra être réactivé ultérieurement.",
  "analyzer.lifecycle.deactivate.title": "Désactiver l'analyseur",
  "analyzer.lifecycle.reactivate.blockedMessage": "Veuillez terminer ces conditions de configuration avant de réactiver.",
  "analyzer.lifecycle.reactivate.blockedTitle": "L'analyseur n'est pas prêt",
  "analyzer.lifecycle.reactivate.cancel": "Annuler la réactivation",
  "analyzer.lifecycle.reactivate.confirm": "Réactiver l'analyseur",
  "analyzer.lifecycle.reactivate.error": "Il n'a pas été possible de réactiver l'analyseur.",
  "analyzer.lifecycle.reactivate.errorTitle": "La réactivation a connu un échec",
  "analyzer.lifecycle.reactivate.message": "Réactiver « {name} » ? Sa configuration sera à nouveau vérifiée avant qu'il ne puisse être utilisé.",
  "analyzer.lifecycle.reactivate.title": "Réactiver l'analyseur",
  "analyzer.connection.choice.select": "Sélectionnez une valeur",
  "analyzer.connection.field.apiToken": "jeton API",
  "analyzer.connection.field.connectionRole": "Rôle de connexion",
  "analyzer.connection.field.directory": "Répertoire",
  "analyzer.connection.field.directory.help": "Répertoire sur l'hôte « Analyseur Bridge »",
  "analyzer.connection.field.enabled": "Activée",
  "analyzer.connection.field.filePattern": "Modèle de fichier",
  "analyzer.connection.field.filePattern.help": "Modèle de nom de fichier surveillé par Analyzer Bridge",
  "analyzer.connection.field.host": "Hôte",
  "analyzer.connection.field.host.help": "Adresse IP de l'analyseur. Facultative lorsque l'analyseur se connecte à l'Analyzer Bridge. Laissez-la vide si l'analyseur joint le Bridge via un NAT ou un proxy, et utilisez plutôt le nom système de l'instrument.",
  "analyzer.connection.field.numberFormat": "Séparateur décimal des résultats",
  "analyzer.connection.numberFormat.comma": "Virgule (12,5)",
  "analyzer.connection.numberFormat.point": "Point (12.5)",
  "analyzer.connection.field.port": "Port",
  "analyzer.connection.field.senderId": "Nom système de l'instrument",
  "analyzer.connection.field.senderId.help": "Le nom que cet instrument envoie dans ses messages (ASTM H.5 ou HL7 MSH-3), par exemple le System Name du GeneXpert. Nécessaire uniquement lorsque plusieurs analyseurs partagent ce port et cette adresse.",
  "analyzer.connection.field.serialPort": "Périphérique série",
  "analyzer.connection.field.transport": "Transports",
  "analyzer.connection.field.unavailable": "Paramètres de connexion",
  "analyzer.connection.readiness.profileUnavailable": "Cette connexion est épinglée à {profileId} révision {revision}, que l'Analyzer Bridge ne possède plus. Réinitialisez le type d'analyseur, puis choisissez-en un disponible pour la reconnecter. L'analyseur conserve son nom, ses unités de laboratoire, sa connexion et son historique.",
  "analyzer.connection.readiness.restoreFailed": "L'Analyzer Bridge n'a pas pu redémarrer cette connexion. Activez-la de nouveau ; si l'échec persiste, consultez le journal du Bridge.",
  "analyzer.connection.role.client": "Client",
  "analyzer.connection.role.server": "Serveur",
  "analyzer.connection.reference.configured": "Connexion en pont configurée",
  "analyzer.connection.reference.missing": "Configuration de la connexion requise",
  "analyzer.connection.transport.RS-232": "Série (RS-232)",
  "analyzer.connection.transport.TCP/IP": "Réseau (TCP/IP)",
  "analyzer.connection.validation.invalid": "Vérifiez cette valeur.",
  "analyzer.connection.validation.required": "Ce champ est requis.",
  "analyzer.setup.close": "Fermer la configuration de l'analyseur",
  "analyzer.setup.connect.address.required": "Veuillez saisir l'adresse de l'analyseur",
  "analyzer.activation.blocker.bridgeAcknowledgement": "L'Analyzer Bridge n'a pas accusé réception de cette configuration précise.",
  "analyzer.activation.blocker.connection": "Les paramètres de connexion sont incomplets ou incorrects.",
  "analyzer.activation.blocker.dataFlow": "Le flux de données sélectionné n'est pas pris en charge par ce type d'analyseur.",
  "analyzer.activation.blocker.labUnit": "Veuillez attribuer au moins une unité de laboratoire active.",
  "analyzer.activation.blocker.mappings": "Il convient de vérifier à nouveau les mappages des analyseurs.",
  "analyzer.activation.blocker.name": "Veuillez saisir un nom de l'analyseur.",
  "analyzer.activation.blocker.profile": "Le type d'analyseur sélectionné n'est pas disponible ou ne correspond plus à cet analyseur.",
  "analyzer.activation.blocker.recognition": "La reconnaissance des commandes doit être vérifiée à nouveau.",
  "analyzer.activation.blocker.transport": "Le type de connexion sélectionné n'est pas pris en charge par ce type d'analyseur.",
  "analyzer.setup.connect.activation.active": "L'analyseur est actif",
  "analyzer.setup.connect.activation.activating": "Mise en service de l'analyseur",
  "analyzer.setup.connect.activation.blockerUnknown": "La configuration de l'analyseur n'est pas prête à être activée.",
  "analyzer.setup.connect.activation.cancel": "Annuler",
  "analyzer.setup.connect.activation.error": "Il n'a pas été possible de vérifier si l'analyseur était prêt.",
  "analyzer.setup.connect.activation.finish": "Terminer et activer",
  "analyzer.setup.connect.activation.loading": "Vérification de l'état de fonctionnement de l'analyseur",
  "analyzer.setup.connect.activation.readiness": "État de préparation à l'activation",
  "analyzer.setup.connect.activation.ready": "L'analyseur est prêt à être activé",
  "analyzer.setup.connect.activation.saveChanges": "Enregistrer les modifications",
  "analyzer.setup.connect.activation.saveLater": "Enregistrer et terminer plus tard",
  "analyzer.setup.connect.activation.saving": "Analyseur d'économies",
  "analyzer.setup.connect.activation.verifyMappings": "Vérifier les correspondances",
  "analyzer.setup.connect.analyzerAddress": "Adresse de l'analyseur",
  "analyzer.setup.connect.check.analyzer.address.missing": "Aucune adresse d'analyseur n'est enregistrée, l'analyseur n'a donc pas été vérifié. L'arrivée de résultats depuis l'analyseur prouve que la connexion fonctionne.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "L'adresse d'analyseur {host} n'a pas pu être résolue, l'analyseur n'a donc pas été vérifié. L'arrivée de résultats depuis l'analyseur prouve que la connexion fonctionne.",
  "analyzer.setup.connect.check.analyzer.reachable": "Le Bridge a joint l'analyseur à l'adresse {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "Le Bridge n'a pas pu joindre l'analyseur à l'adresse {host}. Les analyseurs qui se connectent au Bridge ne sont souvent pas joignables depuis celui-ci (pare-feu, NAT ou serveur hébergé). L'arrivée de résultats depuis l'analyseur prouve que la connexion fonctionne.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "Ce mode de connexion n'est pas pris en charge par le pont.",
  "analyzer.setup.connect.check.directory.configuration.missing": "Accédez au répertoire contenant les fichiers de l'analyseur avant de lancer le test.",
  "analyzer.setup.connect.check.directory.not.directory": "Le chemin indiqué n'est pas un répertoire.",
  "analyzer.setup.connect.check.directory.not.found": "Le répertoire configuré est introuvable.",
  "analyzer.setup.connect.check.directory.not.readable": "Le Bridge ne parvient pas à lire le répertoire configuré.",
  "analyzer.setup.connect.check.directory.path.invalid": "Le chemin d'accès au répertoire configuré n'est pas valide.",
  "analyzer.setup.connect.check.directory.ready": "Le répertoire est prêt.",
  "analyzer.setup.connect.check.http.configuration.missing": "Veuillez saisir l'adresse Web de l'analyseur avant de procéder à l'analyse.",
  "analyzer.setup.connect.check.http.connection.error": "Le Bridge n'a pas pu se connecter à l'adresse Web de l'analyseur.",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "Cet analyseur envoie des messages au Bridge, cette connexion doit donc être vérifiée par la transmission d'un résultat.",
  "analyzer.setup.connect.check.http.interrupted": "Le test de connexion Internet a été interrompu.",
  "analyzer.setup.connect.check.http.ready": "L'adresse Web de l'analyseur est accessible.",
  "analyzer.setup.connect.check.http.server.error": "L'adresse Web de l'analyseur a renvoyé une erreur de serveur.",
  "analyzer.setup.connect.check.http.timeout": "L'adresse Web de l'analyseur n'a pas répondu avant l'expiration du délai.",
  "analyzer.setup.connect.check.http.url.invalid": "L'adresse Web de l'analyseur n'est pas valide.",
  "analyzer.setup.connect.check.listener.configuration.missing": "L'écouteur partagé du Bridge n'est pas configuré. Demandez à l'administrateur du Bridge de vérifier ses paramètres d'écoute.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "L'adresse d'écoute de Bridge est non configurée.",
  "analyzer.setup.connect.check.listener.not.listening": "L'écouteur Bridge n'accepte pas les connexions.",
  "analyzer.setup.connect.check.listener.port.in.use": "Le port d'écoute du Bridge configuré est déjà utilisé.",
  "analyzer.setup.connect.check.listener.profile.unsupported": "Le profil épinglé ne définit pas d'écouteur Bridge compatible.",
  "analyzer.setup.connect.check.listener.ready": "Le programme d'écoute « Bridge » est prêt.",
  "analyzer.setup.connect.check.listener.timeout": "L'écouteur Bridge n'a pas répondu avant l'expiration du délai.",
  "analyzer.setup.connect.check.remote.astm.ready": "L'analyseur a terminé la procédure de connexion ASTM.",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "L'analyseur a renvoyé une réponse de protocole ASTM non valide.",
  "analyzer.setup.connect.check.remote.configuration.missing": "Veuillez saisir l'adresse et le port de l'analyseur avant de procéder au test.",
  "analyzer.setup.connect.check.remote.connection.error": "Le Bridge n'a pas pu se connecter à l'analyseur.",
  "analyzer.setup.connect.check.remote.hl7.ready": "L'analyseur a terminé la procédure d'établissement de la connexion HL7.",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "L'analyseur a renvoyé une réponse de négociation HL7 non valide.",
  "analyzer.setup.connect.check.remote.host.unknown": "L'adresse de l'analyseur n'a pas pu être déterminée.",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "Ce protocole d'analyse ne prend pas en charge le test de connexion à distance.",
  "analyzer.setup.connect.check.remote.refused": "L'analyseur a refusé la connexion.",
  "analyzer.setup.connect.check.remote.timeout": "L'analyseur n'a pas répondu avant l'expiration du délai.",
  "analyzer.setup.connect.check.serial.configuration.missing": "Veuillez saisir le numéro de série de l'analyseur avant de procéder à l'analyse.",
  "analyzer.setup.connect.check.serial.not.found": "Le périphérique série configuré n'a pas été détecté.",
  "analyzer.setup.connect.check.serial.not.readable": "Le Bridge ne parvient pas à lire l’appareil série configuré.",
  "analyzer.setup.connect.check.serial.path.invalid": "Le chemin d'accès au périphérique série configuré n'est pas valide.",
  "analyzer.setup.connect.check.serial.ready": "L'appareil série de l'analyseur est prêt.",
  "analyzer.setup.connect.checkKind.analyzer": "Analyseur (pour information)",
  "analyzer.setup.connect.checkKind.directory": "Répertoire",
  "analyzer.setup.connect.checkKind.http_endpoint": "Adresse Web",
  "analyzer.setup.connect.checkKind.http_input": "Messages entrants de l'analyseur",
  "analyzer.setup.connect.checkKind.listener": "Écouteur de pont",
  "analyzer.setup.connect.checkKind.other": "Vérification de la connexion",
  "analyzer.setup.connect.checkKind.remote_protocol": "Protocole d'analyse d'un analyseur",
  "analyzer.setup.connect.checkKind.serial_device": "Périphérique série",
  "analyzer.setup.connect.checkStatus.failed": "Échec de la vérification de la connexion.",
  "analyzer.setup.connect.checkStatus.missing_configuration": "Les paramètres de connexion sont incomplets.",
  "analyzer.setup.connect.checkStatus.passed": "La vérification de la connexion s'est déroulée avec succès.",
  "analyzer.setup.connect.checkStatus.skipped": "Cette vérification n'a pas pu être exécutée.",
  "analyzer.setup.connect.checkStatus.timed_out": "Le délai d'attente de la vérification de la connexion a expiré.",
  "analyzer.setup.connect.configureEndpoint": "Configurez l'analyseur pour qu'il utilise",
  "analyzer.setup.connect.dataFlow": "Flux de données",
  "analyzer.setup.connect.dataFlow.resultsOnly": "Résultats uniquement",
  "analyzer.setup.connect.dataFlow.twoWay": "Bidirectionnel",
  "analyzer.setup.connect.destination": "Destination : {host}, port {port}",
  "analyzer.setup.connect.destinationRemediation": "Vérifiez l'adresse de l'analyseur, le port de destination, le service d'écoute et l'accès réseau, puis testez à nouveau.",
  "analyzer.setup.connect.listenerPort": "Port d'écoute du Bridge : {port}",
  "analyzer.setup.connect.portSource": "Port sélectionné depuis : {source}",
  "analyzer.setup.connect.portSource.override": "Substitution de connexion",
  "analyzer.setup.connect.portSource.profile": "Valeur par défaut du type d'analyseur",
  "analyzer.setup.connect.portSource.bridge": "Valeur par défaut du Bridge",
  "analyzer.setup.connect.directory": "Répertoire des fichiers de l'analyseur",
  "analyzer.setup.connect.directory.required": "Accédez au répertoire contenant les fichiers de l'analyseur",
  "analyzer.setup.connect.error": "Les paramètres de connexion n'ont pas pu être enregistrés ni testés.",
  "analyzer.setup.connect.evidence": "Preuves de connexion",
  "analyzer.setup.connect.loadError": "La connexion à l'analyseur enregistrée n'a pas pu être chargée.",
  "analyzer.setup.connect.loading": "Chargement de la connexion à l'analyseur",
  "analyzer.setup.connect.outcome.failure": "Échec de la connexion",
  "analyzer.setup.connect.outcome.missing_configuration": "Les paramètres de connexion sont incomplets",
  "analyzer.setup.connect.outcome.success": "Connexion prête",
  "analyzer.setup.connect.outcome.timeout": "Délai d'attente de la connexion dépassé",
  "analyzer.setup.connect.port": "Port de l'analyseur",
  "analyzer.setup.connect.port.invalid": "Veuillez saisir un port compris entre 1 et 65 535",
  "analyzer.setup.connect.sourceAddress": "Adresse source de l'analyseur",
  "analyzer.setup.connect.test": "Tester la connexion",
  "analyzer.setup.connect.testing": "Tester la connexion",
  "analyzer.setup.connect.title": "Connect",
  "analyzer.setup.connect.useResultsOnly": "Afficher uniquement les résultats",
  "analyzer.setup.instrument.continue": "Continuer la vérification",
  "analyzer.setup.instrument.labUnits": "Unités de laboratoire",
  "analyzer.setup.instrument.labUnits.placeholder": "Sélectionnez les unités de laboratoire",
  "analyzer.setup.instrument.labUnits.required": "Veuillez sélectionner au moins une unité de laboratoire",
  "analyzer.setup.instrument.name": "Nom de l'analyseur",
  "analyzer.setup.instrument.name.required": "Veuillez saisir le nom de l'analyseur",
  "analyzer.setup.instrument.notListed": "Votre instrument ne figure pas dans la liste ?",
  "analyzer.setup.instrument.saveError": "L'analyseur n'a pas pu être enregistré. Veuillez réessayer.",
  "analyzer.setup.instrument.saving": "Analyseur d'économies",
  "analyzer.setup.instrument.summary": "Détails de l'instrument enregistré",
  "analyzer.setup.step.edit": "Modifier {step}",
  "analyzer.setup.instrument.type": "Type",
  "analyzer.setup.instrument.type.helper": "Choisissez le type répertorié pour votre instrument, même s'il n'envoie que des résultats. Le fait qu'il envoie uniquement des résultats ou reçoive aussi des demandes se règle plus tard, dans Connexion.",
  "analyzer.setup.instrument.type.placeholder": "Rechercher des types d’analyseurs",
  "analyzer.setup.instrument.type.required": "Sélectionnez le type d'analyseur",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · révision {revision}",
  "analyzer.setup.instrument.title": "Instrument",
  "analyzer.setup.steps": "Étapes de configuration de l'analyseur",
  "analyzer.setup.title": "Configurer un nouvel analyseur",
  "analyzer.setup.title.named": "Configurer {name}",
  "analyzer.setup.verify.confirm": "Confirmez les correspondances ci-dessous pour continuer.",
  "analyzer.setup.verify.noAssays": "Aucun dosage n'est activé pour cet instrument. Activez les dosages qu'il réalise dans Dosages.",
  "analyzer.setup.verify.unresolved": "{count, plural, one {# enregistrement ou valeur des dosages activés doit encore être mis en correspondance. Mettez-le en correspondance ci-dessous, ou désactivez le dosage dans Dosages si cet instrument ne le réalise pas.} many {# enregistrements ou valeurs des dosages activés doivent encore être mis en correspondance. Mettez-les en correspondance ci-dessous, ou désactivez le dosage dans Dosages si cet instrument ne le réalise pas.} other {# enregistrements ou valeurs des dosages activés doivent encore être mis en correspondance. Mettez-les en correspondance ci-dessous, ou désactivez le dosage dans Dosages si cet instrument ne le réalise pas.}} of the assays that are on still need mapping. Map them below, or turn the assay off in Assays if this instrument does not run it.",
  "analyzer.setup.verify.continue": "Continuez à vous connecter",
  "analyzer.setup.verify.selecting": "Appliquer les correspondances...",
  "analyzer.setup.verify.selectionError": "Impossible d'appliquer les correspondances révisées. Veuillez recharger la page « Vérifier », puis réessayez.",
  "analyzer.setup.verify.loading": "Chargement de la vérification de la mise en correspondance",
  "analyzer.setup.verify.summary": "Correspondances examinées pour cette configuration",
  "analyzer.setup.verify.summary.stale": "Les correspondances doivent être vérifiées à nouveau",
  "analyzer.setup.verify.title": "Vérifier",
  "analyzer.navigation.analyzerTypes": "Types d’analyseurs",
  "analyzer.navigation.analyzers": "Analyseurs",
  "analyzer.navigation.analyzersList": "Liste des analyseurs",
  "analyzer.navigation.fieldMappings": "Correspondances de champs",
  "analyzer.navigation.qc": "Contrôle qualité",
  "analyzer.navigation.qcDashboard": "Tableau de bord CQ",
  "analyzer.navigation.qcAlerts": "Alertes et non-conformités de contrôle qualité",
  "analyzer.navigation.qcCorrectiveActions": "Actions correctives",
  "analyzerType.action.deactivate": "Désactiver",
  "analyzerType.action.editMappings": "Modifier le mappage",
  "analyzerType.action.history": "Afficher l'historique",
  "analyzerType.action.reactivate": "Réactiver",
  "analyzerType.action.updateShared": "Mise à jour partagée",
  "analyzerType.adoption.adopted": "Révision {revision} adoptée. Confirmez la correspondance ci-dessous, puis appliquez-la pour basculer cet analyseur.",
  "analyzerType.adoption.blocked.heldResults": "{code} a encore des résultats retenus de la révision {revision}. Traitez-les avant l'adoption.",
  "analyzerType.adoption.blocked.inactiveTest": "Mis en correspondance avec une analyse qui n'est plus active. Choisissez une autre analyse.",
  "analyzerType.adoption.blocked.reviewHeld": "Examiner les résultats obtenus",
  "analyzerType.adoption.bucket.blocked": "Bloqué",
  "analyzerType.adoption.bucket.blocked.help": "L'adoption attend que ces éléments soient résolus.",
  "analyzerType.adoption.bucket.changed": "Modifié",
  "analyzerType.adoption.bucket.changed.help": "La nouvelle révision propose autre chose pour ces éléments. Conservez le choix actuel ou utilisez la nouvelle valeur par défaut.",
  "analyzerType.adoption.bucket.needs_mapping": "Cartographie des besoins",
  "analyzerType.adoption.bucket.needs_mapping.help": "Nouveaux dans cette révision, ou non repris. Mettez-les en correspondance maintenant ou laissez-les pour plus tard.",
  "analyzerType.adoption.bucket.retired": "N'est plus envoyé",
  "analyzerType.adoption.bucket.retired.help": "La révision {revision} n'envoie plus ces éléments, leurs correspondances sont donc supprimées.",
  "analyzerType.adoption.bucket.unchanged": "Inchangé",
  "analyzerType.adoption.bucket.unchanged.help": "Ces éléments sont repris tels quels.",
  "analyzerType.adoption.changed.current": "Actuel : {name}",
  "analyzerType.adoption.changed.newDefault": "Nouvelle valeur par défaut : {name}",
  "analyzerType.adoption.error.save": "L'adoption n'a pas pu être enregistrée",
  "analyzerType.adoption.keepCurrent": "Conserver l'actuel",
  "analyzerType.adoption.notice.subtitle": "Cet analyseur continue de recevoir sur la révision {from} jusqu'à ce que vous enregistriez, confirmiez et appliquiez ce changement.",
  "analyzerType.adoption.notice.title": "Adoption de la révision {revision}",
  "analyzerType.adoption.save": "Enregistrer comme révision {revision}",
  "analyzerType.adoption.title": "Adopter la révision {revision} de {name}",
  "analyzerType.adoption.useNewDefault": "Utiliser la nouvelle valeur par défaut",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, one {Analyseur utilisant ce type} many {Analyseurs utilisant ce type} other {Analyseurs utilisant ce type}}",
  "analyzerType.affectedAnalyzers.adopt": "Adopter la révision {revision}",
  "analyzerType.affectedAnalyzers.verify": "Vérifier la correspondance enregistrée",
  "analyzerType.actions.ariaLabel": "Actions en faveur de l’{name}",
  "analyzerType.button.create": "Créer un nouveau type d’analyseur",
  "analyzerType.button.cancel": "Annuler",
  "analyzerType.button.duplicate": "Profil dupliqué",
  "analyzerType.button.publish": "Publier le profil",
  "analyzerType.button.startUpdate": "Commencer à mettre à jour",
  "analyzerType.column.actions": "Actions",
  "analyzerType.column.protocol": "Protocole",
  "analyzerType.column.resultsMapped": "Résultats cartographiés",
  "analyzerType.column.status": "Statut",
  "analyzerType.column.testsMapped": "Analyses répertoriées",
  "analyzerType.column.type": "Type",
  "analyzerType.column.usedBy": "Utilisé par",
  "analyzerType.dataFlow.resultsOnly": "Résultats uniquement",
  "analyzerType.dataFlow.twoWay": "Bidirectionnel",
  "analyzerType.duplicate.lineage.subtitle": "Le nouveau profil s'appuie sur la révision {revision} de la spécification « {name} ». Les modifications ultérieures n'altèrent ni le profil source ni ses analyseurs.",
  "analyzerType.duplicate.lineage.title": "Nouveau profil avec préservation de la lignée",
  "analyzerType.draft.created.subtitle": "Le brouillon est enregistré dans Analyzer Bridge. Il doit être terminé et validé avant de pouvoir être publié en vue de la configuration de l'analyseur.",
  "analyzerType.draft.created.title": "Ébauche de profil créée",
  "analyzerType.draft.loading": "Chargement du brouillon du projet de profil",
  "analyzerType.draft.publish.ready.subtitle": "{name} possède une identité unique propre à Bridge et préserve la filiation de sa source.",
  "analyzerType.draft.publish.ready.title": "Prêt à être publié",
  "analyzerType.draft.publish.review.subtitle": "Vérifiez et enregistrez le comportement de reconnaissance des commandes pour {name} avant la publication.",
  "analyzerType.draft.publish.review.title": "Examen complet du profil",
  "analyzerType.draft.update.loading": "Chargement du brouillon de mise à jour du profil",
  "analyzerType.draft.update.subtitle": "Le type d'analyseur partagé reste inchangé jusqu'à ce que ce brouillon soit terminé et publié. Les analyseurs existants restent associés à leurs révisions actuelles.",
  "analyzerType.draft.update.title": "Brouillon de mise à jour du profil créé",
  "analyzerType.empty.subtitle": "Ajustez la recherche ou les filtres pour afficher d'autres types d'analyseurs.",
  "analyzerType.empty.title": "Non, aucun type d’analyseur ne correspond",
  "analyzerType.explainer.subtitle": "Des analyseurs identiques peuvent partager un même type. Dupliquez un type lorsqu'un analyseur nécessite un comportement différent ; désactivez les types plutôt que de supprimer leur historique.",
  "analyzerType.explainer.title": "Configuration d'un analyseur réutilisable",
  "analyzerType.error.nameUnique": "Les noms de profil doivent être uniques",
  "analyzerType.field.connectionTest": "Permet de tester la connexion",
  "analyzerType.field.dataFlow": "Flux de données",
  "analyzerType.field.fileFormat": "Format de fichier pour les fichiers",
  "analyzerType.field.filePattern": "Modèle de nom de fichier",
  "analyzerType.field.manufacturer": "Fabricant",
  "analyzerType.field.model": "Modèle",
  "analyzerType.field.newProfileName": "Nouveau nom de profil",
  "analyzerType.field.profileName": "Nom du profil",
  "analyzerType.field.protocol": "Protocole",
  "analyzerType.field.resultColumn": "Colonne « Résultat »",
  "analyzerType.field.sampleColumn": "Colonne « ID d'échantillon »",
  "analyzerType.field.sourceProfile.placeholder": "Sélectionnez le type d'analyseur",
  "analyzerType.field.sourceProfile": "Type d’analyseur de source",
  "analyzerType.field.testColumn": "Colonne « Code de test »",
  "analyzerType.filter.all": "Tous",
  "analyzerType.filter.mapping": "Statut de la cartographie",
  "analyzerType.filter.protocol": "Protocole",
  "analyzerType.filter.showDeactivated": "Affichage désactivé",
  "analyzerType.filter.source": "Créé",
  "analyzerType.history.action.created": "Créé",
  "analyzerType.history.action.deactivated": "Désactivé",
  "analyzerType.history.action.duplicated": "Dupliquer",
  "analyzerType.history.action.reactivated": "Réactivé",
  "analyzerType.history.action.shipped": "Expédiés",
  "analyzerType.history.action.updated": "Mis à Jour ",
  "analyzerType.history.actor": "Modifié par",
  "analyzerType.history.change": "Modifications",
  "analyzerType.history.loading": "Chargement de l'historique des profils",
  "analyzerType.history.revisionValue": "Révision {revision}",
  "analyzerType.history.revision": "Révision",
  "analyzerType.history.status": "Statut",
  "analyzerType.history.time": "Modifié le",
  "analyzerType.lineage": "Extrait de {profileId}, révision {revision}",
  "analyzerType.loading": "Chargement des types d’analyseurs",
  "analyzerType.mapping.complete": "Entièrement cartographié",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} marqué « Ne plus recevoir »",
  "analyzerType.mapping.incomplete": "Cartographie des besoins",
  "analyzerType.mapping.notApplicable": "Sans objet",
  "analyzerType.mapping.notStarted": "Non répertorié",
  "analyzerType.mappingEditor.applyToAnalyzer": "Appliquer les correspondances et retraiter les résultats retenus",
  "analyzerType.mappingEditor.appliedToAnalyzer": "Correspondances actuelles appliquées à cet analyseur. Les résultats retenus éligibles ont été retraités.",
  "analyzerType.mappingEditor.error.applyToAnalyzer": "Impossible d'appliquer les correspondances à cet analyseur.",
  "analyzerType.mappingEditor.alias": "Alias : {alias}",
  "analyzerType.mappingEditor.confirm": "Confirmer les correspondances et contrôler la reconnaissance",
  "analyzerType.mappingEditor.confirmation.by": "Confirmé par {actor} sur {date}",
  "analyzerType.mappingEditor.confirmation.current": "Confirmation de l'état actuel",
  "analyzerType.mappingEditor.confirmation.stale": "La confirmation est périmée",
  "analyzerType.mappingEditor.confirmation.summary.current": "Actuel",
  "analyzerType.mappingEditor.confirmation.summary.stale": "Périmé",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "Non confirmé",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "Non confirmé",
  "analyzerType.mappingEditor.confirmation": "Confirmation",
  "analyzerType.mappingEditor.confirmed": "Correspondances et reconnaissance des commandes confirmées",
  "analyzerType.mappingEditor.error.confirm": "Échec de la confirmation",
  "analyzerType.mappingEditor.error.load": "Les mappages de type d’analyseur n’ont pas pu être chargés",
  "analyzerType.mappingEditor.error.route": "Un type valide d’analyseur est requis",
  "analyzerType.mappingEditor.error.save": "Les correspondances n'ont pas pu être enregistrées",
  "analyzerType.mappingEditor.excludeResult.short": "Ne pas recevoir",
  "analyzerType.mappingEditor.excludeResult": "Ne recevez pas d'{value}",
  "analyzerType.mappingEditor.callComponentPicker": "Le résultat qualitatif de {code} va vers",
  "analyzerType.mappingEditor.componentPicker": "Composant OpenELIS pour {code}",
  "analyzerType.mappingEditor.componentPicker.required": "Choisissez le composant sur lequel arrive cet enregistrement.",
  "analyzerType.mappingEditor.componentPicker.placeholder": "Choisir un composant",
  "analyzerType.mappingEditor.excludeTest": "Ne recevez pas d'{code}",
  "analyzerType.mappingEditor.translationOf": "Traduction de {value}",
  "analyzerType.mappingEditor.partial": "{count} correspondances non résolues. Vous pouvez confirmer et connecter ; les résultats concernés seront conservés pour correction avant utilisation.",
  "analyzerType.mappingEditor.incomplete": "Traitez ou excluez explicitement chaque ligne source avant de confirmer.",
  "analyzerType.mappingEditor.loading": "Chargement des correspondances de types d’analyseurs",
  "analyzerType.mappingEditor.normalized": "Identité normalisée",
  "analyzerType.mappingEditor.observed": "Constaté dans les résultats conservés",
  "analyzerType.mappingEditor.recognition.heading": "Reconnaissance des résultats de contrôle",
  "analyzerType.mappingEditor.recognition.none": "Ce type d'analyseur indique explicitement que l'interface ne transmet aucun résultat de contrôle.",
  "analyzerType.mappingEditor.resultPicker.placeholder": "Choisissez un résultat OpenELIS",
  "analyzerType.mappingEditor.resultPicker": "Résultat OpenELIS pour {value}",
  "analyzerType.mappingEditor.tests.none": "Ce type d'analyseur ne déclare aucune analyse, il n'y a donc rien à mettre en correspondance. Son auteur peut ajouter des analyses dans une nouvelle révision du type.",
  "analyzerType.mappingEditor.results.empty": "Ce test ne comporte aucune option de résultat active",
  "analyzerType.mappingEditor.results.heading": "Résultats - {name}",
  "analyzerType.mappingEditor.results.loading": "Chargement des options de résultats",
  "analyzerType.mappingEditor.results.openCatalog": "Ajouter des options de résultat dans le catalogue de tests",
  "analyzerType.mappingEditor.results.testFirst": "Choisissez un test OpenELIS avant de mettre en correspondance ses résultats",
  "analyzerType.mappingEditor.reason.result.ambiguous": "Non mis en correspondance : plusieurs réponses de cette analyse portent le code de cette valeur. Choisissez-en une.",
  "analyzerType.mappingEditor.reason.result.incompatible": "Non mis en correspondance : aucune réponse de cette analyse ne peut contenir cette valeur.",
  "analyzerType.mappingEditor.reason.result.no_match": "Non mis en correspondance : aucune réponse de cette analyse ne porte le code de cette valeur.",
  "analyzerType.mappingEditor.reason.test.ambiguous": "Non mis en correspondance : plusieurs analyses du catalogue de ce laboratoire portent son code. Choisissez-en une.",
  "analyzerType.mappingEditor.reason.test.incompatible": "Non mis en correspondance : une analyse du catalogue de ce laboratoire porte son code mais ne peut pas contenir ces résultats.",
  "analyzerType.mappingEditor.reason.test.no_match": "Non mis en correspondance : aucune analyse du catalogue de ce laboratoire ne porte son code.",
  "analyzerType.mappingEditor.results": "Résultats cartographiés",
  "analyzerType.mappingEditor.return": "Types d’analyseurs",
  "analyzerType.mappingEditor.save": "Mettre à jour les mappages partagés",
  "analyzerType.mappingEditor.saved": "Correspondances enregistrées",
  "analyzerType.mappingEditor.own.title": "Correspondance propre à cet analyseur",
  "analyzerType.mappingEditor.own.subtitle": "Les modifications faites ici ne s'appliquent qu'à cet analyseur. Elles prennent effet lorsque vous confirmez la correspondance et l'appliquez.",
  "analyzerType.mappingEditor.defaults.title": "Valeurs par défaut pour les nouveaux analyseurs",
  "analyzerType.mappingEditor.defaults.subtitle": "Voici la configuration de départ d'un nouvel analyseur de ce type, mise en correspondance par codes standard avec le catalogue actuel. Rien n'est enregistré ici ; chaque analyseur conserve sa propre correspondance.",
  "analyzerType.mappingEditor.origin.override": "Modifié",
  "analyzerType.mappingEditor.changes.heading": "Vérifier les modifications avant d'enregistrer",
  "analyzerType.mappingEditor.changes.save": "Enregistrer les modifications",
  "analyzerType.mappingEditor.changes.none": "Rien n'a changé depuis le dernier enregistrement.",
  "analyzerType.mappingEditor.changes.row": "{from} à l'adresse {to}",
  "analyzerType.mappingEditor.sourceCode": "Code de l'analyseur",
  "analyzerType.mappingEditor.state.bound": "Mapped",
  "analyzerType.mappingEditor.state.excluded": "Ne pas recevoir",
  "analyzerType.mappingEditor.state.unresolved": "Cartographie des besoins",
  "analyzerType.mappingEditor.subtitle": "{protocol} · révision {revision}",
  "analyzerType.mappingEditor.suggestion": "Suggestion de lien : {name}",
  "analyzerType.mappingEditor.summary": "Résumé de la cartographie",
  "analyzerType.mappingEditor.testPicker.placeholder": "Rechercher par nom, code ou LOINC",
  "analyzerType.mappingEditor.testPicker": "Test OpenELIS pour {code}",
  "analyzerType.mappingEditor.tests.heading": "Correspondances entre les analyses et les résultats",
  "analyzerType.mappingEditor.tests.help": "Examinez chaque code d'analyseur séparément. Associez-le à une analyse OpenELIS active ou excluez-le explicitement.",
  "analyzerType.mappingEditor.tests": "Analyses répertoriées",
  "analyzerType.mappingEditor.title": "{name} correspondances",
  "analyzerType.mappingEditor.unsaved": "Modifications de cartographie non enregistrées",
  "analyzerType.mappingEditor.useSuggestion": "Utilisez l'analyse proposée",
  "analyzerType.modal.deactivate.subtitle": "Les analyseurs existants et l'historique des révisions restent associés. Ce profil ne sera plus disponible pour la configuration de nouveaux analyseurs.",
  "analyzerType.modal.deactivate.title": "Désactiver {name}",
  "analyzerType.modal.history.title": "{name} histoire",
  "analyzerType.modal.reactivate.subtitle": "Ce profil sera à nouveau disponible pour la configuration des nouveaux analyseurs. Les analyseurs existants restent associés aux révisions sélectionnées.",
  "analyzerType.modal.reactivate.title": "Réactiver {name}",
  "analyzerType.modal.update.subtitle": "Cette action démarre une nouvelle révision non modifiable à partir de la révision {revision}. {count, plural, one {# analyseur reste associé à sa révision actuelle.} other {# analyseurs restent associés à leurs révisions actuelles.}}",
  "analyzerType.modal.update.title": "Mise à jour {name}",
  "analyzerType.notification.action.error.subtitle": "Veuillez réessayer l'action liée au profil.",
  "analyzerType.notification.action.error": "Échec de l'action sur le profil",
  "analyzerType.notification.create.success": "Profil créé",
  "analyzerType.notification.deactivate.success": "Profil désactivé",
  "analyzerType.notification.duplicate.success": "Profil en double",
  "analyzerType.notification.update.success": "Profil mis à jour",
  "analyzerType.notification.loadError.subtitle": "Vérifiez la connexion de l'Analyseur Bridge, puis réessayez.",
  "analyzerType.notification.catalogIssues": "Certains profils d'analyseur n'ont pas pu être chargés",
  "analyzerType.notification.catalogIssues.subtitle": "L'Analyzer Bridge a mis ces fichiers de côté et sert tous les autres profils. Corrigez ou supprimez chaque fichier, puis redémarrez le Bridge.",
  "analyzerType.notification.loadError": "Les types d’analyseurs n’ont pas pu être chargés",
  "analyzerType.notification.reactivate.success": "Profil réactivé",
  "analyzerType.page.subtitle": "Les configurations réutilisables de vos analyseurs.",
  "analyzerType.page.title": "Types d’analyseurs",
  "analyzerType.protocol.file": "Fichier plat",
  "analyzerType.recognition.none.affirmation": "Je confirme que cette interface ne transmet pas les résultats de contrôle",
  "analyzerType.recognition.none.subtitle": "Ne publiez ce profil que lorsque l'interface de l'analyseur n'envoie aucun résultat de contrôle. Les profils qui transmettent des contrôles nécessitent des règles de reconnaissance explicites.",
  "analyzerType.recognition.none.title": "Non de reconnaissance automatique des résultats de contrôle",
  "analyzerType.recognition.condition.add": "Ajouter une condition",
  "analyzerType.recognition.condition.fieldValue": "{source} Valeur",
  "analyzerType.recognition.condition.new": "Nouvelle condition de reconnaissance",
  "analyzerType.recognition.condition.prefixValue": "Préfixe d'identification des échantillons",
  "analyzerType.recognition.condition.remove": "Retirer la condition",
  "analyzerType.recognition.condition.select.placeholder": "Choisissez une pathologie",
  "analyzerType.recognition.condition.select": "État neuf",
  "analyzerType.recognition.condition.sourceContains": "{source} contient",
  "analyzerType.recognition.condition.sourceEquals": "{source} équivaut à",
  "analyzerType.recognition.condition.specimenPrefix": "L'identifiant de l'échantillon commence par",
  "analyzerType.recognition.condition.summary.configuredPattern": "L'identifiant de l'échantillon correspond à un modèle configuré",
  "analyzerType.recognition.condition.summary.contains": "{source} contient {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} équivaut à {value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} commence par {value}",
  "analyzerType.recognition.condition.summary.unknown": "Reconnaissance des résultats de contrôle",
  "analyzerType.recognition.error.load": "La reconnaissance des commandes n'a pas pu être chargée.",
  "analyzerType.recognition.error.save": "La reconnaissance des commandes n'a pas pu être enregistrée.",
  "analyzerType.recognition.error.title": "La reconnaissance des commandes nécessite une attention particulière",
  "analyzerType.recognition.heading": "Reconnaissance des résultats de contrôle",
  "analyzerType.recognition.loading": "Reconnaissance du contrôle de chargement",
  "analyzerType.recognition.mode.none": "Cette interface ne transmet pas les résultats des contrôles",
  "analyzerType.recognition.mode.none.short": "Non de reconnaissance des résultats de contrôle",
  "analyzerType.recognition.mode.rules": "Identifiez les contrôles à l'aide de ces conditions",
  "analyzerType.recognition.mode.rules.short": "Reconnaissance des commandes basée sur des règles",
  "analyzerType.recognition.mode.unconfigured.short": "Reconnaissance des contrôles non configurée",
  "analyzerType.recognition.mode.unconfigured": "Aucune règle de reconnaissance des contrôles n'est configurée. Les résultats de contrôle risquent de ne pas être identifiés automatiquement.",
  "analyzerType.recognition.mode": "Comment cette interface identifie-t-elle les résultats des contrôles ?",
  "analyzerType.recognition.rules.help": "Un résultat est considéré comme un contrôle dès lors qu'une condition quelconque est remplie.",
  "analyzerType.recognition.save": "Enregistrer la reconnaissance des commandes",
  "analyzerType.recognition.saved": "Reconnaissance des commandes enregistrée",
  "analyzerType.recognition.source.specimenId": "IDENTIFIANT de l'échantillon",
  "analyzerType.revision": "révision {revision}",
  "analyzerType.search.label": "Rechercher des types d’analyseurs",
  "analyzerType.search.placeholder": "Rechercher des types d’analyseurs...",
  "analyzerType.source.shipped": "Expédiés",
  "analyzerType.source.site": "Créé par le site",
  "analyzerType.status.active": "Active",
  "analyzerType.status.inactive": "Désactivé",
  "analyzerType.summary.ariaLabel": "Résumé des types d’analyseurs",
  "analyzerType.summary.deactivated": "Désactivé",
  "analyzerType.summary.inUse": "Utilisé",
  "analyzerType.summary.needsAttention": "À traiter",
  "analyzerType.summary.total": "Types d’analyseurs",
  "analyzerType.usedBy": "{count, plural, =0 {Non utilisé} one {# analyseur} other {# analyseurs}}",
  "analyzer.navigation.qcControlLots": "Lots de contrôle",
  "analyzer.navigation.qcRuleConfig": "Configuration des règles",
  "analyzer.page.addButton": "Ajouter un analyseur",
  "analyzer.page.hierarchy.list": "Liste des analyseurs",
  "analyzer.page.hierarchy.mappings": "Correspondances de champs",
  "analyzer.page.hierarchy.root": "Analyseurs",
  "analyzer.page.title": "Analyseurs",
  "analyzer.plugin.missing": "Plugin Missing",
  "analyzer.qc.alerts.message": "Les fonctionnalités d'alertes et de violations arrivent bientôt.",
  "analyzer.qc.alerts.title": "Alertes et non-conformités de contrôle qualité",
  "analyzer.qc.corrective.message": "Les fonctionnalités d'actions correctives arrivent bientôt.",
  "analyzer.qc.corrective.title": "Actions correctives",
  "analyzer.qc.placeholder.message": "Les fonctionnalités de contrôle de qualité arrivent bientôt.",
  "analyzer.qc.placeholder.title": "Contrôle qualité",
  "analyzer.action.viewResults": "Voir les résultats",
  "analyzer.results.held.assayNotEnabled": "Ce dosage est désactivé dans la configuration de l'analyseur, son résultat a donc été retenu. Activez-le à l'étape Dosages de la configuration si cet instrument l'effectue ; le résultat est retraité lorsque la correspondance est appliquée.",
  "analyzer.results.held.code": "Code de l'analyseur : {code}",
  "analyzer.results.held.enableAssay": "Activer le dosage",
  "analyzer.results.held.instrumentNote": "Note de l'instrument : {note}",
  "analyzer.results.held.otherRevision": "Envoyé selon la révision {revision} du profil de cet analyseur, qui lit cette analyse différemment de la révision en vigueur. Repassez l'échantillon.",
  "analyzer.results.instrumentReported": "Rapporté par l'instrument",
  "analyzer.results.instrumentReported.assay": "Dosage : {assay}",
  "analyzer.results.instrumentReported.assayVersion": "Dosage : {assay}, version {version}",
  "analyzer.results.instrumentReported.flag": "Indicateur : {flag}",
  "analyzer.results.instrumentReported.operator": "Opérateur : {operator}",
  "analyzer.results.failedRun.dismiss": "Ignorer comme série en échec",
  "analyzer.results.failedRun.dismissed": "La série en échec est enregistrée sur la demande et son analyse reste ouverte pour la reprise.",
  "analyzer.results.failedRun.error": "La série en échec n'a pas pu être ignorée",
  "analyzer.results.held.qcTargetMissing": "Ce contrôle a renvoyé une réponse, mais son analyse et son niveau de contrôle n'ont aucune cible de CQ pour l'évaluer. Définissez la réponse attendue, puis appliquez la correspondance de l'analyseur pour le retraiter.",
  "analyzer.results.held.setQcTarget": "Définir la cible de CQ",
  "analyzer.results.held.reviewMapping": "Vérification de la correspondance des types d’analyseurs",
  "analyzer.results.sampleFlags": "Indicateurs de l'analyseur : {flags}",
  "analyzer.results.held.subtitle": "Les résultats en attente ne peuvent pas être validés. Veuillez corriger le mappage du type d’analyseur afin que la prochaine correspondance puisse intégrer le plan de travail de révision habituel.",
  "analyzer.results.held.tag": "Tenu",
  "analyzer.results.held.title": "{count, plural, one {# résultat d'analyseur nécessite une attention} many {# résultats d'analyseur nécessitent une attention} other {# résultats d'analyseur nécessitent une attention}}",
  "analyzer.qualitativeMapping.isDefault": "Default",
  "analyzer.qualitativeMapping.mappings": "Correspondances des valeurs",
  "analyzer.qualitativeMapping.noValues": "Aucune valeur d’analyseur disponible pour le mapping",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Sélectionner le code OpenELIS",
  "analyzer.qualitativeMapping.subtitle": "Associer les valeurs qualitatives pour {fieldName}",
  "analyzer.qualitativeMapping.title": "Correspondance des valeurs qualitatives",
  "analyzer.qualitativeMapping.validation.error": "Erreur de validation",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Veuillez corriger les erreurs ci-dessous",
  "analyzer.qualitativeMapping.validation.noDefault": "Aucune valeur par défaut",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "Au moins une correspondance doit être définie comme valeur par défaut",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "Le code OpenELIS est obligatoire",
  "analyzer.query.button": "Interroger l'analyseur",
  "analyzer.query.cancel": "Annuler",
  "analyzer.query.modal.logs": "Journaux de connexion",
  "analyzer.query.modal.noLogs": "Aucun journal pour le moment.",
  "analyzer.query.modal.progress": "Progrès",
  "analyzer.query.modal.state": "État",
  "analyzer.query.modal.subtitle": "Récupérer les champs disponibles depuis l'analyseur",
  "analyzer.query.modal.title": "Interroger l'analyseur",
  "analyzer.query.progress": "{percent}% terminé",
  "analyzer.search.label": "Rechercher",
  "analyzer.search.placeholder": "Rechercher des analyseurs...",
  "analyzer.attention.review": "Examiner les résultats obtenus",
  "analyzer.attention.subtitle": "Veuillez recenser les analyses ou les valeurs de résultats inconnues avant d'utiliser ces résultats à des fins cliniques.",
  "analyzer.attention.tag": "À surveiller",
  "analyzer.attention.title.many": "{count} Les analyseurs ont conservé les résultats",
  "analyzer.attention.title.one": "{name} il a publié ses résultats",
  "analyzer.stat.active": "Active",
  "analyzer.stat.inactive": "Inactif",
  "analyzer.stat.needsAttention": "À surveiller",
  "analyzer.stat.setup": "Dans la configuration",
  "analyzer.stat.total": "Total des analyseurs",
  "analyzer.stats.active": "Analyseurs actifs",
  "analyzer.stats.inactive": "Analyseurs inactifs",
  "analyzer.stats.total": "Total des analyseurs",
  "analyzer.status.active": "Active",
  "analyzer.status.deleted": "Supprimé",
  "analyzer.status.error_pending": "Erreur en attente",
  "analyzer.status.inactive": "Inactif",
  "analyzer.status.offline": "Hors ligne",
  "analyzer.status.setup": "Configuration",
  "analyzer.status.validation": "Validation",
  "analyzer.success.save": "Analyseur enregistré avec succès",
  "analyzer.table.actions": "Actions",
  "analyzer.table.connection": "Connexion",
  "analyzer.table.header.connection": "Connexion",
  "analyzer.table.header.lastModified": "Dernière modification",
  "analyzer.table.header.name": "Nom",
  "analyzer.table.header.status": "Statut",
  "analyzer.table.header.testUnits": "Unités de test",
  "analyzer.table.header.type": "Type",
  "analyzer.table.lastModified": "Dernière modification",
  "analyzer.table.name": "Nom",
  "analyzer.table.status": "Statut",
  "analyzer.table.testUnits": "Unités de test",
  "analyzer.table.type": "Type",
  "analyzer.table.type.loading": "Chargement du type d’analyseur",
  "analyzer.table.type.unavailable": "Type d’analyseur indisponible",
  "analyzer.testUnits.count": "{count, plural, one {# unit} other {# units}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "Impossible de joindre l'endpoint de santé du bridge à {url} : {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Le bridge a retourné HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Le bridge n'est pas configuré",
  "analyzer.testConnection.bridge.unparseableResponse": "Le bridge a retourné une réponse non analysable",
  "analyzer.testConnection.bridge.unreachable": "Impossible de joindre le bridge : {detail}",
  "analyzer.testConnection.close": "Fermer",
  "analyzer.testConnection.logs": "Journaux de connexion",
  "analyzer.testConnection.requestBuildFailed": "Échec de la construction de la requête : {detail}",
  "analyzer.testConnection.success": "Connexion réussie",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Le bridge n'est pas configuré, la joignabilité de l'analyseur ne peut pas être testée",
  "analyzer.testConnection.testAgain": "Tester à nouveau",
  "analyzer.testConnection.testing": "Test de la connexion...",
  "analyzer.testConnection.title": "Test de connexion",
  "analyzer.testMapping.activeMappings": "{count} correspondances actives",
  "analyzer.testMapping.analyzerInfo": "Informations sur l’analyseur",
  "analyzer.testMapping.analyzerName": "Nom de l’analyseur",
  "analyzer.testMapping.analyzerType": "Type d’analyseur ",
  "analyzer.testMapping.appliedMappings": "Correspondances appliquées",
  "analyzer.testMapping.entityPreview": "Aperçu de l’entité OpenELIS",
  "analyzer.testMapping.errors": "Erreur",
  "analyzer.testMapping.loading": "Préparation de l’aperçu...",
  "analyzer.testMapping.messageInput": "Message ASTM d’échantillon",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} caractères",
  "analyzer.testMapping.messageInput.helper": "Saisissez un message ASTM d’échantillon pour prévisualiser son interprétation",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Message ASTM d’échantillon *",
  "analyzer.testMapping.noResults": "Aucun résultat d’aperçu pour le moment. Saisissez un message ASTM d’échantillon puis cliquez sur « Prévisualiser le mapping ».",
  "analyzer.testMapping.parsedFields": "Parsed Fields",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM Ref",
  "analyzer.testMapping.parsedFields.fieldName": "Nom du champ",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretation",
  "analyzer.testMapping.parsedFields.mappedTo": "Mapped To",
  "analyzer.testMapping.parsedFields.rawValue": "Raw Value",
  "analyzer.testMapping.pluginConfigSnapshot": "Plugin Config Snapshot",
  "analyzer.testMapping.previewOptions": "Preview Options",
  "analyzer.testMapping.previewOptions.detailedParsing": "Show detailed parsing steps",
  "analyzer.testMapping.previewOptions.validateAll": "Validate all mappings",
  "analyzer.testMapping.results": "Résultats du test",
  "analyzer.testMapping.saveTestCase": "Save as Test Case",
  "analyzer.testMapping.submit": "Soumettre un message d'exemple",
  "analyzer.testMapping.subtitle": "Preview how sample ASTM messages will be interpreted",
  "analyzer.testMapping.testAnother": "Test Another Message",
  "analyzer.testMapping.title": "Tester le mappage",
  "analyzer.testMapping.validation.invalidFormat": "Invalid ASTM message format",
  "analyzer.testMapping.validation.messageRequired": "ASTM message is required",
  "analyzer.testMapping.validation.messageTooLarge": "ASTM message exceeds maximum size of 10KB",
  "analyzer.testMapping.warnings": "Warnings",
  "analyzer.unitMapping.analyzerUnit": "Source Unit (Analyzer)",
  "analyzer.unitMapping.analyzerUnit.helper": "Unit reported by the analyzer",
  "analyzer.unitMapping.conversionFactor": "Conversion Factor",
  "analyzer.unitMapping.conversionFactor.helper": "Factor to convert from {from} to {to} (e.g., 0.0555 for mg/dL to mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Target Unit (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Canonical unit used in OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Select target unit",
  "analyzer.unitMapping.rejectIfMismatch": "Reject if Units Don't Match",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Reject messages if units don't match and no conversion factor is provided",
  "analyzer.unitMapping.subtitle": "Configure unit mapping for {fieldName}",
  "analyzer.unitMapping.title": "Unit Mapping",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Source unit is required",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Conversion factor must be a positive number",
  "analyzer.unitMapping.validation.conversionFactor.required": "Conversion factor is required when units differ",
  "analyzer.unitMapping.validation.error": "Erreur de validation",
  "analyzer.unitMapping.validation.error.subtitle": "Veuillez corriger les erreurs ci-dessous",
  "analyzer.unitMapping.validation.openelisUnit.required": "Target unit is required",
  "analyzerTestName.header.analyzerName": "Analyseur – Nom du test dans l'analyseur",
  "analyzerTestName.modal.add.heading": "Ajouter un nom de test dans l'analyseur",
  "analyzerTestName.modal.update.heading": "Ajouter un nom de test dans l'analyseur",
  "assigned.cytopathologist.label": "Cytopathologiste attribué",
  "assigned.pathologist.label": "Pathologiste affecté",
  "assigned.technician.label": "Technicien affecté",
  "audittrail.table.heading.action": "Action",
  "audittrail.table.heading.identifier": "Identifiant",
  "audittrail.table.heading.item": "Élément",
  "audittrail.table.heading.newvalue": "Nouvelle Valeur",
  "audittrail.table.heading.oldvalue": "Ancienne Valeur",
  "audittrail.table.heading.time": "Heure",
  "audittrail.table.heading.user": "Utilisateur",
  "audittrail.table.title.patientResults": "Résultats des analyses des patients",
  "availabletests.title": "Tests disponibles",
  "back.action.button": "Back",
  "banner.menu.administration": "Administrateur",
  "banner.menu.alerts": "Alertes",
  "banner.menu.alerts.tooltip": "Tableau de bord des alertes et de l’assurance qualité",
  "banner.menu.aliquot": "Aliquote",
  "banner.menu.aliquot.tooltip": "Échantillon Aliquoté",
  "banner.menu.billing": "Facturation",
  "banner.menu.billing.tooltip": "Facturation",
  "banner.menu.createDouble": "Double entrée",
  "banner.menu.createInitial": "Entrée initiale",
  "banner.menu.eorders": "Ordonnances externes",
  "banner.menu.eqa": "EEQ",
  "banner.menu.eqa.distribution": "Distributions d’EEQ",
  "banner.menu.eqa.distribution.tooltip": "Créer et gérer les distributions d'EEQ",
  "banner.menu.eqa.management": "Programmes EEQ",
  "banner.menu.eqa.management.tooltip": "Créer et gérer les programmes d'EEQ",
  "banner.menu.eqa.mgmt": "Gestion EQA",
  "banner.menu.eqa.mgmt.distributions": "Distributions",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Créer et gérer les distributions d'EEQ",
  "banner.menu.eqa.mgmt.participants": "Participants",
  "banner.menu.eqa.mgmt.participants.tooltip": "Gérer l'inscription des organisations aux programmes EQE",
  "banner.menu.eqa.mgmt.programs": "Programmes",
  "banner.menu.eqa.mgmt.programs.tooltip": "Créer et gérer les programmes d'EEQ",
  "banner.menu.eqa.mgmt.results": "Résultats et analyse",
  "banner.menu.eqa.mgmt.results.tooltip": "Collecte de résultats et analyse statistique EQE",
  "banner.menu.eqa.mgmt.tooltip": "Gérer les programmes EQE, participants et distributions",
  "banner.menu.eqa.tests": "Tests EQE",
  "banner.menu.eqa.tests.myPrograms": "Mes programmes",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Gérer l'inscription aux programmes EQE externes",
  "banner.menu.eqa.tests.orders": "Commandes",
  "banner.menu.eqa.tests.orders.tooltip": "Voir et gérer les commandes de tests EQE",
  "banner.menu.eqa.tests.tooltip": "Commandes de tests EQE et inscription aux programmes",
  "banner.menu.eqa.tooltip": "Évaluation Externe de la Qualité",
  "banner.menu.generic.sample": "Échantillon générique",
  "banner.menu.generic.sample.edit": "Modifier l'échantillon",
  "banner.menu.generic.sample.import": "Importer  échantillons",
  "banner.menu.generic.sample.order": "Recevoir un échantillon",
  "banner.menu.generic.sample.results": "Saisir les résultats",
  "banner.menu.help": "Aide",
  "banner.menu.help.about": "Tutoriels vidéo",
  "banner.menu.help.contact": "Notes de version",
  "banner.menu.help.documents": "Documentation des processus",
  "banner.menu.help.formDBS": "Formulaire DBS",
  "banner.menu.help.formVL": "Formulaire VL",
  "banner.menu.help.usermanual": "Manuel de l'utilisateur",
  "banner.menu.home": "Accueil",
  "banner.menu.inventory": "Inventaire",
  "banner.menu.inventory.catalog": "Gérer le catalogue",
  "banner.menu.inventory.dashboard": "Tableau de bord",
  "banner.menu.inventory.list": "Éléments d’inventaire",
  "banner.menu.inventory.reports": "Rapports",
  "banner.menu.nonconformity": "Non Conforme",
  "banner.menu.nonconformity.correctiveActions": "Actions Correctives",
  "banner.menu.nonconformity.dashboard": "Toutes les non-conformités ",
  "banner.menu.nonconformity.report": "Signaler un événement non conforme",
  "banner.menu.nonconformity.view": "Voir les Nouveaux Événements Non Conformes",
  "banner.menu.patient": "Patient",
  "banner.menu.patient.Create": "Etude",
  "banner.menu.patient.addOrEdit": "Ajouter/Modifier un Patient",
  "banner.menu.patient.merge": "Fusionner Patient",
  "banner.menu.patient.merge.tooltip": "Fusionner les enregistrements de patients en doublon",
  "banner.menu.patientConsult": "Voir",
  "banner.menu.patientEdit": "Modifier",
  "banner.menu.patienthistory": "Historique du Patient",
  "banner.menu.printBarcode": "code-barre",
  "banner.menu.referredOut": "Référé à un laboratoire externe",
  "banner.menu.report.validation.backlog": "Compte de tests en attente de validation",
  "banner.menu.reports": "Rapports",
  "banner.menu.reports.routine": "Routine",
  "banner.menu.reports.study": "Etude",
  "banner.menu.results": "Résultats",
  "banner.menu.results.CobasIntegra400": "Biochimie: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Immunologie: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Immunologie: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Immunologie: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biochimie: Fully",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpert",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyze",
  "banner.menu.results.SysmeXT": "Hematologie: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNL",
  "banner.menu.results.SysmexXNLanalyzer": "Automate Sysmex XNL",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXP",
  "banner.menu.results.SysmexXPanalyzer": "Analyseur Sysmex XP",
  "banner.menu.results.accession": "Recherche par ordonnance",
  "banner.menu.results.analyzer": "Analyseur",
  "banner.menu.results.cobasc111analyzer": "Biochimie: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "Par Unité",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Planification des demandes",
  "banner.menu.results.patient": "Par Patient",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "Par Test, Date ou Statut",
  "banner.menu.results.sysmexanalyzer": "Hématologie: Sysmex XT 2000i",
  "banner.menu.results.sysmexxtanalyzer": "Hematologie: Sysmex XT 4000i",
  "banner.menu.results.taqman48dbsanalyzer": "Virologie: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "Par Date de Test",
  "banner.menu.results.unified": "Saisie des résultat",
  "banner.menu.results.unified.tooltip": "Liste de travail unifiée pour la saisie des résultats",
  "banner.menu.results.weber": "La Weber 4000",
  "banner.menu.resultvalidation": "Validation",
  "banner.menu.resultvalidation.bacteria": "Bactérie",
  "banner.menu.resultvalidation.bench": "Par palier",
  "banner.menu.resultvalidation.biochemistry": "Biochimie",
  "banner.menu.resultvalidation.cytobacteriology": "Cytobacteriologie",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endocrinologie",
  "banner.menu.resultvalidation.genotyping": "Génotypage",
  "banner.menu.resultvalidation.hemato-immunology": "Hémato-Immunologie",
  "banner.menu.resultvalidation.hematology": "Hématologie",
  "banner.menu.resultvalidation.immunology": "Immunologie",
  "banner.menu.resultvalidation.immunology.Haiti": "Immuno-Virologie",
  "banner.menu.resultvalidation.immunologyHematology": "Immunologie - Hématologie",
  "banner.menu.resultvalidation.liquidBio": "Liquide biologique",
  "banner.menu.resultvalidation.malaria": "Paludisme",
  "banner.menu.resultvalidation.molecularBio": "Biologie Moleculaire",
  "banner.menu.resultvalidation.mycobacteriology": "Mycobactériologie",
  "banner.menu.resultvalidation.mycology": "Mycologie",
  "banner.menu.resultvalidation.parasitology": "Parasitologie",
  "banner.menu.resultvalidation.serology": "Sérologie",
  "banner.menu.resultvalidation.serology-immunology": "Sérologie-Immunologie",
  "banner.menu.resultvalidation.viralload": "Charge Virale",
  "banner.menu.resultvalidation.virology": "Virologie",
  "banner.menu.resultvalidation_routine": "Routine",
  "banner.menu.resultvalidation_study": "Etude",
  "banner.menu.sample": "Demande d'examen",
  "banner.menu.sample.shipment": "Expédition d'échantillons",
  "banner.menu.sampleAdd": "Ajouter une ordonnance",
  "banner.menu.sampleBatchEntry": "Saisie d'ordonnances en lot",
  "banner.menu.sampleConsult": "Voir",
  "banner.menu.sampleCreate": "Etude",
  "banner.menu.sampleEdit": "Modifier l'échantillon",
  "banner.menu.sampleManagement": "Gestion des échantillons",
  "banner.menu.sampleManagement.tooltip": "Menu de gestion des échantillons",
  "banner.menu.storage": "Stockage",
  "banner.menu.storage.tooltip": "Gestion du stockage des échantillons",
  "banner.menu.study.eorders": "Statistiques journalières. ",
  "banner.menu.workplan": "Plan de Travail",
  "banner.menu.workplan.batch": "Plan de travail par lot",
  "banner.menu.workplan.batch.tooltip": "Plan de travail par lot",
  "banner.menu.workplan.bench": "Par Unité",
  "banner.menu.workplan.panel": "Par Panel",
  "banner.menu.workplan.priority": "Par priorité",
  "banner.menu.workplan.test": "Par test",
  "banner.menu.workplan.unit": "Par Unité",
  "barcode.additionalInvalidLevels.message": "Le code-barre contient des niveaux au-delà de la partie valide. Seuls les niveaux valides sont préremplis.",
  "barcode.additionalInvalidLevels.warning": "Niveaux non valides supplémentaires détectés",
  "barcode.autoOpenForm": "Formulaire d'ouverture de l'emplacement avec hiérarchie valide",
  "barcode.debounce.warning": "Veuillez patienter avant de scanner un autre code-barre",
  "barcode.error": "Code-barres invalide",
  "barcode.firstMissingLevel": "Premier niveau manquant : {level}",
  "barcode.format": "Format du code-barres",
  "barcode.header": "En-tête du code-barres",
  "barcode.invalidFormat": "Format de code-barres invalide. Format attendu : CHAMBRE-APPAREIL ou CHAMBRE-APPAREIL-ÉTAGÈRE-RACK-POSITION",
  "barcode.label.block": "Étiquette de bloc",
  "barcode.label.freezer": "Étiquette de congélateur ",
  "barcode.label.helper.text": "Saisissez les valeurs en : mm",
  "barcode.label.order": "Étiquette de demande d’examen ",
  "barcode.label.slide": "Étiquette de lame",
  "barcode.label.specimen": "Étiquette d’échantillon",
  "barcode.label.info.blockCaseNumber": "Numéro de bloc de dossier",
  "barcode.label.info.blockId": "ID du bloc",
  "barcode.label.info.blockNumber": "Numéro de bloc",
  "barcode.label.info.boxid": "ID de la boîte",
  "barcode.label.info.caseNumber": "Numéro de dossier",
  "barcode.label.info.collectedBy": "Collecté Par",
  "barcode.label.info.collectionDate": "Date de prélèvement",
  "barcode.label.info.collectionDateTime": "Date et Heure de Prélèvement",
  "barcode.label.info.created": "Créé",
  "barcode.label.info.destination": "Destination",
  "barcode.label.info.expiryDate": "Date d'Expiration",
  "barcode.label.info.labNumber": "Numéro d'Accession",
  "barcode.label.info.patientDobFull": "Date de Naissance du Patient",
  "barcode.label.info.patientId": "Identifiant du Patient",
  "barcode.label.info.patientName": "Nom du patient",
  "barcode.label.info.patientSexFull": "Sexe du Patient",
  "barcode.label.info.samplecount": "Échantillons",
  "barcode.label.info.siteId": "ID du Site",
  "barcode.label.info.slideId": "ID de la lame",
  "barcode.label.info.slideNumber": "Numéro de lame",
  "barcode.label.info.specimenType": "Type d'échantillon",
  "barcode.label.info.stainType": "Type de coloration",
  "barcode.label.info.storageLocation": "Emplacement de stockage",
  "barcode.label.info.temperature": "Température",
  "barcode.label.info.tests": "Analyses",
  "barcode.labels.order.row": "Étiquettes de commande",
  "barcode.labels.running.total": "Total cumulé",
  "barcode.labels.sample.row": "Étiquettes d'échantillon {sampleNumber}",
  "barcode.labels.section.title": "Quantités d'étiquettes",
  "barcode.locationNotFound": "Emplacement introuvable",
  "barcode.notification.save": "Les configurations de code-barres ont été enregistrées.",
  "barcode.partialMatch": "Correspondance partielle - certains composants sont valides",
  "barcode.print.button": "Imprimer",
  "barcode.print.labels.title": "Étiquettes de cette demande",
  "barcode.print.all.button": "Tout imprimer",
  "barcode.print.all.saved": "Imprime chaque étiquette enregistrée avec cette demande, selon la quantité enregistrée.",
  "barcode.print.all.legacy": "Imprime {orderCount, plural, one {# étiquette de demande} other {# étiquettes de demande}} et {specimenCount, plural, one {# étiquette} other {# étiquettes}} par échantillon.",
  "barcode.print.col.label": "Etiquette",
  "barcode.print.col.accession": "Numéro d'enregistrement",
  "barcode.print.col.info": "Informations supplémentaires",
  "barcode.print.col.quantity": "Nombre à imprimer",
  "barcode.print.quantity.for": "Nombre d'étiquettes à imprimer pour {label}",
  "barcode.print.size": "{height} × {width} mm",
  "barcode.print.max.hint": "Jusqu'à {max}",
  "barcode.print.max.total": "Jusqu'à {max} au total, impressions précédentes comprises",
  "barcode.print.row.button": "Imprimer {label}",
  "error.labels.quantity.max": "Une quantité supérieure au maximum du préréglage nécessite le forçage d'étiquette.",
  "error.labels.quantity.min": "Imprimez au moins une étiquette.",
  "barcode.print.dialog.quantityFor": "Quantité à imprimer pour {label}",
  "barcode.print.dialog.title": "Imprimer les étiquettes",
  "barcode.print.done": "Terminer",
  "barcode.print.later": "Ignorer — Imprimer plus tard",
  "barcode.print.preprint": "Impression anticipée du code-barres",
  "barcode.print.preprint.button": "Bouton de pré-impression",
  "barcode.print.preprint.note": "Note de pré-impression",
  "barcode.print.skip": "Ignorer",
  "barcode.print.title": "Titre de l'impression du code-barres",
  "barcode.ready": "Prêt à scanner",
  "barcode.scan": "Scanner le code-barres",
  "barcode.scan.error": "Demande d'examens non trouvée",
  "barcode.scan.placeholder": "Scanner le code-barre ou saisir le numéro labo ...",
  "barcode.scan.success": "Demande d'examens chargée avec succès",
  "barcode.scanning": "Scan en cours…",
  "barcode.scanOrType": "Scannez le code-barres ou saisissez l'emplacement",
  "barcode.success": "Emplacement trouvé",
  "barcode.validHierarchyPrefilled": "Niveaux hiérarchiques valides préremplis",
  "barcode.validation.altPrefix": "La saisie doit être alphanumérique et comporter au maximum 4 caractères.",
  "barcode.validationFailed": "La validation du code-barres a échoué",
  "barcodeconfiguration.browse.title": "Page des codes-barres",
  "breadcrumb.home": "Accueil",
  "breadcrumb.caseView": "Vue du dossier",
  "breadcrums.admin.managment": "Gestion de l'administration",
  "calendar.management.title": "Gestion du calendrier",
  "calendar.management.description": "Gérer les jours fériés et la configuration des week-ends pour le calcul des délais de traitement",
  "calendar.management.addHoliday": "Ajouter jour férié",
  "calendar.management.editHoliday": "Modifier jour férié",
  "calendar.management.deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce jour férié ?",
  "calendar.management.holidayName": "Nom du jour férié",
  "calendar.management.date": "Date",
  "calendar.management.recurring": "Récurrent",
  "calendar.management.annual": "Annuel",
  "calendar.management.oneTime": "Ponctuel",
  "calendar.management.active": "Active",
  "calendar.management.inactive": "Inactif",
  "calendar.management.weekend": "Week-end",
  "calendar.management.weekendDays": "Jours de week-end (exclus du temps de travail)",
  "calendar.management.weekendSaved": "Configuration du week-end enregistrée",
  "calendar.management.importCsv": "Importer un fichier CSV",
  "calendar.management.exportCsv": "Exporter en CSV",
  "calendar.management.importPreview": "Aperçu de l’importation",
  "calendar.management.year": "Année",
  "calendar.management.noHolidays": "Aucun jour férié configuré pour {year}. Cliquez sur “Ajouter un jour férié” pour commencer.",
  "calendar.management.duplicateDate": "Un jour férié existe déjà pour cette date",
  "calendar.management.imported": "{count} jours fériés importés",
  "calendar.management.skipped": "{count} jours fériés ignorés",
  "calendar.management.holidayCount": "{count} jours fériés configurés pour {year}",
  "calendar.management.saveError": "Erreur lors de l’enregistrement du jour férié",
  "calendar.management.loadError": "Erreur lors du chargement des jours fériés",
  "calendar.management.save": "Sauvegarder",
  "calendar.management.cancel": "Annuler",
  "calendar.management.actions": "Actions",
  "calendar.management.status": "Statut",
  "calendar.management.column.date": "Date",
  "calendar.management.column.holidayName": "Nom du jour férié",
  "calendar.management.column.recurring": "Récurrent",
  "calendar.management.column.status": "Statut",
  "calendar.management.column.actions": "Actions",
  "calendar.management.day.sun": "Dim",
  "calendar.management.day.mon": "Lun",
  "calendar.management.day.tue": "Mar",
  "calendar.management.day.wed": "Mer",
  "calendar.management.day.thu": "Jeu",
  "calendar.management.day.fri": "Ven",
  "calendar.management.day.sat": "Sam",
  "calendar.management.chooseFile": "Choisir un fichier CSV",
  "calendar.management.csvColumns": "Colonnes : date, nom, récurrent (Vrai/Faux)",
  "calendar.management.rowsFound": "{count} lignes trouvées",
  "calendar.management.column.csvDate": "Date",
  "calendar.management.column.csvName": "Nom",
  "calendar.management.column.csvRecurring": "Récurrent",
  "calendar.management.importing": "Importation en cours ...",
  "caseView.action.discard": "Abandonner les modifications",
  "caseView.action.saveDraft": "Enregistrer le brouillon",
  "caseView.action.showDeactivated": "Affichage désactivé",
  "caseView.banner.unsavedChanges": "Ce dossier contient des modifications non enregistrées. Quitter la page et les perdre ?",
  "caseView.badge.deactivated": "Désactivé",
  "caseView.badge.notApplicable": "N/A",
  "caseView.badge.readOnly": "Lecture seule",
  "caseView.label.assignedStaff": "{role} : {name}",
  "caseView.label.caseProgress": "Suivi des dossiers",
  "caseView.label.caseSummary": "Résumé du dossier",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "– non renseigné",
  "caseView.label.unsavedChanges": "Modifications non enregistrées",
  "caseView.locked.awaitingStage": "Disponible lorsque le dossier atteint l'étape « {stage} »",
  "caseView.locked.prerequisite": "Disponible une fois les étapes précédentes de ce dossier terminées",
  "column.qc.accession": "Échantillon de CQ",
  "column.qc.detail": "Détails",
  "column.qc.result": "Résultat ",
  "column.qc.test": "Test",
  "column.qc.type": "Type",
  "compliance.dashboard.chart.comparison.title": "Comparaison des sites — Taux de conformité pour la période en cours",
  "compliance.dashboard.chart.drilldown.title": "Analyse détaillée du site — Évolution par paramètre",
  "compliance.dashboard.chart.trend.title": "Évolution du taux de conformité — Tous les sites",
  "compliance.dashboard.descriptive.excluded": "Les paramètres descriptifs sont exclus du graphique d’évolution",
  "compliance.dashboard.drilldown.placeholder": "Sélectionner un site…",
  "compliance.dashboard.empty": "Aucune donnée ne correspond aux filtres sélectionnés",
  "compliance.dashboard.export.pdf": "Exporter en PDF",
  "compliance.dashboard.filter.allStandards": "Toutes les normes",
  "compliance.dashboard.filter.dateRange": "Plage de dates",
  "compliance.dashboard.filter.dateRangeEnd": "Date de fin",
  "compliance.dashboard.filter.drilldownSite": "Analyse détaillée par site",
  "compliance.dashboard.filter.sites": "Sites de prélèvement",
  "compliance.dashboard.filter.sites.placeholder": "Tous les sites",
  "compliance.dashboard.filter.standard": "Norme de conformité",
  "compliance.dashboard.kpi.complianceRate": "Taux de conformité",
  "compliance.dashboard.kpi.exceedances": "Nombre total de dépassements",
  "compliance.dashboard.kpi.sitesMonitored": "Sites surveillés",
  "compliance.dashboard.kpi.totalOrders": "Nombre total de commandes",
  "compliance.dashboard.loading.comparison": "Chargement de la comparaison…",
  "compliance.dashboard.loading.drilldown": "Chargement de l’analyse détaillée…",
  "compliance.dashboard.loading.exceedances": "Chargement des dépassements…",
  "compliance.dashboard.loading.generating": "Génération en cours…",
  "compliance.dashboard.loading.trend": "Chargement de l’évolution…",
  "compliance.dashboard.lowData": "Données insuffisantes (< 3 commandes)",
  "compliance.dashboard.status.fail": "ECHEC",
  "compliance.dashboard.table.col.date": "Date",
  "compliance.dashboard.table.col.labNumber": "N° de laboratoire",
  "compliance.dashboard.table.col.parameter": "Paramètre",
  "compliance.dashboard.table.col.result": "Résultat ",
  "compliance.dashboard.table.col.site": "Site",
  "compliance.dashboard.table.col.status": "Statut",
  "compliance.dashboard.table.col.threshold": "Seuil",
  "compliance.dashboard.table.exceedances.title": "Résumé des dépassements",
  "compliance.dashboard.title": "Tableau de bord de conformité environnementale",
  "error.referOut.emailFormat": "Saisissez une adresse e-mail valide (par exemple : lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "La date et l’heure de transmission sont requises pour procéder à l’envoi.",
  "error.referOut.maxLength": "Maximum de {max} caractères.",
  "error.referOut.phoneFormat": "Saisissez un numéro de téléphone valide avec l’indicatif du pays (par exemple : +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Sélectionnez un laboratoire prescripteur.",
  "error.validation.qc.ackFailed": "Échec de l’enregistrement de l’accusé de réception du CQ. Veuillez réessayer.",
  "holding.time.exceeded.message": "Le délai maximal de conservation prévu par la SOP a été dépassé pour : {tests}",
  "holding.time.exceeded.note": "AVERTISSEMENT : Le résultat a été saisi après dépassement du délai maximal de conservation prévu par la SOP.",
  "holding.time.exceeded.title": "Délai de conservation dépassé",
  "label.button.edit.details": "Modifier les détails",
  "label.expand.poolDetails": "Développer les détails du pool",
  "label.pool.collapse": "Masquer les échantillons individuels",
  "label.pool.expand": "Afficher les échantillons individuels",
  "label.pool.expansion.next": "Suivante",
  "label.pool.expansion.page": "Page {page} sur {total}",
  "label.pool.expansion.prev": "Précédent",
  "label.pool.expansion.title": "{animal} Échantillons ({count})",
  "label.qc.fail": "ECHEC",
  "label.qc.pass": "Passer",
  "label.referOut.action.dispatch": "Communiqué",
  "label.referOut.action.edit": "Modifier",
  "label.referOut.action.referOut": "Référé à un laboratoire externe",
  "label.referOut.action.save": "Enregistrer la recommandation",
  "label.referOut.action.view": "Voir",
  "label.referOut.column.actions": "Actions",
  "label.referOut.column.referringLab": "Laboratoire de référence",
  "label.referOut.column.sampleId": "ID d'échantillon",
  "label.referOut.column.sampleType": "Type d'échantillon",
  "label.referOut.column.status": "Statut de la sous-traitance",
  "label.referOut.column.tests": "Analyses",
  "label.referOut.dispatch.error": "Echec pour envoyer la demande de consultation.",
  "label.referOut.dispatch.notSaved": "Enregistrez la demande de consultation avant de l'envoyer.",
  "label.referOut.dispatch.success": "La demande a été transmise.",
  "label.referOut.empty.subtitle": "Les échantillons apparaissent ici une fois qu'ils ont été enregistrés. Veuillez d'abord enregistrer la commande pour pouvoir envoyer les échantillons.",
  "label.referOut.empty.title": "Aucun échantillon n'est disponible pour une demande d'analyse",
  "label.referOut.field.agreementReference": "Référence du contrat",
  "label.referOut.field.cocContactEmail": "Email du contact pour la chaîne de traçabilité",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Nom de la personne à contacter pour la chaîne de traçabilité",
  "label.referOut.field.cocContactPhone": "Numéro de téléphone du responsable de la chaîne de traçabilité",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Date de retour prévue",
  "label.referOut.field.handoffDate": "Date de passation",
  "label.referOut.field.handoffDatetime": "Date/Heure de la passation de pouvoir",
  "label.referOut.field.handoffTime": "Heure de la passation de service",
  "label.referOut.field.handoffTime.placeholder": "HH:mm",
  "label.referOut.field.notes": "Notes",
  "label.referOut.field.referringLab": "Laboratoire de référence",
  "label.referOut.field.referringLab.placeholder": "Veuillez sélectionner un laboratoire de référence",
  "label.referOut.save.error": "Échec de l'enregistrement de la recommandation.",
  "label.referOut.save.success": "La recommandation a été enregistrée.",
  "label.referOut.section.description": "Transmettez les échantillons à un laboratoire externe. Chaque échantillon est accompagné de l'intégralité des métadonnées relatives à la chaîne de traçabilité.",
  "label.referOut.section.title": "Référé à un laboratoire externe",
  "label.referOut.status.cancelled": "Annulé",
  "label.referOut.status.closed": "Fermé",
  "label.referOut.status.completed": "Terminé",
  "label.referOut.status.dispatched": "Expédié",
  "label.referOut.status.draft": "Brouillon",
  "label.referOut.status.inProgress": "En cours",
  "label.referOut.status.notReferred": "En interne",
  "label.referOut.status.received": "Reçu",
  "label.referOut.status.rejected": "Rejeté",
  "label.referOut.status.requested": "Demandé",
  "label.referOut.status.resultsReturned": "Résultats affichés",
  "label.referOut.field.reason": "Motif",
  "label.referOut.field.reason.placeholder": "Sélectionner un motif (facultatif)",
  "label.referOut.action.referOutAll": "Envoyer tous les échantillons internes à un laboratoire de référence",
  "label.referOut.status.pendingSave": "En attente d'enregistrement",
  "label.referOut.staged.success": "Préparé pour {count} échantillon(s). L'envoi est enregistré avec le bouton Enregistrer de cette étape.",
  "order.status.referredOut": "Référé à un laboratoire externe",
  "order.referral.partial": "{referred} analyses sur {total} envoyées à {lab}",
  "order.referral.fully": "Les {total} analyses envoyées à {lab}",
  "label.sampleKind.blank": "BLANK",
  "label.sampleKind.client": "Échantillon de client",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICATE",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "J'ai examiné les échecs du contrôle qualité et évalué leur impact sur la publication des résultats",
  "label.validation.qc.ack.heading": "Mention obligatoire",
  "label.validation.qc.banner.subtitle": "Veuillez vérifier et valider ci-dessous avant de publier les résultats.",
  "label.validation.qc.banner.title": "Échec du contrôle qualité détecté — {count} : un ou plusieurs échantillons de CQ ne répondent pas aux critères d'acceptation",
  "label.validation.qc.failedSamples": "Échantillons non conformes au CQ",
  "label.validation.qc.justification": "Justification",
  "label.validation.checkBeforeRelease": "Vérifier avant la mise en service",
  "label.validation.triage.filterLabel": "Filtrer par signal",
  "label.validation.filter.all": "Tous",
  "label.validation.filter.needsReview": "À vérifier",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "Échec du contrôle QC",
  "label.validation.filter.modified": "Modifié",
  "label.validation.filter.ackPending": "Accusé de réception en attente",
  "label.validation.search.box": "Numéro laboratoire",
  "label.validation.search.rangeHint": "Une plage : A..B, ou A.. à partir de A",
  "label.validation.search.fromDate": "From",
  "label.validation.search.toDate": "À",
  "label.validation.search.loadError": "La file de validation n'a pas pu être chargée.",
  "label.validation.filter.critical": "Critique",
  "label.validation.filter.abnormal": "Anormal",
  "label.validation.lane.clear": "Clear",
  "label.validation.lane.needsReview": "À vérifier",
  "label.validation.signal.nce": "Ouverture du NCE",
  "label.validation.signal.qcFail": "Échec du contrôle QC",
  "label.validation.signal.modified": "Modifié",
  "label.validation.signal.ackPending": "Accusé de réception en attente",
  "label.validation.signal.nonconforming": "Non conforme",
  "label.validation.signal.critical": "Critique",
  "label.validation.review.result": "Résultat ",
  "label.validation.review.units": "Unités",
  "label.validation.review.normalRange": "Plage de référence",
  "label.validation.review.criticalRange": "Plage critique",
  "label.validation.review.method": "Méthodes",
  "label.validation.review.analyzer": "Analyseur",
  "label.validation.review.performedAt": "Réalisé à",
  "label.validation.review.enteredBy": "Saisi par",
  "label.validation.review.enteredDate": "Enregistré le",
  "label.validation.review.collected": "Prélevé",
  "label.validation.review.qc": "QC",
  "label.validation.review.qc.PASS": "QC validé",
  "label.validation.review.qc.FAIL": "Échec du contrôle QC",
  "label.validation.review.notRecorded": "Non enregistré",
  "label.validation.review.beforeRelease": "Avant la mise en service, veuillez vérifier :",
  "label.validation.review.components": "Composants",
  "label.validation.review.component": "Composant",
  "label.validation.review.flag": "Drapeau",
  "label.validation.review.primary": "Primaire",
  "label.validation.review.reference": "Référence",
  "label.validation.review.notes": "Notes",
  "label.validation.review.notes.summary": "{count} Remarques",
  "label.validation.review.notes.empty": "Non de remarques pour l'instant",
  "label.validation.review.notes.add": "Note de validation",
  "label.validation.review.notes.placeholder": "Ajoutez une remarque de validation…",
  "label.validation.review.notes.visibility": "Visibilité",
  "label.validation.review.notes.internal": "Interne",
  "label.validation.review.notes.external": "Envoyer avec le résultat",
  "label.validation.review.notes.externalWarning": "Cette remarque figurera dans le rapport du patient.",
  "label.validation.review.notes.contextHint": "Contexte : Validation (enregistrée automatiquement).",
  "label.validation.review.notes.context.result": "Remarque relative aux résultats",
  "label.validation.review.modify.reason": "Motif de la modification",
  "label.validation.review.modify.reasonRequired": "Il faut indiquer un motif pour modifier un résultat.",
  "label.validation.review.modify.newValue": "Nouveau résultat",
  "label.validation.review.modify.notEditable": "Ce type de résultat est modifié sur la page « Saisie des résultats ».",
  "label.validation.review.qcSection": "QC",
  "label.validation.review.reagents.followUp": "Les lots de réactifs et de contrôle utilisés pour cette analyse sont présentés sur la page « Saisie des résultats ».",
  "label.validation.review.action.release": "Valider et publier",
  "label.validation.review.action.modify": "Modifier le résultat",
  "label.validation.review.action.saveModification": "Enregistrer les modifications",
  "label.validation.review.action.cancel": "Annuler",
  "label.validation.review.action.refer": "Consultez cette analyse",
  "label.validation.review.release.qcAckFirst": "Veuillez accuser réception du contrôle qualité echecciateur ci-dessous avant la mise en ligne.",
  "label.validation.review.error.notAwaitingValidation": "Ce résultat a changé depuis le chargement de la page. Veuillez recharger la page et le vérifier à nouveau.",
  "label.validation.review.error.qcAcknowledgmentRequired": "Les échecs de QC constatés dans ce lot doivent être accusés de réception avant la mise en circulation.",
  "label.validation.review.error.modificationReasonRequired": "Il faut indiquer un motif pour modifier un résultat.",
  "label.validation.review.error.modifyRoleRequired": "Votre rôle ne vous autorise pas à modifier les résultats.",
  "label.validation.review.error.resultRequired": "Veuillez saisir une valeur du résultat avant d'enregistrer.",
  "label.validation.review.error.invalidResult": "Le résultat est incomplet ; veuillez vérifier la valeur qualifiée.",
  "label.validation.review.error.generic": "L'opération n'a pas pu être terminée.",
  "label.validation.review.success.released": "Résultat validé et publié.",
  "label.validation.review.success.modified": "Le résultat a été modifié. Il reste dans la file d'attente de validation.",
  "esig.context.validateSingle": "Valider et publier l'{test} relatives à l'accession {accession}",
  "label.validation.bulk.releaseAllClear": "Fin d'alerte ({count})",
  "label.validation.bulk.heading": "Publier tous les résultats « tout va bien »",
  "label.validation.bulk.bodyClear": "{count, plural, one {Ce # résultat est dans le couloir Sans anomalie : dans l'intervalle, sans échec de CQ enregistré, sans non-conformité, non modifié, non critique. Un résultat qui cesse d'être sans anomalie avant la publication est ignoré.} many {Ces # résultats sont dans le couloir Sans anomalie : dans l'intervalle, sans échec de CQ enregistré, sans non-conformité, non modifié, non critique. Un résultat qui cesse d'être sans anomalie avant la publication est ignoré.} other {Ces # résultats sont dans le couloir Sans anomalie : dans l'intervalle, sans échec de CQ enregistré, sans non-conformité, non modifié, non critique. Un résultat qui cesse d'être sans anomalie avant la publication est ignoré.}} in the Clear lane: in range, no recorded QC failure, no non-conformity, not modified, not critical. A result that stops being clear before the release is skipped.",
  "label.validation.bulk.bodyEsig": "La publication engage une seule signature électronique pour tout l'ensemble.",
  "label.validation.bulk.disabled": "La publication groupée est désactivée pour ce laboratoire.",
  "label.validation.emptyState.signals": "{count} résultats de cette file présentent un point à vérifier avant la publication.",
  "label.validation.emptyState.signalsDetail": "Les plus fréquents : {signals}.",
  "label.validation.emptyState.noReference": "{count} résultats concernent des analyses sans valeur de référence enregistrée dans le catalogue de tests ; ils ne peuvent donc pas être jugés normaux.",
  "label.validation.emptyState.noReferenceHint": "Enregistrez une valeur normale attendue pour ces analyses dans le Catalogue de tests afin que leurs résultats puissent passer en Sans anomalie.",
  "label.validation.emptyState.rangeNotApplied": "{count} résultats n'ont pas eu d'intervalle de référence appliqué car le sexe ou l'âge du patient n'est pas enregistré. Vérifiez-les un par un, ou enregistrez la valeur manquante sur le patient.",
  "label.validation.emptyState.queueEmpty": "Aucun élément en attente de validation.",
  "label.validation.release.scope": "Le contrôle Sans anomalie vérifie l'intervalle de référence, les indicateurs de résultat, les non-conformités, les modifications après enregistrement et l'accusé de réception des valeurs critiques, et bloque tout résultat avec un échec de contrôle qualité enregistré. Il ne confirme pas que le contrôle qualité a été effectué.",
  "label.validation.bulk.none": "Il n'y a pas de résultats clairs à communiquer.",
  "label.validation.bulk.column.accession": "laboratoire non.",
  "label.validation.bulk.success": "{count} publication des résultats définitifs.",
  "label.validation.bulk.partial": "{released} publiées ; les fichiers « {skipped} » ont été ignorés car leur contenu n'était plus clair.",
  "label.validation.bulk.error.bulkReleaseDisabled": "La publication groupée est désactivée pour ce laboratoire.",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "Les échecs de QC constatés dans ce lot doivent être accusés de réception avant la mise en circulation.",
  "label.validation.bulk.error.nothingReleased": "Aucun des résultats sélectionnés n'est encore clair ; aucune information n'a été communiquée.",
  "label.validation.bulk.error.generic": "La publication groupée n'a pas pu être terminée.",
  "label.validation.review.action.review": "Avis →",
  "esig.context.releaseAllClear": "Communiqué de presse {count} : résultats clairs pour {accession}",
  "instructions.validation.bulk.release": "Lorsqu'elle est activée, la page « Validation » propose l'option « Valider tout », qui permet de valider en une seule signature électronique tous les résultats figurant dans la colonne « Clear » (dans les limites, contrôle qualité réussi, absence de signaux). Désactivez cette option pour que chaque résultat doive être validé individuellement après vérification.",
  "instructions.validation.retest.note": "Lorsqu'elle est activée, un validateur qui envoie un résultat en vue d'un nouveau test doit rédiger une remarque à l'attention du banc d'essai.",
  "label.validation.review.action.retest": "Envoyer pour retester",
  "label.validation.review.action.reject": "Rejeter (fichier NCE)",
  "label.validation.review.retest.note": "Remarque à l'intention du tribunal",
  "label.validation.review.retest.noteRequired": "Une remarque est nécessaire pour envoyer un résultat en vue de retester.",
  "label.validation.review.retest.hint": "Le résultat est renvoyé vers la phase « Saisie des résultats » et le pipeline redémarre au niveau 1.",
  "label.validation.review.reject.hint": "Le rejet de fichiers constitue un cas de non-conformité ; veuillez remplir le formulaire pour l'enregistrer.",
  "label.validation.review.reject.disabled": "Le rejet de résultat est désactivé pour ce laboratoire.",
  "label.validation.review.error.stale": "Ce résultat a été modifié par {who} à l'adresse {when}. Rechargement de la file d'attente…",
  "label.validation.review.error.retestNoteRequired": "Une remarque est nécessaire pour envoyer un résultat en vue de retester.",
  "label.validation.review.error.rejectionDisabled": "Le rejet de résultat est désactivé pour ce laboratoire.",
  "label.validation.review.success.retest": "Le résultat a été envoyé pour un nouveau test.",
  "label.validation.review.success.rejected": "Résultat rejeté ; l'événement de non-conformité est consigné.",
  "label.validation.bulk.error.stale": "La file d'attente a changé pendant que vous la consultiez. Rechargement en cours…",
  "label.validation.autoValidated.toggle": "Inclure la validation automatique",
  "label.validation.autoValidated.heading": "Résultats validés automatiquement ({count})",
  "label.validation.autoValidated.tag": "Validé automatiquement",
  "label.validation.autoValidated.empty": "Aucun résultat validé automatiquement pour ce numéro de laboratoire.",
  "label.validation.autoValidated.hint": "Publié lors de la saisie des résultats sans validation ; affiché à titre indicatif uniquement.",
  "label.validation.autoValidated.releasedOn": "Publié le",
  "label.validation.signal.rangeNotApplied": "Intervalle non appliqué",
  "result.rangeNotApplied.sexMissing": "Intervalle de référence non appliqué : sexe du patient non enregistré",
  "result.rangeNotApplied.ageMissing": "Intervalle de référence non appliqué : âge du patient non enregistré",
  "result.rangeNotApplied.sexAndAgeMissing": "Intervalle de référence non appliqué : sexe et âge du patient non enregistrés",
  "laporanHasil.action.generatePdf": "Générer un fichier PDF",
  "laporanHasil.action.regeneratePdf": "Recréer le fichier PDF",
  "laporanHasil.col.actions": "Actions",
  "laporanHasil.col.collectionDate": "Date de prélèvement",
  "laporanHasil.col.compliance": "Conformité",
  "laporanHasil.col.labNumber": "Numéro laboratoire",
  "laporanHasil.col.lastGenerated": "Dernière génération",
  "laporanHasil.col.site": "Site",
  "laporanHasil.col.standard": "Standard",
  "laporanHasil.col.tests": "Analyses",
  "laporanHasil.detail.ambientTemp": "Température ambiante",
  "laporanHasil.detail.collectionDateTime": "Date et Heure de Prélèvement",
  "laporanHasil.detail.collectionMethod": "Méthode de prélèvement ",
  "laporanHasil.detail.complianceSummary": "Résumé de la conformité",
  "laporanHasil.detail.conditions": "Conditions de prélèvement",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Analyste de laboratoire",
  "laporanHasil.detail.labManager": "Responsable de laboratoire",
  "laporanHasil.detail.parameter": "Paramètre",
  "laporanHasil.detail.ppNo": "N° PP",
  "laporanHasil.detail.preservation": "Préservation",
  "laporanHasil.detail.result": "Résultat ",
  "laporanHasil.detail.signatures": "Signatures",
  "laporanHasil.detail.site": "Site",
  "laporanHasil.detail.siteInfo": "Page du site",
  "laporanHasil.detail.standard": "Standard",
  "laporanHasil.detail.status": "Statut",
  "laporanHasil.detail.threshold": "Seuil",
  "laporanHasil.detail.waterTemp": "Température de l'eau",
  "laporanHasil.detail.weather": "Météo",
  "laporanHasil.empty": "Aucune demande d'examen n'a été trouvée correspondant aux filtres sélectionnés.",
  "laporanHasil.error": "Echec du chargement du rapport. Veuillez réessayer.",
  "laporanHasil.filter.all": "Tous",
  "laporanHasil.filter.allSites": "Tous les sites",
  "laporanHasil.filter.allStandards": "Toutes les normes",
  "laporanHasil.filter.complianceStatus": "État de conformité",
  "laporanHasil.filter.dateFrom": "Date de début",
  "laporanHasil.filter.dateTo": "Date de fin",
  "laporanHasil.filter.generated": "Généré",
  "laporanHasil.filter.generationStatus": "État de la production",
  "laporanHasil.filter.notGenerated": "Pas encore généré",
  "laporanHasil.filter.samplingSite": "Sites de prélèvement",
  "laporanHasil.filter.standard": "Norme de conformité",
  "laporanHasil.loading": "Chargement du rapport de conformité...",
  "laporanHasil.status.borderline": "Limite",
  "laporanHasil.status.compliant": "Conforme",
  "laporanHasil.status.ineligible": "Non de normes associées",
  "laporanHasil.status.nonCompliant": "Non conforme",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Générer des certificats de conformité pour les commandes environnementales validées",
  "laporanHasil.tile.generated": "Généré",
  "laporanHasil.tile.ineligible": "Non éligible",
  "laporanHasil.tile.ineligible.desc": "Non validé ou aucune norme associée",
  "laporanHasil.tile.notGenerated": "Pas encore généré",
  "laporanHasil.title": "Rapport de conformité",
  "lhu.amendment.error.generic": "L'échec de la réédition du rapport. Veuillez réessayer.",
  "lhu.amendment.modal.description": "Vous procédez à la réémission du rapport LHU correspondant au numéro de laboratoire {labNumber}. Le rapport réémis sera considéré comme un avenant au certificat précédemment délivré.",
  "lhu.amendment.modal.heading": "Réédition de la LHU avec amendement",
  "lhu.amendment.modal.submit": "Réédition et téléchargement au format PDF",
  "lhu.amendment.reason.helper": "Veuillez indiquer la raison pour laquelle le rapport initial fait l'objet d'une modification (obligatoire pour se conformer à la norme ISO 17025, paragraphe 7.8.8).",
  "lhu.amendment.reason.label": "Motif de la modification",
  "lhu.amendment.reason.placeholder": "Par exemple : résultat de pH incorrect — l'appareil n'avait pas été étalonné",
  "lhu.amendment.reason.required": "Le motif de la modification est obligatoire",
  "lhu.amendment.reissue": "Réédition avec modification",
  "lhu.amendment.submitting": "Réédition…",
  "nce.close.error": "Echec pour fermer le NCE",
  "nce.close.success": "Le programme NCE s'est fermé avec succès",
  "nce.correctiveAction.error": "Échec de la mise à jour du statut NCE",
  "nce.correctiveAction.success": "Le NCE a pris des mesures d'action corrective",
  "notificationtrigger.activetriggers.heading": "Déclencheurs actifs",
  "notificationtrigger.activetriggers.subtitle": "Chaque ligne correspond à un type d'événement de notification. Cochez la case « Activé » pour l'activer. Les paramètres relatifs au canal et au destinataire ne s'appliquent que lorsque le déclencheur est activé.",
  "notificationtrigger.channel.email": "E-mail",
  "notificationtrigger.channel.sms": "SMS",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.template.disallowed": "This message type cannot include {fields}. Use the merge fields listed under the template.",
  "notificationtrigger.column.channels": "Chaînes",
  "notificationtrigger.column.enabled": "Activée",
  "notificationtrigger.column.eventcode": "Code Emplacement de l'événement",
  "notificationtrigger.column.override": "Règle de dérogation par unité de laboratoire",
  "notificationtrigger.column.recipients": "Destinataires",
  "notificationtrigger.column.trigger": "Déclencheur",
  "notificationtrigger.config.subtitle": "Activez ou désactivez les déclencheurs de notification, sélectionnez les canaux de diffusion et configurez les types de destinataires pour chaque événement.",
  "notificationtrigger.config.title": "Configuration des déclencheurs de notification",
  "notificationtrigger.disabled.hint": "Activez ce déclencheur pour configurer ses canaux et ses destinataires.",
  "notificationtrigger.override.comingsoon": "La possibilité de définir une valeur par unité de laboratoire n'est pas encore disponible.",
  "notificationtrigger.override.configure": "Configurer",
  "notificationtrigger.recipient.coccontact": "Contact CoC",
  "notificationtrigger.recipient.orderingprovider": "Prestataire chargé de la commande",
  "notificationtrigger.recipient.submittinguser": "Utilisateur qui soumet",
  "notificationtrigger.referralout.defaultoff": "Par défaut : désactivé — doit être activé explicitement.",
  "notificationtrigger.referralout.description": "Envoyé lorsqu'un échantillon est transmis à un laboratoire externe.",
  "notificationtrigger.referralout.firesoncenote": "Une notification est envoyée pour chaque demande de consultation enregistrée. Si une commande comporte des références pour deux laboratoires différents, deux notifications sont envoyées.",
  "notificationtrigger.referralout.name": "Transfert vers l'extérieur",
  "notificationtrigger.sentmessages.action.resend": "Renvoyer",
  "notificationtrigger.sentmessages.action.viewlog": "Voir le journal",
  "notificationtrigger.sentmessages.channel.failed": "Echec",
  "notificationtrigger.sentmessages.channel.sent": "Envoyé",
  "notificationtrigger.sentmessages.column.actions": "Actions",
  "notificationtrigger.sentmessages.column.channels": "Chaînes",
  "notificationtrigger.sentmessages.column.datetime": "Date/Heure",
  "notificationtrigger.sentmessages.column.recipient": "Destinataire",
  "notificationtrigger.sentmessages.column.reference": "Référence",
  "notificationtrigger.sentmessages.column.status": "Statut",
  "notificationtrigger.sentmessages.column.type": "Type",
  "notificationtrigger.sentmessages.count": "{count} de messages d'{total}",
  "notificationtrigger.sentmessages.empty.heading": "Non, aucune notification n'a encore été envoyée.",
  "notificationtrigger.sentmessages.filter.status.all": "Tous les statuts",
  "notificationtrigger.sentmessages.filter.status.failed": "Failed",
  "notificationtrigger.sentmessages.filter.status.label": "Statut",
  "notificationtrigger.sentmessages.filter.status.sent": "Envoyé",
  "notificationtrigger.sentmessages.filter.type.all": "Tous les types",
  "notificationtrigger.sentmessages.filter.type.label": "Type",
  "notificationtrigger.sentmessages.heading": "Messages envoyés",
  "notificationtrigger.sentmessages.resend.disclaimer": "La réenvoi reproduit les octets du message d'origine et l'adresse du destinataire. Pour envoyer le message à une autre adresse, modifiez le dossier du patient et déclenchez un nouvel événement.",
  "notificationtrigger.sentmessages.resend.failure": "L'envoi nouveau a connu un échec. Veuillez consulter les journaux du serveur pour plus de détails.",
  "notificationtrigger.sentmessages.resend.success": "La notification a été renvoyée.",
  "notificationtrigger.sentmessages.status.failed": "Failed",
  "notificationtrigger.sentmessages.status.sent": "Envoyé",
  "notificationtrigger.sentmessages.subtitle": "Toutes les notifications sortantes envoyées par OpenELIS, tous types de déclencheurs et tous canaux confondus.",
  "notificationtrigger.sentmessages.viewlog.channels": "Résultats par canal",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Tentatives",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Chaîne",
  "notificationtrigger.sentmessages.viewlog.column.error": "Erreur",
  "notificationtrigger.sentmessages.viewlog.column.status": "Statut",
  "notificationtrigger.sentmessages.viewlog.heading": "Journal des notifications",
  "notificationtrigger.sentmessages.viewlog.message": "Corps du message",
  "notificationtrigger.sentmessages.viewlog.subject": "Objet",
  "notificationtrigger.status.new": "NEW",
  "notificationtrigger.subcontractdispatched.description": "Envoyé lorsqu'un échantillon a été physiquement expédié au laboratoire destinataire.",
  "notificationtrigger.subcontractdispatched.name": "Sous-traitance confiée",
  "notificationtrigger.tabs.sentmessages": "Messages envoyés",
  "notificationtrigger.tabs.sentmessages.placeholder": "Messages envoyés — à venir dans une prochaine mise à jour.",
  "notificationtrigger.tabs.templates": "Modèles",
  "notificationtrigger.tabs.templates.placeholder": "Éditeur de modèles — disponible dans une prochaine version.",
  "notificationtrigger.tabs.triggers": "Déclencheurs",
  "notificationtrigger.templates.body.help": "Texte libre avec champs de fusion. Ce modèle n'est pas géré par i18n — vous pouvez le modifier directement.",
  "notificationtrigger.templates.body.label": "Corps du message",
  "notificationtrigger.templates.button.reset": "Réinitialiser aux valeurs par défaut",
  "notificationtrigger.templates.button.save": "Enregistrer le modèle",
  "notificationtrigger.templates.channel.help": "Chaque chaîne dispose de ses propres champs de modèle. Passez d'une chaîne à l'autre pour les modifier séparément.",
  "notificationtrigger.templates.channel.label": "Chaîne",
  "notificationtrigger.templates.heading": "Configuration des modèles de notification",
  "notificationtrigger.templates.mergefields.heading": "Champs de fusion disponibles",
  "notificationtrigger.templates.mergefields.help": "Les champs ci-dessous sont spécifiques à l'événement « {eventCode} ». Cliquez sur un champ pour l'insérer à l'emplacement du curseur.",
  "notificationtrigger.templates.mergefields.optionalnote": "Si [expectedReturn] n'est pas défini pour le parrainé, le champ s'affiche vide — aucune erreur n'est signalée.",
  "notificationtrigger.templates.preview.label": "Aperçu rendu",
  "notificationtrigger.templates.referralout.description": "Envoyé au contact client (Prestataire) et/ou au personnel interne (Utilisateur ayant effectué la saisie) lorsqu'une recommandation est enregistrée.",
  "notificationtrigger.templates.subcontractdispatched.description": "Envoyé au responsable CoC du laboratoire destinataire et au client lorsqu'un échantillon est physiquement expédié au laboratoire destinataire.",
  "notificationtrigger.templates.subject.label": "Objet",
  "notificationtrigger.templates.subtitle": "Rédigez des modèles de message pour chaque type d'événement de notification. Les modèles sont constitués de texte libre et comportent des champs de fusion.",
  "order.clinicalInfo.helper": "Contexte facultatif destiné à orienter le choix des tests et la rédaction du rapport — non enregistré comme diagnostic confirmé.",
  "order.complete.processing.description": "{labNumber} est désormais en statut « {status} » et apparaîtra dans la liste de travail « V-03 Vector Identification ».",
  "order.complete.processing.description.plain": "{labNumber} est désormais en statut de traitement et apparaîtra dans la liste de travail « Identification des Vecteurs V-03 ».",
  "order.complete.processing.title": "Commande terminée — En cours de traitement",
  "order.context.poolOf": "Galerie d'images d'{count} {animal}",
  "order.paymentStatus.helper": "Comment le paiement de cette commande sera-t-il traité ?",
  "order.priority.helper": "ROUTINE : délai de traitement standard. URGENT : à traiter immédiatement.",
  "order.referral.sampleType.ambiguous": "Cette demande de commande concernait l'{items} ; toutefois, le type d'échantillon n'a pas pu être déterminé automatiquement. Veuillez sélectionner un type d'échantillon ci-dessous, puis choisir le ou les tests demandés.",
  "order.requester.section.helper": "Veuillez sélectionner l'établissement qui a demandé les analyses ainsi que le prestataire responsable.",
  "panel.domain.clinical": "Clinique",
  "panel.domain.environmental": "Environnemental",
  "panel.domain.eqa": "EEQ",
  "panel.domain.vector": "Vecteur",
  "panel.filter.domain": "Domaine",
  "panel.organism.flea": "Puce",
  "panel.organism.fly": "Voler",
  "panel.organism.mosquito": "Moustique",
  "panel.organism.rodent": "rongeur",
  "panel.organism.selectPlaceholder": "Sélectionnez un groupe d'organismes",
  "panel.organism.tick": "Cochez",
  "patient.search.section.helper": "Effectuez une recherche en combinant n'importe quels champs — les correspondances partielles sont acceptées. La fonction « Recherche externe » interroge le registre des clients et nécessite au minimum un nom et une date de naissance.",
  "placeholder.validation.qc.justification": "Obligatoire (500 caractères maximum)",
  "provider.add.new": "+ Ajouter un nouveau prestataire « {name} »",
  "providerTitle.abbreviation": "Abréviation",
  "providerTitle.add": "Ajouter un titre",
  "providerTitle.confirm.activate": "Activer « {title} » ?",
  "providerTitle.confirm.activate.body": "Il sera de nouveau proposé lors du choix du titre d'un prescripteur.",
  "providerTitle.confirm.deactivate": "Désactiver « {title} » ?",
  "providerTitle.confirm.deactivate.body": "Il ne sera plus proposé pour les nouvelles sélections. Les {count} prescripteur(s) qui le portent déjà le conservent.",
  "providerTitle.duplicate": "« {value} » figure déjà dans la liste",
  "providerTitle.edit": "Modifier le titre",
  "providerTitle.edit.warning": "La modification d'un titre change son affichage pour tous les prescripteurs qui l'utilisent.",
  "providerTitle.empty": "Aucun titre de prescripteur n'est encore configuré.",
  "providerTitle.filter.status": "Statut",
  "providerTitle.filter.status.active": "Active",
  "providerTitle.filter.status.all": "Tous",
  "providerTitle.filter.status.inactive": "Inactif",
  "providerTitle.inUse": "Utilisé",
  "providerTitle.search": "Rechercher des titres",
  "providerTitle.sortOrder": "Ordre de tri",
  "providerTitle.summary": "{total} titre(s) : {active} actif(s), {inactive} inactif(s).",
  "providerTitle.title": "Titre",
  "providerTitle.titles": "Titres des prescripteurs",
  "provider.email.field": "E-mail du prestataire",
  "provider.fax.field": "Fax du prestataire",
  "provider.title.field": "Titre",
  "provider.title.inName": "Cela ressemble à un titre. Pensez à le déplacer dans le champ Titre pour que les listes soient triées par nom de famille.",
  "provider.title.filter": "Filtrer par titre",
  "provider.title.filter.all": "Tous les titres",
  "provider.title.placeholder": "Sélectionner un titre...",
  "provider.firstName.field": "Prénom",
  "provider.lastName.field": "Nom",
  "provider.new.helper": "Un nouveau prestataire sera créé lors de l'enregistrement de cette commande.",
  "provider.new.tag": "Nouveau",
  "provider.no.match": "Non, aucun prestataire correspondant n'a été trouvé.",
  "provider.phone.field": "Téléphone",
  "qc.add.blank": "+ QC vierge",
  "qc.add.control": "+ Contrôle QC",
  "qc.add.duplicate": "+ QC des doublons",
  "qc.collect.inheritsFromParent": "Détails de la collecte hérités de l'échantillon parenta",
  "qc.expectedValue.placeholder": "par exemple 50,0",
  "qc.samples.label": "Échantillons de CQ :",
  "qc.samples.numericOnly": "Le contrôle qualité n'est actuellement pris en charge que pour les tests dont les résultats sont numériques. Les tests sélectionnés sont marqués d'un code : choisissez un test numérique pour y associer le contrôle qualité.",
  "qc.samples.thresholdsMissing": "Configurez les seuils de contrôle qualité pour l'{tests}, dans Administration → Configuration des tests, avant d'ajouter des échantillons de CQ.",
  "qc.status.current": "Statut CQ actuel",
  "qc.status.failed.warning.message": "Les lots qui échouent au contrôle qualité sont exclus des analyses et du stock disponible.",
  "qc.status.failed.warning.title": "Ce lot ne sera pas utilisable",
  "qc.status.new": "Nouveau statut CQ",
  "qc.status.notes": "Remarques sur le contrôle qualité",
  "qc.status.notes.placeholder": "Motif du résultat CQ, analyse effectuée ou référence",
  "qc.type.blank": "QC : vide",
  "qc.type.control": "QC : Contrôle",
  "qc.type.duplicate": "QC : Dupliquer",
  "referral.accept.error": "Le résultat n'a pas pu être validé. Veuillez réessayer.",
  "referral.action.accept": "Valider",
  "referral.action.acceptToAnalysis": "Valider l'analyse",
  "referral.action.clearFilters": "Effacer les filtres",
  "referral.action.enterResult": "Saisir le résultat",
  "referral.action.markLost": "Marquer comme perdu",
  "referral.action.notifyReferenceLab": "Informer le Laboratoire de référence",
  "referral.action.openResultEntry": "Ouvrir dans la saisie des résultats",
  "referral.action.reject": "Rejeter",
  "referral.banner.filterToStuck": "Filtres pour n'afficher que les éléments bloqués",
  "referral.banner.stuckReferralsSubtitle": "{count} La ou les demandes d'analyse se trouvent dans un laboratoire de référence depuis plus de {threshold} jour(s).",
  "referral.banner.stuckReferralsTitle": "Détection de références bloquées",
  "referral.box.cannotReconcileMessage": "Impossible de faire correspondre les résultats — {count} : certains échantillons sont toujours en attente de rapprochement des résultats. Voir les résultats du Laboratoire de référence.",
  "referral.box.viewBlockedReferrals": "Voir les résultats du Laboratoire de référence",
  "referral.breadcrumb.referenceLabResults": "Résultats d'analyses de laboratoire de référence",
  "referral.chip.ariaLabel": "Affichage des résultats d'analyses du laboratoire de référence",
  "referral.chip.history": "Historique",
  "referral.chip.outstanding": "Exceptionnel",
  "referral.chip.returned": "Renvoyé — action requise",
  "referral.column.actions": "Actions",
  "referral.column.boxId": "ID de la boîte",
  "referral.column.closedDate": "Date de clôture",
  "referral.column.daysOutstanding": "Jours moyens de recouvrement",
  "referral.column.daysTotal": "Nombre total de jours",
  "referral.column.labNumber": "Numéro laboratoire",
  "referral.column.outcome": "Résultat",
  "referral.column.patient": "Patient",
  "referral.column.priority": "Priorité",
  "referral.column.referenceLab": "Laboratoire de référence",
  "referral.column.requestor": "Auteur de la demande initiale",
  "referral.column.resultSummary": "Résumé des résultats",
  "referral.column.returnedDate": "Date de retour",
  "referral.column.sentDate": "Date d'envoi",
  "referral.column.status": "Statut",
  "referral.column.tests": "Test(s)",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# an} many {# ans} other {# ans}}",
  "referral.expand.detail.boxId": "ID de la boîte",
  "referral.expand.detail.boxReceivedDate": "Reçu au laboratoire de référence",
  "referral.expand.detail.collected": "Prélevé",
  "referral.expand.detail.currentStatus": "Statut actuel",
  "referral.expand.detail.daysOutstanding": "Jours moyens de recouvrement",
  "referral.expand.detail.dispatched": "Expédié",
  "referral.expand.detail.fhirTask": "Tâche FHIR",
  "referral.expand.detail.labNumber": "Numéro laboratoire",
  "referral.expand.detail.patient": "Patient",
  "referral.expand.detail.priority": "Priorité",
  "referral.expand.detail.referenceLab": "Laboratoire de référence",
  "referral.expand.detail.requestor": "Auteur de la demande initiale",
  "referral.expand.detail.sampleType": "Type d'échantillon",
  "referral.expand.detail.tests": "Analyses",
  "referral.expand.noResultPayload": "Le laboratoire de référence n'a fourni aucun résultat structuré.",
  "referral.expand.originalOrderContext": "Contexte de la commande d'origine",
  "referral.expand.outcomeDetail": "Détails des résultats",
  "referral.expand.receptionAction": "Mesures de réception",
  "referral.expand.receptionHint": "Veuillez examiner le résultat fourni ci-dessous, puis « Validez-le » pour l'enregistrer dans le dossier du patient, ou « Rejetez-le » s'il ne peut pas être utilisé.",
  "referral.expand.referenceLabTransit": "Transit vers le Laboratoire de référence",
  "referral.expand.result": "Résultat ",
  "referral.expand.statusDetail": "Détails du statut",
  "referral.filter.allPriorities": "Toutes les priorités",
  "referral.filter.allRefLabs": "Tous les laboratoires de référence",
  "referral.filter.dateRange": "Plage de dates",
  "referral.filter.daysOutstandingBucket": "Jours moyens de recouvrement",
  "referral.filter.daysOutstandingBucket.stuck": "En attente (> {threshold} jours)",
  "referral.filter.priority": "Priorité",
  "referral.filter.referenceLab": "Laboratoire de référence",
  "referral.markLost.cancelButton": "Annuler",
  "referral.markLost.confirmButton": "Marquer comme perdu",
  "referral.markLost.description": "Cette opération marque la demande d'analyse comme « perdue en transit » et la retire de la liste des demandes en attente. L'équipe clinique devra prélever à nouveau l'échantillon et renvoyer la demande.",
  "referral.markLost.modalTitle": "Marquer la recommandation comme perdue",
  "referral.markLost.reasonLabel": "Motif",
  "referral.markLost.reasonPlaceholder": "Par exemple : perte confirmée par le transporteur. Le colis n'est jamais parvenu au Laboratoire de référence.",
  "referral.markLost.reasonRequired": "Il faut indiquer un motif.",
  "referral.metric.outstanding": "Exceptionnel",
  "referral.metric.reconciledToday": "Rapprochés aujourd'hui",
  "referral.metric.rejectedThisWeek": "Rejeté cette semaine",
  "referral.metric.returned": "Renvoyé — action requise",
  "referral.notification.accepted": "Le résultat a été validé dans le dossier du patient.",
  "referral.notification.rejected": "Résultat rejeté. Le praticien a été informé qu'il doit procéder à un nouveau prélèvement.",
  "referral.notify.errorRetry": "Echec : impossible d'avertir le Laboratoire de référence. Veuillez réessayer.",
  "referral.notify.toast": "Le laboratoire de référence a été informé.",
  "referral.page.title": "Résultats d'analyses de laboratoire de référence",
  "referral.reject.cancelButton": "Annuler",
  "referral.reject.confirmButton": "Rejeter et en informer le praticien",
  "referral.reject.description": "Le rejet entraîne la clôture définitive du test d'origine et invite le praticien à prélever un nouvel échantillon et à le renvoyer.",
  "referral.reject.error": "Impossible de rejeter le résultat. Veuillez réessayer.",
  "referral.reject.modalTitle": "Rejeter le résultat renvoyé",
  "referral.reject.reason.clotted": "Coagulé",
  "referral.reject.reason.damagedContainer": "Conteneur endommagé",
  "referral.reject.reason.hemolyzed": "Hémolysé",
  "referral.reject.reason.insufficientVolume": "Volume insuffisant",
  "referral.reject.reason.mislabeled": "Mal étiqueté",
  "referral.reject.reason.other": "Autre",
  "referral.reject.reason.temperatureDeviation": "Écart de température de la température",
  "referral.reject.reason.wrongSampleType": "Mauvais type d'échantillon",
  "referral.reject.reasonLabel": "Motif",
  "referral.reject.reasonTextLabel": "Détails",
  "referral.reject.reasonTextPlaceholder": "Expliquez pourquoi ce résultat ne peut pas être utilisé.",
  "referral.reject.reasonTextRequired": "Des détails sont nécessaires.",
  "referral.reject.warningTitle": "Cette action ne peut pas être annulée",
  "referral.result.interp.Abnormal": "Anormal",
  "referral.result.interp.Critical": "Critique",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Annulé",
  "referral.status.completed": "Résultat renvoyé",
  "referral.status.draft": "Brouillon",
  "referral.status.inProgress": "En cours au Laboratoire de référence",
  "referral.status.received": "Au laboratoire de référence",
  "referral.status.reconciled": "Rapproché",
  "referral.status.rejected": "Rejeté par le Laboratoire de référence",
  "referral.status.requested": "Envoyé — en attente de validation",
  "referral.table.count": "{count, plural, =0 {Aucun envoi} one {# envoi} other {# envois}}",
  "referral.table.history.title": "Historique",
  "referral.table.outstanding.title": "Références en attente",
  "referral.table.returned.title": "Renvoyé — action requise",
  "referral.tag.manuallyEntered": "Saisi manuellement",
  "reports.tat.title": "Rapport sur le délai de traitement",
  "reports.tat.description": "Analyser les délais de traitement du laboratoire à travers les différentes étapes du processus",
  "reports.tat.generateReport": "Générer le rapport",
  "reports.tat.clearFilters": "Effacer les filtres",
  "reports.tat.segment.orderToCollection": "De la prescription au prélèvement",
  "reports.tat.segment.collectionToReceipt": "Prélèvement à la réception",
  "reports.tat.segment.receiptToTesting": "Réception au début de l’analyse",
  "reports.tat.segment.receiptToResult": "Réception à la saisie des résultats",
  "reports.tat.segment.receiptToValidation": "Réception à la validation",
  "reports.tat.segment.resultToValidation": "Saisie des résultats à la validation",
  "reports.tat.segment.overall": "Délai de traitement global",
  "reports.tat.calendarTime": "Temps calendaire",
  "reports.tat.workingTime": "Temps de travail",
  "reports.tat.workingTimeInfo": "Mode temps de travail : exclusion des {weekendDays} et de {holidayCount} jours fériés dans la période sélectionnée",
  "reports.tat.configuredWeekends": "week-ends configurés",
  "reports.tat.noHolidaysWarning": " Aucun jour férié configuré. Configurez les jours fériés dans Admin > Gestion du calendrier.",
  "reports.tat.manageCalendar": "Gestion du calendrier",
  "reports.tat.totalResults": "Résultats totaux",
  "reports.tat.meanTat": "Délai moyen de traitement",
  "reports.tat.medianTat": "Délai médian de traitemen",
  "reports.tat.percentile90": "90e percentile",
  "reports.tat.minTat": "Délai minimum de traitement",
  "reports.tat.maxTat": "Délai maximum de traitement",
  "reports.tat.stdDeviation": "Écart-type",
  "reports.tat.distribution": "Distribution des délais de traitement",
  "reports.tat.breakdownBy": "Répartition par",
  "reports.tat.clickRowHint": "Cliquez sur une ligne pour voir les résultats individuels",
  "reports.tat.summary": "Résumé",
  "reports.tat.detailList": "Liste détaillée",
  "reports.tat.trends": "Tendances",
  "reports.tat.noResults": "Aucun résultat trouvé pour les filtres sélectionnés. Essayez d’ajuster la période ou les critères de filtrage.",
  "reports.tat.insufficientData": "Données insuffisantes",
  "reports.tat.loadError": "Erreur lors du chargement des données du rapport",
  "reports.tat.dateRange": "Plage de dates",
  "reports.tat.labUnit": "Unité de laboratoire",
  "reports.tat.testPanel": "Test / Panel",
  "reports.tat.priority.all": "Tous",
  "reports.tat.priority.routine": "Routine",
  "reports.tat.priority.stat": "Urgent",
  "reports.tat.priority.asap": "Dès que possible",
  "reports.tat.sampleType": "Type d'échantillon",
  "reports.tat.orderingSite": "Site demandeur",
  "reports.tat.priority": "Priorité",
  "reports.tat.includeCancelled": "Inclure les analyses annulées/rejetées",
  "reports.tat.export": "Exporter",
  "reports.tat.exportCsv": "Exporter en CSV",
  "reports.tat.exportPdf": "Exporter en PDF",
  "reports.tat.labNumber": "Numéro laboratoire",
  "reports.tat.patient": "Patient",
  "reports.tat.test": "Test",
  "reports.tat.orderCreated": "Demande d'examens créée",
  "reports.tat.collected": "Prélevé",
  "reports.tat.received": "Reçu",
  "reports.tat.testingStarted": "Analyse commencée",
  "reports.tat.resultEntered": "Résultat saisi",
  "reports.tat.validated": "Validé",
  "reports.tat.selectedTat": "Délai de traitement sélectionné",
  "reports.tat.overallTat": "Délai de traitement global",
  "reports.tat.columns": "Colonnes",
  "reports.tat.rowsPerPage": "Lignes par page",
  "reports.tat.showing": "Affichage de {from} à {to} sur {total} résultats",
  "reports.tat.trend": "Tendance",
  "reports.tat.aggregation": "Agrégation",
  "reports.tat.daily": "Journalier",
  "reports.tat.weekly": "Hebdomadaire",
  "reports.tat.monthly": "Mensuel",
  "reports.tat.compareBy": "Comparer par",
  "reports.tat.showVolume": "Afficher le volume des demandes",
  "reports.tat.mean": "Moyenne",
  "reports.tat.median": "Médian",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Plage de Date (De)",
  "reports.tat.dateRangeTo": "Plage de Date (à)",
  "reports.tat.tatSegment": "Segment de Délai de traitement",
  "reports.tat.metrics": "Indicateurs",
  "reports.tat.compareNone": "Aucun",
  "reports.tat.comparePriority": "Priorité",
  "reports.tat.column.labNumber": "Numéro laboratoire",
  "reports.tat.column.test": "Test",
  "reports.tat.column.labUnit": "Unité de laboratoire",
  "reports.tat.column.priority": "Priorité",
  "reports.tat.column.ordered": "Prescrit",
  "reports.tat.column.collected": "Prélevé",
  "reports.tat.column.received": "Reçu",
  "reports.tat.column.started": "Démarré",
  "reports.tat.column.resulted": "Résultat disponible",
  "reports.tat.column.validated": "Validé",
  "reports.tat.column.selectedTat": "Délai de traitement sélectionné",
  "reports.tat.column.overallTat": "Délai de traitement global",
  "reports.tat.column.name": "Nom",
  "reports.tat.column.count": "Nombre",
  "reports.tat.column.mean": "Moyenne",
  "reports.tat.column.median": "Médian",
  "reports.tat.column.p90": "90e percentile",
  "reports.tat.column.max": "Maximum",
  "reports.tat.home": "Accueil",
  "reports.tat.all": "Tous",
  "reports.tat.preset.today": "Aujourd'hui",
  "reports.tat.preset.7days": "7 derniers jours",
  "reports.tat.preset.30days": "30 derniers jours",
  "reports.tat.preset.90days": "90 derniers jours ",
  "reports.tat.preset.thisMonth": "Ce mois",
  "reports.tat.preset.lastMonth": "Dernier mois",
  "reports.tat.preset.thisQuarter": "Ce trimestre",
  "button.cancel": "Annuler",
  "button.activate": "Activer",
  "button.adjust": "Ajuster",
  "button.deactivate": "Désactiver",
  "button.dispose": "Disposer",
  "button.edit": "Modifier",
  "button.generate": "Générer",
  "button.label.genarateReport": "Générer le rapport",
  "button.label.loadnext": "Charger le lot suivant",
  "button.label.loadprevious": "Charger le lot précédent",
  "button.label.showHidePram": "Afficher/Masquer les paramètres du rapport",
  "button.record": "Enregistrer",
  "button.save": "Sauvegarder",
  "button.save.draft": "Enregistrer le brouillon",
  "button.save.next": "Enregistrer et suivant",
  "button.save.stay": "Sauvegarder",
  "button.send": "Envoyer",
  "button.update": "Mettre à jour",
  "calculatedTests": "Calculated Tests",
  "catalog.item.activate.success": "L'élément du catalogue a été activé avec succès.",
  "catalog.item.category": "Catégorie",
  "catalog.item.code": "Code Emplacement",
  "catalog.item.code.hint": "Identifiant stable utilisé par les intégrations. Laissez vide pour qu'un identifiant soit généré à partir du nom, par exemple PAR-500MG-001.",
  "catalog.item.code.locked": "Le code est verrouillé après l'enregistrement afin que les intégrations et les références existantes continuent de fonctionner.",
  "catalog.item.code.placeholder": "Laisser vide pour générer automatiquement à partir du nom",
  "catalog.item.code.preview": "Sera enregistré sous {code}",
  "catalog.item.compatibleAnalyzers": "Automates compatibles",
  "catalog.item.deactivate.confirm.button": "Désactiver",
  "catalog.item.deactivate.confirm.message": "Êtes-vous sûr de vouloir désactiver {itemName} ?",
  "catalog.item.deactivate.confirm.title": "Confirmer la désactivation",
  "catalog.item.deactivate.implications.1": "Cet élément n'apparaîtra plus dans les listes d'articles actifs.",
  "catalog.item.deactivate.implications.2": "Les lots existants pour cet article resteront accessibles.",
  "catalog.item.deactivate.implications.3": "Vous pouvez réactiver cet élément ultérieurement si nécessaire.",
  "catalog.item.deactivate.implications.title": "Implications :",
  "catalog.item.deactivate.label": "Désactiver l'élément",
  "catalog.item.deactivate.success": "Elément désactivé avec succès",
  "catalog.item.error.saveGeneric": "Erreur lors de l'enregistrement de l'élément de catalogue",
  "catalog.item.error.stabilityRequired": "La stabilité après ouverture est obligatoire pour les réactifs",
  "catalog.item.form.title.add": "Ajouter de nouveaux éléments au catalogue",
  "catalog.item.form.title.edit": "Modifier un élément du catalogue",
  "catalog.item.lowStockThreshold": "Seuil de stock bas",
  "catalog.item.manufacturer": "Fabricant",
  "catalog.item.minimumStock": "Niveau de stock minimum",
  "catalog.item.name": "Nom de l'élément ",
  "catalog.item.reorderLevel": "Niveau de réapprovisionnement",
  "catalog.item.reorderQuantity": "Quantité de commande",
  "catalog.item.save.error": "Erreur lors de l'enregistrement de l'élément de catalogue",
  "catalog.item.save.success": "L'élément du catalogue a été enregistré avec succès.",
  "catalog.item.stabilityAfterOpening": "Stabilité après ouverture (jours)",
  "catalog.item.status": "Statut",
  "catalog.item.storageRequirements": "Exigences de stockage",
  "catalog.item.testTypes": "Types de tests",
  "catalog.item.testsPerCartridge": "Tests par cartouche",
  "catalog.item.testsPerKit": "Tests par kit",
  "catalog.item.units": "Unités",
  "catalog.search.placeholder": "Rechercher par nom d'élément",
  "choose.availablepanel": "Choisir un panel disponible",
  "coldStorage.action.createSuccess": "Corrective action created successfully",
  "coldStorage.action.retractSuccess": "Corrective action retracted successfully",
  "coldStorage.action.updateSuccess": "Corrective action updated successfully",
  "coldStorage.actions": "Actions",
  "coldStorage.activated": "activated",
  "coldStorage.addDevicesMessage": "Please add devices in Device Management to configure temperature thresholds.",
  "coldStorage.addNewDevice": "Add New Device",
  "coldStorage.alert.acknowledged": "Alerte acquittée avec succès",
  "coldStorage.alert.actionFailed": "Impossible d'{action}er l'alerte {alertId}",
  "coldStorage.alert.equipment": "Equipment Failure",
  "coldStorage.alert.equipment.description": "Alerts for equipment malfunctions or connectivity issues",
  "coldStorage.alert.inventory": "Inventory Alerts",
  "coldStorage.alert.inventory.description": "Alerts for low inventory or stock management",
  "coldStorage.alert.resolved": "L'alerte a été résolue avec succès",
  "coldStorage.alert.saveFailed": "Failed to save notification preferences: ",
  "coldStorage.alert.saveSuccess": "Notification preferences saved successfully. Each alert type will use its configured notification methods.",
  "coldStorage.alert.temperature": "Temperature Alerts",
  "coldStorage.alert.temperature.description": "Alerts triggered when freezer temperature exceeds defined thresholds",
  "coldStorage.alert.type": "Alert Type",
  "coldStorage.alertConfiguration": "Alert Configuration",
  "coldStorage.autoEscalate": "Automatically escalate unresolved alerts",
  "coldStorage.button.delete": "Supprimer",
  "coldStorage.configuredDevices": "Configured Devices",
  "coldStorage.correctiveAction.column.actionId": "IDENTIFIANT DE L'ACTION",
  "coldStorage.correctiveAction.column.created": "Créé",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "Dernière mise à jour effectuée par",
  "coldStorage.correctiveAction.column.performedBy": "Interprété par",
  "coldStorage.correctiveAction.edited": "Modifié",
  "coldStorage.correctiveAction.status.cancelled": "Annulé",
  "coldStorage.correctiveAction.status.completed": "Terminé",
  "coldStorage.correctiveAction.status.inProgress": "En cours",
  "coldStorage.correctiveAction.status.pending": "En attente",
  "coldStorage.correctiveAction.status.retracted": "Retiré",
  "coldStorage.correctiveAction.type.calibration": "Étalonnage",
  "coldStorage.correctiveAction.type.calibration.description": "Étalonnage des équipements ou des capteurs",
  "coldStorage.correctiveAction.type.equipmentRepair": "Réparation de matériel",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "Réparation ou remplacement du matériel",
  "coldStorage.correctiveAction.type.itemReorder": "Réapprovisionnement d'un élément",
  "coldStorage.correctiveAction.type.itemReorder.description": "Réapprovisionnement des éléments d’inventaire",
  "coldStorage.correctiveAction.type.maintenance": "Maintenance",
  "coldStorage.correctiveAction.type.maintenance.description": "Réalisation des tâches de maintenance",
  "coldStorage.correctiveAction.type.other": "Autre",
  "coldStorage.correctiveAction.type.other.description": "Autres actions correctives ou actions correctives sur mesure",
  "coldStorage.correctiveAction.type.sampleRelocation": "Exemple de déménagement",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "Transfert des échantillons vers un autre emplacement",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "Ajuster la température",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "Réglage des paramètres de température",
  "coldStorage.criticalThreshold": "Critical Threshold (°C)",
  "coldStorage.dashboard.acknowledge": "Accuser réception",
  "coldStorage.dashboard.activeAlerts": "Alertes actives ({count})",
  "coldStorage.dashboard.column.currentTemp": "Température actuelle",
  "coldStorage.dashboard.column.currentTemp2": "Sonde 2 Température",
  "coldStorage.dashboard.column.device": "Appareil",
  "coldStorage.dashboard.column.duration": "Durée",
  "coldStorage.dashboard.column.humidity": "Humidité",
  "coldStorage.dashboard.column.lastReading": "Dernière lecture",
  "coldStorage.dashboard.column.location": "Emplacement",
  "coldStorage.dashboard.column.severity": "Gravité",
  "coldStorage.dashboard.column.started": "Démarré",
  "coldStorage.dashboard.column.targetTemp": "Température cible",
  "coldStorage.dashboard.column.temperature": "Température",
  "coldStorage.dashboard.column.unitId": "Identifiant de l'unité",
  "coldStorage.dashboard.column.unitName": "Nom de l'unité",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} unité(s) de stockage présentant des écarts de température critiques",
  "coldStorage.dashboard.criticalAlertTitle": "Alertes critiques",
  "coldStorage.dashboard.deviceTypeFilter": "Type d'appareil",
  "coldStorage.dashboard.kpi.critical": "Alertes critiques",
  "coldStorage.dashboard.kpi.normal": "Statut normal",
  "coldStorage.dashboard.kpi.totalUnits": "Nombre total d'unités de stockage",
  "coldStorage.dashboard.kpi.warnings": "Warnings",
  "coldStorage.dashboard.lastUpdate": "Dernière mise à jour : {time}",
  "coldStorage.dashboard.loadingUnits": "Chargement des unités de stockage…",
  "coldStorage.dashboard.noActiveAlerts": "Aucune alerte active",
  "coldStorage.dashboard.noUnitsFound": "Aucun espace de stockage n'a été trouvé.",
  "coldStorage.dashboard.online": "En ligne",
  "coldStorage.dashboard.refresh": "Actualiser",
  "coldStorage.dashboard.refreshing": "Rafraîchissant",
  "coldStorage.dashboard.refreshingEllipsis": "C'est rafraîchissant...",
  "coldStorage.dashboard.searchLabel": "Rechercher par identifiant ou par nom d'unité",
  "coldStorage.dashboard.statusFilter": "Statut",
  "coldStorage.dashboard.storageUnitsTitle": "Espaces de stockage",
  "coldStorage.dashboard.subtitle": "Surveillance de la température en temps réel et conformité",
  "coldStorage.dashboard.systemStatus": "Statut du système : {status}",
  "coldStorage.dashboard.tab.correctiveActions": "Actions correctives",
  "coldStorage.dashboard.tab.dashboard": "Tableau de bord",
  "coldStorage.dashboard.tab.historicalTrends": "Historical Trends",
  "coldStorage.dashboard.tab.reports": "Rapports",
  "coldStorage.dashboard.tab.settings": "Paramètres",
  "coldStorage.dashboard.viewAlertDetails": "Voir les détails de l'alerte",
  "coldStorage.deactivated": "deactivated",
  "coldStorage.description": "Description",
  "coldStorage.device.activate": "Activate device",
  "coldStorage.device.activateMessage": "Activating this device will enable monitoring and data collection.",
  "coldStorage.device.changeStatus": "Change Device Status",
  "coldStorage.device.changeStatusOf": "Change the status of {name}:",
  "coldStorage.device.created": "Device created successfully",
  "coldStorage.device.createdSuccess": "Device \\",
  "coldStorage.device.deactivate": "Deactivate device",
  "coldStorage.device.deactivateMessage": "Deactivating this device will stop monitoring and data collection. Historical data will be preserved.",
  "coldStorage.device.delete": "Delete Device",
  "coldStorage.device.deleteConfirm": "Are you sure you want to delete {name}?",
  "coldStorage.device.deleteWarning": "This will mark the device as inactive and remove it from active monitoring. Historical data will be preserved.",
  "coldStorage.device.deleted": "Device \\",
  "coldStorage.device.deviceStatus": "Device Status",
  "coldStorage.device.edit": "Edit device",
  "coldStorage.device.id": "Device ID",
  "coldStorage.device.ipAddress": "Adresse IP",
  "coldStorage.device.port": "Port",
  "coldStorage.device.protocol": "Protocole",
  "coldStorage.device.registerCount": "Registres par valeur",
  "coldStorage.device.registerCount.help": "1 pour une valeur sur 16 bits, 2 pour une valeur sur 32 bits s'étendant sur deux registres",
  "coldStorage.device.roomFacility": "Room/Facility",
  "coldStorage.device.rs485": "RS-485 semi-duplex (en option)",
  "coldStorage.device.rs485.delayAfter": "Délai après transmission (ms)",
  "coldStorage.device.rs485.delayBefore": "Délai avant transmission (ms)",
  "coldStorage.device.rs485.mode": "Activer la synchronisation d'activation du pilote RS-485",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS actif haut pendant la transmission",
  "coldStorage.device.rs485.rxDuringTx": "Veillez à ce que le récepteur reste activé pendant la transmission",
  "coldStorage.device.rs485.termination": "Terminaison de bus activée",
  "coldStorage.device.secondProbe": "Deuxième sonde de température (en option)",
  "coldStorage.device.secondProbe.offset": "Température de base 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "Décalage de base pour la deuxième sonde",
  "coldStorage.device.secondProbe.register": "Registre de température 2",
  "coldStorage.device.secondProbe.registerHelp": "Adresse de registre Modbus pour une deuxième sonde de température indépendante. Ses mesures sont enregistrées et représentées graphiquement ; les alertes de seuil sont déclenchées par la première sonde.",
  "coldStorage.device.secondProbe.scale": "Échelle de température 2",
  "coldStorage.device.secondProbe.scaleHelp": "Facteur d'échelle (par exemple, 0,1 pour diviser par 10)",
  "coldStorage.device.statusChanged": "Device \\",
  "coldStorage.device.type": "Type",
  "coldStorage.device.updated": "Device updated successfully",
  "coldStorage.device.wordOrder": "Ordre des mots",
  "coldStorage.device.wordOrder.bigEndian": "Big-endian (le mot le plus significatif en premier)",
  "coldStorage.device.wordOrder.help": "Ordre des deux registres dans une valeur de 32 bits ; ignoré lors de la lecture d'un registre",
  "coldStorage.device.wordOrder.littleEndian": "Little-endian (le mot le moins significatif en premier)",
  "coldStorage.deviceHistory.averageMetric": "{metric} moyenne",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "Accusé de réception / Réalisé par",
  "coldStorage.deviceHistory.column.date": "Date",
  "coldStorage.deviceHistory.column.eventId": "IDENTIFIANT d'événement",
  "coldStorage.deviceHistory.column.eventType": "Type d'événement",
  "coldStorage.deviceHistory.column.summaryTitle": "Résumé / Titre",
  "coldStorage.deviceHistory.column.time": "Heure",
  "coldStorage.deviceHistory.correctiveActions": "Actions correctives",
  "coldStorage.deviceHistory.dataPoints": "Données",
  "coldStorage.deviceHistory.exportCsv": "Exporter en CSV",
  "coldStorage.deviceHistory.loadingEvents": "Chargement de l'historique des événements...",
  "coldStorage.deviceHistory.loadingTemperature": "Chargement des données de température...",
  "coldStorage.deviceHistory.maxMetric": "Max {metric}",
  "coldStorage.deviceHistory.metric": "Indicateur:",
  "coldStorage.deviceHistory.minMetric": "Min {metric}",
  "coldStorage.deviceHistory.noEventsFound": "Non d'événements trouvés.",
  "coldStorage.deviceHistory.noTemperatureData": "Aucune donnée de température n'est disponible pour la période sélectionnée.",
  "coldStorage.deviceHistory.searchEvents": "Rechercher des événements",
  "coldStorage.deviceHistory.searchPlaceholder": "Rechercher par ID d'événement, Résumé ou Utilisateur...",
  "coldStorage.deviceHistory.tab.eventHistory": "Historique des événements",
  "coldStorage.deviceHistory.tab.temperatureTrends": "Tendances des températures",
  "coldStorage.deviceHistory.timeRange": "Plage :",
  "coldStorage.deviceHistory.title": "Historique des appareils - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "Nombre total d'alertes",
  "coldStorage.deviceHistory.totalEvents": "Nombre total d'événements",
  "coldStorage.email": "E-mail",
  "coldStorage.emailSmsNotifications": "Email Notifications & SMS Notifications",
  "coldStorage.error.createAction": "Failed to create corrective action. Please try again.",
  "coldStorage.error.createDevice": "Failed to create device: ",
  "coldStorage.error.createRoom": "Failed to create room: ",
  "coldStorage.error.deleteDevice": "Failed to delete device: ",
  "coldStorage.error.loadActions": "Failed to load corrective actions. Please try again.",
  "coldStorage.error.loadAuditTrail": "Impossible de charger le formulaire d'Audit",
  "coldStorage.error.loadAuditTrailDetail": "Une erreur inattendue s'est produite lors du chargement des enregistrements d'audit.",
  "coldStorage.error.loadDevices": "Failed to load devices: ",
  "coldStorage.error.loadExcursions": "Impossible de charger l'historique des excursions",
  "coldStorage.error.loadExcursionsDetail": "Une erreur inattendue s'est produite lors du chargement des excursions.",
  "coldStorage.error.loadFailed": "Impossible de charger les données de surveillance des entrepôts frigorifiques.",
  "coldStorage.error.loadLocations": "Failed to load locations: ",
  "coldStorage.error.loadUsers": "Failed to load user list. Please try again later.",
  "coldStorage.error.noCurrentUser": "Impossible d'identifier l'utilisateur actuel. Veuillez vous reconnecter.",
  "coldStorage.error.retractAction": "Failed to retract corrective action. Please try again.",
  "coldStorage.error.saveThreshold": "Failed to save threshold configuration: ",
  "coldStorage.error.toggleStatus": "Failed to toggle device status: ",
  "coldStorage.error.updateAction": "Failed to update corrective action. Please try again.",
  "coldStorage.error.updateDevice": "Failed to update device: ",
  "coldStorage.error.updateFailed": "Impossible de mettre à jour les données de stockage à basse température",
  "coldStorage.escalationDelay": "Escalation Delay (minutes)",
  "coldStorage.escalationDelayHelper": "Time to wait before escalating an unresolved alert",
  "coldStorage.escalationRules": "Escalation Rules",
  "coldStorage.filter.activeOnly": "Active Only",
  "coldStorage.filter.all": "All Devices",
  "coldStorage.filter.inactiveOnly": "Inactive Only",
  "coldStorage.footer": "Surveillance des entrepôts frigorifiques v2.1.0 | Conforme aux directives CAP, CLIA, FDA et de la WHO | Traitement des données conforme à la loi HIPAA",
  "coldStorage.granularNotificationControl": "Granular Notification Control",
  "coldStorage.granularNotificationControlDesc": "Configure email and SMS notifications for each alert type independently. Enable the notification methods you want for each specific alert category.",
  "coldStorage.howNotificationsWork": "How Notifications Work",
  "coldStorage.howNotificationsWorkDesc": "When an alert is triggered (temperature threshold violation, equipment failure, etc.), the system will:",
  "coldStorage.loadingDevices": "Loading devices...",
  "coldStorage.loadingPrefs": "Loading notification preferences...",
  "coldStorage.name": "Nom",
  "coldStorage.noConfigFound": "No Configuration Found",
  "coldStorage.noDevicesConfigured": "No Devices Configured",
  "coldStorage.notification.createRecord": "Create an alert record in the system (visible in Dashboard)",
  "coldStorage.notification.logAttempt": "Log the notification attempt for audit trail purposes",
  "coldStorage.notification.sendEmail": "Send EMAIL notifications if enabled (to configured recipients)",
  "coldStorage.notification.sendSms": "Send SMS notifications if enabled (to configured phone numbers)",
  "coldStorage.pollInterval": "Poll Interval (seconds)",
  "coldStorage.reports.column.action": "Action",
  "coldStorage.reports.column.details": "Détails",
  "coldStorage.reports.column.excursionId": "IDENTIFIANT de l'excursion",
  "coldStorage.reports.column.freezer": "Congélateur",
  "coldStorage.reports.column.freezerId": "IDENTIFIANT du congélateur",
  "coldStorage.reports.column.startTime": "Heure de début",
  "coldStorage.reports.column.temperatureRange": "Plage de températures",
  "coldStorage.reports.column.timestamp": "Horodatage",
  "coldStorage.reports.column.user": "Utilisateur",
  "coldStorage.reports.downloadReport": "Télécharger le rapport « {format} »",
  "coldStorage.reports.endDate": "Date de fin",
  "coldStorage.reports.excursionHistory": "Historique des variations de température",
  "coldStorage.reports.exportFormat": "Format d'exportation",
  "coldStorage.reports.footer": "Surveillance des entrepôts frigorifiques v2.1.0 | Conforme aux normes CAP, CLIA, FDA et WHO | Traitement des données conforme à la loi HIPAA",
  "coldStorage.reports.freezer": "Congélateur",
  "coldStorage.reports.generateReport": "Générer le rapport",
  "coldStorage.reports.loadingAudit": "Chargement des saisies d'audit…",
  "coldStorage.reports.loadingExcursions": "Chargement des excursions…",
  "coldStorage.reports.noAuditActivity": "Aucune activité d'audit n'est disponible pour les filtres sélectionnés.",
  "coldStorage.reports.noAuditMatch": "Non, aucune entrée d'audit ne correspond à votre recherche.",
  "coldStorage.reports.noExcursions": "Non de excursions disponibles selon les filtres sélectionnés.",
  "coldStorage.reports.regulatoryCompliance": "Conformité réglementaire",
  "coldStorage.reports.regulatoryComplianceDesc": "Ces rapports respectent les recommandations du CAP (College of American Pathologists), de la CLIA (Clinical Laboratory Improvement Amendments), de la FDA (Food and Drug Administration) et de la WHO (Organisation mondiale de la santé) en matière de stockage à température contrôlée.",
  "coldStorage.reports.reportType": "Type du rapport",
  "coldStorage.reports.searchAuditTrail": "Rechercher dans l'historique des opérations...",
  "coldStorage.reports.startDate": "Date de début",
  "coldStorage.reports.tab.auditTrail": "Formulaire d'Audit",
  "coldStorage.reports.tab.excursions": "Variations de température",
  "coldStorage.reports.title": "Rapports réglementaires",
  "coldStorage.room.addNew": "Add New Room",
  "coldStorage.room.create": "Create Room",
  "coldStorage.room.created": "Room created successfully",
  "coldStorage.room.description": "Description",
  "coldStorage.room.descriptionPlaceholder": "Enter room description (optional)",
  "coldStorage.room.name": "Room Name *",
  "coldStorage.room.namePlaceholder": "Enter room name (e.g., Lab Storage Room A)",
  "coldStorage.saveNotificationPrefs": "Save Notification Preferences",
  "coldStorage.saveThresholdConfig": "Save Threshold Configuration",
  "coldStorage.saving": "Enregistrement...",
  "coldStorage.search.placeholder": "Search by Device ID or Name",
  "coldStorage.selectType": "Sélectionnez un type",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Statut",
  "coldStorage.status.active": "ACTIVE",
  "coldStorage.status.inactive": "INACTIVE",
  "coldStorage.status.noData": "Non de données",
  "coldStorage.status.offline": "Hors ligne",
  "coldStorage.status.unknown": "Inconnu",
  "coldStorage.supervisorEmail": "Supervisor Email",
  "coldStorage.supervisorEmailHelper": "Email address to send escalated alerts",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.targetTemperature": "Target Temperature (°C)",
  "coldStorage.threshold.saveSuccess": "Threshold configuration saved successfully",
  "coldStorage.thresholdConfiguration": "Temperature Threshold Configuration",
  "coldStorage.trends.averageMetric": "{metric} moyenne",
  "coldStorage.trends.axis.humidity": "Humidité (%)",
  "coldStorage.trends.axis.temperature": "Température (°C)",
  "coldStorage.trends.axis.temperature2": "Température - Sonde 2 (°C)",
  "coldStorage.trends.maxMetric": "Max {metric}",
  "coldStorage.trends.metric": "Indicateur",
  "coldStorage.trends.metric.humidity": "Humidité",
  "coldStorage.trends.metric.temperature": "Température",
  "coldStorage.trends.metric.temperature2": "Température (sonde 2)",
  "coldStorage.trends.minMetric": "Min {metric}",
  "coldStorage.usingDefaults": "Using default notification settings. Save to create configuration.",
  "coldStorage.validation.error": "Erreur de validation",
  "coldStorage.validation.retractionReason": "Please provide a reason for retraction",
  "coldStorage.validation.selectActionType": "Please select an action type",
  "coldStorage.validation.selectDevice": "Please select a device",
  "coldStorage.validation.selectRoom": "Please select a room/location for the device",
  "coldStorage.warningThreshold": "Warning Threshold (°C)",
  "collect.addSample.button": "Ajouter un échantillon",
  "collect.assign.addToSample": "Ajouter à un échantillon existant",
  "collect.assign.button": "Assigner des tests",
  "collect.assign.description": "Assigner les tests demandés aux tubes d’échantillons",
  "collect.assign.newSample": "Créer un nouvel échantillon",
  "collect.assign.newSampleHelp": "Sélectionner le type d’échantillon pour le nouveau tube",
  "collect.assign.noExisting": "Aucun échantillon existant disponible",
  "collect.assign.title": "Attribution des tests",
  "collect.multiSampleExample.description": "Lorsque plusieurs types d’échantillons sont nécessaires",
  "collect.multiSampleExample.result": "Crée des tubes séparés pour chaque type",
  "collect.multiSampleExample.title": "Exemple de collecte multi-échantillons ",
  "collect.noSampleYet": "Aucun échantillon collecté pour le moment",
  "collect.noCompatibleSampleTypes": "Aucun type d'échantillon n'est configuré pour cette analyse dans le catalogue de tests",
  "collect.noTestsOrdered": "Aucune analyse n’a été prescrite",
  "collect.noTestsWarning.subtitle": "Ajoutez des échantillons avec des analyses à l’étape 1 avant de continuer",
  "collect.noTestsWarning.title": "Aucune analyse à prélever",
  "collect.requestedTests.info": "Analyses demandées pour cette prescription",
  "collect.requestedTests.title": "Analyses demandées",
  "collect.sample.assignedTests": "Tests assignés",
  "collect.sample.collectionConditions": "Conditions de prélèvement",
  "collect.sample.collectionConditions.placeholder": "Notez toute condition particulière…",
  "collect.sample.collectionDate": "Date de prélèvement",
  "collect.sample.collectionMethod": "Méthode de prélèvement ",
  "collect.addTests.title": "Ajouter des analyses ou des panels",
  "collect.addTests.helper": "Ajoutez une analyse demandée par le clinicien après la saisie de la demande, ou qui ne devient pertinente qu'une fois l'échantillon en main.",
  "collect.consentRequired.title": "Le consentement éclairé est obligatoire",
  "collect.consentRequired.subtitle": "Ce laboratoire exige que le consentement soit enregistré avant de procéder au prélèvement.",
  "sample.holdingLimit": "Délai de conservation : {limit}",
  "sample.holdingLimit.testBy": "analyser avant {deadline}",
  "env.sample.receivedAtLab": "Reçu au laboratoire",
  "collect.sample.specimenOrigin": "Origine du spécimen",
  "collect.sample.temperature": "Température a l’arrivée de l’échantillons ",
  "collect.sample.temperature.placeholder": "ex. 4 C",
  "collect.sample.collectionDate.helper": "Date à laquelle l’échantillon a été prélevé",
  "collect.sample.collectionTime": "Heure de prélèvement",
  "collect.sample.collector": "Préleveur",
  "collect.sample.header": "Échantillon {number}",
  "collect.sample.labPerformedSampling": "Échantillons effectués en laboratoire",
  "collect.sample.nce.link": "Signaler un événement non conforme",
  "collect.sample.noTests": "Aucune analyse assignée à cet échantillon",
  "collect.sample.printLabels": "Imprimer les étiquettes ",
  "collect.printMoreLabels.helper": "Vous avez prélevé plus que prévu ou il vous faut un autre type d'échantillon ? Utilisez Ajouter un échantillon, puis imprimez ses étiquettes depuis la carte de l'échantillon ou la section Étiquettes.",
  "collect.sample.quantity": "Quantité",
  "collect.sample.receivedAtLab": "Reçu au laboratoire",
  "collect.sample.receivedAtLab.helper": " Vérifier si l’échantillon a été reçu au laboratoire",
  "collect.sample.receivedDate": "Date de réception",
  "collect.sample.receivedTime": "Heure de réception",
  "collect.sample.remove": "Retirer l'échantillon",
  "collect.samples.title": "Échantillons",
  "collect.table.compatibleTypes": "Types d’échantillons compatibles",
  "collect.table.sampleAssignments": "Attribution des échantillons",
  "collect.table.testPanel": "Test / Panel",
  "heading.informedConsent.sectionTitle": "Consentement éclairé",
  "heading.informedConsent.auditRecord": "Historique du consentement",
  "label.informedConsent.consentGiven": "Le patient a fourni un consentement signé",
  "label.informedConsent.formReference": "Numéro de référence du formulaire de consentement",
  "label.informedConsent.recordedBy": "Enregistré par",
  "label.informedConsent.recordedAt": "Enregistré le",
  "label.informedConsent.statusTag": "Consentement enregistré",
  "label.informedConsent.notRecorded": "Non enregistré",
  "placeholder.informedConsent.formReference": "ex. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "ex. Dr Smith",
  "error.informedConsent.formReferenceMaxLength": "La référence du formulaire de consentement doit contenir 100 caractères ou moins",
  "error.informedConsent.formReferenceInvalidChars": "Seules les lettres, chiffres, tirets et espaces sont autorisés",
  "coldstorage.label.dashboard": "Tableau de bord du stockage frigorifique",
  "collection.date": "Date de prélèvement",
  "collector": "Préleveur",
  "collector.label": "Préleveur",
  "column.actions": "Actions",
  "column.name.accept": "Valider",
  "column.name.analyzerResult": "Résultat de l'automate",
  "column.name.currentResult": "Résultat actuel",
  "column.name.ignore": "Ignore",
  "column.name.normalRange": "Valeurs normales ",
  "column.name.notes": "Notes",
  "column.name.pastNotes": "Notes antérieures",
  "column.name.qcDetail": "Détails",
  "column.name.qcStatus": "statut QC",
  "column.name.reject": "Rejeter",
  "column.name.result": "Résultat ",
  "column.name.retest": "Retester",
  "column.name.sampleInfo": "Informations sur l'échantillon",
  "column.name.sampleKind": "Type d'échantillon",
  "column.name.save": "Sauvegarder",
  "column.name.statusPerRegulation": "Statut — Conformément au règlement",
  "column.name.testDate": "Date du test",
  "column.name.testId": "Id du Test",
  "column.name.testName": "Nom du test ",
  "column.name.uncertainty": "U (k = 2)",
  "common.codeGenerator.error.invalidCode": "Le code doit contenir au moins une lettre, un chiffre ou un trait de soulignement.",
  "common.properties.title": "Propriétés communes",
  "configuration.batch.test.reassignment": "Réaffectation et annulation des tests par lot",
  "configuration.method": "Gérer les méthodes",
  "configuration.method.create": "Créer une nouvelle méthode",
  "configuration.testCatalog.tests.explain": "Créer, modifier, renommer, activer les analyses et définir si elles peuvent être demandées, avec leurs intervalles, options de résultat, méthodes et libellés",
  "configuration.testCatalog.panels.explain": "Créer et modifier des panels, leur attribuer des analyses et définir leur ordre d'affichage",
  "configuration.testCatalog.sampleTypes.explain": "Créer et modifier des types d'échantillons, attribuer des analyses et définir leur ordre d'affichage",
  "configuration.testCatalog.labUnits.explain": "Créer et modifier des unités de laboratoire et leur attribuer des analyses",
  "configuration.testCatalog.import.explain": "Charger des analyses, panels, types d'échantillons et unités de laboratoire à partir de fichiers CSV",
  "configuration.testCatalog.methods.explain": "Ajouter des méthodes ; une nouvelle méthode devient active dès qu'une analyse l'utilise",
  "configuration.selectList.add": "Ajouter une liste de sélection des résultats",
  "configuration.selectList.add.alert": "Pour modifier l'orthographe des entrées de la liste de résultats actuelles, utilisez Renommer les options de liste de résultats existantes",
  "configuration.selectList.add.explain": "Utilisez pour créer une liste de sélection des résultats pour les résultats de test",
  "configuration.selectList.rename": "Renommer les options de liste de résultats existantes",
  "configuration.selectList.rename.explain": "Renommer les options de liste de résultats existantes",
  "configuration.test.activate": "Activer/Désactiver les tests",
  "configuration.test.activate.explain": "Utilisez pour activer ou désactiver un test existant.",
  "configuration.test.catalog": "Voir le catalogue des tests",
  "configuration.test.catalog.explain": "Voir le catalogue des tests actuel",
  "configuration.test.orderable": "Activer/désactiver la commandabilité des tests",
  "configuration.test.orderable.explain": "Les tests commandables peuvent être commandés à l'admission. S'ils ne sont pas commandables, ils ne peuvent être commandés qu'en tant que résultat d'un réflexe",
  "configuration.testCatalog.uom.explain": "Lister les unités de mesure et corriger leurs noms, codes et codes UCUM",
  "configuration.uom.title": "Unités de mesure",
  "configuration.uom.explain": "Unités dans lesquelles les résultats numériques sont rendus. Une unité peut aussi être créée lors de la modification d'une analyse.",
  "configuration.uom.add": "Ajouter une unité",
  "configuration.uom.edit": "Modifier l'unité",
  "configuration.uom.empty": "Aucune unité de mesure ne correspond",
  "method.modal.edit.heading": "Modifier la méthode",
  "configuration.method.create.duplicate": "Une méthode portant ce nom existe déjà. Utilisez un autre nom.",
  "configuration.panel.assign": "Attribution des tests",
  "configuration.panel.assign.explain": "Sélectionnez les tests à réaffecter à un autre panneau en cliquant sur le nom du test ; ils sont affichés sous leur panneau actuellement attribué.",
  "configuration.panel.confirmation.explain": "Ce panneau ne sera pas actif tant qu'au moins un test ne lui aura pas été attribué.",
  "configuration.panel.create": "Créer un nouveau panel",
  "configuration.panel.create.duplicate": "Un type de panel existant avec le même nom a été trouvé. Veuillez annuler ou utiliser un nom différent.",
  "configuration.panel.order": "Définir l'ordre des panels",
  "configuration.panel.order.explain": "Triez les panels en cliquant sur un type et en le faisant glisser dans le bon ordre.",
  "configuration.panel.order.explain.limits": "Seuls les panels avec tests assignés peuvent être sélectionnés. Pour les nouveaux panels, veuillez assigner des tests avant de sélectionner.",
  "configuration.sampleType.assign.explain": "Sélectionnez les tests à réaffecter à un type d'échantillon différent en cliquant sur le nom du test ; ils sont affichés sous leur type d'échantillon actuellement attribué.",
  "configuration.sampleType.assign.new.type": "Assigner à un type d'échantillon",
  "configuration.sampleType.confirmation.explain": "Ce type d'échantillon ne sera pas actif tant qu'au moins un test ne lui aura pas été attribué.",
  "configuration.sampleType.create": "Créer un nouveau type d'échantillon",
  "configuration.sampleType.create.duplicate": "Un type d'échantillon de test existant portant le même nom a été trouvé. Veuillez annuler ou utiliser un autre nom.",
  "configuration.sampleType.manage": "Gérer les types d'échantillons",
  "configuration.sampleType.manage.explain": "Utilisez pour créer, définir l'ordre d'affichage ou attribuer des tests aux types d'échantillons",
  "configuration.sampleType.order": "Définir l'ordre des types d'échantillons",
  "configuration.sampleType.order.explain": "Triez les types d'échantillons en cliquant sur un type et en le faisant glisser dans le bon ordre.",
  "configuration.sampleType.order.explain.limits": "Seuls les échantillons avec tests attribués peuvent être sélectionnés. Pour les nouveaux échantillons, veuillez attribuer des tests avant de sélectionner.",
  "configuration.selectList.assign.description": "La nouvelle entrée peut être affectée aux tests ou être enregistrée sans affectation. Sélectionnez un ou plusieurs tests pour l’affectation, puis ajustez l’ordre d’affichage. Si la nouvelle entrée doit être la valeur normale du test sélectionné, cochez la case intitulée « Normal ». Si vous souhaitez que le technicien saisisse du texte avec la sélection du résultat pour qualifier davantage les résultats, cochez la case intitulée « Qualifiable ». Par exemple, si les options correspondent à une liste d’organismes et que la dernière option est « Autre », l’utilisateur pourra saisir un organisme qui ne figure pas dans la liste.",
  "configuration.selectList.assign.header": "Affecter la nouvelle sélection de résultat au test",
  "configuration.selectList.assign.new": "Nouvelle option de liste de sélection",
  "configuration.selectList.confirmChange": "La valeur normale sera modifiée de %oldvalue% à %newvalue%. Voulez-vous vraiment continuer ?",
  "configuration.selectList.description": "Entrez en anglais et en français pour la nouvelle option de sélection. Si vous ne connaissez pas la traduction, le terme saisi sera utilisé pour les deux langues.",
  "configuration.selectList.header": "Créer une nouvelle option de sélection de résultat",
  "configuration.test.management.ocl": "Importation du concept OCL",
  "configuration.test.management.organization": "Organisation des tests",
  "configuration.test.modify.tab.configuration": "Configurer",
  "configuration.test.modify.tab.compliance": "Seuils de conformité",
  "configuration.test.modify.filter.instruction": "Sélectionnez un type d'échantillon ou une section de test pour afficher les tests.",
  "configuration.test.modify.filter.noTestsFound": "Aucun test ne correspond aux critères sélectionnés.",
  "configuration.test.modify.filter.selectToBegin": "Veuillez sélectionner un type d'échantillon ou une section de test pour commencer à consulter les tests.",
  "configuration.testUnit.assign.new.unit": "Assigner à une section de tests",
  "configuration.testUnit.confirmation.explain": "Cette unité de test ne sera pas active tant qu'au moins un test ne lui aura pas été attribué.",
  "configuration.testUnit.create": "Créer une nouvelle unité de test",
  "configuration.testUnit.create.duplicate": "Une unité portant le même nom a été trouvée. Veuillez annuler ou utiliser un autre nom.",
  "configuration.testUnit.order": "Définir l'ordre des unités de test",
  "configuration.testUnit.order.explain": "Triez les unités de laboratoire en cliquant sur une unité et en la faisant glisser dans le bon ordre.",
  "configuration.testUnit.order.explain.limits": "Seules les unités comportant des tests assignés peuvent être sélectionnés. Pour les nouvelles sections, veuillez assigner des tests avant de sélectionner.",
  "heading.sampleType.management": "Éditeur de type d'échantillon",
  "heading.sampleType.subtitle": "Configurez les types d'échantillons, l'ordre d'affichage des tests, les associations de tests et la classification par domaine.",
  "heading.sampleType.editing": "Modification : {name}",
  "label.sampleType.domain": "Échantillon de nom de domaine",
  "label.domain.CLINICAL": "Clinique",
  "label.domain.ENVIRONMENTAL": "Environnemental",
  "label.domain.VECTOR": "Vecteur",
  "label.sampleType.domain.clinical": "Clinique",
  "label.sampleType.domain.environmental": "Environnemental",
  "label.sampleType.domain.helper": "Détermine dans quel mode de plan de travail (clinique ou environnemental) ce type d'échantillon apparaît.",
  "label.sampleType.filterDomain": "Filtrer par domaine",
  "label.sampleType.testCount": "Analyses",
  "label.sampleType.actions": "Actions",
  "label.sampleType.status": "Statut",
  "placeholder.sampleType.search": "Rechercher des types d'échantillons...",
  "placeholder.sampleType.filter.domain": "Tous les domaines",
  "button.sampleType.add": "Ajouter un type d’échantillon",
  "configuration.uom.create": "Créer de nouvelles unités de mesure",
  "configure.labNumber.title": "Gestion des Numéro de Laboratoire",
  "confirmation.rename": "Confirmez les modifications ci-dessus que vous avez apportées.",
  "currentests.title": "Essais en cours",
  "cytology.label.cellabnomality": "Anomalie des Cellules Épithéliales",
  "cytology.label.confirmSelect": "Si vous sélectionnez cette option, toutes les informations de diagnostic actuelles seront supprimées",
  "cytology.label.dashboard": "Tableau de bord en cytologie",
  "cytology.label.glandular": "Glandulaire",
  "cytology.label.negative": "Négatif Pour Lésion ou Malignité Intraépithéliale",
  "cytology.label.neoplastic": "Variations Cellulaires Non Néoplasiques",
  "cytology.label.organisms": "Organismes",
  "cytology.label.other": "Autres Néoplasmes Malins",
  "cytology.label.otherResult": "Autre Résultat de Diagnostic",
  "cytology.label.reactive": "Modifications Cellulaires Réactives",
  "cytology.label.review": "En attente de révision cytopathologique",
  "cytology.label.specimen": "Aptitude de l'Échantillon",
  "cytology.label.squamous": "Épidermoïde",
  "cytology.label.title": "Cytologie",
  "cytology.status.completed": "Terminé",
  "cytology.status.preparingSlides": "Préparation des lames",
  "cytology.status.readyForCytopathologist": "Prêt pour le cytopathologiste",
  "cytology.status.screening": "Dépistage",
  "dashboard.avg.turn.around.label": "Temps de traitement moyen",
  "dashboard.avg.turn.around.reception.to.result.label": "Délai moyen de réception à résultat",
  "dashboard.avg.turn.around.reception.to.validation.label": "Délai moyen de réception à validation",
  "dashboard.avg.turn.around.result.to.validation.label": "Délai moyen de résultat à validation",
  "dashboard.avg.turn.around.subtitle.label": "Délai moyen de réception à validation",
  "dashboard.complete.orders.label": "Demandes d'examens terminées aujourd'hui",
  "dashboard.in.progress.label": "En cours",
  "dashboard.in.progress.subtitle.label": "En attente de saisie des résultats",
  "dashboard.metrics.loadFailed": "Impossible de charger les compteurs du tableau de bord.",
  "dashboard.partially.completed.label": "Partiellement complété aujourd'hui",
  "dashboard.partially.completed.subtitle.label": "En attente des analyses restantes",
  "dashboard.rejected.orders": "Ordonnances rejetées",
  "dashboard.turn.around.label": "Délai d'exécution retardé",
  "dashboard.turn.around.subtitle.label": "Dépassement de 96 heures",
  "dashboard.unprints.results.label": "Résultats non imprimés",
  "dashboard.user.orders.label": "Ordonnances saisies par l'utilisateur",
  "dashboard.user.orders.today.label": "Ordonnances saisies par l'utilisateur aujourd'hui",
  "dashboard.user.ordersEntered": "Demandes saisies",
  "dashboard.validation.ready.label": "Prêt pour la validation",
  "dashboard.validation.ready.subtitle.label": "En attente de validation",
  "dataexport.status.actions": "Actions",
  "dataexport.status.attempt.duration": "Durée",
  "dataexport.status.attempt.endTime": "Heure de fin",
  "dataexport.status.attempt.startTime": "Heure de début",
  "dataexport.status.attempt.status": "Statut",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "Non, aucun abonné FHIR n'est configuré. Définissez le paramètre « org.openelisglobal.fhir.subscriber » dans les Propriétés communes, puis redémarrez le serveur pour en enregistrer un.",
  "dataexport.status.endpoint": "Point d'extrémité",
  "dataexport.status.failed24h": "Echec / Total (24 h)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Intervalle entre les tentatives",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Dernière tentative",
  "dataexport.status.lastRefreshed": "Dernière actualisation",
  "dataexport.status.lastStatus": "Dernier statut",
  "dataexport.status.lastSuccess": "Dernier succès",
  "dataexport.status.loadingAttempts": "Chargement de l'historique des tentatives…",
  "dataexport.status.never": "Jamais",
  "dataexport.status.noAttempts": "Non de tentatives pour l'instant",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Actualiser",
  "dataexport.status.retry": "Réessayez maintenant",
  "dataexport.status.retryInFlight": "Déclencheur…",
  "dataexport.status.title": "Statut de l'exportation des données FHIR",
  "datasubmission.siteid": "ID du Site",
  "database.clean": "Nettoyage de la base de données",
  "database.clean.button": "Nettoyer la base de données",
  "database.clean.confirm.message": "Êtes-vous sûr de vouloir nettoyer la base de données ? Cela supprimera toutes les données des patients et des analyses.",
  "database.clean.confirm.title": "Confirmer le nettoyage de la base de données",
  "database.clean.confirm.warning": " Cette action est irréversible !",
  "database.clean.error": "Échec du nettoyage de la base de données.",
  "database.clean.not.training": "Le nettoyage de la base de données est uniquement disponible sur les environnements de formation. ",
  "database.clean.success": " Base de données nettoyée avec succès.",
  "database.clean.warning": "Cela supprimera définitivement toutes les données des patients, des échantillons et des résultats de la base de données.",
  "date.created": "Date de création",
  "datepicker.future.notAllowed": "La date ne peut pas être dans le futur.",
  "datepicker.past.notAllowed": "La date ne peut pas être dans le passé.",
  "datepicker.placeholder.dmy": "jj/mm/aaaa",
  "datepicker.placeholder.mdy": "mm/jj/aaaa",
  "delete.error.msg": "Erreur lors de la suppression",
  "delete.success.msg": "Supprimé avec succès",
  "description.active": "Si le test est actif, il peut être commandé sur le formulaire de commande ou dans le cadre d'un algorithme de test. S'il n'est pas actif, il ne peut pas être commandé ni faire partie d'un algorithme de test.",
  "description.ageRange": "Si la tranche d'âge (en mois) importe pour les valeurs données, elle sera spécifiée ici.",
  "description.name": "Le nom du test tel qu'il apparaîtra dans openELIS. Les versions anglaise et française sont affichées.",
  "description.normalRange": "Tout résultat numérique dans cette plage est ce qui est attendu chez une personne en bonne santé.",
  "description.note": "n/a signifie non disponible. La valeur n'est pas spécifiée.",
  "description.orderable": "Si un test est actif et sélectionnable, il peut être sélectionné via un bulletin d'analyse. S'il est actif mais non sélectionnable, il ne sera actif que s'il est lié à un autre test.",
  "description.panel": "Si ce test fait partie d'un panel de tests, le panel sera nommé ici.",
  "description.referenceValue": "La valeur d'une sélection pour une personne en bonne santé. Donnée uniquement pour les résultats de liste de sélection.",
  "description.reportName": "Le nom du test tel qu'il apparaîtra dans les rapports. Les versions anglaise et française sont affichées.",
  "description.resultLimits": "Les limites des résultats normaux et valides pour les tests numériques. Les valeurs peuvent dépendre à la fois de l'âge et du sexe du patient.",
  "description.resultType": "Le type de résultat pour ce test :",
  "description.resultType.alphanumeric": "A - Alphanumérique :",
  "description.resultType.alphanumericDesc": "Accepte des résultats numériques ou textuels dans une zone de texte. Ils ne seront pas évalués pour être normaux ou valides.",
  "description.resultType.cascadingMultiSelectList": "C - Liste de sélection multiple en cascade :",
  "description.resultType.cascadingMultiSelectListDesc": "Similaire à la sélection multiple mais l'utilisateur pourra sélectionner plusieurs groupes dans la liste déroulante.",
  "description.resultType.kind": "Le type de résultat pour ce test :",
  "description.resultType.multiSelectList": "M - Liste de sélection multiple :",
  "description.resultType.multiSelectListDesc": "L'utilisateur pourra sélectionner une ou plusieurs valeurs dans une liste déroulante. Aucune valeur de référence ne sera spécifiée.",
  "description.resultType.numeric": "N - Numérique :",
  "description.resultType.numericDesc": "Accepte uniquement des résultats numériques dans une zone de texte. Les résultats peuvent être évalués comme étant dans une plage normale ou valide.",
  "description.resultType.selectList": "D - Liste de sélection :",
  "description.resultType.selectListDesc": "L'utilisateur pourra sélectionner dans une liste déroulante. La valeur normale sera spécifiée comme valeur de référence.",
  "description.resultType.textArea": " :",
  "description.resultType.textAreaDesc": "Accepte jusqu'à 200 caractères dans une zone de texte. Ils ne seront pas évalués pour être normaux ou valides.",
  "description.sampleType": "Le type d'échantillon sur lequel le test peut être effectué. Si le technicien d'accueil peut sélectionner le type d'échantillon après avoir commandé le test, il sera marqué comme utilisateur pour indiquer que l'utilisateur sélectionnera le type.",
  "description.selectValues": "Spécifié uniquement pour les résultats de sélection, de sélection multiple ou de sélection multiple en cascade. Ce sont les sélections disponibles affichées à l'utilisateur. Si la sélection est marquée comme 'qualifiable', lorsque l'utilisateur sélectionne cette valeur, il pourra saisir des informations supplémentaires dans une zone de texte.",
  "description.sex": "Si le sexe du patient importe pour les valeurs données, il sera spécifié ici.",
  "description.significantDigits": "Le nombre de chiffres significatifs pour les résultats numériques. Les résultats saisis seront arrondis ou complétés au nombre correct de chiffres. La plage normale sera également affichée avec le nombre correct de chiffres significatifs.",
  "description.testUnit": "L'unité du laboratoire qui effectue le test. Elle est également connue sous le nom de section de test.",
  "description.uom": "Unité de mesure pour le test. Cela s'applique généralement aux types de résultats numériques ou alphanumériques.",
  "description.validRange": "Tout résultat numérique hors de cette plage indique que le test peut ne pas avoir été effectué correctement.",
  "dictionary.category.isActive": "La catégorie est active",
  "dictionary.category.label": "Catégorie du dictionnaire",
  "dictionary.category.localAbbreviation": "Abréviation locale de la catégorie",
  "dictionary.category.name": "Catégorie",
  "dictionary.dictEntry": "Entrée du dictionnaire",
  "dictionary.label.modify": "Modifier le dictionnaire",
  "dictionary.loincCode": "Code LOINC",
  "dictionary.loincCode.help": "Saisir un identifiant LOINC Standard",
  "dictionary.loincCode.helpText": "Identifiant standard d'observation de laboratoire",
  "dictionary.loincCode.invalid": "Format incorrect de code LOINC ( attendu:12345-6 ou LP12345-6)",
  "dictionary.loincCode.placeholder": "exemple: 12345-6",
  "dictionary.menu.deactivate.fail": "Impossible de désactiver le menu du dictionnaire",
  "dictionary.menu.deactivate.success": "Menu de dictionnaire désactivé avec succès",
  "dictionary.modal.add.heading": "Ajouter au dictionnaire ",
  "dictionary.modal.edit.heading": "Modifier le dictionnaire ",
  "dictionary.number.label": "Numéro du dictionnaire",
  "disposal.button": "Disposer des lots ",
  "disposal.notes": "Notes relatives à l'élimination",
  "disposal.notes.placeholder": "Fournir des détails sur l'élimination (méthode d'élimination, témoin, etc.)",
  "disposal.reason": "Motif de mise au rebut",
  "disposal.reason.select": "Sélectionnez une raison",
  "disposal.success": "Lot éliminé avec succès",
  "disposal.title": "Disposer des lots ",
  "disposal.warning.message": "Cette action ne peut pas être annulée. Le lot sera considéré comme éliminé et retiré de l’inventaire actif.",
  "disposal.warning.title": "Avertissement",
  "emergencyContactInfo.title": "Informations de contact d'urgence",
  "english.current": "ANGLAIS actuel",
  "english.label": "Français",
  "enterText.label": "Entrez le reste du texte",
  "eorder.allInfo": "Toutes les infos",
  "eorder.button.editOrder": "Modifier l'échantillon",
  "eorder.button.enterOrder": "Saisir la demande d’examen",
  "eorder.buttons": " ",
  "eorder.date.end": "Date de fin",
  "eorder.date.start": "Date de début",
  "eorder.facility.requesting": "Établissement Référent",
  "eorder.header": "Voir les Demandes Electroniques",
  "eorder.id.national": "Identité nationale",
  "eorder.id.subjectNumber": "Numéro Patient",
  "eorder.instructions.enter1": "Recherche de correspondance des demandes de test - Dans le menu de ",
  "eorder.instructions.enter2": " ajoutez un numéro de laboratoire et sélectionnez ",
  "eorder.instructions.enter3": " pour accepter l'ordonnance telle quelle, ou sélectionnez ",
  "eorder.instructions.enter4": " pour apporter des modifications ",
  "eorder.labNumber": "Numéro laboratoire",
  "eorder.labnumber.referring": "Numéro du Laboratoire Référent",
  "eorder.name.first": "Prénom",
  "eorder.name.last": "Nom",
  "eorder.passport.number": "Numéro de passeport",
  "eorder.priority": "Priorité",
  "eorder.requestDate": "Date de demande",
  "eorder.search.noresults": "Pas de Demandes Électronique",
  "eorder.search1.text": "Recherche par nom de famille, numéro de carte d'identité nationale, numéro de laboratoire du laboratoire référent ou numéro de passeport",
  "eorder.search2.text": "Recherche par date et statut Saisissez la plage de dates pour les demandes de test. Cela permettra d'effectuer une recherche en fonction de la date de renvoi ou de la date de commande de la demande électronique",
  "eorder.searchValue": "Rechercher par",
  "eorder.status": "Statut",
  "eorder.test.name": "Nom du test ",
  "eqa.action.deactivate": "Désactiver",
  "eqa.action.edit": "Modifier",
  "eqa.action.enterResults": "Saisir les résultats",
  "eqa.action.enterViewResults": "Saisir / consulter les résultats ",
  "eqa.action.reactivate": "Réactiver",
  "eqa.action.viewOrder": "Voir la commande",
  "eqa.action.viewResults": "Voir les résultats",
  "eqa.admin.addProgram": "Ajouter un programme",
  "eqa.admin.col.actions": "Actions",
  "eqa.admin.col.category": "Catégorie",
  "eqa.admin.col.frequency": "Fréquence",
  "eqa.admin.col.participants": "Participants inscrits",
  "eqa.admin.col.programName": "Nom du programme",
  "eqa.admin.col.provider": "Page du prestataire",
  "eqa.admin.delete": "Supprimer",
  "eqa.admin.form.addHeading": "Ajouter un nouveau programme EQA",
  "eqa.admin.form.category.placeholder": "Sélectionner la catégorie",
  "eqa.admin.form.description.placeholder": "Description et objectifs du programme...",
  "eqa.admin.form.editHeading": "Modifier le programme EQE",
  "eqa.admin.form.frequency.placeholder": "Sélectionner la fréquence",
  "eqa.admin.form.name.placeholder": "ex. : Culture et sensibilité TB",
  "eqa.admin.form.provider.placeholder": "Sélectionner le prestataire",
  "eqa.admin.form.subtitle": "Inscrire à un nouveau programme d'assurance qualité externe",
  "eqa.admin.programs.subtitle": "Gérer les programmes EEQ inscrits et les prestataires",
  "eqa.admin.programs.title": "Programmes EEQ",
  "eqa.admin.provider.placeholder": "ex. : OMS, CDC, CAP",
  "eqa.admin.subtitle": "Gérer les programmes EQA, les utilisateurs et les paramètres système",
  "eqa.admin.tab.participants": "Participants",
  "eqa.admin.tab.userManagement": "Gestion des utilisateurs",
  "eqa.admin.tile.acrossAllPrograms": "Dans tous les programmes",
  "eqa.admin.tile.activePrograms": "Programmes actifs",
  "eqa.admin.tile.canManageEqa": "Peuvent gérer l'EQA",
  "eqa.admin.tile.enrolledParticipants": "Participants inscrits",
  "eqa.admin.tile.systemUsers": "Utilisateurs système",
  "eqa.admin.tile.totalParticipants": "Total des participants",
  "eqa.admin.tile.totalPrograms": "{count} programmes au total",
  "eqa.admin.title": "Administration des programmes",
  "eqa.admin.userManagement.placeholder": "Gestion des utilisateurs bientôt disponible.",
  "eqa.column.actions": "Actions",
  "eqa.deadline.label": "Date limite de test",
  "eqa.distribution.action.continue": "Continuer",
  "eqa.distribution.action.ship": "Expédier",
  "eqa.distribution.action.track": "Suivre",
  "eqa.distribution.action.viewReport": "Voir le rapport",
  "eqa.distribution.advance": "Avancer le statut",
  "eqa.distribution.backToDashboard": "Retour aux distributions",
  "eqa.distribution.barcodes": "Générer les codes-barres",
  "eqa.distribution.col.actions": "Actions",
  "eqa.distribution.col.deadline": "Date limite",
  "eqa.distribution.col.participants": "Participants",
  "eqa.distribution.col.program": "Programme",
  "eqa.distribution.col.responses": "Réponses",
  "eqa.distribution.col.round": "Ronde",
  "eqa.distribution.col.samples": "Échantillons",
  "eqa.distribution.col.shipmentId": "ID d'envoi",
  "eqa.distribution.col.status": "Statut",
  "eqa.distribution.create": "Créer une distribution",
  "eqa.distribution.createError": "Échec de la création de la distribution.",
  "eqa.distribution.createShipment": "Créer un nouvel envoi",
  "eqa.distribution.createSuccess": "Distribution créée avec succès.",
  "eqa.distribution.dashboard.subtitle": "Distribuer les échantillons EQA aux laboratoires participants",
  "eqa.distribution.dashboard.title": "Distribution EQA",
  "eqa.distribution.deadline": "Date limite de soumission",
  "eqa.distribution.detail.title": "Détails de la distribution",
  "eqa.distribution.empty": "Aucune distribution trouvée",
  "eqa.distribution.filter.allShipments": "Tous les envois",
  "eqa.distribution.filter.program": "Filtrer par programme",
  "eqa.distribution.filter.status": "Filtrer par statut",
  "eqa.distribution.list.title": "Distributions d’EEQ",
  "eqa.distribution.manageParticipants": "Gérer les participants",
  "eqa.distribution.name": "Nom de la distribution",
  "eqa.distribution.name.placeholder": "ex., Ronde 1 - Chimie 2026",
  "eqa.distribution.network.active": "Participants actifs",
  "eqa.distribution.network.active.sub": "Actuellement inscrits",
  "eqa.distribution.network.responseRate": "Taux de réponse moyen",
  "eqa.distribution.network.responseRate.sub": "4 derniers trimestres",
  "eqa.distribution.network.subtitle": "Aperçu des laboratoires participants inscrits",
  "eqa.distribution.network.title": "Réseau de participants",
  "eqa.distribution.network.total": "Total des participants",
  "eqa.distribution.network.total.sub": "Dans tous les pays",
  "eqa.distribution.participants": "Organisations participantes",
  "eqa.distribution.participants.min": "Au moins 2 organisations participantes sont requises",
  "eqa.distribution.participants.none": "Aucune organisation n’est actuellement inscrite au programme sélectionné. Inscrivez des participants avant de créer une distribution. ",
  "eqa.distribution.participants.select": "Sélectionner les organisations",
  "eqa.distribution.program": "Programme EQE",
  "eqa.distribution.program.select": "Sélectionner un programme",
  "eqa.distribution.responseRate": "taux de réponse",
  "eqa.distribution.shipments.subtitle": "Suivre les échantillons EQA distribués et les réponses des participants",
  "eqa.distribution.shipments.title": "Envois EQA",
  "eqa.distribution.shipped": "Expédiés",
  "eqa.distribution.status.completed": "Terminé",
  "eqa.distribution.status.draft": "Brouillon",
  "eqa.distribution.status.prepared": "Préparé",
  "eqa.distribution.status.shipped": "Expédiés",
  "eqa.distribution.step.confirmation": "Confirmation",
  "eqa.distribution.step.details": "Programme et détails",
  "eqa.distribution.step.participants": "Participants",
  "eqa.distribution.summary.completed": "Terminé",
  "eqa.distribution.summary.completed.sub": "Toutes les réponses reçues",
  "eqa.distribution.summary.draft": "Envois brouillon",
  "eqa.distribution.summary.draft.sub": "En préparation",
  "eqa.distribution.summary.participants": "Participants",
  "eqa.distribution.summary.participants.sub": "Inscrits",
  "eqa.distribution.summary.shipped": "Expédiés",
  "eqa.distribution.summary.shipped.sub": "En attente de réponses",
  "eqa.enrollment.allStatuses": "Tous les statuts",
  "eqa.enrollment.alreadyEnrolled": "Déjà inscrit",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organisation(s) déjà inscrite(s)",
  "eqa.enrollment.confirmWithdraw": "Confirmer le retrait",
  "eqa.enrollment.created.success": "Inscription au programme créée avec succès",
  "eqa.enrollment.deactivated": "Inscription au programme désactivée",
  "eqa.enrollment.description": "Description",
  "eqa.enrollment.district": "District",
  "eqa.enrollment.editing": "Modification : {name}",
  "eqa.enrollment.empty": "Aucune inscription trouvée pour ce programme",
  "eqa.enrollment.enroll": "Inscrire",
  "eqa.enrollment.enrollParticipant": "Inscrire un participant",
  "eqa.enrollment.enrollSelected": "Inscrire la sélection",
  "eqa.enrollment.enrollmentDate": "Date d'inscription",
  "eqa.enrollment.error": "L'inscription n'a pas été enregistrée. Réessayez.",
  "eqa.enrollment.labUnits": "Unités de laboratoire",
  "eqa.enrollment.new": "Nouvelle inscription au programme EQA",
  "eqa.enrollment.organizationCode": "Code de l'organisation",
  "eqa.enrollment.organizationName": "Nom de l'organisation",
  "eqa.enrollment.panels": "Panels",
  "eqa.enrollment.programName": "Nom du programme",
  "eqa.enrollment.programName.placeholder": "Saisir le nom du programme",
  "eqa.enrollment.provider": "Page du prestataire",
  "eqa.enrollment.provider.placeholder": "Saisir le nom du prestataire",
  "eqa.enrollment.reactivate": "Réactiver",
  "eqa.enrollment.reactivated": "Inscription au programme réactivée",
  "eqa.enrollment.save": "Enregistrer l'inscription",
  "eqa.enrollment.saveChanges": "Save Changes",
  "eqa.enrollment.searchOrgs": "Rechercher des organisations...",
  "eqa.enrollment.searchPlaceholder": "Rechercher par nom ou code d'organisation...",
  "eqa.enrollment.selectLabUnits": "Sélectionner les unités de laboratoire...",
  "eqa.enrollment.selectOrg": "Sélectionner une organisation…",
  "eqa.enrollment.selectOrgsPrompt": "Sélectionnez les organisations à inscrire",
  "eqa.enrollment.selectPanels": "Sélectionner les panels...",
  "eqa.enrollment.selectProgram": "Sélectionner le programme",
  "eqa.enrollment.selectProgramPrompt": "Sélectionnez un programme pour voir les inscriptions",
  "eqa.enrollment.selectTests": "Sélectionner les tests...",
  "eqa.enrollment.selected": "sélectionné(s)",
  "eqa.enrollment.status": "Statut",
  "eqa.enrollment.status.active": "Active",
  "eqa.enrollment.status.suspended": "Suspendu",
  "eqa.enrollment.status.withdrawn": "Retiré",
  "eqa.enrollment.success": "Inscription réussie",
  "eqa.enrollment.suspend": "Suspendre",
  "eqa.enrollment.tests": "Analyses",
  "eqa.enrollment.thisLab": "Ce laboratoire",
  "eqa.enrollment.updated.success": "Inscription au programme mise à jour avec succès",
  "eqa.enrollment.withdraw": "Retirer",
  "eqa.enrollment.withdrawReason": "Raison du retrait",
  "eqa.enrollment.withdrawReasonPlaceholder": "Indiquez la raison du retrait de ce participant...",
  "eqa.filter.allPriorities": "Toutes les priorités",
  "eqa.filter.allPrograms": "Tous les programmes",
  "eqa.filter.allStatuses": "Tous les statuts",
  "eqa.filter.eqaOnly": "Échantillons EQA uniquement",
  "eqa.filter.priority": "Priorité",
  "eqa.filter.program": "Programme",
  "eqa.filter.status": "Statut",
  "eqa.management.action.enterResults": "Saisir les résultats",
  "eqa.management.action.submit": "Soumettre",
  "eqa.management.bulkUpload": "Téléchargement en masse des résultats",
  "eqa.management.col.accession": "N° d'accession",
  "eqa.management.col.actions": "Actions",
  "eqa.management.col.deadline": "Date limite",
  "eqa.management.col.progress": "Progrès",
  "eqa.management.col.provider": "Prestataire/Programme",
  "eqa.management.col.sampleId": "ID d'échantillon",
  "eqa.management.col.status": "Statut",
  "eqa.management.daysLeft": "jours restants",
  "eqa.management.distributions.title": "Distributions",
  "eqa.management.filter.allSamples": "Tous les échantillons",
  "eqa.management.overdue": "En retard ",
  "eqa.management.participants.subtitle": "Gérer l'inscription des organisations aux programmes EQE",
  "eqa.management.participants.title": "Participants",
  "eqa.management.performance.onTime": "Soumission à temps",
  "eqa.management.performance.participation": "Taux de participation",
  "eqa.management.performance.participation.sub": "Tous les programmes inscrits",
  "eqa.management.performance.subtitle": "Métriques de performance EQA de votre laboratoire",
  "eqa.management.performance.title": "Résumé de performance",
  "eqa.management.performance.zScore": "Score Z moyen",
  "eqa.management.performance.zScore.sub": "Dans la plage acceptable",
  "eqa.management.programs.subtitle": "Gérer les programmes distribués par ce laboratoire",
  "eqa.management.programs.title": "Programmes EEQ",
  "eqa.management.results.title": "Résultats et analyse",
  "eqa.management.samples.empty": "Aucun échantillon EQA trouvé",
  "eqa.management.samples.subtitle": "Gérer les échantillons EQA reçus et soumettre les résultats",
  "eqa.management.samples.title": "Échantillons EQA",
  "eqa.management.status.completed": "Terminé",
  "eqa.management.status.completed.sub": "Prêt à soumettre",
  "eqa.management.status.inProgress": "En cours",
  "eqa.management.status.inProgress.sub": "Tests en cours",
  "eqa.management.status.in_progress": "En cours",
  "eqa.management.status.overdue": "En retard ",
  "eqa.management.status.pending": "En attente",
  "eqa.management.status.pending.sub": "Non commencé",
  "eqa.management.status.submitted": "Soumis",
  "eqa.management.status.submitted.sub": "Résultats envoyés",
  "eqa.management.subtitle": "Recevoir et gérer les échantillons EEQ des prestataires externes",
  "eqa.management.title": "Gestion EQA",
  "eqa.management.viewPerformance": "Voir la performance",
  "eqa.myProgram.helperText": "Sélectionner une inscription pré-remplit les tests et panels",
  "eqa.myProgram.label": "Mon inscription au programme",
  "eqa.myProgram.prePopulated.subtitle": "{tests} tests et {panels} panels pré-sélectionnés à partir de l'inscription",
  "eqa.myProgram.prePopulated.title": "Tests/panels pré-remplis",
  "eqa.myProgram.select": "Sélectionner une inscription pour pré-remplir les tests...",
  "eqa.myPrograms.action.deactivate": "Désactiver",
  "eqa.myPrograms.action.edit": "Modifier",
  "eqa.myPrograms.action.reactivate": "Réactiver",
  "eqa.myPrograms.description": "Description",
  "eqa.myPrograms.enrollButton": "S'inscrire à un programme",
  "eqa.myPrograms.enrollInProgram": "S'inscrire à un programme",
  "eqa.myPrograms.labUnits": "Unité(s) de laboratoire",
  "eqa.myPrograms.panels": "Panels",
  "eqa.myPrograms.programName": "Nom du programme",
  "eqa.myPrograms.provider": "Page du prestataire",
  "eqa.myPrograms.search.placeholder": "Rechercher des programmes...",
  "eqa.myPrograms.status": "Statut",
  "eqa.myPrograms.status.active": "Active",
  "eqa.myPrograms.status.inactive": "Inactif",
  "eqa.myPrograms.subtitle": "Programmes auxquels ce laboratoire participe",
  "eqa.myPrograms.testMapping": "Correspondance des tests (facultatif)",
  "eqa.myPrograms.testMappingHint": "Sélectionnez les tests et panels pour pré-remplir la saisie de commande lorsque ce programme est sélectionné",
  "eqa.myPrograms.tests": "Analyses",
  "eqa.myPrograms.title": "Mes programmes EQE",
  "eqa.order.deadline": "Date limite de résultat",
  "eqa.order.form.title": "Informations sur l'échantillon EQA",
  "eqa.order.participantId": "ID du participant",
  "eqa.order.priority": "Priorité EQA",
  "eqa.order.programme": "Programme",
  "eqa.order.provider": "Page du prestataire",
  "eqa.order.providerSampleId": "ID d'échantillon du prestataire",
  "eqa.orders.completedThisMonth": "Terminés ce mois-ci",
  "eqa.orders.enterNewTest": "Saisir un nouveau test EQA",
  "eqa.orders.inProgress": "En cours",
  "eqa.orders.overdue": "En retard ",
  "eqa.orders.pending": "En attente",
  "eqa.orders.search.placeholder": "Rechercher par numéro de laboratoire ou programme...",
  "eqa.participant.id": "ID du participant",
  "eqa.priority.critical": "Critique",
  "eqa.priority.label": "Priorité",
  "eqa.priority.standard": "Standard",
  "eqa.priority.urgent": "Urgence",
  "eqa.program.activate": "Activer",
  "eqa.program.active": "Active",
  "eqa.program.addProgram": "Ajouter un programme",
  "eqa.program.cancel": "Annuler",
  "eqa.program.create": "Créer un programme",
  "eqa.program.createTitle": "Créer un programme EQE",
  "eqa.program.deactivate": "Désactiver",
  "eqa.program.description": "Description",
  "eqa.program.description.placeholder": "Décrivez le programme EQA...",
  "eqa.program.edit": "Modifier le programme",
  "eqa.program.editTitle": "Modifier le programme EQE",
  "eqa.program.empty": "Aucun programme EQA trouvé",
  "eqa.program.inactive": "Inactif",
  "eqa.program.label": "Programme EQE",
  "eqa.program.management.title": "Gestion des programmes d’EEQ",
  "eqa.program.name": "Nom du programme",
  "eqa.program.name.placeholder": "ex. : Tests de compétence en chimie",
  "eqa.program.name.required": "Le nom du programme est requis",
  "eqa.program.provider.required": "Le prestataire est requis ",
  "eqa.program.participantCount": "Participants inscrits",
  "eqa.program.provider": "Page du prestataire",
  "eqa.program.required": "Le programme EQA est obligatoire lors de l'enregistrement d'un échantillon EQA",
  "eqa.program.save": "Enregistrer le programme",
  "eqa.program.select": "Sélectionner le programme EQA",
  "eqa.program.status": "Statut",
  "eqa.program.tests": "Tests assignés",
  "eqa.program.tests.assign": "Assigner des tests",
  "eqa.program.tests.select": "Sélectionner les tests à assigner",
  "eqa.provider.label": "Organisation prestataire EEQ",
  "eqa.provider.sampleId": "ID d'échantillon du prestataire",
  "eqa.provider.select": "Sélectionner le prestataire EEQ",
  "eqa.results.acceptable": "Acceptable",
  "eqa.results.batch.import": "Importation par lot",
  "eqa.results.col.deadline": "Date limite",
  "eqa.results.col.labNumber": "Numéro laboratoire",
  "eqa.results.col.priority": "Priorité",
  "eqa.results.col.programme": "Programme",
  "eqa.results.col.provider": "Page du prestataire",
  "eqa.results.col.status": "Statut",
  "eqa.results.import.confirm": "Confirmer l'importation",
  "eqa.results.import.errors": "{count} lignes contiennent des erreurs",
  "eqa.results.import.success": "{count} résultats importés avec succès",
  "eqa.results.import.upload": "Télécharger le fichier CSV",
  "eqa.results.manual.entry": "Saisie manuelle des résultats",
  "eqa.results.mean": "Moyenne",
  "eqa.results.minimum.participants": "Minimum 5 participants requis pour l'analyse statistique",
  "eqa.results.noResults": " Aucun résultat d’EEQ trouvé.",
  "eqa.results.organization": "Organisation",
  "eqa.results.organization.select": "Sélectionner l'organisation",
  "eqa.results.participant.count": "Nombre de participants",
  "eqa.results.performance": "Performance",
  "eqa.results.questionable": "Discutable",
  "eqa.results.report.downloading": "Téléchargement du rapport...",
  "eqa.results.report.generate": "Générer le rapport",
  "eqa.results.search.placeholder": "Rechercher par numéro laboratoire, programme ou prestataire…",
  "eqa.results.standardDeviation": "Écart-type",
  "eqa.results.statistics": "Statistiques",
  "eqa.results.submit": "Soumettre le résultat",
  "eqa.results.test": "Test",
  "eqa.results.test.select": "Sélectionner le test",
  "eqa.results.title": "Résultats et analyse de l’EEQ",
  "eqa.results.unacceptable": "Inacceptable",
  "eqa.results.value": "Valeur du résultat",
  "eqa.results.zscore": "Score Z",
  "eqa.sample.badge": "EEQ",
  "eqa.sample.checkbox": "Échantillon EQA",
  "eqa.sample.checkbox.helper": "Cochez si c'est un échantillon d'Assurance Qualité Externe",
  "eqa.sample.demographics.disabled": "Données démographiques désactivées pour les échantillons EQA",
  "eqa.sample.patient.readonly.body": "Les champs démographiques du patient sont automatiquement définis sur N/A pour les échantillons EQA et ne peuvent pas être modifiés.",
  "eqa.sample.patient.readonly.title": "Échantillon EQA — Infos patient verrouillées",
  "eqa.section.title": "Détails de l'échantillon EQA",
  "eqa.status.active": "Active",
  "eqa.status.completed": "Terminé",
  "eqa.status.inProgress": "En cours",
  "eqa.status.inactive": "Inactif",
  "eqa.status.inprogress": "En cours",
  "eqa.status.overdue": "En retard ",
  "eqa.status.pending": "En attente",
  "eqa.submission.audit": "Piste d'audit de soumission",
  "eqa.submission.date": "Date de soumission",
  "eqa.submission.error": "La soumission a échoué",
  "eqa.submission.fhir": "Soumettre via FHIR",
  "eqa.submission.fhir.description": "Soumettre les résultats au prestataire EEQ externe via FHIR R4",
  "eqa.submission.late.approve": "Approuver la soumission tardive",
  "eqa.submission.late.justification": "Justification de la soumission tardive",
  "eqa.submission.late.justification.placeholder": "Indiquez la raison de la soumission tardive...",
  "eqa.submission.late.supervisor": "ID utilisateur du superviseur",
  "eqa.submission.late.warning": "La date limite de soumission est dépassée. L'approbation du superviseur est requise.",
  "eqa.submission.method": "Méthode de soumission",
  "eqa.submission.success": "Résultats soumis avec succès",
  "eqa.submission.title": "Soumission des résultats",
  "eqa.tests.action.enterResults": "Saisir les résultats",
  "eqa.tests.action.viewOrder": "Voir la commande",
  "eqa.tests.action.viewResults": "Voir les résultats",
  "eqa.tests.dateEntered": "Date de saisie",
  "eqa.tests.deadline": "Date limite",
  "eqa.tests.enterNew": "Saisir un nouveau test EQA",
  "eqa.tests.labNumber": "Numéro laboratoire",
  "eqa.tests.orders.subtitle": "Commandes de tests de compétence pour ce laboratoire",
  "eqa.tests.orders.title": "Commandes EQE",
  "eqa.tests.priority": "Priorité",
  "eqa.tests.program": "Programme EQE",
  "eqa.tests.provider": "Page du prestataire",
  "eqa.tests.searchPlaceholder": "Rechercher par n° d'accession, programme ou prestataire...",
  "eqa.tests.status": "Statut",
  "eqa.tests.status.completed": "Terminé",
  "eqa.tests.status.inProgress": "En cours",
  "eqa.tests.status.overdue": "En retard ",
  "eqa.tests.status.pending": "En attente",
  "eqa.tests.summary.completedThisMonth": "Terminés ce mois-ci",
  "eqa.tests.summary.inProgress": "En cours",
  "eqa.tests.summary.overdue": "En retard ",
  "eqa.tests.summary.pending": "En attente",
  "eqa.validation.deadline.required": "La date limite de test est requise",
  "eqa.validation.program.required": "Le programme EQA est requis",
  "eqa.validation.provider.required": "L'organisation prestataire EEQ est requise",
  "error.add.edited.msg": "Erreur lors de la modification/ajout",
  "error.barcode.dimension.positive": "La dimension de l'étiquette doit être un nombre positif",
  "error.barcode.labelcount.default.lte.max": "Le nombre par défaut ne doit pas dépasser le maximum pour ce type d'étiquette",
  "error.delete.msg": "Erreur lors de la suppression",
  "error.duplicate.calculationname": "Nom de calcul en double",
  "error.fetch.boxDetails": "Échec de la récupération des détails de la boîte",
  "error.fetch.boxes": "Échec de la récupération des boîtes en expédition",
  "error.fetch.facilities": "Échec de la récupération des établissements",
  "error.fetch.unassignedSamples": "Échec de la récupération des échantillons non attribués",
  "error.field.required": "Ce champ est requis",
  "error.import.patient": "Erreur lors de l'importation du patient",
  "error.invalid.email": "Email invalide",
  "error.invalidcredentials": "L'identifiant ou le mot de passe est incorrect",
  "error.locale.format": "Invalid format. Use: en, fr, es, or en-US, fr-CA, etc.",
  "error.no.patient.data": "Aucune donnée de patient",
  "error.nonconform.report": "Veuillez saisir une valeur",
  "error.report.csv.date": "Veuillez sélectionner le type de date.",
  "error.report.csv.study": "Veuillez sélectionner le type d'étude.",
  "error.report.status": "Erreur lors de la génération du rapport",
  "error.report.linkIncomplete": "Le lien n'indique pas quel élément {0} ouvrir : le rapport ne peut donc pas être affiché. Choisissez-le plutôt dans les listes de rapports.",
  "error.report.linkIncomplete.title": "Ce lien de rapport est incomplet",
  "error.required.destination": "L’établissement de destination est requis",
  "error.results.loadFailed": "Impossible de charger la liste de travail des résultats",
  "error.results.loadFailed.detail": "Cette liste de tâches n'est pas vide : la requête a échoué, c'est pourquoi aucune tâche en attente n'y apparaît. Veuillez réessayer et prévenez un administrateur si le problème persiste.",
  "error.results.precision": "Ce test affiche le résultat à {0} décimale(s). Veuillez saisir la valeur avec cette précision, sinon la valeur enregistrée et la valeur affichée ne correspondront pas.",
  "error.results.staleSave": "Ce résultat a été mis à jour par {0} à l'adresse {1} — actualisez la page pour voir la dernière valeur",
  "error.results.save.noResponse": "Le résultat n'a pas été enregistré car le serveur n'a pas répondu. Vérifiez la connexion et réessayez.",
  "error.order.staleSave": "Cette demande a été mise à jour par {0} à {1}. Actualisez pour voir la dernière version, puis refaites votre modification.",
  "error.patient.staleSave": "Ce patient a été mis à jour par {0} à {1}. Actualisez pour voir la dernière version, puis refaites votre modification.",
  "error.testCatalog.staleSave": "Cette analyse a été mise à jour par {0} à {1}. Actualisez pour voir la dernière version, puis refaites votre modification.",
  "error.testCatalog.storage.invalidField": "{field} : cette valeur n'est pas acceptée. Choisissez une condition de la liste, utilisez zéro ou plus pour les durées et respectez la longueur maximale des textes.",
  "error.staleSave.section": "Quelqu'un d'autre a modifié cet élément après que vous l'avez ouvert. Rien n'a été enregistré. Actualisez pour voir la dernière version, puis refaites votre modification.",
  "error.load.failed": "Impossible de charger cette liste. Rechargez pour réessayer.",
  "error.save.failed": "Échec de l'enregistrement",
  "error.save.msg": "Erreur lors de l'enregistrement",
  "error.save.order": "Erreur lors de l’enregistrement de la demande d’examen ",
  "error.save.patient": "Erreur lors de l'enregistrement du patient",
  "error.title": "Erreur",
  "errorBoundary.reload": "Recharger",
  "errorBoundary.route.patientResultsViewer.message": "Une erreur est survenue lors de l’affichage des résultats de ce patient. Rechargez pour réessayer",
  "errorBoundary.route.patientResultsViewer.title": "Impossible de charger les résultats du patient",
  "errorBoundary.route.resultsSearch.message": "Une erreur est survenue sur la page des résultats. Rechargez pour réessayer.",
  "errorBoundary.route.resultsSearch.title": "Impossible de charger les résultats",
  "errorBoundary.route.modifyOrder.message": "Une erreur est survenue sur la page de modification de la demande. Rechargez pour réessayer.",
  "errorBoundary.route.modifyOrder.title": "Impossible de charger la modification de la demande",
  "errorBoundary.route.orderEntry.message": "Une erreur est survenue sur la page de saisie de la demande. Rechargez pour réessayer.",
  "errorBoundary.route.orderEntry.title": "Impossible de charger la saisie de la demande",
  "errorBoundary.route.samplePatientEntry.message": "Une erreur est survenue sur la page de saisie des échantillons. Rechargez pour réessayer.",
  "errorBoundary.route.samplePatientEntry.title": "Impossible de charger la saisie des échantillons",
  "errorBoundary.route.storage.message": "Une erreur est survenue sur cette page. Rechargez pour réessayer ou utilisez le menu pour naviguer ailleurs.",
  "errorBoundary.route.storage.title": "Impossible de charger le stockage ",
  "errorBoundary.route.analyzers.message": "Une erreur est survenue lors du chargement de cette page. Rechargez pour réessayer.",
  "errorBoundary.route.analyzers.title": "Impossible de charger le module analyseur",
  "errorBoundary.route.analyzerResults.message": "Une erreur est survenue lors du chargement des résultats. Rechargez pour réessayer.",
  "errorBoundary.route.analyzerResults.title": "Impossible de charger les résultats de l’analyseur",
  "serverReconnect.title": "Impossible de joindre le serveur",
  "serverReconnect.retryIn": "Nouvelle tentative dans {seconds} s",
  "serverReconnect.trying": "Nouvelle tentative en cours…",
  "serverReconnect.tryNow": "Réessayer maintenant",
  "errors.no.sample": "Sélectionnez l'échantillon approprié pour chaque analyse.",
  "errors.requester.org.or.requestor.required": "Saisissez au moins l'un des champs Organisation demandeuse ou Contact du demandeur.",
  "esig.button.certify": "Certifier et continuer",
  "esig.button.reject": "Rejeter",
  "esig.button.saveAndSign": "Sauvegarder",
  "esig.button.saveModification": "Sauvegarder",
  "esig.button.sign": "Signer",
  "esig.button.validate": "Valider",
  "esig.certification.acknowledge": "J’ai lu et compris la déclaration ci-dessus",
  "esig.certification.intro": "Avant d’utiliser les signatures électroniques, vous devez certifier que votre signature électronique a la même valeur légale que votre signature manuscrite.",
  "esig.error.disabled": "Les signatures électroniques ne sont pas activées",
  "esig.error.generic": "Une erreur s’est produite",
  "esig.error.invalidCredentials": "Identifiants invalides",
  "esig.error.keycloakNotSupported": "L’authentification Keycloak n’est pas encore prise en charge pour les signatures électroniques",
  "esig.error.loadingStatus": "Échec du chargement du statut de signature",
  "esig.error.mustAcknowledge": "Vous devez accepter la déclaration de certification",
  "esig.error.passwordRequired": "Le mot de passe est requis",
  "esig.error.rejectionReasonRequired": "Le motif de rejet est requis",
  "esig.error.title": "Erreur",
  "esig.error.usernameRequired": "Le nom d’utilisateur est requis",
  "esig.info.fullAuth": "Il s’agit de votre première signature dans cette session. Veuillez saisir votre nom d’utilisateur et votre mot de passe pour vous authentifier.",
  "esig.info.legalBinding": "En saisissant vos identifiants, vous créez une signature électronique ayant une valeur légale conformément à la réglementation 21 CFR Part 11.",
  "esig.info.passwordOnly": "Vous avez une session de signature active. Saisissez votre mot de passe pour continuer.",
  "esig.label.context": "Action:",
  "esig.label.meaning": "Signification de la signature :",
  "esig.label.password": "Mot de passe",
  "esig.label.rejectionReason": "Motif du rejet",
  "esig.label.signingAs": "Signé par : {userName}",
  "esig.label.username": "Nom d'utilisateur",
  "esig.meaning.authored": "Saisi",
  "esig.meaning.modified": "Modifié",
  "esig.meaning.rejected": "Rejeté",
  "esig.meaning.validatedAndReleased": "Validé et publié",
  "esig.placeholder.password": "Saisissez votre mot de passe pour confirmer",
  "esig.placeholder.rejectionReason": "Saisissez le motif du rejet",
  "esig.placeholder.username": "Saisissez votre nom d’utilisateur ",
  "esig.title.certification": "Certification de signature électronique",
  "esig.title.signature": "Signature électronique",
  "example": "Exemple",
  "external.id": "ID externe",
  "external.referrals.report": "Rapport de références externes",
  "externalReferredOutTests.title": "Rapport de références externes",
  "externalconnections.active": "Active",
  "externalconnections.add.title": "Ajouter une connexion externe",
  "externalconnections.authtype": "Type d’authentification",
  "externalconnections.authtype.basic.password": "Mot de passe",
  "externalconnections.authtype.basic.username": "Nom d'utilisateur",
  "externalconnections.browse.title": "Connexions externes",
  "externalconnections.deactivate.success": "Connexion(s) externe(s) désactivée(s) avec succès.",
  "externalconnections.description": "Description",
  "externalconnections.edit.title": "Modifier la connexion externe",
  "externalconnections.name": "Nom",
  "externalconnections.name.placeholder": "Saisir le nom de la connexion",
  "externalconnections.programmedconnection": "Type de connexion",
  "externalconnections.save.success": "Connexion externe enregistrée avec succès.",
  "externalconnections.search": "Rechercher des connexions externes",
  "externalconnections.search.placeholder": "Rechercher par nom ou type",
  "externalconnections.select": "Sélectionner",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "ex. https://serveur:port",
  "false.label": "Faux",
  "field.active": "Actif/Non actif",
  "field.ageRange": "Tranche d'âge",
  "field.dictionaryValues": "Valeurs du dictionnaire",
  "field.loinc": "LOINC",
  "field.name": "Nom",
  "field.normalRange": "Plage normale",
  "field.note": "Remarque",
  "field.orderable": "Commandable/Non commandable",
  "field.panel": "Panneau",
  "field.referenceValue": "Valeur de référence",
  "field.reportName": "Nom du rapport",
  "field.resultLimits": "Limites des résultats",
  "field.resultType": "Type de résultat",
  "field.sampleType": "Type d'échantillon",
  "field.select.testSection": "Select Test Section",
  "field.selectValues": "Sélectionner des valeurs",
  "field.sex": "Sexe",
  "field.significantDigits": "Chiffres significatifs",
  "field.testSection": "Section de test",
  "field.testUnit": "Test Unit",
  "field.uom": "Unité de mesure",
  "field.validRange": "Plage valide",
  "file.import.configuration.active": "Active",
  "file.import.configuration.analyzer": "Analyseur",
  "file.import.configuration.analyzer.emptyState": "No file import plugins installed",
  "file.import.configuration.analyzer.placeholder": "Sélectionner l'analyseur",
  "file.import.configuration.cancel": "Annuler",
  "file.import.configuration.columnMappings": "Mappages de colonnes",
  "file.import.configuration.columnMappings.helperText": "Mappage JSON des colonnes CSV vers les champs OpenELIS (ex: {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Délimiteur",
  "file.import.configuration.delimiter.helperText": "Caractère délimiteur CSV (par défaut: virgule)",
  "file.import.configuration.error.save": "Échec de l'enregistrement de la configuration d'import de fichier",
  "file.import.configuration.error.unknown": "An unknown error occurred",
  "file.import.configuration.fileFormat": "File Format",
  "file.import.configuration.fileFormat.placeholder": "Select file format",
  "file.import.configuration.filePattern": "Modèle de fichier",
  "file.import.configuration.filePattern.helperText": "Modèle glob pour correspondre aux fichiers (ex: *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "A une ligne d'en-tête",
  "file.import.configuration.importDirectory": "Répertoire d'import",
  "file.import.configuration.importDirectory.helperText": "Répertoire à surveiller pour les nouveaux fichiers",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Sauvegarder",
  "file.import.configuration.success.created": "Configuration d'import de fichier créée avec succès",
  "file.import.configuration.success.updated": "Configuration d'import de fichier mise à jour avec succès",
  "file.import.configuration.title.add": "Ajouter une configuration d'import de fichier",
  "file.import.configuration.title.edit": "Modifier la configuration d'import de fichier",
  "file.import.configuration.validation.analyzerId.required": "L'analyseur est obligatoire",
  "file.import.configuration.validation.columnMappings.invalid": "Format JSON invalide pour les mappages de colonnes",
  "file.import.configuration.validation.importDirectory.required": "Le répertoire d'import est requis",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filtres",
  "freezer.alert.detail.acknowledge": "Accuser réception",
  "freezer.alert.detail.acknowledgedAt": "Accusé de réception",
  "freezer.alert.detail.acknowledgedBy": "Accusé de réception par",
  "freezer.alert.detail.acknowledgmentNotes": "Remarques",
  "freezer.alert.detail.actions": "Mesures prises",
  "freezer.alert.detail.close": "Fermer",
  "freezer.alert.detail.correctiveAction": "Action corrective",
  "freezer.alert.detail.correctiveActionDescription": "Description",
  "freezer.alert.detail.correctiveActionFailed": "Echec de l'enregistrement de l'action corrective",
  "freezer.alert.detail.correctiveActionType": "Type d'action",
  "freezer.alert.detail.delete": "Supprimer l'alerte",
  "freezer.alert.detail.deleteConfirm": "Souhaitez-vous supprimer définitivement cette alerte ?",
  "freezer.alert.detail.deleteFailed": "Echec de la suppression de l'alerte",
  "freezer.alert.detail.deletePermanently": "Supprimer définitivement",
  "freezer.alert.detail.deleteWarning": "L'heure de début, le niveau de gravité, l'accusé de réception et les remarques sont retirés sans laisser de trace d'audit et ne peuvent pas être récupérés.",
  "freezer.alert.detail.freezer": "Congélateur",
  "freezer.alert.detail.id": "Identifiant de l'alerte",
  "freezer.alert.detail.logCorrectiveAction": "Enregistrer les actions correctives",
  "freezer.alert.detail.message": "Message",
  "freezer.alert.detail.method": "Méthodes",
  "freezer.alert.detail.notes": "Notes",
  "freezer.alert.detail.notesPlaceholder": "Ajouter des remarques concernant cette alerte…",
  "freezer.alert.detail.notifications": "Notifications envoyées",
  "freezer.alert.detail.overview": "Présentation des alertes",
  "freezer.alert.detail.recipient": "Destinataire",
  "freezer.alert.detail.resolutionNotes": "Notes de résolution",
  "freezer.alert.detail.resolve": "Résolu",
  "freezer.alert.detail.resolvedAt": "Résolu lors de la réunion du",
  "freezer.alert.detail.resolvedBy": "Résolu par",
  "freezer.alert.detail.sentAt": "Envoyé le",
  "freezer.alert.detail.severity": "Gravité",
  "freezer.alert.detail.startTime": "Heure de début",
  "freezer.alert.detail.status": "Statut",
  "freezer.alert.detail.summary": "Résumé",
  "freezer.alert.detail.takenAt": "Prise à",
  "freezer.alert.detail.takenBy": "Photo prise par",
  "freezer.alert.detail.title": "Détails de l'alerte",
  "freezer.alert.severity.critical": "Critique",
  "freezer.alert.severity.warning": "Avertissement",
  "freezer.alert.status.acknowledged": "Accusé de réception",
  "freezer.alert.status.closed": "Fermé",
  "freezer.alert.status.escalated": "Transmis à un niveau supérieur",
  "freezer.alert.status.open": "Ouvert",
  "freezer.alert.status.resolved": "Résolu",
  "freezer.nav.corrective": "Actions correctives",
  "freezer.nav.corrective.tooltip": "Manage corrective actions",
  "freezer.nav.dashboard": "Tableau de bord",
  "freezer.nav.dashboard.tooltip": "View cold storage monitoring dashboard",
  "freezer.nav.reports": "Rapports",
  "freezer.nav.reports.tooltip": "Generate cold storage reports",
  "freezer.nav.settings": "Paramètres",
  "freezer.nav.settings.tooltip": "Configure cold storage settings",
  "freezer.nav.trends": "Historical Trends",
  "freezer.nav.trends.tooltip": "View temperature trends over time",
  "french.current": "FRANÇAIS actuel",
  "french.label": "Français",
  "from.title": "From",
  "genericSample.edit.success": "Sample updated successfully",
  "genericSample.edit.success.accession": "Numéro de laboratoire : {accessionNumber}",
  "genericSample.edit.title": "Modifier l'échantillon",
  "genericSample.field.by": "Par",
  "genericSample.field.count": "N°",
  "genericSample.field.date": "Date",
  "genericSample.field.from": "From",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "Personne de laboratoire reçue",
  "genericSample.field.project": "Projet",
  "genericSample.field.storageLocation": "Congélateur de stockage n° et emplacement",
  "genericSample.field.type": "Type",
  "genericSample.notebook.selection.title": "Sélection du projet (facultatif)",
  "genericSample.order.error.labNoRequired": "Veuillez générer un numéro de laboratoire avant d'enregistrer.",
  "genericSample.order.generateLabNo": "Générer le numéro laboratoire",
  "genericSample.order.labNo.placeholder": "Cliquez sur « Générer un numéro de laboratoire » pour générer ",
  "genericSample.order.success.details": "Détails de l'échantillon",
  "genericSample.order.success.message": "Sample order created successfully with accession number: {accessionNumber}",
  "genericSample.order.title": "Recevoir un échantillon",
  "gps.accuracy.display": "±{accuracy}m accuracy",
  "gps.accuracy.warning.message": "GPS accuracy is {accuracy}m, which exceeds the required {required}m threshold. Consider capturing the location again in a better position.",
  "gps.accuracy.warning.title": "GPS Accuracy Warning",
  "gps.button.clear": "Clear",
  "gps.button.getting.location": "Getting Location...",
  "gps.button.location.captured": "Location Captured",
  "gps.button.use.my.location": "Use My Location",
  "gps.collapse": "Collapse GPS section",
  "gps.config.accuracy.helper": "Maximum acceptable GPS accuracy in meters. Set to 0 to disable accuracy checking.",
  "gps.config.accuracy.label": "Required Accuracy (meters)",
  "gps.config.enabled.description": "When enabled, GPS coordinate fields will appear in the Order Entry workflow to capture sample collection locations.",
  "gps.config.enabled.label": "Enable GPS Coordinates",
  "gps.config.error.load": "Failed to load GPS configuration",
  "gps.config.save.error": "Failed to save GPS configuration",
  "gps.config.save.success": "GPS configuration saved successfully",
  "gps.config.saving": "Enregistrement...",
  "gps.config.section.general": "GPS Settings",
  "gps.config.timeout.helper": "Maximum time to wait for GPS location in seconds.",
  "gps.config.timeout.label": "Timeout (seconds)",
  "gps.config.title": "GPS Coordinates Configuration",
  "gps.config.unsaved.changes": "You have unsaved changes. Are you sure you want to leave?",
  "gps.config.unsaved.subtitle": "Remember to save your changes before navigating away.",
  "gps.config.unsaved.title": "Unsaved Changes",
  "gps.config.validation.accuracy.negative": "Required accuracy cannot be negative",
  "gps.config.validation.accuracy.too.high": "Required accuracy cannot exceed 10,000 meters",
  "gps.config.validation.timeout.too.high": "Timeout cannot exceed 120 seconds",
  "gps.config.validation.timeout.too.low": "Timeout must be at least 1 second",
  "gps.coordinates.captured.via": "Captured via {method}",
  "gps.coordinates.current": "Current coordinates",
  "gps.error.not.supported": "GPS is not supported by this browser",
  "gps.error.permission.denied": "GPS access was denied. Please enable location permissions and try again.",
  "gps.error.position.unavailable": "GPS position is unavailable. Please check your device's location settings.",
  "gps.error.timeout": "GPS request timed out. Please try again.",
  "gps.error.title": "GPS Error",
  "gps.error.unknown": "An unknown GPS error occurred. Please try again.",
  "gps.info.description": "GPS coordinates record the geographic location where the sample was collected. This supports epidemiological surveillance and disease mapping.",
  "gps.info.title": "GPS Coordinates",
  "gps.latitude.helper": "Degrees North (+) or South (-), between -90 and 90",
  "gps.latitude.invalid": "Latitude must be between -90 and 90 degrees",
  "gps.latitude.label": "Latitude",
  "gps.latitude.placeholder": "e.g., -1.286389",
  "gps.longitude.helper": "Degrees East (+) or West (-), between -180 and 180",
  "gps.longitude.invalid": "Longitude must be between -180 and 180 degrees",
  "gps.longitude.label": "Longitude",
  "gps.longitude.placeholder": "e.g., 36.817223",
  "gps.manual.entry.off": "Off",
  "gps.manual.entry.on": "On",
  "gps.manual.entry.title": "Enter coordinates manually",
  "gps.manual.entry.toggle": "Manual coordinate entry",
  "gps.not.captured": "Not captured",
  "gps.section.description": "Capture the geographic location where this sample was collected for epidemiological tracking",
  "gps.section.title": "Collection Location (GPS)",
  "gps.status.captured": "Captured",
  "gps.status.optional": "Optional",
  "gps.tile.collapse": "Collapse GPS section",
  "gps.tile.expand": "Expand to add GPS coordinates",
  "gps.warning.partial.coordinates": "Both latitude and longitude should be provided for a valid location.",
  "header.ID": "ID",
  "header.assign": "Attribuer",
  "header.cancel.test": "Annuler le test",
  "header.formname": "Nom du formulaire",
  "header.icon.help": "Aide",
  "header.icon.lang": "Langue",
  "header.icon.menu.close": "Fermer le menu",
  "header.icon.menu.open": "Ouvrir le menu",
  "header.icon.menu.pin": "Épingler le menu",
  "header.icon.menu.unpin": "Désépingler le menu",
  "header.icon.notifications": "Notifications",
  "header.icon.search": "Rechercher",
  "header.icon.user": "Utilisateur",
  "header.label.ARV": "ARV-initial",
  "header.label.EID": "Diagnostic pour les enfants avec DBS-PCR",
  "header.label.changeLab": "Changer de laboratoire",
  "header.label.followup": "ARV-suivi",
  "header.label.intialFollowup": "ARV -->Suivi initial-VL",
  "header.label.logout": "Déconnexion",
  "header.label.nonconformityByDate": "Rapport de non-conformité par date",
  "header.label.selectLab": "Changer de laboratoire",
  "header.label.selectlocale": "Sélectionner la Langue",
  "header.label.specialRequest": "Demande Spéciale",
  "header.label.study.ciexport": "Exporter un fichier CSV par date",
  "header.label.study.vlloadtrends": "Rapport d'exportation des données de charge virale",
  "header.label.version": "Version:",
  "header.reject": "Rejeter",
  "header.rejection.reason": "Raison du rejet",
  "header.results.recorded": "Résultats enregistrés",
  "hide.aliquoting": "Masquer l'aliquotage",
  "holder.choose.availabletest": "Choisir une analyse disponible",
  "home.dashboard.title": "Tableau de bord",
  "home.label": "Accueil",
  "immunohistochemistry.label.addreport": "Ajouter un Rapport",
  "immunohistochemistry.label.averageChrom": "Moyenne des signaux Chromosome 17 par noyau",
  "immunohistochemistry.label.averageHer2": "Moyenne de HER2 par noyau",
  "immunohistochemistry.label.cellIntensity": "d'intensité. Score Allred",
  "immunohistochemistry.label.cellPercent": "% des cellules présentent une coloration nucléaire avec",
  "immunohistochemistry.label.dashboard": "Tableau de bord en immunohistochimie",
  "immunohistochemistry.label.her2Assesment": "L'évaluation de la protéine HER2 est de",
  "immunohistochemistry.label.her2Pattern": "Motif de coloration CerbB2/HER 2",
  "immunohistochemistry.label.her2ScoreOf": "Avec un score de",
  "immunohistochemistry.label.historicalDiagnosis": "Diagnostic histologique",
  "immunohistochemistry.label.ihcRatio": "Ratio des signaux Her2/neu par rapport au Chromosome 17",
  "immunohistochemistry.label.ihcScore": "Score IHC (Cerb2)",
  "immunohistochemistry.label.mibName": "MiB 1 (ki-67) (Indice de prolifération) :",
  "immunohistochemistry.label.molecularType": "Sous-type moléculaire",
  "immunohistochemistry.label.numberOfCancer": "Nombre de noyaux cancéreux",
  "immunohistochemistry.label.outOf8": "sur 8",
  "immunohistochemistry.label.report": "Rapport",
  "immunohistochemistry.label.reports": "Rapports",
  "immunohistochemistry.label.review": "En attente de révision en immunohistochimie",
  "immunohistochemistry.label.title": "Immuno-Histochimie",
  "immunohistochemistry.label.tumorCells": "des cellules tumorales sont positives (couper 20%)",
  "immunohistochemistry.status.completed": "Terminé",
  "immunohistochemistry.status.inProgress": "En cours",
  "immunohistochemistry.status.readyPathologist": "Prêt pour le pathologiste",
  "import.autoGenerated": "Auto-generated",
  "import.created": "Créé",
  "import.error.failed": "Import failed",
  "import.error.importFile": "Failed to import file",
  "import.error.selectFile": "Please select a file first",
  "import.error.validateFile": "Failed to validate file",
  "import.error.validateFirst": "Please validate the file first and fix any errors",
  "import.error.validationFailed": "Validation failed. Please check the errors below.",
  "import.failed": "Import Failed",
  "import.failedCount": "Failed",
  "import.header.collectionDate": "Date de prélèvement",
  "import.header.errorMessage": "Error Message",
  "import.header.field": "Champ",
  "import.header.from": "From",
  "import.header.labNo": "Lab No",
  "import.header.quantity": "Quantité",
  "import.header.row": "Row",
  "import.header.sampleType": "Type d'échantillon",
  "import.header.samplesToCreate": "Samples to Create",
  "import.importing": "Importation en cours ...",
  "import.invalidRows": "Invalid Rows",
  "import.selectFile": "Select file",
  "import.status.invalid": "Invalid",
  "import.status.valid": "Valid",
  "import.success": "Import Successful",
  "import.totalRows": "Total Rows",
  "import.totalSamplesToCreate": "Total Samples to Create",
  "import.uploadFile": "Upload File",
  "import.uploadFileDesc": "Upload CSV or Excel file ({types})",
  "import.validRows": "Valid Rows",
  "import.validating": "Validating...",
  "import.validationStatus": "Validation Status",
  "input.error.same.panel.type": "Un panneau existant avec le même nom a été trouvé. Veuillez annuler ou utiliser un nom différent.",
  "input.placeholder.labNo": "Saisir le numéro de laboratoire",
  "input.placeholder.patientFirstName": "Saisir le prénom du patient",
  "input.placeholder.patientId": "Saisir l'ID du patient",
  "input.placeholder.patientLastName": "Saisir le nom de famille du patient",
  "input.placeholder.prevLabNumber": "Entrez le numéro de laboratoire précédent",
  "input.placeholder.providerEmail": "Saisir l'adresse e-mail du prescripteur",
  "input.placeholder.providerFax": "Saisir le numéro de fax du prescripteur",
  "input.placeholder.providerWorkPhone": "Saisir le numéro de téléphone du prescripteur",
  "input.placeholder.provisionalClinicalDiagnosis": "Entrer le diagnostic clinique provisoire",
  "input.placeholder.requesterFirstName": "Saisir le prénom du prescripteur",
  "input.placeholder.requesterLastName": "Saisir le nom de famille du prescripteur",
  "input.placeholder.searchTestName": "Rechercher Nom de test ici",
  "input.placeholder.selectPanel": "Sélectionnez le type de panneau",
  "input.placeholder.selectPriority": "Sélectionnez la priorité",
  "input.placeholder.selectTest": "Sélectionnez le type de test",
  "input.placeholder.selectTestSection": "Sélectionnez le type d'unité",
  "instructions.copy.labnum": "Copier le numéro de laboratoire",
  "instructions.order.entry.eqa.enabled": "Lorsqu'il est activé, une case à cocher apparaît sur l'écran de saisie de commande permettant au personnel de marquer un échantillon comme EQA. Les données démographiques du patient seront automatiquement remplies avec N/A et verrouillées.",
  "instructions.order.entry.requester": "Lorsque cette option est activée, les champs « Recherche du demandeur », « Prénom du demandeur » et « Nom du demandeur » deviennent obligatoires sur l'écran « Ajouter une ordonnance ». Lorsqu'elle est désactivée (par défaut), ces trois champs sont facultatifs.",
  "instructions.test.activation": "Tests actifs: une case cochée indique un test déjà actif. Pour activer un test, cochez la case; pour désactiver, décochez la case. Tous les types d'échantillons sans test actif existant sont désactivés et apparaissent en bas, sous 'Types d'échantillons inactifs'. Si l'un des tests est activé, le type d'échantillon sera activé.",
  "instructions.test.activation.confirm": "Vérifiez que ces modifications sont celles que vous souhaitez effectuer. Si elles sont correctes, enregistrez-les. Sinon, utilisez le bouton retour pour apporter les corrections nécessaires.",
  "instructions.test.activation.sort": "Ordre d'affichage : Listes des types d'échantillons avec des tests nouvellement activés. Triez les tests pour indiquer comment ils seront affichés dans l'écran de saisie des ordonnances. Le tri peut être effectué en faisant glisser les éléments à la position souhaitée.",
  "instructions.test.order": "Les tests avec des cases cochées sont commandables, ceux sans cases cochées ne le sont pas. Modifiez les cases pour changer le statut. Pour qu’un test puisse être commandé lors de l’admission, il doit être à la fois actif et commandable. Les tests qui sont actifs mais non commandables peuvent être demandés dans le cadre d’un test réflexe.",
  "invalid.json": "JSON n'est pas valide",
  "inventory.add.button": "Ajouter un nouveau lot ",
  "inventory.addItem.button": "Ajouter un élément au catalogue",
  "inventory.consume.error.noLots": "Aucun stock disponible pour {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "Aucun stock ayant réussi le CQ pour {name} ({code}) : {count} lot(s) en stock sont en attente de CQ. Marquez le CQ comme réussi pour les utiliser.",
  "inventory.consume.error.noLotsQcFailed": "Aucun stock utilisable pour {name} ({code}) : {count} lot(s) en stock ont échoué au CQ",
  "inventory.consume.error.noLotsQuarantined": "Aucun stock utilisable pour {name} ({code}) : {count} lot(s) en stock sont en quarantaine",
  "inventory.dashboard.title": "Tableau de bord d'inventaire",
  "inventory.export.button": "Exporter",
  "inventory.filter.all": "Tous",
  "inventory.filter.status": "Filtrer par statut",
  "inventory.item.error.duplicateCode": "Un article d'inventaire avec le code « {code} » existe déjà.",
  "inventory.item.error.codeGenerationExhausted": "Impossible de trouver un code libre pour le préfixe « {prefix} ». Saisissez un code manuellement.",
  "inventory.list.title": "Éléments d’inventaire",
  "inventory.lot.error.duplicateBarcode": "Le code-barres « {barcode} » est déjà attribué au lot {lotNumber}",
  "inventory.lot.search.placeholder": "Rechercher par nom d'article, numéro de lot ou code-barres",
  "inventory.metrics.expired": "Expiré",
  "inventory.metrics.expiringSoon": "Bientôt Expiration",
  "inventory.metrics.lowStock": "Stock faible",
  "inventory.metrics.totalLots": "Nombre total de lots",
  "inventory.tab.catalog": "Catalogue",
  "inventory.tab.dashboard": "Tableau de bord",
  "inventory.tab.reports": "Rapports",
  "inventory.title": "Gestion des stocks",
  "label.action": "Action",
  "labNumber.format.current": "Format actuel",
  "labNumber.format.new": "Nouveau format",
  "labNumber.prefix": "Préfixe",
  "labNumber.type": "Type de numéro de laboratoire",
  "labNumber.usePrefix": "Utiliser le préfixe",
  "label.actions": "Actions",
  "label.active": "Active",
  "label.actualTestName": "Nom du test réel",
  "label.add": "Ajouter",
  "label.add.notification": "Ajouter une notification contextuelle à l'utilisateur",
  "label.all": "Tous",
  "label.analysisNotStarted": "Analyse non commencée",
  "label.any": "N'importe lequel",
  "label.audittrail": "Lab No",
  "label.audittrail.Reports": "Rapports de piste d'audit",
  "label.audittrail.labNo.invalidaccessionnumber": "Numéro d'accès invalide",
  "label.audittrail.labNo.missing": "Le numéro de laboratoire est requis !",
  "label.audittrailreport.nextvisitdate": "Date de la prochaine visite",
  "label.audittrailreport.priority": "Priorité",
  "label.audittrailreport.program": "Programme",
  "label.audittrailreport.receiveddate": "Date de réception",
  "label.audittrailreport.requestdate": "Date de demande",
  "label.audittrailreport.requester": "Prescripteur",
  "label.audittrailreport.requester.firstname": "Prénom du prescripteur",
  "label.audittrailreport.requester.lastname": "Nom de famille du prescripteur",
  "label.audittrailreport.sitename": "Nom du site",
  "label.autoFilledFromServer": "Rempli automatiquement depuis le serveur",
  "label.barcode": "code-barre",
  "label.barcode.labelsets": "Nombre d'ensembles d'étiquettes",
  "label.barcode.orderlabel": "Nombre d'étiquettes d'ordonnance par ensemble",
  "label.barcode.specimenlabel": "Nombre d'étiquettes d'échantillon par ensemble",
  "label.barcode.totallabel": "Nombre total d'étiquettes à imprimer",
  "label.button.action": "Action",
  "label.button.add": "Ajouter",
  "label.button.add.question": "Ajouter une nouvelle question",
  "label.button.cancel": "Annuler",
  "label.button.close": "Fermer",
  "label.button.changepassword": "Changer Mot de Passe",
  "label.button.clear": "Clear",
  "label.button.confirm": "Confirmer",
  "label.button.confirmAction": "Confirmer l'action",
  "label.button.confirmDelete": " Confirmer la suppression",
  "label.button.confirmTitle": "Es-tu sûr ?",
  "label.button.delete": "Supprimer",
  "label.button.descritpion": "Description",
  "label.button.edit": "Modifier",
  "label.button.activate": "Activer",
  "label.button.deactivate": "Désactiver",
  "label.button.exit": "Sortie",
  "label.button.externalsearch": "Recherche externe",
  "label.button.field": "Champ",
  "label.button.finish": "Terminer",
  "label.button.finished": "Terminé",
  "label.button.generatePrintableVersion": "Générer une version à imprimer",
  "label.button.import": "Importer",
  "label.button.login": "Se Connecter",
  "label.button.login.sso": "L'authentification unique",
  "label.button.newEntry": "Nouvelle saisie",
  "label.button.ok": "D'accord",
  "label.button.previous": "Précédent",
  "label.button.range": "Plage",
  "label.button.remove": "Retirer",
  "label.button.remove.report": "Supprimer le Rapport",
  "label.button.remove.slide": "Supprimer la Diapositive",
  "label.button.reset": "Reset",
  "label.button.sample": "Échantillon",
  "label.button.save": "Sauvegarder",
  "label.button.saveconfig": "Enregistrer la configuration",
  "label.button.search": "Rechercher",
  "label.button.select": "Sélectionner",
  "label.button.select.pathologist": "Sélectionner le pathologiste",
  "label.button.select.status": "Sélectionner l'état",
  "label.button.select.technician": "Sélectionner le technicien",
  "label.button.select.test": "Sélectionner le test",
  "label.button.start": "Commencer",
  "label.button.submit": "Soumettre",
  "label.button.update": "Mettre à jour",
  "label.button.uploadfile": "Télécharger le Fichier",
  "label.button.validate": "Valider",
  "label.button.viewReport": "Voir le rapport",
  "label.cancel": "Annuler",
  "label.cancel.test.no.replace": "Annuler le test pour les numéros de laboratoire sélectionnés, ne pas assigner un nouveau test",
  "label.checkedWillBeModified": "Les numéros de laboratoire cochés seront modifiés",
  "label.clear": "Effacer les filtres",
  "label.content": "Contenu de l’étiquette",
  "label.confirm": "Confirmer",
  "label.created.samples": "Échantillons créés",
  "label.critical.range": "Plage critique",
  "label.currentTest": "Test actuel",
  "label.days": "jours",
  "label.default.result": "Résultat par défaut",
  "label.delete": "Supprimer",
  "label.description": "Description",
  "label.edit": "Modifier",
  "label.electronic.orders": "Statistiques journalières. ",
  "label.equals": "équivaut à",
  "label.error": "Erreur",
  "label.existing.methods": "Méthodes existantes",
  "label.existing.test.sets": "Ensembles de tests existants",
  "label.filters.mycases": "Mes cas",
  "label.filters.status": "Statut",
  "label.field.required": "Ce champ est requis",
  "label.status": "Statut",
  "label.form.searchby": "Rechercher par",
  "label.id": "ID",
  "label.import.errors": "Erreurs d'importation",
  "label.inactive": "Inactif",
  "label.inactive.methods": "Méthodes inactives. Assignez des tests pour activer.",
  "label.includeInactiveTests": "Inclure les tests inactifs",
  "label.inside.normalrange": "est dans la plage normale",
  "label.lastPrinted": "Dernière impression : {date} {heure} par {utilisateur}",
  "label.loading": "Chargement...",
  "label.required": "obligatoire",
  "label.loinc": "LOINC",
  "label.management.title": "Gestion des étiquettes",
  "label.no": "No",
  "label.no.options.available": "Aucune option disponible",
  "label.none": "Aucun (pas de filtre)",
  "label.notValidated": "Non validé",
  "label.notequals": "n'est pas égal",
  "label.order.labNrPrefix": "N° de laboratoire",
  "label.order.patientPrefix": "Patient",
  "label.order.scan.text": "Scanner OU Saisir manuellement OU",
  "label.orderable": "Sélectionnable",
  "label.outside.normalrange": "est en dehors de la plage normale",
  "label.page.patientHistory": "Historique du Patient",
  "label.preview.data": "Aperçu des données",
  "label.print": "Imprimer l'étiquette",
  "label.print.error": "Erreur lors de la génération de l'étiquette. Veuillez réessayer.",
  "label.print.error.popupBlocked": "Fenêtre contextuelle bloquée. Veuillez autoriser les fenêtres contextuelles pour que ce site puisse imprimer les étiquettes.",
  "label.print.openDirectly": "Ouvrir les étiquettes dans un nouvel onglet",
  "label.print.generating": "Génération en cours...",
  "label.print.success": "Étiquette imprimée avec succès",
  "label.print.description": "Imprimer les étiquettes pour les demandes d'examens et les échantillons",
  "label.print.helper": "Sélectionner le type et la quantité d’étiquettes à imprimer",
  "label.print.success.count": "{count} étiquettes imprimées avec succès",
  "label.print.title": "Imprimer les étiquettes ",
  "label.printAll": "Imprimer toutes les étiquettes",
  "label.printAll.success": "Toutes les étiquettes ont été imprimées avec succès",
  "label.printConfirmation.message": "Imprimer l'étiquette pour {nom}{code} ?",
  "label.printConfirmation.title": "Imprimer l'étiquette",
  "label.printHistory": "Historique d'impression",
  "label.printHistory.byUser": "Par {utilisateur}",
  "label.printHistory.count": "{count} libellés",
  "label.printHistory.loading": "Chargement de l’historique d’impression…",
  "label.printHistory.never": "Jamais imprimé",
  "label.printHistory.unknownUser": "Inconnu",
  "label.printHistory.viewAll": "Afficher l'historique",
  "label.printLabel": "Imprimer l'étiquette",
  "label.program": "Programme",
  "label.qualifiers": "Qualificateurs",
  "label.quantity": "Quantité",
  "label.readonly": "Lecture seule",
  "label.reference.value": "Valeur de référence",
  "label.refertest.referencelab": "Référer l'analyse à un laboratoire de référence",
  "label.rejectedByBiologist": "Rejeté par le biologiste",
  "label.rejectedByTechnician": "Rejeté par le technicien",
  "label.remove": "Retirer",
  "label.replaceWith": "Remplacer par",
  "label.report.byNationalId": "Numéro d'Identification Nationale / Identifiant Santé Unique",
  "label.reporting.range": "Plage de rapport",
  "label.result.order": "Ordre des résultats",
  "label.resultSelectList": "Liste de sélection des résultats",
  "label.results.actions": "Actions",
  "label.results.anotherUser": "un autre Utilisateur",
  "label.results.date": "Date du test",
  "label.results.domain": "Clinique",
  "label.results.domain.env": "Qualité de l'eau",
  "label.results.domain.vector": "Surveillance des vecteurs",
  "label.results.edit": "Modifier",
  "label.results.inReviewBy": "En cours de révision par {0}",
  "label.results.labUnit": "Unité de laboratoire",
  "label.results.load": "Charger les résultats",
  "label.results.loading": "Chargement des résultats...",
  "label.results.range": "Plage de référence",
  "label.results.range.env": "Seuil réglementaire",
  "label.results.range.vector": "Interpretation",
  "label.results.reflexTriggered": "Ajout de tests de réflexes/calculés pour :",
  "label.results.refresh": "Actualiser",
  "label.results.result": "Résultat ",
  "label.results.resultFor": "Résultat pour « {0} »",
  "label.results.retry": "Veuillez réessayer",
  "label.results.save": "Sauvegarder",
  "label.results.search": "Rechercher par numéro de laboratoire",
  "label.results.searchByPatient": "Recherche par Patient",
  "label.results.selectAnotherPatient": "Sélectionnez un autre patient",
  "label.results.selectedPatient": "Patient sélectionné",
  "label.results.selectedPatient.none": "Aucun",
  "label.results.status": "Statut",
  "label.results.status.all": "Tous",
  "label.results.subject": "Échantillon / Patient",
  "label.results.subject.env": "Échantillon / Site",
  "label.results.subject.vector": "Échantillon / Piège",
  "label.results.table.caption": "Liste de travail des résultats",
  "label.results.test": "Test",
  "label.results.titer.placeholder": "p. ex. 1:10",
  "label.results.method": "Méthodes",
  "label.results.analyzer": "Analyseur",
  "label.results.analyzer.none": "Pas de manière directe",
  "label.results.fromAnalyzer": "provenant de l'analyseur",
  "label.results.methodAnalyzerHint": "« Méthode » désigne le type d'analyseur ; « Analyseur » désigne l'instrument spécifique.",
  "label.results.expandRow": "Développer la ligne",
  "label.results.collapseRow": "Réduire la ligne",
  "label.results.referredOut": "Référé à un laboratoire externe",
  "label.results.notes": "Notes",
  "label.results.note.context": "Contexte",
  "label.results.note.context.entry": "Entrée",
  "label.results.note.context.modification": "Modification",
  "label.results.note.context.auto": "Le réglage s'effectue automatiquement en fonction de ce que vous faites.",
  "label.results.note.visibility": "Visibilité",
  "label.results.note.internal": "Uniquement en laboratoire",
  "label.results.note.external": "Envoyer avec le résultat",
  "label.results.note.analysisLevel": "Niveau d'analyse",
  "label.results.note.externalWarning": "Cette remarque figurera dans le rapport du patient.",
  "label.results.note.placeholder": "Ajouter une remarque…",
  "label.results.dilution.measured": "Valeur mesurée",
  "label.results.dilution.factor": "Facteur de dilution",
  "label.results.dilution.reported": "Valeur déclarée : {0}",
  "label.results.saveHint": "La fonction « Enregistrer » enregistre votre signature électronique. Les messages d'avertissement critiques n'empêchent jamais l'opération « Enregistrer ».",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Anormal",
  "label.results.flag.critical": "Critique",
  "label.results.flag.invalid": "Invalid",
  "label.results.sample": "Échantillon",
  "label.results.flag": "Drapeau",
  "label.results.order.clinician": "Médecin prescripteur",
  "label.results.order.phone": "Téléphone",
  "label.results.order.site": "Site demandeur",
  "label.results.order.priority": "Priorité",
  "label.results.order.collection": "Collection",
  "label.results.section.program": "Informations sur les programmes",
  "label.results.program.name": "Programme",
  "label.results.program.eqa": "EEQ",
  "label.results.program.readonly": "Les champs du programme sont ici en lecture seule — veuillez les modifier dans la commande d'origine.",
  "label.results.section.storage": "Stockage et élimination des échantillons",
  "label.results.storage.location": "Emplacement",
  "label.results.storage.position": "Position",
  "label.results.storage.notes": "Notes",
  "label.results.storage.unassigned": "Non aucune affectation de stockage",
  "label.results.storage.assignLocation": "Attribuer un chemin ",
  "label.results.storage.moveLocation": "Se rendre à l'emplacement",
  "label.results.program.capturedData": "Données relatives au programme",
  "label.results.sampleStatus.title": "Statut de l'échantillon",
  "label.results.sampleStatus.volume": "Volume : il reste {0} de {1} · statut : {2}.",
  "label.results.sampleStatus.noVolume": "Statut : « {0} ».",
  "label.results.sampleStatus.available": "Disponible",
  "label.results.sampleStatus.usedUp": "épuisé(e)",
  "label.results.sampleStatus.disposed": "Rejeté",
  "label.results.sampleStatus.recordUse": "Montant record utilisé",
  "label.results.sampleStatus.markUsedUp": "Mark a épuisé",
  "label.results.sampleStatus.startDisposal": "Commencer la mise au rebut",
  "label.results.sampleStatus.amountUsed": "Quantité utilisée pour cette analyse",
  "label.results.sampleStatus.record": "Enregistrer",
  "label.results.sampleStatus.recordHint": "Diminue le volume restant — l'échantillon n'est pas rejeté tant qu'il n'est pas épuisé ou qu'il n'a pas été explicitement marqué comme épuisé.",
  "label.results.sampleStatus.usedUpNote": "L'échantillon est épuisé et mis en file d'attente pour le plan de travail d'élimination. Le registre d'élimination indique qui, quand et par quelle méthode.",
  "label.results.sampleStatus.disposalReason": "Motif de mise au rebut",
  "label.results.sampleStatus.disposalMethod": "Méthode d'élimination",
  "label.results.sampleStatus.disposalNotes": "Notes",
  "label.results.sampleStatus.confirmDisposal": "Confirmer la mise au rebut",
  "label.results.sampleStatus.updateFailed": "Le statut de l'échantillon n'a pas été mis à jour car le serveur n'a pas répondu. Vérifiez la connexion et réessayez.",
  "label.results.sampleStatus.reason.expired": "Expiré",
  "label.results.sampleStatus.reason.contaminated": "Contaminé",
  "label.results.sampleStatus.reason.patient_request": "Demande du patient",
  "label.results.sampleStatus.reason.testing_complete": "Test terminé",
  "label.results.sampleStatus.reason.other": "Autre",
  "label.results.sampleStatus.method.autoclave": "Autoclave pour déchets biologiques dangereux",
  "label.results.sampleStatus.method.neutralization": "Neutralisation chimique",
  "label.results.sampleStatus.method.incineration": "Incinération",
  "label.results.sampleStatus.method.other": "Autre",
  "label.results.sampleStatus.footnote": "L'utilisation partielle permet d'enregistrer la quantité consommée par rapport au volume restant de l'échantillon ; l'épuisement total (ou la mention « épuisé ») déclenche la mise au rebut.",
  "label.results.section.reagents": "Réactifs, QC et témoins",
  "label.results.reagents.summary.analyzer": "lot signalé par l'analyseur",
  "label.results.reagents.summary.manual": "saisie manuelle",
  "label.results.reagents.mode.analyzer": "mode de capture : signalé par l'analyseur",
  "label.results.reagents.mode.manual": "mode de capture : Manuel (facultatif)",
  "label.results.reagents.analyzerNote": "Signalé par « {0} » dans sa charge utile de résultats — en lecture seule.",
  "label.results.reagents.lotsUsed": "Lots de réactifs utilisés",
  "label.results.reagents.noneLinked": "Non de réactif est associé à ce test — les liens sont configurés dans le Catalogue de tests.",
  "label.results.reagents.noLots": "Il n'y a pas de lots disponibles dans l'inventaire pour ce réactif.",
  "label.results.reagents.perTest": "{0} {1} par analyse",
  "label.results.reagents.fefo": "FEFO (méthode recommandée)",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} restant",
  "label.results.reagents.quantityUsed": "Quantité utilisée",
  "label.results.reagents.recordUse": "Utilisation record",
  "label.results.reagents.recorded": "Données enregistrées sur {0} {1} — consommé selon le principe FEFO (premier entré, premier sorti) pour l'ensemble des lots.",
  "label.results.reagents.recordFailed": "Il n'a pas été possible d'enregistrer la consommation de réactifs.",
  "label.results.reagents.amountInvalid": "La quantité utilisée doit être un nombre positif.",
  "label.results.reagents.consumeNote": "L'enregistrement de l'utilisation réduit l'inventaire (FEFO) et associe une opération de consommation à cette analyse.",
  "label.results.control.title": "Résultat du contrôle",
  "label.results.control.noneConfigured": "Aucun lot de contrôle n'a été configuré pour ce test et cet analyseur.",
  "label.results.control.viewResults": "Voir les résultats du contrôle",
  "label.results.control.capture.controlLine": "Ligne de contrôle",
  "label.results.control.capture.valid": "Valid",
  "label.results.control.capture.invalid": "Invalid",
  "label.results.control.capture.kitLot": "Lot du kit",
  "label.results.control.capture.outcome": "Résultat",
  "label.results.control.capture.lot": "Lot de contrôle",
  "label.results.control.capture.measured": "Valeur mesurée",
  "label.results.control.capture.expected": "Valeur attendue",
  "label.results.control.capture.uncertainty": "Incertitude (±)",
  "label.results.control.capture.record": "Enregistrer le résultat du contrôle",
  "label.results.control.capture.recorded": "Résultat du contrôle enregistré.",
  "label.results.control.capture.recordedBlocked": "Résultat du contrôle enregistré. Le rendu des résultats concernés est bloqué jusqu'à l'enregistrement d'une répétition conforme.",
  "label.results.control.capture.blockedHint": "Un contrôle en échec bloque le rendu des résultats concernés : une nouvelle série est attendue.",
  "label.results.control.capture.noBenchLots": "Aucun lot de contrôle de paillasse n'est configuré pour cette analyse : ajoutez-en un dans CQ → Lots de contrôle avant d'enregistrer un contrôle quantitatif.",
  "label.results.control.capture.incomplete": "Complétez les champs du résultat du contrôle avant l'enregistrement.",
  "label.results.control.capture.failed": "L'enregistrement du résultat du contrôle a échoué.",
  "label.results.dilution.title": "Dilution",
  "label.results.section.attachments": "Pièces jointes",
  "label.results.attachments.summary": "{0} fichier(s)",
  "label.results.attachments.none": "Aucun",
  "label.results.attachments.empty": "Cette commande ne comporte pour l'instant aucune pièce jointe.",
  "label.results.attachments.add": "Ajouter une pièce jointe",
  "label.results.attachments.tooLarge": "Les fichiers dépassent la limite de 10 Mo.",
  "label.results.attachments.uploadFailed": "Échec du téléversement — Fichiers PDF, JPG, PNG ou TIFF d'une taille maximale de 10 Mo.",
  "label.results.attachments.resultsScope": "Résultats",
  "label.results.attachments.orderScope": "Saisie des commandes",
  "label.results.attachments.view": "Voir",
  "label.results.attachments.download": "Télécharger",
  "label.results.section.interpretation": "Interpretation",
  "label.results.interpretation.summary": "saisir via une règle ou en texte libre",
  "label.results.interpretation.ruleFired": "règle déclenchée ({0}) · ouverture automatique",
  "label.results.interpretation.autoOpen": "règle « fired » · ouverture automatique",
  "label.results.interpretation.ruleBanner": "Règle de correspondance (configurée dans le test) : la valeur saisie « {0} » correspond à « {1} ». Choisissez une catégorie pour appliquer son texte d'interprétation, puis modifiez-le si nécessaire.",
  "label.results.interpretation.match": "correspond à la valeur",
  "label.results.interpretation.freeText": "Interprétation (texte libre)",
  "label.results.interpretation.footnote": "L'interprétation peut être définie à l'aide d'une règle configurée dans le test (les catégories, associées automatiquement à la valeur) ou sous forme de texte libre. Le texte de la règle n'a qu'une valeur indicative tant qu'il n'a pas été appliqué ou modifié. Lorsque vous enregistrez, il est joint au résultat dans le rapport.",
  "label.results.nce.disposition": "Traitement des résultats",
  "label.results.nce.disposition.hint": "Cette procédure est appliquée lors de la soumission du NCE. Le renvoi vers un service externe constitue une action distincte au niveau de la ligne, et non une décision.",
  "label.results.nce.disposition.none": "Aucun",
  "label.results.nce.disposition.none.detail": "Enregistrez le NCE sans modifier le résultat.",
  "label.results.nce.disposition.cancel": "Annuler le résultat",
  "label.results.nce.disposition.cancel.detail": "Annulé. Aucune valeur indiquée. Ce cas est fréquent pour les NCE pré-analytiques.",
  "label.results.nce.disposition.reject": "Rejet + motif",
  "label.results.nce.disposition.reject.detail": "Efface la valeur et enregistre le motif. Appliqué par votre signature électronique. Enregistrer.",
  "label.results.nce.disposition.retest": "Retester",
  "label.results.nce.disposition.retest.detail": "Ordonne la réalisation d'un nouveau test sur cet échantillon ; cette nouvelle analyse apparaît comme étant en attente.",
  "label.results.nce.disposition.rejectArmed": "Le rejet est activé dans cette ligne — Enregistrez (signature électronique) pour l'appliquer.",
  "label.results.nce.disposition.cancelled": "Résultat annulé.",
  "label.results.nce.disposition.retested": "Un nouveau test a été prescrit.",
  "label.results.critical.range": "Critique",
  "label.results.critical.banner.title": "Valeur critique — notification obligatoire au médecin",
  "label.results.critical.banner.notify": "Le clinicien responsable doit être prévenu. Consignez-le sur le tableau de bord des alertes et enregistrez l'appel ci-dessous.",
  "label.results.critical.acknowledge": "J'accuse réception",
  "label.results.critical.acknowledged": "Accusé de réception",
  "label.results.critical.comment": "Remarque relative aux remerciements",
  "label.results.critical.comment.placeholder": "par exemple : médecin informé par Téléphone",
  "label.results.section.history": "Historique (cette analyse)",
  "label.results.history.summary": "{0} événements",
  "label.results.history.summary.unloaded": "révisions · statut · nouveaux tests",
  "label.results.history.when": "Lorsque",
  "label.results.history.event": "Événement",
  "label.results.history.detail": "Détails",
  "label.results.history.by": "Par",
  "label.results.history.event.CREATED": "Créé",
  "label.results.history.event.STATUS": "Statut",
  "label.results.history.event.RESULT": "Résultat ",
  "label.results.history.event.NOTE": "Remarque",
  "label.results.history.event.RETEST": "Retester",
  "label.results.history.event.REFLEX": "Réflexe",
  "label.results.history.event.OTHER": "Événement",
  "label.results.history.empty": "Aucun événement n'a encore été enregistré pour cette analyse.",
  "label.results.history.footnote": "Cette analyse porte uniquement sur les révisions, les changements d'état, les nouveaux tests, les corrections, les notes et les entrées d'audit. Les tendances relatives aux patients figurent dans le dossier du patient ; les règles de Westgard apparaissent sur le Tableau de bord CQ.",
  "label.results.nce.report": "Signaler une non-conformité",
  "label.results.reject.result": "Rejeter le résultat",
  "label.results.reject.reason": "Motif du rejet",
  "label.results.reject.hint": "L'enregistrement avec un rejet efface la valeur, consigne le motif et attribue à l'analyse le statut « Rejeté sur le plan technique ».",
  "label.results.referral.refer": "Consultez cette analyse",
  "label.results.referral.editing": "En attente de transmission — modifier",
  "label.results.referral.organization": "Laboratoire de référence",
  "label.results.referral.reason": "Raison de référence",
  "label.results.referral.date": "Date de saisine",
  "label.results.referral.reportDate": "Date du rapport du laboratoire de référence",
  "label.results.referral.hint": "La demande de prise en charge est enregistrée lorsque vous enregistrez cette ligne et est transférée vers le Tableau de bord des demandes de prise en charge.",
  "label.results.referral.cancel": "Ignorer",
  "label.results.section.aliquots": "Aliquotes",
  "label.results.aliquots.summary": "{0} aliquotes",
  "label.results.aliquots.summary.unloaded": "liste · créer",
  "label.results.aliquots.labNo": "Lab No",
  "label.results.aliquots.quantity": "Quantité",
  "label.results.aliquots.createdDate": "Créé",
  "label.results.aliquots.empty": "Il n'y a pas encore d'aliquotes pour cet échantillon.",
  "label.results.aliquots.count": "Nombre d’aliquotes",
  "label.results.aliquots.totalQuantity": "Quantité totale à transférer",
  "label.results.aliquots.notes": "Notes",
  "label.results.aliquots.create": "Créer des aliquotes",
  "label.results.aliquots.created": "Aliquotes créées.",
  "label.results.aliquots.failed": "Impossible de créer des aliquotes.",
  "label.results.aliquots.remaining": "Quantité restante du produit parent",
  "label.results.history.event.REFERRAL": "Transmis",
  "label.results.history.event.NCE": "Non-conformité",
  "label.results.history.event.CRITICAL_ACK": "Accusé de réception de valeur critique",
  "label.results.history.event.INVALID_CONFIRMED": "Hors intervalle valide confirmé",
  "label.results.alert.critical.title": "Résultat critique",
  "label.results.alert.critical.defaultMessage": "Ceci est un résultat critique. Prévenez le clinicien responsable selon la procédure de votre laboratoire.",
  "label.results.alert.invalid.title": "Valeur hors de l'intervalle valide",
  "label.results.alert.invalid.body": "Cette valeur est hors de l'intervalle valide pour cette analyse ({low} à {high}). Vérifiez-la avant d'enregistrer.",
  "label.results.alert.correct": "Corriger la valeur",
  "label.results.alert.keepValue": "Conserver cette valeur",
  "label.results.alert.confirmAndSave": "Confirmer et enregistrer",
  "label.results.alert.acknowledgeAndSave": "Accuser réception et enregistrer",
  "label.results.callback.logged": "Rappel enregistré",
  "label.results.referenceZone": "Référence et contexte",
  "label.results.layoutRemembered": "Mise en page mémorisée",
  "label.results.resetLayout": "Réinitialiser la mise en page",
  "label.results.section.orderInfo": "Informations sur la commande",
  "label.results.sampleType": "Type d'échantillon",
  "label.results.testDate": "Date du test",
  "label.results.receivedDate": "Reçu",
  "label.results.technician": "Nom du technicien",
  "label.routine.Reports": "Rapports de routine",
  "label.sample.types.activate": "Les types d'échantillons suivants seront activés :",
  "label.sample.types.deactivate": "Les types d'échantillons suivants seront désactivés car ils ne contiennent aucun test :",
  "label.save": "Sauvegarder",
  "label.saving": "Enregistrement...",
  "label.search.available.targetest": "Rechercher les tests disponibles",
  "label.search.availablepanel": "Panneau de recherche disponible",
  "label.search.labno.family": "Recherche par numéro de laboratoire ou nom de famille",
  "label.search.patient": "Recherche de patient",
  "label.select": "Sélectionner",
  "label.select.dateRange": "Sélectionnez la plage de dates pour laquelle vous souhaitez le rapport",
  "label.select.list.options": "Options de la liste de sélection",
  "label.selectTestSectionCatalog": "Sélectionnez la section de test pour voir le catalogue de cette section",
  "label.sex.dependent": "Dépendant du sexe",
  "label.shortCode": "Code court",
  "label.shortCode.error.invalidChars": "Un code court ne peut contenir que des lettres, des chiffres, des tirets et des traits de soulignement.",
  "label.shortCode.error.maxLength": "Le code court doit comporter 10 caractères ou moins.",
  "label.shortCode.error.network": "Impossible de vérifier l'unicité. Veuillez vérifier manuellement.",
  "label.shortCode.error.save": "Erreur lors de l'enregistrement du code court : {error}",
  "label.shortCode.error.startChar": "Le code court doit commencer par une lettre ou un chiffre.",
  "label.shortCode.helper": "10 caractères maximum, alphanumériques, tiret, trait de soulignement",
  "label.shortCode.optional.helper": "Facultatif (un code sera utilisé si la longueur est inférieure ou égale à 10 caractères). Maximum 10 caractères, alphanumériques avec tirets et traits de soulignement.",
  "label.shortCode.required.helper": "Obligatoire lorsque le code dépasse 10 caractères. Maximum 10 caractères, alphanumériques avec tirets et traits de soulignement.",
  "label.shortCode.update.success": "Code court mis à jour avec succès",
  "label.shortCodeRequired": "Un code court est requis pour l'impression des étiquettes. Veuillez le renseigner au préalable dans le formulaire de modification.",
  "label.shortCodeWarning": "Modifier le code court invalidera les étiquettes existantes",
  "label.showChildren": "Afficher les éléments enfants",
  "label.study.Reports": "Rapports d'étude",
  "label.test.name": "Nom du test ",
  "label.test.activate": "Les tests suivants seront activés :",
  "label.test.add": "Ajouter un test",
  "label.test.batch.cancel.finish": "Cette action est irréversible.",
  "label.test.batch.cancel.start": "Vous avez choisi d'annuler le test",
  "label.test.batch.no.change.finish": "ne seront pas modifiés.",
  "label.test.batch.replace.start": "Les tests suivants",
  "label.test.deactivate": "Les tests suivants seront désactivés :",
  "label.test.display.order": "Ordre d'affichage du test",
  "label.test.order.confirm": "Vérification : Activer/désactiver l'ordonnabilité des tests",
  "label.test.activation.confirm": "Vérifier : activer/désactiver les analyses",
  "label.test.orderable": "Les tests suivants seront disponibles pour la commande depuis le formulaire de commande.",
  "label.test.results": "Résultats des tests",
  "label.test.resultsData": "Données des résultats des tests",
  "label.test.unorderable": "Les tests suivants ne seront pas disponibles à la commande sur le formulaire de commande. Ils ne pourront être commandés qu'en tant que tests réflexes.",
  "label.testActivate": "Activation des tests",
  "label.testName": "Noms des tests",
  "label.text.generate": "générer",
  "label.total.tests": "Analyse au total",
  "label.type": "Type d’étiquette",
  "label.type.order": "Étiquette de la demande d'examen",
  "label.type.pool": "Galerie d'images d'{count} {animal}",
  "label.type.sample": "Étiquette d'échantillon",
  "label.unit": "Unité",
  "label.user.notestsection": "L'utilisateur actuel n'a pas d'unité de laboratoire assassinée. Veuillez contacter l'administrateur",
  "label.validation.errors": "Erreurs de validation",
  "label.validation.results": "Validation des résultats",
  "label.view": "Voir",
  "label.viewtestCatalog": "Catalogue de tests",
  "label.warning": "Avertissement",
  "label.yes": "Yes",
  "labno.alt.prefix.instruction": "Préfixe pour les étiquettes de code-barres pré-imprimées (4 caractères) :",
  "labno.alt.prefix.note": "REMARQUE : Si ce préfixe a déjà été utilisé, la numérotation continuera à partir du dernier numéro généré.",
  "labno.alt.prefix.use": "Utilisez le même format de numéro d'accès et le même pool de numéros disponibles que la génération de commande.",
  "language.select.label": "Français",
  "legend.search.availabletests": "Recherchez parmi les tests disponibles",
  "loading": "Chargement...",
  "loading.boxes": "Chargement des boîtes...",
  "loading.description": "Chargement...",
  "location.collection.title": "Lieu de prélèvement ",
  "location.environmentalConditions": "Conditions environnementales",
  "location.environmentalConditions.placeholder": "ex. 25°C, temps clair",
  "location.gps.error": "Impossible d’obtenir la localisation",
  "location.gps.getCurrent": "Obtenir la position actuelle",
  "location.gps.getting": "Obtention de la position…",
  "location.gps.latitude": "Latitude GPS ",
  "location.gps.longitude": "Longitude GPS",
  "location.gps.notSupported": "La géolocalisation n’est pas prise en charge par votre navigateur",
  "location.gps.permissionDenied": "Autorisation de localisation refusée",
  "location.gps.timeout": "Délai de demande de localisation dépassé",
  "location.gps.unavailable": "Informations de localisation indisponibles",
  "location.helper": "La hiérarchie des localisations (Région / District / Ville-Village) utilise la structure existante du système de localisation. Les profils de workflow environnemental permettent de laisser certaines lignes sans libellé afin de simplifier ou raccourcir les ensembles de lignes selon les besoins de configuration.",
  "location.requesterReference": "Référence du prescripteur",
  "location.requesterReference.placeholder": "ex. Méthode EPA 524.2",
  "location.select.placeholder": "Sélectionner {levelName}…",
  "location.siteDescription": "Description du site de prélèvement ",
  "location.siteDescription.placeholder": "ex. Point de captage d’approvisionnement municipal en eau",
  "locale.active": "Active",
  "locale.add": "Add Language",
  "locale.add.title": "Add Language",
  "locale.code": "Locale Code",
  "locale.code.helper": "e.g., en, fr, es, pt",
  "locale.create.success": "Language created successfully",
  "locale.delete.confirm.message": "Are you sure you want to delete this language? This action cannot be undone.",
  "locale.delete.confirm.title": "Delete Language",
  "locale.delete.error": "Failed to delete language",
  "locale.delete.fallback.error": "Cannot delete the fallback language. Set another language as fallback first.",
  "locale.delete.success": "Language deleted successfully",
  "locale.displayName": "Nom d'affichage",
  "locale.displayName.helper": "e.g., English, Français, Español",
  "locale.edit.title": "Edit Language",
  "locale.fallback": "Fallback",
  "locale.fallback.error": "Failed to set fallback language",
  "locale.fallback.success": "Fallback language updated",
  "locale.management.description": "Manage supported languages for metadata translations.",
  "locale.management.title": "Language Management",
  "locale.setFallback": "Set as Fallback",
  "locale.sortOrder": "Sort Order",
  "locale.status": "Statut",
  "locale.update.success": "Language updated successfully",
  "log.submitting.aliquot.data": "Soumission des données aliquotes :",
  "log.submitting.aliquot.data2": "Soumission des données aliquotes (JSON) :",
  "logging.management.apply": "Appliquer le niveau de journalisation",
  "logging.management.description": "Modifier le niveau de journalisation du backend à l’exécution. Ceci est utile pour le débogage sans redémarrer le serveur. Les changements prennent effet immédiatement mais ne persistent pas après un redémarrage du serveur.",
  "logging.management.label": "Configuration des journaux",
  "logging.management.level": "Niveau de journalisation",
  "logging.management.logger": "Nom du logger",
  "logging.management.logger.helper": "ex. org.openelisglobal, root",
  "logging.management.success": "Niveau de log défini à {level} pour {logger}",
  "login.account.disabled": "Compte désactivé",
  "login.account.locked": "Compte verrouillé",
  "login.complexity.message": "Le mot de passe doit répondre aux critères suivants :",
  "login.complexity.message.1": "Être d'au moins 7 caractères",
  "login.complexity.message.2": "Doit contenir des lettres majuscules et minuscules ou des chiffres",
  "login.complexity.message.3": "Doit contenir au moins un des caractères suivants : *, $, #, !",
  "login.complexity.message.4": "Ne doit contenir aucun autre caractère",
  "login.complexity.new.message": "Le nouveau mot de passe doit : ",
  "login.complexity.new.message.1": "Ne doit pas être le même que le mot de passe actuel",
  "login.error.account.disable": "Votre compte a été désactivé. Veuillez contacter l'administrateur système.",
  "login.error.password.current.incorrect": "Le mot de passe actuel que vous venez de saisir est incorrect. Veuillez réessayer.",
  "login.error.password.expired": "Votre mot de passe a expiré. Veuillez contacter l'administrateur système.",
  "login.error.update.message": "La mise à jour du mot de passe a échoué. Veuillez réessayer.",
  "login.login.": "Répéter le mot de passe",
  "login.login.current.password": "Mot de passe actuel",
  "login.login.first": "Prénom",
  "login.login.last": "Nom",
  "login.login.name": "Nom d'utilisateur",
  "login.login.new.password": "Nouveau mot de passe",
  "login.login.password": "Mot de passe",
  "login.login.repeat.password": "Répéter le mot de passe",
  "login.msg.password": "Mot de passe",
  "login.msg.password.missing": "Votre mot de passe requis",
  "login.msg.username": "Nom d'utilisateur",
  "login.msg.username.missing": "Votre nom d'utilisateur requis",
  "login.notice.message": "Avis : L’accès à ce service est réservé au personnel autorisé. Si vous n’avez pas l’autorisation expresse de l’administrateur, vous devez quitter immédiatement. Cette organisation interdit tout accès non autorisé, divulgation, duplication, modification, détournement, destruction, perte, utilisation abusive ou vol de ses informations.",
  "login.password.expired.date": "Date d'expiration du mot de passe",
  "login.password.expired.date.placeholder": "jj/mm/aaaa",
  "login.redirecting.sso": "Redirection vers l'authentification unique",
  "login.subtitle": "Se Connecter",
  "login.timeout": "Délai d'inactivité de l'utilisateur (minutes)",
  "login.timeout.placeholder": "Entrer en minutes",
  "login.title": "Se Connecter",
  "lot.barcode": "code-barre",
  "lot.barcode.assign": "Ce lot n'a pas encore de code-barres. Saisissez-en un maintenant ; il sera verrouillé après l'enregistrement.",
  "lot.barcode.hint": "Laissez vide pour en générer un à partir du code de l'article et du numéro de lot.",
  "lot.barcode.locked": "Le code-barres est verrouillé après l'enregistrement afin que les étiquettes imprimées restent valides.",
  "lot.barcode.placeholder": "Laisser vide pour générer automatiquement",
  "lot.barcode.placeholder.assign": "Saisir un code-barres",
  "lot.calculatedExpiry": "Expiration calculée",
  "lot.currentQuantity": "Quantité actuelle",
  "lot.dateOpened": "Date d'ouverture",
  "lot.details.no.movements": "Aucun mouvement enregistré pour ce lot",
  "lot.details.no.transactions": "Aucune transaction enregistrée pour ce lot",
  "lot.details.no.usage": "Aucun historique d'utilisation pour ce lot",
  "lot.details.section.basic": "Informations de base",
  "lot.details.section.dates": "Dates importantes",
  "lot.details.section.movements": "Historique des mouvements",
  "lot.details.section.quantities": "Quantité",
  "lot.details.section.storage": "Emplacement de stockage",
  "lot.details.section.transactions": "Historique des transactions",
  "lot.details.section.usage": "Historique d'utilisation",
  "lot.details.tab.info": "Information",
  "lot.details.tab.transactions": "Transactions",
  "lot.details.tab.usage": "Historique d'utilisation",
  "lot.details.title": "Détails du lot",
  "lot.details.view": "Voir les détails",
  "lot.expirationDate": "Date d'expiration",
  "lot.form.title.add": "Réception d'un nouveau lot d'inventaire",
  "lot.form.title.edit": "Modifier le lot d'inventaire",
  "lot.initialQuantity": "Quantité initiale",
  "lot.label.print": "Imprimer l'étiquette",
  "lot.label.print.failed": "Impossible de générer l'étiquette. Veuillez réessayer.",
  "lot.number": "Numéro de lot",
  "lot.number.hint": "Identifiant stable de ce lot. Laissez vide pour en générer un à partir du code de l'article et de la date du jour.",
  "lot.number.placeholder": "Laisser vide pour générer automatiquement",
  "lot.qcStatus.FAILED": "Failed",
  "lot.qcStatus.PASSED": "Réussi",
  "lot.qcStatus.PENDING": "En attente",
  "lot.qcStatus.QUARANTINED": "En quarantaine",
  "lot.qcStatus.hint": "Les lots restent inutilisables pour les analyses tant que le CQ n'est pas marqué Réussi.",
  "lot.qcStatus": "statut QC",
  "lot.receiptDate": "Date de réception",
  "lot.save.error": "Erreur de sauvegarde par Lot ",
  "lot.save.error.locationAfterCreate": "Le lot a été créé, mais l'attribution de son emplacement de stockage a échoué. Appuyez de nouveau sur Enregistrer pour relancer uniquement l'attribution, afin que le lot ne soit pas réceptionné deux fois. {reason}",
  "lot.save.success": "Lot de sauvegardé avec succès",
  "lot.selectItem": "Sélectionner un élément du catalogue",
  "lot.selectLocation": "Sélectionner l'emplacement de stockage",
  "lot.status": "Statut",
  "lot.status.ACTIVE": "Active",
  "lot.status.CONSUMED": "Consommé",
  "lot.status.DISPOSED": "Rejeté",
  "lot.status.EXPIRED": "Expiré",
  "lot.status.IN_USE": "Utilisé",
  "lot.status.QUARANTINED": "En quarantaine",
  "lot.storageLocation": "Emplacement de stockage",
  "manage.testing.algorithms.add.reflex.tests": "Gérer les algorithmes de test et les tests réflexes",
  "master.lists.page": "Page des listes principales",
  "master.lists.page.analyzer": "Page de l'automate",
  "master.lists.page.barcode": "Page des codes-barres",
  "master.lists.page.batchtest": "Réaffectation et annulation des tests par lot",
  "master.lists.page.external.connections": "Page des connexions externes",
  "master.lists.page.field": "Page des champs",
  "master.lists.page.list": "Page de la liste",
  "master.lists.page.menu": "Configuration du menu",
  "master.lists.page.notification": "Page des notifications",
  "master.lists.page.order.entry": "Page de saisie de commande",
  "master.lists.page.org": "Page de l'organisation",
  "master.lists.page.patient": "Page du patient",
  "master.lists.page.printed": "Page des impressions",
  "master.lists.page.provider": "Page du prestataire",
  "master.lists.page.report.result": "Configuration de la diffusion des résultats",
  "master.lists.page.result": "Page des résultats",
  "master.lists.page.site": "Page du site",
  "master.lists.page.test.management": "Page de gestion des tests",
  "master.lists.page.user": "Gestion des utilisateurs",
  "master.lists.page.work.plan": "Page du plan de travail",
  "menu.accession.validation": "Recherche par ordonnance",
  "menu.accession.validation.range": "Recherche gamme par ordonnance",
  "menu.billing.active": "Menu de facturation Actif",
  "menu.billing.address": "Adresse de facturation",
  "menu.billing.title": "Gestion du menu de facturation",
  "menu.genericSample": "Échantillon générique",
  "menu.genericSample.edit": "Modifier l'échantillon",
  "menu.genericSample.import": "Importer",
  "menu.genericSample.order": "Demande d'examen",
  "menu.global.title": "Titre global",
  "menu.label.filter": "Filtres : ",
  "menu.label.filter.active": "Uniquement actifs",
  "menu.label.filter.admin": "Uniquement administrateurs",
  "menu.label.filter.role": "Par rôles des unités de laboratoire",
  "menu.nonconform.active": "Menu des non-conformités actif",
  "menu.nonconform.title": "Gestion du menu des non-conformités",
  "menu.patient.active": "Menu des patients actif",
  "menu.patient.title": "Gestion du menu des patients",
  "menu.results.range": "Recherche gamme par ordonnance",
  "menu.sidenav.active": "Menu actif",
  "menu.study.active": "Menu d'étude actif",
  "menu.study.title": "Configuration du menu d'étude",
  "menu.validation.date": "Rechercher par date de test",
  "message.method.activation": "Cette méthode ne sera pas active tant qu'au moins un test ne lui aura pas été assigné.",
  "message.propertiesupdate.success": "Properties updated successfully",
  "method.browse.title": "Section de méthode",
  "method.methodName": "Nom de la méthode",
  "method.modal.add.heading": "Ajouter une nouvelle méthode",
  "modal.add.method": "Ajouter une nouvelle méthode",
  "move.back": "Revenir en arrière",
  "move.to.aliquot": "Déplacement vers Aliquote",
  "new.patient.label": "Nouveau patient",
  "next.action.button": "Suivante",
  "nextLabel.action.button": "Suivant",
  "no.aliquots": "Pas d'aliquotes disponibles",
  "no.analysis.found": "Aucune analyse trouvée",
  "no.data.found": "Aucune donnée trouvée",
  "no.option": "No",
  "noTestsFound.matching": "Aucun test trouvé correspondant",
  "nonconform.add.new.date": "Ajouter une Nouvelle Date",
  "nonconform.corrective.action": "Action corrective planifiée ou recommandée :",
  "nonconform.corrective.actionType": "Type d'action",
  "nonconform.corrective.comment": "Commentaires",
  "nonconform.corrective.control": "Action préventive corrective planifiée ou recommandée ou contrôles simultanés :",
  "nonconform.corrective.title": "Action Corrective pour Événements Non Conformes",
  "nonconform.date.completed": "Date d'Achèvement",
  "nonconform.date.discussion.nce": "Date de Discussion avec le Personnel ENC",
  "nonconform.date.event": "Date de l'Événement",
  "nonconform.description.nce": "Description de l'ENC",
  "nonconform.field.date": "Date ENC",
  "nonconform.field.reporting.data": "Date de Signalement",
  "nonconform.goToNceForm": "Accéder au formulaire de signalement NCE",
  "nonconform.lab.componenet.nce": "Composant du Laboratoire où l'ENC a eu lieu",
  "nonconform.label.highseverity": "9 = gravité très élevée - une action immédiate est requise",
  "nonconform.label.lowseverity": "1 = gravité très faible - aucune action immédiate n'est requise",
  "nonconform.label.prescibernamesite": "Nom du prescripteur et site",
  "nonconform.label.proposed.action": "Action proposée",
  "nonconform.label.reportingunit": "Unité de rapport",
  "nonconform.label.suspected.cause.nce": "Cause suspectée de l'ENC",
  "nonconform.nce.concurrent.control.action": "action de contrôle concurrent",
  "nonconform.nce.number": "Numéro d'ENC",
  "nonconform.nce.preventive.action": "action préventive",
  "nonconform.nce.resolution": "Résolution ENC",
  "nonconform.nce.resolution.description": "Les actions correctives et les contrôles préventifs/concurrents étaient-ils efficaces pour résoudre l'événement non conforme et empêcher sa récurrence?",
  "nonconform.nce.turnaround.time": "Délai d'Exécution",
  "nonconform.order.save.fail": "Échec de l'enregistrement",
  "nonconform.order.save.success": "Enregistrement réussi",
  "nonconform.person.reporting.different": "Nom de la personne signalant l'ENC (si différent)",
  "nonconform.person.responsible": "Personne Responsable",
  "nonconform.report": "Rapport d'événement non conforme (ENC)",
  "nonconform.report.field.date": "Date de rapport",
  "nonconform.severity.score": "Score de Gravité",
  "nonconform.view.comments": "Commentaires",
  "nonconform.view.corrective.action.description": "Description de l'action corrective à entreprendre",
  "nonconform.view.event.date": "Date de l'Événement",
  "nonconform.view.event.description": "Description de l'Événement",
  "nonconform.view.lab.component": "Composant de Laboratoire",
  "nonconform.view.nce.category": "Catégorie de non-conformité",
  "nonconform.view.nce.likely.occur": "Quelle est la probabilité que l'ÉCN se reproduise ?",
  "nonconform.view.nce.severity": "Gravité",
  "nonconform.view.nce.type": "Type de non-conformité ",
  "nonconform.view.preventive.description": "Le cas échéant, description de l'action préventive ou de contrôle concomitante",
  "nonconform.view.report": "Voir le Nouvel Événement Non Conforme",
  "nonconform.view.reporting.person": "Personne Responsable du Rapport",
  "nonconform.view.severe.consequences": "Quelle est la gravité des conséquences ou de l'impact de l'ÉCN ?",
  "nonconform.view.specimen": "Spécimen(s)",
  "nce.attachment.dropzone": "Glissez-déposez les fichiers ici ou cliquez pour téléverser",
  "nce.attachment.error.maxFiles": " Maximum {maxFiles} fichiers autorisés",
  "nce.attachment.error.size": "La taille du fichier dépasse le maximum de {maxSize}",
  "nce.attachment.error.type": "Type de fichier non autorisé. Types acceptés : {types}",
  "nce.attachment.error.upload": " Erreur lors du téléversement du fichier",
  "nce.attachment.files": "fichiers",
  "nce.attachment.hint": "(Optionnel – max {maxFiles} fichiers, 10 Mo chacun)",
  "nce.attachment.uploading": "Téléversement en cours…",
  "nce.category.administrative": "Administratif",
  "nce.category.analytical": "Analytique",
  "nce.category.postanalytical": "Post-analytique",
  "nce.category.preanalytical": "Pré-analytique",
  "nce.field.attachments": "Pièces jointes",
  "nce.field.notes": "Notes",
  "nce.field.description.placeholder": "Décrivez ce qui s’est passé, quand cela a été détecté et tout contexte pertinent…",
  "nce.field.immediateAction": "Action immédiate entreprise",
  "nce.field.immediateAction.placeholder": "Quelles mesures correctives ont été prises immédiatement…",
  "nce.field.linkedItems": "Échantillons/Résultats associés",
  "nce.field.severity": "Gravité",
  "nce.field.title": "Titre",
  "nce.field.title.placeholder": "Brève description de l’événement… ",
  "nce.severity.critical": "Critique",
  "nce.severity.critical.description": "Risque pour la sécurité des patients, violation réglementaire",
  "nce.severity.major": "Majeur",
  "nce.severity.major.description": "Impact significatif sur la qualité ou les opérations",
  "nce.severity.minor": "Mineur",
  "nce.severity.minor.description": "Impact limité, facilement corrigé",
  "nce.severity.low": "Bas",
  "nce.severity.low.description": "Impact minimal, aucune action corrective requise",
  "nce.status.open": "Ouvert",
  "nce.status.underInvestigation": "En cours d’investigation",
  "nce.tree.empty": "Aucune demande d'examen trouvée. Recherchez par numéro laboratoire pour commencer.",
  "nce.tree.loading": "Chargement des demandes d'examen… ",
  "nce.tree.order": "Demande d'examen",
  "nce.tree.search": "Filtrer par test ou échantillon…",
  "nce.tree.selected": "{sampleCount} échantillons, {resultCount} résultats sélectionnés ",
  "nce.trigger.order_cancellation": " L’annulation de la demande d'examen peut nécessiter une documentation de la non-conformité ",
  "nce.trigger.partial_sample_rejection": "Le rejet partiel d’échantillon nécessite une documentation de la non-conformité",
  "nce.trigger.pathology_rejection": "Le rejet de cas en pathologie peut nécessiter une documentation  de non-conformité",
  "nce.trigger.premature_disposal": "L’élimination prématurée peut nécessiter une documentation de conformité",
  "nce.trigger.qc_invalidation": "L’invalidation du contrôle qualité nécessite une documentation de non-conformité",
  "nce.trigger.referral_rejection": "Le rejet de référencement nécessite une documentation de non-conformité",
  "nce.trigger.result_rejection_no_retest": "Le rejet de résultat sans nouveau test nécessite une documentation de non-conformité",
  "nce.trigger.result_rejection_retest": "Le rejet de résultat avec nouveau test peut nécessiter une documentation de non-conformité",
  "nce.trigger.sample_rejection": " Le rejet d’échantillon nécessite une documentation de non-conformité",
  "nce.trigger.test_cancel_no_results": "L’annulation d’analyse peut nécessiter une documentation de non-conformité ",
  "nce.trigger.test_cancel_with_results": "L’annulation d’analyse avec résultats nécessite une documentation de non-conformité",
  "nce.type.calibration_failure": "Échec de la calibration ",
  "nce.type.communication_failure": "Echec de la communication",
  "nce.type.contamination": "Contamination",
  "nce.type.documentation_error": "Erreur de documentation",
  "nce.type.equipment_malfunction": "Dysfonctionnement de l’équipement",
  "nce.type.labeling_error": "Erreur d’étiquetage",
  "nce.type.patient_id_mismatch": "Discordance d’identifiant patient",
  "nce.type.policy_violation": "Violation de procédure",
  "nce.type.procedure_deviation": "Écart de procédure",
  "nce.type.qc_failure": "Échec du contrôle qualité",
  "nce.type.reagent_issue": "Problème de réactif ",
  "nce.type.report_delay": "Retard de rapport",
  "nce.type.report_distribution_error": "Erreur de distribution du rapport",
  "nce.type.requisition_incomplete": "Demande incomplète",
  "nce.type.resource_shortage": "Manque de ressources",
  "nce.type.result_interpretation_error": "Erreur d’interprétation des résultats",
  "nce.type.sample_collection_error": "Erreur de prélèvement de l'échantillon",
  "nce.type.staff_competency_issue": " Problème de compétence du personnel ",
  "nce.type.storage_error": "Erreur de stockage",
  "nce.type.system_error": "Erreur système",
  "nce.type.training_gap": "Manque de formation",
  "nce.type.transcription_error": "Erreur de transcription",
  "nce.type.transport_issue": "Problème de transport",
  "nce.type.request_form_error": "Erreur sur le formulaire de demande",
  "nce.type.equipment_failure": "Défaillance de l’équipement",
  "nce.type.procedure_error": "Erreur de procédure",
  "nce.type.calibration_error": "Erreur de calibration",
  "nce.type.cross_contamination": "Contamination croisée",
  "nce.type.result_transcription_error": "Erreur de transcription des résultats",
  "nce.type.report_delivery_error": "Erreur de livraison du rapport",
  "nce.type.critical_value_not_reported": "Valeur critique non signalée",
  "nce.type.delayed_result": "Résultat retardé",
  "nce.type.result_amendment": "Modification du résultat",
  "nce.type.training_issue": "Problème de formation",
  "nce.button.createNce": "Créer une non-conformité",
  "nce.button.skip": "Ignorer",
  "nce.creating": "Création de la non-conformité",
  "nce.description.placeholder": "Décrivez la non-conformité",
  "nce.error.create.failed": "Échec de la création de la non-conformité",
  "nce.error.severity.required": "La gravité est requise",
  "nce.trigger.mandatory.message": "Vous devez créer un NCE avant de poursuivre cette action.",
  "nce.trigger.mandatory.title": "La non-conformité est requise",
  "nce.trigger.order_cancellation.message": "L’annulation de la prescription peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.order_cancellation.title": "Annulation de la prescription – Non-Conformité",
  "nce.trigger.partial_sample_rejection.message": "Le rejet partiel d’échantillon nécessite la documentation d’un événement non conforme.",
  "nce.trigger.partial_sample_rejection.title": "Rejet partiel d’échantillon – Non-Conformité requis ",
  "nce.trigger.pathology_rejection.message": "Le rejet de cas en pathologie peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.pathology_rejection.title": "Rejet en pathologie – Non-Conformité",
  "nce.trigger.premature_disposal.message": "L’élimination prématurée peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.premature_disposal.title": "Élimination prématurée – Non-Conformité",
  "nce.trigger.qc_invalidation.message": " L’invalidation du contrôle qualité nécessite la documentation d’un événement non conforme.",
  "nce.trigger.qc_invalidation.title": "Invalidation Contrôle Qualité – Non-Conformité requise",
  "nce.trigger.referral_rejection.message": "Le rejet de référencement nécessite la documentation d’un événement non conforme.",
  "nce.trigger.referral_rejection.title": "Rejet de référencement – Non-Conformité requise",
  "nce.trigger.result_rejection_no_retest.message": "Le rejet de résultat sans nouveau test nécessite la documentation d’un événement non conforme.",
  "nce.trigger.result_rejection_no_retest.title": "Rejet de résultat – Non-Conformité requise",
  "nce.trigger.result_rejection_retest.message": "Le rejet de résultat avec nouveau test peut nécessiter la documentation d’un événement non conforme. ",
  "nce.trigger.result_rejection_retest.title": "Rejet de résultat – Non-Conformité",
  "nce.trigger.sample_rejection.message": "Le rejet d’échantillon nécessite la documentation d’un événement non conforme.",
  "nce.trigger.sample_rejection.title": "Rejet d’échantillon – Non-Conformité requise",
  "nce.trigger.test_cancel_no_results.message": " L’annulation d’analyse peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.test_cancel_no_results.title": "Annulation d’analyse – Non-conformité",
  "nce.trigger.test_cancel_with_results.message": "L’annulation d’analyse avec résultats existants nécessite la documentation d’une non-conformité.",
  "nce.trigger.test_cancel_with_results.title": "Annulation d’analyse – Non-conformité requise",
  "nce.admin.trigger.config.title": "Configuration des déclencheurs de non-conformité ",
  "nce.admin.trigger.config.description": "Configurer les cas où les non-conformités sont créées automatiquement ou demandées.",
  "nce.admin.trigger.behaviors.title": "Comportements de déclenchement",
  "nce.admin.rejection.mappings.title": "Mappage des motifs de rejet ",
  "nce.admin.rejection.mappings.description": "Associer les motifs de rejet aux catégories de non-conformité pour un remplissage automatique.",
  "nce.trigger.behavior.mandatory": "Obligatoire",
  "nce.trigger.behavior.prompted": "Avec invite",
  "nce.trigger.behavior.disabled": "Désactivé",
  "nce.trigger.column.type": "Type de déclencheur ",
  "nce.trigger.column.description": "Description",
  "nce.trigger.column.behavior": "Comportement",
  "nce.trigger.column.active": "Active",
  "nce.trigger.type.sampleRejection": "Rejet d'échantillon",
  "nce.trigger.type.resultRejection": "Rejet de résultat",
  "nce.trigger.type.qaEvent": "Événement Assurance Qualité",
  "nce.trigger.type.manual": "Manuel",
  "nce.trigger.update.success": "Configuration des déclencheurs mise à jour",
  "nce.trigger.update.error": "Échec de la mise à jour de la configuration des déclencheurs",
  "nce.mapping.add": "Ajouter un mappage",
  "nce.mapping.edit": "Modifier le mappage",
  "nce.mapping.column.rejectionReason": "Motif du rejet",
  "nce.mapping.column.category": "Catégorie de non-conformité",
  "nce.mapping.column.type": "Type de non-conformité ",
  "nce.mapping.column.severity": "Gravité par défaut ",
  "nce.mapping.column.active": "Active",
  "nce.mapping.noData": "Pas de mapping de rejet configuré",
  "nce.mapping.validation.error": "Le motif de rejet et la catégorie sont requis",
  "nce.mapping.save.success": "Mappage enregistré avec succès",
  "nce.mapping.active": "Active",
  "nce.field.category": "Catégorie",
  "nce.field.type": "Type",
  "nce.select.category": "Choisir une catégorie",
  "nce.select.type": "Sélectionner un type",
  "nce.error.dateOfEvent.required": "La date de l’événement est requise",
  "nce.error.reportingUnit.required": "L’unité de déclaration est requise",
  "nce.error.description.required": "La description est requise",
  "nce.error.suspectedCauses.required": " Les causes suspectées sont requises",
  "nce.error.proposedAction.required": "L’action proposée est requise",
  "nce.error.category.required": "La catégorie est requise ",
  "nce.attachment.saveFirst": "Enregistrez la non-conformité pour activer les pièces jointes ",
  "nce.attachment.error.noEvent": "Veuillez d’abord enregistrer la non-conformité avant de téléverser des pièces jointes ",
  "nce.attachment.download": "Télécharger",
  "nce.attachment.delete": "Supprimer",
  "requester.add.new.restricted": "L'ajout d'une nouvelle organisation a été désactivé par votre administrateur.",
  "requester.add.new.restricted.organization.contact": "La saisie des coordonnées d'une nouvelle organisation a été désactivée par votre administrateur. Recherchez une organisation existante ci-dessus.",
  "requester.add.new.restricted.provider": "L'ajout d'un nouveau prestataire a été désactivé par votre administrateur.",
  "requester.add.new.restricted.provider.contact": "La saisie des coordonnées d'un nouveau prestataire a été désactivée par votre administrateur. Veuillez rechercher un prestataire existant ci-dessus.",
  "requester.add.new.restricted.requestor": "L'ajout d'un nouveau demandeur a été désactivé par votre administrateur. Recherchez un demandeur existant ci-dessus.",
  "requester.contact.search": "Recherche de demandeurs",
  "requester.contact.search.helper": "Recherchez la personne de contact à l'origine de ces analyses, ou saisissez-en une nouvelle ci-dessous. Il est obligatoire de renseigner au moins l'un des champs « Organisation demandeuse » ou « Demandeur ».",
  "requester.organization.add.new": "+ Ajouter une nouvelle organisation « {name} »",
  "requester.organization.email": "Adresse e-mail de l'organisation",
  "requester.organization.fax": "Fax de l'organisation",
  "requester.organization.new.helper": "Une nouvelle organisation sera créée lors de l'enregistrement de cette commande.",
  "requester.organization.new.tag": "Nouveau",
  "requester.organization.no.match": "Aucune organisation correspondante n'a été trouvée.",
  "requester.organization.phone": "Numéro de téléphone de l'organisation",
  "requester.organization.search": "Recherche d'organisations demandeuses",
  "requestor.add.new": "+ Ajouter un nouveau demandeur « {name} »",
  "requestor.add.new.restricted": "L'ajout d'un nouveau demandeur a été désactivé par votre administrateur.",
  "requestor.department": "Département",
  "requestor.email": "E-mail",
  "requestor.fax": "Fax",
  "requestor.firstName": "Prénom",
  "requestor.lastName": "Nom",
  "requestor.name": "Nom du demandeur",
  "requestor.name.placeholder": "Veuillez saisir le nom du demandeur",
  "requestor.new.helper": "Un nouveau demandeur sera créé lors de l'enregistrement de cette commande.",
  "requestor.new.tag": "Nouveau",
  "requestor.no.match": "Non, aucun demandeur correspondant n'a été trouvé.",
  "requestor.phone": "Téléphone",
  "requestor.search.helper": "Saisissez au moins 2 caractères pour lancer la recherche automatique.",
  "result.compliance.fail": "ECHEC",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "Tous les lots",
  "result.pool.filter.allPools": "Toutes les piscines",
  "result.pool.filter.clear": "Effacer les filtres",
  "result.pool.filter.count": "Affichage de {shown} résultats sur {total}",
  "result.pool.filter.lot": "Filtrer par lot",
  "result.pool.filter.pool": "Filtrer par piscine",
  "result.pool.intake": "Bassin d'alimentation",
  "result.pool.subpool": "{n} de sous-pool",
  "result.vectorPool.label": "Galerie d'images d'{count} {animal}",
  "results.uncertainty.column.label": "U (k = 2)",
  "results.uncertainty.validation.negative": "L'incertitude doit être un nombre non négatif.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Échantillon",
  "sample.priority.ASAP": "Dès que possible",
  "sample.priority.FUTURE_STAT": "STAT (futur)",
  "sample.priority.ROUTINE": "Routine",
  "sample.priority.STAT": "STAT (Urgent)",
  "sample.priority.TIMED": "Programmé",
  "sample.referToReferenceLab.helper": "Indiquez si cet échantillon doit faire l'objet d'analyses dans un laboratoire de référence externe.",
  "sampleAcceptance.action.moveDown": "Descendre",
  "sampleAcceptance.action.moveUp": "Remonter",
  "sampleAcceptance.banner.resampledFrom": "Il s'agit d'une version de remplacement créée à partir d'un rééchantillonnage de l'échantillon n°{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Échantillon de remplacement",
  "sampleAcceptance.banner.resampledTo": "Cet échantillon a été rejeté et un nouvel échantillon a été prélevé. Ordre de remplacement : {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Rééchantillonné",
  "sampleAcceptance.button.addItem": "Ajouter un élément",
  "sampleAcceptance.col.active": "Active",
  "sampleAcceptance.col.label": "Etiquette",
  "sampleAcceptance.col.order": "Demande d'examen",
  "sampleAcceptance.col.statusForDomain": "Statut de ce domaine",
  "sampleAcceptance.domain.all": "Tous les domaines",
  "sampleAcceptance.domain.clinical": "Clinique",
  "sampleAcceptance.domain.environmental": "Environnemental",
  "sampleAcceptance.domain.vector": "Vecteur",
  "sampleAcceptance.enforcement.help": "L'application de cette règle est définie par domaine, et non par unité de laboratoire — un réceptionniste peut en effet intervenir dans plusieurs unités de laboratoire.",
  "sampleAcceptance.enforcement.label": "Application de la liste de contrôle — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Obligatoire — bloquer l'étape 3 jusqu'à ce qu'elle soit terminée",
  "sampleAcceptance.enforcement.off": "Désactivé — masquer la liste de contrôle",
  "sampleAcceptance.enforcement.optional": "Facultatif — enregistrer sans bloquer",
  "sampleAcceptance.gate.blocked": "L'acceptation à la réception est obligatoire pour ce domaine : vous devez accepter chaque échantillon (ou signaler une non-conformité / procéder à un nouveau prélèvement) avant que cette demande d'examen puisse être traitée.",
  "sampleAcceptance.labWide.heading": "Éléments valables pour l'ensemble du laboratoire (s'appliquent sauf si un domaine les remplace)",
  "sampleAcceptance.labWide.inherited": "Éléments applicables à l'ensemble du laboratoire — hérités (solution de repli active)",
  "sampleAcceptance.labWide.superseded": "Éléments valables pour l'ensemble du laboratoire — remplacés ici (modification par rapport à « Tous les domaines »)",
  "sampleAcceptance.notify.enforcementSaved": "Mise à jour des mesures d'application",
  "sampleAcceptance.notify.itemAdded": "Élément ajouté à la liste de contrôle",
  "sampleAcceptance.notify.itemSaved": "Élément de la liste de contrôle enregistré",
  "sampleAcceptance.notify.recordFailed": "Echec de l'enregistrement de l'acceptation",
  "sampleAcceptance.notify.rejectFailed": "Echec du rejet",
  "sampleAcceptance.notify.resampleFailed": "Echec du rééchantillonnage",
  "sampleAcceptance.ownItems.empty": "Aucun élément pour l'instant — ce domaine renvoie à la liste générale du laboratoire ci-dessous.",
  "sampleAcceptance.ownItems.heading": "{domain} éléments",
  "sampleAcceptance.qa.accepted.success": "Acceptation enregistrée",
  "sampleAcceptance.qa.answer.fail": "ECHEC",
  "sampleAcceptance.qa.answer.na": "N/A",
  "sampleAcceptance.qa.answer.pass": "Passer",
  "sampleAcceptance.qa.button.accept": "Valider l'échantillon",
  "sampleAcceptance.qa.button.reject": "Rejeter",
  "sampleAcceptance.qa.button.resample": "Rééchantillonner",
  "sampleAcceptance.qa.context.collected": "Prélevé",
  "sampleAcceptance.qa.context.longTransit": "long trajet — c’est à vous de décider",
  "sampleAcceptance.qa.context.note": "Transit est présenté à titre indicatif uniquement — il n'effectue aucune notation automatique. Liste active : {domain}.",
  "sampleAcceptance.qa.context.received": "Reçu",
  "sampleAcceptance.qa.context.transit": "Durée du trajet",
  "sampleAcceptance.qa.empty": "Non, aucune liste de contrôle de validation n'est configurée pour ce domaine.",
  "sampleAcceptance.qa.failHint": "Cet échantillon n'a pas satisfait aux contrôles — signalez une non-conformité ou procédez à un nouveau prélèvement au lieu de l'accepter.",
  "sampleAcceptance.qa.failHint.reject": "Cet échantillon a échoué à des contrôles. Signalez un ENC ou rejetez-le au lieu de l'accepter.",
  "sampleAcceptance.qa.noSample": "Enregistrez le prélèvement afin de procéder à la réception de cet échantillon.",
  "sampleAcceptance.qa.note.label": "Remarque (facultative)",
  "sampleAcceptance.qa.note.placeholder": "Optionnel — veuillez noter n'importe lequel des éléments constatés",
  "sampleAcceptance.qa.status.accepted": "Accepté",
  "sampleAcceptance.qa.status.pending": "En attente",
  "sampleAcceptance.qa.status.rejected": "Rejeté",
  "sampleAcceptance.qa.status.review": "Critique",
  "sampleAcceptance.qa.subtitle": "Veuillez terminer la liste de contrôle de réception pour cet échantillon",
  "sampleAcceptance.qa.subtitle.rejected": "Cet échantillon a été rejeté et un nouvel échantillon a été prélevé — en lecture seule.",
  "sampleAcceptance.qa.subtitle.rejectedEqa": "Cet échantillon a été rejeté : lecture seule.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "Cette capture a été rejetée — en lecture seule.",
  "sampleAcceptance.qa.title": "Validation de l'admission",
  "sampleAcceptance.reject.commit": "Rejet de la validation",
  "sampleAcceptance.reject.comment.label": "Commentaire (optionnel)",
  "sampleAcceptance.reject.info": "Considérez cette prise comme inutilisable. Elle ne pouvant pas être récupérée, aucune commande de remplacement n'est créée.",
  "sampleAcceptance.reject.info.eqa": "Rejeter cet échantillon d'EEQ. Le matériel d'EEQ ne peut pas être prélevé de nouveau : aucune demande de remplacement n'est créée.",
  "sampleAcceptance.reject.reason.label": "Motif (prérempli à partir des éléments ayant fait l'objet d'un échec — modifiable)",
  "sampleAcceptance.reject.reason.required": "Une raison est requise",
  "sampleAcceptance.reject.success": "Échantillon rejeté.",
  "sampleAcceptance.reject.title": "Rejet — {labNumber}",
  "sampleAcceptance.resample.commit": "Valider le rééchantillonnage",
  "sampleAcceptance.resample.info": "Veuillez rejeter cet échantillon et créer une nouvelle demande de prélèvement pour un nouveau prélèvement. Le demandeur en sera informé.",
  "sampleAcceptance.resample.reason.label": "Motif (prérempli à partir des éléments ayant fait l'objet d'un échec — modifiable)",
  "sampleAcceptance.resample.reason.required": "Une raison est requise",
  "sampleAcceptance.resample.success": "Nouvel échantillonnage créé — nouvelle prescription {accession}. Le prescripteur a été informé.",
  "sampleAcceptance.resample.title": "Resample — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Conditions d'éligibilité",
  "sampleAcceptance.review.col.labNo": "N° de laboratoire",
  "sampleAcceptance.review.col.sampleType": "Type d'échantillon",
  "sampleAcceptance.review.col.transit": "Transit",
  "sampleAcceptance.review.noSamples": "Il n'y a pour l'instant aucun échantillon prélevé à examiner.",
  "sampleAcceptance.review.subtitle": "Sélectionnez un échantillon pour remplir sa fiche de contrôle de réception",
  "sampleAcceptance.review.title": "Validation de l'admission",
  "sampleAcceptance.status.active": "Active",
  "sampleAcceptance.status.inactive": "Inactif",
  "sampleAcceptance.status.inheritedActive": "Actif (hérité)",
  "sampleAcceptance.status.superseded": "Remplacé",
  "sampleAcceptance.title": "Exemple de liste de contrôle pour l'acceptation des échantillons",
  "sidenav.label.admin.nceTriggerConfig": "Configuration des déclencheurs",
  "sidenav.label.admin.nceCategoryType": "Catégories et types ",
  "sidenav.label.admin.nceConfig": "Configuration des non-conformités",
  "nce.admin.categorytype.title": "Configuration des catégories et types de non-conformités ",
  "nce.admin.categorytype.description": "Gérer les catégories et types disponibles pour les non-conformités",
  "nce.admin.tab.categories": "Catégories",
  "nce.admin.tab.types": "Types",
  "nce.admin.category.add": "Ajouter une catégorie ",
  "nce.admin.category.edit": "Modifier la catégorie ",
  "nce.admin.category.name.required": "Le nom de la catégorie est requis",
  "nce.admin.category.save.success": "Catégorie enregistrée avec succès ",
  "nce.admin.category.save.error": "Échec de l’enregistrement de la catégorie",
  "nce.admin.type.add": "Ajouter un type",
  "nce.admin.type.edit": "Modifier le type",
  "nce.admin.type.validation.error": "Le nom du type et la catégorie sont requis",
  "nce.admin.type.save.success": "Type enregistré avec succès",
  "nce.admin.type.save.error": "Échec de l’enregistrement du type",
  "nce.admin.column.name": "Nom",
  "nce.admin.column.displayKey": "Clé d’affichage",
  "nce.admin.column.typesCount": "Nombre de types",
  "nce.admin.column.category": "Catégorie",
  "nce.admin.column.actions": "Actions",
  "nce.admin.field.name": "Nom",
  "nce.admin.field.displayKey": " Clé d’affichage (pour i18n)",
  "nce.admin.field.displayKey.helper": "Optionnel. Utilisé pour les traductions.",
  "nce.admin.field.category": "Catégorie",
  "nce.admin.delete.confirm.title": " Confirmer la suppression",
  "nce.admin.delete.confirm.message": "Êtes-vous sûr de vouloir supprimer « {name} » ? Cette action est irréversible.",
  "nce.admin.delete.success": "Supprimé avec succès",
  "nce.inline.title": "Signaler une non-conformité",
  "nce.inline.context": "CONTEXTE (rempli automatiquement)",
  "nce.dashboard.title": "Toutes les non-conformités ",
  "nce.dashboard.subtitle": "Toutes les non-conformités ouvertes du laboratoire",
  "nce.button.reportNce": "Signaler une non-conformité",
  "nce.search.placeholder": "Rechercher des non-conformités… ",
  "nce.filter.allStatus": "Tous les statuts",
  "nce.filter.allCategories": "Toutes les catégories",
  "nce.filter.allSeverities": "Toutes les gravités",
  "nce.filter.clearAll": "Tout effacer",
  "nce.summary.critical": "Critique",
  "nce.summary.major": "Majeur",
  "nce.summary.minor": "Mineur",
  "nce.summary.overdue": "En retard ",
  "nce.tag.overdue": "En retard ",
  "nce.tab.eventDetails": "Détails de l’événement ",
  "nce.tab.investigation": "Investigation",
  "nce.tab.capa": "Actions correctives et préventives",
  "nce.tab.history": "Historique",
  "nce.field.suspectedCauses": " Causes suspectées",
  "nce.field.proposedAction": "Action proposée",
  "nce.field.trigger": "Déclencheur",
  "nce.capReason.time_24h": "{count} échantillons liés, limités à une fenêtre de 24 h",
  "nce.capReason.count_50": "{count} échantillons liés, limités aux 50 plus récents",
  "nce.capa.noItems": "Aucune action corrective/préventive enregistrée pour le moment.",
  "nce.capa.dueDate": "Date d'échéance",
  "nce.history.noItems": "Aucun historique disponible.",
  "nce.history.system": "Système",
  "nce.action.acknowledge": "Accuser réception",
  "nce.action.assignTo": "Assigner à",
  "nce.action.addNote": "Ajouter une note",
  "nce.action.close": "Fermer NCE",
  "nce.action.startCorrectiveAction": "Commencer une action corrective",
  "nce.link.duplicate.warning": "Ces échantillons sont déjà liés à cette non-conformité",
  "nce.list.empty": "Aucune non-conformité ne correspond à vos critères.",
  "nce.modal.addNote": "Ajouter une note",
  "nce.modal.addNoteDescription": "Ajouter une note à la non-conformité {nceNumber} ",
  "nce.modal.notePlaceholder": "Saisissez votre note…",
  "nce.modal.assign": "Assigner la non-conformité",
  "nce.modal.assignDescription": "Assigner la non-conformité {nceNumber} à un utilisateur",
  "nce.modal.selectUser": "Sélectionner un utilisateur",
  "nce.modal.searchUser": "Rechercher un utilisateur…",
  "nce.assign.selectUser": "Veuillez sélectionner un utilisateur à assigner ",
  "nce.assign.success": "Non-conformité assignée avec succès",
  "nce.assign.error": " Échec de l’assignation de la non-conformité",
  "nce.acknowledge.success": "Non-conformité accusée réception avec succès",
  "nce.acknowledge.error": "Échec de l’accusé de réception de la non-conformité ",
  "nce.note.empty": "Veuillez saisir une note",
  "nce.note.success": "Note ajoutée avec succès",
  "nce.note.error": " Échec de l’ajout de la note",
  "nce.attachment.downloadError": "Échec du téléchargement de la pièce jointe",
  "nce.attachment.viewError": "Échec de l’affichage de la pièce jointe",
  "not.available": "Pas disponible",
  "not.specified": "Non spécifié",
  "notAuthenticated": "Non authentifié",
  "notebook.attachments.title": "Pièces jointes",
  "notebook.attachments.uploadPrompt": "Cliquez pour télécharger des fichiers",
  "notebook.auditTrail.action.archived": "Archivé",
  "notebook.auditTrail.action.created": "Créé",
  "notebook.auditTrail.action.finalized": "Finalisé",
  "notebook.auditTrail.action.locked": "verouillé",
  "notebook.auditTrail.action.submitted": "Soumis",
  "notebook.auditTrail.action.updated": "Mis à Jour ",
  "notebook.auditTrail.comingSoon": "La fonctionnalité de journalisation des audits sera bientôt disponible.",
  "notebook.auditTrail.none.subtitle": "Aucun enregistrement de suivi n’a été trouvé pour ce cahier.",
  "notebook.auditTrail.none.title": "Aucune piste d'audit disponible",
  "notebook.auditTrail.title": "Formulaire d'Audit",
  "notebook.button.edit": "Modifier",
  "notebook.button.editResults": "Afficher les résultats",
  "notebook.button.enterResults": "Saisir les résultats",
  "notebook.button.newLabNotebook": "Projet",
  "notebook.button.view": "Voir",
  "notebook.comments.add.button": "Ajouter un commentaire",
  "notebook.comments.add.label": "Ajouter un commentaire",
  "notebook.comments.none.subtitle": "Aucun commentaire n'a encore été ajouté.",
  "notebook.comments.none.title": "Pas de commentaires",
  "notebook.comments.title": "Commentaires",
  "notebook.error.notAssigned": "Vous n’êtes pas affecté à ce projet",
  "notebook.heading.allEntries": "Toutes les saisies",
  "notebook.heading.notebooks": "Les Projets",
  "notebook.icon.edit": "Modifier",
  "notebook.instruments.title": "Instruments",
  "notebook.label.addpage": "Ajouter un page",
  "notebook.label.author": "Auteur",
  "notebook.label.basicinfo": "Informations de base",
  "notebook.label.content": "Contenu principal",
  "notebook.label.dashboard": "Tableau de bord des notes",
  "notebook.label.drafts": "Brouillons",
  "notebook.label.entry": "Saisie dans le carnet de notes",
  "notebook.label.entryFiles": "Fichiers d’entrée",
  "notebook.label.instanceEntry": "Entrée d'instance de carnet de notes",
  "notebook.label.entryTags": "Saisie les étiquettes ",
  "notebook.label.experimentDoc": "Documentation relative à l'expérience",
  "notebook.label.experimentType": "Type d'expérience",
  "notebook.label.filter.types": "les types d'expérience",
  "notebook.label.finalized": "Terminé cette semaine",
  "notebook.label.formEntry": "Saisie du formulaire de note",
  "notebook.label.objective": "Objectif",
  "notebook.label.pages": "Pages des flux de données",
  "notebook.label.pending": "En attente de révision",
  "notebook.label.project": "Projet",
  "notebook.label.project.title": "Nom du Projet",
  "notebook.label.projectFiles": "Fichiers du projet",
  "notebook.label.projectTags": "Libelle du projet ",
  "notebook.label.protocol": "Identifiant du protocole",
  "notebook.label.questionnaire": "Questionnaire",
  "notebook.label.sampleManagement": "Gestion des échantillons",
  "notebook.label.status": "Statut",
  "notebook.label.technician": "Nom du technicien",
  "notebook.label.title": "Saisie le Titre",
  "notebook.label.total": "Total saisie ",
  "notebook.page.completed": "Terminé",
  "notebook.page.content": "Contenu:",
  "notebook.page.instructions": "Instructions",
  "notebook.page.markComplete": "Marquer comme terminé",
  "notebook.page.modal.add.errorRequired": "Le titre et le contenu sont obligatoires.",
  "notebook.page.modal.add.title": "Ajouter une nouvelle page",
  "notebook.page.modal.content.label": "Contenu",
  "notebook.page.modal.edit.title": "Modifier la page",
  "notebook.page.modal.instructions.label": "Instructions",
  "notebook.page.modal.title.label": "Titre",
  "notebook.page.title": "Carnet de notes",
  "notebook.pages.none.subtitle": "Cliquez pour ajouter des pages",
  "notebook.pages.none.title": "Aucune page ajoutée",
  "notebook.project.definition.form.title": "Formulaire pour définir le projet",
  "notebook.project.entry.form.title": "Formulaire de saisie du projet",
  "notebook.results.modal.title": "Résultats par numéro de laboratoire",
  "notebook.results.noAccession": "Pas de numéro de laboratoire disponible pour cet échantillon",
  "notebook.results.none.subtitle": "Aucun résultat trouvé pour le numéro d'accès fourni.",
  "notebook.results.none.title": "Aucun résultat trouvé",
  "notebook.results.title": "Résultats",
  "notebook.sample.result.dateCreated": "Date de création",
  "notebook.samples.available": "Échantillons disponibles",
  "notebook.samples.none.subtitle": "Recherche d'échantillons par patient ou par numéro de laboratoire",
  "notebook.samples.none.subtitle.selected": "Cliquez pour ajouter des échantillons",
  "notebook.samples.none.title": "Aucun échantillon disponible",
  "notebook.samples.none.title.selected": "Aucun échantillon sélectionné",
  "notebook.samples.resultsRecorded": "Résultats enregistrés :",
  "notebook.samples.selected": "Échantillons sélectionnés",
  "notebook.search.byAccession": "Recherche par numéro de laboratoire ",
  "notebook.search.byPatient": "Recherche par Patient",
  "notebook.select.label": "Sélectionnez le bloc-notes",
  "notebook.select.none": "Aucun - champs par défaut uniquement",
  "notebook.select.optional": "Sélectionner un cahier de laboratoire (facultatif)",
  "notebook.status.archived": "Saisie des archives",
  "notebook.status.assignment.title": "Statut et affectation",
  "notebook.status.draft": "Enregistrer le brouillon",
  "notebook.status.finalized": "Sauvegarder la saisie ",
  "notebook.status.locked": "verrouiller la saisie ",
  "notebook.status.metadata.title": "Statut et métadonnées",
  "notebook.status.submitted": "Soumis pour revue",
  "notebook.tab.attachments": "Pièces jointes",
  "notebook.tab.auditTrail": "Formulaire d'Audit",
  "notebook.tab.comments": "Commentaires",
  "notebook.tab.content": "Contenu",
  "notebook.tab.entryDetails": "Saisie les détails ",
  "notebook.tab.metadata": "Données volumineuses ",
  "notebook.tab.results": "Résultats",
  "notebook.tab.samples": "Échantillons",
  "notebook.tab.workflow": "Plan de travail",
  "notebook.table.header.entries": "Saisies",
  "notebook.tag.placeholder": "Saisir des étiquettes",
  "notebook.tags.add": "Ajouter une balise",
  "notebook.tags.modal.add.errorRequired": "l'étiquette est requise.",
  "notebook.tags.modal.add.label": "Etiquette ",
  "notebook.tags.modal.add.title": "Ajouter une nouvelle étiquette ",
  "notebook.tags.title": "Etiquettes ",
  "notebook.validation.content.required": "Contenu principal obligatoire",
  "notebook.validation.objective.required": "L'objectif est obligatoire",
  "notebook.validation.project.required": "Projet obligatoire",
  "notebook.validation.protocol.required": "Identifiant du protocole obligatoire",
  "notebook.validation.title.required": "Titre obligatoire",
  "notebook.validation.type.required": "Le type d'expérience est requis.",
  "notification.error": "Erreur",
  "notification.info": "Information",
  "notification.invalid.confirm.password": "Votre mot de passe saisi n'est pas identique au mot de passe ci-dessus.",
  "notification.invalid.loginName": "Veuillez saisir des valeurs alphanumériques sans espaces uniquement.",
  "notification.invalid.name": "Veuillez saisir uniquement des caractères alphanumériques.",
  "notification.invalid.password": "Veuillez entrer le mot de passe selon les instructions.",
  "notification.login.generic.error": "Erreur de connexion générique",
  "notification.login.syntax.error": "Erreur de syntaxe dans le nom d'utilisateur ou le mot de passe",
  "notification.organization.post.delete.success": "L'organisation a été désactivée avec succès.",
  "notification.organization.post.internetAddress": "Entrez une URL d'organisation valide.",
  "notification.organization.post.save.success": "Informations sur l'organisation ajoutées avec succès.",
  "notification.organization.post.success": "Informations sur l'organisation mises à jour avec succès.",
  "notification.password.change.fail": "Échec du changement de mot de passe",
  "notification.password.change.success": "Mot de passe modifié avec succès",
  "notification.response.syntax.error": "Erreur de syntaxe de la réponse",
  "notification.resultSelectList.post.save.success": "Liste de sélection de résultats enregistrée avec succès.",
  "notification.resultSelectList.post.update.success": "Liste de sélection de résultats mise à jour avec succès.",
  "notification.slideover.button.hideread": "Masquer les lus",
  "notification.slideover.button.markallasread": "Marquer tout comme lu",
  "notification.slideover.button.markasread": "Marquer comme lu",
  "notification.slideover.button.reload": "Recharger",
  "notification.slideover.button.showread": "Afficher les lus",
  "notification.slideover.button.subscribe": "S'abonner sur cet appareil",
  "notification.slideover.button.subscribe.fail": "Échec de l'abonnement",
  "notification.slideover.button.subscribe.success": "Abonnement réussi",
  "notification.slideover.button.unsubscribe": "Se désabonner",
  "notification.slideover.button.unsubscribe.fail": "Échec de l'annulation de l'abonnement",
  "notification.slideover.button.unsubscribe.success": "Désabonnement réussi",
  "notification.slideover.empty.header": "Vous êtes à jour",
  "notification.sliderover.empty.message": "Vous n'avez pas de notifications pour le moment.",
  "notification.success": "Succès",
  "notification.title": "Message de notification",
  "notification.user.add.success": "Informations utilisateur ajoutées avec succès.",
  "notification.user.post.delete.success": "Utilisateur désactivé avec succès.",
  "notification.user.post.save.success": "Informations utilisateur ajoutées avec succès.",
  "notification.user.update.success": "Informations utilisateur mises à jour avec succès.",
  "notify.error": "Utilisateur et message sont requis",
  "notify.main.title": "Notifier l'utilisateur",
  "notify.message": "Message",
  "notify.user.by": "Utilisateur à notifier",
  "notify.user.success.notification": "Notification envoyée avec succès",
  "of": "de",
  "openreports.activity.title": "Rapports d'activité",
  "openreports.aggregate.title": "Rapports agrégés",
  "openreports.all.test.summary.title": "Résumé du rapport de test",
  "openreports.all.tests.aggregate": "Résumé de tous les tests",
  "openreports.hiv.aggregate": "Résumé du Test VIH",
  "openreports.management.title": "Rapports de gestion",
  "openreports.mgt.nonconformity.date": "Rapport des non-conformités par date",
  "openreports.mgt.nonconformity.section": "Rapport des non-conformités par unité et raison",
  "openreports.mgt.rejection": "Rapport de rejet",
  "openreports.patient.EID.version1": "EID Version 1",
  "openreports.patient.EID.version2": "EID Version 2",
  "openreports.patient.VL.version1": "VL Version Nationale",
  "openreports.patientTestStatus": "Résultats du patient",
  "openreports.patientreports.title": "Résultats du patient",
  "openreports.stat.aggregate": "Rapport statistique",
  "order.accept": "Valider",
  "order.accept.error": "Échec de l’acceptation de la prescription",
  "order.additionalInfo": "Informations complémentaires",
  "order.additionalInfo.helper": "Notes facultatives concernant cette prescription ",
  "order.clinicalInfo": "Informations cliniques",
  "order.continue": "Continuer",
  "order.current.time": "Heure actuelle (hh:mm)",
  "order.dashboard.empty": "Aucune demande d'examen trouvée ",
  "order.dashboard.title": " Tableau de bord des demandes d'examen",
  "order.department.label": "Service/département/unité:",
  "order.diagnosis.helper": "Diagnostic provisoire — sert de base au choix des examens. Non enregistré comme diagnostic confirmé.",
  "order.diagnosis.placeholder": "Saisir le diagnostic ou les notes cliniques",
  "order.entry.setup": "Configuration de saisie de commande par lot",
  "order.external": "Externe",
  "order.facility": "Établissement",
  "order.filter.priority": "Filtrer par priorité",
  "order.filter.status": "Filtrer par statut",
  "order.fixIssue": "Corriger le problème ",
  "order.form.label": "Formulaire :",
  "order.form.select": "Sélectionner le formulaire",
  "order.generate.barcode": "Générer un code-barres",
  "order.generate.barcode.history": "Historique des codes-barres générés",
  "order.if.other.label": "si Autre préciser:",
  "order.invalid.requester.name.label": "nom du prescripteur invalide",
  "order.invalid.site.name": "Nom de site invalide",
  "order.labNumber": "Numéro laboratoire",
  "order.labNumber.generate": "Générer le numéro laboratoire",
  "order.labNumber.helper": "Identifiant unique pour cette demande d'examen",
  "order.attachment.action.delete": "Supprimer la pièce jointe",
  "order.attachment.action.download": "Télécharger la pièce jointe",
  "order.attachment.action.view": "Voir la pièce jointe",
  "order.attachment.column.actions": "Actions",
  "order.attachment.column.fileName": "Nom du fichier",
  "order.attachment.column.fileSize": "Taille",
  "order.attachment.column.fileType": "Type",
  "order.attachment.column.uploadedAt": "Téléversé le",
  "order.attachment.delete.confirm.body": "Êtes-vous sûr de vouloir supprimer « {fileName} » ? Cette action est irréversible.",
  "order.attachment.delete.confirm.title": "Supprimer la pièce jointe",
  "order.attachment.delete.failed": "Impossible de supprimer la pièce jointe. Veuillez réessayer.",
  "order.attachment.dropzone": "Glissez-déposez les fichiers ici ou cliquez pour parcourir",
  "order.attachment.empty": "Aucune pièce jointe pour le moment",
  "order.attachment.saveFirst": "Enregistrez la demande pour ajouter des pièces jointes.",
  "order.attachment.error.maxFiles": "ous pouvez joindre au maximum {maxFiles} fichiers.",
  "order.attachment.error.size": "Chaque fichier doit faire {maxSize} ou moins.",
  "order.attachment.error.type": "Types de fichiers autorisés : {types}",
  "order.attachment.heading": "Pièces jointes",
  "order.attachment.hint": "Optionnel. Jusqu’à {maxFiles} fichiers, 10 Mo chacun. Formats autorisés : PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "Une ou plusieurs pièces jointes n’ont pas pu être téléversées.",
  "order.labNumber.placeholder": "Saisir ou générer le numéro laboratoire",
  "order.label.add": "Ajouter une ordonnance",
  "order.label.modify": "Modifier le bulletin d'analyse",
  "order.legend.EDTATube": "Tube EDTA",
  "order.legend.commonFields": "Champs communs",
  "order.legend.configureBarcode": "Configurer la saisie du code-barres",
  "order.legend.dryBloodSpot": "Tache de sang sec",
  "order.legend.dryTube": "Tube sec",
  "order.legend.facility": "Établissement",
  "order.legend.onDemand": "À la demande",
  "order.legend.optionalFields": "Champs optionnels",
  "order.legend.patient": "Patient",
  "order.legend.preDemand": "Demande anticipée",
  "order.legend.sample": "Échantillon",
  "order.legend.selectMethod": "Sélectionner la méthode",
  "order.legend.siteName": "Nom du site",
  "order.legend.specimen.collected": "Spécimen collecté",
  "order.legend.tests": "Analyses",
  "order.legend.viralLoadTest": "Test de charge virale",
  "order.lastUpdated": "Dernière mise à jour",
  "order.load.error": "Échec du chargement de la demande d'examen",
  "order.location": "Emplacement",
  "order.new": "Nouvelle prescription",
  "order.payment.status.label": "Statut de paiement du patient:",
  "order.paymentStatus": "Statut du paiement",
  "order.previousLabNumber": "Numéro laboratoire précédent",
  "order.previousLabNumber.placeholder": "Saisir le numéro laboratoire précédent si applicable",
  "order.printLabels": "Imprimer les étiquettes ",
  "order.printLabels.info": " Imprimer les codes-barres pour cette demande d'examen ",
  "order.priority": "Priorité",
  "order.progress": "Progrès",
  "order.provisionalDiagnosis": "Diagnostic provisoire",
  "order.received.time": "Heure à laquelle la commande a été reçue",
  "order.reception.time": "Heure de réception (hh:mm) :",
  "order.remember.site.and.requester.label": "Se souvenir du site et du prescripteur",
  "order.readonly.message": "Cette demande d'examen est en mode lecture seule",
  "order.requester": "Prescripteur",
  "order.requester.email.label": "Courriel du prescripteur:",
  "order.requester.fax.label": "Numéro de fax du prescripteur:",
  "order.requester.firstName.label": "Prénom du prescripteur:",
  "order.requester.lastName.label": "Nom du prescripteur:",
  "order.requester.phone.label": "Téléphone du prescripteur:",
  "order.requester.provisionalDiagnosis.label": "Renseignement clinique:",
  "order.result.reporting.heading": "RAPPORT DE RÉSULTATS",
  "order.sampleCategory": "Catégorie d’échantillon ",
  "order.sampleCategory.helper": "Sélectionner la catégorie d’échantillon à prélever ",
  "order.sampling.performed.label": "Échantillonnage effectué pour analyse:",
  "order.search.requester.label": "Prescripteur",
  "order.saveStatus.error": "Échec de l'enregistrement",
  "order.saveStatus.saved": "Enregistré",
  "order.saveStatus.saving": "Enregistrement...",
  "order.saveStatus.unsaved": "Modifications non enregistrées",
  "order.save.blocked": "La commande n'a pas été enregistrée",
  "order.save.notPersisted": "Le serveur a accepté la demande mais n'a enregistré aucun échantillon. Vérifiez la demande avant de continuer.",
  "order.save.incomplete": "Veuillez ajouter un patient (ou un site de prélèvement) et au moins un type d’échantillon avant d’enregistrer. ",
  "order.save.incomplete.fields": "Ajoutez {fields} avant d'enregistrer.",
  "order.save.incomplete.and": "et",
  "order.save.requirements.title": "Requis avant l'enregistrement",
  "order.save.requirement.labNumber": "un numéro de laboratoire",
  "order.save.requirement.patient": "un patient",
  "order.save.requirement.samplingSite": "un site d'échantillonnage",
  "order.save.requirement.collectionSite": "un site de prélèvement",
  "order.save.requirement.requesterOrRequestor": "une organisation demandeuse ou un demandeur",
  "order.sample.missingTests": "L'échantillon {sampleNumber} a un type d'échantillon mais aucune analyse. Ajoutez une analyse ou retirez l'échantillon avant d'enregistrer.",
  "order.save.requirement.sampleType": "au moins un type d'échantillon",
  "order.save.requirement.site": "un site demandeur",
  "order.save.requirement.patientSex": "le sexe du patient",
  "order.save.requirement.patientBirthDate": "la date de naissance du patient",
  "order.save.requirement.nationalId": "le numéro d'identification national du patient",
  "order.save.requirement.validEmail": "une adresse e-mail valide",
  "order.requestDate": "Date de Commande",
  "order.nextVisitDate": "Date de la prochaine visite",
  "order.sampleHandling": "Manipulation des échantillons",
  "sampleAcceptance.qa.button.continueWithTesting": "Poursuivre les analyses",
  "sampleAcceptance.qa.continueWithTesting.reason": "Pourquoi cet échantillon est-il analysé malgré l'échec du contrôle ?",
  "sampleAcceptance.qa.continueWithTesting.record": "Enregistrer et continuer",
  "order.eqaSample": "Échantillon d'évaluation externe de la qualité (EEQ)",
  "order.noPatient": "Cette demande n'a pas de patient",
  "order.noPatient.reason": "Motif de la demande sans patient",
  "order.noPatient.reason.eqa": "Échantillon d'évaluation externe de la qualité",
  "order.noPatient.warning.title": "Les résultats ne seront pas évalués par rapport à un intervalle de référence",
  "order.noPatient.warning.subtitle": "Sans patient, il n'y a ni âge ni sexe pour sélectionner un intervalle de référence ; les résultats de cette demande ne seront donc pas signalés comme normaux ou anormaux.",
  "order.noPatient.butPatientChosen": "Un patient est associé à cette demande ; la décision sans patient ne sera donc pas enregistrée.",
  "order.rangeNotApplied.warning.title": "Certains résultats ne seront pas comparés à un intervalle de référence",
  "order.rangeNotApplied.warning.subtitle": "Le sexe ou l'âge du patient n'est pas enregistré, et ces analyses ont des intervalles qui en dépendent : {tests}. Leurs résultats devront être vérifiés avant leur diffusion.",
  "order.rangeNotApplied.warning.reportNce": "Signaler une non-conformité",
  "order.eqa.program": "Programme EEQ",
  "order.eqa.providerSampleId": "ID d'échantillon du prestataire",
  "order.eqa.deadline": "Date limite de soumission",
  "order.eqa.priority": "Priorité EQA",
  "order.rememberSiteAndRequester": "Mémoriser ce site et ce prescripteur pour ma prochaine demande",
  "order.testLocationCode": "Prélèvement effectué à",
  "order.testLocationCode.other": "Autre",
  "order.testLocationCode.otherLabel": "Si autre, préciser",
  "provider.fax.invalid": "Saisissez un numéro de fax valide (chiffres et + ( ) - uniquement).",
  "provider.email.invalid": "Saisissez une adresse e-mail valide, par exemple lab@example.org.",
  "order.save.requirement.provider": "un prescripteur",
  "order.save.requirement.testsPerSample": "au moins une analyse ou un panel pour chaque échantillon",
  "order.saved.draft": "Brouillon enregistré ",
  "order.saved.title": "Commande « {labNumber} » enregistrée",
  "order.saved.next": "Suivante : {step}",
  "order.search.placeholder": "Rechercher des demandes d'examen … ",
  "order.search.site.name": "Site de prélèvement",
  "order.send.toAnalyzer": "Envoyer à l'analyseur",
  "order.send.modal.title": "Envoyer la commande à l'analyseur",
  "order.send.modal.confirm": "Envoyer",
  "order.send.modal.cancel": "Annuler",
  "order.send.modal.analyzerLabel": "Analyseur de cibles",
  "order.send.modal.accession": "Numéro de laboratoire : {accession}",
  "order.send.modal.noAnalyzers": "Non, aucun analyseur n'est configuré pour l'envoi de demandes initié par le LIS.",
  "order.send.success": "Commande expédiée",
  "order.send.error": "Échec de l'expédition de la commande",
  "order.send.unknownError": "Erreur de pont inconnue",
  "order.send.missingAccession": "La commande ne comporte pas de numéro de laboratoire permettant de recouper le résultat.",
  "order.site.name": "Nom du site:",
  "order.step.collect": "Prélever",
  "order.step.complete": "Terminé",
  "order.step.enter": "Saisir la demande d’examen",
  "order.step.label": " Étiqueter et stocker",
  "order.step.patient.info": "Patient",
  "order.step.program.selection": "Sélection du programme",
  "order.step.qa": "Revue Assurance Qualité",
  "order.step.prepare": "Préparer les échantillons",
  "order.step.sampleCheck": "Vérification de l'échantillon",
  "order.step.notStarted": "Non commencé",
  "order.step.done": "Terminer",
  "order.step.doneAt": "Terminé {time}",
  "order.step.toDo": "{count} à faire",
  "order.step.ready": "Prêt",
  "order.nav.saveExit": "Enregistrer et quitter",
  "order.nav.saveNext": "Enregistrer et continuer",
  "order.nav.saveFinish": "Enregistrer et terminer",
  "order.nav.discard.title": "Abandonner les modifications non enregistrées ?",
  "order.nav.discard.body": "Les modifications non enregistrées sur cette page seront perdues ({samples} échantillons, {tests} analyses).",
  "order.nav.discard.order": "Abandonner la demande",
  "order.nav.discard.changes": "Abandonner les modifications",
  "order.continue.heading": "Pour passer à {step}",
  "order.continue.count": "{count} éléments requis pour continuer",
  "order.continue.countOne": "1 élément requis pour continuer",
  "order.continue.item.patient": "Sélectionner ou créer le patient",
  "order.continue.item.labNumber": "Ajouter un numéro de laboratoire",
  "order.continue.item.nationalId": "Saisir le numéro d'identification national du patient",
  "order.continue.item.patientSex": "Choisir le sexe du patient",
  "order.continue.item.birthDate": "Saisir la date de naissance du patient",
  "order.continue.item.sampleType": "Ajouter au moins un type d'échantillon",
  "order.continue.item.provider": "Ajouter le prescripteur",
  "order.continue.item.noTests": "Échantillon {number} : choisir au moins une analyse",
  "order.continue.item.noTestsOnSample": "{sample} n'a aucune analyse. Ajoutez-en dans Saisie de la demande ou retirez l'échantillon",
  "errors.samples.with.no.tests": "Un échantillon n'a aucune analyse. Ajoutez des analyses dans Saisir la demande ou supprimez l'échantillon.",
  "order.continue.item.collectionTime": "Date et heure de prélèvement pour {sample}",
  "order.continue.item.consent": "Enregistrer le consentement",
  "order.continue.item.acceptance": "Répondre à la liste de contrôle d'acceptation de l'échantillon",
  "order.status.entered": "Saisi",
  "order.status.samplesPrepared": "Échantillons préparés",
  "order.status.readyForTesting": "Prêt pour analyse",
  "order.status.cancelled": "Annulé",
  "order.status.complete": "Terminé",
  "order.cancelled.notice": "Cette demande a été annulée : {reason}",
  "order.cancelled": "Cette demande est déjà annulée",
  "order.notFound": "Demande d'examens non trouvée",
  "order.cancel.reasonRequired": "Un motif d'annulation est requis",
  "order.cancel.complete": "La saisie de la demande est terminée ; cette demande ne peut plus être annulée ici",
  "order.cancel.inProgress": "Les analyses ont commencé pour cette demande ; elle ne peut plus être annulée ici",
  "order.release.prepareIncomplete": "« Préparer les échantillons » n'est pas terminé",
  "order.release.reasonRequired": "Motif de la libération avant l'acceptation de tous les échantillons",
  "order.finish.title": "Demande {labNo} terminée",
  "order.finish.subtitle": "La saisie de la demande est terminée. Les résultats peuvent être saisis à mesure qu'ils arrivent.",
  "order.finish.backToOrders": "Retour aux demandes",
  "order.finish.awaiting": "Échantillon encore attendu pour : {tests}",
  "order.sampleCheck.release": "Libérer pour analyse",
  "order.sampleCheck.return": "Retour à « Préparer les échantillons »",
  "order.sampleCheck.proceedReason": "Motif de la libération avant l'acceptation de tous les échantillons",
  "order.sampleCheck.notAcceptedYet": "Pas encore acceptés : {samples}. Les réponses sont prises en compte une fois que vous appuyez sur Accepter l'échantillon.",
  "order.sampleCheck.released": "Demande {labNo} libérée pour analyse",
  "order.sampleCheck.disabled.incomplete": "« Préparer les échantillons » n'est pas terminé. Ouvrez cette étape et terminez d'abord les échantillons.",
  "order.dashboard.cancelOrder": "Annuler la demande",
  "order.dashboard.cancel.reason": "Motif d'annulation",
  "order.dashboard.cancel.reasonOther": "Décrivez le motif",
  "order.dashboard.cancel.other": "Autre",
  "order.dashboard.cancel.confirm": "Annuler la demande {labNo} ?",
  "order.dashboard.cancel.body": "Ses analyses sont annulées et ses échantillons invalidés. Rien n'est supprimé.",
  "order.dashboard.cancelled": "Demande {labNo} annulée",
  "order.dashboard.filter.cancelled": "Annulé",
  "order.dashboard.open": "Ouvert",
  "order.samples.printLabels": "Imprimer les étiquettes",
  "order.samples.notStored": "Non stocké",
  "storage.noSamples": "Ajoutez un échantillon ci-dessus pour le stocker.",
  "common.discard": "Ignorer",
  "common.stay": "Rester",
  "order.start.new": "Démarrer une nouvelle demande",
  "order.submit.labNumber": "Soumettre avec numéro laboratoire",
  "order.submit.success": "Demande d’examen soumise avec succès",
  "order.submit.success.labNumber": "Numéro de laboratoire : {labNumber}",
  "order.submitted.success.msg": "La demande d’examen a été soumise avec succès",
  "order.summary.accessionNumber": "Numéro d'enregistrement",
  "order.summary.collectionDate": "Date de prélèvement",
  "order.dashboard.status.all": "Tous les statuts",
  "order.dashboard.status.inProgress": "En cours",
  "order.dashboard.status.pendingQa": "En attente de vérification de l'échantillon",
  "order.dashboard.status.completed": "Terminé",
  "order.dashboard.status.hasReferred": "Contient des analyses envoyées",
  "order.dashboard.status.referredOut": "Référé à un laboratoire externe",
  "order.dashboard.priority.all": "Toutes les priorités",
  "order.dashboard.priority.stat": "Urgent",
  "order.dashboard.priority.asap": "Dès que possible",
  "order.dashboard.priority.timed": "Programmé",
  "order.dashboard.priority.routine": "Routine",
  "order.summary.patientName": "Nom du patient",
  "order.summary.sampleType": "Type d'échantillon",
  "order.summary.title": "Résumé de la prescription",
  "order.test.request.heading": "Requête de test",
  "order.title": "COMMANDE",
  "ordertests.title": "Analyses de la demande d'examen",
  "organization.add.placeholder": "Valeurs alphanumériques",
  "organization.add.placeholder.active": "Oui ou Non",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Ajouter un parent de l'organisation",
  "organization.add.title": "Ajouter une organisation",
  "organization.city": "Ville",
  "organization.clia.number": "Numéro de CLIA",
  "organization.edit.title": "Modifier l'organisation",
  "organization.internetaddress": "Adresse Internet",
  "organization.isActive": "La catégorie est active",
  "organization.main.title": "Gestion des organisations",
  "organization.next": "Page suivante",
  "organization.organizationName": "Nom de l'organisation",
  "organization.parent": "Organisation parent",
  "organization.previous": "Page précédente",
  "organization.search.byorgname": "Rechercher par nom d'organisation",
  "organization.search.parent.name": "Noms des organisations parentes",
  "organization.search.placeHolder": "Rechercher par nom d'organisation...",
  "organization.select": "Sélectionner",
  "organization.short.CI": "Préfixe de l'organisation",
  "organization.streetAddress": "Adresse de la rue",
  "organization.type.CI": "Type d'organisation",
  "organization.type.CI.description": "Description du type d'organisation",
  "organization.type.CI.name": "Nom du type d'organisation",
  "organization.type.CI.select": "Sélectionner le type d'organisation",
  "otherMalignant.placeholder": "Autre malin",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Back",
  "pagination.backward": "Page précédente",
  "pagination.forward": "Page suivante",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} de {total} entrées",
  "pagination.items-on-page": "{count} {count, plural, one {élément} other {éléments}} sur cette page",
  "pagination.items-per-page": "Entrées par page",
  "pagination.itemsPerPage": "Items per page:",
  "pagination.nextPage": "Next page",
  "pagination.page": "page {page}",
  "pagination.page-number": "Numéro de page",
  "pagination.page-range": "de {total} {total, plural, one {page} other {pages}}",
  "pagination.previousPage": "Previous page",
  "panel.existing": "Panneaux existants",
  "panel.existing.inactive": "Panneaux inactifs (Attribuer des tests pour activer)",
  "panel.new": "Nouveau panneau",
  "panel.panelName": "Nom du panel",
  "pathology.action.addCassette": "Ajouter une cassette",
  "pathology.action.addSlide": "Ajouter une lame",
  "pathology.action.deactivateBlock": "Désactiver le bloc {designation}",
  "pathology.action.deactivateCassette": "Désactiver la cassette {designation}",
  "pathology.action.deactivateSlide": "Désactiver la lame {barcode}",
  "pathology.action.printCassetteLabels": "Imprimer toutes les étiquettes de cassette",
  "pathology.action.printSlideLabels": "Imprimer toutes les étiquettes de lame",
  "pathology.badge.cassetteCount": "{count, plural, one {# cassette} many {# cassettes} other {# cassettes}}",
  "pathology.badge.openRequestCount": "{count} en cours",
  "pathology.badge.openRequests": "Demandes en cours : {names}",
  "pathology.badge.openRequestsMore": "Demandes en cours : {names} et {count} autres",
  "pathology.badge.slideCount": "{count, plural, one {# lame} many {# lames} other {# lames}}",
  "pathology.banner.transitionsLater": "Les transitions de stade arriveront dans une version ultérieure. Définissez le stade ici pour le moment.",
  "pathology.empty.noReports": "Aucun rapport pour l'instant. Complétez les observations et la conclusion pour en générer un.",
  "pathology.empty.stageNotRecorded": "OpenELIS n'enregistre pas encore le travail à ce stade. Le cas peut tout de même passer par ce stade.",
  "pathology.error.designationConflict": "Une autre sauvegarde a modifié ce cas au même moment. Rechargez le cas et réessayez.",
  "pathology.label.addslide": "Ajouter une Lame(s)",
  "pathology.label.block": "Bloc",
  "pathology.label.block.number": "Numéro du Bloc",
  "pathology.label.blocks": "Blocs",
  "pathology.label.case": "Cas de pathologie",
  "pathology.label.caseTitle": "Cas de pathologie {labNumber}",
  "pathology.label.casesInProgress": "Cas en cours",
  "pathology.label.cassette": "Cassette",
  "pathology.label.cassettes": "Cassettes",
  "pathology.label.complete": "Terminé",
  "pathology.label.conclusion": "Conclusion",
  "pathology.label.dashboard": "Tableau de Bord de la Pathologie",
  "pathology.label.deactivating": "Désactivation",
  "pathology.label.designationPending": "Attribué à l'enregistrement",
  "pathology.label.grossexam": "Examen Macroscopique",
  "pathology.label.location": "Emplacement",
  "pathology.label.microexam": "Examen Microscopique",
  "pathology.label.newCassette": "Nouvelle cassette {position}",
  "pathology.label.newSlide": "Nouvelle lame {position}",
  "pathology.label.parentBlock": "Coupée dans le bloc",
  "pathology.label.printlabel": "Imprimer l'étiquette",
  "pathology.label.refer": "Référer à l'Immuno-Histochimie",
  "pathology.label.release": "Prêt pour la Publication",
  "pathology.label.report": "Rapport de Pathologie",
  "pathology.label.request": "Demandes",
  "pathology.label.requests": "Demandes pathologiques supplémentaires",
  "pathology.label.review": "En attente de révision pathologique",
  "pathology.label.slide": "Lame",
  "pathology.label.slide.add.number": "Ajouter un numéro de lame",
  "pathology.label.slide.number": "numéro de diapositive",
  "pathology.label.slides": "Lames",
  "pathology.label.stage": "Stade",
  "pathology.label.techniques": "Techniques Utilisées",
  "pathology.label.textconclusion": "Conclusion Textuelle",
  "pathology.label.title": "Pathologie",
  "pathology.label.view": "Voir la fiche",
  "pathology.locked.nothingToPrint": "Aucune étiquette enregistrée à imprimer",
  "pathology.locked.reasonRequired": "Indiquez un motif avant de désactiver",
  "pathology.locked.releaseNoPathologist": "Un pathologiste doit être affecté avant que le cas puisse être publié",
  "pathology.locked.releaseNoTechnician": "Un technicien doit être affecté avant que le cas puisse être publié",
  "pathology.locked.saveBeforeDeactivate": "Enregistrez ou annulez vos modifications avant de désactiver",
  "pathology.locked.slideNeedsBlock": "Choisissez le bloc dans lequel cette lame a été coupée",
  "pathology.locked.slideNeedsSavedBlock": "Enregistrez une cassette avant d'ajouter une lame",
  "pathology.locked.stageDisabled": "Non suivi dans ce laboratoire",
  "pathology.modal.deactivateBlockHeading": "Désactiver le bloc {designation} ?",
  "pathology.modal.deactivateBody": "L'enregistrement est conservé et reste visible avec Afficher les désactivés. Les cassettes, blocs et lames ne sont jamais supprimés.",
  "pathology.modal.deactivateCassetteHeading": "Désactiver la cassette {designation} ?",
  "pathology.modal.deactivateFailed": "La désactivation a été refusée. Rechargez le cas et réessayez.",
  "pathology.modal.deactivateSlideHeading": "Désactiver la lame {barcode} ?",
  "pathology.section.caseInfo": "Informations sur le cas",
  "pathology.section.findings": "Observations et conclusion",
  "pathology.section.review": "Vérification par le pathologiste",
  "pathology.stage.accessioned": "Enregistré",
  "pathology.stage.completed": "Terminé",
  "pathology.stage.coverslipping": "Montage des lamelles et CQ",
  "pathology.stage.decalcification": "Décalcification",
  "pathology.stage.embedding": "Inclusion",
  "pathology.stage.grossing": "Macroscopie",
  "pathology.stage.microtomy": "Microtomie",
  "pathology.stage.processing": "Traitement",
  "pathology.stage.readyPathologist": "Prêt pour le pathologiste",
  "pathology.stage.staining": "Coloration",
  "pathology.stage.underReview": "En cours de vérification par le pathologiste",
  "pathology.toast.blockDeactivated": "Bloc {designation} désactivé",
  "pathology.toast.cassetteDeactivated": "Cassette {designation} désactivée",
  "pathology.toast.slideDeactivated": "Lame {barcode} désactivée",
  "patient.address.camp": "Camp/Commune",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hameau / Lotissement ",
  "patient.address.healthdistrict": "District",
  "patient.address.healthregion": "Région",
  "patient.address.province": "Province",
  "patient.address.street": "Rue",
  "patient.address.town": "Ville",
  "patient.age.days": "Jours",
  "patient.age.months": "Mois",
  "patient.age.years": "Âge en années",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Nom de la source de données du patient",
  "patient.dob": "Date de naissance",
  "patient.dob.future": "La date de naissance ne peut pas être dans le futur.",
  "patient.validation.contactEmailInvalid": "Saisissez une adresse e-mail valide pour le contact.",
  "patient.validation.dobInvalid": "Saisissez une date de naissance valide.",
  "patient.validation.dobOrAgeRequired": "Saisissez une date de naissance ou un âge en années, mois ou jours.",
  "patient.validation.emailInvalid": "Saisissez une adresse e-mail valide.",
  "patient.validation.nationalIdRequired": "Saisissez le numéro de la carte nationale d'identité.",
  "patient.validation.sexRequired": "Sélectionnez le sexe du patient.",
  "patient.eduction": "Éducation",
  "patient.emergency.additional.camp": "Entrez le camp/commune",
  "patient.emergency.additional.district": "Entrez le district",
  "patient.emergency.additional.education": "Entrez l'éducation",
  "patient.emergency.additional.maritalstatus": "Entrez l'état civil",
  "patient.emergency.additional.nationnality": "Entrez la nationalité",
  "patient.emergency.additional.othernationality": "Entrez une autre nationalité",
  "patient.emergency.additional.region": "Entrez la région",
  "patient.emergency.additional.street": "Entrez la rue",
  "patient.emergency.additional.town": "Entrez la ville",
  "patient.emergency.email": "Entrez l'e-mail du contact d'urgence",
  "patient.emergency.firstname": "Entrez le prénom du contact d'urgence",
  "patient.emergency.lastname": "Entrez le nom de famille du contact d'urgence",
  "patient.emergency.phone": "Entrez le numéro de téléphone du contact d'urgence",
  "patient.externalId": "Carte nationale d’identité",
  "patient.female": "Femelle",
  "patient.first.name": "Prénom",
  "patient.gender": "Sexe",
  "patient.gps.latitude": "Latitude GPS ",
  "patient.gps.latitude.placeholder": "ex. -18.879190 (plage -90 à 90)",
  "patient.gps.longitude": "Longitude GPS",
  "patient.gps.longitude.placeholder": "ex. 47.507905 (plage -180 à 180)",
  "patient.id": "Numéro du patient",
  "patient.information.age": "Entrez l'âge",
  "patient.information.days": "Entrez les jours",
  "patient.information.email": "Saisir l’e-mail du patient",
  "patient.information.firstname": "Entrez le prénom du patient",
  "patient.information.healthid": "Entrez l'identifiant santé unique",
  "patient.information.lastname": "Entrez le nom de famille du patient",
  "patient.information.months": "Entrez les mois",
  "patient.information.nationalid": "Entrez le numéro de la carte d'identité",
  "patient.information.primaryphone": "Entrez le numéro de téléphone principal du patient",
  "patient.label": "Patient",
  "patient.label.additionalInfo": "Informations complémentaires",
  "patient.label.age": "Âge",
  "patient.label.customNotes": "Notes personnalisées ",
  "patient.label.diseaseProgramme": "Programme de maladie cible",
  "patient.label.occupation": "Profession",
  "patient.label.contactphone": "Téléphone de contact : {PHONE_FORMAT}",
  "patient.label.email": "E-mail",
  "patient.label.info": " Informations du patient",
  "patient.label.modify": "Ajouter ou modifier un patient",
  "patient.label.name": "Nom",
  "patient.label.nopatientid": "Aucune information sur le patient disponible",
  "patient.label.primaryphone": "Téléphone principal du patient",
  "patient.label.sex": "Sexe",
  "patient.last.name": "Nom",
  "phone.format.international.label": "International",
  "phone.format.local.label": "Local",
  "patient.male": "Mâle",
  "patient.maritalstatus": "État civil",
  "patient.merge.activeOrders": "Demande d'examens active",
  "patient.merge.address": "Adresse",
  "patient.merge.addressesDiffer": "L'adresse diffère : {primaire} vs {secondaire}",
  "patient.merge.auditEntries": "Écritures d'audit (le patient d'origine sera conservé)",
  "patient.merge.back": "Back",
  "patient.merge.cancelButton": "Annuler",
  "patient.merge.clinicalSummary": "Résumé clinique",
  "patient.merge.confirmButton": "Confirmer la fusion",
  "patient.merge.confirmCheckbox": "Je comprends que cette action est irréversible et j'ai vérifié que les bons patients sont bien fusionnés.",
  "patient.merge.confirmMerge": "Confirmer la fusion des patients",
  "patient.merge.conflictNote": "(Les données démographiques primaires des patients seront utilisées)",
  "patient.merge.conflictingInfo": "Informations contradictoires détectées",
  "patient.merge.contactInfo": "Coordonnées",
  "patient.merge.county": "Comté/État",
  "patient.merge.dataToConsolidate": "Données à consolider",
  "patient.merge.demographics": "Données démographiques",
  "patient.merge.dob": "DOB",
  "patient.merge.email": "E-mail",
  "patient.merge.emailsDiffer": "L'adresse électronique diffère : {primaire} vs {secondaire}",
  "patient.merge.error.alreadyMerged": "Le patient a déjà été fusionné.",
  "patient.merge.error.executionFailed": "L'exécution de la fusion a échoué",
  "patient.merge.error.noPermission": "Seuls les administrateurs globaux peuvent fusionner les dossiers des patients.",
  "patient.merge.error.patientNotFound": "Patient introuvable",
  "patient.merge.error.samePatient": "Impossible de fusionner un patient avec lui-même",
  "patient.merge.error.selectBoth": "Veuillez sélectionner les deux patients pour continuer",
  "patient.merge.error.selectPrimary": "Veuillez sélectionner le patient dont le dossier doit être principal.",
  "patient.merge.error.validationFailed": "La validation de la fusion a échoué",
  "patient.merge.externalIds": "ID externes",
  "patient.merge.gender": "Sexe",
  "patient.merge.identifiers": "Identifiants",
  "patient.merge.identifiersToPreserve": "Identifiants à préserver (pour les deux patients)",
  "patient.merge.mergeSummary": "Fusionner le résumé",
  "patient.merge.mergingFrom": "Fusionner à partir de",
  "patient.merge.mergingLabel": "Fusion",
  "patient.merge.name": "Nom",
  "patient.merge.nationalId": "Carte nationale d’identité",
  "patient.merge.nationalIds": "Numéro de la carte d'Identité",
  "patient.merge.nextStep": "Étape suivante",
  "patient.merge.noIdentifiers": "Aucun identifiant enregistré",
  "patient.merge.noPatientSelected": "Aucun patient sélectionné",
  "patient.merge.notRecorded": "Non enregistré",
  "patient.merge.orders": "Commandes",
  "patient.merge.ordersCount": "{count} ({active} active)",
  "patient.merge.patientId": "Identifiant du Patient",
  "patient.merge.patientIds": "ID des patients",
  "patient.merge.patientResults": "Résultats des analyses des patients",
  "patient.merge.phone": "Téléphone",
  "patient.merge.phonesDiffer": "Les numéros de téléphone diffèrent : {primaire} vs {secondaire}",
  "patient.merge.postalCode": "Code Postal",
  "patient.merge.primaryLabel": "Primaire",
  "patient.merge.primaryPatient": "Patient principal",
  "patient.merge.reason": "Motif de la fusion (obligatoire)",
  "patient.merge.reasonPlaceholder": "Veuillez indiquer le motif de la fusion de ces dossiers patients...",
  "patient.merge.recordsReassigned": "{count} enregistrements réattribués",
  "patient.merge.samples": "Échantillons",
  "patient.merge.searchDifferent": "Rechercher un autre patient",
  "patient.merge.selectFirstPatient": "Sélectionnez le premier patient",
  "patient.merge.selectPrimaryDescription": "Quel patient devrait faire l'objet du dossier principal ? ",
  "patient.merge.selectPrimaryRecord": "Sélectionner le dossier patient principal",
  "patient.merge.selectSecondPatient": "Sélectionner un deuxième patient",
  "patient.merge.step.compare": "Sélectionnez Primaire",
  "patient.merge.step.confirm": "Confirmer la fusion",
  "patient.merge.step.select": "Sélectionner des patients",
  "patient.merge.streetAddress": "Adresse de la rue",
  "patient.merge.success": "Fusion des patients effectuée avec succès",
  "patient.merge.successMessage": "Le patient {mergedId} a été fusionné avec le patient {primaryId}. ID d'audit : {auditId}",
  "patient.merge.testResults": "Résultats des tests",
  "patient.merge.title": "Fusionner les dossiers des patients",
  "patient.merge.totalContacts": "Contacts",
  "patient.merge.totalRelations": "Rapports",
  "patient.merge.totalResults": "Résultats totaux",
  "patient.merge.totalSamples": "Échantillons",
  "patient.merge.town": "Ville/Ville",
  "patient.merge.tryDifferentSearch": "Essayez de modifier vos critères de recherche ou d'utiliser différents identifiants de patients.",
  "patient.merge.warning.dataLink": "Toutes les données ultérieures seront associées au patient principal. Le patient non sélectionné sera marqué comme fusionné et inactif.",
  "patient.merge.warning.irreversible": "Cette action est irréversible. Toutes les données seront définitivement consolidées.",
  "patient.merge.warning.samePatient": "Même patient sélectionné",
  "patient.merge.warning.samePatientDescription": "Vous avez sélectionné le même patient pour les deux dossiers. Veuillez sélectionner deux patients différents à fusionner.",
  "patient.natioanalid": "Carte nationale d’identité",
  "patient.nationalid": "Carte nationale d’identité",
  "patient.nationality": "Nationalité",
  "patient.nationality.other": "Précisez Autre nationalité",
  "patient.photo.active.camera": "Cliquer pour activer la caméra",
  "patient.photo.add": "Ajouter une photo",
  "patient.photo.browse": "Cliquez pour parcourir les fichiers",
  "patient.photo.camera.permission.denied": "Autorisation d'accès à la caméra refusée. Veuillez vérifier les paramètres de votre navigateur.",
  "patient.photo.cancel": "Annuler",
  "patient.photo.capture": "Prise de photo",
  "patient.photo.captured": "Photo prise:",
  "patient.photo.change": "Modifier l'image",
  "patient.photo.confirm": "Confirmer",
  "patient.photo.dragndrop": "Copier/Coller une image ici",
  "patient.photo.error.fileTooLarge": "L’image est trop volumineuse. Taille maximale : 2 Mo.",
  "patient.photo.formats": "Formats: JPG, PNG (max 1MB)",
  "patient.photo.import": "Importer",
  "patient.photo.label": "Photo du patient",
  "patient.photo.modal.heading": "Choisir la photo du patient",
  "patient.photo.modal.options": "Options de sélection d'images",
  "patient.photo.preview": "Pré-visualiser",
  "patient.photo.preview.alt": "Pré-visualiser la photo du patient",
  "patient.photo.preview.captured.alt": "Photo du patient capturée",
  "patient.photo.retake": "Reprendre",
  "patient.photo.start.camera": "Démarrer la caméra",
  "patient.photo.take": "Prendre une photo",
  "patient.photo.view": "Voir la photo",
  "patient.idDoc.title": "Documents d’identification",
  "patient.idDoc.addDocument": "Ajouter un document",
  "patient.idDoc.selectImage": "Sélectionner une image",
  "patient.idDoc.documentType": "Type de document",
  "patient.idDoc.description": "Description",
  "patient.idDoc.description.placeholder": "Saisir la description du document",
  "patient.idDoc.category.nationalId": "Carte nationale d’identité",
  "patient.idDoc.category.insuranceCard": "Carte d’assurance",
  "patient.idDoc.category.other": "Autre",
  "patient.idDoc.view": "Voir",
  "patient.idDoc.edit": "Modifier",
  "patient.idDoc.delete": "Supprimer",
  "patient.idDoc.remove": "Retirer",
  "patient.idDoc.pending": "Non enregistré",
  "patient.idDoc.empty": "Aucun document d’identification téléversé ",
  "patient.idDoc.viewDocument": "Voir le document",
  "patient.idDoc.editDocument": "Modifier le document",
  "patient.idDoc.confirmDelete": "Supprimer le document",
  "patient.idDoc.deleteWarning": "Êtes-vous sûr de vouloir supprimer ce document ? Cette action est irréversible.",
  "patient.idDoc.upload": "Téléverser",
  "patient.idDoc.dragndrop": "Glissez-déposez un fichier ici",
  "patient.idDoc.browse": "ou cliquez pour parcourir les fichiers",
  "patient.idDoc.formats": "Formats : JPEG, PNG, PDF (max 10 Mo)",
  "patient.idDoc.useCamera": "Utiliser la caméra",
  "patient.idDoc.pdfSelected": "Document PDF sélectionné",
  "patient.idDoc.error.invalidFormat": "Format de fichier invalide. Formats acceptés : JPEG, PNG, PDF. ",
  "patient.idDoc.error.fileTooLarge": "Le fichier est trop volumineux. Taille maximale : 10 Mo.",
  "patient.prev.lab.no": "Numéro laboratoire précédent",
  "patient.report.associated.name": "Rapports des Patients Associés",
  "patient.report.collection.name": "ARV Rapports des Patients Recueillies",
  "patient.search.nopatient": "Aucun patient trouvé",
  "patient.st.number": "Numéro ST",
  "patient.subject.number": "Identifiant unique du patient",
  "patient.yrs": "ans",
  "patientcontact.person.email": "Email du contact",
  "patientcontact.person.firstname": "Prénom du contact",
  "patientcontact.person.lastname": "Nom de famille du contact",
  "placeholder.accession.number": "Saisissez le N° Labo",
  "print.barcode": "Imprimer les codes",
  "process.testAdd.pressNext.ageRangeSelectiong": "Appuyez sur le bouton Suivant. L'étape de sélection de la tranche d'âge n'est pas requise !",
  "process.testAdd.pressNext.selectGroupDictionary": "Appuyez sur le bouton Suivant. L'étape de sélection de la liste de dictionnaires de groupe n'est pas requise !",
  "program.name.label": "Nom du programme",
  "project.ARVFollowupStudy.name": "ARV - Bilan de Suivi",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV - Bilan Initial",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Indéterminé",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Recency Testing",
  "project.SequencingStudy.name": "Séquençage",
  "project.SpecialRequestStudy.name": "Demande Spéciale",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Ajouter Projet",
  "project.add.title": "Ajouter Projet",
  "project.browse.title": "Projet",
  "project.completedDate": "Completed Date",
  "project.desc.short": "Project Descr.",
  "project.description": "Project Description",
  "project.edit.subtitle": "Éditer Projet",
  "project.edit.title": "Éditer Projet",
  "project.external.reference": "External Reference",
  "provider.browse.title": "Gestion des Prestataires",
  "provider.email": "E-mail",
  "provider.fax": "Fax",
  "provider.isActive": "La catégorie est active",
  "provider.modal.add.heading": "Ajouter un prestataire",
  "provider.modal.update.heading": "Mettre à jour le Prestataire",
  "provider.providerFirstName": "Prénom du Prestataire",
  "provider.providerLastName": "Nom de Famille du Prestataire",
  "provider.search": "Rechercher un Prestataire",
  "provider.search.placeholder": "Rechercher par Nom de Prestataire...",
  "provider.select": "Sélectionner un Prestataire",
  "provider.telephone": "Téléphone",
  "qa.checklist.incomplete": "La checklist Assurance Qualité est incomplète",
  "qa.checklist.instructions": "Complétez tous les contrôles requis avant de soumettre",
  "qa.checklist.samplingSiteCorrect": "Les informations relatives au site de prélèvement sont correctes",
  "qa.checklist.title": "Checklist Assurance Qualité",
  "qa.summary.noSamples": "Aucun échantillon à examiner",
  "qa.summary.noTests": "Aucun test sélectionné",
  "qa.summary.order": "Détails de la demande d’examen",
  "qa.summary.panel": "Panneau",
  "qa.summary.patient": " Informations du patient",
  "qa.summary.poolOf": "Galerie d'images d'{count} {animal}",
  "qa.summary.samples": "Résumé des échantillons",
  "qa.summary.samplingSite": "Sites de prélèvement",
  "qa.summary.siteCode": "Code Emplacement du site",
  "qa.summary.siteName": "Nom du site",
  "qc.comments.add": "Ajouter un commentaire",
  "qc.comments.empty": "Aucun commentaire",
  "qc.comments.placeholder": "Entrer un commentaire CQ...",
  "qc.comments.title": "Commentaires CQ",
  "qc.expectedValue": "Valeur attendue",
  "qc.frequency.compliance": "Métriques de conformité",
  "qc.frequency.config": "Configuration de fréquence CQ",
  "qc.frequency.daily": "Démarrage quotidien",
  "qc.frequency.everyHours": "Toutes les N heures",
  "qc.frequency.everySamples": "Tous les N échantillons",
  "qc.frequency.manual": "Déclenchement manuel uniquement",
  "qc.frequency.notConfigured": "Non configuré",
  "qc.frequency.perShift": "Par quart de travail",
  "qc.frequency.save": "Enregistrer la configuration",
  "qc.frequency.type": "Type de fréquence",
  "qc.frequency.value": "Valeur de fréquence",
  "qc.leveyJennings.mean": "Moyenne",
  "qc.leveyJennings.minus2SD": "-2 ET",
  "qc.leveyJennings.minus3SD": "-3 ET",
  "qc.leveyJennings.noData": "Aucune donnée CQ disponible",
  "qc.leveyJennings.plus2SD": "+2 ET",
  "qc.leveyJennings.plus3SD": "+3 ET",
  "qc.leveyJennings.title": "Graphique de contrôle Levey-Jennings",
  "qc.notes": "Remarques sur le contrôle qualité",
  "qc.notes.placeholder": "Saisir les notes et observations relatives au contrôle qualité",
  "qc.parentSample": "Échantillon parenta",
  "qc.signature.comment": "Commentaire (optionnel)",
  "qc.signature.comment.placeholder": "Ajouter un commentaire...",
  "qc.signature.ipAddress": "Adresse IP",
  "qc.signature.noSignatures": "Aucune signature",
  "qc.signature.sign": "Signer le rapport",
  "qc.signature.signedAt": "Signé le",
  "qc.signature.success": "Rapport signé avec succès",
  "qc.signature.title": "Signatures électroniques",
  "qc.signature.userId": "ID utilisateur",
  "qc.status": "statut QC",
  "qc.status.failed": "Failed",
  "qc.status.notRequired": "Pas obligatoire",
  "qc.status.passed": "Réussi",
  "qc.status.pending": "QC en attente",
  "qc.status.select": "Sélectionnez le statut QC",
  "qc.status.update.button": "Statut QC mis à jour ",
  "qc.status.update.success": "Statut QC mis à jour avec succès",
  "qc.status.update.title": "Statut QC mis à jour ",
  "qc.status.warning.message": "Le fait de marquer ce lot comme Non conforme empêchera son utilisation jusqu'à ce que le statut du contrôle qualité soit mis à jour.",
  "qc.status.warning.title": "Avertissement d’échec du contrôle qualité",
  "qc.westgard.noViolations": "Aucune violation détectée",
  "qc.westgard.rule.disabled": "Désactivé",
  "qc.westgard.rule.enabled": "Activée",
  "qc.westgard.rules": "Règles de Westgard",
  "qc.westgard.rules.description": "Configurer l'évaluation CQ multi-règles de Westgard",
  "qc.westgard.violations": "Violations",
  "quantity": "Quantité",
  "quantity.balanced": "Quantité équilibrée",
  "quantity.not.balanced": "Quantité non équilibrée",
  "quick.entry.accession.number": "Numéro d'enregistrement",
  "referTest.referralLabel": "Référer l'analyse à un laboratoire de référence",
  "referral.button.labSearch": "Rechercher les références par numéro de laboratoire",
  "referral.button.patientSearch": "Recherche de patient",
  "referral.button.unitTestSearch": "Rechercher les références par unité(s) et test(s)",
  "referral.date.end": "Date de fin (jj/mm/aaaa)",
  "referral.date.start": "Date de Début (jj/mm/aaaa)",
  "referral.emptyState": "Non de références ont été trouvées pour les filtres sélectionnés.",
  "referral.error": "Aucune référence ne correspond aux critères",
  "referral.input": "Scanner ou Entrer Manuellement",
  "referral.label.institute": "Institut",
  "referral.label.reason": "Raison de référence",
  "referral.label.referredOutTests": "Tests référés à l'extérieur",
  "referral.label.sentdate": "Date d'envoi",
  "referral.label.testmethod": "Méthodes",
  "referral.label.testtoperform": "Test à effectuer",
  "referral.main.button": "Rechercher les références par patient",
  "referral.matching.search": "Tests référés correspondant à la recherche",
  "referral.out.head": "Références",
  "referral.out.note": "Notez que si vous recherchez par date de résultat, seuls les tests avec des résultats apparaîtront.",
  "referral.out.request": "Résultats par Date / Test / Type de Date d'Unité :",
  "referral.print.selected.patient.reports": "Imprimer les rapports des patients sélectionnés",
  "referral.print.selected.patient.reports.selectall.button": "Sélectionner tout",
  "referral.print.selected.patient.reports.selectnone.button": "Désélectionner tout",
  "referral.result.labNumber": "Résultats par Numéro de Laboratoire",
  "referral.result.referenceRange": "Plage de référence",
  "referral.search": "Rechercher",
  "referral.search.column.analysisId": "Identifiant de l'analyse",
  "referral.search.column.referenceLab": "Laboratoire de référence",
  "referral.search.column.resultDate": "Date de résultat",
  "referral.search.column.sentDate": "Date d'envoi",
  "referral.test": "Test(s)",
  "referral.testresult.pastnote": "Notes antérieures",
  "referral.units": "Unité(s)",
  "referrer.label": "Référent",
  "reflexTests": "Tests de réflexes",
  "reject.action.button": "Rejeter",
  "reject.order.sample.notification": "Vous rejetez un échantillon.Cet échantillon sera rejeté et n’apparaîtra pas dans les plans de travail une fois enregistré,aucun résultat ne peut être entré pour cette commande.",
  "remaining.quantity": "Quantité restante :",
  "remove.aliquot": "Supprimer l’aliquote",
  "report.enter.labNumber.headline": "Générer un rapport ou une plage de rapports par numéro de numéro de laboratoire",
  "report.enter.patient.headline": "Générer tous les rapports pour un client",
  "report.enter.patient.headline.description": "Recherchez le patient via le numéro de laboratoire précédent, l'ID du patient (qui peut être soit le numéro d'identification unique de la santé, soit l'ID national) ou d'autres champs.",
  "report.enter.site.headline": "Générer des rapports par site",
  "report.labe.byLabNumber": "Rapport par Numéro de Laboratoire",
  "report.labe.byPatient": "Rapport par Patient",
  "report.labe.date": "Rapport par Date",
  "report.labe.site": "Rapport par Site",
  "report.label.site.dateType": "Type de date",
  "report.label.site.onlyResults": "Uniquement les rapports avec des résultats",
  "report.patient.site.description": "Générer des rapports par date de résultat ou par date de commande. La date de résultat montrera uniquement les rapports avec des résultats. Si vous sélectionnez uniquement les rapports avec des résultats, tous les rapports où tous les tests sont en cours ne seront pas générés.",
  "report.patient.title.final": "Results: final report",
  "report.patient.title.partial": "Results: partial report",
  "report.patient.labDirector": "Lab director",
  "report.patient.block.order": "Demande d'examen",
  "report.patient.block.dates": "Dates",
  "report.patient.siteWard": "Site / ward",
  "report.patient.completed": "Terminé",
  "report.patient.completed.pending": "Not yet complete",
  "report.patient.contactTracing.indexName": "Contact tracing index name",
  "report.patient.contactTracing.indexRecordNumber": "Contact tracing index record number",
  "report.patient.samples": "Échantillons",
  "report.patient.sample.number": "N°",
  "report.patient.sample.condition": "État",
  "report.patient.sample.rejected": "Rejected: {0}",
  "report.patient.sample.notRecorded": "Non enregistré",
  "report.patient.strip.collected": "Collected {0}",
  "report.patient.strip.collectedFirst": "Collected {0} (first of {1} samples)",
  "report.patient.result.sampleRejected": "Sample rejected",
  "report.patient.result.rejected": "Rejeté",
  "report.patient.col.sample": "Smp",
  "report.patient.col.completed": "Terminé",
  "report.patient.flag.low": "L",
  "report.patient.flag.high": "H",
  "report.patient.flag.criticalLow": "LL",
  "report.patient.flag.criticalHigh": "HH",
  "report.patient.flag.abnormal": "*",
  "report.patient.flag.referred": "R",
  "report.patient.flag.confirm": "C",
  "report.patient.legend": "Legend",
  "report.patient.legend.high": "above normal",
  "report.patient.legend.low": "below normal",
  "report.patient.legend.critical": "critical",
  "report.patient.legend.referred": "referred, result pending",
  "report.patient.legend.confirm": "confirmation test",
  "report.patient.notAccredited": "Not within the laboratory's accredited scope",
  "report.patient.awaitingValidation": "Awaiting validation",
  "report.patient.performedBy": "Interprétée par {0}",
  "report.patient.accred.notesLine": "Tests on this report are accredited by: {0}.",
  "report.patient.callback.line": "Callback: {0}, {1}, by {2}. {3}.",
  "report.patient.callback.more": "(+{0} earlier attempts)",
  "report.patient.callback.confirmed": "Read back confirmed",
  "report.patient.callback.noReadback": "Joint, sans relecture",
  "report.patient.callback.unreachable": "Impossible à joindre",
  "report.patient.corrected.line": "Corrected report. Replaces the report issued {0}. Change: {1}.",
  "report.patient.corrected.seeReplaced": "See the replaced report",
  "report.patient.version": "Version {0}.",
  "report.patient.comments": "General comments",
  "report.patient.releasedBy": "Validated and released by",
  "report.patient.endOfReport": "End of report",
  "report.patient.issued": "Issued",
  "report.patient.page": "Page",
  "report.select.site": "Sélectionner le site",
  "report.select.studttype": "Sélectionner le type d'étude",
  "reporting.label.testName": "Nom du test dans les rapports",
  "reports.auditTrail": "Formulaire d'Audit",
  "reports.systemAuditTrail": "Journal d’audit du système",
  "reports.button": "Générer le rapport",
  "reports.dateRange": "Plage de dates",
  "reports.endDate": "Date de fin",
  "reports.error.dateRangeRequired": "La plage de dates est requise pour ce type de rapport.",
  "reports.error.generationFailed": "Impossible de générer le rapport. Veuillez réessayer.",
  "reports.error.invalidDate": "Date non valide",
  "reports.error.invalidDateRange": "La date de fin doit être postérieure à la date de début.",
  "reports.error.unknownExportFormat": "Format d'export inconnu",
  "reports.error.unknownReportType": "Type de rapport inconnu",
  "reports.export": "Exporter",
  "reports.export.byDate": "Exporter en Fichier CSV",
  "reports.export.byDate_routine": "Exporter Routine en Fichier CSV",
  "reports.export.general": "Exportation générale",
  "reports.export.specific": "Exportation Données Charge Viral",
  "reports.export.valid": "Valid",
  "reports.export.whonet": "WHONET Report",
  "reports.followupRequired.byLocation": "Suivi Requis",
  "reports.format": "Format d'exportation",
  "reports.format.select": "Sélectionner un format",
  "reports.generate.title": "Générer le rapport de stock des éléments",
  "reports.generating": "Génération en cours...",
  "reports.generation.success": "Rapport généré et téléchargé avec succès",
  "reports.groupByLocation": "Regrouper par lieu de stockage",
  "reports.groupByType": "Regrouper par type d'élément",
  "reports.grouping": "Options de regroupement",
  "reports.help.description": "Utilisez ces rapports pour analyser vos données d'inventaire :",
  "reports.help.tip1": "Utilisez des plages de dates pour l'analyse des tendances",
  "reports.help.tip2": "Regroupez par type ou par emplacement pour une meilleure analyse.",
  "reports.help.tip3": "Exporter vers Excel pour une analyse plus approfondie",
  "reports.help.title": "Conseils pour signaler",
  "reports.includeExpired": "Inclure les lots expirés",
  "reports.includeInactive": "Inclure les éléments inactifs",
  "reports.info.message": "Sélectionnez le type de rapport et les options ci-dessous. La génération des rapports peut prendre quelques instants.",
  "reports.info.title": "Génération de rapports",
  "reports.label.cistudyexport": "Rapport général",
  "reports.label.indicator": "Indicateur",
  "reports.label.indicator.performance": "Performances de l'unité",
  "reports.label.referred.out": "Rapport des tests référencés",
  "reports.label.trends": "Tendances",
  "reports.menu.covid": "Covid Report",
  "reports.nonConformity.byDate.report": "Rechercher par date de test",
  "reports.nonConformity.byLabno.report": "Par Labno",
  "reports.nonConformity.bySectionReason.report": "Par unité et raison",
  "reports.nonConformity.bySectionReason.title": "Rapport des non-conformités par unité et raison",
  "reports.nonConformity.menu": "Non-conformités",
  "reports.nonConformity.notification.report": "Non-conformités notification",
  "reports.nonConformity.notification.report.instructions": "Instructions pour le rapport de notification de non-conformité",
  "reports.options": "Options de filtre",
  "reports.patient.ARV.version1": "ARV-Version",
  "reports.patient.ARV.version1 ": "ARV-Version 1",
  "reports.patient.ARVFollowup.version1": "ARV-Bilan de Suivi Version 1",
  "reports.patient.ARVFollowup.version2": "ARV-Bilan de Suivi Version 2",
  "reports.patient.ARVInitial.version1": "ARV-Bilan Initial Version 1",
  "reports.patient.ARVInitial.version2": "ARV-Bilan Initial Version 2",
  "reports.patient.Indeterminate.location": "Indéterminés par le Service",
  "reports.patient.Indeterminate.version1": "Indéterminés Version 1",
  "reports.patient.Indeterminate.version2": "Indéterminés Version 2",
  "reports.startDate": "Date de début",
  "reports.type": "Type du rapport",
  "reports.type.expirationForecast": "Prévision d’expiration",
  "reports.type.expirationForecast.description": "Éléments expirant dans la période indiqué",
  "reports.type.lotTraceability": "Traçabilité des lot",
  "reports.type.lotTraceability.description": "Traçabilité complète des mouvements et de l’utilisation des lots",
  "reports.type.lowStock": "Alerte de stock faible",
  "reports.type.lowStock.description": "Éléments actuellement en dessous du stock minimum",
  "reports.type.select": "Sélectionner type du rapport",
  "reports.type.stockLevels": "Rapport sur les niveaux de stock des éléments",
  "reports.type.stockLevels.description": "Niveaux de stock actuels pour tous les éléments en inventaire",
  "reports.type.transactionHistory": "Historique des transactions",
  "reports.type.transactionHistory.description": "Toutes les transactions comprises dans la plage de dates indiquée",
  "reports.type.usageTrends": "Tendances d’utilisation",
  "reports.type.usageTrends.description": "Évolution des usages et de la consommation au fil du temps",
  "request.samesite.order": "Passer la commande sur le même site",
  "requester.label": "Prescripteur",
  "required.invalidtext": "Ce champ est requis",
  "result.acceptasis.warning": "Avertissement d'acceptation en l'état",
  "result.acceptasis.trigger": "Valider",
  "result.acceptasis.reason.label": "Motif de l’acceptation sans condition",
  "result.acceptasis.reason.placeholder": "Par exemple : retesté deux fois avec le même résultat, ou aucun résultat disponible",
  "result.acceptasis.confirm": "Confirmer la validation",
  "result.acceptasis.cancel": "Annuler",
  "result.acceptasis.committed": "Accepté",
  "result.acceptasis.undo": "Annuler",
  "result.entry.error.accessionRequired": "Veuillez saisir un numéro de laboratoire",
  "result.entry.error.title": "Erreur",
  "result.entry.info.title": "Information",
  "result.entry.label": "Saisie les résultats",
  "result.entry.noResults": "Aucun échantillon trouvé pour le numéro lab{accessionNumber}",
  "result.entry.noTestsFound": "Aucun test avec des résultats en attente n'a été trouvé pour le numéro d'accès {accessionNumber}",
  "result.entry.results.accessionNumber": "Numéro d'enregistrement",
  "result.entry.results.sampleCount": "Échantillons",
  "result.entry.results.testCount": "Analyses",
  "result.entry.results.title": "Résultats des tests en attente",
  "result.entry.saveSuccess": "Résultat enregistré pour {testName}",
  "result.entry.search.accessionLabel": "Numéro d'enregistrement",
  "result.entry.search.accessionPlaceholder": "Saisissez le numéro de laboratoire ",
  "result.entry.search.button": "Rechercher",
  "result.entry.search.searching": "Recherche en cours…",
  "result.entry.search.title": "Recherche par numéro de laboratoire",
  "result.entry.success.title": "Succès",
  "result.entry.table.action": "Action",
  "result.entry.table.header.sampleId": "ID d'échantillon",
  "result.entry.table.header.sampleType": "Type d'échantillon",
  "result.entry.table.header.testCount": "Analyses",
  "result.entry.table.noSamples": "Aucun échantillon testé trouvé",
  "result.entry.table.noTests": "Aucun test n'a été effectué sur cet échantillon.",
  "result.entry.table.result": "Résultat ",
  "result.entry.table.resultPlaceholder": "Saisir le résultat",
  "result.entry.table.save": "Sauvegarder",
  "result.entry.table.saving": "Enregistrement...",
  "result.entry.table.status": "Statut",
  "result.entry.table.testName": "Nom du test ",
  "result.entry.table.testsTitle": "Tests ({count})",
  "result.entry.title": "Saisie les résultats",
  "result.noTestsFound": "Aucun test approprié trouvé",
  "result.nonconforming.item": "L'échantillon ou l'ordonnance est non conforme OU le test a été rejetée",
  "result.outOfValidRange.msg": "La valeur que vous avez entrée (en champ rouge) est hors de la gamme des valeurs admissible pour ce bilan. Prière de vérifier la valeur.",
  "result.notNumeric.msg": "{test} : « {value} » n'est pas un nombre. Saisissez un nombre décimal simple ou une notation scientifique comme 1.5e5 ou 1.5 x 10^5, puis enregistrez à nouveau.",
  "result.reject.warning": "Avertissement de rejet de résultat",
  "result.report.queue.size": "Taille de la file d'attente :",
  "result.search.noresult": "Aucun résultat trouvé",
  "resultreporting.browse.title": "Configuration de la diffusion des résultats",
  "resultreporting.config.url": "URL du site vers lequel les résultats seront envoyés. Par exemple http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://nomdelorganisation.com/someSite",
  "results.label.refer": "Référer l'analyse à un laboratoire de référence",
  "routine.reports": "Rapports de routine",
  "rulebuilder.error.invalidNumeric": "Valeur numérique invalide",
  "rulebuilder.error.invalidTest": "Test invalide",
  "rulebuilder.label.add.externaltrigger": "Ajouter un message externe \\",
  "rulebuilder.label.add.internaltrigger": "Ajouter un message interne \\",
  "rulebuilder.label.addAction": "Ajouter une action",
  "rulebuilder.label.addCondition": "Ajouter une condition",
  "rulebuilder.label.addExternalNote": "Ajouter une note externe",
  "rulebuilder.label.addInternalNote": "Ajouter une note interne",
  "rulebuilder.label.addPopup": "Ajouter une fenêtre contextuelle",
  "rulebuilder.label.addRule": "Ajouter une règle",
  "rulebuilder.label.addRuleConditions": "Ajouter des conditions de règle réflexe",
  "rulebuilder.label.confirmDelete": "Êtes-vous sûr de vouloir supprimer cette règle ?",
  "rulebuilder.label.dictValue": "Sélectionner",
  "rulebuilder.label.noSuggestions": "Aucune suggestion disponible",
  "rulebuilder.label.numericValue": "Valeur numérique",
  "rulebuilder.label.numericValue2": "Valeur numérique 2",
  "rulebuilder.label.overallOptions": "Sur toutes les options",
  "rulebuilder.label.perfomActions": "Effectuer les actions suivantes",
  "rulebuilder.label.relation": "Relation logique",
  "rulebuilder.label.removeAction": "Supprimer l'action",
  "rulebuilder.label.removeCondition": "Supprimer la condition",
  "rulebuilder.label.removeRule": "Désactiver la règle",
  "rulebuilder.label.rule": "Règle",
  "rulebuilder.label.ruleDetails": "Voir la règle",
  "rulebuilder.label.ruleName": "Nom de la règle",
  "rulebuilder.label.searchTest": "Rechercher un test",
  "rulebuilder.label.selectSample": "Sélectionner un échantillon ",
  "rulebuilder.label.textValue": "Valeur de texte",
  "rulebuilder.label.toggleRule": "Basculer la règle",
  "sample.accession.number": "Numéro Laboratoire de l’échantillon",
  "sample.add.action": "Ajouter un échantillon",
  "sample.collection.date": "Date de prélèvement",
  "sample.collection.method": "Méthode de prélèvement ",
  "sample.collection.method.placeholder": "ex. ponction veineuse, capillaire, tubulure",
  "sample.collection.time": "Heure de prélèvement",
  "sample.currentDate": "Date actuelle",
  "sample.requiredBy": "Exigé par",
  "sample.specimen.origin": "Origine de l’échantillon (laboratoire référent)",
  "sample.specimen.origin.placeholder": "Nom du laboratoire référent",
  "sample.temperature": "Température a l’arrivée de l’échantillons ",
  "sample.temperature.placeholder": "ex. température ambiante, sur glace, réfrigéré",
  "sample.entry.available.tests": "Tests disponibles",
  "sample.entry.nextVisit.date": "Rendez-vous pour récupération résultat",
  "sample.entry.panels": "Panels",
  "sample.entry.project.patient.and.testName": "Noms et/ou Numéro d'identité National \n Nom du Test",
  "sample.entry.project.testName": "Nom du test ",
  "sample.entry.search.barcode": "Rechercher un code-barres d'échantillon",
  "sample.id": "ID d'échantillon",
  "sample.item.info": "Informations sur l’échantillon",
  "sample.items.for.accession": "Échantillons associés au numéro Lab :",
  "sample.label.accessionNumber": "Numéro d'enregistrement",
  "sample.label.collectionDate": "Date de prélèvement",
  "sample.label.dept": "Service/Département/Unité",
  "sample.label.facility": "Établissement Référant",
  "sample.label.labnumber": "Numéro laboratoire",
  "sample.label.labnumber.generate": "Générer",
  "sample.label.labnumber.new": "Nouveau numéro de laboratoire",
  "sample.labnumber.reassign.button": "Réattribuer un numéro de laboratoire",
  "sample.labnumber.reassign.confirm": "Réaffecter",
  "sample.labnumber.reassign.current": "Numéro laboratoire actuel",
  "sample.labnumber.reassign.heading": "Réattribuer un numéro de laboratoire",
  "sample.labnumber.reassign.pending": "Cet échantillon sera réattribué à « {number} » lorsque vous enregistrerez.",
  "sample.labnumber.reassign.pending.title": "Réattribution du numéro de laboratoire en attente",
  "sample.labnumber.reassign.undo": "Annuler",
  "sample.labnumber.reassign.warning": "La réattribution modifie définitivement le Numéro laboratoire de cet échantillon. Les étiquettes, rapports et références existants associant ce Numéro à l'échantillon ne correspondront plus à celui-ci. N'effectuez cette opération que pour corriger un échantillon mal étiqueté.",
  "sample.label.noorder": "La commande n'existe pas",
  "sample.label.orderdate": "Date de Commande",
  "sample.label.orderpanel": "Panels de demande d'examen",
  "sample.label.requester": "Prescripteur",
  "sample.label.search.Order": "Rechercher une commande",
  "sample.label.search.labnumber": "Rechercher par numéro d'accès",
  "sample.label.search.patient": "Recherche par Patient",
  "sample.label.typeOfSample": "Type d'échantillon",
  "sample.label.types": "Types d’échantillons",
  "sample.management.action.clearSelection": "Effacer la sélection",
  "sample.management.action.createAliquot": "Créer une aliquote",
  "sample.management.action.selectAllAliquots": "Sélectionner toutes les aliquotes",
  "sample.management.action.selectAllParents": "Sélectionner tous les parents",
  "sample.management.addTests.button": "Ajouter des tests",
  "sample.management.addTests.error.addFailed": "Impossible d'ajouter les tests. Veuillez réessayer.",
  "sample.management.addTests.error.loadSampleTypes": "Erreur lors du chargement des types d'échantillons",
  "sample.management.addTests.error.loadTests": "Erreur lors du chargement des tests disponibles",
  "sample.management.addTests.error.noEligibleSamples": "Impossible d'ajouter des tests : tous les échantillons sélectionnés ont été distribués.",
  "sample.management.addTests.error.noTests": "Veuillez sélectionner au moins un test",
  "sample.management.addTests.modal.add": "Ajouter des tests",
  "sample.management.addTests.modal.addCount": "Ajouter {count} test(s)",
  "sample.management.addTests.modal.adding": "Ajout...",
  "sample.management.addTests.modal.aliquotsIncluded": "aliquot(s) inclus",
  "sample.management.addTests.modal.bulkAliquotNote": "Des tests seront ajoutés à tous les échantillons sélectionnés, y compris les aliquotes.",
  "sample.management.addTests.modal.cancel": "Annuler",
  "sample.management.addTests.modal.noEligibleSamples": "Aucun échantillon admissible",
  "sample.management.addTests.modal.noTestsAvailable": "Aucun test n'est disponible pour ce type d'échantillon.",
  "sample.management.addTests.modal.noTestsSelected": "Aucun test sélectionné",
  "sample.management.addTests.modal.panels": "Panels",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Rechercher des tests...",
  "sample.management.addTests.modal.selectSampleType": "Type d'échantillon",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Veuillez sélectionner un type d'échantillon pour afficher les panels et les tests disponibles.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Sélectionnez un type d'échantillon...",
  "sample.management.addTests.modal.selectTests": "Sélectionnez des tests",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Rechercher et sélectionner des tests...",
  "sample.management.addTests.modal.selectedTests": "Tests sélectionnés",
  "sample.management.addTests.modal.subtitle": "Ajouter des tests à {count} échantillons sélectionnés",
  "sample.management.addTests.modal.tests": "Analyses",
  "sample.management.addTests.modal.title": "Ajouter des tests à l'échantillon",
  "sample.management.addTests.resultItem": "{sampleId}: {added} ajouté",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId} : {added} ajouté, {skipped} ignoré",
  "sample.management.addTests.success": "{count} test(s) ajoutés avec succès",
  "sample.management.addTests.successDetailed": "{count} test(s) ajoutés à {samples} échantillon(s) : {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} test(s) ajoutés à {samples} échantillon(s), {skipped} ignoré: {details}",
  "sample.management.addTests.successWithSkipped": "{added} test(s) ajoutés, {skipped} ignorés (déjà commandés)",
  "sample.management.addTests.title": "Ajouter des tests",
  "sample.management.addTests.warning.dispensedSamples": "{count} échantillon(s) n’ont plus de volume restant et seront ignorés. Les tests seront ajoutés à {eligible} échantillon(s) éligibles.",
  "sample.management.addTests.warning.dispensedSamples.title": "Échantillons distribués exclus",
  "sample.management.aliquot.error.createFailed": "Impossible de créer l'aliquote. Veuillez réessayer.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Le nombre d'aliquotes doit être compris entre 1 et 100.",
  "sample.management.aliquot.error.quantityExceedsRemaining": "La quantité demandée ({requested}) dépasse la quantité restante ({remained})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "La quantité par aliquote ({quantité par aliquot}) serait inférieure au minimum (0,001).",
  "sample.management.aliquot.error.quantityPositive": "La quantité doit être supérieure à 0",
  "sample.management.aliquot.error.quantityRequired": "La quantité est requise",
  "sample.management.aliquot.error.title": "Erreur",
  "sample.management.aliquot.modal.cancel": "Annuler",
  "sample.management.aliquot.modal.create": "Créer une aliquote",
  "sample.management.aliquot.modal.createMultiple": "Créer {count} aliquotes",
  "sample.management.aliquot.modal.creating": "Création...",
  "sample.management.aliquot.modal.notesLabel": "Notes (optionnel)",
  "sample.management.aliquot.modal.notesPlaceholder": "Ajoutez des notes concernant cette aliquote…",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Indiquez le nombre d'aliquotes de volume égal à (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Nombre d’aliquotes",
  "sample.management.aliquot.modal.parentInfo": "Informations sur l’échantillon parent",
  "sample.management.aliquot.modal.preview": "Preview",
  "sample.management.aliquot.modal.previewText": "Création de {coumpter} aliquotes avec {Chaque quantité} {unités} chacune",
  "sample.management.aliquot.modal.quantityHelper": "Saisissez la quantité à transférer en {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Quantité à transférer",
  "sample.management.aliquot.modal.quantityPlaceholder": "Saisir la quantité",
  "sample.management.aliquot.modal.subtitle": "Créer une aliquote à partir de l’échantillon {externalId}",
  "sample.management.aliquot.modal.title": "Créer une aliquote",
  "sample.management.aliquot.modal.totalQuantityHelper": "Saisissez la quantité totale à répartir entre toutes les aliquotes en {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Quantité total à transférer",
  "sample.management.aliquot.success": "Aliquot {externalId} créé avec succès. Veuillez effectuer une nouvelle recherche pour afficher les résultats mis à jour.",
  "sample.management.aliquot.successMultiple": "{count} aliquotes créées avec succès ({externalIds}). Veuillez effectuer une nouvelle recherche pour afficher les résultats mis à jour.",
  "sample.management.breadcrumb.title": "Gestion des échantillons",
  "sample.management.cancelTest.error": "Impossible d'annuler le test. Veuillez réessayer.",
  "sample.management.cancelTest.success": "Le test « {testName} » a été annulé avec succès",
  "sample.management.description": "Rechercher et gérer des échantillons, créer des aliquotes et ajouter des tests",
  "sample.management.error.title": "Erreur",
  "sample.management.hierarchy.aliquotOf": "Aliquote de {parent}",
  "sample.management.hierarchy.aliquots": "aliquotes",
  "sample.management.noResults.subtitle": "Aucun échantillon trouvé pour le numéro de laboratoire : {numéro de laboratoire}",
  "sample.management.noResults.title": "Aucun résultat trouvé",
  "sample.management.results.accessionNumber": "Numéro d'enregistrement",
  "sample.management.results.aliquots": "aliquotes",
  "sample.management.results.aliquotsSelected": "aliquotes",
  "sample.management.results.item": "élément",
  "sample.management.results.items": "éléments",
  "sample.management.results.selected": "Sélectionné",
  "sample.management.results.title": "Sample Items",
  "sample.management.results.totalCount": "Total des échantillons",
  "sample.management.search.error.general": "Erreur lors du chargement des résultats d'exemple. Veuillez réessayer.",
  "sample.management.search.label": "Rechercher des échantillons",
  "sample.management.search.loading": "Recherche en cours…",
  "sample.management.search.placeholder": "Saisissez le numéro d'accession pour effectuer une recherche.",
  "sample.management.search.title": "Rechercher des échantillons",
  "sample.management.status.allVolumeDispensed": "Tous les volumes distribués",
  "sample.management.status.available": "Disponible",
  "sample.management.status.consumed": "Consommé",
  "sample.management.status.inUse": "Utilisé",
  "sample.management.status.unknown": "Inconnu",
  "sample.management.success.title": "Succès",
  "sample.management.table.cancelTest": "Annuler le test",
  "sample.management.table.cancelling": "Annulation...",
  "sample.management.table.header.externalId": "ID d'échantillon",
  "sample.management.table.header.hierarchy": "Hiérarchie",
  "sample.management.table.header.originalQuantity": "Quantité originale",
  "sample.management.table.header.quantity": "Quantité originale",
  "sample.management.table.header.remainingQuantity": "Quantité restante",
  "sample.management.table.header.sampleType": "Type d'échantillon",
  "sample.management.table.header.status": "Statut",
  "sample.management.table.header.tests": "Analyses",
  "sample.management.table.noResults": "Aucun échantillons afficher. Utilisez la fonction de recherche ci-dessus pour trouver des échantillons.",
  "sample.management.table.noTests": "Aucun test commandé pour cet échantillon",
  "sample.management.table.orderedDate": "Prescrit",
  "sample.management.table.orderedTests": "Tests commandés ({count})",
  "sample.management.title": "Gestion des échantillons",
  "sample.panel.label.text": "Panneau de recherche disponible",
  "sample.panel.placeholder": "Choisir un panel disponible",
  "sample.panel.search.error.msg": "Aucun panneau trouvé correspondant",
  "sample.quantity.label": "Quantité",
  "sample.receivedDate": "Date de réception",
  "sample.reject.label": "Rejeter l'échantillon",
  "sample.reject.reason.choose": "Choisissez un motif de rejet",
  "sample.reject.reason.label": "Motif du rejet",
  "sample.reject.reasonRequired": "Choisissez un motif de rejet.",
  "sample.remove.action": "Retirer l'échantillon",
  "sample.requestDate": "Date de demande",
  "sample.search.nosample": "Aucun échantillon n'a été trouvé pour le numéro laboratoire fourni.",
  "sample.search.panel.legend.text": "Rechercher parmi les panneaux disponibles",
  "sample.search.scanner.instructions": "Scannez ou saisissez manuellement. Pour un seul rapport, laissez le champ de droite vide",
  "sample.search.scanner.instructions.highaccession": "Scanner le code-barres de l'échantillon pour rechercher les résultats",
  "sample.search.scanner.instructions2": "Scanner le code-barres de l'échantillon pour rechercher les résultats",
  "sample.search.title": "Rechercher un échantillon",
  "sample.select.type": "Sélectionnez le type d'échantillon",
  "sample.type": "Type d'échantillon",
  "sample.type.and.test.sort.order": "Ordre de tri des types d'échantillons et des tests",
  "sample.type.helper": "Sélectionnez un type d'échantillon — les panneaux et les tests disponibles s'actualisent après la sélection.",
  "sample.uom.label": "Unité de mesure de l’échantillon",
  "sample.voided.title": "L’échantillon est annulé",
  "sampleManagement.actions": "Actions",
  "sampleManagement.addTests.button": "Ajouter des tests",
  "sampleManagement.addTests.cancel": "Annuler",
  "sampleManagement.addTests.duplicate": "Test déjà commandé pour {sampleId}",
  "sampleManagement.addTests.error": "Erreur lors de l'ajout des tests",
  "sampleManagement.addTests.incompatible": "Test non compatible avec le type d'échantillon ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Sélectionnez le(s) échantillon(s) auquel ajouter des tests",
  "sampleManagement.addTests.selectTests": "Sélectionnez les test(s) à ajouter",
  "sampleManagement.addTests.skipped": "{count} doublons ignoré(s)",
  "sampleManagement.addTests.submit": "Ajouter des tests",
  "sampleManagement.addTests.success": "{count} test(s) ajoutés avec succès",
  "sampleManagement.addTests.title": "Ajouter des tests aux échantillons",
  "sampleManagement.aliquot.button": "Créer une aliquote",
  "sampleManagement.aliquot.cancel": "Annuler",
  "sampleManagement.aliquot.error": "Erreur lors de la création de l'aliquote",
  "sampleManagement.aliquot.error.concurrentModification": "Cet exemple a été modifié par un autre utilisateur. Veuillez actualiser la page et réessayer.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Impossible de répartir : la quantité demandée {requested} dépasse la quantité restante {remaining}.",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Volume total distribué : aucune quantité restante disponible pour le fractionnement.",
  "sampleManagement.aliquot.notes": "Notes (facultatives)",
  "sampleManagement.aliquot.notesPlaceholder": "Ajouter des notes concernant cette aliquote...",
  "sampleManagement.aliquot.parentExternalId": "ID externe du parent",
  "sampleManagement.aliquot.parentLabel": "Échantillon parenta",
  "sampleManagement.aliquot.quantityPlaceholder": "Entrez la quantité...",
  "sampleManagement.aliquot.quantityToTransfer": "Quantité à transférer",
  "sampleManagement.aliquot.remainingQuantity": "Quantité restante",
  "sampleManagement.aliquot.submit": "Créer une aliquote",
  "sampleManagement.aliquot.success": "Aliquot {externalId} créé avec succès",
  "sampleManagement.aliquot.title": "Créer une aliquote",
  "sampleManagement.aliquot.unit": "Unité",
  "sampleManagement.aliquot.validation.exceeds": "la quantité dépasse la quantité restante",
  "sampleManagement.aliquot.validation.min": "La quantité doit être d'au moins 0,001",
  "sampleManagement.aliquot.validation.required": "Quantité à transférer requise",
  "sampleManagement.clearSelection": "Effacer la sélection",
  "sampleManagement.hierarchy.children": "Aliquotes:",
  "sampleManagement.hierarchy.collapse": "Réduire la hiérarchie",
  "sampleManagement.hierarchy.expand": "Développer la hiérarchie",
  "sampleManagement.hierarchy.level": "Niveau {niveau}",
  "sampleManagement.hierarchy.parent": "Parent:",
  "sampleManagement.notification.refreshResults": "Les résultats ont été mis à jour.",
  "sampleManagement.results.children": "Aliquotes",
  "sampleManagement.results.collectionDate": "Date de prélèvement",
  "sampleManagement.results.count": "{compter} échantillon(s) trouvé(s)",
  "sampleManagement.results.externalId": "ID externe",
  "sampleManagement.results.originalQuantity": "Quantité originale",
  "sampleManagement.results.parent": "Parent",
  "sampleManagement.results.remainingQuantity": "Quantité restante",
  "sampleManagement.results.sampleType": "Type d'échantillon",
  "sampleManagement.results.status": "Statut",
  "sampleManagement.results.tests": "Analyses",
  "sampleManagement.results.title": "Résultats de la recherche",
  "sampleManagement.search.button": "Rechercher",
  "sampleManagement.search.error": "Erreur lors de la recherche d'échantillons",
  "sampleManagement.search.label": "Recherche par numéro de laboratoire",
  "sampleManagement.search.loading": "Recherche en cours…",
  "sampleManagement.search.noResults": "Aucun échantillon trouvé avec ce numéro de laboratoire",
  "sampleManagement.search.placeholder": "Saisissez le numéro de laboratoire ",
  "sampleManagement.selectSamples": "Sélectionner un ou plusieurs échantillons",
  "sampleManagement.selectedCount": "{compter} sélectionné",
  "sampleManagement.test.name": "Nom du test ",
  "sampleManagement.test.orderedDate": "Date de commande",
  "sampleManagement.test.status": "Statut",
  "sampleManagement.test.status.CANCELLED": "Annulé",
  "sampleManagement.test.status.COMPLETED": "Terminé",
  "sampleManagement.test.status.IN_PROGRESS": "En cours",
  "sampleManagement.test.status.ORDERED": "Prescrit",
  "sampleManagement.title": "Gestion des échantillons",
  "sampleManagement.validation.accessionNumberRequired": "Un numéro de laboratoire est requis.",
  "sampleManagement.validation.parentSampleRequired": "L'élément parent de référence est requis.",
  "sampleManagement.validation.samplesRequired": "Au moins un échantillon doit être sélectionné",
  "sampleManagement.validation.testsRequired": "Au moins un test doit être sélectionné",
  "sampleType.existing": "Sortir des types d'échantillon",
  "sampleType.existing.inactive": "Type d'échantillons inactif. Attribuer des tests pour l'activer.",
  "sampleType.new": "Nouveau type d'échantillon",
  "sampleType.typeName": "Nom du type d'échantillon",
  "save.aliquot.changes": "Enregistrer les modifications de l’Aliquote",
  "save.config.success.msg": "Configuration mise à jour avec succès",
  "save.order.success.msg": "La commande a été enregistrée avec succès",
  "save.success": "Enregistrement réussi",
  "saving": "Enregistrement...",
  "search.by.dictionary.entry": "Rechercher une entrée du dictionnaire",
  "search.label": "Rechercher",
  "search.label.accession": "Saisissez le numéro d'accès",
  "search.label.analysis": "Sélectionnez l'état de l'analyse",
  "search.label.collectiondate": "Saisissez la date de collecte",
  "search.label.fromaccession": "Du numéro d'accès",
  "search.label.loadnext": "Charger les 99 enregistrements suivants à partir du numéro de laboratoire",
  "search.label.receiveddate": "Saisir la date de réception",
  "search.label.sample": "Sélectionnez l'état de l'échantillon",
  "search.label.test": "Sélectionnez le nom du test",
  "search.label.testdate": "Saisissez la date du test",
  "search.label.testunit": "Sélectionnez l'unité de test",
  "search.label.toaccession": "Au numéro d'accès",
  "search.patient.label": "Rechercher un patient",
  "search.placeholder": "Rechercher...",
  "searchTests.label": "Rechercher les tests disponibles",
  "searchTests.legend": "Recherchez parmi les tests disponibles",
  "searchindexmanagement.description": "L'index de recherche se met à jour automatiquement lorsque des données sont ajoutées ou modifiées. Si vous devez mettre à jour manuellement l'index de recherche, cliquez sur le bouton Démarrer la réindexation. Cela peut prendre un certain temps.",
  "searchindexmanagement.label": "Gestion de l'index de recherche",
  "searchindexmanagement.reindex": "Réindexer",
  "searchindexmanagement.reindex.error": "Erreur de réindexation",
  "searchindexmanagement.reindex.success": "Réindexation réussie",
  "select.aliquot": "Sélectionner l’aliquote",
  "select.datarange.label": "Sélectionner la plage de données",
  "select.dateRange": "Sélectionnez la plage de dates pour le résumé du rapport de test",
  "select.default.option.label": "Choisis une option",
  "select.end.date.referredTests": "Date de fin (jj/mm/aaaa)",
  "select.labUnits": "Sélectionnez l'unité ou les unités de laboratoire pour lesquelles vous souhaitez créer le test. Vous pouvez en sélectionner autant que vous le souhaitez.",
  "select.label.analyser": "Choisir l'automate",
  "select.priority.tests": "Sélectionnez la priorité des tests que vous souhaitez afficher",
  "select.program": "Programme",
  "select.referral.centre": "Sélectionner le centre de référence",
  "select.referral.centre.is.required": "Le centre de référence est requis",
  "select.start.date.referredTests": "Date de Début (jj/mm/aaaa)",
  "select.timeFrame": "Sélectionnez les plages horaires pour lesquelles vous souhaitez générer les rapports",
  "select.timeFrame.Note": "NOTE : toutes les dates et heures sont basées sur l'heure de réception. Par exemple : un test reçu le 31 janvier à 23h59 et dont le résultat est obtenu le 1er février à 9h30 apparaîtrait comme étant hors des heures normales en janvier.",
  "select.year.report": "Sélectionnez l'année pour laquelle vous souhaitez générer les rapports",
  "selectListRenameEntry.selectList": "Renommer une entrée de liste de sélection",
  "selectListRenameEntry.selectListEdit": "Renommer une entrée de liste de sélection",
  "selectReportValues.title": "Sélectionner les valeurs du rapport",
  "selectResult.title": "Sélectionner le résultat",
  "serial.config.active.label": "Active",
  "serial.config.baudRate.label": "Baud Rate",
  "serial.config.connect.button": "Connect",
  "serial.config.connect.error": "Error connecting serial port",
  "serial.config.connect.success": "Serial port connected successfully",
  "serial.config.create.title": "Create Serial Port Configuration",
  "serial.config.dataBits.label": "Data Bits",
  "serial.config.disconnect.button": "Disconnect",
  "serial.config.disconnect.error": "Error disconnecting serial port",
  "serial.config.disconnect.success": "Serial port disconnected successfully",
  "serial.config.edit.title": "Edit Serial Port Configuration",
  "serial.config.flowControl.label": "Flow Control",
  "serial.config.flowControl.none": "Aucun",
  "serial.config.form.legend": "Serial Port Settings",
  "serial.config.parity.even": "Even",
  "serial.config.parity.label": "Parity",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "Aucun",
  "serial.config.parity.odd": "Odd",
  "serial.config.parity.space": "Space",
  "serial.config.portName.label": "Port Name",
  "serial.config.save.error": "Error saving serial port configuration",
  "serial.config.save.success": "Serial port configuration saved successfully",
  "serial.config.status.label": "Connection Status",
  "serial.config.stopBits.label": "Stop Bits",
  "serial.config.validation.analyzerId.required": "Analyzer ID is required",
  "serial.config.validation.baudRate.invalid": "Baud rate must be between 9600 and 115200",
  "serial.config.validation.dataBits.invalid": "Data bits must be 7 or 8",
  "serial.config.validation.portName.required": "Port name is required",
  "server.error.msg": "Oups, erreur de serveur, veuillez contacter l'administrateur",
  "common.retry": "Réessayer",
  "show.aliquoting": "Afficher l’aliquotage",
  "showing": "Affichage",
  "breadcrumb.label.addOrder": "Ajouter une ordonnance",
  "sidenav.label.admin": "Administrateur",
  "sidenav.label.admin.backToMainMenu": "Retour au menu principal",
  "sidenav.label.admin.barcodeconfiguration": "Page des codes-barres",
  "sidenav.label.admin.labelPresets": "Modèles d’étiquettes",
  "sidenav.label.admin.commonproperties": "Propriétés de l'application",
  "sidenav.label.admin.eqaProgram": "Gestion des programmes d’EEQ",
  "sidenav.label.admin.formEntry.menustatementconfig": "Configuration de MenuStatement",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Configuration de Non-Conformité",
  "sidenav.label.admin.formEntry.patientconfig": "Page du patient",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Configuration des rapports imprimés",
  "sidenav.label.admin.formEntry.resultConfig": "Page des résultats",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Page de saisie de commande",
  "sidenav.label.admin.formEntry.siteBranding": "Personnalisation du site",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Page du site",
  "sidenav.label.admin.formEntry.validationconfig": "Configuration de validation",
  "sidenav.label.admin.formEntry.Workplanconfig": "Configuration du plan de travail",
  "sidenav.label.admin.labNumber": "Gestion des Numéro de Laboratoire",
  "sidenav.label.admin.localization": "Localisation",
  "sidenav.label.admin.menu": "Configuration du menu",
  "sidenav.label.admin.menu.billing": "Configuration du menu de facturation",
  "sidenav.label.admin.menu.global": "Menu global",
  "sidenav.label.admin.menu.nonconform": "Configuration du menu des non-conformités",
  "sidenav.label.admin.menu.patient": "Configuration du menu des patients",
  "sidenav.label.admin.menu.study": "Configuration du menu d'étude",
  "sidenav.label.admin.organizationmgt": "Gestion des organisations",
  "sidenav.label.admin.testmgt": "Configuration des tests réflexes",
  "sidenav.label.admin.testmgt.calculated": "Gestion des tests de valeur calculée",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Éditeur de catalogue d'analyses",
  "sidenav.label.admin.testCatalog": "Gestion du catalogue d'analyses",
  "sidenav.label.admin.testCatalog.backToList": "← Toutes les analyses",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Cliquez sur un test pour modifier ses sections",
  "sidenav.label.admin.testCatalog.editing": "Modification : {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Test d'édition",
  "label.testCatalog.editor": "Éditeur de catalogue d'analyses",
  "label.testCatalog.editor.empty": "Cliquez sur un test pour modifier ses sections",
  "label.testCatalog.editor.empty.helper": "Ouvrez un test dans la liste « Catalogue de tests » pour le modifier.",
  "label.testCatalog.editor.loadError": "Impossible de charger ce test. Veuillez réessayer.",
  "label.testCatalog.editor.saveAsNew": "Enregistrer sous une nouvelle analyse…",
  "label.testCatalog.editor.save.pending": "La fonction d'enregistrement sera disponible dès que les éditeurs de section seront expédiés.",
  "label.testCatalog.editor.clone.pending": "La fonction « Enregistrer sous un nouveau test » sera disponible dès que les sections de l'éditeur seront expédiées.",
  "label.testCatalog.section.pending": "L'éditeur de cette section sera expédié dans une version ultérieure.",
  "label.testCatalog.section.basic-info": "Informations de base",
  "label.testCatalog.section.sample-results": "Échantillon et résultats",
  "label.testCatalog.section.methods": "Méthodes",
  "label.testCatalog.section.ranges": "Plages",
  "label.testCatalog.section.qc-targets": "Cibles de CQ",
  "label.testCatalog.section.storage": "Stockage des échantillons",
  "label.testCatalog.section.panels": "Panels",
  "label.testCatalog.entity.panels": "Panels",
  "note.panel.domainUpgrade": "Les panneaux disposent désormais d'un Domaine ; les panneaux existants étaient configurés sur « Clinique ».",
  "note.panel.domainLaterPhase": "Les domaines « Environnemental » et « Vecteurs » seront activés lors d'une phase ultérieure.",
  "label.panel.list.description": "Ensembles ordonnés de tests ; les types d'échantillons découlent des tests qui les composent",
  "label.panel.list.empty": "Aucun panneau ne correspond aux filtres actuels.",
  "label.panel.search": "Rechercher par nom ou par code LOINC",
  "button.panel.add": "Ajouter un panneau",
  "label.panel.col.name": "Nom du panel",
  "label.panel.col.tests": "Analyses",
  "label.panel.col.domain": "Domaine",
  "label.panel.list.mixedDomain": "Domaine mixte",
  "label.panel.list.mixedDomain.detail": "Types d'échantillons hors du domaine de ce panel : {sampleTypes}",
  "label.panel.col.sampleTypes": "Types d’échantillons (dérivés)",
  "label.panel.col.status": "Statut",
  "label.panel.backToList": "Retour à la liste",
  "label.panel.notFound": "Ce panel n'existe pas ou n'a pas pu être chargé. Revenez à la liste pour en choisir un autre.",
  "title.panel.new": "Nouveau panneau",
  "label.panel.name": "Nom du panel",
  "placeholder.panel.name": "Par exemple : bilan de l'anémie",
  "label.panel.domain": "Domaine",
  "helper.panel.domainGuard": "Seuls les tests de domaine « {domain} » peuvent être ajoutés à ce panneau.",
  "helper.panel.loincIsIdentifier": "Le code LOINC du panneau sert d'identifiant.",
  "note.panel.sampleTypesDerived": "Les types d'échantillons sont déterminés en fonction des analyses comprises dans ce panel.",
  "label.panel.description": "Description",
  "label.panel.active": "Active",
  "helper.panel.needsTest": "Vous devez ajouter au moins un test avant de pouvoir activer ce panneau.",
  "error.panel.save": "Le panneau n'a pas pu être enregistré. Vérifiez les champs et réessayez.",
  "error.panel.nameRequired": "Il est obligatoire d'indiquer le nom du panel.",
  "error.panel.nameTooLong": "Un nom de panel comporte au maximum 20 caractères.",
  "error.panel.descriptionTooLong": "Une description comporte au maximum 60 caractères.",
  "error.panel.nameDuplicate": "Un autre panel utilise déjà ce nom. Saisissez un autre nom.",
  "error.panel.domainConflict": "Ce panel ne peut pas être classé sous {domain} : {count, plural, one {# de ses analyses appartient} other {# de ses analyses appartiennent}} à un autre domaine ({tests}).",
  "helper.panel.domainConflict.remedy": "Modifiez le domaine de ces analyses dans le Catalogue de tests, ou retirez-les de ce panel, puis enregistrez à nouveau.",
  "error.panel.tests.domainConflict": "Non enregistré : {tests} {count, plural, one {n'appartient pas} other {n'appartiennent pas}} au domaine de ce panel ({domain}). Seules les analyses du domaine {domain} peuvent être ajoutées.",
  "error.panel.tests.activeNeedsTest": "Non enregistré : un panel actif doit contenir au moins une analyse. Conservez une analyse, ou désactivez d'abord le panel dans Informations de base.",
  "error.panel.tests.inactive": "Non enregistré : {tests} {count, plural, one {est inactive} other {sont inactives}}. Seules les analyses actives peuvent être ajoutées à un panel.",
  "error.panel.tests.loadFailed": "Les analyses du panel n'ont pas pu être chargées, rien ne peut donc encore être enregistré. Réessayez pour les recharger.",
  "error.testCatalog.panels.domainConflict": "Cette analyse ne peut pas rejoindre {panelName} : le panel est classé sous {panelDomain} et l'analyse sous {testDomain}.",
  "error.testCatalog.panels.activeNeedsTest": "Non enregistré : cette modification laisserait un panel actif sans aucune analyse ({panels}). Désactivez d'abord {count, plural, one {ce panel} other {ces panels}}, ou conservez cette analyse dans {count, plural, one {celui-ci} other {ceux-ci}}.",
  "success.panel.created": "Panel créé. Il reste inactif tant qu'aucune analyse ne lui est attribuée.",
  "error.panel.create.invalid": "Le panel n'a pas pu être créé. Remplissez tous les champs obligatoires, y compris un code LOINC.",
  "label.panel.section.basic-info": "Informations de base",
  "label.panel.section.tests": "Analyses",
  "label.panel.section.terminology": "Terminologie",
  "label.panel.section.localization": "Localisation",
  "label.panel.localization.intro": "Modifiez les traductions par langue du nom de ce panneau. Les champs non traduits s'affichent par défaut en anglais. Gérez toutes les traductions depuis la page d'administration « Gestion des traductions ».",
  "label.panel.localization.empty": "Ce panneau ne comporte aucun champ de nom pouvant être localisé.",
  "label.panel.localization.loadError": "Impossible de charger les traductions de ce panneau.",
  "label.panel.localization.field.name": "Nom du panel",
  "sidenav.label.admin.panel.editing": "Rédaction : {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Cliquez sur un panneau pour modifier ses sections",
  "sidenav.label.admin.panel.addingNew": "Ajouter un nouveau panneau",
  "label.panel.testsCount": "Analyses",
  "label.panel.addTest": "Ajouter un test",
  "label.panel.tests.filterBySampleType": "Filtrer par type d'échantillon",
  "label.panel.tests.filterBySampleType.all": "Tous les types d'échantillons",
  "placeholder.panel.addTest": "Rechercher par nom ou par code…",
  "helper.panel.membershipSync": "Les écritures relatives aux adhésions assurent la synchronisation de la liste du panneau de saisie des commandes.",
  "label.panel.col.order": "Demande d'examen",
  "label.panel.col.testName": "Nom du test ",
  "label.panel.col.code": "Code Emplacement",
  "label.panel.moveUp": "Remonter",
  "label.panel.moveDown": "Descendre",
  "empty.panel.tests": "Aucune analyse pour l'instant — utilisez la barre de recherche ci-dessus pour ajouter la première.",
  "helper.panel.loincRouting": "Il s'agit également d'un code de routage en temps réel : les ordonnances électroniques FHIR associent les panneaux à ce code lors de leur enregistrement. Le code LOINC primaire reste associé au panneau pour l'affichage de la liste et la saisie des ordonnances.",
  "label.panel.terminology.primary": "Primaire",
  "label.panel.terminology.empty": "Il n'y a pas encore de correspondances terminologiques. La correspondance loinc correspond à l'identifiant du bilan.",
  "label.panel.terminology.saved": "Les correspondances terminologiques ont été enregistrées.",
  "label.panel.terminology.saveInvalid": "Certaines correspondances ne sont pas valides. Vérifiez la source, le Code Emplacement et les doublons.",
  "label.panel.terminology.codeTooLong": "Non enregistré : le code {code} dépasse {max} caractères.",
  "label.panel.terminology.loincTooLong": "Non enregistré : {code} n'est pas un code LOINC. Un code LOINC comporte au plus 10 caractères.",
  "label.panel.terminology.saveError": "Impossible d'enregistrer les correspondances terminologiques.",
  "note.panel.positionShared": "Cette fonction écrit la valeur de panel_item.sort_order — le même champ que celui modifié dans la section « Panels » du côté test.",
  "label.testCatalog.section.labels": "Étiquettes",
  "label.testCatalog.section.terminology": "Terminologie",
  "label.testCatalog.labels.col.preset": "Préréglage",
  "label.testCatalog.labels.col.defaultQty": "Quantité par défaut",
  "label.testCatalog.labels.col.maxQty": "Quantité maximale",
  "label.testCatalog.labels.col.allowOverride": "Autoriser la substitution",
  "label.testCatalog.labels.col.actions": "Actions",
  "label.testCatalog.labels.addLabelType": "Ajouter un type d’étiquette",
  "label.testCatalog.labels.addLabelType.placeholder": "Sélectionnez un modèle d’étiquette…",
  "label.testCatalog.labels.empty": "Aucun type d’étiquette n’a été configuré. Ajoutez des modèles d’étiquettes afin que celles-ci soient automatiquement proposées lorsque ce test est commandé.",
  "label.testCatalog.labels.loadError": "Impossible de charger la configuration des étiquettes pour ce test.",
  "label.testCatalog.labels.saved": "La configuration de l'étiquette a été enregistrée",
  "label.testCatalog.labels.saveError": "Impossible d'enregistrer la configuration de l'étiquette.",
  "label.testCatalog.labels.unsaved": "Vous avez des modifications d'étiquettes non enregistrées. Cliquez sur « Enregistrer » pour les appliquer.",
  "label.testCatalog.labels.maxLtDefault": "La quantité maximale doit être supérieure ou égale à la quantité par défaut.",
  "label.testCatalog.labels.allowOverride.label": "Autoriser la modification lors de la saisie de la commande",
  "label.testCatalog.labels.generationSettings": "Paramètres de génération d'étiquettes",
  "label.testCatalog.labels.remove.action": "Retirer",
  "label.testCatalog.labels.remove.title": "Retirer le type d’étiquette",
  "label.testCatalog.labels.remove.confirm": "Retirer",
  "label.testCatalog.labels.remove.body": "Souhaitez-vous retirer « {name} » de la configuration des étiquettes de ce test ?",
  "label.testCatalog.section.reagents": "Réactifs",
  "label.testCatalog.section.analyzers": "Analyseurs",
  "label.testCatalog.section.alerts": "Alertes",
  "label.testCatalog.section.accreditation": "Accréditation",
  "label.testCatalog.accreditation.add": "Ajouter une accréditation",
  "label.testCatalog.accreditation.added": "Accréditation ajoutée",
  "label.testCatalog.accreditation.removed": "Accréditation retirée",
  "label.testCatalog.accreditation.empty": "Cette analyse n'est accréditée par aucun organisme.",
  "label.testCatalog.accreditation.selectBody": "Choisir un organisme d'accréditation",
  "label.testCatalog.accreditation.remove": "Retirer l'accréditation",
  "label.testCatalog.accreditation.remove.body": "Retirer cette analyse de {body} ? Son logo n'apparaîtra plus sur les rapports qui ne contiennent que cette analyse.",
  "label.testCatalog.accreditation.manageLink": "Gérer les organismes d'accréditation et les dates d'expiration",
  "label.testCatalog.accreditation.loadError": "L'accréditation n'a pas pu être chargée.",
  "label.testCatalog.accreditation.saveError": "L'accréditation n'a pas pu être ajoutée.",
  "label.testCatalog.accreditation.deleteError": "L'accréditation n'a pas pu être retirée.",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "Localisation",
  "label.testCatalog.section.display-order": "Ordre d'affichage",
  "label.sampleType.section.basic-info": "Informations de base",
  "label.sampleType.section.associated-tests": "Analyses associées",
  "label.sampleType.section.terminology": "Terminologie",
  "label.sampleType.section.localization": "Localisation",
  "label.sampleType.localization.intro": "Modifiez les traductions par langue pour le nom de ce type d'exemple. Les champs non traduits s'affichent par défaut en anglais. Gérez toutes les traductions depuis la page d'administration « Gestion des traductions ».",
  "label.sampleType.localization.empty": "Ce type d'échantillon ne comporte aucun champ de nom localisable.",
  "label.sampleType.localization.loadError": "Impossible de charger les traductions pour ce type d’échantillon.",
  "label.sampleType.localization.field.name": "Nom du type d'échantillon",
  "label.sampleType.terminology.intro": "Associez ce type d'échantillon aux codes terminologiques standard à des fins d'interopérabilité.",
  "label.sampleType.terminology.empty": "Non, il n'y a pour l'instant aucune correspondance terminologique.",
  "label.sampleType.terminology.saved": "Les correspondances terminologiques ont été enregistrées.",
  "label.sampleType.terminology.saveError": "Impossible d'enregistrer les correspondances terminologiques.",
  "label.sampleType.terminology.saveInvalid": "Certaines correspondances ne sont pas valides. Vérifiez la source, le Code Emplacement et les doublons.",
  "label.sampleType.terminology.addHint": "Enregistrez d'abord ce type d'échantillon, puis ajoutez les correspondances terminologiques.",
  "label.sampleType.localization.addHint": "Enregistrez d'abord ce type d'échantillon, puis modifiez ses traductions.",
  "label.sampleType.name": "Nom",
  "label.sampleType.section.display-order": "Ordre d'affichage",
  "label.sampleType.section.disposal": "Élimination",
  "label.sampleType.displayOrder": "Position dans le menu « Type d'échantillon »",
  "label.sampleType.displayOrder.intro": "Placez ce type d'échantillon dans le menu « Type d'échantillon » de la saisie de commande. Saisissez un numéro ou utilisez les flèches, puis enregistrez : tous les types d'échantillons sont renumérotés.",
  "label.sampleType.displayOrder.current": "Ce type d'échantillon",
  "label.sampleType.displayOrder.loading": "Chargement des types d’échantillons...",
  "label.sampleType.displayOrder.saved": "L'ordre d'affichage a été mis à jour.",
  "label.sampleType.displayOrder.saveError": "Impossible de mettre à jour l'ordre d'affichage.",
  "label.sampleType.displayOrder.addHint": "Enregistrez d'abord ce type d'échantillon, puis définissez sa position dans le menu.",
  "label.sampleType.disposalInstructions": "Consignes d'élimination",
  "label.sampleType.disposal.intro": "Consignes générales sous forme de texte libre concernant l'élimination de ce type d'échantillon. Les instructions officielles et structurées figurent dans la section de Stockage de chaque test ainsi que dans le plan de travail d'élimination des échantillons.",
  "label.sampleType.disposal.placeholder": "Par exemple : stérilisation en autoclave avant rejet avec les déchets à risque biologique",
  "label.sampleType.disposal.loading": "Chargement des consignes d'élimination...",
  "label.sampleType.disposal.saved": "Les consignes d'élimination ont été enregistrées.",
  "label.sampleType.disposal.saveError": "Impossible d'enregistrer les consignes d'élimination.",
  "label.sampleType.disposal.addHint": "Enregistrez d'abord ce type d'échantillon, puis ajoutez les consignes d'élimination.",
  "label.sampleType.tests.manageIntro": "Tests associés à ce type d'échantillon. Effectuez une recherche dans le catalogue pour en ajouter d'autres ou retirer des liens existants. Ce même lien peut également être géré à partir des « Informations de base » d'un test dans le catalogue des tests.",
  "label.sampleType.tests.search": "Analyses de recherche",
  "label.sampleType.tests.searchPlaceholder": "Rechercher par nom de test...",
  "label.sampleType.tests.filterBySampleType": "Filtrer par type d'échantillon",
  "label.sampleType.tests.filterBySampleType.all": "N'importe quel type d'échantillon",
  "label.sampleType.tests.pick": "Test d'ajout",
  "label.sampleType.tests.pickPlaceholder": "Sélectionner un test...",
  "label.sampleType.tests.add": "Ajouter un test",
  "label.sampleType.tests.addError": "Impossible d'associer le test à ce type d'échantillon.",
  "label.sampleType.tests.domainMismatch": "Cette analyse appartient à un autre domaine que ce type d'échantillon, elle ne peut donc pas l'utiliser.",
  "label.sampleType.tests.remove": "Retirer l'analyse",
  "helper.sampleType.name": "Saisissez un nom unique pour ce type d'échantillon (par ex. \"Sérum\", \"Sang total\")",
  "helper.sampleType.description": "Saisissez une description de ce type d'échantillon pour référence du personnel de laboratoire",
  "label.sampleType.active": "Active",
  "label.sampleType.description": "Description",
  "label.sampleType.tests.removeError": "Impossible de dissocier le test.",
  "label.sampleType.tests.removeLastOfActive": "Non dissocié : il s'agit du seul type d'échantillon d'une analyse active, qui ne pourrait alors plus être demandée. Attribuez d'abord un autre type d'échantillon à l'analyse ou désactivez-la.",
  "label.sampleType.tests.loading": "Chargement des analyses associées...",
  "label.sampleType.tests.none": "Aucune analyse n'est associée à ce type d'échantillon.",
  "message.sampleType.add.success": "Le type d'échantillon a été enregistré avec succès.",
  "message.sampleType.edit.success": "Le type d'échantillon a été mis à jour avec succès.",
  "heading.sampleType.add": "Ajouter un nouveau type d'échantillon",
  "button.sampleType.create": "Créer un type d'échantillon",
  "button.sampleType.creating": "Création...",
  "heading.sampleType.filtered": "{filtered} sur {total} types d'échantillons affichés",
  "heading.sampleType.total": "Total : {total} types d'échantillons",
  "label.sampleType.tests.addHint": "Enregistrez d'abord ce type d'échantillon, puis associez les analyses depuis la configuration des analyses.",
  "message.sampleType.noResults": "Aucun type d'échantillon ne correspond à vos critères",
  "error.sampleType.create.invalidName": "Ce nom contient des caractères non autorisés, comme des balises HTML. Supprimez-les et réessayez.",
  "error.sampleType.create.invalid": "Le type d'échantillon n'a pas été créé. Vérifiez les champs et réessayez.",
  "error.sampleType.create.duplicateName": "Un type d'échantillon portant ce nom existe déjà.",
  "error.sampleType.create.duplicateDescription": "Un autre type d'échantillon de ce domaine possède déjà cette description.",
  "error.sampleType.update.description.409": "Un autre type d'échantillon de ce domaine possède déjà cette description.",
  "error.sampleType.update.abbreviation.409": "Un autre type d'échantillon de ce domaine utilise déjà cette abréviation.",
  "error.sampleType.update.abbreviation.400": "L'abréviation comporte au maximum 10 caractères.",
  "error.sampleType.update.whonetCode.400": "Le code WHONET comporte au maximum 5 caractères.",
  "error.sampleType.update.description.400": "La description comporte au maximum 40 caractères.",
  "error.sampleType.nameTooLong": "Le nom d'un nouveau type d'échantillon comporte au maximum 40 caractères.",
  "label.sampleType.loading": "Chargement du type d'échantillon...",
  "label.sampleType.notFound": "Ce type d'échantillon n'existe pas. Revenez à la liste pour en choisir un autre.",
  "label.sampleType.editorLoadError": "Impossible de charger les types d'échantillons. Actualisez la page pour réessayer.",
  "stock.status.pendingQc": "QC en attente",
  "stock.status.qcFailed": "Échec du CQ",
  "stock.status.quarantined": "En quarantaine",
  "label.sampleType.whonetCode": "Code d'échantillon WHONET",
  "helper.sampleType.whonetCode": "Code saisi dans le champ SPECIMEN_TYPE de WHONET (5 caractères maximum).",
  "label.sampleType.whonetReturn": "Retour à l'aperçu de WHONET",
  "warning.sampleType.deactivateInUse": "{count} Les tests actifs utilisent ce type ; ils ne seront pas sélectionnables tant qu'il est inactif.",
  "note.sampleType.associatedTests.viewOnly": "Affichage uniquement — l'échantillon d'un test fait partie intégrante de son identité. Pour effectuer un test sur ce type d'échantillon, créez une variante d'échantillon dans le catalogue de tests.",
  "sidenav.label.admin.sampleType.backToList": "← Tous les types d’échantillons",
  "sidenav.label.admin.sampleType.editing": "Modification : {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Modification du type d'échantillon",
  "sidenav.label.admin.sampleType.sectionsHelper": "Cliquez sur un type d'échantillon pour modifier ses sections",
  "sidenav.label.admin.sampleType.addingNew": "Ajout d'un nouveau type d'échantillon",
  "label.testCatalog.localization.locale": "Localisation",
  "label.testCatalog.localization.intro": "Modifiez les traductions par langue du nom de ce test et de son nom dans les rapports. Les champs non traduits s'affichent par défaut en anglais. Gérez toutes les traductions depuis la page d'administration « Gestion des traductions ».",
  "label.testCatalog.localization.unsaved": "Vous avez des modifications de traduction non enregistrées. Cliquez sur « Enregistrer » pour les appliquer.",
  "label.testCatalog.localization.loadError": "Impossible de charger les traductions pour cette analyse.",
  "label.testCatalog.localization.empty": "Ce test ne comporte aucun champ de nom localisable.",
  "label.testCatalog.localization.saved": "Traduction enregistrée",
  "label.testCatalog.localization.saveError": "Impossible d'enregistrer la traduction.",
  "label.testCatalog.localization.fallbackRequired": "La valeur anglaise est celle que chaque écran affiche en l'absence de traduction, elle ne peut donc pas être vide.",
  "label.testCatalog.localization.field.name": "Nom du test ",
  "label.testCatalog.localization.field.reportingName": "Nom du rapport",
  "label.testCatalog.localization.fallback.en": "Solution de repli (An)",
  "label.testCatalog.localization.fallback.tooltip": "L'affichage de la valeur en anglais se produit car aucune traduction n'est configurée pour « {locale} ».",
  "label.testCatalog.reflexCalc.loadError": "Impossible de charger les liens croisés relatifs aux réflexes et aux calculs pour ce test.",
  "label.testCatalog.reflexCalc.reflex.heading": "Tests de réflexes",
  "label.testCatalog.reflexCalc.reflex.helper": "Règles qui commandent automatiquement des analyses supplémentaires en fonction des résultats de ce test. À gérer dans « Listes principales » → « Règles Reflex ».",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Nom de la règle",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Condition de déclencheur",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Tests de réflexes prescrits",
  "label.testCatalog.reflexCalc.reflex.empty": "Non de règles Reflex configurées. Les règles Reflex sont gérées dans « Listes principales » → « Règles Reflex ».",
  "label.testCatalog.reflexCalc.reflex.manage": "Gérer les règles Reflex",
  "label.testCatalog.reflexCalc.calc.heading": "Résultats calculés",
  "label.testCatalog.reflexCalc.calc.helper": "Formules qui utilisent les résultats de ce test ou qui génèrent ce test en sortie. Gérez-les dans « Listes principales » → « Résultats calculés ».",
  "label.testCatalog.reflexCalc.calc.feedsInto": "Cette analyse alimente",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "Ce test est calculé comme suit :",
  "label.testCatalog.reflexCalc.calc.col.name": "Nom de la formule",
  "label.testCatalog.reflexCalc.calc.col.formula": "Formule",
  "label.testCatalog.reflexCalc.calc.col.output": "Test de sortie",
  "label.testCatalog.reflexCalc.calc.empty": "Aucun",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "Ce test n'est pris en compte dans aucun résultat calculé. Les calculs sont gérés dans « Listes principales » → « Valeurs calculées ».",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "Ce test n'est pas calculé à partir d'autres tests. Les calculs sont gérés dans « Listes principales » → « Valeurs calculées ».",
  "label.testCatalog.reflexCalc.calc.manage": "Gérer les résultats calculés",
  "label.testCatalog.alerts.addRule": "Ajouter une règle",
  "label.testCatalog.alerts.empty": "Aucune règle d'alerte n'a été configurée. Ajoutez une règle pour avertir les destinataires lorsque les résultats répondent à une condition.",
  "label.testCatalog.alerts.loadError": "Impossible de charger les règles d'alerte pour ce test.",
  "label.testCatalog.alerts.saved": "Règle d'alerte enregistrée",
  "label.testCatalog.alerts.saveError": "Impossible d'enregistrer la règle d'alerte.",
  "label.testCatalog.alerts.saveRefused": "La règle d'alerte a été refusée. Le nom, la valeur et l'e-mail personnalisé comportent au plus 100 caractères, le téléphone personnalisé 20, et le rôle doit pouvoir être notifié.",
  "label.testCatalog.alerts.deleted": "Règle d'alerte supprimée",
  "label.testCatalog.alerts.deleteError": "Impossible de supprimer la règle d'alerte.",
  "label.testCatalog.alerts.nameRequired": "Le nom de la règle est obligatoire.",
  "label.testCatalog.alerts.valueRequired": "Une valeur spécifique est requise pour le déclencheur « Valeur spécifique ».",
  "label.testCatalog.alerts.col.name": "Nom",
  "label.testCatalog.alerts.col.trigger": "Déclencheur",
  "label.testCatalog.alerts.col.channels": "Chaînes",
  "label.testCatalog.alerts.col.ack": "Accusé de réception requis",
  "label.testCatalog.alerts.col.enabled": "Activée",
  "label.testCatalog.alerts.col.actions": "Actions",
  "label.testCatalog.alerts.trigger.ALL": "Tous les résultats",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Anormal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Critique",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Valeur spécifique",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Manquement aux obligations de conformité",
  "label.testCatalog.alerts.edit.action": "Modifier",
  "label.testCatalog.alerts.delete.action": "Supprimer",
  "label.testCatalog.alerts.delete.title": "Supprimer une règle d'alerte",
  "label.testCatalog.alerts.delete.confirm": "Supprimer",
  "label.testCatalog.alerts.delete.body": "Supprimer la règle d'alerte « {name} » ?",
  "label.testCatalog.alerts.modal.addTitle": "Ajouter une règle d'alerte",
  "label.testCatalog.alerts.modal.editTitle": "Modifier une règle d'alerte",
  "label.testCatalog.alerts.field.name": "Nom de la règle",
  "label.testCatalog.alerts.field.trigger": "Envoyer une alerte lorsque le résultat est :",
  "label.testCatalog.alerts.field.specificValue": "Valeur spécifique",
  "label.testCatalog.alerts.field.channels": "Canaux de notification",
  "label.testCatalog.alerts.field.recipients": "Destinataires",
  "label.testCatalog.alerts.field.ackRequired": "Exiger un accusé de réception",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "E-mail",
  "label.testCatalog.alerts.recipient.physician": "Médecin prescripteur",
  "label.testCatalog.alerts.recipient.patient": "Patient",
  "label.testCatalog.alerts.recipient.facility": "Établissement Référant",
  "label.testCatalog.alerts.recipient.customPhone": "Téléphone personnalisé",
  "label.testCatalog.alerts.recipient.customEmail": "E-mail personnalisé",
  "label.testCatalog.alerts.recipient.roleId": "Informer les utilisateurs ayant ce rôle",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Sélectionnez un rôle",
  "label.testCatalog.reagents.col.name": "Nom du réactif",
  "label.testCatalog.reagents.col.usage": "Type d'utilisation",
  "label.testCatalog.reagents.col.qty": "Quantité par analyse",
  "label.testCatalog.reagents.col.stock": "Niveau de stock",
  "label.testCatalog.reagents.col.actions": "Actions",
  "label.testCatalog.reagents.empty": "Aucun réactif n'est associé. Associez les réactifs de l'Inventaire afin de suivre leur consommation par analyse.",
  "label.testCatalog.reagents.loadError": "Impossible de charger les réactifs nécessaires à cette analyse.",
  "label.testCatalog.reagents.linkButton": "Réactif de liaison",
  "label.testCatalog.reagents.linkError": "Impossible d'associer un ou plusieurs réactifs. Veuillez réessayer.",
  "label.testCatalog.reagents.modal.title": "Réactifs de liaison",
  "label.testCatalog.reagents.modal.linkSelected": "Lien sélectionné",
  "label.testCatalog.reagents.modal.select.label": "Réactifs",
  "label.testCatalog.reagents.modal.select.placeholder": "Sélectionnez les réactifs à associer",
  "label.testCatalog.reagents.modal.allLinked": "Tous les réactifs disponibles sont déjà associés à ce test.",
  "label.testCatalog.reagents.unitPlaceholder": "Unité",
  "label.testCatalog.reagents.updated": "Réactif mis à jour",
  "label.testCatalog.reagents.saveError": "Impossible d'enregistrer les modifications.",
  "label.testCatalog.reagents.unitTooLong": "Une unité peut comporter au plus 50 caractères.",
  "label.testCatalog.reagents.unsaved": "Vous avez des modifications de réactifs non enregistrées. Cliquez sur « Enregistrer » pour les appliquer.",
  "label.testCatalog.reagents.retry": "Réessayer",
  "label.testCatalog.reagents.unlink.action": "Supprimer le lien",
  "label.testCatalog.reagents.unlink.title": "Réactif de dissociation",
  "label.testCatalog.reagents.unlink.confirm": "Supprimer le lien",
  "label.testCatalog.reagents.unlink.body": "Souhaitez-vous dissocier « {name} » de ce test ? Les résultats existants associés à ce réactif ne sont pas affectés.",
  "label.testCatalog.reagents.unlinked": "Réactif non associé",
  "label.testCatalog.reagents.unlinkError": "Impossible de dissocier le réactif. Veuillez réessayer.",
  "label.testCatalog.basicInfo.name": "Nom",
  "label.testCatalog.basicInfo.name.helper": "Le nom d'affichage est traduit — vous pouvez le modifier dans la section « Localisation ».",
  "label.testCatalog.basicInfo.reportingName": "Nom d'affichage",
  "label.testCatalog.basicInfo.labUnit": "Unité de laboratoire",
  "label.testCatalog.basicInfo.labUnit.inactive": "{name} (inactive)",
  "label.testCatalog.basicInfo.labUnit.inactiveHelp": "Cette unité de laboratoire est inactive, l'analyse ne peut donc pas être demandée. L'enregistrement la laisse inactive ; réactivez-la dans Gestion des unités de laboratoire.",
  "label.testCatalog.basicInfo.createInactiveHint": "Le test est créé en mode « Inactif ». Configurez ses sections, puis activez-le pour qu'il soit sélectionnable.",
  "sidenav.label.environmental.compliance.tooltip": "Tableau de bord de conformité environnementale",
  "site.search.helper": "Saisissez au moins 2 caractères pour lancer la recherche automatique. Ce champ est obligatoire pour renvoyer les résultats vers le site demandeur.",
  "storage.skipped.title": "Le stockage a été ignoré pour {count} échantillon(s)",
  "test.qc.blankThreshold": "Seuil vierge",
  "test.qc.recoveryWindowPct": "Taux de récupération (%)",
  "test.qc.rpdThreshold": "Seuil RPD (%)",
  "test.qc.thresholds.description": "Seuils facultatifs pour l'évaluation du contrôle qualité environnemental et des vecteurs. Laissez ce champ vide si cela ne s'applique pas.",
  "test.qc.thresholds.heading": "Seuils d'acceptation du QC",
  "title.testCatalog.createTest": "Créer un nouveau test",
  "label.testCatalog.testName": "Nom du test",
  "label.testCatalog.testCode": "Code de test",
  "label.testCatalog.domain": "Domaine",
  "label.testCatalog.specimenType": "Type d'échantillon",
  "label.testCatalog.basicInfo.sampleTypes": "Types d’échantillons",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Sélectionnez tous les échantillons sur lesquels ce test est effectué. La configuration est commune à tous ces échantillons.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Veuillez sélectionner au moins un type d'échantillon.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "Le domaine de ce type d'échantillon ne correspond pas à celui du test.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Échantillon",
  "label.testCatalog.override.shared": "Tous les échantillons (partagés)",
  "notice.testCatalog.intake.awaitingSpecimen": "En attente d'échantillon — ce test est réalisé sur plusieurs échantillons ; à régler au moment du prélèvement.",
  "tag.testCatalog.finding.noSampleTypeLink": "Non de lien de type « échantillon »",
  "error.testCatalog.codeExists": "Un test utilisant ce code existe déjà.",
  "error.testCatalog.description.inUse": "Un autre test utilise déjà cette description. Les descriptions doivent être uniques : modifiez-la et enregistrez à nouveau.",
  "notification.testCatalog.testCreated": "Le test « {name} » a été créé. Veuillez terminer sa configuration dans les sections situées à gauche.",
  "label.testCatalog.basicInfo.code": "Code Emplacement",
  "label.testCatalog.basicInfo.description": "Description",
  "label.testCatalog.basicInfo.domain": "Domaine",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Clinique",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Environnemental",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vecteur",
  "label.testCatalog.basicInfo.domainModal.title": "Changer le domaine de test ?",
  "label.testCatalog.basicInfo.domainModal.body": "Souhaitez-vous modifier le domaine de ce test pour le remplacer par « {domain} » ? Cela a une incidence sur la manière dont le test est classé dans le Catalogue.",
  "label.testCatalog.basicInfo.amr": "Test de surveillance des bactéries résistantes aux antibiotiques (AMR)",
  "label.testCatalog.basicInfo.active": "Active",
  "label.testCatalog.basicInfo.status": "Statut",
  "label.testCatalog.basicInfo.orderable": "Sélectionnable",
  "label.testCatalog.basicInfo.saved": "Les informations de base ont été enregistrées.",
  "error.testCatalog.basicInfo.labUnitInactive": "Cette unité de laboratoire est inactive. Choisissez une unité active, ou réactivez-la d'abord dans Gestion des unités de laboratoire.",
  "error.testCatalog.create.refused": "L'analyse n'a pas été créée : un type d'échantillon ou l'unité de laboratoire ne peut pas être utilisé. Vérifiez-les et réessayez.",
  "error.testCatalog.basicInfo.invalidValue": "Les informations de base n'ont pas été enregistrées : l'une des valeurs ne peut pas être stockée. Corrigez le champ en surbrillance.",
  "error.testCatalog.basicInfo.timeHolding": "Saisissez un nombre entier de minutes, ou laissez vide.",
  "error.testCatalog.basicInfo.qcThreshold": "Saisissez un nombre supérieur ou égal à 0 (jusqu'à 5 décimales), ou laissez vide.",
  "label.testCatalog.sampleResults.saved": "L'échantillon et les résultats ont été enregistrés.",
  "label.testCatalog.sampleResults.empty": "Il n'y a pas encore de composants de résultat. Ajoutez-en un pour définir comment les résultats de ce test sont enregistrés.",
  "label.testCatalog.sampleResults.newComponent": "(nouveau composant)",
  "label.testCatalog.sampleResults.code": "Code du composant",
  "label.testCatalog.sampleResults.isPrimary": "Composant primaire",
  "label.testCatalog.sampleResults.showOnReport": "Afficher dans le dossier du patient",
  "label.testCatalog.sampleResults.label": "Étiquette du composant",
  "label.testCatalog.sampleResults.resultType": "Type de résultat",
  "label.testCatalog.sampleResults.resultType.N": "Numérique",
  "label.testCatalog.sampleResults.resultType.none": "Aucun type de résultat n'a été sélectionné",
  "label.testCatalog.sampleResults.preview.noType": "Sélectionnez un type de résultat ci-dessus pour voir comment les techniciens saisiront ce résultat.",
  "label.testCatalog.sampleResults.resultType.D": "Liste à sélection unique (dictionnaire)",
  "label.testCatalog.sampleResults.resultType.R": "Texte libre",
  "label.testCatalog.sampleResults.resultType.M": "Liste à sélection multiple",
  "label.testCatalog.sampleResults.resultType.C": "Sélection multiple en cascade",
  "label.testCatalog.sampleResults.resultType.T": "Titre",
  "label.testCatalog.sampleResults.resultType.A": "Alpha (texte validé)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Courant",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Types avancés / types hérités",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Types avancés / types hérités",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Masquer les types avancés / hérités",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "Une valeur mesurée accompagnée d'une unité (par exemple, 12,3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "Une valeur choisie parmi un ensemble fixe (par exemple : « Détecté » / « Non détecté »).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "Un commentaire ou une description rédigé(e) à l'ordinateur.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "Une ou plusieurs valeurs issues d'une liste ; aucune valeur de référence unique.",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Options regroupées ; sélectionnez plusieurs groupes.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "Un rapport de dilution tel que 1:10 ou 1:20 (courant en Sérologie).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Texte alphanumérique validé (un code ou une valeur codée courte).",
  "label.testCatalog.sampleResults.preview": "Aperçu de la saisie des résultats",
  "label.testCatalog.sampleResults.previewHelper": "Voici ce que verra un technicien lorsqu'il saisira ce résultat.",
  "label.testCatalog.sampleResults.purpose": "Précisez ce que le technicien doit consigner pour ce test et comment les résultats sont interprétés.",
  "label.testCatalog.sampleResults.labelRequired": "Chaque élément de résultat doit être intitulé avant de pouvoir être enregistré.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Veuillez sélectionner un type de résultat pour « {component} » avant d'enregistrer.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "La plupart des analyses fournissent un seul résultat. N'ajoutez un composant que si cette analyse produit plusieurs valeurs (par exemple, un différentiel).",
  "label.testCatalog.sampleResults.displayOrder": "Ordre d'affichage",
  "label.testCatalog.sampleResults.uom": "Unité de mesure",
  "label.testCatalog.sampleResults.uom.none": "(aucun)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Ajouter une nouvelle unité…",
  "label.testCatalog.sampleResults.uom.newName": "Nom d'affichage",
  "label.testCatalog.sampleResults.uom.newCode": "Code Emplacement",
  "label.testCatalog.sampleResults.uom.newUcum": "Code Emplacement UCUM",
  "label.testCatalog.sampleResults.uom.newDescription": "Description",
  "label.testCatalog.sampleResults.uom.saveNew": "Créer une unité",
  "label.testCatalog.sampleResults.significantDigits": "Chiffres significatifs",
  "label.testCatalog.sampleResults.significantDigits.helper": "Nombre de chiffres à conserver après la virgule lors de la saisie d'un résultat numérique. Laissez ce champ vide pour ne pas arrondir.",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Limite de détection (facultatif)",
  "admin.testCatalog.sampleResults.loq.helper": "Limite de quantification (facultatif)",
  "error.testCatalog.sampleResults.valueTooLong": "{component} : une valeur dépasse la longueur autorisée par son champ (libellé 255, code 50, résultat par défaut et valeur d'option 80 ; texte d'interprétation 255, correspondance 80, gravité et couleur 20 caractères).",
  "error.testCatalog.sampleResults.unitUnknown": "{component} : cette unité de mesure n'existe pas.",
  "error.testCatalog.sampleResults.activeNeedsComponent": "Non enregistré : une analyse active doit avoir au moins un composant de résultat. Conservez un composant, ou désactivez d'abord l'analyse dans Informations de base.",
  "error.testCatalog.sampleResults.lodGtLoq": "La LOD ne peut pas être supérieure à la LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Les limites de détection doivent être supérieures ou égales à zéro.",
  "admin.testCatalog.qcTargets.section.label": "Cibles de CQ",
  "admin.testCatalog.qcTargets.intro": "Les cibles de contrôle par rapport auxquelles la saisie des résultats évalue chaque série de CQ. Saisissez-les une seule fois ici pour que les techniciens n'aient à saisir que la valeur mesurée.",
  "admin.testCatalog.qcTargets.column.level": "Niveau de contrôle",
  "admin.testCatalog.qcTargets.column.expected": "Valeur attendue",
  "admin.testCatalog.qcTargets.column.uncertainty": "Incertitude (±)",
  "admin.testCatalog.qcTargets.column.unit": "Unité",
  "admin.testCatalog.qcTargets.column.overrides": "Substitutions par lot",
  "admin.testCatalog.qcTargets.column.status": "Statut",
  "admin.testCatalog.qcTargets.column.actions": "Actions",
  "admin.testCatalog.qcTargets.level.low": "Bas",
  "admin.testCatalog.qcTargets.level.normal": "Normal",
  "admin.testCatalog.qcTargets.level.high": "Haut",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Résultat attendu",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Choisissez le résultat attendu",
  "admin.testCatalog.qcTargets.addTarget": "Ajouter une cible",
  "admin.testCatalog.qcTargets.addOverride": "Ajouter une substitution par lot",
  "admin.testCatalog.qcTargets.lot.label": "Lot de contrôle",
  "admin.testCatalog.qcTargets.lot.placeholder": "Rechercher des lots de contrôle…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "Aucun lot trouvé : gérez les lots dans la gestion des lots de CQ",
  "admin.testCatalog.qcTargets.overrides.none": "Aucune substitution par lot",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, one {# substitution par lot} many {# substitutions par lot} other {# substitutions par lot}}",
  "admin.testCatalog.qcTargets.empty.level": "Aucune cible configurée : les techniciens saisissent les valeurs lors de l'enregistrement",
  "admin.testCatalog.qcTargets.helper.precedence": "Lors de la saisie des résultats, le formulaire de contrôle est prérempli à partir de la substitution du lot si elle existe, sinon à partir de la valeur par défaut du niveau.",
  "admin.testCatalog.qcTargets.showDeactivated": "Affichage désactivé",
  "admin.testCatalog.qcTargets.deactivate": "Désactiver",
  "admin.testCatalog.qcTargets.reactivate": "Réactiver",
  "admin.testCatalog.qcTargets.edit": "Modifier la cible",
  "admin.testCatalog.qcTargets.done": "Terminer",
  "admin.testCatalog.qcTargets.saved": "Cibles de CQ enregistrées.",
  "admin.testCatalog.qcTargets.loadError": "Impossible de charger les cibles de CQ.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "L'incertitude doit être un nombre non négatif.",
  "error.testCatalog.qcTargets.required": "Chaque cible active nécessite une valeur attendue et une incertitude, ou un résultat attendu.",
  "label.testCatalog.sampleResults.defaultResult": "Résultat par défaut",
  "label.testCatalog.sampleResults.defaultResult.none": "Aucune valeur par défaut",
  "label.testCatalog.sampleResults.allowMultiple": "Autoriser plusieurs lectures",
  "label.testCatalog.sampleResults.options": "Options de la liste de sélection",
  "label.testCatalog.sampleResults.options.empty": "Aucune option n'a encore été définie. Veuillez ajouter au moins une option afin que ce résultat puisse être saisi.",
  "label.testCatalog.sampleResults.option.value": "Valeur",
  "label.testCatalog.sampleResults.option.sortOrder": "Ordre de tri",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Les options sont présentées aux techniciens par ordre croissant : les chiffres les plus bas apparaissent en premier.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.option.qualifiable": "Qualifiable",
  "error.testCatalog.sampleResults.duplicateOption": "{component} contient {options} plus d'une fois. Supprimez la ligne en trop pour que la saisie des résultats propose chaque option une seule fois.",
  "label.testCatalog.sampleResults.addOption": "Ajouter une option",
  "label.testCatalog.sampleResults.addCustomOption": "Ajouter une option personnalisée",
  "label.testCatalog.sampleResults.searchDictionary": "Rechercher des valeurs du dictionnaire…",
  "label.testCatalog.sampleResults.removeOption": "Option « Retirer »",
  "label.testCatalog.sampleResults.interpretations": "Interprétations",
  "label.testCatalog.sampleResults.interpretations.empty": "Aucune interprétation n'a été définie. Veuillez ajouter une interprétation afin d'associer des recommandations ou un indicateur de gravité à un résultat.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Garantie de la valeur la plus élevée",
  "label.testCatalog.sampleResults.interp.selectValue": "Choisissez une valeur…",
  "label.testCatalog.sampleResults.interp.numericHint": "par exemple : >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Interpretation",
  "label.testCatalog.sampleResults.interp.severity": "Gravité",
  "label.testCatalog.sampleResults.addInterpretation": "Ajouter une interprétation",
  "label.testCatalog.sampleResults.removeInterpretation": "Retirer l'interprétation",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Anormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Critique",
  "label.testCatalog.sampleResults.actions": "Actions",
  "label.testCatalog.sampleResults.addComponent": "Ajouter un composant",
  "label.testCatalog.sampleResults.removeComponent": "Retirer un composant",
  "label.testCatalog.sampleResults.moveUp": "Déplacer le composant vers le haut",
  "label.testCatalog.sampleResults.moveDown": "Déplacer le composant vers le bas",
  "label.testCatalog.sampleResults.copyFrom": "Copier la configuration de « test »",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Sélectionner un test…",
  "label.testCatalog.sampleResults.copyFromButton": "Copier de « test »",
  "label.testCatalog.sampleResults.copyConfirm.title": "Remplacer la configuration des résultats de cette analyse ?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Chaque composant de résultat, option de liste de sélection et interprétation de cette analyse sera remplacé par ceux de {source}. Rien ne change tant que vous n'avez pas cliqué sur Enregistrer. Une fois enregistré, le remplacement est irréversible.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Remplacer la configuration",
  "label.testCatalog.sampleResults.copyStaged": "Configuration copiée depuis {source}, pas encore enregistrée",
  "label.testCatalog.sampleResults.copyStaged.helper": "Cliquez sur Enregistrer pour remplacer la configuration de cette analyse par celle-ci, ou abandonnez-la pour conserver la configuration actuelle.",
  "label.testCatalog.sampleResults.copyDiscard": "Abandonner la configuration copiée",
  "label.testCatalog.sampleResults.copyEmpty": "{source} n'a aucune configuration de résultats à copier.",
  "label.testCatalog.sampleResults.copyLoadError": "La configuration de {source} n'a pas pu être chargée.",
  "label.testCatalog.sampleResults.copied": "La configuration a été copiée.",
  "label.testCatalog.ranges.activated": "Test activé.",
  "label.testCatalog.ranges.ackModal.title": "Activer en cas de lacunes de couverture ?",
  "label.testCatalog.ranges.ackModal.confirm": "Accuser réception et activer",
  "label.testCatalog.ranges.ackModal.warning": "Ces analyses présentent des lacunes dans la couverture des plages de référence.",
  "label.testCatalog.ranges.ackModal.body": "Les tests suivants ne disposent pas de fourchette de référence — les résultats correspondants ne peuvent donc pas être comparés à une fourchette. Veuillez valider pour les activer malgré tout.",
  "label.testCatalog.ranges.male": "Mâle",
  "label.testCatalog.ranges.female": "Femelle",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "jours",
  "label.testCatalog.ranges.months": "Mois",
  "label.testCatalog.ranges.years": "années",
  "label.testCatalog.ranges.noUpperLimit": "pas de limite maximale",
  "label.testCatalog.ranges.noLowerLimit": "pas de limite inférieure",
  "label.testCatalog.ranges.both": "Les deux",
  "label.testCatalog.ranges.add": "Ajouter une plage",
  "label.testCatalog.ranges.empty": "Non, aucune plage de référence n'a encore été définie.",
  "label.testCatalog.ranges.saved": "Les plages de référence ont été enregistrées.",
  "label.testCatalog.ranges.loadError": "Impossible de charger les plages de référence.",
  "label.testCatalog.ranges.col.component": "Composant",
  "label.testCatalog.ranges.allComponents": "Tous les composants",
  "label.testCatalog.ranges.col.sex": "Sexe",
  "label.testCatalog.ranges.col.age": "Tranche d'âge",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Critique",
  "label.testCatalog.ranges.col.valid": "Valid",
  "label.testCatalog.ranges.col.actions": "Actions",
  "label.testCatalog.ranges.anyAge": "N'importe lequel",
  "label.testCatalog.ranges.coverage.title": "Validation de la couverture",
  "label.testCatalog.ranges.coverage.gapsHeading": "Tranches d'âge non couvertes :",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Entièrement couvert",
  "label.testCatalog.ranges.coverage.status.GAP": "Présente des lacunes",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Il y a des chevauchements",
  "label.testCatalog.ranges.coverage.status.EMPTY": "Non de plages",
  "label.testCatalog.ranges.modal.titleAdd": "Ajouter une plage de référence",
  "label.testCatalog.ranges.modal.titleEdit": "Modifier la plage de référence",
  "label.testCatalog.ranges.modal.sex": "S'applique à",
  "label.testCatalog.ranges.modal.component": "Composant « Résultat »",
  "label.testCatalog.ranges.modal.component.all": "Tous les composants",
  "label.testCatalog.ranges.modal.ageUnit": "Unité d'âge",
  "label.testCatalog.ranges.modal.minAge": "De l'âge",
  "label.testCatalog.ranges.modal.maxAge": "Jusqu'à l'âge de (champ vide = non, pas de limite supérieure)",
  "label.testCatalog.ranges.modal.lowNormal": "Niveau faible normal",
  "label.testCatalog.ranges.modal.highNormal": "Niveau normal élevé",
  "label.testCatalog.ranges.modal.lowCritical": "Niveau faible",
  "label.testCatalog.ranges.modal.highCritical": "Niveau critique élevé",
  "label.testCatalog.ranges.modal.lowValid": "Valeur faible valide",
  "label.testCatalog.ranges.modal.highValid": "Valeur maximale valide",
  "label.testCatalog.ranges.modal.lowReporting": "Limite basse de rendu",
  "label.testCatalog.ranges.modal.highReporting": "Limite haute de rendu",
  "error.testCatalog.ranges.reportingInverted": "La limite basse de rapport ne doit pas dépasser la limite haute de rapport.",
  "label.testCatalog.ranges.modal.ageError": "La valeur de « Âge » doit être supérieure à celle de « De ».",
  "label.testCatalog.ranges.modal.boundsError": "Les limites doivent être imbriquées vers l'extérieur : limite faible valide ≤ limite faible critique ≤ limite faible normale ≤ limite haute normale ≤ limite haute critique ≤ limite haute valide.",
  "label.testCatalog.storage.saved": "Le stockage des échantillons a été enregistré.",
  "label.testCatalog.storage.loadError": "Impossible de charger les paramètres de stockage des échantillons.",
  "label.testCatalog.storage.history.view": "Voir l'historique des modifications",
  "label.testCatalog.storage.history.title": "Stockage des échantillons — Historique des modifications",
  "label.testCatalog.storage.history.loadError": "Impossible de charger l'historique des modifications.",
  "label.testCatalog.storage.history.empty": "Aucune modification n'a été enregistrée.",
  "label.testCatalog.storage.history.filter": "Filtrer par champ",
  "label.testCatalog.storage.history.col.changedAt": "Modifié le",
  "label.testCatalog.storage.history.col.changedBy": "Modifié par",
  "label.testCatalog.storage.history.col.field": "Champ",
  "label.testCatalog.storage.history.col.old": "Ancienne Valeur",
  "label.testCatalog.storage.history.col.new": "Nouvelle Valeur",
  "label.testCatalog.storage.storageHeading": "Stockage",
  "label.testCatalog.storage.disposalHeading": "Élimination",
  "label.testCatalog.storage.handlingHeading": "Traitement particulier",
  "label.testCatalog.storage.condition": "Conditions de stockage",
  "label.testCatalog.storage.conditionCustom": "Condition personnalisée",
  "label.testCatalog.storage.duration": "Durée maximale de stockage",
  "label.testCatalog.storage.durationUnit": "Unité de durée",
  "label.testCatalog.storage.stabilityNotes": "Remarques sur la stabilité",
  "label.testCatalog.storage.protectFromLight": "À conserver à l'abri de la lumière",
  "label.testCatalog.storage.doNotFreeze": "Ne pas congeler",
  "label.testCatalog.storage.doNotRefrigerate": "Ne pas mettre au réfrigérateur",
  "label.testCatalog.storage.disposalMethod": "Méthode d'élimination",
  "label.testCatalog.storage.disposalTimeframe": "Délai de destruction",
  "label.testCatalog.storage.disposalUnit": "Unité de temps",
  "label.testCatalog.storage.specialInstructions": "Instructions particulières",
  "label.testCatalog.storage.overrideRestricted": "Restriction de la dérogation au stockage",
  "label.testCatalog.storage.none": "— Aucun —",
  "label.testCatalog.storage.condition.AMBIENT": "Température ambiante / température de la pièce",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Température ambiante contrôlée (20 à 25 °C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Chambre fraîche (8 à 15 °C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Chambre froide (2 à 8 °C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Réfrigéré (2-8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Congelé (-20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Surgelé (−70 °C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Congélateur à très basse température (−80 °C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Incubateur chauffé (35 à 37 °C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Incinération",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Désinfection chimique",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Déchets à risque biologique",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Conteneur pour objets tranchants",
  "label.testCatalog.storage.disposal.SEWER": "Évacuation des eaux usées / des eaux de drainage",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Retour à l'expéditeur",
  "label.testCatalog.storage.disposal.ARCHIVE": "Archives à long terme",
  "label.testCatalog.storage.disposal.STANDARD": "Déchets courants",
  "label.testCatalog.storage.unit.hours": "heures",
  "label.testCatalog.storage.unit.days": "jours",
  "label.testCatalog.storage.unit.weeks": "semaines",
  "label.testCatalog.storage.unit.months": "Mois",
  "label.testCatalog.analyzers.infoCard": "Les analyseurs sont associés à ce test dans l'écran de configuration des analyseurs. Cette liste est en lecture seule.",
  "label.testCatalog.analyzers.empty": "Aucun analyseur n'est encore associé à ce test.",
  "label.testCatalog.analyzers.loadError": "Impossible de charger les analyseurs pour cette analyse.",
  "label.testCatalog.analyzers.col.analyzer": "Analyseur",
  "label.testCatalog.analyzers.col.testName": "Nom du test de l'analyseur",
  "label.testCatalog.displayOrder.pickSampleType": "Type d'échantillon",
  "label.testCatalog.displayOrder.intro": "Réorganisez l'ordre d'affichage des tests au sein d'un type d'échantillon. L'ordre est enregistré automatiquement.",
  "label.testCatalog.displayOrder.empty": "Aucun test n'est associé à ce type d'échantillon.",
  "label.testCatalog.displayOrder.loadError": "Impossible de charger l'ordre d'affichage.",
  "label.testCatalog.displayOrder.saved": "L'ordre d'affichage a été enregistré.",
  "label.testCatalog.displayOrder.currentTest": "Cette analyse",
  "label.testCatalog.displayOrder.moveUp": "Remonter",
  "label.testCatalog.displayOrder.moveDown": "Descendre",
  "label.testCatalog.displayOrder.col.position": "Position",
  "label.testCatalog.displayOrder.col.test": "Test",
  "label.testCatalog.displayOrder.dragHandle": "Faites glisser pour réorganiser",
  "label.testCatalog.terminology.intro": "Associez ce test aux codes terminologiques standard à des fins d'interopérabilité.",
  "vector.collectedVolume.helper": "Nombre d'organismes présents dans ce plan d'eau, par exemple le nombre de moustiques.",
  "vector.complete.animal": "Animal",
  "vector.complete.cancel": "Annuler",
  "vector.complete.details.collectionDate": "Date de prélèvement",
  "vector.complete.details.collectionSite": "Site de collecte",
  "vector.complete.details.collector": "Préleveur",
  "vector.complete.details.lifecycleStage": "Lifecycle Stage",
  "vector.complete.details.tests": "Analyses",
  "vector.complete.details.title": "Détails de la demande d’examen",
  "vector.complete.details.trapType": "Type de piège",
  "vector.complete.labNumber": "Numéro laboratoire",
  "vector.complete.newOrder": "Nouvelle commande Vector",
  "vector.complete.quantity": "Quantité",
  "vector.complete.quantity.value": "{count} Organismes",
  "vector.complete.status": "Statut",
  "vector.complete.status.processing": "Traitement",
  "vector.lifecycleStage.helper": "Stade de développement de l'organisme prélevé.",
  "vector.order.collectionContext.helper": "Facultatif — permet de consigner les conditions écologiques au moment du prélèvement (bionomie).",
  "vector.order.collectionDate.heading": "Date de prélèvement",
  "vector.order.collectionDate.helper": "Date à laquelle le lot a été physiquement prélevé sur le terrain. Cela s'applique à chaque échantillon de cette commande.",
  "vector.order.site.add.new": "+ Ajouter un nouveau site « {name} »",
  "vector.order.site.add.new.restricted": "L'ajout d'un nouveau site de prélèvement a été désactivé par votre administrateur.",
  "vector.order.site.new.helper": "Ce site de prélèvement sera créé lors de l'enregistrement de cette commande.",
  "vector.order.site.new.tag": "Nouveau",
  "vector.order.site.no.match": "Non, aucun site correspondant n'a été trouvé.",
  "vector.pool.noTests": "Non de tests ont été enregistrés",
  "vector.pool.summary": "Galerie d'images d'{count} {animal}",
  "vector.trapCount.helper": "Nombre de pièges déployés — utilisé conjointement avec le nombre de nuits pour calculer la densité par nuit-piège.",
  "vector.trapNights.helper": "Nombre de nuits pendant lesquelles les pièges ont été actifs. Laissez ce champ vide si l'effort n'a pas été enregistré.",
  "vector.trapType.helper": "Méthode ou appareil de prélèvement utilisé — veuillez d'abord sélectionner un type d'échantillon.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} assigné · {pools} pools",
  "vectorDec.button.back": "Back",
  "vectorDec.button.discard": "Ignorer",
  "vectorDec.button.previewGrouping": "Aperçu du regroupement",
  "vectorDec.button.savePools": "Pools de sauvegarde",
  "vectorDec.button.splitIndividuals": "Répartition entre les particuliers →",
  "vectorDec.button.splitIndividuals.tooltip": "Mise en place rapide : un échantillon par groupe",
  "vectorDec.button.view": "Voir",
  "vectorDec.col.children": "Échantillons provenant d'enfants",
  "vectorDec.col.positiveTest": "Analyses positives",
  "vectorDec.col.results": "Résultats",
  "vectorDec.col.status": "Statut",
  "vectorDec.empty": "Non de tâches de déconvolution.",
  "vectorDec.error.initiateFailed": "Impossible de lancer la déconvolution.",
  "vectorDec.error.loadWorklist": "Impossible de charger la liste de travail de déconvolution.",
  "vectorDec.error.minPoolCount": "Le nombre de groupes doit être au moins égal à 2.",
  "vectorDec.error.noAssignedSpecimens": "Faites glisser au moins un échantillon dans un bac avant d'enregistrer.",
  "vectorDec.error.noParent": "Non, aucun élément « SampleItem » parent n'est disponible pour être divisé.",
  "vectorDec.error.poolFloorByType": "Lot propose des types d'échantillons {types} ({names}) — un nombre minimum de pools « {types} » est requis pour la distribution aléatoire.",
  "vectorDec.error.unassignedSpecimens": "{count} Les échantillons sont toujours non attribués. Veuillez attribuer tous les échantillons avant d'enregistrer.",
  "vectorDec.field.howManyPools": "Combien de piscines ?",
  "vectorDec.field.notes": "Notes",
  "vectorDec.field.organismsPerPool": "Nombre d'organismes par échantillon",
  "vectorDec.field.poolCount": "Nombre de bassins",
  "vectorDec.field.strategy": "Méthode d'affectation",
  "vectorDec.filter.all": "Tous",
  "vectorDec.filter.status": "Filtrer par statut",
  "vectorDec.heading.preview": "Proposition de regroupement des groupes de piscine",
  "vectorDec.heading.split": "Répartition en sous-groupes",
  "vectorDec.heading.worklist": "Déconvolution par regroupement",
  "vectorDec.individualMode.badge": "Mode individuel",
  "vectorDec.locationOverride.help": "Remplacer le site de collecte d'origine pour chaque sous-groupe. Utilisez cette option lorsqu'un même lot a été prélevé sur plusieurs sites.",
  "vectorDec.locationOverride.inherit": "Hériter du lot (par défaut)",
  "vectorDec.locationOverride.notes": "Remarques sur les aliquotes",
  "vectorDec.locationOverride.site": "Lieu de collecte",
  "vectorDec.locationOverride.title": "Par lieu de prélèvement de sous-pool (facultatif)",
  "vectorDec.message.success": "{count} sous-pools créés ({labRange}), {orders} commandes de test mises en file d'attente. Statut → Déconvolution en cours.",
  "vectorDec.message.successIndividual": "{count} aliquotes individuelles créées ({labRange}), {orders} demandes d'analyse mises en file d'attente. Statut → Déconvolution en cours. La confirmation des sporozoïtes VR-07 se déclenchera en cas de résultats positifs confirmés.",
  "vectorDec.parent.label": "Parent",
  "vectorDec.parent.quantity": "Quantité : {qty}",
  "vectorDec.preview.body": "{count} groupes à l'aide de l'{strategy}. Faites glisser les échantillons d'un groupe à l'autre pour les ajuster avant d'enregistrer.",
  "vectorDec.preview.empty": "Non de spécimens",
  "vectorDec.preview.organisms": "Organismes",
  "vectorDec.preview.poolN": "{n} de la piscine",
  "vectorDec.preview.poolWithSpecies": "{n} sur la piscine — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# spécimen} many {# spécimens} other {# spécimens}}",
  "vectorDec.preview.title": "Regroupement proposé",
  "vectorDec.preview.unassigned": "{count, plural, =0 {Tous les spécimens attribués} one {# non attribué} other {# non attribués}}",
  "vectorDec.preview.unassignedHint": "{count} Non attribués — ceux-ci restent dans le pool d'origine.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Les règles de réflexe s'appliqueront lors d'un jet de sauvegarde",
  "vectorDec.reflexPreview.parentTests": "Commandes de test parents ({test}) — à réexécuter sur chaque enfant",
  "vectorDec.reflexPreview.screeningPanel": "comité de sélection",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Conseil : séparez les échantillons en spécimens individuels afin de pouvoir également déclencher l'{rules}. Ces règles ne s'appliquent qu'aux lots contenant un seul organisme.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} spécimens → ~{perPool} par pool{remainder, plural, =0 {} other {, reste : +1 aux {remainder} premiers}}",
  "vectorDec.status.complete": "Désinfection terminée",
  "vectorDec.status.confirmed": "Confirmé",
  "vectorDec.status.inProgress": "En cours",
  "vectorDec.status.pending": "Révision requise",
  "vectorDec.strategy.manual": "Attribuer manuellement — glisser-déposer les échantillons dans des groupes",
  "vectorDec.strategy.manual.hint": "Glissez-déposez vous-même les échantillons dans les bacs",
  "vectorDec.strategy.manual.title": "Attribuer manuellement",
  "vectorDec.strategy.random": "Attribuez de manière aléatoire — répartissez les échantillons de manière homogène entre les groupes",
  "vectorDec.strategy.random.hint": "Répartissez les échantillons de manière homogène entre les lots",
  "vectorDec.strategy.random.title": "Attribuer de manière aléatoire",
  "vectorDec.strategy.species": "Regroupement automatique par espèce — regroupement des échantillons par catégorie",
  "vectorDec.strategy.species.hint": "Regrouper les échantillons par espèce — l'IDENTIFIANT de l'espèce sur les échantillons est obligatoire",
  "vectorDec.strategy.species.title": "Répartition automatique par sous-groupe d'espèces",
  "vectorDec.totalOrganisms": "Nombre total d'organismes",
  "vectorDec.warning.exceedsParent.body": "{total} Les organismes demandés varient d’un ensemble d’enfants à l’autre, mais l’élément parent possède la valeur « {parent} ». Le système créera tout de même des enfants « {total} ».",
  "vectorDec.warning.exceedsParent.title": "Le total dépasse la quantité indiquée par le parent",
  "vectorId.batch.selectedCount": "{count, plural, one {# spécimen sélectionné} many {# spécimens sélectionnés} other {# spécimens sélectionnés}}",
  "vectorId.bloodMeal.add": "Ajouter un panneau à la commande",
  "vectorId.bloodMeal.added": "Le panel d'identification des traces de sang a été ajouté aux demandes d'analyse des échantillons.",
  "vectorId.bloodMeal.addedSub": "Provenance : manuelle (suggestion validée par le technicien de laboratoire). Conformément à la norme BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Le panel de tests « Blood-meal » est déjà joint (analyses « {skipped} »).",
  "vectorId.bloodMeal.body": "Commandez le panel d'identification des repas sanguins des moustiques afin de déterminer l'espèce hôte dont cet échantillon s'est nourri.",
  "vectorId.bloodMeal.bulkAdd": "Ajouter un panneau à tous ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Panneau d'analyse des échantillons de sang destiné aux spécimens « {count} ».",
  "vectorId.bloodMeal.bulkBody": "Veuillez ajouter le « Panel d'identification des repas sanguins des moustiques » à chaque échantillon sélectionné afin que le laboratoire puisse déterminer quel hôte vertébré a servi de repas à ces moustiques.",
  "vectorId.bloodMeal.bulkSummary": "Panneau « Blood-meal » : « {added} » ajouté, « {skipped} » déjà inclus, « {rejected} » rejeté.",
  "vectorId.bloodMeal.bulkTitle": "Femelles ayant pris du sang détectées (échantillons de {count})",
  "vectorId.bloodMeal.dismiss": "Ignorer",
  "vectorId.bloodMeal.error.add": "Impossible d'ajouter le panneau d'identification des repas sanguins des moustiques.",
  "vectorId.bloodMeal.error.dismiss": "Il n'a pas été possible d'enregistrer le licenciement.",
  "vectorId.bloodMeal.title": "Détection d'une femelle ayant pris son repas de sang",
  "vectorId.bulk.applyToCount": "Appliquer aux échantillons d{count}",
  "vectorId.bulk.heading": "Appliquer en masse l'IDENTIFIANT d'espèce",
  "vectorId.bulk.notice.body": "Les champs relatifs aux détails moléculaires (gène cible, test, numéro de laboratoire) ne sont pas copiés en bloc : veuillez les enregistrer séparément pour chaque échantillon.",
  "vectorId.bulk.notice.title": "Les champs spécifiques à l'échantillon n'ont pas été copiés",
  "vectorId.button.bulkApply": "🔖 Application groupée ({count})",
  "vectorId.button.cancel": "Annuler",
  "vectorId.button.close": "▲ Fermer",
  "vectorId.button.confirm": "Confirmer",
  "vectorId.button.confirmAll": "✓ Confirmez pour tous les vecteurs",
  "vectorId.button.confirmResult": "✓ Confirmer : {test}",
  "vectorId.button.hideResults": "Masquer les résultats",
  "vectorId.button.identify": "▼ Identifiant",
  "vectorId.button.reviewResults": "Consultez les résultats ({n})",
  "vectorId.button.save": "Enregistrer les informations d'identification",
  "vectorId.button.splitPool": "↗ Diviser",
  "vectorId.col.collectionDate": "Date de prélèvement",
  "vectorId.col.decon": "Décontamination",
  "vectorId.col.decon.help": "Statut de la déconvolution — indique si les résultats des groupes ont été saisis et si les sous-groupes sont en attente de validation.",
  "vectorId.col.idStatus": "Statut de l'identifiant",
  "vectorId.col.lotId": "IDENTIFIANT du lot",
  "vectorId.col.organismGroup": "Groupe",
  "vectorId.col.progress": "Progrès",
  "vectorId.col.site": "Sites de prélèvement",
  "vectorId.completion.body": "{positive} des sous-groupes d'{total} confirmés ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} vecteurs confirmés",
  "vectorId.completion.body.partial": "Confirmé pour tous les vecteurs de ce lot :",
  "vectorId.completion.heading": "Déconvolution terminée",
  "vectorId.completion.heading.confirmed": "Résultat confirmé",
  "vectorId.completion.heading.partial": "Résultats partiellement confirmés",
  "vectorId.completion.tag": "Désinfection terminée",
  "vectorId.completion.tag.confirmed": "Confirmé",
  "vectorId.completion.tag.partial": "Partiellement confirmé",
  "vectorId.confidence.confirmed": "Confirmé",
  "vectorId.confidence.presumptive": "Présomptif",
  "vectorId.distribution.confirmed": "{count} Confirmé",
  "vectorId.distribution.heading": "Répartition des espèces",
  "vectorId.distribution.notIdentified": "{count} Non identifié",
  "vectorId.distribution.notYet": "Pas encore identifié",
  "vectorId.distribution.presumptive": "{count} Présomptif",
  "vectorId.empty": "Cette file d'attente ne contient aucun lot.",
  "vectorId.error.accessionFormat": "Format des numéros de laboratoire GenBank : 1 à 2 lettres suivies de 5 à 8 chiffres (par exemple : MW123456).",
  "vectorId.error.confidenceRequired": "Il faut avoir confiance en soi.",
  "vectorId.error.loadSpecimens": "Impossible de charger les échantillons correspondant à ce lot.",
  "vectorId.error.loadWorklist": "Impossible de charger la liste de travail.",
  "vectorId.error.methodRequired": "Une méthode d'identification est requise.",
  "vectorId.error.notesTooLong": "Les remarques ne doivent pas dépasser 500 caractères.",
  "vectorId.error.requiredFields": "L'espèce, la méthode et le niveau de confiance doivent être indiqués.",
  "vectorId.error.saveFailed": "Impossible d'enregistrer les informations d'identification.",
  "vectorId.error.speciesRequired": "Le champ « Espèce » est obligatoire.",
  "vectorId.filter.complete": "Terminé",
  "vectorId.filter.complete.sub": "Tous les échantillons ont été identifiés.",
  "vectorId.filter.decon": "Déconvolution",
  "vectorId.filter.decon.sub": "Les résultats du pool ont été saisis ; nous attendons la décision du technicien quant à leur division ou leur confirmation.",
  "vectorId.filter.label": "Statut",
  "vectorId.filter.notstarted": "Non commencé",
  "vectorId.filter.notstarted.sub": "Reçu : 0 échantillon identifié.",
  "vectorId.filter.partialid": "IDENTIFIANT partiel",
  "vectorId.filter.partialid.sub": "Identification en cours.",
  "vectorId.filter.pending": "En attente",
  "vectorId.filter.pending.sub": "Tous les lots non terminés, y compris les séries dont les résultats sont en attente d'examen par un technicien.",
  "vectorId.form.assayName": "Nom du dosage",
  "vectorId.form.assayName.placeholder": "PCR multiplexe",
  "vectorId.form.confidence": "Confiance",
  "vectorId.form.genbankAccession": "Numéro de laboratoire GenBank",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Lifecycle Stage",
  "vectorId.form.linkedResult": "Associer les résultats relatifs aux agents pathogènes",
  "vectorId.form.linkedResultPlaceholder": "Sélectionnez un résultat parmi ce lot…",
  "vectorId.form.method": "Méthodes",
  "vectorId.form.molecularDetails": "🔬 Détails moléculaires",
  "vectorId.form.notes": "Notes",
  "vectorId.form.physState": "État physiologique",
  "vectorId.form.select": "Sélectionner…",
  "vectorId.form.species": "Espèces",
  "vectorId.form.speciesPlaceholder": "Rechercher un genre ou une espèce…",
  "vectorId.form.targetGene": "Gène cible",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, ADN ribosomique 28S",
  "vectorId.heading.worklist": "Liste de travail relative à l'identification des vecteurs",
  "vectorId.loading": "Chargement en cours…",
  "vectorId.message.bulkSuccess": "Appliquer l'identification aux échantillons {count}.",
  "vectorId.message.saveSuccess": "L'identification a été enregistrée.",
  "vectorId.method.both": "Morphologique + moléculaire",
  "vectorId.method.molecular": "Moléculaire",
  "vectorId.method.morphological": "Morphologique",
  "vectorId.notif.confirmAll.error": "Impossible de confirmer le résultat. Veuillez réessayer.",
  "vectorId.notif.confirmAll.success": "Le résultat a été confirmé pour tous les vecteurs de ce lot.",
  "vectorId.notif.deconNeeded.body": "Un résultat a été saisi pour ce groupe. Divisez-le en sous-groupes pour effectuer des analyses supplémentaires, ou confirmez que le résultat s'applique à tous les vecteurs.",
  "vectorId.notif.deconNeeded.bodyWithTest": "L'un des tests a donné un résultat. Divisez l'échantillon en sous-groupes pour effectuer des tests supplémentaires, ou confirmez que ce résultat s'applique à tous les vecteurs.",
  "vectorId.notif.deconNeeded.title": "Résultat du tournoi en attente de validation",
  "vectorId.physState.blood_fed": "Nourri de sang",
  "vectorId.physState.gravid": "Gravide",
  "vectorId.physState.half_gravid": "Semi-gravide",
  "vectorId.physState.unfed": "Non nourri",
  "vectorId.physState.unknown": "Inconnu / non évalué",
  "vectorId.resplit.heading": "Split : {label}",
  "vectorId.search.placeholder": "Rechercher des lots…",
  "vectorId.specimen.col.confidence": "Confiance",
  "vectorId.specimen.col.idStatus": "Statut de l'identifiant",
  "vectorId.specimen.col.label": "Échantillon",
  "vectorId.specimen.col.labNo": "Numéro laboratoire",
  "vectorId.specimen.col.poolOrSpecimen": "Pool / Échantillon",
  "vectorId.specimen.col.species": "Espèces",
  "vectorId.specimen.confirmed": "Confirmé",
  "vectorId.specimen.count": "Échantillons",
  "vectorId.specimen.empty": "Il n'y a pas d'échantillons pour ce lot.",
  "vectorId.specimen.label": "Échantillon n°{n}",
  "vectorId.specimen.notIdentified": "Non identifié",
  "vectorId.specimen.presumptive": "Présomptif",
  "vectorId.status.complete": "Terminé",
  "vectorId.status.inProgress": "En cours",
  "vectorId.status.notStarted": "Non commencé",
  "vectorId.tag.deconComplete": "Terminé",
  "vectorId.tag.deconInProgress": "Désinfection en cours",
  "vectorId.tag.deconNeeded": "⚠ Résultat de l'évaluation",
  "vectorId.tag.subPoolPending": "{count} sous-ensemble contenant les résultats",
  "vectorId.tree.organisms": "{count, plural, one {# organisme} many {# organismes} other {# organismes}}",
  "vectorReport.density.bySite": "Densité par site et par période",
  "vectorReport.density.effortNotRecorded": "Effort non enregistré",
  "vectorReport.density.period": "Période",
  "vectorReport.density.perTrapNight": "Densité (par nuit-piège)",
  "vectorReport.density.pools": "Piscines",
  "vectorReport.density.site": "Site",
  "vectorReport.density.specimens": "Échantillons",
  "vectorReport.density.title": "Nombre d'échantillons par site",
  "vectorReport.density.trapNights": "Soirées Trap",
  "vectorReport.description": "Indices de surveillance calculés à partir des prélèvements de vecteurs enregistrés, des identifications d'espèces et des résultats relatifs aux agents pathogènes",
  "vectorReport.empty": "Aucune donnée n'est disponible pour la portée sélectionnée.",
  "vectorReport.exportPdf": "Exporter en PDF",
  "vectorReport.fieldMap.description": "Réorganisez, masquez, renommez ou attribuez des balises de portail aux indicateurs affichés dans l'assistant de saisie manuelle.",
  "vectorReport.fieldMap.hidden": "Caché",
  "vectorReport.fieldMap.label": "Etiquette",
  "vectorReport.fieldMap.metric": "Indicateur",
  "vectorReport.fieldMap.order": "Demande d'examen",
  "vectorReport.fieldMap.portalTag": "Etiquette du portail",
  "vectorReport.fieldMap.title": "Carte des champs de saisie manuelle",
  "vectorReport.fieldMap.visibility": "Visibilité",
  "vectorReport.fieldMap.visible": "Visible",
  "vectorReport.fieldMap.visibleLabel": "Affiché dans l'assistant de saisie manuelle",
  "vectorReport.filter.allSites": "Tous les sites",
  "vectorReport.filter.apply": "Appliquer",
  "vectorReport.filter.dateRange": "Plage de dates",
  "vectorReport.filter.from": "From",
  "vectorReport.filter.site": "Site de prélèvement",
  "vectorReport.filter.to": "À",
  "vectorReport.freshness": "Actualité des données",
  "vectorReport.freshness.as": "Chiffres au {time}",
  "vectorReport.freshness.unknown": "Inconnu",
  "vectorReport.generated": "Généré le :",
  "vectorReport.home": "Accueil",
  "vectorReport.loadError": "Echec du chargement des indices de surveillance. Veuillez réessayer.",
  "vectorReport.manualEntry.confirmBody": "Souhaitez-vous enregistrer un aperçu de contrôle des chiffres de cette semaine ({periodStart} – {periodEnd}) ? La nouvelle soumission d'une semaine est enregistrée comme une entrée distincte.",
  "vectorReport.manualEntry.confirmSubmit": "Confirmer",
  "vectorReport.manualEntry.copied": "Copié dans le presse-papiers",
  "vectorReport.manualEntry.copy": "Copier la valeur",
  "vectorReport.manualEntry.empty": "Non de période",
  "vectorReport.manualEntry.loading": "Chargement des chiffres hebdomadaires...",
  "vectorReport.manualEntry.lowConfidence": "Confiance réduite (déconvolution du pool inférieure à 95 %)",
  "vectorReport.manualEntry.markSubmitted": "Semaine de notation soumise",
  "vectorReport.manualEntry.submitError": "Impossible d'enregistrer votre soumission",
  "vectorReport.manualEntry.submitted": "Semaine marquée comme soumise",
  "vectorReport.manualEntry.title": "Aide à la saisie manuelle",
  "vectorReport.manualEntry.week": "Semaine de référence",
  "vectorReport.mir.classic": "MIR (classique)",
  "vectorReport.mir.observed": "Taux d'infection (observé)",
  "vectorReport.mir.pathogen": "Agent pathogène",
  "vectorReport.mir.positivePools": "Groupes positifs",
  "vectorReport.mir.resolution": "Résolution positive",
  "vectorReport.mir.species": "Espèces",
  "vectorReport.mir.sporozoite": "Taux de sporozoïtes",
  "vectorReport.mir.sporozoiteNote": "Le niveau de confiance diminue lorsque la résolution de la déconvolution par regroupement est inférieure à 95 %.",
  "vectorReport.mir.title": "Taux d'infection minimal par espèce",
  "vectorReport.mir.totalSpecimens": "Nombre total d'échantillons",
  "vectorReport.mir.withheld": "Non divulgué",
  "vectorReport.positivity.notConfigured": "La classification des résultats positifs n'est pas configurée pour ce déploiement ; par conséquent, les chiffres relatifs au taux d'infection, aux résultats positifs et aux sporozoïtes ne sont pas disponibles. Veuillez configurer la pertinence des résultats dans le Catalogue de tests pour les activer.",
  "vectorReport.positivity.pathogen": "Agent pathogène",
  "vectorReport.positivity.pct": "Positivité",
  "vectorReport.positivity.poolsPositive": "Résultats positifs",
  "vectorReport.positivity.poolsTested": "Piscines analysées",
  "vectorReport.positivity.title": "Présence d'agents pathogènes",
  "vectorReport.positivity.unrecognized": "Certains résultats présentent une valeur de signification qui ne correspond à aucune classification reconnue (POSITIF, NÉGATIF ou INDÉTERMINÉ) et sont donc exclus du décompte des résultats positifs. Veuillez consulter le Catalogue de tests afin que ces résultats puissent être pris en compte.",
  "vectorReport.prompt": "Sélectionnez une plage de dates et un site, puis cliquez sur « Appliquer » pour voir les indices de surveillance.",
  "vectorReport.qc.detail": "{passed} nombre d'analyses « {total} » réussies",
  "vectorReport.qc.passed": "Analyses réussies",
  "vectorReport.qc.passRate": "Taux de réussite",
  "vectorReport.qc.title": "Taux de conformité au QC",
  "vectorReport.qc.total": "Total des analyses",
  "vectorReport.species.genus": "Genre",
  "vectorReport.species.pct": "Partager",
  "vectorReport.species.species": "Espèces",
  "vectorReport.species.specimens": "Échantillons",
  "vectorReport.species.title": "Répartition des espèces",
  "vectorReport.sporozoite.title": "Taux de sporozoïtes (Anopheles)",
  "vectorReport.title": "Surveillance des vecteurs",
  "vfs.abj": "ABJ (taux d'absence de larves)",
  "vfs.abj.target.below": "✗ Taux de couverture vaccinale (ABJ) inférieur à l'objectif de 95 % fixé par le ministère de la Santé",
  "vfs.abj.target.met": "✓ L'ABJ atteint l'objectif de 95 % fixé par le ministère de la Santé",
  "vfs.bi": "Indice Breteau (pour 100 logements)",
  "vfs.ci": "Indice des conteneurs (CI)",
  "vfs.containersExamined": "Conteneurs examinés",
  "vfs.containersPositive": "Conteneurs positifs",
  "vfs.err.containersExceeded": "Le nombre de conteneurs inspectés ne doit pas être dépassé.",
  "vfs.err.examinedMin": "Cette valeur doit être ≥ 1 lors de la saisie des données relatives aux larves.",
  "vfs.err.housesExceeded": "Le nombre de logements inspectés ne doit pas être dépassé.",
  "vfs.err.negative": "Ne peut pas être négatif.",
  "vfs.err.populationMin": "Cette valeur doit être ≥ 1 lors de la saisie des données relatives aux pupes.",
  "vfs.hi": "Indice House (HI)",
  "vfs.housesExamined": "Maisons examinées",
  "vfs.housesPositive": "Maisons positives",
  "vfs.indices.title": "Indices calculés (aperçu)",
  "vfs.larval.title": "Recensement des larves — Mode C",
  "vfs.populationAtRisk": "Population à risque",
  "vfs.ppi": "Nombre de pupes par personne (PPI)",
  "vfs.pupaeCount": "Nombre de pupes",
  "vfs.pupal.title": "Enquête sur les pupes — Mode D",
  "vfs.surveyMethod": "Méthode d'enquête",
  "vfs.surveyMethod.placeholder": "Choisis une option",
  "warning.testCatalog.noLoinc": "Ce test ne dispose pas de code LOINC. Les résultats provenant d'un analyseur ou d'une commande électronique ne peuvent pas y être importés.",
  "warning.testCatalog.duplicateLoinc": "Le code LOINC « {code} » est également utilisé par « {testName} ». Les résultats reçus pour ce code sont acheminés vers un seul test (premier résultat correspondant) ; il se peut que les résultats soient attribués au mauvais test.",
  "label.testCatalog.terminology.col.source": "Source",
  "label.testCatalog.terminology.col.code": "Code Emplacement",
  "label.testCatalog.terminology.col.displayName": "Nom d'affichage",
  "label.testCatalog.terminology.displayName.placeholder": "par exemple : glucose [masse/volume] dans le sérum ou le plasma",
  "label.testCatalog.terminology.col.relationship": "Relation",
  "label.testCatalog.terminology.col.appliesTo": "S'applique à",
  "label.testCatalog.terminology.appliesTo.test": "Analyses complètes",
  "label.testCatalog.terminology.col.actions": "Actions",
  "label.testCatalog.terminology.source": "Source terminologique",
  "label.testCatalog.terminology.code": "Code Emplacement",
  "label.testCatalog.terminology.relationship": "Relation",
  "label.testCatalog.terminology.addMapping": "Ajouter un mappage",
  "label.testCatalog.terminology.remove": "Retirer le mappage",
  "label.testCatalog.terminology.empty": "Non, il n'y a pour l'instant aucune correspondance terminologique.",
  "label.testCatalog.terminology.loadError": "Impossible de charger les correspondances terminologiques.",
  "label.testCatalog.terminology.saved": "Les correspondances terminologiques ont été enregistrées.",
  "error.testCatalog.terminology.duplicate": "Code de duplication de l'{source} : {code} — ce mappage existe déjà pour ce test.",
  "error.testCatalog.terminology.invalid": "Les mappages n'ont pas pu être enregistrés — vérifiez s'il n'y a pas de code en double, de source inconnue ou de relation non valide.",
  "error.testCatalog.terminology.tooLong": "Un code comporte au maximum 80 caractères et un nom d'affichage 255.",
  "label.testCatalog.terminology.rel.none": "— Aucun —",
  "label.testCatalog.terminology.rel.SAME_AS": "Identique à",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Plus large que",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Plus étroit que",
  "label.testCatalog.panels.intro": "Gérez les panneaux auxquels ce test appartient, ainsi que sa position au sein de chacun d'entre eux.",
  "label.testCatalog.panels.addToPanel": "Ajouter au panneau",
  "label.testCatalog.panels.col.panel": "Panneau",
  "label.testCatalog.panels.col.position": "Position",
  "label.testCatalog.panels.col.actions": "Actions",
  "label.testCatalog.panels.position": "Position",
  "label.testCatalog.panels.remove": "Retirer du panneau",
  "label.testCatalog.panels.remove.confirm.heading": "Retirer le test du panneau ?",
  "label.testCatalog.panels.remove.confirm.body": "Ce test sera retiré de {panel}. Il restera toutefois dans le catalogue et dans tous les autres Panneaux. Vous pourrez le rajouter ultérieurement.",
  "label.testCatalog.panels.moveUp": "Agissez plus tôt",
  "label.testCatalog.panels.moveDown": "Reporter à plus tard",
  "label.testCatalog.panels.viewOrder": "Consultez la commande de test de ce panneau",
  "label.testCatalog.panels.orderContext": "Analyses comprises dans ce panel (par ordre) :",
  "label.testCatalog.panels.empty": "Ce test ne figure pour l'instant dans aucun panel.",
  "label.testCatalog.panels.loadError": "Impossible de charger les affiliations aux commissions.",
  "label.testCatalog.panels.saved": "Les affiliations aux comités ont été enregistrées.",
  "label.testCatalog.panels.createPanel": "Créer un nouveau panneau",
  "label.testCatalog.panels.createPanelHint": "Saisissez un nom pour créer un panneau et y ajouter ce test. Son type d'échantillon, l'ordre des modules et les autres paramètres seront configurés ultérieurement dans l'éditeur de panneaux.",
  "notification.testCatalog.panels.created": "Le panneau « {name} » a été créé et ce test y a été ajouté. Configurez-le plus en détail dans l'éditeur de panneaux.",
  "label.search": "Rechercher",
  "label.testCatalog.list": "Catalogue de tests",
  "label.testCatalog.list.search": "Rechercher par nom du test",
  "label.testCatalog.list.col.status": "Statut",
  "label.testCatalog.list.filter.allDomains": "Tous les domaines",
  "label.testCatalog.list.filter.allStatus": "Tous les statuts",
  "label.testCatalog.list.filter.inactive": "Inactif",
  "label.testCatalog.list.coverageIncomplete": "Couverture incomplète",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "N'importe lequel",
  "label.testCatalog.list.filter.amrOnly": "AMR uniquement",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.filter.sampleType": "Type d'échantillon",
  "label.testCatalog.list.filter.allSampleTypes": "Tous les types d'échantillons",
  "label.testCatalog.list.filter.allLabUnits": "Toutes les unités de laboratoire",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "Non LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Uniquement les analyses présentant des problèmes",
  "label.testCatalog.list.health.banner": "{count} les analyses présentent des problèmes de configuration (erreurs de type « {errors} » · avertissements de type « {warnings} »)",
  "label.testCatalog.list.health.show": "Afficher",
  "label.testCatalog.activation.incomplete.heading": "Le test ne peut pas encore être activé",
  "label.testCatalog.activation.incomplete.body": "Veuillez régler les tests suivants avant de pouvoir activer ce test :",
  "label.testCatalog.list.col.sampleType": "Type d'échantillon",
  "button.testCatalog.newTest": "Nouvelle analyse",
  "button.testCatalog.editRelated": "Modifier ensemble les analyses associées",
  "button.testCatalog.editRelatedFromEditor": "Modifier les analyses associées…",
  "label.testCatalog.editor.noRelated": "Aucun test associé ne porte le même nom que ce test.",
  "label.testCatalog.editor.createSaveFirst.title": "Enregistrez d'abord le test",
  "label.testCatalog.editor.createSaveFirst": "Remplissez les informations de base et enregistrez. Cette section devient disponible une fois le test créé.",
  "label.testCatalog.editingNTests": "Modification des analyses « {count} »",
  "label.testCatalog.perTestIdentity": "Identité et LOINC (par analyse)",
  "state.testCatalog.differsAcrossTests": "Cela varie d'une analyse à l'autre",
  "button.testCatalog.setAllTo": "Veuillez régler tous les paramètres sur ces valeurs",
  "label.testCatalog.group.rangesSaved": "Plages de référence enregistrées dans les analyses « {count} ».",
  "label.testCatalog.group.storageIntro": "Modifiez les paramètres de stockage et de manutention une seule fois ; cette modification s'applique à tous les tests sélectionnés.",
  "label.testCatalog.group.storageDiffer": "Ces champs ne sont pas identiques pour toutes les analyses sélectionnées : {fields}. Le formulaire affiche les valeurs de la première analyse ; un champ laissé inchangé conserve la valeur propre à chaque analyse.",
  "button.testCatalog.removeFromSet": "Retirer de cet ensemble",
  "label.testCatalog.group.rangesIntro": "Modifiez les plages de référence une seule fois ; leur enregistrement les applique à tous les tests sélectionnés. L'identifiant et le code LOINC restent inchangés pour chaque test.",
  "label.testCatalog.group.rangesDiffer": "Les plages de courant des tests sélectionnés ne sont pas identiques. Si vous enregistrez, elles seront toutes définies sur les valeurs indiquées ci-dessous.",
  "label.testCatalog.group.rangesLoadError": "Impossible de charger les intervalles actuels de {tests}, rien ne peut donc encore être appliqué. Réessayez pour les recharger.",
  "label.testCatalog.ranges.table.sex": "S'applique à",
  "label.testCatalog.ranges.table.age": "Tranche d'âge",
  "label.testCatalog.ranges.table.normal": "Normal (faible / élevé)",
  "label.testCatalog.list.filters": "Filtres",
  "label.testCatalog.list.filters.count": "Filtres ({count})",
  "label.testCatalog.list.error": "Impossible de charger le Catalogue de tests. Ajustez les filtres ou rechargez la page pour réessayer.",
  "label.testCatalog.list.empty": "Non, aucune analyse ne correspond aux filtres actuels.",
  "sidenav.label.admin.testmgt.ManageMethod": "Gérer la méthode",
  "sidenav.label.admin.testmgt.reflex": "Gestion des tests de réflexes",
  "sidenav.label.admin.usermgt": "Gestion des utilisateurs",
  "sideNav.label.arvfollowup1": "ARV-Bilan de Suivi Version 1",
  "sideNav.label.arvfollowup2": "ARV-Bilan de Suivi Version 2",
  "sideNav.label.arvreports1": "ARV-Bilan Initial Version 1",
  "sideNav.label.arvreports2": "ARV-Bilan Initial Version 2",
  "sideNav.label.arvversion1": "ARV-Version 1",
  "sideNav.label.associatedpatientreport": "Rapports des Patients Associés",
  "sideNav.label.audittrail": "Formulaire d'Audit",
  "sidenav.label.barcode": "code-barre",
  "sidenav.label.batchorder": "Saisie d'ordonnances en lot",
  "sideNav.label.bypaneltype": "Par type de panneau",
  "sideNav.label.bytesttype": "Par test",
  "sideNav.label.byunit": "Par Unité",
  "sideNav.label.collectedarvpatientreports": "Rapport de patient ARV collecté",
  "sidenav.label.cytology": "Cytologie",
  "sidenav.label.cytology.dashboard": "Tableau de bord",
  "sideNav.label.delayedvalidation": "Compte de tests en attente de validation",
  "sidenav.label.editorder": "Modifier l'échantillon",
  "sideNav.label.eidreports1": "EID Version 1",
  "sideNav.label.eidreports2": "EID Version 2",
  "sideNav.label.exportcsvfile": "Exporter le fichier CSV de routine",
  "sideNav.label.followuprequired": "Suivi Requis",
  "sideNav.label.generalreport": "Rapport général",
  "sideNav.label.hivtestsummary": "Résumé du Test VIH",
  "sidenav.label.immunochem": "Immuno-Histochimie",
  "sidenav.label.immunochem.dashboard": "Tableau de bord",
  "sidenav.label.incomingorder": "Statistiques journalières. ",
  "sideNav.label.intermediatebyservice": "Intermédiaire par service",
  "sideNav.label.intermediatereport1": "Version intermédiaire 1",
  "sideNav.label.intermediatereport2": "Version intermédiaire 2",
  "sidenav.label.inventory": "Inventaire",
  "sidenav.label.inventory.management": "Gestion des stocks",
  "sidenav.label.inventory.management.tooltip": "Gérer les articles, les lots et les niveaux de stock.",
  "sidenav.label.inventory.tooltip": "Gestion des stocks de réactifs, de kits et de fournitures",
  "sideNav.label.laporanHasil": "Rapport de conformité",
  "sideNav.label.noncomformitynotification": "Notification de non-conformité",
  "sideNav.label.noncomformityreportsbydate": "Rechercher par date de test",
  "sideNav.label.noncomformityreportsbylabno": "Par numéro de laboratoire",
  "sideNav.label.noncomformityreportsbyunit": "Par unité et raison",
  "sidenav.label.notebook": "Projet",
  "sidenav.label.add.order": "Ajouter une ordonnance",
  "sidenav.label.clinical.order": "Ajouter une ordonnance clinique",
  "sidenav.label.environmental.compliance": "Tableau de bord de conformité",
  "sidenav.label.environmental.order": "Ajouter une commande « Environnemental »",
  "sidenav.label.vector.order": "Ajouter une commande vectorielle",
  "sidenav.label.order": "Demande d'examen",
  "sidenav.label.order.collect": "Prélever un échantillon",
  "sidenav.label.order.dashboard": "Tableau de bord",
  "sidenav.label.order.enter": "Saisir la demande d’examen",
  "sidenav.label.order.label": " Étiqueter et stocker",
  "sidenav.label.order.qa": "Revue Assurance Qualité",
  "sidenav.label.order.prepare": "Préparer les échantillons",
  "sidenav.label.order.sampleCheck": "Vérification de l'échantillon",
  "sidenav.label.pathology": "Pathologie",
  "sidenav.label.pathology.dashboard": "Tableau de bord",
  "sideNav.label.referredtestreport": "Rapport des tests référencés",
  "sideNav.label.rejectionreport": "Rapport de rejet",
  "sidenav.label.reports": "Rapports",
  "sidenav.label.reports.routine": "Routine",
  "sidenav.label.reports.study": "Etude",
  "sidenav.label.results": "Résultats",
  "sidenav.label.results.byrange": "Par plage de numéros de commande",
  "sidenav.label.results.order": "Recherche par ordonnance",
  "sidenav.label.results.patient": "Par Patient",
  "sidenav.label.results.testdate": "Par Date de Test",
  "sidenav.label.results.unit": "Par Unité",
  "sideNav.label.sectionperformance": "Performances de l'unité",
  "sideNav.label.specialrequest": "Demande spéciale ",
  "sidenav.label.statisticsreport": "Rapport statistique",
  "sidenav.label.statusreport": "Résultats du patient",
  "sidenav.label.storage.coldstorage": "Surveillance des entrepôts frigorifiques",
  "sidenav.label.storage.coldstorage.tooltip": "Surveiller la température et l'humidité des congélateurs et des réfrigérateurs.",
  "sidenav.label.storage.management": "Gestion du stockage",
  "sidenav.label.storage.management.tooltip": "Gérer les emplacements de stockage et les appareils",
  "sidenav.label.testsummary": "Résumé de tous les tests",
  "sidenav.label.validation": "Validation",
  "sidenav.label.validation.order": "Recherche Par Commande",
  "sidenav.label.validation.routine": "Routine",
  "sidenav.label.validation.study": "Etude",
  "sidenav.label.validation.testdate": "Recherche Par Date de Test",
  "sideNav.label.viralloaddataexport": "Exportation Données Charge Viral",
  "sideNav.label.vlversionnational": "VL version Nationale",
  "sidenav.label.workplan": "Plan de Travail",
  "sidenav.label.workplan.panel": "Par type de panneau",
  "sidenav.label.workplan.priority": "Par priorité",
  "sidenav.label.workplan.test": "Par test",
  "sidenav.label.workplan.unit": "Par Unité",
  "sideNav.title.activityreport": "Rapport d'activité",
  "sidenav.title.aggregatereport": "Rapports agrégés",
  "sideNav.title.arvreports": "Rapports ARV",
  "sideNav.title.associatedpatientreport": "Rapports des Patients Associés",
  "sideNav.title.audittrail": "Formulaire d'Audit",
  "sideNav.title.collectedarvpatientreports": "Rapport de patient ARV collecté",
  "sideNav.title.delayedvalidation": "Compte de tests en attente de validation",
  "sideNav.title.eidreports": "Rapports EID",
  "sideNav.title.environmentalReports": "Rapports environnementaux",
  "sideNav.title.exportbydate": "Exporter en Fichier CSV",
  "sideNav.title.exportcsvfile": "Exporter le fichier CSV de routine",
  "sideNav.title.indicator": "Indicateur",
  "sideNav.title.intermediatereport": "Rapport intermédiaire",
  "sideNav.title.noncomformityreports": "Rapports de non-conformité",
  "sideNav.title.referredtestreport": "Rapport des tests référencés",
  "sideNav.title.rejectionreport": "Rapport de rejet",
  "sideNav.title.specialrequest": "Demande spéciale ",
  "sideNav.title.tatreport": "Délai de traitement",
  "sideNav.title.vectorIdentification": "Identification des vecteurs",
  "sideNav.title.vlreport": "Rapport VL",
  "sideNav.label.audittrail.orderEvents": "Événements de la demande d’examen",
  "sideNav.label.audittrail.systemEvents": "Événements système",
  "sidenav.label.addorder": "Ajouter une commande",
  "sidenav.label.admin.sampleTypeManagement": "Éditeur de type d'échantillon",
  "sideNav.label.qa": "Assurance qualité",
  "sideNav.label.qa.overview": "Vue d'ensemble AQ",
  "sideNav.label.qa.qc": "CQ statistique",
  "sideNav.label.qa.qc.dashboard": "Tableau de bord CQ",
  "sideNav.label.qa.qc.alerts": "Alertes CQ",
  "sideNav.label.qa.qc.controlLots": "Gestion des lots de CQ",
  "sideNav.label.qa.qc.ruleConfig": "Configuration des règles",
  "sideNav.label.qa.qc.reagentQc": "CQ des réactifs",
  "sideNav.label.qa.qc.manualQc": "CQ manuel des analyseurs",
  "sideNav.label.qa.qi": "Indicateurs qualité",
  "sideNav.label.qa.qi.dashboard": "Tableau de bord des indicateurs qualité",
  "sideNav.label.qa.qi.config": "Configuration des indicateurs qualité",
  "qa.qiConfig.subtitle": "Définissez les seuils cible et d'action par indicateur, activez ou désactivez les indicateurs et remplacez les seuils pour des unités de laboratoire spécifiques.",
  "qa.qiConfig.column.overrides": "Dérogations",
  "qa.qiConfig.field.enabled": "Suivre cet indicateur",
  "qa.qiConfig.field.target": "Cible",
  "qa.qiConfig.field.action": "Seuil d'action",
  "qa.qiConfig.field.category": "Unité de laboratoire",
  "qa.qiConfig.editor.title": "Modifier {indicator}",
  "qa.qiConfig.editor.defaults": "Seuils par défaut",
  "qa.qiConfig.editor.overrides": "Dérogations par unité",
  "qa.qiConfig.editor.usesDefault": "Les unités de laboratoire sans dérogation utilisent la valeur par défaut de l'indicateur.",
  "qa.qiConfig.editor.noOverrides": "Aucune dérogation : chaque unité de laboratoire utilise la valeur par défaut.",
  "qa.qiConfig.editor.addOverride": "Ajouter une dérogation par unité",
  "qa.qiConfig.editor.autoNce": "Lorsque la valeur depuis le début du mois dépasse le seuil d'action, un événement non conforme est créé automatiquement (un par indicateur et par mois).",
  "qa.qiConfig.indicator.tat": "Délai moyen de rendu des résultats",
  "qa.qiConfig.indicator.rejection": "Taux de rejet",
  "qa.qiConfig.indicator.amendment": "Taux de correction",
  "qa.qiConfig.indicator.nce": "Suivi des ENC",
  "qa.qiConfig.indicator.callback": "Conformité des rappels critiques",
  "qa.qiConfig.validation.required": "Les seuils cible et d'action sont tous deux obligatoires.",
  "qa.qiConfig.validation.range": "Les seuils doivent être compris entre 0 et 100.",
  "qa.qiConfig.validation.direction": "La cible et le seuil d'action sont dans le mauvais ordre pour cet indicateur.",
  "qa.qiConfig.validation.category": "Choisissez une unité de laboratoire pour chaque dérogation.",
  "qa.qiConfig.validation.duplicateCategory": "Une unité de laboratoire ne peut faire l'objet que d'une seule dérogation.",
  "qa.qiConfig.confirmDisableTitle": "Désactiver cet indicateur ?",
  "qa.qiConfig.confirmDisableBody": "Cela masquera la tuile du tableau de bord, supprimera les nouvelles alertes et arrêtera la création automatique d'ENC pour cet indicateur. Les données historiques sont conservées. Continuer ?",
  "qa.qiConfig.saveFailed": "Impossible d'enregistrer la configuration des IQ.",
  "sideNav.label.qa.qms": "SMQ et amélioration",
  "sideNav.label.qa.qms.esigLog": "Journal des signatures électroniques",
  "sideNav.label.qa.qms.capaRegister": "Registre CAPA",
  "sideNav.label.qa.qms.accreditation": "Accréditation",
  "qa.qms.capaRegister.subtitle": "Toutes les actions correctives et préventives de tous les événements non conformes, avec leurs dates d'échéance et leur statut.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Échéance cette semaine",
  "qa.qms.capaRegister.tile.completed": "Terminées (90 j)",
  "qa.qms.capaRegister.filter.assignee": "Responsable",
  "qa.qms.capaRegister.filter.from": "Date d'échéance (du)",
  "qa.qms.capaRegister.filter.to": "Date d'échéance (au)",
  "qa.qms.capaRegister.column.correctiveAction": "Action corrective / préventive",
  "qa.qms.capaRegister.column.assignee": "Responsable",
  "qa.qms.capaRegister.status.open": "Ouvert",
  "qa.qms.capaRegister.status.overdue": "En retard ",
  "qa.qms.capaRegister.status.completed": "Terminé",
  "qa.qms.capaRegister.error": "Le registre CAPA n'a pas pu être chargé.",
  "qa.qms.accreditation.title": "Accréditation des analyses",
  "qa.qms.accreditation.subtitle": "Organismes d'accréditation et inscription par analyse. Détermine les logos d'accréditation sur les rapports patients et la réponse sur la préparation à l'inspection.",
  "qa.qms.accreditation.error": "Les données d'accréditation n'ont pas pu être chargées.",
  "qa.qms.accreditation.actionError": "La modification n'a pas pu être enregistrée.",
  "qa.qms.accreditation.tile.total": "Organismes",
  "qa.qms.accreditation.inForce": "En vigueur : {names}",
  "qa.qms.accreditation.bodies.title": "Organismes d'accréditation",
  "qa.qms.accreditation.bodies.add": "Ajouter un organisme",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Expire le",
  "qa.qms.accreditation.status.ACTIVE": "Active",
  "qa.qms.accreditation.status.EXPIRING": "Expire bientôt",
  "qa.qms.accreditation.status.EXPIRED": "Expiré",
  "qa.qms.accreditation.status.INACTIVE": "Inactif",
  "qa.qms.accreditation.body.modal.addTitle": "Ajouter un organisme d'accréditation",
  "qa.qms.accreditation.body.modal.editTitle": "Modifier l'organisme d'accréditation",
  "qa.qms.accreditation.body.edit": "Modifier l'organisme",
  "qa.qms.accreditation.body.delete": "Supprimer l'organisme",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 caractères : majuscules, chiffres et traits d'union. Non modifiable par la suite.",
  "qa.qms.accreditation.body.field.expiresOn": "Expiration de l'accréditation",
  "qa.qms.accreditation.body.field.visibilityMode": "Afficher le logo sur un rapport lorsque",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Une analyse accréditée figure sur le rapport",
  "qa.qms.accreditation.visibility.PERCENTAGE": "Un pourcentage des analyses du rapport est accrédité",
  "qa.qms.accreditation.body.field.thresholdPct": "Seuil (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG ou JPEG, au moins 64×64 pixels, jusqu'à 500 Ko)",
  "qa.qms.accreditation.body.logo.remove": "Supprimer le logo",
  "qa.qms.accreditation.body.required": "Le code, le nom et la date d'expiration sont obligatoires.",
  "qa.qms.accreditation.body.saveError": "L'organisme d'accréditation n'a pas pu être enregistré.",
  "qa.qms.accreditation.body.logoError": "Le logo n'a pas pu être téléversé. Utilisez un PNG ou JPEG d'au moins 64×64 pixels et de 500 Ko maximum.",
  "qa.qms.accreditation.body.delete.title": "Supprimer l'organisme d'accréditation",
  "qa.qms.accreditation.body.delete.body": "Supprimer {name} ? Cette action est irréversible.",
  "qa.qms.accreditation.body.delete.blocked": "Suppression impossible : {count} accréditations d'analyses font référence à cet organisme. Supprimez-les d'abord.",
  "qa.qms.accreditation.enrollments.title": "Analyses inscrites",
  "qa.qms.accreditation.enrollments.add": "Inscrire des analyses",
  "qa.qms.accreditation.enrollment.column.body": "Organisme d'accréditation",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "En vigueur à partir du",
  "qa.qms.accreditation.enrollment.column.expires": "Expiration de l'accréditation",
  "qa.qms.accreditation.enrollment.remove": "Retirer l'inscription",
  "qa.qms.accreditation.eqa.title": "Couverture EEQ du périmètre accrédité",
  "qa.qms.accreditation.eqa.subtitle": "La norme ISO 15189 §7.7 demande si chaque analyse déclarée accréditée participe à une évaluation externe de la qualité. Cette vue compare le périmètre accrédité aux inscriptions EEQ actives.",
  "qa.qms.accreditation.eqa.column.scope": "Analyses dans le périmètre",
  "qa.qms.accreditation.eqa.column.covered": "Couvert par l'EEQ",
  "qa.qms.accreditation.eqa.column.gaps": "Lacunes",
  "qa.qms.accreditation.eqa.noGaps": "Couverture complète",
  "qa.qms.accreditation.eqa.gapsMore": "{names} et {count} autres",
  "qa.qms.accreditation.eqa.error": "La couverture EEQ n'a pas pu être chargée.",
  "qa.qms.accreditation.filter.body": "Organisme d'accréditation",
  "qa.qms.accreditation.filter.test": "Analyse : {name}",
  "qa.qms.accreditation.enroll.modal.title": "Inscrire des analyses",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "En vigueur à partir du (facultatif)",
  "qa.qms.accreditation.enroll.required": "Sélectionnez un organisme d'accréditation et au moins une analyse.",
  "qa.qms.accreditation.enroll.failed": "L'inscription a été rejetée.",
  "qa.qms.accreditation.enrollment.delete.title": "Retirer l'inscription",
  "qa.qms.accreditation.enrollment.delete.body": "Retirer {test} de {body} ?",
  "qa.qms.esigLog.subtitle": "Toutes les signatures électroniques enregistrées dans le système : qui a signé quoi, quand et pourquoi.",
  "qa.qms.esigLog.column.signer": "Signataire",
  "qa.qms.esigLog.column.subject": "Objet",
  "qa.qms.esigLog.filter.subjectType": "Type d'objet",
  "qa.qms.esigLog.filter.apply": "Appliquer les filtres",
  "qa.qms.esigLog.export.confirm.title": "Exporter sans filtres ?",
  "qa.qms.esigLog.export.confirm.body": "Aucun filtre n'est appliqué : l'export inclura toutes les signatures de la plage de dates sélectionnée (jusqu'à 10 000 lignes).",
  "qa.qms.esigLog.meaning.AUTHORED": "Saisi",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Validé et publié",
  "qa.qms.esigLog.meaning.REJECTED": "Rejeté",
  "qa.qms.esigLog.error": "Impossible de charger le journal des signatures. Veuillez réessayer.",
  "qa.qi.dashboard.subtitle": "Cinq indicateurs qualité, dont l'indicateur optionnel de conformité des rappels critiques.",
  "qa.qi.dashboard.window.label": "Période de rapport",
  "qa.qi.dashboard.window.7d": "7 jours glissants",
  "qa.qi.dashboard.window.30d": "30 jours glissants",
  "qa.qi.dashboard.window.90d": "90 jours glissants",
  "qa.qi.dashboard.window.ytd": "Depuis le début de l'année",
  "qa.qi.dashboard.lastRecomputed": "Dernier recalcul : {time}",
  "qa.qi.dashboard.viewDetail": "Voir le détail",
  "qa.qi.dashboard.tileInfo": "Que mesure cette tuile ?",
  "qa.qi.disabled.toast.title": "Indicateur désactivé",
  "qa.qi.disabled.toast.message": "Cet indicateur qualité est désactivé dans Configuration des IQ ; sa page de détail est indisponible.",
  "qa.qi.dashboard.tile.tat.label": "TAT moyen",
  "qa.qi.dashboard.tile.tat.tooltip": "Délai moyen entre la réception de l'échantillon et la validation du résultat, pour toutes les demandes d'analyses terminées sur la période de rapport.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "par rapport aux {days} jours précédents",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "par rapport à la période précédente",
  "qa.qi.dashboard.tile.tat.secondary": "Sur {count, plural, one {# unité de laboratoire} other {# unités de laboratoire}} · Plus lente : {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "Aucune demande d'analyse terminée sur cette période.",
  "qa.qi.dashboard.tile.tat.error": "Les données de délai de rendu sont indisponibles.",
  "qa.qi.dashboard.tile.rejection.label": "Taux de rejet",
  "qa.qi.dashboard.tile.amendment.label": "Taux de correction",
  "qa.qi.dashboard.tile.ncePulse.label": "Suivi des ENC",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Événements non conformes critiques sans accusé de réception à cet instant. Un décompte actuel, pas une tendance.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "critiques en attente",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} en action corrective",
  "qa.qi.dashboard.tile.ncePulse.error": "Les données ENC sont indisponibles.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Résultats corrigés après l'envoi de leur rapport patient, en proportion des résultats publiés sur la période de rapport.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "par rapport aux {days} jours précédents",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "par rapport à la période précédente",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} corrigés sur {released} publiés",
  "qa.qi.dashboard.tile.amendment.empty": "Aucun résultat publié sur cette période.",
  "qa.qi.dashboard.tile.amendment.error": "Les données de correction sont indisponibles.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Analyses rejetées lors de la saisie des résultats ou de la validation, en proportion des analyses démarrées sur la période de rapport.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "par rapport aux {days} jours précédents",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "par rapport à la période précédente",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} rejetées sur {total} démarrées",
  "qa.qi.dashboard.tile.rejection.empty": "Aucune analyse démarrée sur cette période.",
  "qa.qi.dashboard.tile.rejection.error": "Les données de rejet sont indisponibles.",
  "qa.qi.dashboard.tile.thresholds": "Cible {target} · action {action}",
  "qa.qi.amendment.title": "Taux de correction : détail",
  "qa.qi.amendment.subtitle": "Résultats corrigés après l'envoi de leur rapport patient.",
  "qa.qi.amendment.column.amendedAt": "Corrigé le",
  "qa.qi.amendment.column.priorValue": "Valeur précédente",
  "qa.qi.amendment.column.currentValue": "Valeur actuelle",
  "qa.qi.amendment.column.amendedBy": "Corrigé par",
  "qa.qi.amendment.column.releasedAt": "Publié le",
  "qa.qi.amendment.column.timeToAmend": "Délai de correction",
  "qa.qi.amendment.rate.label": "Taux de correction",
  "qa.qi.amendment.trend.empty": "Aucune donnée de tendance sur cette période.",
  "qa.qi.amendment.breakdown.title": "Par analyse",
  "qa.qi.amendment.breakdown.column.rate": "Taux",
  "qa.qi.rejection.title": "Taux de rejet : détail",
  "qa.qi.rejection.subtitle": "Analyses rejetées lors de la saisie des résultats, avec le motif de rejet enregistré.",
  "qa.qi.rejection.column.rejectedAt": "Rejeté le",
  "qa.qi.rejection.column.rejectedBy": "Rejeté par",
  "qa.qi.rejection.heatmap.title": "Carte thermique : lieu demandeur × unité de laboratoire",
  "qa.qi.rejection.heatmap.section": "Unité de laboratoire",
  "qa.qi.rejection.heatmap.unknown": "Lieu inconnu",
  "qa.qi.rejection.heatmap.unknownSection": "Unité inconnue",
  "qa.qi.rejection.heatmap.legend": "Cellules colorées selon le taux par rapport aux seuils du laboratoire : vert ≤ {target}%, orange entre les deux, rouge ≥ {action}%. Survolez une cellule pour voir les nombres rejetés / démarrés.",
  "qa.qi.rejection.rate.label": "Taux de rejet",
  "qa.qi.rejection.reasons.title": "Par motif (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% des rejets",
  "qa.qi.rejection.reasons.column.cumulative": "% cumulé",
  "qa.qi.rejection.reasons.donut.label": "Rejets",
  "qa.qi.rejection.reasons.insight": "Les {count} principaux motifs sur {total} représentent {percent}% des rejets ; traiter {reason} en premier a le plus d'impact.",
  "qa.qi.rejection.breakdown.other": "Autres ({count} analyses)",
  "qa.qi.rejection.list.title": "Rejets individuels",
  "qa.qi.amendment.list.title": "Corrections individuelles",
  "qa.qi.callback.button": "Consigner le rappel",
  "qa.qi.callback.banner.title": "Des résultats critiques nécessitent un rappel au clinicien",
  "qa.qi.callback.banner.subtitle": "{count, plural, one {# résultat critique enregistré sur cette page n'a aucun rappel consigné : relecture requise (TJC NPSG.02.03.01).} many {# résultats critiques enregistrés sur cette page n'ont aucun rappel consigné : relecture requise (TJC NPSG.02.03.01).} other {# résultats critiques enregistrés sur cette page n'ont aucun rappel consigné : relecture requise (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Consigner un rappel critique",
  "qa.qi.callback.field.recipientName": "Personne avisée",
  "qa.qi.callback.field.recipientName.placeholder": "Nom du clinicien ou du service contacté",
  "qa.qi.callback.field.status": "Résultat du rappel",
  "qa.qi.callback.status.CONFIRMED": "Confirmé avec relecture",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Joint, sans relecture",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Impossible à joindre",
  "qa.qi.callback.save.success": "Rappel enregistré",
  "qa.qi.callback.save.fail": "Échec de la consignation du rappel",
  "qa.qi.callback.title": "Conformité des rappels critiques : détail",
  "qa.qi.callback.subtitle": "Résultats critiques publiés et indication, pour chacun, d'un appel au clinicien avec relecture dans le délai cible de rappel.",
  "qa.qi.callback.distribution.title": "Distribution du délai d'accusé de réception",
  "qa.qi.callback.distribution.0-5": "0–5 min",
  "qa.qi.callback.distribution.5-15": "5–15 min",
  "qa.qi.callback.distribution.15-30": "15–30 min",
  "qa.qi.callback.distribution.30-60": "30–60 min",
  "qa.qi.callback.distribution.over60": "60+ min",
  "qa.qi.callback.distribution.noAck": "Aucun accusé",
  "qa.qi.callback.failures.title": "Échecs ({count}) par motif",
  "qa.qi.callback.failures.overTarget": "Au-delà de la cible",
  "qa.qi.callback.failures.unableToReach": "Impossible à joindre",
  "qa.qi.callback.failures.noReadback": "Aucune relecture enregistrée",
  "qa.qi.callback.failures.noCallback": "Aucun rappel enregistré",
  "qa.qi.callback.list.title": "Résultats critiques sur la période",
  "qa.qi.callback.rate.label": "Conformité des rappels (relecture en moins de {minutes} min)",
  "qa.qi.callback.status.notLogged": "Non consigné",
  "qa.qi.callback.column.status": "Statut du rappel",
  "qa.qi.callback.column.timeToCallback": "Délai de rappel",
  "qa.qi.callback.column.loggedBy": "Consigné par",
  "qa.qi.dashboard.tile.callback.label": "Conformité des rappels critiques",
  "qa.qi.dashboard.tile.callback.tooltip": "Résultats critiques publiés avec un rappel confirmé par relecture dans le délai cible de rappel du laboratoire. Optionnel : à activer dans Configuration des IQ. La conformité est recalculée à partir des intervalles critiques actuels.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} sur {critical} résultats critiques confirmés dans le délai cible",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "par rapport aux {days} jours précédents",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "par rapport à la période précédente",
  "qa.qi.dashboard.tile.callback.empty": "Aucun résultat critique sur cette période.",
  "qa.qi.dashboard.tile.callback.error": "Les données de rappel sont indisponibles.",
  "qa.qi.dashboard.tile.callback.disabled": "Non activé : à activer dans Configuration des IQ.",
  "qa.empty.callback.title": "Aucun résultat critique sur cette période",
  "qa.empty.callback.subhead": "Les résultats critiques publiés apparaissent ici avec l'état de documentation de leur rappel.",
  "qa.overview.rejection.caption": "rejetés lors de la saisie des résultats (30 j)",
  "qa.overview.rejection.ofStarted": "{rejected} sur {total} démarrés",
  "qa.overview.callback.caption": "conformité de la relecture des résultats critiques (30 j)",
  "qa.overview.callback.ofCritical": "{confirmed} sur {critical} confirmés",
  "qa.overview.callback.none": "aucun résultat critique sur la période",
  "qa.overview.week.confirmedCount": "{count} confirmés",
  "qa.overview.amendment.caption": "corrigés après rapport (30 j)",
  "qa.overview.amendment.ofReleased": "{amended} sur {released} publiés",
  "qa.future.subtitle": "Fonctionnalité future : conception disponible, développement pas encore planifié.",
  "qa.future.questionLabel": "La question à laquelle répond cette fonctionnalité",
  "qa.future.whyLabel": "Pourquoi c'est important",
  "qa.future.readDesignDoc": "Lire le document de conception sur GitHub",
  "qa.future.reagentQc.question": "Ce lot de réactif a-t-il été vérifié avant de l'utiliser sur des patients ?",
  "qa.future.reagentQc.summary": "Suivi de la fréquence du CQ par lot. Avant qu'un nouveau lot de réactif soit utilisé en clinique, le système exige des échantillons de vérification documentés comparant le nouveau lot à l'ancien ou à une référence de comparaison inter-laboratoires.",
  "qa.future.reagentQc.why": "Sans vérification des lots, un mauvais lot de réactif peut gâcher une semaine de résultats patients avant que quiconque ne s'en aperçoive. La plupart des laboratoires le font aujourd'hui de façon informelle ; l'intégrer au système permet de détecter les cas où le processus informel échoue.",
  "qa.future.manualQc.question": "Le technicien a-t-il effectué un contrôle quotidien sur cet instrument aujourd'hui, et a-t-il réussi ?",
  "qa.future.manualQc.summary": "Journal quotidien RÉUSSI/ÉCHEC par instrument. Les instruments ont des contrôles quotidiens différents ; le système les ramène tous à un même format : un journal quotidien RÉUSSI/ÉCHEC avec un signataire, un horodatage et un blocage de l'utilisation de l'instrument en cas d'ÉCHEC.",
  "qa.future.manualQc.why": "La première chose que demande un inspecteur en entrant dans un laboratoire, c'est « montrez-moi votre journal de CQ quotidien pour cet instrument ». Un journal signé par instrument et par jour, tous les jours. L'oublier, c'est ce qui fait échouer les inspections.",
  "qa.overview.subtitle": "Instantané quotidien pour le responsable qualité",
  "qa.overview.comingSoon": "Bientôt disponible",
  "qa.overview.section.attention": "Attention requise",
  "qa.overview.section.thisWeek": "Cette semaine",
  "qa.overview.section.pillars": "État des piliers",
  "qa.overview.section.activity": "Activité récente",
  "qa.overview.section.inspector": "Préparation à l'inspection : cinq questions qualité ISO 15189",
  "qa.overview.attention.criticalNce": "ENC critiques en attente d'accusé de réception",
  "qa.overview.attention.criticalResults": "Résultats critiques au cours des dernières 24 heures",
  "qa.overview.attention.overdueCapas": "CAPA en retard",
  "qa.overview.attention.qcViolations": "Violations du CQ au cours des dernières 24 heures",
  "qa.overview.attention.effectivenessReview": "Revues d'efficacité des CAPA à échéance",
  "qa.overview.attention.eqaDue": "Soumissions EEQ dues dans les 14 prochains jours",
  "qa.overview.attention.nceSla": "ENC proches du délai (SLA) d'accusé de réception",
  "qa.overview.tile.criticalCallback": "Rappel critique",
  "qa.overview.week.newNces": "Nouveaux ENC",
  "qa.overview.week.ncesResolved": "ENC résolus",
  "qa.overview.week.capasCompleted": "CAPA terminées",
  "qa.overview.week.qcViolations": "Violations du CQ",
  "qa.overview.week.criticalResults": "Résultats critiques",
  "qa.overview.week.eqaSubmissions": "Soumissions EEQ",
  "qa.overview.week.auditEntries": "Entrées du journal d'audit",
  "qa.overview.week.signatureEvents": "Événements de signature",
  "qa.overview.inspector.q1": "Les séries sont-elles sous contrôle ?",
  "qa.overview.inspector.q2": "Quelle a été la performance EEQ au dernier cycle ?",
  "qa.overview.inspector.q3": "Les IQ atteignent-ils leurs cibles ?",
  "qa.overview.inspector.q4": "ENC critiques ouverts ?",
  "qa.overview.inspector.q5": "État de l'accréditation ?",
  "qa.overview.inspector.q1.answer": "{inControl} instruments sur {total} sous contrôle (30 j)",
  "qa.overview.inspector.q3.answer": "TAT moyen {tat} par rapport aux 30 j précédents",
  "qa.overview.inspector.q4.answer": "{count} ENC critiques en attente d'accusé de réception",
  "qa.overview.inspector.q5.answer": "{active} sur {total} en vigueur, {expiring} arrivant à expiration, {expired} expirés",
  "qa.overview.inspector.q5.noData": "Aucun organisme d'accréditation configuré",
  "qa.overview.week.severityBreakdown": "{critical} critiques · {major} majeurs · {minor} mineurs",
  "qa.overview.week.overdueCount": "{count} en retard",
  "qa.overview.week.currentlyOpen": "actuellement ouverts",
  "qa.overview.pillar.qc.text": "{inControl} instruments sur {total} sous contrôle",
  "qa.overview.pillar.qc.noData": "Pas encore de données CQ",
  "qa.overview.pillar.qi.text": "TAT moyen {tat}",
  "qa.overview.pillar.qi.noData": "Pas encore de données de TAT",
  "qa.overview.pillar.qi.disabled": "Non suivi actuellement",
  "qa.overview.pillar.qms.text": "{critical} critiques en attente · {capa} en action corrective",
  "qa.overview.activity.viewAudit": "Voir la piste d'audit complète",
  "qa.overview.activity.empty": "Aucune activité au cours des dernières 24 heures",
  "qa.empty.activity.subhead": "Les actions attestées de tous les piliers apparaissent ici au fur et à mesure.",
  "qa.empty.attention.title": "Rien ne requiert votre attention pour le moment",
  "qa.empty.attention.subhead": "Les ENC critiques, les CAPA en retard et les violations du CQ apparaissent ici lorsqu'ils surviennent.",
  "qa.empty.amendment.title": "Aucune correction sur cette période",
  "qa.empty.amendment.subhead": "Les corrections apparaissent ici lorsqu'un résultat publié est corrigé.",
  "qa.empty.rejection.title": "Aucun rejet sur cette période",
  "qa.empty.rejection.subhead": "Les rejets apparaissent ici lorsqu'une analyse est rejetée lors de la saisie des résultats ou de la validation.",
  "qa.empty.capaRegister.title": "Aucune CAPA ne correspond à ces filtres",
  "qa.empty.capaRegister.subhead": "Les actions correctives et préventives apparaissent ici au fur et à mesure de leur enregistrement pour les événements non conformes.",
  "qa.empty.accreditation.bodies.title": "Aucun organisme d'accréditation pour l'instant",
  "qa.empty.accreditation.bodies.subhead": "Ajoutez les organismes qui accréditent ce laboratoire pour commencer le suivi de l'accréditation par analyse.",
  "qa.empty.accreditation.enrollments.title": "Aucune inscription ne correspond à ces filtres",
  "qa.empty.accreditation.enrollments.subhead": "Inscrivez des analyses auprès d'un organisme d'accréditation pour afficher son logo sur les rapports patients.",
  "qa.empty.accreditation.eqa.title": "Rien à comparer pour l'instant",
  "qa.empty.accreditation.eqa.subhead": "Une fois les analyses inscrites auprès d'un organisme d'accréditation, leur couverture EEQ est comparée ici.",
  "qa.empty.esigLog.title": "Aucune signature sur cette période",
  "qa.empty.esigLog.subhead": "Les signatures apparaissent ici lorsque les résultats sont saisis et validés. Essayez une plage de dates plus large ou moins de filtres.",
  "qa.empty.tat.title": "Aucun résultat sur cette période",
  "qa.empty.tat.subhead": "Les délais de rendu apparaissent ici au fur et à mesure que les demandes d'analyses sont terminées et validées. Essayez une autre plage de dates.",
  "qa.empty.sparse.labUnits": "{count, plural, one {# unité de laboratoire sur cette période} many {# unités de laboratoire sur cette période} other {# unités de laboratoire sur cette période}} this period",
  "qa.overview.activity.yesterday": "Hier {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "a saisi les résultats de",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "a validé et publié",
  "qa.overview.activity.meaning.REJECTED": "a rejeté",
  "qa.overview.activity.qc": "Alerte CQ : {rule} ({severity}) sur {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} a déclaré {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} a accusé réception de {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} a assigné {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} a ajouté une note à {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} a mis à jour le statut de {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} a mis à jour l'action corrective de {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} a résolu {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} a mis à jour {nce}",
  "sidenav.title.statusreport": "Résultats du patient",
  "systemAudit.filter.startDate": "Date de début",
  "systemAudit.filter.endDate": "Date de fin",
  "systemAudit.filter.entityType": "Type d’entité",
  "systemAudit.filter.action": "Action",
  "systemAudit.filter.search": "Rechercher",
  "systemAudit.filter.export": "Exporter en CSV",
  "systemAudit.table.heading.time": "Heure",
  "systemAudit.table.heading.entityType": "Type d’entité",
  "systemAudit.table.heading.entityId": "ID de l’entité ",
  "systemAudit.table.heading.action": "Action",
  "systemAudit.table.heading.user": "Utilisateur",
  "systemAudit.table.heading.changes": "Modifications",
  "systemAudit.noResults": "Aucun événement système trouvé pour les filtres donnés.",
  "systemAudit.filter.all": "Tous",
  "systemAudit.filter.user": "Utilisateur",
  "systemAudit.filter.searchText": "Rechercher",
  "systemAudit.filter.searchText.placeholder": "Rechercher par ID d’entité… ",
  "systemAudit.filter.exportPdf": "Exporter en PDF",
  "systemAudit.filter.selectedPatient": "Patiente sélectionnée",
  "systemAudit.filter.selectedPatient.none": "Aucun",
  "systemAudit.filter.selectPatient": "Sélectionnez un patient",
  "systemAudit.filter.selectAnotherPatient": "Sélectionnez un autre patient",
  "systemAudit.action.insert": "Insérer",
  "systemAudit.action.update": "Mettre à jour",
  "systemAudit.action.delete": "Supprimer",
  "site.branding.cancel": "Annuler",
  "site.branding.color.format.error": "Invalid color format. Please use a valid CSS color (e.g., #0f62fe)",
  "site.branding.color.hex.label": "Code couleur hexadécimal",
  "site.branding.colorPicker.helperText": "Enter any CSS color (e.g., #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe or blue",
  "site.branding.confirm.remove": "Remove Logo",
  "site.branding.confirm.remove.message": "Are you sure you want to remove this logo and revert to the default OpenELIS logo?",
  "site.branding.current.logo": "Current Logo",
  "site.branding.description": "Gestion de l’identité visuelle (logos et couleurs)",
  "site.branding.error.remove": "Error removing logo file.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Icône affichée dans les onglets et les favoris du navigateur",
  "site.branding.file.format.error": "Unsupported file format. Please use PNG, SVG, or JPG/JPEG",
  "site.branding.file.pending": "File selected - click Save Changes to upload",
  "site.branding.file.size.error": "File size exceeds 2MB limit",
  "site.branding.formats": "Formats : PNG, SVG, JPG (max 2 Mo)",
  "site.branding.header.color": "Couleur de l’en-tête",
  "site.branding.header.color.description": "Couleur de fond de la barre d’en-tête de l’application",
  "site.branding.header.logo": "Header Logo",
  "site.branding.header.logo.description": "Logo affiché dans le coin supérieur gauche de l'application",
  "site.branding.login.logo": "Login Page Logo",
  "site.branding.login.logo.description": "Logo de la page de connexion",
  "site.branding.login.using.header.logo": "Utiliser le logo de l’en-tête pour la page de connexion",
  "site.branding.logo.upload.success": "Logo uploaded successfully",
  "site.branding.no.logo": "No custom logo (using default)",
  "site.branding.preview": "Preview",
  "site.branding.primary.color": "Couleur principal",
  "site.branding.primary.color.description": "Couleur des boutons principaux, des éléments de menu actifs et des liens",
  "site.branding.remove.favicon": "Remove Favicon",
  "site.branding.remove.header.logo": "Remove Header Logo",
  "site.branding.remove.login.logo": "Remove Login Logo",
  "site.branding.remove.logo": "Remove Logo",
  "site.branding.reset.confirmation": "Are you sure you want to reset all branding to OpenELIS defaults? This will remove all custom logos and colors.",
  "site.branding.reset.error": "Error resetting branding to defaults.",
  "site.branding.reset.success": "Branding reset to default values successfully.",
  "site.branding.reset.to.defaults": "Reset to Default Branding",
  "site.branding.save": "Save Changes",
  "site.branding.save.error": "Error saving branding configuration",
  "site.branding.save.success": "Branding configuration saved successfully",
  "site.branding.secondary.color": "Couleur secondaire",
  "site.branding.secondary.color.description": "Couleur des boutons secondaires, des bordures et des états inactifs",
  "site.branding.section.colors": "Colors",
  "site.branding.section.logos": "Logos",
  "site.branding.title": "Personnalisation du site",
  "site.branding.unsaved.changes": "You have unsaved changes. Do you want to save, discard, or cancel?",
  "site.branding.unsaved.changes.warning": "You have unsaved changes. Click Save to apply them.",
  "site.branding.upload.favicon": "Upload Favicon",
  "site.branding.upload.header.logo": "Upload Header Logo",
  "site.branding.upload.login.logo": "Upload Login Logo",
  "site.branding.upload.logo": "Upload Logo",
  "site.branding.use.header.logo.for.login": "Use same logo as header",
  "siteInfo.description.default.barcode": "Indiquez le nombre par défaut d'étiquettes de code-barres qui doivent être imprimées avec chaque commande et spécimen.",
  "siteInfo.description.dimensions": "Indiquez les dimensions auxquelles les étiquettes de code-barres doivent se conformer lors de l'impression.",
  "siteInfo.description.elements": "Cochez la case à côté des éléments optionnels qui doivent apparaître sur les étiquettes de code-barres de commande et d'échantillon.",
  "siteInfo.description.max.barcode": "Indiquez le nombre maximum d'étiquettes de code-barres pouvant être imprimées pour chaque commande ou spécimen. Une fois le maximum atteint, un utilisateur ne pourra plus imprimer d'étiquettes supplémentaires.",
  "siteInfo.elements.mandatory": "Éléments Obligatoires",
  "siteInfo.elements.optional": "Éléments Optionnels",
  "siteInfo.section.altAccession": "Numéro d'accès au code-barres pré-imprimé",
  "siteInfo.section.elements": "Éléments de l'étiquette de code-barres",
  "siteInfo.section.number": "Nombre d'étiquettes de code-barres",
  "siteInfo.section.size": "Dimensions de l'étiquette de code-barres",
  "siteInfo.title.default.barcode": "Étiquettes de code-barres par défaut",
  "siteInfo.title.default.barcode.block": "Bloc",
  "siteInfo.title.default.barcode.height": "Hauteur",
  "siteInfo.title.default.barcode.order": "Demande d'examen",
  "siteInfo.title.default.barcode.order.none": "Aucun",
  "siteInfo.title.default.barcode.slide": "Lame",
  "siteInfo.title.default.barcode.specimen": "Échantillon",
  "siteInfo.title.default.barcode.freezer": "Congélateur",
  "siteInfo.title.default.barcode.width": "Largeur",
  "siteInfo.title.max.barcode": "Nombre maximum d'étiquettes de code-barres",
  "started.date": "Date de début",
  "status": "Statut",
  "status.in.progress": "En cours",
  "status.unknown": "Inconnu",
  "stillThere.message": "la session utilisateur est sur le point d'expirer. Cliquez pour rester connecté",
  "stillThere.title": "Toujours là?",
  "stock.available": "Disponible",
  "stock.level": "Niveau de stock",
  "stock.status": "État des stocks",
  "stock.status.expired": "Expiré",
  "stock.status.expiring": "Expiration",
  "stock.status.expiringIn": "Expire bientôt ({days} j)",
  "stock.status.inStock": "En stock",
  "stock.status.lowStock": "Stock faible",
  "stock.status.outOfStock": "En rupture de stock",
  "storage.active": "Active",
  "storage.add.device": "Ajouter un appareil",
  "storage.add.location": "Emplacement",
  "storage.add.location.option": "Ajouter Emplacement",
  "storage.add.new.device": "Ajouter un nouvel appareil",
  "storage.add.rack": "Ajouter un support",
  "storage.add.box": "Ajouter une boîte",
  "storage.add.room": "Ajouter une pièce",
  "storage.add.shelf": "Ajouter une étagère",
  "storage.allAssigned.title": "Tous les échantillons assignés",
  "storage.assign.button": "Attribuer un chemin ",
  "storage.assign.title": "Attribuer un lieu de stockage",
  "storage.assigned": "Assigné",
  "storage.assigned.by": "Attribué par",
  "storage.assigned.date": "Date d’attribution",
  "storage.barcode.scan.placeholder": "Scannez le code-barres ou saisissez manuellement.",
  "storage.bulk.move.auto.assigned": "Positions attribuées automatiquement (modifiables)",
  "storage.bulk.move.preview": "Aperçu de la suppression groupé",
  "storage.cannotDelete.hasAssignments": "Impossible de supprimer {entityType} '{name}': contient{count}type d'echantillon",
  "storage.cannotDelete.hasChildren": "Impossible de supprimer {entityType} '{name}' : contient {count} {childType}(s)",
  "storage.capacity.calculated": "Calculé",
  "storage.capacity.manual": "Limite manuelle",
  "storage.capacity.undetermined.tooltip": "La capacité ne peut pas être calculée : certains emplacements enfants n’ont pas de capacités définies",
  "storage.capacity.warning": "{location} est rempli à {percentage} %. Envisagez d’utiliser un autre emplacement de stockage.",
  "storage.code.change.acknowledge": "Je comprends et souhaite procéder à la modification du code.",
  "storage.code.change.warning": "Avertissement",
  "storage.code.change.warning.message": "La modification du code invalidera toutes les étiquettes imprimées précédemment pour cet emplacement.",
  "storage.confirm.add.device": "Voulez-vous créer un nouvel appareil '{name}' ?",
  "storage.conditionNotes": "Notes sur les conditions",
  "storage.conditionNotes.placeholder": "Saisissez des notes sur les conditions de stockage…",
  "storage.confirm.delete": " Confirmer la suppression",
  "storage.create.room.error": "Failed to create room: {error}",
  "storage.create.room.success": "Room \\",
  "storage.current.location": "Emplacement actuel ",
  "storage.currentLocation": "Emplacement actuel ",
  "storage.delete.admin.only": "Seuls les administrateurs globaux peuvent supprimer des emplacements",
  "storage.delete.are.you.sure": "Êtes-vous sûr de vouloir supprimer",
  "storage.delete.cannot.be.undone": "Cette action est irréversible.",
  "storage.delete.cascade.confirm": "Confirmer la suppression en cascade",
  "storage.delete.cascade.confirmation.checkbox": "Je confirme vouloir supprimer cet emplacement et tous ses sous-emplacements. Tous les échantillons seront désattribués. Cette action est irréversible.",
  "storage.delete.cascade.summary": "Cela supprimera {childCount} {childType}(s) et désassignera {sampleCount} échantillon(s). Êtes-vous sûr de vouloir continuer ?",
  "storage.delete.cascade.warning": "Avertissement de suppression en cascade",
  "storage.delete.checking": "Vérification des contraintes…",
  "storage.delete.confirmation.checkbox": "Je confirme que je souhaite supprimer cet emplacement. Cette action est irréversible.",
  "storage.delete.constraints.title": "Suppression impossible",
  "storage.delete.device": "Delete Device",
  "storage.delete.error": "Échec de la suppression de l’emplacement",
  "storage.delete.location": "Supprimer l'emplacement",
  "storage.delete.rack": "Supprimer le support",
  "storage.delete.room": "Supprimer la pièce",
  "storage.delete.shelf": "Supprimer l'étagère",
  "storage.device.code": "Code Emplacement",
  "storage.device.communicationProtocol": "Protocole de communication",
  "storage.device.communicationProtocol.helper": "Protocole utilisé pour la communication entre les appareils (par exemple, BACnet)",
  "storage.device.ipAddress": "Adresse IP",
  "storage.device.ipAddress.helper": "Adresse IPv4 ou IPv6 pour les équipements connectés au réseau",
  "storage.device.label": "Appareil",
  "storage.device.name": "Nom",
  "storage.device.placeholder": "Sélectionnez ou saisissez pour créer un appareil…",
  "storage.device.port": "Port",
  "storage.device.port.helper": "Numéro de port (1-65535) pour la communication",
  "storage.device.room": "Pièce",
  "storage.device.type": "Type",
  "storage.edit.device": "Modifier l'appareil",
  "storage.edit.error.loadLocation": "Échec du chargement de l'emplacement",
  "storage.edit.error.saveFailed": "Échec de l'enregistrement",
  "storage.edit.error.saveHttp": "Échec de l'enregistrement (HTTP {status})",
  "storage.edit.rack": "Modifier le support",
  "storage.edit.room": "Modifier la salle",
  "storage.edit.shelf": "Modifier l'étagère",
  "storage.edit.selectParent": "Sélectionner {parent}",
  "storage.editbox.error.loadBox": "Échec du chargement de la boîte",
  "storage.editbox.selectRack": "Sélectionner le portoir",
  "storage.box.capacity": "Capacité",
  "storage.box.gridSize": "Taille de la grille",
  "storage.box.rows": "Lignes",
  "storage.box.columns": "Colonnes",
  "storage.box.preset": "Préréglage de dimensions",
  "storage.box.preset.select": "Sélectionner les dimensions",
  "storage.error.location.inactive": "Impossible d'affecter à un emplacement inactif",
  "storage.error.name.duplicate": "Une entité de  type {entityType} portant ce nom existe déjà dans l'emplacement parent sélectionné.",
  "storage.error.position.occupied": "Le poste est déjà occupé",
  "storage.expanded.capacityLimit": "Limite de capacité",
  "storage.expanded.createdBy": "Created By",
  "storage.expanded.createdDate": "Date de création",
  "storage.expanded.description": "Description",
  "storage.expanded.lastModifiedBy": "Dernière modification par",
  "storage.expanded.lastModifiedDate": "Date de dernière modification",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Indication du schéma de position",
  "storage.expanded.temperatureSetting": "Réglage de la température",
  "storage.filter.by.locations": "Filtrer par emplacements",
  "storage.filter.by.locations.placeholder": "Filtrer par emplacements",
  "storage.filter.device": "Filtrer par appareil",
  "storage.filter.room": "Filtrer par Chambre",
  "storage.filter.status": "Filtrer par statut",
  "storage.hierarchical.path": "Chemin d'accès",
  "storage.inline.add.device": "Add New Device",
  "storage.inline.add.rack": "Ajouter un nouveau support ",
  "storage.inline.add.room": "Add New Room",
  "storage.inline.add.shelf": "Ajouter une nouvelle étagère",
  "storage.location": "Emplacement",
  "storage.location.active": "Active",
  "storage.location.add.button": "Ajouter Emplacement",
  "storage.location.add.title": "Ajouter un emplacement de stockage",
  "storage.location.current": "Lieu de stockage",
  "storage.location.code": "Code Emplacement",
  "storage.location.code.helper": "10 caractères maximum, alphanumériques avec tirets/traits de soulignement",
  "storage.location.description": "Description",
  "storage.location.label": "Emplacement de stockage",
  "storage.location.name": "Nom de l'emplacement",
  "storage.location.skipped": "Stockage passé",
  "storage.location.tempMax": "Température Max",
  "storage.location.tempMin": "Température Min",
  "storage.location.type": "Type Emplacement",
  "storage.location.unassigned": "Non attribué",
  "storage.location.notAssigned": "Non attribué",
  "storage.location.move": "Déplacer l'emplacement de stockage",
  "storage.location.assign": "Attribuer un emplacement de stockage",
  "storage.manageLocation.error.saveFailed": "Échec de l'enregistrement",
  "storage.manageLocation.error.selectTarget": "Sélectionnez un appareil, une étagère, un portoir ou une boîte avant d'enregistrer",
  "storage.nav.box": "Boîte",
  "storage.nav.device": "Appareil",
  "storage.nav.room": "Pièce",
  "storage.nav.shelf": "Étagère",
  "storage.picker.currentLocation": "Emplacement actuel",
  "storage.picker.heading.assignLocation": "Attribuer un lieu de stockage",
  "storage.picker.heading.move": "Déplacer l'élément",
  "storage.picker.newLocation": "Nouvel emplacement",
  "storage.picker.notes": "Notes",
  "storage.picker.orBrowse": "Ou choisir niveau par niveau",
  "storage.picker.position.optional": "Position (facultatif)",
  "storage.picker.select": "Sélectionner {level}",
  "storage.picker.selectDeviceType": "Sélectionner le type d'appareil",
  "storage.picker.addNewLevel": "Ajouter un nouveau {level}",
  "storage.picker.inlineCreate.heading": "Créer un nouveau {level}",
  "storage.picker.inlineCreate.error.title": "Impossible de créer l'emplacement",
  "storage.picker.inlineCreate.error": "Échec de la création de l'emplacement",
  "storage.picker.occupant.identifier": "Identifiant",
  "storage.picker.occupant.heading": "Élément",
  "storage.picker.occupant.status": "Statut",
  "storage.picker.occupant.type": "Type",
  "storage.picker.storageLocation": "Lieu de stockage",
  "storage.metrics.active": "Active",
  "storage.metrics.disposed": "Rejeté",
  "storage.metrics.total.samples": "Total des échantillons",
  "storage.mode.autocomplete": "Recherche à saisie semi-automatique",
  "storage.mode.barcode": "Numérisation des codes à barres",
  "storage.mode.cascading": "Menus déroulants en cascade",
  "storage.move.button": "Déplacer l'échantillon",
  "storage.move.reason.label": "Raison de la suppression",
  "storage.nav.boxes": "Boxes",
  "storage.nav.boxes.tooltip": "Manage storage boxes",
  "storage.nav.dashboard": "Storage Dashboard",
  "storage.nav.devices": "Devices",
  "storage.nav.devices.tooltip": "Manage storage devices",
  "storage.nav.locations": "Locations",
  "storage.nav.locations.tooltip": "Manage storage locations",
  "storage.nav.racks": "Racks",
  "storage.nav.racks.tooltip": "Manage storage racks",
  "storage.nav.rooms": "Rooms",
  "storage.nav.rooms.tooltip": "Manage storage rooms",
  "storage.nav.sample.items": "Sample Items",
  "storage.nav.sample.items.tooltip": "View and manage stored samples",
  "storage.nav.samples": "Sample Items",
  "storage.nav.samples.tooltip": "View and manage stored samples",
  "storage.nav.shelves": "Shelves",
  "storage.nav.shelves.tooltip": "Manage storage shelves",
  "storage.no.data": "Aucune donnée disponible",
  "storage.occupancy": "Occupation",
  "storage.position.label": "Position",
  "storage.rack.device": "Appareil",
  "storage.rack.dimensions": "Dimensions",
  "storage.rack.label": "Support",
  "storage.rack.placeholder": "Sélectionnez ou saisissez pour créer un support…",
  "storage.rack.room": "Pièce",
  "storage.rack.shelf": "Étagère",
  "storage.room.code": "Code Emplacement",
  "storage.room.devices": "Devices",
  "storage.room.label": "Pièce",
  "storage.room.name": "Nom",
  "storage.room.placeholder": "Sélectionnez ou saisissez pour créer une chambre...",
  "storage.room.samples": "Échantillons",
  "storage.sampleitem.id": "ID d'élément d'échantillon",
  "storage.search.boxes.placeholder": "Rechercher des boîtes par étiquette ou code...",
  "storage.search.devices.placeholder": "Rechercher par nom ou code de l’appareil…",
  "storage.search.location.minLength": "Continuez la saisie, au moins 2 caractères",
  "storage.search.location.searching": "Recherche en cours…",
  "storage.search.location.error": "Impossible de rechercher les emplacements. Veuillez réessayer.",
  "storage.search.location.noResults": "Aucun emplacement de stockage ne correspond à \"{query}\"",
  "storage.search.placeholder": "Recherche par identifiant d'échantillon ou par emplacement...",
  "storage.search.racks.placeholder": "Rechercher par étiquette de support d'echantillons…",
  "storage.search.rooms.placeholder": "Recherche par nom ou code de chambre...",
  "storage.search.lots.placeholder": "Rechercher par numéro de lot, code-barres, article ou emplacement...",
  "storage.search.samples.placeholder": "Recherche par identifiant d'échantillon ou par emplacement...",
  "storage.search.shelves.placeholder": "Rechercher par étiquette d’étagère…",
  "storage.select.location": "Sélectionner un emplacement",
  "storage.selectSample": "Sélectionner un échantillon ",
  "storage.shelf.device": "Appareil",
  "storage.shelf.label": "Étagère",
  "storage.shelf.placeholder": "Sélectionnez ou saisissez pour créer une étagère…",
  "storage.shelf.room": "Pièce",
  "storage.status": "Statut",
  "storage.status.disposed": "Rejeté",
  "storage.success.assigned": "Échantillon affecté avec succès à l'emplacement de stockage",
  "storage.success.moved": "L'échantillon a été déplacé avec succès vers son nouvel emplacement.",
  "storage.tab.ariaLabel": "Onglets de gestion du stockage",
  "storage.tab.dashboard": "Tableau de bord",
  "storage.tab.inventoryLots": "Lots d'inventaire",
  "storage.tab.samples": "Sample Items",
  "storage.target.location": "Emplacement cible",
  "storage.unassigned.title": "Échantillons non assignés",
  "storage.skipAssignment": "Aucun stockage requis – les échantillons seront traités immédiatement",
  "success.add.edited.msg": "Ajouté/Modifié avec succès",
  "success.delete.msg": "Supprimé avec succès",
  "success.import.patient": "Patient importé avec succès",
  "success.report.status": "Rapport généré avec succès",
  "success.save.msg": "Enregistré avec succès",
  "success.save.patient": "Patient enregistré avec succès",
  "systemuser.firstName": "Prénom de l'utilisateur",
  "systemuser.isActive": "La catégorie est active",
  "systemuser.lastName": "Nom de l'utilisateur",
  "systemuser.loginName": "Nom d'utilisateur",
  "systemuser.role": "Rôles",
  "systemuserrole.apply": "Appliquer",
  "systemuserrole.allLabUnits.confirm.body": "Passer cette ligne à Toutes les unités de laboratoire supprime ces autorisations par unité de laboratoire. La ligne Toutes les unités de laboratoire commence sans aucune autorisation cochée.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "aucune autorisation cochée",
  "systemuserrole.allLabUnits.confirm.primary": "Remplacer les autorisations",
  "systemuserrole.allLabUnits.confirm.title": "Remplacer les autorisations de l'unité de laboratoire ?",
  "systemuserrole.allLabUnits.exclusive.error": "L'option Toutes les unités de laboratoire ne peut pas être combinée avec des unités individuelles. Rien n'a été enregistré.",
  "systemuserrole.allLabUnits.exclusive.info": "L'option Toutes les unités de laboratoire ne peut pas être combinée avec des unités individuelles : la sélectionner remplace toutes les autorisations propres à une unité de laboratoire.",
  "systemuserrole.copypermissions": "Copier les permissions de l'utilisateur",
  "systemuserrole.copypermissions.placeholder": "Copier les permissions d'un utilisateur",
  "systemuserrole.instruction.1": "Il existe deux types de rôles. Les rôles globaux qui sont définis pour l'ensemble de l'application et les rôles des unités de laboratoire qui peuvent être définis pour toutes les unités de laboratoire ou des unités spécifiques.",
  "systemuserrole.instruction.2": "Les rôles globaux disponibles sont : Administrateur global (accès à toutes les fonctions d'administration), Audit Trail (accès à tous les audits), Administrateur de comptes utilisateur (accès à toutes les fonctionnalités d'administration des comptes utilisateur, mais pas à d'autres fonctions d'administration).",
  "systemuserrole.instruction.3": "Les rôles des unités de laboratoire sont : Réception (accès aux onglets Commande, Patient et Non-conformité), Résultats (accès aux onglets Plan de travail, Non-conformité et Résultats), Validation (accès aux onglets Validation et Non-conformité), Rapports (accès à l'onglet Rapports sauf export CSV uniquement disponible pour les administrateurs globaux).",
  "systemuserrole.instruction.4": "Pour attribuer des rôles d'unités de laboratoire, sélectionnez toutes les unités de laboratoire ou l'unité spécifique dans le menu déroulant et sélectionnez les rôles que vous souhaitez définir.",
  "systemuserrole.instruction.5": "Vous pouvez également utiliser la fonctionnalité de copie des autorisations pour copier les autorisations d'un utilisateur existant. Assurez-vous d'avoir rempli toutes les informations ci-dessus et entrez le nom d'utilisateur dont vous souhaitez copier les autorisations dans la case et cliquez sur appliquer.",
  "systemuserrole.newpermissions": "Ajouter une nouvelle permission",
  "systemuserrole.rmpermissions": "Supprimer la permission",
  "systemuserrole.roles.global": "Rôles globaux",
  "systemuserrole.roles.labunit": "Rôles Unité de Laboratoire",
  "test.add.copy.name": "Copier depuis le nom du test",
  "test.antimicrobialResistance": "Résistance aux antimicrobiens",
  "test.description.active": "Si le test est actif, il peut être sélectionné sur le bulletin d'analyse ou dans le cadre d'un algorithme de test. S'il n'est pas actif, il ne peut pas être sélectionné ou faire partie d'un algorithme de test",
  "test.description.name": "Le nom du test tel qu'il apparaîtra dans openELIS. L'anglais et le français sont requis.",
  "test.description.orderable": "Si un test est actif et sélectionnable, il peut être sélectionné via un bulletin d'analyse. S'il est actif mais non sélectionnable, il ne sera actif que s'il est lié à un autre test.",
  "test.description.panel": "Si ce test fait partie d'un panel de tests, le panel peut être ajouté ici. Il est possible, mais pas habituel, qu'un test soit dans plus d'un panel",
  "test.description.reportName": "Nom du test tel qu'il apparaîtra dans les rapports. L'anglais et le français sont requis. Si le nom et le nom sur le rapport sont identiques, cliquez sur le bouton pour copier le nom.",
  "test.description.testSection": "La section de test dans laquelle le test sera effectué",
  "test.description.uom": "Unité de mesure du test. Cela ne s'applique généralement qu'aux résultats numériques ou alphanumériques",
  "test.field.active": "Active",
  "test.field.orderable": "Sélectionnable",
  "test.inLabOnly": "Uniquement en laboratoire",
  "test.modify.en": "An",
  "test.modify.fr": "Fr",
  "test.modify.header.modify": "Sélectionner le test à modifier",
  "test.modify.header.test": "Test",
  "test.name": "Nom du test ",
  "test.notifyResults": "Notifier le patient des résultats",
  "test.section": "Section de test",
  "test.section.label": "Section de test",
  "test.show.guide": "Consulter l'aide",
  "testcalculation.label.calculation": "Calcul",
  "testcalculation.label.finalresult": "Résultat final",
  "testcalculation.label.insertOperation": "Insérer une opération",
  "testcalculation.label.integer": "Entier",
  "testcalculation.label.mathFucntion": "Fonction mathématique",
  "testcalculation.label.name": "Nom du calcul",
  "testcalculation.label.patientAttribute": "Attribut du patient",
  "testcalculation.label.searchNumericTest": "Rechercher un test numérique",
  "testcalculation.label.selectDictionaryValue": "Sélectionnez la valeur du dictionnaire",
  "testcalculation.label.testResult": "Résultat du test",
  "testcalculation.label.textValue": "Valeur de texte",
  "testCatalog.header.ageRange": "Tranche d’âge",
  "testCatalog.header.criticalRange": "Plage critique",
  "testCatalog.header.field": "Champ",
  "testCatalog.header.gender": "Sexe",
  "testCatalog.header.normalRange": "Valeurs normales ",
  "testCatalog.header.reportingRange": "Plage de rendu ",
  "testCatalog.header.validRange": "Plage valide",
  "testCatalog.header.value": "Valeur",
  "admin.testCatalog.methods.title": "Méthodes",
  "admin.testCatalog.methods.column.name": "Nom de la méthode",
  "admin.testCatalog.methods.column.code": "Code Emplacement",
  "admin.testCatalog.methods.column.default": "Default",
  "admin.testCatalog.methods.column.effectiveDate": "Date d'entrée en vigueur",
  "admin.testCatalog.methods.column.actions": "Actions",
  "admin.testCatalog.methods.action.edit": "Modifier",
  "admin.testCatalog.methods.action.remove": "Retirer",
  "admin.testCatalog.methods.btn.linkMethod": "+ Méthode « Associer »",
  "admin.testCatalog.methods.btn.createMethod": "+ Créer une nouvelle méthode",
  "admin.testCatalog.methods.btn.copyFromTest": "Copier de « Test »",
  "admin.testCatalog.methods.modal.link.title": "Méthode d'association",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Sélectionnez une méthode pour associer",
  "admin.testCatalog.methods.modal.link.noAvailable": "Toutes les méthodes actives sont déjà associées",
  "admin.testCatalog.methods.inline.nameEnglish": "Nom de la méthode (en Anglais)",
  "admin.testCatalog.methods.inline.nameFrench": "Nom de la méthode (en français)",
  "admin.testCatalog.methods.inline.code": "Code court",
  "admin.testCatalog.methods.inline.codeHint": "3 à 10 caractères alphanumériques en majuscules, sans espaces",
  "admin.testCatalog.methods.inline.createAndLink": "Créer et associer",
  "admin.testCatalog.methods.copyFromTest.label": "Copier les méthodes du test",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Sélectionnez le test source",
  "admin.testCatalog.methods.effectiveDate.label": "Date d'entrée en vigueur",
  "admin.testCatalog.methods.default.label": "Définir comme valeur par défaut",
  "admin.testCatalog.methods.error.duplicateLink": "Cette méthode est déjà associée à l’analyse",
  "admin.testCatalog.methods.error.codeFormat": "Le code doit comporter entre 3 et 10 caractères alphanumériques en majuscules, sans espaces.",
  "admin.testCatalog.methods.error.effectiveDateRequired": "La date d'entrée en vigueur est obligatoire",
  "admin.testCatalog.methods.error.duplicateCode": "Une méthode avec ce code existe déjà. Saisissez un autre code.",
  "admin.testCatalog.methods.error.duplicateName": "Une méthode portant ce nom existe déjà. Utilisez un autre nom ou associez la méthode existante.",
  "admin.testCatalog.methods.error.invalidRequest": "La demande a été refusée. Vérifiez les champs et réessayez.",
  "admin.testCatalog.methods.error.server": "Le serveur n'a pas pu traiter la demande. Réessayez.",
  "admin.testCatalog.methods.error.removeFailed": "La méthode n'a pas pu être retirée. Elle est encore associée ; réessayez.",
  "admin.testCatalog.methods.linked": "Méthode associée.",
  "admin.testCatalog.methods.created": "Méthode créée et associée.",
  "admin.testCatalog.methods.copied": "Depuis {source} : {count, plural, one {# méthode copiée} other {# méthodes copiées}}.",
  "admin.testCatalog.methods.copyNothing": "Aucune méthode copiée : {source} n'a aucune méthode qui ne soit pas déjà associée à cette analyse.",
  "admin.testCatalog.methods.empty": "Aucune méthode n'est associée. Utilisez « + Associer une méthode » ou « + Créer une nouvelle méthode » pour en ajouter une.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Nom du test pour lequel cela est",
  "testnotification.instructionis.variables.body.0": "[testResult] : Résultat du test",
  "testnotification.instructionis.variables.header": "Liste des variables :",
  "testnotification.instructions.body": "Lorsqu'une notification est créée, elle vérifiera d'abord si un modèle de message est défini pour le destinataire/type de message.",
  "testnotification.instructions.body.0": "S'il n'en existe pas, elle utilisera le message par défaut du test.",
  "testnotification.instructions.body.1": "Si cela n'existe pas, elle utilisera le message par défaut du système.",
  "testnotification.instructions.body.2": "Les variables seront remplacées par leurs valeurs correspondantes dans le corps du message et l'objet.",
  "testnotification.instructions.body.3": "Les variables doivent toujours être entre crochets et ne doivent pas contenir d'espaces.",
  "testnotification.instructions.header": "Instructions",
  "testnotification.messagetemplate": "Message",
  "testnotification.options": "Messages individuels",
  "testnotification.patient.email": "E-mail du patient",
  "testnotification.patient.sms": "SMS du patient",
  "testnotification.patiententry.header": "Rapport de résultats",
  "testnotification.patiententry.info": "Si OpenELIS n'est pas en mesure de se connecter au destinataire des résultats transmis, il les mettra en file d'attente. Une file d'attente grande et croissante est un signe qu'il faut entreprendre des actions correctives, y compris contacter la partie réceptrice.",
  "testnotification.provider.email": "E-mail du prestataire",
  "testnotification.provider.sms": "SMS du prestataire",
  "testnotification.subjecttemplate": "Objet",
  "testnotification.systemdefault.template": "Message par défaut du système",
  "testnotification.testdefault.editIcon": "Modifier la notification de test",
  "testnotification.testdefault.template": "Message par défaut pour le test",
  "testnotificationconfig.browse.title": "Page des notifications",
  "tests.not.assigned": "Tests non assignés",
  "testsection.testSectionName": "Nom de la section de test",
  "testUnit.existing": "Unités de test existantes",
  "testUnit.existing.inactive": "Unités de test inactives. Attribuer des tests pour les activer",
  "testUnit.new": "Nouvelle unité de tests",
  "text.length.max": "La longueur du texte ne doit pas dépasser 200",
  "title.notestfoundmatching": "Aucun test trouvé correspondant",
  "to.title": "À",
  "tooltip.banner.menu.generic.sample.results": "Saisir les résultats des tests pour les échantillons génériques",
  "tooltip.banner.menu.workplan.batch": "Plan de travail par lot",
  "total.quantity": "Quantité totale",
  "transaction.date": "Date",
  "transaction.quantity": "Quantité",
  "transaction.type": "Type",
  "transaction.user": "Utilisateur",
  "true.label": "Vrai",
  "unifiedSystemUser.add.user": "Ajouter un utilisateur",
  "unifiedSystemUser.browser.button.add": "Ajouter un nouvel utilisateur",
  "unifiedSystemUser.browser.search": "Recherche par noms d'utilisateurs",
  "unifiedSystemUser.browser.search.placeholder": "Recherche par noms d'utilisateurs...",
  "unifiedSystemUser.browser.title": "Gestion des utilisateurs",
  "unifiedSystemUser.edit.user": "Modifier l'utilisateur",
  "unifiedSystemUser.select": "Sélectionner",
  "unknown.section": "Section inconnue",
  "unknown.test": "Test inconnu",
  "uom.browse.title": "Unité de mesure",
  "uom.create.heading.confirmation": "Confirmation",
  "uom.existing": "Unité de mesure actuelle",
  "uom.existing.inactive": "Unité de mesure inactive. Assignez des tests à cette unité de mesure pour l’activer.",
  "uom.new": "Créer une nouvelle unité de mesure",
  "uom.new.added": "Une nouvelle unité de mesure sera ajoutée",
  "uom.notification.duplicate": "L’unité de mesure existe déjà",
  "uom.notification.save": "La nouvelle unité de mesure a été enregistrée.",
  "uom.uomName": "Nom de l'unité de mesure",
  "training.installation.message": "Environnement de formation ",
  "translation.edit.title": "Modifier les traductions",
  "translation.export": "Exporter en CSV",
  "translation.export.success": " Traductions exportées avec succès",
  "translation.fallback": "Valeur de repli (anglais) ",
  "translation.management.description": "Voir et modifier les traductions des métadonnées",
  "translation.management.title": "Gestion des traductions",
  "translation.missing": "Manquant",
  "translation.search": "Rechercher des traductions…",
  "translation.selectLocale": "Sélectionner la langue ",
  "translation.showMissing": "Afficher uniquement les éléments manquants",
  "translation.stats.title": "Progression des traductions",
  "translation.stats.total": "Nombre total d’entrées : {count}",
  "translation.update.error": "Échec de la mise à jour de la traduction",
  "translation.update.success": "Traduction mise à jour avec succès",
  "translation.value": "Traduction",
  "usage.analysisId": "Identifiant de l'analyse",
  "usage.date": "Date d’utilisation",
  "usage.error.quantityPositive": "La quantité doit être supérieure à 0",
  "usage.fefo.note": "La quantité est déduite du lot de cet article ayant réussi le CQ et expirant le plus tôt (FEFO), qui peut ne pas être le lot à partir duquel vous avez ouvert cette fenêtre.",
  "usage.item": "Élément",
  "usage.notes": "Notes",
  "usage.notes.placeholder": "Ajoutez toute note concernant cette utilisation",
  "usage.quantityUsed": "Quantité utilisée",
  "usage.quantityUsed.helper": "Saisissez le nombre d'unités utilisées ",
  "usage.record.button": "Enregistrement en cours",
  "usage.record.error": "Erreur lors de l'enregistrement de l'utilisation",
  "usage.record.success": "Enregistrée avec succès",
  "usage.record.title": "Enregistrement le matériels utilisé  ",
  "usage.testResultId": "ID du résultat du test (facultatif)",
  "usage.testResultId.placeholder": "Lien vers le résultat du test pour la traçabilité",
  "user.select.instruction": "Sélectionnez un utilisateur à modifier ou à désactiver. Vous pouvez définir un filtre, rechercher des utilisateurs ou ajouter un utilisateur à l'aide des contrôles en haut.",
  "validation.accept.all": "Enregistrer tous les résultats",
  "validation.accept.normal": "Enregistrer tous les normals",
  "validation.field.required": "Ce champ est requis",
  "validation.ignore.all": "Ignorer tous les résultats",
  "validation.label.nonconform": "= L'échantillon ou la commande est non conforme ou le test a été rejeté",
  "validation.legend.qcHold": "= Un contrôle qualité couvrant ce résultat a échoué ; la non-conformité est toujours ouverte",
  "validation.qcHold.tooltip": "Une série de contrôles pour cette analyse dans cette unité de laboratoire a échoué. Vérifiez la non-conformité avant de libérer ce résultat.",
  "validation.password.match": "Les mots de passe doivent correspondre",
  "validation.password.minLength": "Le mot de passe doit contenir au moins 7 caractères ",
  "validation.password.notSameAsOld": "Le nouveau mot de passe ne doit pas être identique à l’ancien",
  "validation.password.specialChar": "Le mot de passe doit contenir au moins un caractère spécial (*$#!) et une lettre majuscule ",
  "validation.no.records.display": "Aucun enregistrement trouvé",
  "validation.reject.all": "Rejeter tous les résultats",
  "validation.save.error": "Validation enregistrée avec succès",
  "validation.save.success": "Validation enregistrée avec succès",
  "validation.search.noresult": "Aucun résultat trouvé pour la validation",
  "validation.search.noresult.analyser": "Aucun résultat trouvé à partir de :",
  "vl.arvRegimen": "Régime ARV",
  "vl.durationOnARV": "Durée sous ARV (mois) ",
  "vl.durationOnARV.placeholder": "Saisir le nombre de mois de traitement",
  "vl.indication": "Indication du test de charge virale ",
  "vl.lastVLDate": "Date du dernier résultat de charge virale",
  "vl.lastVLResult": "Dernier résultat de charge virale (copies/mL) ",
  "vl.lastVLResult.placeholder": "ex. 150",
  "vl.pregnancyStatus": "Statut grossesse / allaitement ",
  "workplan.batch.action.activate": "Activer",
  "workplan.batch.action.archive": "Archives",
  "workplan.batch.action.complete": "Terminé",
  "workplan.batch.batches": "Lots",
  "workplan.batch.batches.empty": "Aucun lot trouvé",
  "workplan.batch.column.actions": "Actions",
  "workplan.batch.column.count": "Analyses",
  "workplan.batch.column.created": "Créé",
  "workplan.batch.column.method": "Méthodes",
  "workplan.batch.column.name": "Lot",
  "workplan.batch.column.sampleType": "Type d'échantillon",
  "workplan.batch.column.status": "Statut",
  "workplan.batch.column.test": "Test",
  "workplan.batch.column.unit": "Unité",
  "workplan.batch.create": "Créer un lot ({count})",
  "workplan.batch.create.error": "Le lot n'a pas pu être créé",
  "workplan.batch.create.success": "Lot créé",
  "workplan.batch.pending.empty": "Aucune analyse en attente trouvée",
  "workplan.batch.pendingTests": "Analyses en attente",
  "workplan.batch.refresh": "Actualiser",
  "workplan.batch.selectPage": "Sélectionner la page",
  "workplan.batch.selectTest": "Sélectionner {accessionNumber}",
  "workplan.batch.status.ACTIVE": "Active",
  "workplan.batch.status.ARCHIVED": "Archivé",
  "workplan.batch.status.COMPLETED": "Terminé",
  "workplan.batch.status.DRAFT": "Brouillon",
  "workplan.batch.status.error": "Le statut du lot n'a pas pu être mis à jour",
  "workplan.batch.status.success": "Statut du lot mis à jour",
  "workplan.batch.tabs": "Onglets du plan de travail par lot",
  "workplan.batch.title": "Plan de travail par lot",
  "workplan.page.title": "Plan de Travail {0}",
  "workplan.panel.selection.error.msg": "Sélection du panneau invalide.",
  "workplan.panel.title": "Plan de Travail par Panel",
  "workplan.panel.types": "Panel",
  "workplan.print": "Imprimer Plan de Travail",
  "workplan.priority.list": "Priorité",
  "workplan.priority.title": "Plan de travail par priorité",
  "workplan.run": "Rechercher",
  "workplan.test.title": "Plan de Travail par Test",
  "workplan.test.types": "Test",
  "workplan.title": "Plan de Travail",
  "workplan.unit.title": "Plan de travail par unité",
  "workplan.unit.types": "Unité",
  "yes.option": "Yes",
  "shipment.module.title": "Gestion des expéditions",
  "shipment.breadcrumb": "Expédition d'échantillons",
  "shipment.nav.dashboard": "Tableau de bord",
  "shipment.nav.createBox": "Créer une boîte",
  "shipment.nav.receiveBox": "Recevoir une boîte",
  "shipment.dashboard.title": "Tableau de bord des expéditions",
  "shipment.dashboard.description": "Gérer les boîtes d'expédition et suivre les échantillons référés",
  "shipment.dashboard.tabs.shipments": "Expéditions",
  "shipment.dashboard.tabs.unassigned": "Analyses non assignées",
  "shipment.tab.boxes": "Boîtes d'expédition",
  "shipment.tab.unassignedSamples": "Échantillons non assignés",
  "shipment.label.boxId": "ID de la boîte",
  "shipment.label.createdDate": "Date de création",
  "shipment.label.daysUnassigned": "Jours non assignés",
  "shipment.label.destination": "Destination",
  "shipment.label.priority": "Priorité",
  "shipment.label.referralTest": "Analyse référée",
  "shipment.label.sampleCount": "Nombre d'échantillons",
  "shipment.label.state": "État",
  "shipment.label.tests": "Analyses",
  "shipment.filter.state": "Filtrer par état",
  "shipment.filter.facility": "Filtrer par établissement",
  "shipment.action.addSelected": "Ajouter les éléments sélectionnés",
  "shipment.action.addToBox": "Ajouter à la boîte",
  "shipment.action.cancelReferral": "Annuler la référence",
  "shipment.action.confirmRejection": "Confirmer le rejet",
  "shipment.action.createBox": "Créer une nouvelle boîte",
  "shipment.action.markAsLost": "Marquer comme perdu",
  "shipment.action.printManifest": "Imprimer le bordereau",
  "shipment.action.rejectSample": "Rejeter l'échantillon",
  "shipment.action.saveAndMarkReady": "Enregistrer et marquer prêt à envoyer",
  "shipment.action.saveBox": "Enregistrer la boîte",
  "shipment.action.saveDraft": "Enregistrer comme brouillon",
  "shipment.action.scanSample": "Scanner l'échantillon",
  "shipment.box.addSample": "Ajouter un échantillon",
  "shipment.box.addSampleDescription": "Sélectionner les échantillons à ajouter à cette boîte d'expédition",
  "shipment.box.addSamples": "Ajouter des échantillons",
  "shipment.box.details": "Détails du coffret",
  "shipment.box.autoGenerate": "Générer automatiquement",
  "shipment.box.capacity": "Capacité",
  "shipment.box.capacityValue": "{capacity} échantillons",
  "shipment.box.create": "Créer une boîte",
  "shipment.box.createDescription": "Créer une nouvelle boîte d'expédition pour les échantillons référés",
  "shipment.box.created": "Date de création :",
  "shipment.box.createdBy": "Créé par :",
  "shipment.box.createdDate": "Date de création",
  "shipment.box.destination": "Destination",
  "shipment.box.downloadLabel": "Télécharger l'étiquette",
  "shipment.box.downloadManifest": "Télécharger le bordereau",
  "shipment.box.generateLabel": "Générer l'étiquette",
  "shipment.box.generateManifest": "Générer le bordereau",
  "shipment.box.id": "ID de boîte :",
  "shipment.box.labelDownloaded": "Étiquette téléchargée avec succès",
  "shipment.box.labelPrefix": "Préfixe d'étiquette",
  "shipment.box.labelPrefixHelper": "Configuré par l'administrateur dans les paramètres du site",
  "shipment.box.manifest": "Bordereau",
  "shipment.box.manifestDownloaded": "Bordereau téléchargé avec succès",
  "shipment.box.noSamples": "Cette boîte ne contient pas encore d'échantillons",
  "shipment.box.noUnassignedSamples": "Aucun échantillon non assigné trouvé pour cet établissement",
  "shipment.box.notes": "Notes",
  "shipment.box.notesPlaceholder": "Saisir les instructions spéciales de manipulation ou les notes...",
  "shipment.box.number": "Numéro de boîte",
  "shipment.box.readyConfirmation": "Êtes-vous sûr de vouloir marquer cette boîte comme prête à envoyer ?",
  "shipment.box.readySampleCount": "Cette boîte contient {count} échantillon(s)",
  "shipment.box.readyToSend": "Marquer prêt à envoyer",
  "shipment.box.reconcile": "Rapprocher",
  "shipment.box.removeSample": "Retirer l'échantillon",
  "shipment.box.removeSampleConfirmation": "Êtes-vous sûr de vouloir retirer cet échantillon de la boîte ?",
  "shipment.box.resendManifest": "Renvoyer le bordereau",
  "shipment.box.sampleCount": "Nombre d'échantillons",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} restant(s))",
  "shipment.box.samplesAdded": "Échantillons ajoutés",
  "shipment.box.samplesSelected": "{count} échantillon(s) sélectionné(s)",
  "shipment.box.scanExisting": "Scanner un existant",
  "shipment.box.scanExistingId": "Scanner ou saisir l'ID de boîte existant",
  "shipment.box.scanExistingIdPlaceholder": "Scanner le code-barres ou saisir l'ID de boîte",
  "shipment.box.sendBox": "Envoyer la boîte",
  "shipment.box.sendConfirmation": "Êtes-vous sûr de vouloir envoyer cette boîte ?",
  "shipment.box.sendSampleCount": "Cette boîte contient {count} échantillon(s) qui seront marqué(s) comme envoyé(s)",
  "shipment.box.state": "État",
  "shipment.box.summary": "Résumé",
  "shipment.box.temperature": "Exigence de température",
  "shipment.box.title": "Boîte {boxId}",
  "shipment.box.useExistingId": "Mode ID de boîte",
  "shipment.dashboard.boxNotFound": "Aucune boîte trouvée avec l'ID \"{boxId}\". Essayez de filtrer la liste à la place.",
  "shipment.dashboard.scanBoxPlaceholder": "Rechercher ou scanner l'ID de boîte (appuyez sur Entrée pour naviguer)",
  "shipment.error.addSample": "Échec de l'ajout de l'échantillon à la boîte",
  "shipment.error.assignToBox": "Échec de l'assignation de l'échantillon à la boîte",
  "shipment.error.boxFull": "La boîte est pleine. Impossible d'ajouter plus d'échantillons.",
  "shipment.error.boxNotEmpty": "La boîte doit contenir au moins un échantillon",
  "shipment.error.boxNotFound": "Boîte introuvable",
  "shipment.error.cancelReferral": "Échec de l'annulation de la référence",
  "shipment.error.confirmReception": "Échec de la confirmation de réception",
  "shipment.error.createBox": "Échec de la création de la boîte d'expédition",
  "shipment.error.exceedsCapacity": "Impossible d'ajouter {requested} échantillon(s). Seulement {available} emplacement(s) disponible(s).",
  "shipment.error.fetchBox": "Échec de la récupération des informations de la boîte",
  "shipment.error.fetchBoxes": "Échec de la récupération des boîtes disponibles",
  "shipment.error.generateLabel": "Erreur lors de la génération de l'étiquette d'expédition",
  "shipment.error.generateManifest": "Erreur lors de la génération du bordereau",
  "shipment.error.invalidState": "État de boîte invalide pour cette opération",
  "shipment.error.markAsLost": "Échec du marquage de l'échantillon comme perdu",
  "shipment.error.markReady": "Échec du marquage de la boîte comme prête à envoyer",
  "shipment.error.noDestinationFacility": "Aucun établissement de destination spécifié pour cet échantillon",
  "shipment.error.noReferralId": "Aucun ID de référence disponible pour cet échantillon",
  "shipment.error.noSampleSelected": "Veuillez sélectionner au moins un échantillon",
  "shipment.error.partialReception": "Certaines mises à jour de statut d'échantillons ont échoué. Veuillez réessayer SVP.",
  "shipment.error.partialSampleAdd": "Seuls {added} échantillons sur {total} ont été ajoutés à la boîte. Elle a été laissée en brouillon pour que vous puissiez ajouter les autres.",
  "shipment.error.reasonRequired": "Veuillez fournir un motif SVP",
  "shipment.error.reconcile": "Erreur lors du rapprochement de la boîte",
  "shipment.error.removeSample": "Échec du retrait de l'échantillon de la boîte",
  "shipment.error.sampleAlreadyAssigned": "Cet échantillon est déjà assigné à une boîte",
  "shipment.error.sampleAlreadyInBox": "Échantillon déjà dans la boîte",
  "shipment.error.sampleNotFound": "Échantillon introuvable",
  "shipment.error.saveFailed": "Échec de l'enregistrement",
  "shipment.error.searchFailed": "Échec de la recherche de l'échantillon. Veuillez réessayer SVP.",
  "shipment.error.selectBox": "Veuillez sélectionner une boîte SVP",
  "shipment.error.sendBox": "Échec de l'envoi de la boîte",
  "shipment.filter.clear": "Effacer les filtres",
  "shipment.filter.dateFrom": "Date de début",
  "shipment.filter.dateTo": "Date de fin",
  "shipment.filter.referenceLab": "Laboratoire de référence",
  "shipment.label.addedDate": "Date d'ajout",
  "shipment.label.position": "Position",
  "shipment.label.samples": "Échantillons",
  "shipment.label.shippingLabel": "ÉTIQUETTE D'EXPÉDITION",
  "shipment.manifest.generated": "Généré le :",
  "shipment.manifest.number": "N°",
  "shipment.manifest.recallExpired": "Le rappel du bordereau n'est plus disponible (délai de 7 jours dépassé depuis l'envoi)",
  "shipment.manifest.regenerationExpired": "La régénération du bordereau n'est plus disponible (délai de 24 heures dépassé depuis l'envoi)",
  "shipment.manifest.serviceLocation": "Lieu de service :",
  "shipment.manifest.specimenBarcodes": "Codes-barres des spécimens",
  "shipment.manifest.title": "Bordereau d'expédition",
  "shipment.manifest.totalSamples": "Total des échantillons :",
  "shipment.modal.addToBox.existingBox": "Ajouter à une boîte existante",
  "shipment.modal.addToBox.mode": "Sélectionner une option",
  "shipment.modal.addToBox.newBox": "Créer une nouvelle boîte",
  "shipment.modal.addToBox.newBoxInfo.message": "Vous serez redirigé pour créer une nouvelle boîte pour cet échantillon",
  "shipment.modal.addToBox.newBoxInfo.title": "Créer une nouvelle boîte",
  "shipment.modal.addToBox.noDraftBoxes.message": "Aucune boîte brouillon trouvée pour cette destination. Une nouvelle boîte sera créée.",
  "shipment.modal.addToBox.noDraftBoxes.title": "Aucune boîte brouillon disponible",
  "shipment.modal.addToBox.selectBox": "Sélectionner une boîte",
  "shipment.modal.addToBox.title": "Ajouter un échantillon à la boîte",
  "shipment.modal.cancelReferral.reason": "Motif de l'annulation",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Veuillez expliquer pourquoi cette référence est annulée...",
  "shipment.modal.cancelReferral.title": "Annuler la référence",
  "shipment.modal.cancelReferral.warning.message": "Cette action annulera définitivement la référence et ne peut pas être annulée.",
  "shipment.modal.cancelReferral.warning.title": "Avertissement",
  "shipment.modal.createBox.cancel": "Annuler",
  "shipment.modal.createBox.submit": "Créer",
  "shipment.modal.createBox.title": "Créer une nouvelle boîte",
  "shipment.modal.markAsLost.reason": "Motif du marquage comme perdu",
  "shipment.modal.markAsLost.reasonPlaceholder": "Veuillez expliquer pourquoi cet échantillon est marqué comme perdu...",
  "shipment.modal.markAsLost.title": "Marquer l'échantillon comme perdu",
  "shipment.modal.markAsLost.warning.message": "Cette action marquera définitivement l'échantillon comme perdu et ne peut pas être annulée.",
  "shipment.modal.markAsLost.warning.title": "Avertissement",
  "shipment.modal.rejectSample": "Rejeter l'échantillon",
  "shipment.modal.rejectSampleMessage": "Êtes-vous sûr de vouloir rejeter l'échantillon {accession} ?",
  "shipment.nav.referenceLabResults": "Résultats d'analyses de laboratoire de référence",
  "shipment.nav.reports": "Rapports",
  "shipment.nav.settings": "Paramètres",
  "shipment.notification.boxCreated": "Boîte créée avec succès",
  "shipment.notification.boxReadyToSend": "Boîte marquée comme prête à envoyer",
  "shipment.notification.boxReconciled": "La boîte a été rapprochée avec succès",
  "shipment.notification.boxSent": "Boîte envoyée avec succès",
  "shipment.notification.error": "Une erreur est survenue : {message}",
  "shipment.notification.partialSamplesAdded": "Seulement {added} sur {total} échantillons ajoutés. Capacité de la boîte atteinte ({notAdded} non ajouté(s)).",
  "shipment.notification.receptionComplete": "Expédition reçue avec succès",
  "shipment.notification.referralCancelled": "Référence annulée avec succès",
  "shipment.notification.sampleAdded": "Échantillon {accessionNumber} ajouté avec {testCount, plural, one {# analyse} other {# analyses}}",
  "shipment.notification.sampleAssignedToBox": "Échantillon assigné à la boîte avec succès",
  "shipment.notification.sampleMarkedAsLost": "Échantillon marqué comme perdu",
  "shipment.notification.sampleRejected": "Échantillon {accession} rejeté : {reason}",
  "shipment.notification.sampleRemoved": "Échantillon retiré de la boîte",
  "shipment.notification.samplesAdded": "{count, plural, one {# sample added to box} many {# samples added to box} other {# échantillons ajoutés à la boîte}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} échantillon(s) retiré(s) en raison de la réduction de capacité.",
  "shipment.reception.acceptSample": "Valider l'échantillon",
  "shipment.reception.applyToAll": "Appliquer le statut à tous...",
  "shipment.reception.awaitingAcceptance": "En attente de validation",
  "shipment.reception.confirmMessage": "Confirmer la réception de {count} échantillon(s) ?",
  "shipment.reception.confirmReception": "Confirmer la réception",
  "shipment.reception.damaged": "Endommagé",
  "shipment.reception.description": "Scanner le code-barres de la boîte pour recevoir et vérifier les échantillons",
  "shipment.reception.enterBoxId": "Veuillez saisir un ID de boîte",
  "shipment.reception.generalNotes": "Notes générales",
  "shipment.reception.generalNotesPlaceholder": "Saisir les notes de réception générales",
  "shipment.reception.importError": "Erreur lors de l'importation des expéditions depuis le serveur distant",
  "shipment.reception.importFromFhir": "Importer depuis FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {Aucune nouvelle expédition trouvée} one {1 expédition importée} other {{count} expéditions importées}}",
  "shipment.reception.incomingBoxes": "Expéditions entrantes",
  "shipment.reception.leaked": "Fuité",
  "shipment.reception.markAllMissing": "Tout marquer comme manquant",
  "shipment.reception.markAllReceived": "Tout marquer comme reçu",
  "shipment.reception.missing": "Manquant",
  "shipment.reception.noIncomingBoxes": "Aucune expédition n'est en cours de réception. Cliquez sur « Importer depuis FHIR » pour vérifier s'il y a de nouvelles expéditions.",
  "shipment.reception.notes": "Notes",
  "shipment.reception.notesPlaceholder": "Saisir les notes si nécessaire",
  "shipment.reception.notesRequired": "Les notes sont obligatoires pour les échantillons non reçus en bon état",
  "shipment.reception.notesRequiredPlaceholder": "Obligatoire : décrivez le problème",
  "shipment.reception.openBox": "Ouvert",
  "shipment.reception.originFacility": "From",
  "shipment.reception.pending": "En attente",
  "shipment.reception.pendingAcceptance": "Échantillons en attente de validation",
  "shipment.reception.received": "Reçu",
  "shipment.reception.referralOrder": "Ordonnance de renvoi",
  "shipment.reception.rejected": "Rejeté",
  "shipment.reception.sampleCountSummary": "{accepted} accepté / {expected} attendu",
  "shipment.reception.sampleNotFound": "Échantillon {accessionNumber} introuvable dans cette boîte",
  "shipment.reception.sampleScanned": "Échantillon {accessionNumber} enregistré comme reçu",
  "shipment.reception.sampleVerification": "Vérification des échantillons",
  "shipment.reception.scanBox": "ID de boîte / Code-barres",
  "shipment.reception.scanBoxPlaceholder": "Scanner ou saisir le code-barres de la boîte",
  "shipment.reception.scanButton": "Scanner la boîte",
  "shipment.reception.scanSample": "Scanner l'ID de l'échantillon",
  "shipment.reception.scanSampleButton": "Enregistrer l'échantillon",
  "shipment.reception.scanSamplePlaceholder": "Scanner ou saisir le numéro d'enregistrement de l'échantillon",
  "shipment.reception.shipped": "Expédiés",
  "shipment.reception.specimen": "Échantillon",
  "shipment.reception.status": "Statut de réception",
  "shipment.reception.title": "Recevoir l'expédition",
  "shipment.reception.unresolved": "Aucune commande correspondante",
  "shipment.rejection.damaged": "Endommagé",
  "shipment.rejection.expired": "Expiré",
  "shipment.rejection.insufficientVolume": "Volume insuffisant",
  "shipment.rejection.other": "Autre",
  "shipment.rejection.reason": "Motif du rejet",
  "shipment.rejection.wrongType": "Mauvais type d'échantillon",
  "shipment.report.contents": "Contenu",
  "shipment.report.description": "Générer et exporter des rapports d'expédition par boîte, date, destination ou laboratoire de référence",
  "shipment.report.export.excel": "Exporter en Excel",
  "shipment.report.export.pdf": "Exporter en PDF",
  "shipment.report.generate": "Générer le rapport",
  "shipment.report.noResults": "Aucun enregistrement d'expédition trouvé pour les filtres sélectionnés",
  "shipment.report.receivedDate": "Date de réception",
  "shipment.report.receivedStatus": "Statut de réception",
  "shipment.report.receiver": "Destinataire",
  "shipment.report.receivingUser": "Utilisateur récepteur",
  "shipment.report.sender": "Expéditeur",
  "shipment.report.sentDate": "Date d'envoi",
  "shipment.report.title": "Rapports d'expédition",
  "shipment.report.totalBoxes": "Total des boîtes",
  "shipment.report.totalSamples": "Total des échantillons",
  "shipment.sample.accessionNumber": "Numéro d'enregistrement",
  "shipment.sample.multipleMatches": "Plusieurs échantillons correspondent — sélectionnez celui que vous souhaitez ajouter",
  "shipment.sample.remove": "Retirer",
  "shipment.sample.search": "Rechercher un échantillon par numéro d'enregistrement",
  "shipment.sample.searchPlaceholder": "Scanner ou saisir le numéro d'enregistrement",
  "shipment.sample.status": "Statut",
  "shipment.sample.type": "Type d'échantillon",
  "shipment.settings.administration": "Administration",
  "shipment.settings.boxLabelSection": "Configuration des étiquettes de boîte",
  "shipment.settings.description": "Configurer les paramètres du module d'expédition",
  "shipment.settings.fhirConfig": "Options de mappage FHIR",
  "shipment.settings.fhirConfigDesc": "Configurer le mappage SupplyDelivery et les types de conteneurs de spécimens pour l'interopérabilité FHIR",
  "shipment.settings.fhirConfigNote": "Le mappage FHIR est configuré via les propriétés de l'application. Contactez votre administrateur système pour les modifications.",
  "shipment.settings.fhirConfigSaveError": "Erreur lors de l'enregistrement de la configuration du mappage FHIR",
  "shipment.settings.fhirConfigSaved": "Configuration du mappage FHIR enregistrée",
  "shipment.settings.fhirContainerType": "Type de conteneur de spécimen (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Nom d'affichage",
  "shipment.settings.fhirNonConformity": "Codes de non-conformité (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "Code SNOMED CT",
  "shipment.settings.manageFacilities": "Gérer le registre des établissements",
  "shipment.settings.manageFacilitiesDesc": "Ajouter, modifier ou supprimer des destinations de laboratoires de référence",
  "shipment.settings.manageUsers": "Gérer les utilisateurs",
  "shipment.settings.manageUsersDesc": "Configurer les comptes utilisateurs et les rôles pour le module d'expédition",
  "shipment.settings.prefixHelperText": "Préfixe utilisé lors de la génération de nouveaux ID de boîte (ex. : BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Aperçu : {preview}",
  "shipment.settings.prefixRequired": "Le préfixe d'étiquette de boîte est obligatoire",
  "shipment.settings.prefixSaveError": "Erreur lors de l'enregistrement du préfixe d'étiquette de boîte",
  "shipment.settings.prefixSaved": "Préfixe d'étiquette de boîte enregistré avec succès",
  "shipment.settings.siteOrgDescription": "Sélectionnez l'organisation qui représente ce laboratoire. Seules les expéditions destinées à cette organisation seront importées depuis les serveurs FHIR distants.",
  "shipment.settings.siteOrgLabel": "Ce laboratoire",
  "shipment.settings.siteOrgSaveError": "Erreur lors de l'enregistrement de l'organisation du site",
  "workflow.clinical": "Clinique",
  "workflow.environmental": "Environnemental / Autre",
  "provider.name": "Nom du prescripteur",
  "provider.name.placeholder": "Saisir le nom du prestataire",
  "provider.phone": "Téléphone du prescripteur",
  "provider.search.helper": "Saisir le nom ou le numéro de téléphone du prescripteur et appuyer sur Rechercher.",
  "site.search": "Recherche de site",
  "site.name": "Nom du site",
  "site.name.placeholder": "Saisir le nom du site",
  "site.location": "Emplacement",
  "site.type": "Type",
  "site.department": "Département / Service / Unité",
  "site.department.selectFirst": "Sélectionner d'abord un établissement...",
  "site.department.choose": "Veuillez sélectionner un service...",
  "site.department.none": "Aucune sous-unité disponible",
  "sample.filterByLabUnit": "Filtrer par unité de laboratoire",
  "sample.allLabUnits": "Toutes les unités de laboratoire",
  "sample.orderPanels": "Panels de demande d'examen",
  "sample.orderTests": "Analyses de la demande d'examen",
  "sample.referToReferenceLab": "Référer l'analyse à un laboratoire de référence",
  "sample.optional.info": "La sélection de l'échantillon et de l'analyse est facultative à cette étape. Les analyses et le type d'échantillon peuvent être spécifiés ultérieurement lors de la collecte.",
  "panel.search.placeholder": "Choisir un panel disponible",
  "test.search.placeholder": "Choisir une analyse disponible",
  "test.timeHolding": "Durée maximale de maintien selon la procédure standard (minutes)",
  "select.regimen": "Sélectionner un régime...",
  "select": "Sélectionner...",
  "generating": "Génération en cours...",
  "label.order": "Étiquette de la demande d'examen",
  "label.sample": "Étiquette d'échantillon",
  "label.slide": "Étiquette de lame",
  "label.block": "Étiquette de bloc",
  "label.freezer": "Étiquette de congélateur",
  "environmental.coming.soon": "Flux de travail environnemental",
  "environmental.location.info": "Les champs de hiérarchie de localisation (Région/District/Ville-Village) et la capture GPS seront disponibles ici.",
  "env.collectionConditions.title": "Conditions de prélèvement par défaut",
  "env.collectionConditions.subtitle": "Les paramètres par défaut ont été appliqués à tous les échantillons de ce lot.",
  "env.collectionMethod": "Méthode de prélèvement ",
  "env.waterTemp": "Température de l'eau (°C)",
  "env.ambientTemp": "Température ambiante (°C)",
  "env.weather": "Météo",
  "env.preservationMethod": "Méthode de conservation",
  "env.preservationMethod.placeholder": "par exemple, acidification à l'HNO₃, refroidisseur à 4 °C",
  "env.fieldNotes": "Notes de terrain",
  "env.fieldNotes.placeholder": "Saisissez vos observations sur le terrain...",
  "env.sample.manifest.title": "Bordereau par échantillon",
  "env.sample.manifest.subtitle": "une ligne = un échantillon physique",
  "env.sample.container": "Conteneur",
  "env.sample.gpsLat": "Latitude GPS",
  "env.sample.gpsLat.placeholder": "par exemple : -6,2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "par exemple : 106,8456",
  "env.sample.samplingSite": "Site de prélèvement",
  "env.sample.useOrderSite": "Utiliser le site de la demande {site}",
  "order.microPreview.site": "Site : {site}",
  "env.sample.locationDetails": "Détails sur l'emplacement",
  "env.sample.locationDetails.placeholder": "par exemple : Inlet, Bank...",
  "env.sample.collected": "Prélevé",
  "env.sample.duplicate": "Échantillon en double",
  "env.sample.addRow": "+ Ajouter un échantillon",
  "env.sample.total": "Total : {count} {count, plural, one {échantillon} other {échantillons}} dans ce lot",
  "env.sample.testsAndPanels": "Analyses et panels",
  "env.sample.tests.required": "obligatoire",
  "env.complianceStandards.title": "Normes de conformité applicables",
  "env.complianceStandards.subtitle": "Veuillez sélectionner les normes réglementaires applicables à cette commande.",
  "env.complianceStandards.label": "Norme de conformité",
  "env.complianceStandards.placeholder": "Sélectionnez des normes...",
  "env.complianceStandards.empty": "Aucune norme de conformité active n'est configurée. Veuillez les ajouter dans Administration → Normes de conformité.",
  "order.dashboard.samplingSite": "Sites de prélèvement",
  "order.search.placeholder.env": "Recherchez par nom de site ou par numéro de laboratoire...",
  "order.filter.dateFrom": "From",
  "order.filter.dateTo": "À",
  "program.placeholder": "Saisir pour filtrer ou sélectionner dans la liste",
  "program.helper": "Saisir pour filtrer ou sélectionner dans la liste. La sélection d'un programme affiche ses champs d'informations de demande spécifiques ci-dessous.",
  "patient.externalSearch": "Recherche externe",
  "patient.results": "Résultats des analyses des patients",
  "patient.id.helper": "Veuillez saisir le numéro Patient, le numéro de la carte nationale d’identité ou le Numéro ST.",
  "patient.id.placeholder": "Saisir l'ID du patient",
  "patient.lastName.placeholder": "Saisir le nom de famille du patient",
  "patient.firstName.placeholder": "Saisir le prénom du patient",
  "patient.natId": "Identifiant de santé unique",
  "patient.dataSource": "Source de données",
  "patient.noResults": "0-0 sur 0 éléments",
  "patient.new.info": "Saisir les informations du nouveau patient ci-dessous. Le patient sera créé lors de l'enregistrement de la demande.",
  "pagination.showing": "Affichage de {start}-{end} sur {total} analyses",
  "results.found.for": "résultats trouvés pour \"{term}\"",
  "selected": "Sélectionné",
  "shipment.settings.siteOrgSaved": "Organisation du site enregistrée (UUID FHIR : {uuid})",
  "shipment.settings.siteOrgSection": "Organisation du site (FHIR)",
  "shipment.settings.title": "Paramètres d'expédition",
  "shipment.state.cancelled": "Annulé",
  "shipment.state.draft": "Brouillon",
  "shipment.state.inTransit": "En transit",
  "shipment.state.lostInTransit": "Perdu en transit",
  "shipment.state.partiallyReceived": "Partiellement reçu",
  "shipment.state.readyToSend": "Prêt à envoyer",
  "shipment.state.received": "Reçu",
  "shipment.state.reconciled": "Rapproché",
  "shipment.state.sent": "Envoyé",
  "shipment.stats.delivered": "Livré",
  "shipment.stats.inTransit": "En transit",
  "shipment.stats.reconciled": "Rapproché",
  "shipment.stats.totalSamples": "Total des échantillons",
  "shipment.temperature.ambient": "Ambiant (température ambiante)",
  "shipment.temperature.deepFrozen": "Ultra-congelé (-80°C)",
  "shipment.temperature.dryIce": "Glace carbonique",
  "shipment.temperature.frozen": "Congelé (-20°C)",
  "shipment.temperature.refrigerated": "Réfrigéré (2-8°C)",
  "shipment.validation.addSample": "Ajouter au moins un échantillon",
  "shipment.validation.selectDestination": "Sélectionner un établissement de destination",
  "qc.dashboard.title": "Tableau de bord du contrôle qualité",
  "qc.dashboard.lastUpdate": "Dernière mise à jour",
  "qc.dashboard.complianceStatus": "État de conformité",
  "qc.dashboard.compliant": "Conforme",
  "qc.dashboard.warning": "Avertissement",
  "qc.dashboard.nonCompliant": "Non conforme",
  "qc.dashboard.violationsCount": "{count} violations",
  "qc.dashboard.lastResult": "Dernier résultat",
  "qc.dashboard.noInstruments": "Aucun instrument configuré",
  "qc.dashboard.subtitle": "Surveiller l'état CQ et les alertes des instruments",
  "qc.dashboard.loading": "Chargement des données du tableau de bord...",
  "qc.dashboard.refresh": "Actualiser",
  "qc.dashboard.lastUpdated": "Dernière mise à jour",
  "qc.dashboard.export.title": "Exporter les données CQ",
  "qc.dashboard.export.selectInstrument": "Sélectionner un instrument",
  "qc.dashboard.export.dateError": "La date de fin doit être égale ou postérieure à la date de début.",
  "qc.dashboard.error.title": "Erreur",
  "qc.dashboard.error.loadFailed": "Échec du chargement des données. Veuillez réessayer.",
  "qc.dashboard.tab.instruments": "Instruments",
  "qc.dashboard.tab.alerts": "Alertes",
  "qc.dashboard.summary.inControl": "Instruments sous contrôle",
  "qc.dashboard.summary.warningStatus": "État d'avertissement",
  "qc.dashboard.summary.outOfControl": "Hors contrôle",
  "qc.dashboard.summary.passRate": "Taux global de réussite CQ",
  "qc.dashboard.summary.ofTotal": "{percentage} % du total des instruments",
  "qc.dashboard.instruments.title": "État du contrôle qualité des instruments",
  "qc.dashboard.instruments.subtitle": "Surveiller la conformité et la performance CQ de tous les instruments de laboratoire",
  "qc.dashboard.instruments.search": "Rechercher des instruments...",
  "qc.dashboard.instruments.col.id": "ID de l'instrument",
  "qc.dashboard.instruments.col.name": "Nom de l'instrument",
  "qc.dashboard.instruments.col.type": "Type",
  "qc.dashboard.instruments.col.location": "Emplacement",
  "qc.dashboard.instruments.col.status": "Statut",
  "qc.dashboard.instruments.col.analytes": "Analytes",
  "qc.dashboard.instruments.col.violations": "Violations récentes",
  "qc.dashboard.instruments.col.lastUpdate": "Dernière mise à jour",
  "qc.dashboard.instruments.col.actions": "Actions",
  "qc.dashboard.instruments.view": "Voir",
  "qc.dashboard.instruments.status.green": "Sous contrôle",
  "qc.dashboard.instruments.status.yellow": "Avertissement",
  "qc.dashboard.instruments.status.red": "Hors contrôle",
  "qc.dashboard.instruments.status.notConfigured": "Non configuré",
  "qc.dashboard.instruments.status.unknown": "Inconnu",
  "qc.dashboard.instruments.noViolations": "Aucune violation",
  "qc.dashboard.instruments.empty": "Aucun instrument trouvé",
  "qc.dashboard.alerts.title": "Violations et alertes CQ",
  "qc.dashboard.alerts.subtitle": "Violations des {period} dernières",
  "qc.dashboard.alerts.timePeriod": "Période",
  "qc.dashboard.alerts.timePeriod.24h": "Dernières 24 heures",
  "qc.dashboard.alerts.timePeriod.72h": "Dernières 72 heures",
  "qc.dashboard.alerts.timePeriod.7d": "7 derniers jours",
  "qc.dashboard.alerts.timePeriod.30d": "30 derniers jours",
  "qc.dashboard.alerts.timePeriod.all": "Depuis toujours",
  "qc.dashboard.alerts.active": "Violations CQ actives",
  "qc.dashboard.alerts.active.count": "{count} violation(s) sans accusé de réception nécessitant une attention",
  "qc.dashboard.alerts.active.empty": "Aucune violation active",
  "qc.dashboard.alerts.acknowledge": "Accuser réception",
  "qc.dashboard.alerts.acknowledged": "Violations avec accusé de réception",
  "qc.dashboard.alerts.acknowledged.count": "{count} violation(s) ont reçu un accusé de réception",
  "qc.dashboard.alerts.acknowledged.empty": "Aucune violation avec accusé de réception",
  "qc.dashboard.alerts.col.severity": "Gravité",
  "qc.dashboard.alerts.col.time": "Heure",
  "qc.dashboard.alerts.col.instrument": "Instrument",
  "qc.dashboard.alerts.col.analyte": "Analyte",
  "qc.dashboard.alerts.col.rule": "Règle",
  "qc.dashboard.alerts.col.acknowledgedBy": "Accusé de réception par",
  "qc.dashboard.alerts.col.acknowledgedDate": "Date d'accusé de réception",
  "qc.dashboard.banner.title": "{count} violation(s) CQ active(s) nécessitent une attention",
  "qc.dashboard.banner.viewAll": "Voir toutes les alertes",
  "qc.violations.error.acknowledgeFailed": "Échec de l'accusé de réception de la violation",
  "qc.chart.axis.date": "Date/Heure",
  "qc.chart.axis.run": "Série",
  "qc.chart.axis.value": "Écarts-types (σ)",
  "qc.instrument.notFound": "Instrument introuvable",
  "qc.chart.stats.sd": "ET",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Performance sigma",
  "qc.chart.sigma.notCalculable": "Non calculable : ETa non configurée",
  "qc.chart.sigma.bias": "Biais non appliqué (pas de données de pairs)",
  "qc.chart.sigma.WORLD_CLASS": "Classe mondiale",
  "qc.chart.sigma.ACCEPTABLE": "Acceptable",
  "qc.chart.sigma.MARGINAL": "Marginal",
  "qc.chart.sigma.POOR": "Faible",
  "qc.chart.title": "Carte de contrôle qualité",
  "qc.chart.loading": "Chargement de la carte de contrôle…",
  "qc.chart.error.title": "Impossible de charger la carte de contrôle",
  "qc.chart.tabs.label": "Niveaux de la carte de contrôle",
  "qc.chart.filter.allLevels": "Tous les niveaux",
  "qc.chart.filter.selectLot": "Sélectionner le lot",
  "qc.chart.action.zoomIn": "Zoom avant",
  "qc.chart.action.zoomOut": "Zoom arrière",
  "qc.chart.action.zoomReset": "Réinitialiser le zoom",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Violation",
  "qc.chart.mean": "Moyenne",
  "qc.chart.noData": "Aucune donnée CQ disponible",
  "qc.chart.tooltip.date": "Date",
  "qc.chart.tooltip.value": "Valeur",
  "qc.chart.tooltip.violations": "Violations",
  "qc.chart.tooltip.zScore": "Score Z",
  "qc.charts.title": "Graphiques de contrôle",
  "qc.charts.leveyJennings": "Diagramme de Levey-Jennings",
  "qc.charts.dateRange": "Plage de dates",
  "qc.charts.controlLevel": "Niveau de contrôle",
  "qc.charts.export": "Exporter le graphique",
  "qc.charts.noData": "Aucune donnée CQ disponible",
  "qc.violations.title": "Violations CQ",
  "qc.violations.severity": "Gravité",
  "qc.violations.rule": "Règle",
  "qc.violations.date": "Date",
  "qc.violations.status": "Statut",
  "qc.violations.unresolved": "Non résolu",
  "qc.violations.resolved": "Résolu",
  "qc.violations.acknowledged": "Accusé de réception",
  "qc.correctiveActions.title": "Actions correctives",
  "qc.correctiveActions.create": "Créer une action corrective",
  "qc.correctiveActions.type": "Type d'action",
  "qc.correctiveActions.description": "Description",
  "qc.correctiveActions.assignedTo": "Assigné à",
  "qc.correctiveActions.status": "Statut",
  "qc.correctiveActions.pending": "En attente",
  "qc.correctiveActions.inProgress": "En cours",
  "qc.correctiveActions.completed": "Terminé",
  "qc.correctiveActions.resolutionNotes": "Notes de résolution",
  "qc.alerts.title": "Alertes CQ",
  "qc.alerts.markAsRead": "Marquer comme lu",
  "qc.alerts.viewDetails": "Voir les détails",
  "qc.rules.title": "Configuration des règles de Westgard",
  "qc.rules.enable": "Activer",
  "qc.rules.disable": "Désactiver",
  "qc.rules.preset": "Configuration prédéfinie",
  "qc.rules.basic": "De base",
  "qc.rules.standard": "Standard",
  "qc.rules.comprehensive": "Complet",
  "qc.rules.1₂ₛ.description": "Un contrôle dépasse ±2 ET",
  "qc.rules.1₃ₛ.description": "Un contrôle dépasse ±3 ET",
  "qc.rules.2₂ₛ.description": "Deux contrôles consécutifs dépassent ±2 ET dans la même direction",
  "qc.rules.R₄ₛ.description": "L'écart entre deux contrôles dépasse 4 ET",
  "qc.rules.4₁ₛ.description": "Quatre contrôles consécutifs dépassent ±1 ET dans la même direction",
  "qc.rules.10ₓ.description": "Dix contrôles consécutifs du même côté de la moyenne",
  "qc.rules.3₁ₛ.description": "Trois contrôles consécutifs dépassent ±1 ET dans la même direction",
  "qc.rules.7ₜ.description": "Sept contrôles consécutifs évoluant dans la même direction",
  "qc.ruleConfig.title": "Configuration des règles",
  "qc.ruleConfig.subtitle": "Configurer les règles de Westgard par combinaison analyseur/test",
  "qc.ruleConfig.field.analyzer": "Analyseur",
  "qc.ruleConfig.field.selectAnalyzer": "Sélectionner un analyseur",
  "qc.ruleConfig.field.test": "Test",
  "qc.ruleConfig.field.selectTest": "Sélectionner un test",
  "qc.ruleConfig.field.severity": "Gravité",
  "qc.ruleConfig.severity.warning": "Avertissement",
  "qc.ruleConfig.severity.rejection": "Rejet",
  "qc.ruleConfig.category.rejection": "Règles de rejet",
  "qc.ruleConfig.category.warning": "Règles d'avertissement",
  "qc.ruleConfig.action.reset": "Réinitialiser aux valeurs par défaut",
  "qc.ruleConfig.loading": "Chargement de la configuration des règles...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Sélectionnez un analyseur et un test pour configurer les règles de Westgard.",
  "qc.ruleConfig.error.title": "Erreur",
  "qc.ruleConfig.error.selectAnalyzerTest": "Veuillez sélectionner à la fois un analyseur et un test.",
  "qc.ruleConfig.error.saveFailed": "Échec de l'enregistrement de la configuration des règles.",
  "qc.ruleConfig.success.title": "Succès",
  "qc.ruleConfig.success.saved": "Configuration des règles enregistrée avec succès.",
  "qc.ruleConfig.table.title": "Ensembles de règles configurés",
  "qc.ruleConfig.table.empty": "Aucune configuration de règle trouvée.",
  "qc.ruleConfig.field.enabledRules": "Règles activées",
  "qc.ruleConfig.unconfigured.title": "Mappages de contrôle non configurés",
  "qc.ruleConfig.unconfigured.subtitle": "Lots de contrôle sans configuration de règles de Westgard",
  "qc.ruleConfig.unconfigured.configure": "Configurer",
  "qc.ruleConfig.unconfigured.activeLots": "Lots actifs",
  "qc.ruleConfig.modal.title.edit": "Modifier la configuration des règles",
  "qc.ruleConfig.modal.title.create": "Créer une configuration de règles",
  "button.saving": "Enregistrement...",
  "qc.controlLots.title": "Lots de contrôle",
  "qc.controlLots.create": "Créer un lot de contrôle",
  "qc.controlLots.productName": "Nom du produit",
  "qc.controlLots.lotNumber": "Numéro de lot",
  "qc.controlLots.level": "Niveau de contrôle",
  "qc.controlLots.statisticsMethod": "Méthode de calcul des statistiques",
  "qc.controlLots.initialRuns": "Exécutions initiales",
  "qc.controlLots.rolling": "Fenêtre glissante",
  "qc.controlLots.manufacturerFixed": "Valeurs fixes du fabricant",
  "qc.controlLots.activationDate": "Date d'activation",
  "qc.controlLots.expirationDate": "Date d'expiration",
  "qc.controlLots.status.active": "Active",
  "qc.controlLots.status.establishment": "Établissement",
  "qc.controlLots.status.expired": "Expiré",
  "qc.controlLots.subtitle": "Gérer les lots de contrôle CQ pour l'évaluation des règles de Westgard",
  "qc.controlLots.empty": "Aucun lot de contrôle trouvé",
  "qc.controlLot.filter.allStatuses": "Tous les statuts",
  "qc.controlLot.status.establishment": "Établissement",
  "qc.controlLot.status.active": "Active",
  "qc.controlLot.status.expired": "Expiré",
  "qc.controlLot.field.lotNumber": "Numéro de lot",
  "qc.controlLot.field.lotNumberPlaceholder": "Saisir le numéro de lot",
  "qc.controlLot.field.material": "Matériau de contrôle",
  "qc.controlLot.field.materialPlaceholder": "Saisir le nom du matériau",
  "qc.controlLot.field.manufacturer": "Fabricant",
  "qc.controlLot.field.level": "Niveau de contrôle",
  "qc.controlLot.field.selectLevel": "Sélectionner le niveau",
  "qc.controlLot.field.expiration": "Date d'expiration",
  "qc.controlLot.field.analyzer": "Analyseur",
  "qc.controlLot.field.selectAnalyzer": "Sélectionner l'analyseur",
  "qc.controlLot.field.analyzerHelper": "Facultatif. Choisissez « Paillasse / sans analyseur » pour une méthode manuelle réalisée à la paillasse sans instrument.",
  "qc.controlLot.analyzer.bench": "Paillasse / sans analyseur (méthode manuelle)",
  "qc.controlLot.field.test": "Test",
  "qc.controlLot.field.selectTest": "Sélectionner le test",
  "qc.controlLot.field.isActive": "Statut",
  "qc.controlLot.field.inactive": "Inactif",
  "qc.controlLot.field.active": "Active",
  "qc.controlLot.field.status": "Statut",
  "qc.controlLot.loading": "Chargement...",
  "qc.controlLot.error.title": "Erreur",
  "qc.controlLot.error.saveFailed": "Échec de l'enregistrement du lot de contrôle",
  "qc.controlLot.error.statsRequired": "Les lots à valeurs fixes du fabricant nécessitent une moyenne et un écart-type. Cliquez sur « Configurer » pour les saisir avant d'enregistrer.",
  "qc.controlLot.error.benchNeedsFixedStats": "Un lot de paillasse n'a pas d'analyseur qui accumule des séries ; il doit donc utiliser des statistiques fixes du fabricant. Cliquez sur « Configurer » pour saisir une moyenne et un écart-type, ou sélectionnez un analyseur pour ce lot.",
  "qc.controlLot.new.title": "Nouveau lot de contrôle",
  "qc.controlLot.viewChart": "Voir le graphique",
  "qc.controlLot.new.subtitle": "Créer un nouveau lot de contrôle CQ",
  "qc.controlLot.edit.title": "Modifier le lot de contrôle",
  "qc.controlLot.edit.subtitle": "Mettre à jour la configuration du lot de contrôle",
  "qc.controlLot.validation.lotNumberRequired": "Le numéro de lot est obligatoire",
  "qc.controlLot.validation.materialRequired": "Le matériau est obligatoire",
  "qc.controlLot.validation.levelRequired": "Le niveau de contrôle est obligatoire",
  "qc.controlLot.validation.expirationRequired": "La date d'expiration est obligatoire",
  "qc.controlLot.validation.analyzerRequired": "L'analyseur est obligatoire",
  "qc.controlLot.validation.testRequired": "Le test est obligatoire",
  "qc.controlLot.level.low": "Bas",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "Haut",
  "qc.controlLot.statistics.title": "Configuration des statistiques",
  "qc.controlLot.statistics.configure": "Configurer",
  "qc.controlLot.statistics.method": "Méthode de calcul",
  "qc.controlLot.statistics.mean": "Moyenne",
  "qc.controlLot.statistics.sd": "Écart-type",
  "qc.controlLot.statistics.config.title": "Configuration des statistiques",
  "qc.controlLot.statistics.config.label": "Configurer la méthode statistique",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Valeurs fixes du fabricant",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Utiliser les valeurs de moyenne et d'écart-type fournies par le fabricant",
  "qc.controlLot.statistics.method.rolling": "Fenêtre glissante",
  "qc.controlLot.statistics.method.rolling.description": "Recalculer à partir des N résultats les plus récents",
  "qc.controlLot.statistics.method.initial_runs": "Exécutions initiales",
  "qc.controlLot.statistics.method.initial_runs.description": "Calculer une fois à partir des N premières exécutions d'établissement",
  "qc.controlLot.statistics.manufacturerValues": "Valeurs du fabricant",
  "qc.controlLot.statistics.rollingConfig": "Configuration de la fenêtre glissante",
  "qc.controlLot.statistics.windowSize": "Taille de la fenêtre",
  "qc.controlLot.statistics.windowSize.helper": "Nombre de résultats récents à inclure dans le calcul",
  "qc.controlLot.statistics.initialRunsConfig": "Configuration des exécutions initiales",
  "qc.controlLot.statistics.initialRunsRequired": "Exécutions requises",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Nombre d'exécutions d'établissement avant le calcul des statistiques",
  "qc.instrumentDetail.analytesMonitored": "Analytes surveillés",
  "qc.instrumentDetail.analyte.cv": "CV : {value} %",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {Nombre de violations} many {Nombre de violations} other {Nombre de violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "Chronologie d'activité",
  "qc.instrumentDetail.tab.controlChart": "Graphique de contrôle",
  "qc.instrumentDetail.timeline.empty": "Aucune alerte ou action corrective enregistrée pour la période sélectionnée",
  "qc.instrumentDetail.timeline.violation": "Violation",
  "qc.instrumentDetail.timeline.correctiveAction": "Action corrective",
  "qc.instrumentDetail.timeline.loading": "Chargement de la chronologie...",
  "qc.instrumentDetail.chart.selectAnalyte": "Sélectionner l'analyte",
  "qc.instrumentDetail.chart.loading": "Chargement de la carte de contrôle...",
  "qc.instrumentDetail.chart.noData": "Aucune donnée CQ disponible pour cet analyte",
  "qc.instrumentDetail.chart.activeRules": "Règles CQ actives",
  "qc.instrumentDetail.chart.noRules": "Aucune règle active configurée",
  "qc.instrumentDetail.chart.stats.cv": "CV %",
  "qc.instrumentDetail.chart.stats.mean": "Moyenne (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Écart-type (s)",
  "qc.instrumentDetail.error.loadFailed": "Échec du chargement des détails de l'instrument",
  "qc.instrumentDetail.notConfigured.title": "Le QC opérationnel n'est pas configuré",
  "qc.instrumentDetail.notConfigured.description": "Aucun lot de contrôle actif ni aucun résultat de contrôle qualité n'est associé à cet analyseur.",
  "question.text.required": "Le texte de la question est requis",
  "compliance.legend.limitTypes": "TYPES DE LIMITES :",
  "compliance.limitType.borderlineShort": "Borderline ⚑",
  "compliance.limitType.descriptiveShort": "Qualitatif",
  "compliance.limitType.MAXIMUM": "Limite supérieure ≤",
  "compliance.limitType.MINIMUM": "Limite faible ≥",
  "compliance.limitType.RANGE": "Valeurs normales ",
  "compliance.limitType.BORDERLINE": "Limite 🚩",
  "compliance.limitType.DESCRIPTIVE": "Qualitatif",
  "compliance.limitType.EXACT": "Exact",
  "compliance.limitType.SELECT_MAP": "Cartographie des valeurs",
  "compliance.status.ACTIVE": "Active",
  "compliance.status.DRAFT": "Brouillon",
  "compliance.status.SUPERSEDED": "Remplacé",
  "compliance.status.ARCHIVED": "Archivé",
  "compliance.standard.placeholder.name": "par exemple, le décret présidentiel n° 22/2021 — Qualité de l'eau",
  "compliance.standard.placeholder.issuingBody": "par exemple, le gouvernement indonésien",
  "compliance.standard.placeholder.regulationNumber": "par exemple, PP 22/2021",
  "compliance.standard.placeholder.version": "par exemple, 2021",
  "compliance.standard.placeholder.countryRegion": "par exemple, l'Indonésie",
  "compliance.standard.placeholder.description": "Optionnel. Description complète de la portée de la norme.",
  "compliance.standard.placeholder.date": "aaaa-mm-jj",
  "compliance.threshold.placeholder.lower": "Faible / Min.",
  "compliance.threshold.placeholder.upper": "Haut / Maximum",
  "compliance.threshold.placeholder.unit": "Unité",
  "compliance.standard.archive": "Archives",
  "compliance.standard.archiveHeading": "Norme de conformité en matière d'archivage",
  "compliance.standard.archivePrompt": " Archiver ce standard ? Les résultats déjà évalués resteront liés à ce standard pour l’audit, mais il ne sera plus visible dans les listes de sélection actives. Cette action peut être annulée en réactivant le statut du standard.",
  "compliance.standard.archived": "Norme de conformité archivée.",
  "compliance.standard.archiveError": "Impossible d'archiver cet étalon.",
  "button.complianceStandard.copy": "Copier le modèle d'étalon",
  "compliance.standard.copied": "La norme de conformité a été copiée sous forme de nouveau Brouillon.",
  "compliance.standard.copyError": "Impossible de copier cet étalon.",
  "compliance.standard.viewLinkedTests": "Voir les analyses associées",
  "compliance.testEditor.groupBy": "Regrouper par",
  "compliance.testEditor.section.configuration": "Configurer",
  "compliance.testEditor.section.organization": "Organisation",
  "compliance.testEditor.section.resources": "Ressources",
  "compliance.testEditor.section.automation": "Automatisation",
  "compliance.testEditor.section.compliance": "Conformité",
  "compliance.testEditor.tab.compliance": "Conformité",
  "compliance.testEditor.tabPlaceholder": "Cette fonctionnalité est intégrée à l'interface de l'éditeur de test — pour l'instant, vous pouvez la gérer depuis la page « Modifier les tests ».",
  "compliance.parameterGroup.editBtn": "Modifier",
  "compliance.parameterGroup.moveUp": "Remonter",
  "compliance.parameterGroup.moveDown": "Descendre",
  "compliance.parameterGroup.updateError": "Impossible de mettre à jour le groupe de paramètres.",
  "compliance.testEditor.standardInactiveBanner": "Ce test comporte des seuils associés à la norme {name}, désormais accessible à l'adresse {status}. Les résultats ne seront plus évalués par rapport à cette norme.",
  "compliance.standard.viewLinkedTests.heading": "Analyses associées — {name}",
  "compliance.standard.viewLinkedTests.empty": "Aucune analyse n'est actuellement associée à cette norme.",
  "compliance.filter.status": "Statut",
  "compliance.filter.region": "Région",
  "compliance.filter.allStatuses": "Tous les statuts",
  "compliance.filter.allRegions": "Toutes les Régions",
  "compliance.filter.sampleType": "Type d'échantillon",
  "compliance.filter.allSampleTypes": "Tous les types d’échantillons",
  "compliance.sampleTypes.addLabel": "Ajouter un type d’échantillon",
  "compliance.sampleTypes.noneConfigured": "Aucune configuration",
  "compliance.sampleTypes.noneTitle": "Aucun type d'échantillon n'a encore été configuré.",
  "compliance.sampleTypes.noneSubtitle": "Veuillez ajouter au moins un type d'échantillon avant d'associer les tests.",
  "compliance.sampleTypes.counter": "{count, plural, one {# type d'échantillon configuré} many {# types d'échantillons configurés} other {# types d'échantillons configurés}}",
  "compliance.standard.default": "Default",
  "compliance.standard.groups": "Groupes",
  "compliance.standard.tests": "Analyses",
  "compliance.standard.expiryDate": "Date d'Expiration",
  "compliance.parameterGroups.heading": "Groupes de paramètres et analyses associées",
  "compliance.parameterGroups.requireSampleTypes": "Commencez par configurer les champs et les types d’échantillons de la norme, puis associez-y les essais.",
  "compliance.button.save": "Sauvegarder",
  "compliance.button.saving": "Enregistrement en cours…",
  "compliance.parameterGroup.createError": "Impossible d'ajouter le groupe de paramètres.",
  "compliance.parameterGroup.deleteHeading": "Supprimer un groupe de paramètres",
  "compliance.parameterGroup.deletePrompt": "Souhaitez-vous supprimer le groupe de paramètres « {name} » ainsi que tous ses seuils ? Cette action ne peut pas être annulée.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# analyse est actuellement liée. Tous les seuils liés seront supprimés.} many {# analyses sont actuellement liées. Tous les seuils liés seront supprimés.} other {# analyses sont actuellement liées. Tous les seuils liés seront supprimés.}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Impossible d'enregistrer cette ligne.",
  "compliance.threshold.deleteError": "Impossible de retirer cette ligne.",
  "compliance.validation.required": "Ce champ est requis.",
  "compliance.validation.expiryAfterEffective": "La date d'Expiration doit être égale ou postérieure à la date d'entrée en vigueur.",
  "compliance.validation.missingUpper": "Une limite supérieure est requise.",
  "compliance.validation.missingLower": "Une limite inférieure est requise.",
  "compliance.validation.missingBounds": "Il est nécessaire de disposer à la fois d'une borne inférieure et d'une borne supérieure.",
  "compliance.validation.lowerGtUpper": "La borne inférieure doit être inférieure ou égale à la borne supérieure.",
  "compliance.validation.missingDescriptive": "Une valeur qualitative est requise.",
  "compliance.linkTest.selectNoOptions": "Ce test est de type « liste de sélection des résultats », mais aucune option n'est configurée dans le catalogue de tests. Veuillez ajouter les options de résultat dans la gestion des tests avant de l'associer à une norme de conformité.",
  "compliance.linkTest.resultTypeLegend": "Type de résultat",
  "compliance.linkTest.resultType.numeric": "Numérique (utiliser des valeurs limites)",
  "compliance.linkTest.resultType.select": "Liste de sélection (associer les options aux statuts)",
  "compliance.linkTest.optionsHint": "Ajoutez les options de résultat pour ce test (par exemple, « Absent », « Présent »). L'étape suivante vous permet d'associer chacune d'entre elles à un état de conformité.",
  "compliance.linkTest.optionLabel": "Valeur de l'option",
  "compliance.linkTest.optionPlaceholder": "par exemple : Absent",
  "compliance.linkTest.optionsRequired": "Ajoutez au moins une option ci-dessus avant d’associer les statuts.",
  "compliance.admin.title": "Administration des normes de conformité",
  "compliance.admin.tile.explain": "Gérer les normes de conformité, les groupes de paramètres et les seuils par test (par exemple, PP 22/2021, WHO – Eau potable).",
  "compliance.tabs.standardsAdmin": "Liste des normes de conformité",
  "compliance.tabs.testThresholds": "Onglet « Conformité » (Éditeur de test d’analyses)",
  "compliance.testEditor.back": "Back",
  "compliance.testEditor.editTest": "Test de modification :",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Type d'échantillon:",
  "compliance.testEditor.resultType": "Type de résultat :",
  "compliance.testEditor.saveTest": "Enregistrer le test",
  "compliance.testEditor.saveDisabledHint": "Les autres onglets de l'éditeur de test ne sont pas encore connectés dans cette version.",
  "compliance.testEditor.thresholdsHeading": "Seuils de conformité pour",
  "compliance.testEditor.addThreshold": "Ajouter un seuil",
  "compliance.testEditor.addThresholdHeading": "Associer {name} à une norme de conformité",
  "compliance.testEditor.pickStandard": "Norme de conformité",
  "compliance.testEditor.pickStandardPlaceholder": "-- Sélectionnez un étalon --",
  "compliance.testEditor.pickGroup": "Groupe de paramètres",
  "compliance.testEditor.pickGroupPlaceholder": "-- Sélectionnez un groupe de paramètres --",
  "compliance.testEditor.pickGroupHint": "Choisissez ci-dessus un étalon et un groupe de paramètres pour configurer le seuil.",
  "compliance.testEditor.unlink": "Supprimer le lien",
  "compliance.testEditor.unlinkHeading": "Seuil de dissociation",
  "compliance.testEditor.unlinkPrompt": "Faut-il retirer ce seuil de la norme « {test} » ? Le seuil lui-même reste dans le groupe de paramètres de la norme ; seul le lien vers ce test spécifique est retiré.",
  "compliance.testEditor.linkedBanner": "Cette analyse est associée à {count, plural, one {# norme de conformité} other {# normes de conformité}}. Les seuils sont évalués au moment de la validation.",
  "compliance.testEditor.expandRow": "Développer la ligne",
  "compliance.testEditor.col.standard": "Standard",
  "compliance.testEditor.col.parameterGroup": "Groupe de paramètres",
  "compliance.testEditor.col.limitType": "Type de limite",
  "compliance.testEditor.col.thresholdRange": "Seuil / Plage",
  "compliance.testEditor.col.unit": "Unité",
  "compliance.testEditor.col.effective": "En vigueur",
  "compliance.testEditor.col.status": "Statut",
  "compliance.testThresholds.selectHint": "Sélectionnez un test pour voir ses seuils de conformité, associés aux différentes normes.",
  "compliance.testThresholds.overviewHeading": "Analyses associées aux normes de conformité",
  "compliance.testThresholds.overviewCount": "{filtered} sur {total} analyse{total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "Aucune analyse n'est pour l'instant associée à des normes de conformité.",
  "compliance.testThresholds.overviewEmptyHint": "Les seuils définis par fichier CSV au niveau des groupes de paramètres figurent dans l'onglet 1 (Gestion des normes de conformité), et non ici. Utilisez la fonction de recherche ci-dessus pour sélectionner un test dans le Catalogue et l'associer à une norme.",
  "compliance.testThresholds.noLinkedMatches": "Non de tests associés qui correspondent à « {q} ».",
  "compliance.testThresholds.addSection": "Ajouter un test de conformité",
  "compliance.testThresholds.col.test": "Test",
  "compliance.testThresholds.col.code": "Code Emplacement",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Types d’échantillons",
  "compliance.testThresholds.col.thresholdCount": "# Seuils",
  "compliance.testThresholds.col.standardCount": "# Étalons",
  "compliance.testThresholds.openEditor": "Ouvert",
  "compliance.testThresholds.title": "Seuils de conformité des analyses",
  "compliance.testThresholds.tile.explain": "Voir les seuils de conformité associés à un test spécifique, regroupés par norme et par groupe de paramètres.",
  "compliance.testThresholds.searchLabel": "Rechercher un test",
  "compliance.testThresholds.searchPlaceholder": "Filtrer la liste des analyses…",
  "compliance.testThresholds.test": "Test",
  "compliance.testThresholds.selectPlaceholder": "-- Sélectionner un test --",
  "compliance.testThresholds.empty": "Aucun seuil de conformité n'est encore associé à ce test. Cliquez sur « + Ajouter un seuil » ci-dessus pour l'associer au groupe de paramètres d'une norme de conformité.",
  "compliance.testThresholds.parameter": "Paramètre",
  "compliance.testThresholds.type": "Type de limite",
  "compliance.testThresholds.value": "Valeur",
  "compliance.testThresholds.note": "Remarque",
  "compliance.testThresholds.unknownStandard": "Étalon inconnu",
  "compliance.button.openAdmin": "Administration des normes de conformité ouvertes",
  "compliance.button.addStandard": "Ajouter un étalon",
  "compliance.button.saveStandard": "Enregistrer la norme",
  "compliance.button.linkTest": "Associer le test au groupe",
  "compliance.button.saveLimits": "Limites d'enregistrement",
  "compliance.button.saveMapping": "Enregistrer le mappage",
  "compliance.search": "Critères de recherche",
  "compliance.search.placeholder": "Rechercher par nom, organisme émetteur, réglementation, pays…",
  "compliance.list.empty": "Il n'existe pas encore de normes de conformité.",
  "compliance.standard.name": "Nom d'Étalon",
  "compliance.standard.issuingBody": "Organisme émetteur",
  "compliance.standard.regulationNumber": "Numéro de règlement",
  "compliance.standard.version": "Version",
  "compliance.standard.countryRegion": "Pays / Région",
  "compliance.standard.status": "Statut",
  "compliance.standard.effectiveDate": "Date d'entrée en vigueur",
  "compliance.standard.description": "Description",
  "compliance.standard.addNew": "Ajouter une nouvelle norme de conformité",
  "compliance.standard.edit": "Modifier la norme de conformité",
  "compliance.standard.preSeeded": "Pré-sélectionnés",
  "compliance.standard.saved": "La norme de conformité a été enregistrée.",
  "compliance.standard.saveError": "Impossible d'enregistrer l'étalon.",
  "compliance.standard.saveBeforeGroups": "Enregistrez le modèle avant d'ajouter des groupes de paramètres.",
  "compliance.standard.deleted": "La norme de conformité a été supprimée.",
  "compliance.standard.deleteError": "Impossible de supprimer le modèle standard (il est peut-être préconfiguré ou associé à des seuils).",
  "compliance.standard.deleteHeading": "Supprimer la norme de conformité",
  "compliance.standard.deletePrompt": "Êtes-vous sûr de vouloir supprimer cet étalon ? Les étalons prédéfinis et ceux associés à des seuils ne peuvent pas être supprimés.",
  "compliance.sampleTypes.heading": "Types d’échantillons compatibles",
  "compliance.sampleTypes.explicitHint": "Veuillez indiquer à quelles catégories de types d'échantillons la présente norme s'applique. Ces sélections déterminent le filtre d'essais lors de l'association des essais.",
  "compliance.sampleTypes.empty": "Aucun type d'échantillon n'a encore été déclaré.",
  "compliance.sampleTypes.selectPlaceholder": "Sélectionnez le type d'échantillon...",
  "compliance.sampleTypes.addBtn": "Ajouter un type d’échantillon",
  "compliance.sampleTypes.remove": "Retirer",
  "compliance.parameterGroups": "Groupes de paramètres",
  "compliance.parameterGroups.empty": "Non, aucun groupe de paramètres n'a encore été défini.",
  "compliance.parameterGroups.add": "Ajouter un groupe de paramètres",
  "compliance.parameterGroup.name": "Nom du groupe",
  "compliance.parameterGroup.description": "Description",
  "compliance.parameterGroup.deleteBtn": "Supprimer",
  "compliance.label.tests": "Analyses",
  "compliance.linkedTest.name": "Test",
  "compliance.linkedTest.sampleTypes": "Types d’échantillons",
  "compliance.linkedTest.limits": "Limites configurées",
  "compliance.linkedTest.editLimits": "Limites de modification",
  "compliance.linkedTest.unlink": "Retirer du groupe",
  "compliance.linkedTest.unlinkHeading": "Retirer « Test » du groupe",
  "compliance.linkedTest.unlinkConfirm": "Retirer",
  "compliance.linkedTest.unlinkPrompt": "Souhaitez-vous retirer ce test du groupe ? Toutes les définitions de seuil associées à ce test au sein de ce groupe seront supprimées.",
  "compliance.group.noTests": "Non de tests sont encore associés à ce groupe. Associez des analyses afin de définir les seuils de conformité à des fins d'évaluation.",
  "compliance.linkTest.heading": "Associer le test au groupe",
  "compliance.linkTest.step1": "Étape 1 — Filtrer par type d'échantillon",
  "compliance.linkTest.step2": "Étape 2 — Rechercher et sélectionner un test",
  "compliance.linkTest.step3Numeric": "Étape 3 — Configurer les limites",
  "compliance.linkTest.step3Select": "Étape 3 — Cartographie des valeurs de conformité",
  "compliance.linkTest.filterByST": "Filtrer par type d'échantillon :",
  "compliance.linkTest.searchTest": "Rechercher un test dans le catalogue de tests",
  "compliance.linkTest.searchPlaceholder": "Saisissez un nom ou un code pour rechercher...",
  "compliance.linkTest.noResults": "Aucune analyse correspondant n'a été trouvée.",
  "compliance.linkTest.selectListBadge": "Sélectionner une liste",
  "compliance.linkTest.clearSelection": "Effacer la sélection",
  "compliance.multiLimit.editHeading": "Configurer les limites",
  "compliance.multiLimit.hint": "Activez un ou plusieurs types de limites pour ce test. Au moins un type de limite doit être activé.",
  "compliance.multiLimit.type": "Type de limite",
  "compliance.multiLimit.lower": "Inférieur",
  "compliance.multiLimit.upper": "Partie supérieure",
  "compliance.multiLimit.unit": "Unité",
  "compliance.multiLimit.note": "Remarque / Avis",
  "compliance.multiLimit.descriptive.placeholder": "par exemple : non odorant, absent, limpide",
  "compliance.multiLimit.note.placeholder": "Remarque optionnelle",
  "compliance.limitType.high": "Limite supérieure ≤",
  "compliance.limitType.high.hint": "Non conforme si le résultat dépasse la limite supérieure",
  "compliance.limitType.low": "Limite faible ≥",
  "compliance.limitType.low.hint": "Non conforme si le résultat est inférieur à la limite inférieure",
  "compliance.limitType.range": "Valeurs normales ",
  "compliance.limitType.range.hint": "Conforme à la plage inférieure-supérieure",
  "compliance.limitType.borderline": "Borderline (Avertissement)",
  "compliance.limitType.borderline.hint": "Zone d'avertissement — déclenche un déclencheur de révision, mais n'entraîne pas d'échec",
  "compliance.limitType.descriptive": "Qualitatif / Descriptif",
  "compliance.limitType.descriptive.hint": "Valeur de texte évaluée par l'analyste",
  "compliance.selectMap.editHeading": "Cartographie de la conformité",
  "compliance.selectMap.hint": "Associez chaque option de résultat à son statut de conformité. Les options proviennent du catalogue de tests",
  "compliance.selectMap.option": "Option de résultat",
  "compliance.selectMap.status": "État de conformité",
  "compliance.selectMap.preview": "Preview",
  "compliance.selectMap.badge": "Cartographie des valeurs",
  "compliance.selectMap.optionsLabel": "options associées",
  "compliance.selectMap.statusForOption": "Statut de conformité pour {option}",
  "compliance.status.compliant": "Conforme",
  "compliance.status.borderline": "Limite",
  "compliance.status.nonCompliant": "Non conforme",
  "compliance.status.compliantWithIcon": "Conforme ✓",
  "compliance.status.borderlineWithIcon": "Borderline ⚑",
  "compliance.status.nonCompliantWithIcon": "Non conforme ✗",
  "compliance.linkedTest.noLimits": "Non de limites ont été configurées",
  "compliance.threshold.savedThresholds": "Seuils de conformité associés au test.",
  "compliance.threshold.savedValueMap": "Seuil de mise en correspondance des valeurs enregistré.",
  "compliance.threshold.savedPartialError": "Certains seuils n'ont pas pu être enregistrés. Veuillez vérifier les lignes mises en évidence.",
  "compliance.threshold.unlinked": "Seuil non lié au test.",
  "compliance.threshold.unlinkError": "Impossible de dissocier ce seuil.",
  "notification.title.success": "Succès",
  "notification.title.error": "Erreur",
  "sidenav.label.admin.vectorSurveillance": "Surveillance des vecteurs",
  "vector.admin.title": "Configuration de la surveillance des vecteurs",
  "vector.admin.groups": "Groupes d'organismes",
  "vector.admin.group.code": "Code Emplacement",
  "vector.admin.group.label": "Etiquette",
  "vector.admin.group.colorTag": "Etiquette de couleur",
  "vector.admin.group.description": "Description",
  "vector.admin.active": "Active",
  "vector.admin.system": "Système",
  "vector.admin.trapTypes": "Types de pièges",
  "vector.admin.trapType.name": "Nom",
  "vector.admin.trapType.description": "Description",
  "vector.admin.species": "Espèces",
  "vector.admin.selectGroup": "Sélectionnez un groupe à gauche pour gérer ses types de pièges et ses espèces.",
  "vector.admin.newGroup": "Nouveau groupe (non enregistré)",
  "vector.admin.newTrapType": "Nouveau type de piège",
  "vector.admin.newSpecies": "Nouvelle espèce",
  "vector.admin.saveGroup": "Enregistrer le groupe",
  "vector.admin.saveTrap": "Enregistrer le piège",
  "vector.admin.saveSpecies": "Sauver les espèces",
  "vector.admin.addGroup": "+ Ajouter un groupe",
  "vector.admin.addTrapType": "+ Ajouter un type de piège",
  "vector.admin.addSpecies": "+ Ajouter une espèce",
  "vector.admin.locked": "verrouillé",
  "vector.admin.systemGroup": "Groupe protégé par le Système",
  "vector.admin.systemGroup.desc": "Le code est verouillé car ce groupe est utilisé dans des rapports système et des données de base. Vous pouvez toutefois modifier l’étiquette, la couleur et la description.",
  "vector.admin.usedBy": "Utilisé par",
  "vector.admin.status": "Statut",
  "vector.admin.status.active": "Active",
  "vector.admin.status.inactive": "Inactif",
  "vector.admin.group": "Groupe d'organismes",
  "vector.admin.trapType.group": "Groupe d'organismes cibles",
  "vector.admin.trapType.groups": "Groupes d'organismes",
  "vector.admin.trapType.sampleTypes": "Types d’échantillons",
  "vector.admin.sampleType": "Type d'échantillon",
  "vector.admin.search.groups": "Rechercher par code ou par étiquette...",
  "vector.admin.search.traps": "Rechercher le nom ou la description d'un piège...",
  "vector.admin.search.species": "Rechercher un genre ou une espèce...",
  "vector.admin.samplingSites": "Sites de prélèvement",
  "vector.admin.samplingSite.newSite": "Nouveau site",
  "vector.admin.samplingSite.allSites": "Tous les sites",
  "vector.admin.samplingSite.code": "Code Emplacement",
  "vector.admin.samplingSite.name": "Nom du site",
  "vector.admin.samplingSite.type": "Type de site",
  "vector.admin.samplingSite.region": "Région",
  "vector.admin.samplingSite.district": "District",
  "vector.admin.samplingSite.contactName": "Personne à contacter",
  "vector.admin.samplingSite.contactPhone": "Numéro de téléphone du Téléphone",
  "vector.admin.samplingSite.gpsLatitude": "Latitude GPS ",
  "vector.admin.samplingSite.gpsLongitude": "Longitude GPS",
  "vector.admin.samplingSite.environmentalZone": "Zone environnementale",
  "vector.admin.samplingSite.address": "Adresse",
  "vector.admin.samplingSite.description": "Description",
  "vector.admin.samplingSite.source": "Source",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Dernière collection",
  "vector.admin.samplingSite.search": "Recherche par code, nom, région...",
  "vector.admin.samplingSite.saveSite": "Enregistrer le site",
  "vector.admin.samplingSites.registry": "Registre des sites de prélèvement",
  "vector.admin.samplingSite.deactivate": "Désactiver",
  "vector.admin.samplingSite.activate": "Activer",
  "vector.admin.samplingSite.location": "Emplacement",
  "vector.admin.samplingSite.allTypes": "Tous les types",
  "vector.admin.samplingSite.subtype": "Sous-type",
  "vector.admin.samplingSite.subtype.placeholder": "par exemple : rivière, puits, BG-Sentinel, station fixe",
  "vector.admin.samplingSite.city": "Ville",
  "vector.admin.samplingSite.addressLocation": "Adresse et emplacement",
  "vector.admin.samplingSite.addressSearch.placeholder": "Rechercher un emplacement pour remplir automatiquement les menus déroulants...",
  "vector.admin.samplingSite.gpsCoordinates": "GPS Coordinates",
  "vector.admin.samplingSite.lastModified": "Dernière modification",
  "label.noResults": "Aucun résultat trouvé",
  "vector.admin.addSite": "+ Nouveau site",
  "vector.order.title": "Nouvelle commande Vector",
  "vector.order.subtitle": "Unité de laboratoire : Laboratoire de surveillance des vecteurs — Domaine « Vecteurs » actif.",
  "vector.order.samplingSite": "Sites de prélèvement",
  "vector.order.site.code": "Code Emplacement du site",
  "vector.order.site.helper": "Uniquement les sites actifs apparaissent dans les résultats. Les coordonnées GPS sont préremplies à partir de la fiche du site.",
  "vector.order.site.name": "Nom du site",
  "vector.order.site.placeholder": "Rechercher par nom ou code de site...",
  "vector.order.site.type": "Type de site",
  "vector.order.specimen": "Échantillon",
  "vector.order.organism": "Animal / Organisme",
  "vector.order.organism.hint": "Nom commun — par exemple : moustique, tique, rongeur, phlébotome.",
  "vector.order.organism.placeholder": "Rechercher un organisme ou une espèce...",
  "vector.order.quantity": "Quantité",
  "vector.order.quantity.hint": "Nombre d'organismes présents dans ce groupe.",
  "vector.order.requester.section": "Prescripteur / Programme de commande",
  "vector.order.requester": "Prescripteur",
  "vector.order.requester.placeholder": "Rechercher par nom ou code de l'organisation...",
  "vector.order.panels": "Panels de demande d'examen",
  "vector.order.panels.search": "Choisissez le panneau disponible",
  "vector.order.tests": "Analyses de la demande d'examen",
  "vector.order.tests.search": "Choisissez le test disponible",
  "vector.order.collectionContext": "Contexte de la collecte (facultatif — relevé bionomique)",
  "vector.order.timeOfDay": "Heure de la journée",
  "vector.order.timeOfDay.dawn": "L'aube",
  "vector.order.timeOfDay.day": "Jour",
  "vector.order.timeOfDay.dusk": "Le crépuscule",
  "vector.order.timeOfDay.night": "Nuit",
  "vector.order.restingContext": "Contexte de repos",
  "vector.order.restingContext.outdoor": "En extérieur (exophile)",
  "vector.order.restingContext.indoor": "D'intérieur (endophile)",
  "vector.order.restingContext.peridomestic": "Péridomestique",
  "vector.order.humanBitingCatch": "Une prise qui mord les humains",
  "vector.order.humanBitingCatch.hint": "Cet échantillon provient d'un prélèvement effectué lors d'un atterrissage avec des passagers à bord",
  "vector.order.collectionNotes": "Remarques sur la collection",
  "vector.order.collectionNotes.placeholder": "La météo, l'état des pièges, les anomalies...",
  "vector.admin.group.code.placeholder": "par exemple, SANDFLY",
  "vector.admin.group.label.placeholder": "par exemple, le phlébotome",
  "vector.species.genus.placeholder": "par exemple, Mansonia",
  "vector.species.species.placeholder": "par exemple, uniformis",
  "vector.species.subspecies.placeholder": "par exemple, diardii",
  "vector.species.genus": "Genre",
  "vector.species.species": "Espèces",
  "vector.species.subspecies": "Sous-espèces",
  "vector.species.pathogensOfInterest": "Agents pathogènes d'intérêt",
  "vector.species.lifecycleStages": "Stades du cycle de vie",
  "vector.species.pathogenCategory": "Catégorie d'agents pathogènes",
  "vector.species.lifecycleCategory": "Catégorie de cycle de vie",
  "workflow.vector": "Surveillance des vecteurs",
  "vector.sampleType": "Type d'échantillon",
  "vector.organismGroup": "Groupe d'organismes",
  "vector.species": "Espèces",
  "vector.animalOrganism": "Animal/Organisme",
  "vector.animalOrganism.add": "Ajouter un animal/organisme",
  "vector.animalOrganism.remove": "Retirer un animal/organisme",
  "vector.collectedVolume": "Quantité disponible",
  "vector.lifecycleStage": "Lifecycle Stage",
  "vector.trapCount": "Pièges mis en place",
  "vector.trapNights": "Nuits passées en mission",
  "vector.trapType": "Type de piège",
  "vector.poolingMethod": "Méthode de mise en commun",
  "vector.poolCount": "Nombre de bassins",
  "vector.samplesPerPool": "Nombre d'échantillons par regroupement",
  "vector.totalSpecimens": "Nombre total d'échantillons",
  "vector.pathogensOfInterest": "Agents pathogènes d'intérêt",
  "vector.homogeneous": "Homogène",
  "vector.random": "Au hasard",
  "vector.collectionSite": "Site de collecte",
  "vector.collectionSiteName": "Nom du site de collecte",
  "vector.gpsLatitude": "Latitude GPS ",
  "vector.gpsLongitude": "Longitude GPS",
  "patient.search.merged.tag": "Fusionné",
  "patient.merged.banner.title": "Ce dossier médical a été fusionné",
  "patient.merged.banner.subtitle": "Les dossiers actifs sont conservés sur « {target} ».",
  "patient.merged.banner.subtitle.noTarget": "Cette fiche a été fusionnée avec celle d'un autre patient.",
  "admin.testCatalog.tabs.ariaLabel": "Onglets « Détails de l’analyse »",
  "admin.testCatalog.tabs.details": "Détails",
  "admin.testCatalog.tabs.labels": "Étiquettes",
  "admin.testCatalog.labels.masterOverride.label": "Autoriser la modification manuelle de la saisie des commandes",
  "admin.testCatalog.labels.masterOverride.on": "On",
  "admin.testCatalog.labels.masterOverride.off": "Off",
  "admin.testCatalog.labels.linkedPresets.title": "Modèles d’étiquettes associés",
  "admin.testCatalog.labels.linkedPresets.empty": "Aucun modèle d’étiquette n’est associé. Utilisez le menu déroulant ci-dessous pour en ajouter un.",
  "admin.testCatalog.labels.col.presetName": "Nom du modèle",
  "admin.testCatalog.labels.col.defaultQty": "Quantité par défaut",
  "admin.testCatalog.labels.col.maxQty": "Quantité maximale",
  "admin.testCatalog.labels.col.allowOverride": "Autoriser la substitution",
  "admin.testCatalog.labels.col.actions": "Actions",
  "admin.testCatalog.labels.action.remove": "Retirer le lien prédéfini",
  "admin.testCatalog.labels.addPreset.label": "Ajouter un type d’étiquette",
  "admin.testCatalog.labels.addPreset.placeholder": "Sélectionnez un modèle d’étiquette",
  "admin.testCatalog.labels.preview.title": "Aperçu de la saisie de commande",
  "admin.testCatalog.labels.preview.col.locked": "verouillé",
  "admin.testCatalog.labels.preview.locked": "verouillé",
  "admin.testCatalog.labels.preview.unlocked": "Modifiable",
  "admin.testCatalog.labels.save.success": "La configuration de l'étiquette a été enregistrée.",
  "admin.testCatalog.labels.save.error": "Échec de l'enregistrement de la configuration des étiquettes.",
  "orderEntry.labels.orderTable.title": "Commander des étiquettes de commande",
  "orderEntry.labels.sampleTable.title": "Étiquettes d'échantillon",
  "orderEntry.labels.col.row": "Row",
  "orderEntry.labels.col.sample": "Échantillon",
  "orderEntry.labels.col.quantity": "Quantité",
  "orderEntry.labels.orderRow.header": "Demande d'examen",
  "orderEntry.labels.sampleRow.header": "Échantillon {number}",
  "orderEntry.labels.input.sample": "Échantillon : {number} {column} Quantité",
  "orderEntry.labels.source.test": "De l'analyse",
  "orderEntry.labels.source.presetDefault": "Paramètre par défaut",
  "orderEntry.labels.source.saved": "Enregistré",
  "orderEntry.labels.locked.tooltipFor": "{label} est verrouillé par la configuration du test et ne peut pas être modifié.",
  "orderEntry.labels.total": "Nombre total d'étiquettes : {total}",
  "orderEntry.labels.heading": "LABELS",
  "orderEntry.labels.title": "Étiquettes",
  "orderEntry.labels.printRow": "Imprimer les étiquettes pour {label}",
  "orderEntry.labels.printColumn": "Imprimer toutes les étiquettes {label}",
  "orderEntry.labels.printAll": "Imprimer toutes les étiquettes",
  "orderEntry.labels.pendingSave": "Impression après enregistrement",
  "orderEntry.labels.empty": "Ajoutez un échantillon ci-dessus pour afficher ses étiquettes.",
  "orderEntry.labels.loadFailed": "Les quantités d'étiquettes n'ont pas pu être chargées depuis les préréglages.",
  "orderEntry.labels.printFailed": "Les étiquettes n'ont pas pu être générées.",
  "orderEntry.labels.printFailed.detail": "Le serveur a répondu {status}.",
  "orderEntry.labels.printFailed.unreachable": "Impossible de joindre le serveur.",
  "orderEntry.labels.nothingToPrint": "Aucune étiquette n'est configurée pour cette sélection.",
  "orderEntry.labels.downloaded": "La fenêtre d'impression a été bloquée, les étiquettes ont donc été téléchargées.",
  "orderEntry.labels.retry": "Réessayer",
  "label.patientHistory.filterByCategory": "Filtrer par catégorie de test",
  "label.patientHistory.testCategories": "Catégories d'analyses",
  "label.patientHistory.tree": "Arbre",
  "label.patientHistory.showTree": "Afficher l'arborescence",
  "label.patientHistory.resetTree": "Réinitialiser l'arborescence",
  "label.patientHistory.viewResults": "Consultez les résultats de l'{count}",
  "label.patientHistory.emptyState": "Il n'y a aucune « {displayText} » à afficher pour cette patiente.",
  "label.patientHistory.record": "{displayText} de l'enregistrement",
  "label.patientHistory.dataLoadError": "Erreur de chargement des données",
  "label.patientHistory.errorCopy": "Veuillez nous excuser, un problème est survenu lors de l'affichage de ces informations. Vous pouvez essayer de recharger cette page ou contacter l'administrateur du site en lui indiquant le code d'erreur ci-dessus.",
  "label.patientHistory.backToTimeline": "Retour à la chronologie",
  "label.patientHistory.returnToTimeline": "Retour à la chronologie",
  "label.patientHistory.timeOfTest": "Date de l'examen",
  "label.patientHistory.observations": "remarques",
  "label.patientHistory.range.oneDay": "1 jour",
  "label.patientHistory.range.fiveDays": "5 jours",
  "label.patientHistory.range.oneMonth": "1 mois",
  "label.patientHistory.range.sixMonths": "6 mois",
  "label.patientHistory.range.oneYear": "1 année",
  "label.patientHistory.range.fiveYears": "5 années",
  "label.patientHistory.range.all": "Tous",
  "label.patientHistory.date": "Date",
  "address.search.no.results": "Aucune adresse n'a été trouvée pour « {term} ».",
  "address.search.placeholder": "Rechercher une adresse (saisissez au moins 2 caractères)...",
  "address.search.results.count": "{count} résultats trouvés",
  "alert.error": "Erreur",
  "alert.warning": "Avertissement",
  "analyzer.errorDetails.noLogsAvailable": "Non de journaux disponibles",
  "analyzer.fieldSelector.placeholder": "Rechercher et sélectionner un champ...",
  "analyzer.fieldSelector.title": "Sélectionnez un champ OpenELIS",
  "analyzer.form.columnMappings": "Mappages de colonnes (JSON)",
  "analyzer.form.columnMappings.helperText": "Mappe les noms des colonnes du fichier aux noms des champs internes",
  "analyzer.form.delimiter": "Délimiteur",
  "analyzer.form.fileFormat": "File Format",
  "analyzer.form.fileImport.title": "Paramètres d'importation de fichiers",
  "analyzer.form.filePattern": "Modèle de fichier",
  "analyzer.form.filePattern.helperText": "Modèle « Glob » permettant de faire correspondre les fichiers de résultats",
  "analyzer.form.hasHeader": "Le fichier comporte une ligne d'en-tête",
  "analyzer.form.importDirectory": "Répertoire d'import",
  "analyzer.form.importDirectory.helperText": "Répertoire dans lequel le pont surveille l'arrivée des fichiers de résultats",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "Les mappages de colonnes doivent être au format JSON valide",
  "analyzer.form.validation.importDirectory.required": "Le répertoire d'import est requis pour les analyseurs basés sur des fichiers",
  "analyzer.form.validation.port.invalid": "Le numéro de port doit être un nombre compris entre 1 et 65 535",
  "analyzer.qc.batch.failure.subtitle": "Les contrôles de qualité de ce lot présentent des anomalies. Veuillez examiner les résultats des contrôles de qualité ci-dessous avant de valider les résultats des analyses des patients.",
  "analyzer.qc.batch.failure.title": "Echec des contrôles QC",
  "analyzer.qc.controls.hidden": "Contrôles de qualité invisibles pour le patient",
  "analyzer.qc.controls.section.title": "QC Controls ({count})",
  "audittrail.table.heading": "Informations relatives à la commande",
  "barcode.label.info.labnumber": "Numéro d'Accession",
  "button.close": "Fermer",
  "button.collapse": "Réduire",
  "button.expand": "Développer",
  "button.home": "Accueil",
  "button.new.search": "Nouvelle recherche",
  "column.name.labNo": "N° de laboratoire",
  "env.collectionConditions.helper": "Recherchez un site de prélèvement existant ou créez-en un nouveau. Les sites sont réutilisables d'une commande à l'autre, à l'instar des patients dans les flux de travail cliniques.",
  "env.collectionMethod.placeholder": "par exemple : échantillon ponctuel, échantillon composite sur 24 heures",
  "env.conditions": "Conditions environnementales",
  "env.conditions.placeholder": "par exemple, 20 °C, temps dégagé, saison sèche",
  "env.regulatoryReference": "Référence réglementaire",
  "env.regulatoryReference.placeholder": "par exemple, le décret n° 22/2021 « Batu Mutu Air »",
  "env.samplingSite.title": "Objet — Site de prélèvement",
  "env.site.address": "Adresse",
  "env.site.addressSearch.placeholder": "Recherchez un emplacement pour remplir automatiquement les menus déroulants ci-dessous...",
  "env.site.code": "Code Emplacement du site",
  "env.site.code.placeholder": "Généré automatiquement (ou à saisir manuellement)",
  "env.site.contactPerson": "Personne à contacter",
  "env.site.contactPerson.placeholder": "Nom du responsable du site ou de la personne à contacter",
  "env.site.contactPhone": "Numéro de téléphone du Téléphone",
  "env.site.description": "Description du site",
  "env.site.description.placeholder": "par exemple, point de surveillance en aval près d'une vanne",
  "env.site.helperText": "Enregistrez un nouveau site de prélèvement. Ce site sera enregistré dans le registre des sites et pourra être réutilisé pour de futures commandes.",
  "env.site.name": "Nom du site",
  "env.site.name.placeholder": "par exemple, Sungai Ciliwung — Manggarai",
  "env.site.newTab": "Nouveau site",
  "env.site.saveAndSelect": "Enregistrer et sélectionner le site",
  "env.site.searchLabel": "Nom du site",
  "env.site.searchPlaceholder": "par exemple, Sungai Ciliwung - Manggarai",
  "env.site.searchTab": "Rechercher sur le site",
  "env.site.streetAddress": "Adresse",
  "env.site.streetAddress.placeholder": "Adresse postale ou référence d'emplacement",
  "env.site.subtype": "Sous-type",
  "env.site.subtype.placeholder": "par exemple : rivière, puits, BG-Sentinel, station fixe",
  "env.site.type": "Type de site",
  "env.site.type.select": "Sélectionnez le type...",
  "env.site.zone": "Zone environnementale",
  "env.site.zone.select": "Sélectionnez une zone...",
  "error.dateRange.start": "Veuillez sélectionner les dates de début et de fin.",
  "error.loading.metrics": "Erreur lors du chargement des indicateurs",
  "error.nonconform.report.data.found": "Aucune donnée trouvée",
  "error.report.csv.dateType": "Veuillez sélectionner le type de date.",
  "error.required.fields": "Veuillez remplir tous les champs obligatoires",
  "error.save.sample": "Erreur lors de l'enregistrement de l'échantillon",
  "error.validation.failed": "Échec de la validation",
  "error.value": "Veuillez sélectionner une valeur.",
  "esig.context.saveResults": "Enregistrer le(s) résultat(s) de {count} pour l'accession {accession}",
  "esig.context.saveResultsMulti": "Enregistrer le(s) résultat(s) de « {count} » pour l'ensemble des numéros de laboratoire de « {accessionCount} »",
  "esig.context.validateResults": "Validez le(s) résultat(s) de l'{count} pour le numéro de laboratoire {accession}",
  "esig.context.validateResultsMulti": "Valider les résultats d'{count} pour l'ensemble des numéros de laboratoire de {accessionCount}",
  "fhir.questionnaire.title": "Informations complémentaires",
  "genericSample.default.fields.title": "Informations sur l’échantillon",
  "genericSample.import.success": "Importer avec succès",
  "genericSample.notebook.label": "Sélectionnez le bloc-notes",
  "genericSample.order.newOrder": "Créer un autre échantillon",
  "genericSample.search.title": "Recherche par numéro de laboratoire",
  "http.success": "Succès!",
  "label.button.assign": "Attribuer",
  "label.button.create": "Créer",
  "label.button.saving": "Enregistrement...",
  "label.button.view": "Voir le rapport",
  "label.code": "Code Emplacement",
  "label.editing": "Modification",
  "label.label": "Etiquette",
  "label.name": "Nom",
  "label.panel": "Panneau",
  "label.tests": "Analyses",
  "loading.label": "Chargement...",
  "loading.metrics": "Chargement des indicateurs...",
  "locale.save.error": "Échec de l'enregistrement de la langue",
  "logging.management.tail.clear": "Clear",
  "logging.management.tail.disconnected": "La connexion au flux a été interrompue. Désactivez puis réactivez la fonction pour vous reconnecter.",
  "logging.management.tail.label": "Journal d'application en temps réel",
  "logging.management.tail.off": "Off",
  "logging.management.tail.on": "On",
  "logging.management.tail.stream": "Diffusion en direct",
  "nationalID.title": "Carte nationale d’identité",
  "nce.button.linkSelected": "Lien vers les échantillons sélectionnés",
  "nce.button.submit": "Soumettre un NCE",
  "nce.error.numberGeneration": "Echec pour générer le numéro d'ENC. Veuillez réessayer.",
  "nce.field.dateOfEvent": "Date de l'Événement",
  "nce.field.description": "Description",
  "nce.field.nceNumber": "Numéro d'ENC",
  "nce.field.proposedAction.helper": "Distinctes des actions CAPA attribuées dans le cadre du plan de travail pour les actions correctives",
  "nce.field.proposedAction.placeholder": "Étapes suivantes recommandées...",
  "nce.field.reporterName": "Nom du journaliste",
  "nce.field.reportingUnit": "Unité de rapport",
  "nce.field.subcategory": "Sous-catégorie",
  "nce.field.suspectedCauses.helper": "Il s'agit uniquement d'une première évaluation — la cause profonde officielle sera déterminée au cours de l'enquête",
  "nce.field.suspectedCauses.placeholder": "Journaliste",
  "nce.form.subtitle": "Consignez un événement lié à la qualité et associez-y les échantillons concernés ainsi que les résultats",
  "nce.form.title": "Signaler une non-conformité",
  "nce.linkSamples.helper": "Recherchez les commandes ci-dessus pour associer des échantillons à ce NCE. Cette étape est facultative.",
  "nce.section.attachments": "Pièces jointes",
  "nce.section.classification": "Classification",
  "nce.section.details": "Détails",
  "nce.section.linkSamples": "Lien vers les échantillons / Résultats associés (facultatif)",
  "nce.section.reporterContext": "Journaliste et contexte de l'événement",
  "nce.select.subcategory": "Sélectionnez une sous-catégorie...",
  "nce.severity.critical.desc": "Risque pour la sécurité des patients, violation réglementaire",
  "nce.severity.major.desc": "Impact significatif sur la qualité ou les opérations",
  "nce.severity.minor.desc": "Impact limité, facilement corrigé",
  "nonconform.corrective.requiredFields": "Veuillez remplir tous les champs relatifs aux actions correctives (action, Personne Responsable, Date d'Achèvement et au moins un type d'action), ou laissez la ligne entièrement vide.",
  "nonconform.view.requiredFields": "Les champs « Composant de laboratoire », « Catégorie d'ÉCN », « Type d'ÉCN », « Gravité et conséquences » et « Récurrence » sont tous obligatoires.",
  "notebook.sample.create": "Créer",
  "notebook.sample.create.title": "Créer un nouvel échantillon",
  "notebook.sample.edit": "Modifier",
  "notebook.sample.edit.title": "Modifier l'échantillon",
  "notebook.sample.import": "Importer",
  "notebook.sample.import.title": "Importer  échantillons",
  "notebook.sample.order.info": "Cet échantillon sera associé au carnet de notes actuel.",
  "notebook.sample.order.title": "Créer un échantillon pour le cahier de laboratoire",
  "notification.warning": "Avertissement",
  "order.entry.setup.batch": "Saisie d'ordonnances en lot",
  "order.legend.patient1": "Patient",
  "pagination.next": "Next page",
  "pagination.previous": "Previous page",
  "patient.fetch.error": "Impossible de charger les données du patient. L'identifiant est peut-être invalide ou le serveur est inaccessible.",
  "patient.firstName": "Prénom",
  "patient.lastName": "Nom",
  "print.barcode.all": "Imprimer tous les codes-barres ({count})",
  "sample.item.id": "Exemple d'identifiant d'article",
  "sample.label": "Échantillon",
  "sample.noPanels": "Aucun panneau n'est disponible pour ce type d'échantillon",
  "sample.noTests": "Aucun test n'est disponible pour ce type d'échantillon",
  "sample.testsLoadFailed": "Les analyses pour ce type d'échantillon n'ont pas pu être chargées.",
  "sample.noTestsMatchSearch": "Aucune analyse ne correspond à votre recherche",
  "sample.noPanelsMatchSearch": "Aucun panel ne correspond à votre recherche",
  "sample.selectType.first": "Sélectionnez un type d'échantillon ci-dessus pour découvrir les panneaux et les tests disponibles",
  "sample.testsCount": "{count} Analyses disponibles",
  "sample.types": "Échantillons",
  "sample.referral.listsFailed": "Les motifs d'envoi ou les laboratoires n'ont pas pu être chargés. Toutes vos saisies sont conservées ; appuyez sur Réessayer pour envoyer une analyse.",
  "sample.tests.loadFailed": "Les analyses pour {sampleType} n'ont pas pu être chargées.",
  "sample.tests.loadFailed.hint": "Toutes vos saisies sont conservées. Vérifiez la connexion ou reconnectez-vous, puis appuyez sur Réessayer.",
  "sample.tests.loading": "Chargement des analyses…",
  "save.error.msg": "Erreur lors de l'enregistrement",
  "saving.label": "Enregistrement...",
  "select.label.analyzer": "Choisir l'automate",
  "site.code": "Code Emplacement",
  "steps.complete": "étapes",
  "storage.audit.empty": "Aucun mouvement n'a encore été enregistré pour cet échantillon.",
  "storage.audit.empty.title": "Non de mouvements",
  "storage.audit.fetch.error": "Impossible de charger le formulaire d'Audit.",
  "storage.audit.fetch.error.title": "Erreur",
  "storage.audit.from": "From",
  "storage.audit.movedBy": "Proposé par",
  "storage.audit.movementDate": "Date du mouvement",
  "storage.audit.reason": "Motif",
  "storage.audit.to": "À",
  "storage.box.code.helper": "Jusqu'à 10 caractères",
  "storage.confirm.disposal": "Confirmer la mise au rebut",
  "storage.dashboard.title": "Stockage",
  "storage.disposal.method": "Méthode d'élimination",
  "storage.disposal.method.placeholder": "Sélectionnez la méthode...",
  "storage.disposal.notes": "Remarques supplémentaires (optionnelles)",
  "storage.disposal.notes.placeholder": "Veuillez saisir vos remarques supplémentaires...",
  "storage.disposal.reason": "Motif de mise au rebut",
  "storage.disposal.reason.placeholder": "Sélectionnez la raison...",
  "storage.dispose.confirmation": "Je confirme que je souhaite supprimer définitivement cet échantillon. Cette action ne peut pas être annulée.",
  "storage.dispose.error": "Échec de l'élimination",
  "storage.dispose.instructions.subtitle": "Veuillez vous assurer que les procédures d'élimination appropriées sont respectées, conformément aux protocoles de sécurité du laboratoire.",
  "storage.dispose.instructions.title": "Consignes d'élimination",
  "storage.dispose.location.note": "L’échantillon sera retiré de cet emplacement lors de son rejet",
  "storage.dispose.sample": "Disposer de l'échantillon",
  "storage.dispose.sample.subtitle": "Éliminer définitivement l'échantillon {sampleId}",
  "storage.dispose.warning.subtitle": "L'échantillon sera marqué comme ayant été rejeté et retiré du stockage.",
  "storage.dispose.warning.title": "Cette action ne peut pas être annulée",
  "storage.edit.heading": "Modifier {type}",
  "storage.edit.title": "Modifier",
  "storage.editbox.heading": "Zone de modification",
  "storage.error": "Erreur",
  "storage.error.save": "Échec de l'enregistrement de l'emplacement",
  "storage.filter.select.location": "Sélectionnez un emplacement...",
  "storage.filter.selected": "sélectionné(s):",
  "storage.location.assigned.error": "Echec pour attribuer un emplacement",
  "storage.location.assigned.success": "L'emplacement a été attribué avec succès",
  "storage.location.created": "{level} créé(e)",
  "storage.location.deleted": "{level} supprimé(e)",
  "storage.location.no.results": "Non de lieux trouvés",
  "storage.location.type.devices": "Appareils",
  "storage.location.type.racks": "Supports",
  "storage.location.type.rooms": "Chambres",
  "storage.location.type.shelves": "Étagères",
  "storage.location.updated": "{level} mis(e) à jour",
  "storage.manage.location": "Gérer l'emplacement",
  "storage.nav.rack": "Support",
  "storage.sample.actions": "Échantillons d'actions",
  "storage.sampleitem.accession": "Numéro Laboratoire de l’échantillon",
  "storage.sampleitem.location": "Lieu de stockage",
  "storage.sampleitem.status": "Statut",
  "storage.sampleitem.type": "Type",
  "storage.search.location.label": "Rechercher un emplacement de stockage",
  "storage.search.location.placeholder": "Saisissez 2 caractères ou plus pour rechercher…",
  "storage.skipRemaining": "Passer le stockage pour les échantillons non assignés ({count}) : ils seront traités immédiatement",
  "storage.view.audit": "Voir l'audit",
  "storage.view.audit.subtitle": "Historique des mouvements pour l'échantillon {sampleId}",
  "storage.view.audit.title": "Historique des formulaires d'Audit pour le stockage",
  "systemDefaultPayloadTemplate.messageTemplate": "Modèle de message",
  "systemDefaultPayloadTemplate.subjectTemplate": "Modèle d'objet",
  "tests.count": "{count, plural, one {analyse} many {analyses} other {analyses}}",
  "validation.invalid.ip": "Format d'adresse IP non valide (IPv4 ou IPv6)",
  "validation.invalid.port": "Le port doit être compris entre 1 et 65 535",
  "validation.required": "Ce champ est requis",
  "common.accept": "Valider",
  "common.accessionNumber": "Numéro d'enregistrement",
  "common.action": "Action",
  "common.actions": "Actions",
  "common.active": "Active",
  "common.addTests": "Ajouter des tests",
  "common.aliquots": "aliquotes",
  "common.all": "Tous",
  "common.allStatuses": "Tous les statuts",
  "common.analyzer": "Analyseur",
  "common.analyzers": "Analyseurs",
  "common.auditTrail": "Formulaire d'Audit",
  "common.back": "Back",
  "common.boxId": "ID de la boîte",
  "common.byUnit": "Par Unité",
  "common.cancel": "Annuler",
  "common.category": "Catégorie",
  "common.clinical": "Clinique",
  "common.code": "Code Emplacement",
  "common.collected": "Prélevé",
  "common.collectionDate": "Date de prélèvement",
  "common.complete": "Terminé",
  "common.completed": "Terminé",
  "common.confirm": "Confirmer",
  "common.correctiveActions": "Actions correctives",
  "common.createAliquot": "Créer une aliquote",
  "common.critical": "Critique",
  "common.dashboard": "Tableau de bord",
  "common.date": "Date",
  "common.dateRange": "Plage de dates",
  "common.deactivate": "Désactiver",
  "common.delete": "Supprimer",
  "common.description": "Description",
  "common.draft": "Brouillon",
  "common.edit": "Modifier",
  "common.editOrder": "Modifier l'échantillon",
  "common.email": "E-mail",
  "common.enterResults": "Saisir les résultats",
  "common.error": "Erreur",
  "common.expired": "Expiré",
  "common.exportPdf": "Exporter en PDF",
  "common.failed": "Failed",
  "common.filterByStatus": "Filtrer par statut",
  "common.firstName": "Prénom",
  "common.from": "From",
  "common.generateReport": "Générer le rapport",
  "common.home": "Accueil",
  "common.inProgress": "En cours",
  "common.inactive": "Inactif",
  "common.labNumber": "Numéro laboratoire",
  "common.lastName": "Nom",
  "common.loading": "Chargement...",
  "common.location": "Emplacement",
  "common.mean": "Moyenne",
  "common.name": "Nom",
  "common.nationalId": "Carte nationale d’identité",
  "common.new": "Nouveau",
  "common.none": "Aucun",
  "common.normal": "Normal",
  "common.normalRange": "Valeurs normales ",
  "common.notCompleted": "Non terminé",
  "common.notes": "Notes",
  "common.order": "Demande d'examen",
  "common.overdue": "En retard ",
  "common.panels": "Panels",
  "common.participants": "Participants",
  "common.patient": "Patient",
  "common.pending": "En attente",
  "common.position": "Position",
  "common.printLabel": "Imprimer l'étiquette",
  "common.priority": "Priorité",
  "common.program": "Programme",
  "common.programName": "Nom du programme",
  "common.provider": "Page du prestataire",
  "common.quantity": "Quantité",
  "common.reason": "Motif",
  "common.received": "Reçu",
  "common.referenceLab": "Laboratoire de référence",
  "common.reject": "Rejeter",
  "common.remove": "Retirer",
  "common.removeSelection": "Retirer « {name} »",
  "common.reports": "Rapports",
  "common.requester": "Prescripteur",
  "common.result": "Résultat ",
  "common.results": "Résultats",
  "common.room": "Pièce",
  "common.routine": "Routine",
  "common.sample": "Échantillon",
  "common.sampleId": "ID d'échantillon",
  "common.sampleManagement": "Gestion des échantillons",
  "common.sampleType": "Type d'échantillon",
  "common.samples": "Échantillons",
  "common.samplingSite": "Sites de prélèvement",
  "common.save": "Sauvegarder",
  "common.saveFailed": "Échec de l'enregistrement",
  "common.saving": "Enregistrement...",
  "common.search": "Rechercher",
  "common.select": "Sélectionner",
  "common.severity": "Gravité",
  "common.siteName": "Nom du site",
  "common.species": "Espèces",
  "common.standard": "Standard",
  "common.status": "Statut",
  "common.storageLocation": "Emplacement de stockage",
  "common.study": "Etude",
  "common.test": "Test",
  "common.testName": "Nom du test ",
  "common.tests": "Analyses",
  "common.type": "Type",
  "common.unit": "Unité",
  "common.user": "Utilisateur",
  "common.value": "Valeur",
  "common.view": "Voir",
  "common.warning": "Avertissement",
  "label.testCatalog.alerts.field.component": "Composant « Résultat »",
  "label.testCatalog.alerts.field.componentHelp": "Résultat surveillé par cette alerte. Ne rien indiquer pour surveiller tous les composants de ce test.",
  "label.testCatalog.alerts.field.sampleType": "Type d'échantillon",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Échantillon sur lequel s'applique cette alerte. Ne rien indiquer pour surveiller tous les types d'échantillons sur lesquels ce test est effectué.",
  "label.testCatalog.alerts.scope.anyComponent": "N'importe lequel des composants",
  "label.testCatalog.alerts.scope.anySampleType": "N'importe quel type d'échantillon",
  "label.testCatalog.alerts.col.scope": "S'applique à",
  "label.testCatalog.alerts.scope.wholeTest": "Analyses complètes",
  "microbiology.ast.breakpointStandard": "Norme relative aux points d'arrêt",
  "microbiology.ast.hint": "Enregistrez les mesures du MIC ou des zones, examinez les interprétations et consignez les dérogations directement dans le système.",
  "microbiology.ast.noOverride": "Non à la dérogation",
  "microbiology.ast.reading": "Résultat de l'AST",
  "microbiology.case.isolates.hint": "Ajoutez et identifiez toute croissance cliniquement significative avant l'AST.",
  "microbiology.isolate.contaminant": "Contaminant",
  "microbiology.isolate.edit": "Modifier l'isolat",
  "microbiology.isolate.identificationStatus": "Statut d'identification",
  "microbiology.isolate.normalFlora": "Flore normale",
  "microbiology.isolate.organism": "Organismes",
  "microbiology.isolate.organism.freeText": "Saisissez le nom de l'organisme sous forme de texte libre",
  "microbiology.isolate.significant": "Cliniquement significatif",
  "microbiology.isolate.unknown": "Inconnu",
  "microbiology.isolate.update": "Enregistrer les informations d'identification",
  "microbiology.enum.AST_REVIEW_REQUIRED": "Vérification AST requise",
  "microbiology.enum.AWAITING_RESULTS": "En attente des résultats",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "Une cartographie des antibiotiques est nécessaire",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "Dossier finalisé",
  "microbiology.enum.AMENDED": "Modifié",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "Echec de l'action de modification",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "Modification du protocole de culture",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "Amendement déjà ouvert",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "Échec du chargement de l'historique des modifications",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "Modification en cours",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "Une nouvelle exécution de l'AST est requise pour apporter cette modification",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "Amendement non ouvert à la discussion",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "Motif de la modification requis",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "Cet amendement nécessite une publication définitive",
  "microbiology.enum.ACKNOWLEDGED": "Accusé de réception",
  "microbiology.enum.AMENDMENT_CANCELLED": "Amendement annulé",
  "microbiology.enum.AMENDMENT_OPENED": "Ouverture de la procédure d'amendement",
  "microbiology.enum.AMENDMENT_RELEASED": "Publication d'un amendement",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "Source de la modification : l'AST doit faire l'objet d'une déclaration",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "Indicateurs de l'analyseur accusés de réception",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "Echec du contrôle QC de l'analyseur",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "Réception des résultats de l'analyseur",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "AST : motif de la tentative obligatoire",
  "microbiology.enum.AST_ENTRY": "Inscription à l'AST",
  "microbiology.enum.AST_IN_PROGRESS": "AST en cours",
  "microbiology.enum.AST_READY": "Compatible AST",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "Répétition ou Retester requis",
  "microbiology.enum.AST_REVIEW": "Revue AST",
  "microbiology.enum.AST_REVIEWED": "Vérifié par l'AST",
  "microbiology.enum.AST_READING_OVERRIDDEN": "Valeur de lecture AST remplacée",
  "microbiology.enum.AST_READING_RECORDED": "Valeur AST enregistrée",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "AST à déclarer sélectionnée",
  "microbiology.enum.AST_RUN_CREATED": "Création d'une exécution AST",
  "microbiology.enum.AST_RUN_INVALIDATED": "Exécution AST invalidée",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "Incohérence entre les méthodes d'exécution AST",
  "microbiology.enum.AST_QC_OVERRIDDEN": "QC AST contourné",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "Configuration AST indisponible",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "Examen obligatoire des résultats de l'AST requis",
  "microbiology.enum.ANALYZER": "Analyseur",
  "microbiology.enum.BROTH_MICRODILUTION": "Microdilution en bouillon",
  "microbiology.enum.CASE": "Cas",
  "microbiology.enum.CASE_CREATED": "Dossier créé",
  "microbiology.enum.CASE_REVIEW": "Examen du dossier",
  "microbiology.enum.CANCELLED": "Annulé",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "Cliniquement significatif",
  "microbiology.enum.CLOSED": "Fermé",
  "microbiology.enum.CONFIRMED": "Confirmé",
  "microbiology.enum.CONTAMINANT": "Contaminant",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "Communication critique accusée de réception",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "Communication critique : fermée",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "Critique de communication enregistrée",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "Suivi Requis",
  "microbiology.enum.DISK_DIFFUSION": "Diffusion sur disque",
  "microbiology.enum.EMAIL": "E-mail",
  "microbiology.enum.EMERGENCY": "Urgence",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "Failed",
  "microbiology.enum.FINAL": "Finale",
  "microbiology.enum.FINAL_REPORT_RELEASED": "Publication du rapport final",
  "microbiology.enum.GROWTH_DETECTED": "Croissance détectée",
  "microbiology.enum.HIGH": "Haut",
  "microbiology.enum.IDENTIFICATION": "Identification",
  "microbiology.enum.ICU": "Soins intensifs",
  "microbiology.enum.INCUBATING": "En incubation",
  "microbiology.enum.INPATIENT": "Hospitalisation",
  "microbiology.enum.IN_PROGRESS": "En cours",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "En personne",
  "microbiology.enum.INOCULATION_RECORDED": "Inoculation enregistrée",
  "microbiology.enum.ISOLATE": "Isoler",
  "microbiology.enum.ISOLATE_CREATED": "Isolat créé",
  "microbiology.enum.ISOLATE_ID": "IDENTIFIANT de l'isolat",
  "microbiology.enum.ISOLATE_REQUIRED": "Isolation obligatoire",
  "microbiology.enum.ISOLATE_UPDATED": "Mise à jour de l’isolat Mis à Jour",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "Technique de CMI non précisée",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "Technique de zone non précisée",
  "microbiology.enum.MANUAL_NOTE": "Remarque relative au Manuel",
  "microbiology.enum.MANUAL_ENTRY": "Saisie manuelle",
  "microbiology.enum.MIC": "CMI",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "L'audit de vaccination n'a pas pu être enregistré",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "L'audit du protocole n'a pas pu être enregistré",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "Sélectionnez un autre protocole",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "Attribuez un plan de travail avant de sélectionner un protocole",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "La source de la sous-culture doit se rapporter à cette affaire",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "L'audit du plan de travail n'a pas pu être enregistré",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "Confirmer la conservation des travaux existants",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "Classification des plans de travail requise",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "La méthode de culture n'est pas compatible avec le plan de travail",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "Ce plan de travail n'est pas pris en charge",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "Ce plan de travail existe déjà dans un cas concret",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "Sélectionnez un autre plan de travail",
  "microbiology.enum.NO_GROWTH_READY": "Non prêt pour la croissance",
  "microbiology.enum.NORMAL_FLORA": "Flore normale",
  "microbiology.enum.NEEDS_WORKFLOW": "Plan de travail à mettre en place",
  "microbiology.enum.NOT_READY": "Pas prêt",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "Rapport sur la non-conformité",
  "microbiology.enum.NONE": "Aucun",
  "microbiology.enum.OPEN": "Ouvert",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "Cartographie des organismes requise",
  "microbiology.enum.ORGANISM": "Organismes",
  "microbiology.enum.ORIGINAL": "Original",
  "microbiology.enum.OTHER": "Autre",
  "microbiology.enum.OUTPATIENT": "Soins ambulatoires",
  "microbiology.enum.PENDING": "En attente",
  "microbiology.enum.PASSED": "Réussi",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "Téléphone",
  "microbiology.enum.POSITIVE_SIGNAL": "Signal positif",
  "microbiology.enum.PRELIM_RELEASED": "Publication préliminaire",
  "microbiology.enum.PRELIMINARY": "Préliminaire",
  "microbiology.enum.PRELIMINARY_RELEASED": "Publication préliminaire",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "Publication du rapport préliminaire",
  "microbiology.enum.QC_FAILED": "Échec du contrôle QC",
  "microbiology.enum.RECEIVED": "Reçu",
  "microbiology.enum.RELEASED": "Publié",
  "microbiology.enum.REPEAT": "Répétez",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "Exécution obligatoire d'un AST à déclarer",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "Tout cycle AST devant faire l'objet d'un rapport doit être examiné",
  "microbiology.enum.RESULT": "Résultat ",
  "microbiology.enum.RESULTS_IN": "Résultats dans",
  "microbiology.enum.RETEST": "Retester",
  "microbiology.enum.REVIEW_READY": "Prêt pour la révision",
  "microbiology.enum.REVIEWED": "Révisé",
  "microbiology.enum.INTERMEDIATE": "Niveau intermédiaire",
  "microbiology.enum.LOST_SPECIMEN": "Échantillon perdu",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "Échantillon perdu - Culture positive",
  "microbiology.enum.NO_BREAKPOINT": "Non, il n'y a pas de point d'arrêt",
  "microbiology.enum.RESISTANT": "Résistant",
  "microbiology.enum.ROUTINE": "Routine",
  "microbiology.enum.SAMPLE_ITEM": "Éléments d’échantillon",
  "microbiology.enum.SETUP": "Configuration",
  "microbiology.enum.SETUP_RECORDED": "Configuration enregistrée",
  "microbiology.enum.SMS": "SMS",
  "microbiology.enum.SPECIMEN_LOST": "Échantillon perdu",
  "microbiology.enum.STAGE_CHANGED": "Changement de scène",
  "microbiology.enum.SUBCULTURE_RECORDED": "Subculture enregistrée",
  "microbiology.enum.UNASSIGNED": "Non attribué",
  "microbiology.enum.UNKNOWN_ERROR": "Erreur inconnue",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "Modification du plan de travail",
  "microbiology.enum.ZONE": "Zone",
  "microbiology.enum.FINAL_RELEASED": "Version finale publiée",
  "microbiology.enum.SUSCEPTIBLE": "Susceptible",
  "microbiology.enum.UNKNOWN": "Inconnu",
  "rulebuilder.label.selectComponent": "Sélectionner un composant",
  "testcalculation.label.selectComponent": "Sélectionner un composant",
  "testcalculation.label.finalComponent": "Composant de résultat",
  "qc.dashboard.tab.bench": "CQ de paillasse",
  "qc.bench.source.all": "Toutes les sources de paillasse",
  "qc.bench.source.manual": "Quantitatif manuel",
  "qc.bench.source.rdt": "Test de diagnostic rapide (TDR)",
  "qc.bench.column.runs": "Contrôles effectués",
  "qc.bench.column.lastRun": "Dernière série",
  "qc.bench.empty": "Aucun contrôle manuel ou d'analyse rapide n'a été enregistré sur cette période.",
  "microbiology.case.activityNote": "Remarque relative à l'activité",
  "microbiology.case.accessionNumber": "Numéro d'Accession",
  "microbiology.case.actionError": "L'opération de culture n'a pas pu être terminée",
  "microbiology.case.action.markNoGrowth": "Mark n'est pas prêt à se développer",
  "microbiology.case.action.recordGrowth": "Une croissance record a été constatée",
  "microbiology.case.action.rejectCase": "Rejeter le dossier",
  "microbiology.case.action.setIncubating": "Lancer l'incubation",
  "microbiology.case.action.startInoculation": "Commencer l'inoculation",
  "microbiology.case.createIsolate": "Créer un isolat",
  "microbiology.case.cultureAction": "Action culturelle",
  "microbiology.case.atmosphere": "Ambiance",
  "microbiology.case.eyebrow": "Table de travail pour la microbiologie",
  "microbiology.case.sectionExpanded": "{section} élargi",
  "microbiology.case.sectionStatus": "Statut de la section",
  "microbiology.case.error": "Erreur relative à un cas de microbiologie",
  "microbiology.case.isolateLabel": "Etiquette « Isoler »",
  "microbiology.case.isolates": "Isolats",
  "microbiology.case.isolates.empty": "Non d'isolat enregistré",
  "microbiology.case.loadError": "Impossible de charger le cas de microbiologie",
  "microbiology.case.lastActivityBy": "Dernière activité de",
  "microbiology.case.incubation": "Incubation",
  "microbiology.case.media": "Support ou bouteille",
  "microbiology.case.nextStage": "Stade suivant",
  "microbiology.case.patient": "Patient",
  "microbiology.case.nonconformanceCount": "{count, plural, one {# ENC} many {# ENC} other {# ENC}}",
  "microbiology.case.relatedWorkflows": "Plan de travail lié aux échantillons",
  "microbiology.case.requestingLocation": "Demande d'emplacement",
  "microbiology.case.preliminaryOrganism": "Organisme préliminaire",
  "microbiology.case.recordActivity": "Activité record",
  "microbiology.case.sampleItem": "Exemple d'élément",
  "microbiology.case.setup": "Inoculation",
  "microbiology.case.setup.hint": "Veuillez enregistrer la configuration initiale, le milieu de culture ou l'étape d'incubation pour cette culture.",
  "microbiology.case.significance": "Importance",
  "microbiology.case.specimenType": "Type d'échantillon",
  "microbiology.case.timeline": "Chronologie de l'affaire",
  "microbiology.case.timeline.addNote": "Ajouter une note",
  "microbiology.case.timeline.auto": "Auto",
  "microbiology.case.timeline.culturePurposeChange": "{from} à l'adresse {to}",
  "microbiology.case.timeline.culturePurposeChanged": "Changement d'orientation culturelle",
  "microbiology.case.timeline.empty": "Aucune activité liée à ce dossier n'a été enregistrée",
  "microbiology.case.timeline.hint": "L'activité relative aux dossiers enregistrés est présentée par ordre chronologique.",
  "microbiology.case.timeline.manual": "Manuel",
  "microbiology.case.timeline.note": "Remarque ou observation",
  "microbiology.case.timeline.noteExpanded": "Remarque développée",
  "microbiology.case.timeline.performedBy": "Interprétée par {actor}",
  "microbiology.case.timeline.saveNote": "Enregistrer la note",
  "microbiology.case.timeline.showAll": "Afficher tous les événements « {count} »",
  "microbiology.case.timeline.showRecent": "Afficher les événements récents de l'{count}",
  "microbiology.case.events": "événements",
  "microbiology.case.finalLocked.message": "Les modifications relatives aux isolats et aux AST sont désactivées après la mise en production définitive.",
  "microbiology.case.finalLocked.title": "La dernière case est en lecture seule",
  "microbiology.case.title": "Cas de microbiologie",
  "microbiology.inoculation.addSubculture": "Ajouter une sous-culture",
  "microbiology.inoculation.empty": "Aucun support n'a encore été enregistré. Veuillez commencer l'inoculation pour commencer.",
  "microbiology.inoculation.hint": "Enregistrez chaque flacon ou chaque plaque et conservez la traçabilité de sa culture.",
  "microbiology.inoculation.identifier": "IDENTIFIANT de la bouteille ou de l'assiette",
  "microbiology.inoculation.identifierHint": "Scannez ou saisissez l'identifiant.",
  "microbiology.inoculation.parent": "Médias parents",
  "microbiology.inoculation.parentPlaceholder": "Choisissez la bouteille ou l'assiette d'origine",
  "microbiology.inoculation.primaryExpanded": "Formulaire de vaccination (version détaillée)",
  "microbiology.inoculation.primary": "Primaire",
  "microbiology.inoculation.recorded": "Supports enregistrés",
  "microbiology.inoculation.save": "Enregistrer les fichiers multimédias",
  "microbiology.inoculation.source": "Source",
  "microbiology.inoculation.start": "Commencer l'inoculation",
  "microbiology.inoculation.subcultureExpanded": "Formulaire « Sous-culture » développé",
  "microbiology.inoculation.subculture": "Sous-culture",
  "microbiology.amendment.actionError": "L'opération de modification n'a pas pu être terminée",
  "microbiology.amendment.cancel": "Annuler la modification",
  "microbiology.amendment.cancelReason": "Motif d'annulation",
  "microbiology.amendment.cancelled": "Modification annulée ; le dossier final est à nouveau verouillé",
  "microbiology.amendment.correctsVersion": "Corrige la versión {number}",
  "microbiology.amendment.hint": "Corrigez un rapport final sans modifier son Historique de versions.",
  "microbiology.amendment.history": "Historique des modifications",
  "microbiology.amendment.inProgress.message": "Enregistrez la correction, puis validez ou annulez cette modification afin de verrouiller à nouveau le dossier.",
  "microbiology.amendment.inProgress.title": "Modification en cours",
  "microbiology.amendment.noReportVersions": "Aucune version du rapport final n'a été enregistrée",
  "microbiology.amendment.none": "Aucun amendement n'a été enregistré",
  "microbiology.amendment.number": "Amendement",
  "microbiology.amendment.numberValue": "Amendement n° {number}",
  "microbiology.amendment.open": "Amendement ouvert",
  "microbiology.amendment.opened": "La modification est ouverte ; les corrections cliniques sont désormais activées",
  "microbiology.amendment.reason": "Motif de la modification",
  "microbiology.amendment.release": "Publier le rapport modifié",
  "microbiology.amendment.released": "Publication du rapport modifié ; l'affaire est à nouveau verouillée sans suite",
  "microbiology.amendment.reportVersions": "Versions publiées du rapport",
  "microbiology.amendment.status": "Statut",
  "microbiology.amendment.status.closed": "Non d'amendement en cours d'examen",
  "microbiology.amendment.status.open": "Amendement ouvert",
  "microbiology.amendment.title": "Modifications",
  "microbiology.amendment.version": "Version{number}",
  "microbiology.ast.antibiotic": "Antibiotique",
  "microbiology.ast.acceptResults": "Valider les résultats",
  "microbiology.ast.acknowledgeFlags": "Accuser réception des signalements examinés",
  "microbiology.ast.analyzer": "Analyseur",
  "microbiology.ast.analyzerOrganism": "Analyseur : {organism} ({confidence}%)",
  "microbiology.ast.analyzerProvenance": "{card} de cartes ou de panneaux · {version} de logiciels",
  "microbiology.ast.analyzerResolutionReason": "Cause et action corrective",
  "microbiology.ast.actionError": "L'action AST n'a pas pu être terminée",
  "microbiology.ast.adjustPanel": "Panneau de réglage",
  "microbiology.ast.orderedAntibiotics": "Antibiotiques pour les analyses",
  "microbiology.ast.actions": "Actions",
  "microbiology.ast.applyOverride": "Appliquer la dérogation",
  "microbiology.ast.attempt": "Tentative",
  "microbiology.ast.attemptMethod": "Méthode « Attempt »",
  "microbiology.ast.attemptNumber": "Tentative {number}",
  "microbiology.ast.attemptReason": "Motif",
  "microbiology.ast.attemptScope": "Portée de la répétition",
  "microbiology.ast.attempts": "Tentatives d'AST",
  "microbiology.ast.attemptType": "Type de tentative",
  "microbiology.ast.awaitingAnalyzerResults": "En attente des résultats d'analyse",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "Les résultats s'afficheront automatiquement dès que l'analyseur connecté les aura envoyés. Les événements non mis en correspondance sont conservés dans la section « Problèmes d'importation de l'analyseur ».",
  "microbiology.ast.awaitingSetupCount": "{count} en attente de configuration",
  "microbiology.ast.cardId": "Identifiant de la carte ou du panneau",
  "microbiology.ast.entryMode": "Saisie des résultats",
  "microbiology.ast.entryMode.analyzer": "Analyseur connecté",
  "microbiology.ast.entryMode.manual": "Saisie manuelle",
  "microbiology.ast.expertFlags": "Les alertes générées par les experts des analyseurs doivent faire l'objet d'un examen",
  "microbiology.ast.hideOriginal": "Masquer l'historique",
  "microbiology.ast.historyTo": "à",
  "microbiology.ast.interpretation": "Interpretation",
  "microbiology.ast.instrumentInterpretation": "Analyseur : {interpretation}",
  "microbiology.ast.invalidateAndRepeat": "Annuler et commencer une nouvelle exécution",
  "microbiology.ast.includedInReport": "Inclus dans le rapport",
  "microbiology.ast.initialAttemptReason": "Première tentative",
  "microbiology.ast.isolate": "Isoler",
  "microbiology.ast.method": "Méthodes",
  "microbiology.ast.matchedBy": "Point d'arrêt correspondant",
  "microbiology.ast.measurement.mic": "MIC (µg/mL)",
  "microbiology.ast.measurement.zone": "Diamètre de la zone (mm)",
  "microbiology.ast.noBreakpointGuidance": "Il n'y a pas de seuil de coupure standard. Veuillez interpréter ce résultat conformément à la procédure opérationnelle standard locale.",
  "microbiology.ast.noBreakpointTitle": "Une interprétation locale est nécessaire",
  "microbiology.ast.noIsolate": "Créez un isolat avant d'enregistrer l'AST",
  "microbiology.ast.noSourceAttempt": "Première tentative",
  "microbiology.ast.notIncludedInReport": "Non inclus",
  "microbiology.ast.newAttempt": "Nouvelle répétition ou retest",
  "microbiology.ast.noRunsYet": "Non de points marqués pour l'instant",
  "microbiology.ast.antibioticToRepeat": "Antibiotique à renouveler",
  "microbiology.ast.override": "Interprétation prévalente",
  "microbiology.ast.overrideHistory": "Historique des modifications",
  "microbiology.ast.optionsExpanded": "{section} options développées.",
  "microbiology.ast.overrideReason": "Motif de la dérogation",
  "microbiology.ast.orderedPanel": "Panneau AST prescrit",
  "microbiology.ast.organismMismatch": "L'analyseur utilisé pour l'analyse diffère de l'isolat du cas",
  "microbiology.ast.organismMismatchDetail": "L'identification effectuée par l'analyseur est donnée à titre indicatif. Vérifiez cette divergence ; l'isolat du cas confirmé fait toujours autorité.",
  "microbiology.ast.overrideQc": "Ignorer l'indicateur de QC",
  "microbiology.ast.panel": "Panneau AST",
  "microbiology.ast.panelAdjustmentReason": "Motif de l'ajustement du panneau",
  "microbiology.ast.panelProvenance.organismDefault": "Prescrits selon les paramètres par défaut configurés pour l'organisme identifié",
  "microbiology.ast.rawValue": "Valeur du résultat",
  "microbiology.ast.qcFailed": "Echec du contrôle QC de l'analyseur",
  "microbiology.ast.qcFailedDetail": "Référence de contrôle qualité : {reference}. L'acceptation des résultats est bloquée jusqu'à ce que cette série d'analyses soit invalidée ou qu'un superviseur consigne une dérogation.",
  "microbiology.ast.replacementCardId": "Nouvel identifiant de carte ou de panneau",
  "microbiology.ast.resultsReady": "Les résultats de l'analyse sont prêts à être examinés",
  "microbiology.ast.resultsReadyDetail": "Vérifiez les divergences, les points d'arrêt manquants et les signalements des experts avant de valider ces résultats.",
  "microbiology.ast.runsComplete": "{complete} / La série « {total} » est terminée",
  "microbiology.ast.pendingIdentificationCount": "{count} en attente d'identification",
  "microbiology.ast.reasonForAttempt": "Motif de la répétition ou du retest",
  "microbiology.ast.recordReading": "Enregistrer la valeur de l'AST",
  "microbiology.ast.reviewRun": "Analyse de la session AST",
  "microbiology.ast.repeat": "Répétez",
  "microbiology.ast.revertOverride": "Revenir à la version d'origine",
  "microbiology.ast.revertReason": "Motif de l'annulation de la modification",
  "microbiology.ast.reporting": "Rapports",
  "microbiology.ast.retest": "Retester",
  "microbiology.ast.selectAntibiotic": "Sélectionnez un antibiotique",
  "microbiology.ast.singleAntibiotic": "Un seul antibiotique",
  "microbiology.ast.wholePanel": "L'ensemble des panneaux",
  "microbiology.ast.runStatus": "Statut d'exécution de l'AST",
  "microbiology.ast.startRun": "Commencer l'exécution de l'AST",
  "microbiology.ast.startAttempt": "Commencer une tentative {type}",
  "microbiology.ast.sourceAttempt": "Source",
  "microbiology.ast.source": "Source de lecture",
  "microbiology.ast.showOriginal": "Afficher l'original",
  "microbiology.ast.title": "Manuel AST",
  "microbiology.ast.useAttemptForReporting": "Veuillez utiliser l'adresse {number} pour signaler tout problème.",
  "microbiology.ast.useForReporting": "À utiliser pour l'établissement de rapports",
  "microbiology.ast.view": "Voir",
  "microbiology.ast.viewAttempt": "Voir la tentative {number}",
  "microbiology.ast.viewing": "Affichage",
  "microbiology.ast.viewingAttempt": "Tentative de consultation {number}",
  "microbiology.critical.acknowledge": "Accuser réception",
  "microbiology.critical.followUp": "Un suivi est nécessaire",
  "microbiology.critical.hint": "Enregistrez les rappels de résultats critiques et accusez-en réception directement dans le code.",
  "microbiology.critical.log": "Journal des communications",
  "microbiology.critical.logForIsolate": "Enregistrer une notification critique pour l'{isolate}",
  "microbiology.critical.logNotification": "Enregistrer une notification critique",
  "microbiology.critical.method": "Méthode de communication",
  "microbiology.critical.message": "Message",
  "microbiology.critical.messageRequired": "Un message est obligatoire",
  "microbiology.critical.none": "Non de communication critique enregistrée",
  "microbiology.critical.recipient": "Destinataire",
  "microbiology.critical.recipientContact": "Coordonnées du destinataire",
  "microbiology.critical.required": "Choisissez une cible, puis indiquez le destinataire et le message.",
  "microbiology.critical.resolution": "Remarque relative à la résolution",
  "microbiology.critical.resolutionRequired": "Une note de résolution est requise avant de fermer la communication.",
  "microbiology.critical.close": "Une communication étroite",
  "microbiology.critical.target": "Objectif de résultat critique",
  "microbiology.critical.targetId": "Enregistrement cible",
  "microbiology.critical.title": "Communication critique",
  "microbiology.caseInfo.no": "No",
  "microbiology.caseInfo.notProvided": "Non fourni",
  "microbiology.caseInfo.summary": "Résumé des informations relatives à l'affaire",
  "microbiology.caseInfo.yes": "Yes",
  "microbiology.currentStep.open": "{step} ouverte",
  "microbiology.currentStep.title": "Étape actuelle",
  "microbiology.cultureAction.error": "Il n'a pas été possible de mettre à jour l'état de la culture.",
  "microbiology.cultureAction.noGrowth.confirm": "Confirmez qu'il n'y a pas de croissance",
  "microbiology.cultureAction.noGrowth.detail": "Confirmez que la période d'incubation requise est terminée et qu'aucune prolifération n'a été détectée.",
  "microbiology.cultureAction.noGrowth.title": "Indiquez que la culture n'a pas de croissance",
  "microbiology.cultureAction.positive.confirm": "Confirmer le signal positif",
  "microbiology.cultureAction.positive.detail": "Confirmez que le résultat est positif. L'étape suivante consiste à réaliser une culture secondaire et à consigner les résultats de la coloration de Gram.",
  "microbiology.cultureAction.positive.title": "Indiquez « culture positive »",
  "microbiology.nce.category": "Catégorie",
  "microbiology.nce.configurationBlockerTitle": "Configuration requise",
  "microbiology.nce.configurationLoadError": "Les catégories d'ÉCN et les unités de rapport n'ont pas pu être chargées.",
  "microbiology.nce.critical": "Critique",
  "microbiology.nce.description": "Description",
  "microbiology.nce.disposition": "Disposition",
  "microbiology.nce.errorTitle": "Il n'a pas été possible de signaler la non-conformité",
  "microbiology.nce.flagOnly": "Drapeau uniquement",
  "microbiology.nce.immediateAction": "Mesures immédiates",
  "microbiology.nce.lostTypeMissing": "La configuration actuelle du NCE ne comprend pas de type « Échantillon perdu ».",
  "microbiology.nce.major": "Majeur",
  "microbiology.nce.markLost": "Mark a perdu",
  "microbiology.nce.markLostHint": "Enregistrez l'échantillon physique comme perdu et rejetez les analyses en cours concernées.",
  "microbiology.nce.markLostTitle": "Perte d'un échantillon de référence",
  "microbiology.nce.minor": "Mineur",
  "microbiology.nce.rejectTests": "Rejeter les analyses concernées",
  "microbiology.nce.retest": "Retester l'AST",
  "microbiology.nce.retestLoadError": "Les séries de tests AST déjà évaluées n'ont pas pu être chargées. Veuillez réessayer avant de sélectionner « Retester l'AST ».",
  "microbiology.nce.sourceAstRun": "Nouvelle exécution de l'AST pour retester",
  "microbiology.nce.report": "Signaler une non-conformité",
  "microbiology.nce.reportHint": "Enregistrez une non-conformité concernant cet échantillon et choisissez la suite à y donner.",
  "microbiology.nce.reportingUnit": "Unité de rapport",
  "microbiology.nce.reportTitle": "Rapport sur une non-conformité",
  "microbiology.nce.required": "Choisissez une catégorie, une unité de rapport et une gravité, puis fournissez une description.",
  "microbiology.nce.sectionTitle": "Non-conformité",
  "microbiology.nce.severity": "Gravité",
  "microbiology.nce.submitError": "La non-conformité n'a pas pu être enregistrée.",
  "microbiology.nce.title": "Titre",
  "microbiology.nce.type": "Type",
  "microbiology.isolate.identify": "Identifier l'organisme",
  "microbiology.isolate.reidentify": "Réidentifier",
  "microbiology.isolate.identified": "Identifié",
  "microbiology.isolate.pending": "Identification en attente",
  "microbiology.isolate.gramStain": "Coloration de Gram",
  "microbiology.isolate.colonyMorphology": "Morphologie de la colonie",
  "microbiology.isolate.identification": "Identification",
  "microbiology.isolate.identificationMethod": "Méthode d'identification de l'IDENTIFIANT",
  "microbiology.isolate.identificationConfidence": "Confiance dans l'IDENTIFIANT (%)",
  "microbiology.isolate.identificationChange": "{previous} {next} : {reason}",
  "microbiology.isolate.identificationHistory": "Historique des identifications",
  "microbiology.isolate.identificationReason": "Motif de la réidentification",
  "microbiology.isolate.organism.select": "Sélectionnez un organisme",
  "microbiology.isolate.unidentified": "Non identifié",
  "microbiology.ast.identificationRequired": "Identifiez l'isolat avant de mettre en place le test de sensibilité aux antibiotiques.",
  "microbiology.next.createIsolate": "Inoculation enregistrée. Ajoutez une croissance significative ou marquez le cas comme prêt à être traité en l'absence de croissance.",
  "microbiology.next.completeAmendment": "La modification est ouverte. Veuillez enregistrer la correction, relire le rapport, puis publier la version modifiée.",
  "microbiology.next.finalReleased": "Le rapport final a été publié. Vérifiez que les mesures de surveillance sont en place avant l'exportation.",
  "microbiology.next.incubating": "Incubation. Indiquez que le cas est positif dès l'apparition d'une croissance, ou indiquez « non de croissance » une fois la période d'incubation requise terminée.",
  "microbiology.next.subculturePositive": "Signal positif enregistré. Procédez à une sous-culture du flacon et notez le résultat de la coloration de Gram.",
  "microbiology.next.recordSetup": "Dossier reçu. Enregistrez la configuration initiale pour lancer l'incubation.",
  "microbiology.next.release": "L'AST a procédé à la révision. Veuillez confirmer que le rapport est prêt et publier le rapport final.",
  "microbiology.next.noGrowthRelease": "Aucune croissance n'a été enregistrée. Veuillez examiner et publier le rapport final négatif.",
  "microbiology.next.reviewAst": "Isolat enregistré. L'AST doit être terminé et vérifié avant la sortie.",
  "microbiology.next.title": "Étape suivante",
  "microbiology.navigation.backToWorklist": "Retour à la liste des tâches de microbiologie",
  "microbiology.navigation.menu": "Microbiologie",
  "microbiology.navigation.worklist": "Liste des analyses de microbiologie",
  "order.context.workflowProgress": "Suivi de l'avancement du traitement des commandes",
  "microbiology.culturePurpose.clinical": "Diagnostic clinique ou traitement",
  "microbiology.culturePurpose.label": "Objectif culturel",
  "microbiology.culturePurpose.screening": "Dépistage actif ou portage",
  "microbiology.culturePurpose.unspecified": "Non précisé",
  "microbiology.orderDetail.antibioticExposure": "La patiente a récemment suivi un traitement antibiotique (au cours des deux dernières semaines)",
  "microbiology.orderDetail.admissionDate": "Date d'admission",
  "microbiology.orderDetail.admissionDateFuture": "La date d'admission ne peut pas être postérieure à la date du présent.",
  "microbiology.orderDetail.admissionDateHelper": "Date d'admission en hospitalisation. Ne rien indiquer si cette date n'est pas connue.",
  "microbiology.orderDetail.admissionDateOutpatient": "Les patients en consultation externe ne sont pas admis ; ils sont enregistrés comme provenant de la communauté.",
  "microbiology.orderDetail.collectionDateContext": "Date de prélèvement : {date}",
  "microbiology.orderDetail.collectionTimingHospital": "{days} prélevées quelques jours après l'admission – données provenant de l'hôpital à des fins de surveillance.",
  "microbiology.orderDetail.collectionTimingCommunity": "{days} prélevées quelques jours après l'admission – origine communautaire à des fins de surveillance.",
  "microbiology.orderDetail.clinicalHistory": "Antécédents cliniques",
  "microbiology.orderDetail.cultureMethod": "Protocole culturel",
  "microbiology.orderDetail.hint": "Enregistrez les informations relatives à la demande dont le laboratoire a besoin pour la configuration de la culture et le suivi des résultats critiques.",
  "microbiology.orderDetail.numberOfSets": "Nombre de séries",
  "microbiology.orderDetail.numberOfSets.helper": "Les groupes de prélèvements, tels que deux kits d'hémoculture provenant de sites différents. Il ne s'agit pas du nombre ni du volume des échantillons.",
  "microbiology.orderDetail.patientOrigin": "Origine des patients",
  "microbiology.orderDetail.protocolDerived": "Dérivé",
  "microbiology.orderDetail.protocolHelper": "De l'examen prescrit. Modifiez-le au laboratoire si les résultats diffèrent.",
  "microbiology.orderDetail.protocolUnset": "Non défini : le laboratoire sélectionnera un protocole",
  "microbiology.orderDetail.protocolUnsetTitle": "Protocole non défini",
  "microbiology.orderDetail.save": "Enregistrer les détails de la commande",
  "microbiology.orderDetail.title": "Détails de la commande",
  "microbiology.patientOrigin.emergency": "Service des urgences",
  "microbiology.patientOrigin.icu": "Unité de soins intensifs",
  "microbiology.patientOrigin.inpatient": "Service d'hospitalisation",
  "microbiology.patientOrigin.other": "Autre",
  "microbiology.patientOrigin.outpatient": "Service de consultations externes",
  "microbiology.progress.ast": "Résultats de l'AST",
  "microbiology.progress.caseInfo": "Informations sur l'affaire",
  "microbiology.progress.inoculation": "Inoculation",
  "microbiology.progress.isolates": "Isolats",
  "microbiology.progress.reports": "Rapports",
  "microbiology.progress.review": "Avis d'expert",
  "microbiology.progress.timeline": "Chronologie",
  "microbiology.progress.title": "Suivi des dossiers",
  "microbiology.protocol.noneTitle": "Non de protocole défini",
  "microbiology.case.timeline.protocolChanged": "Le protocole de culture a été modifié, passant de {from} à {to} : {reason}",
  "microbiology.readiness.blocked": "La publication définitive a été bloquée",
  "microbiology.readiness.ready": "Version finale prête",
  "microbiology.reagentLots.blocked": "Bloqué : {reason}",
  "microbiology.reagentLots.context": "Contexte de l'essai sur banc",
  "microbiology.reagentLots.context.AST_SETUP": "Configuration de l'AST",
  "microbiology.reagentLots.context.CULTURE_SETUP": "Configuration de la culture",
  "microbiology.reagentLots.empty": "Non, aucun réactif n'est associé à ce test.",
  "microbiology.reagentLots.fefo": "FEFO - « premier entré, premier sorti »",
  "microbiology.reagentLots.fifo.tooltip": "Les lots sont classés par date de péremption la plus proche, puis par date de réception lorsque la date de péremption n'est pas disponible.",
  "microbiology.reagentLots.hint": "Veuillez sélectionner le lot exact utilisé pour chaque réactif ou consommable associé.",
  "microbiology.reagentLots.history": "Utilisation enregistrée des parcelles",
  "microbiology.reagentLots.legend": "Lots disponibles pour « {reagent} »",
  "microbiology.reagentLots.lot": "Lot",
  "microbiology.reagentLots.noExpiry": "Non, aucune date d'expiration n'a été enregistrée",
  "microbiology.reagentLots.noLots": "Il n'y a aucun lot disponible pour ce réactif.",
  "microbiology.reagentLots.option": "{lot}, {quantity} {unit} disponible, expire le {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "Quantité par test : {quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} Le lot « {lot} » est expiré ; veuillez choisir un autre lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} Le lot {lot} n'est plus disponible en quantité suffisante ; veuillez choisir un autre lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} Le lot {lot} a connu un échec au QC ; veuillez choisir un lot ayant réussi le QC.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} Le lot {lot} n'a pas passé le QC ; veuillez choisir un lot ayant passé le QC.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} Le lot {lot} n'est plus disponible ; veuillez actualiser la page et choisir un autre lot.",
  "microbiology.reagentLots.qc.FAILED": "Échec du contrôle QC",
  "microbiology.reagentLots.qc.PASSED": "QC validé",
  "microbiology.reagentLots.qc.PENDING": "QC en attente",
  "microbiology.reagentLots.qc.QUARANTINED": "Mise en quarantaine par le service de QC",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "Consommé",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "Expiré",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "Inactif",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "Quantité insuffisante",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "Échec du contrôle QC",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "QC non validé",
  "microbiology.reagentLots.reagent": "Réactif ou consommable",
  "microbiology.reagentLots.recorded": "Enregistré",
  "microbiology.reagentLots.role.PRIMARY": "Primaire",
  "microbiology.reagentLots.role.SECONDARY": "Secondaire",
  "microbiology.reagentLots.scan.ambiguous": "Ce numéro de lot correspond à plusieurs réactifs associés. Veuillez sélectionner le lot dans la liste des réactifs.",
  "microbiology.reagentLots.scan.label": "Scannez ou saisissez le numéro de lot",
  "microbiology.reagentLots.scan.notFound": "Non, aucun lot associé ne correspond à ce numéro de lot.",
  "microbiology.reagentLots.scan.placeholder": "Scannez ou saisissez le numéro de lot exact",
  "microbiology.reagentLots.scan.selected": "Lot sélectionné : « {lot} ».",
  "microbiology.reagentLots.status": "Statut actuel du lot",
  "microbiology.reagentLots.status.ACTIVE": "Active",
  "microbiology.reagentLots.status.CONSUMED": "Consommé",
  "microbiology.reagentLots.status.IN_USE": "Utilisé",
  "microbiology.reagentLots.title": "Traçabilité des réactifs et des lots",
  "microbiology.reagentLots.used": "Quantité utilisée",
  "microbiology.release.failed": "Le rapport n'a pas pu être publié. Vérifiez les conditions requises et réessayez.",
  "microbiology.release.final": "Publication du rapport final",
  "microbiology.release.finalReleased": "Publication du rapport final",
  "microbiology.release.hint": "Ne publiez les rapports que lorsque les contrôles de préparation ont été validés.",
  "microbiology.release.mappingConfigured": "Configuration de la cartographie des déclarations des patients",
  "microbiology.release.mappingRequired": "La mise en correspondance des données déclarées par les patients est nécessaire pour la publication définitive",
  "microbiology.release.noReportableContent": "Non de contenu microbiologique à communiquer n'est disponible.",
  "microbiology.release.notEvaluated": "L'état de préparation n'a pas encore été évalué",
  "microbiology.release.patientReport": "Aperçu du rapport du patient",
  "microbiology.release.preliminary": "Publication du rapport préliminaire",
  "microbiology.release.readinessChecks": "État de préparation à la mise en production définitive",
  "microbiology.release.title": "État d'avancement du rapport",
  "microbiology.release.viewPatientResults": "Voir les résultats des analyses des patients",
  "microbiology.release.useAmendment": "Publiez la version corrigée issue des modifications",
  "microbiology.release.whonetChecks": "État de préparation de WHONET",
  "microbiology.whonet.blocked": "Exportation WHONET bloquée",
  "microbiology.whonet.ready": "Prêt pour l'exportation vers WHONET",
  "microbiology.worklist.clearFilters": "Effacer les filtres",
  "microbiology.worklist.column.action": "Action",
  "microbiology.worklist.column.context": "Contexte",
  "microbiology.worklist.column.due": "Mesures appropriées",
  "microbiology.worklist.column.flags": "Drapeaux",
  "microbiology.worklist.column.isolate": "Isoler",
  "microbiology.worklist.column.labNumber": "N° de laboratoire",
  "microbiology.worklist.column.lastActivity": "Dernière activité de",
  "microbiology.worklist.column.organism": "Organismes",
  "microbiology.worklist.column.panel": "Panneau",
  "microbiology.worklist.column.patient": "Patient",
  "microbiology.worklist.column.priority": "Priorité",
  "microbiology.worklist.column.sample": "Exemple d'élément",
  "microbiology.worklist.column.specimen": "Échantillon",
  "microbiology.worklist.column.stage": "Stade",
  "microbiology.worklist.column.started": "Démarré",
  "microbiology.worklist.column.status": "Statut",
  "microbiology.worklist.column.urgency": "Urgence",
  "microbiology.worklist.critical": "Communication critique",
  "microbiology.worklist.dueDetail.ast_entry": "Mettez en place un test AST pour l'isolat identifié.",
  "microbiology.worklist.dueDetail.ast_review": "Examinez les résultats des tests de sensibilité.",
  "microbiology.worklist.dueDetail.case_review": "Vérifier que le rapport est prêt et valider sa publication.",
  "microbiology.worklist.dueDetail.isolate_id": "Enregistrez la croissance et identifiez l'isolat.",
  "microbiology.worklist.dueDetail.incubating": "Jour n°{day} de « {max} »",
  "microbiology.worklist.dueDetail.setup": "Enregistrez les paramètres de configuration de la culture initiale.",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "Réalisez une culture et enregistrez les résultats de la coloration de Gram.",
  "microbiology.worklist.empty.ast": "Non, aucune exécution AST ne correspond. Effacez les critères de recherche ou sélectionnez un autre statut.",
  "microbiology.worklist.empty.cultures": "Non, aucune culture ne correspond. Effacez les critères de recherche ou choisissez un autre statut.",
  "microbiology.worklist.expertRulesUnavailable": "Les indicateurs de règles d’experts OpenELIS sont disponibles dans la phase 1B. Les indicateurs signalés par les Analyseurs s’affichent lorsqu’ils sont présents.",
  "microbiology.worklist.filters": "Filtres de la liste de tâches",
  "microbiology.worklist.filter.allActions": "Toutes les actions",
  "microbiology.worklist.filter.allStages": "Tous les stades",
  "microbiology.worklist.filter.allUrgencies": "Tous les niveaux d'urgence",
  "microbiology.worklist.filter.activeAst": "Travail actif",
  "microbiology.worklist.filter.astStatus": "Statut AST",
  "microbiology.worklist.filter.dueAction": "Mesures appropriées",
  "microbiology.worklist.filter.reviewed": "Révisé",
  "microbiology.worklist.filter.stage": "Stade",
  "microbiology.worklist.filter.urgency": "Urgence",
  "microbiology.worklist.flagsUnavailable": "Règles d'expert (phase 1B)",
  "microbiology.worklist.loadError.subtitle": "La file d'attente n'a pas pu être chargée. Veuillez actualiser la page.",
  "microbiology.worklist.loadError.title": "Impossible de charger la liste de travail de microbiologie",
  "microbiology.worklist.editAst": "Modifier l'AST",
  "microbiology.worklist.grain.ast": "Les courses AST",
  "microbiology.worklist.grain.cultures": "Cultures",
  "microbiology.worklist.notSet": "Non défini",
  "microbiology.worklist.notStarted": "Non commencé",
  "microbiology.worklist.markLost": "Mark a perdu",
  "microbiology.worklist.markNoGrowth": "Non de croissance",
  "microbiology.worklist.markPositive": "Marquer comme positif",
  "microbiology.worklist.openCase": "Dossier ouvert",
  "microbiology.worklist.newAstAttempt": "Configurer une nouvelle exécution AST",
  "microbiology.worklist.newPositive": "Nouveau cas positif",
  "microbiology.worklist.phase1b": "Disponible dans le cadre de la phase 1B",
  "microbiology.worklist.print": "Imprimer la liste",
  "microbiology.worklist.qcDashboard": "Tableau de bord CQ",
  "microbiology.worklist.queueStatus": "File d'attente partagée",
  "microbiology.worklist.refresh": "Actualiser maintenant",
  "microbiology.worklist.rowActions": "Actions sur les lignes",
  "microbiology.worklist.recentActivity.empty": "Aucune activité récente en microbiologie.",
  "microbiology.worklist.recentActivity.title": "Activité récente ({count})",
  "microbiology.worklist.resistance.hint": "Les alertes signalées par l'analyseur ont été terminées aujourd'hui ; la détection par règles d'experts dans OpenELIS reste en phase 1B.",
  "microbiology.worklist.resistance.title": "Les niveaux de résistance atteints aujourd'hui",
  "microbiology.worklist.search.ast": "Rechercher un numéro de laboratoire, un patient, un isolat, un micro-organisme ou un panel",
  "microbiology.worklist.search.cultures": "Rechercher un numéro de laboratoire, un patient, un échantillon ou un plan de travail",
  "microbiology.worklist.sharedQueue": "File d'attente commune du laboratoire",
  "microbiology.worklist.setupAst": "Configurer AST",
  "microbiology.worklist.sort": "Trier",
  "microbiology.worklist.sort.newest": "Dernière activité",
  "microbiology.worklist.sort.priority": "Priorité",
  "microbiology.worklist.sort.workflow": "Plan de travail",
  "microbiology.worklist.subtitle": "Classez les cas de culture par ordre de priorité en fonction du stade du plan de travail, du degré d'urgence et de l'intervention requise de la part du laboratoire.",
  "microbiology.worklist.summary.astReview": "Analyse de l'AST",
  "microbiology.worklist.summary.astInProgress": "En cours",
  "microbiology.worklist.summary.astInQueue": "En attente",
  "microbiology.worklist.summary.astPendingSetup": "Configuration en attente",
  "microbiology.worklist.summary.astResultsIn": "Résultats à venir - en cours d'examen",
  "microbiology.worklist.summary.caseReview": "Prêt pour l'examen du dossier",
  "microbiology.worklist.summary.critical": "Suivis critiques en cours",
  "microbiology.worklist.summary.growthDetected": "Croissance détectée",
  "microbiology.worklist.summary.hint": "Sélectionnez une file d'attente pour mettre à jour la liste des dossiers.",
  "microbiology.worklist.summary.identification": "Identification en cours",
  "microbiology.worklist.summary.incubating": "En incubation",
  "microbiology.worklist.summary.positive": "Positif",
  "microbiology.worklist.summary.expertFlags": "Indicateurs d'expert (1B)",
  "microbiology.worklist.summary.title": "Tâches nécessitant une intervention",
  "microbiology.worklist.summary.totalPending": "Total en attente",
  "microbiology.worklist.table.hint": "Les dossiers sont classés par ordre d'urgence et en fonction de la prochaine mesure à prendre.",
  "microbiology.worklist.table.astTitle": "Les courses AST",
  "microbiology.worklist.table.title": "Dossiers de microbiologie en cours",
  "microbiology.worklist.viewAudit": "Voir l'audit",
  "microbiology.worklist.viewReviewedAst": "Voir l'AST révisé",
  "microbiology.worklist.whonetExport": "Exporter vers WHONET",
  "microbiology.worklist.surveillance.title": "Portée de la surveillance",
  "microbiology.worklist.surveillance.description": "Affinez la sélection des lignes AST par période de déclaration et par champs de surveillance structurés. Les filtres opérationnels de la file d'attente ne modifient pas l'ensemble des données exportées.",
  "microbiology.worklist.ast.automaticResults": "Les résultats de l'analyseur vous sont communiqués automatiquement",
  "microbiology.worklist.ast.automaticResultsDetail": "Les appareils connectés envoient directement les résultats au dossier. Les événements ayant connu un échec ou ne correspondant à aucun dossier sont conservés dans la section « Problèmes d'importation » de l'Analyseur.",
  "microbiology.worklist.ast.awaitingResults": "En attente des résultats d'analyse",
  "microbiology.worklist.ast.pendingIdentification": "Identification en attente",
  "microbiology.worklist.ast.resultsInBadge": "Résultats dans",
  "microbiology.worklist.title": "Liste des analyses de microbiologie",
  "microbiology.worklist.updated": "Mis à jour il y a {seconds}· Actualisation automatique toutes les 30 secondes",
  "microbiology.admin.action.deactivate": "Désactiver",
  "microbiology.admin.action.moveDown": "Descendre",
  "microbiology.admin.action.moveUp": "Remonter",
  "microbiology.admin.action.reactivate": "Réactiver",
  "microbiology.admin.actions": "Actions sur les lignes",
  "microbiology.admin.antibiotics.add": "Ajouter un antibiotique",
  "microbiology.admin.antibiotics.description": "Vocabulaire relatif aux agents antimicrobiens utilisé par les groupes d'experts de l'AST et règles relatives aux seuils de sensibilité.",
  "microbiology.admin.antibiotics.edit": "Antibiotique",
  "microbiology.admin.antibiotics.title": "Antibiotiques",
  "microbiology.admin.astPanels.add": "Ajouter un panneau AST",
  "microbiology.admin.astPanels.antibiotic": "Antibiotique",
  "microbiology.admin.astPanels.behavior.always": "Toujours",
  "microbiology.admin.astPanels.behavior.cascade": "Cascade",
  "microbiology.admin.astPanels.behavior.resistant": "Uniquement en cas de résistance",
  "microbiology.admin.astPanels.current": "Actuel",
  "microbiology.admin.astPanels.confirmDeactivate": "La version « {version} » sera-t-elle considérée comme indisponible pour les nouveaux travaux ? Les analyses AST existantes conserveront la version originale de leur panel.",
  "microbiology.admin.astPanels.confirmPublish": "Version de publication {version} ? Les exécutions AST existantes conserveront la version originale de leur panel.",
  "microbiology.admin.astPanels.confirmTitle": "Confirmer la publication du panneau",
  "microbiology.admin.astPanels.historical": "Historique",
  "microbiology.admin.astPanels.loadingEditor": "Le chargement de l'interface d'administration du panel AST est en cours.",
  "microbiology.admin.astPanels.publishVersion": "Publier une nouvelle version",
  "microbiology.admin.astPanels.readOnly": "Cette version historique est en lecture seule. Veuillez ouvrir la version actuelle pour publier une modification.",
  "microbiology.admin.astPanels.reportBehavior": "Signaler un comportement",
  "microbiology.admin.astPanels.tier": "Niveau",
  "microbiology.admin.astPanels.title": "Panneaux AST",
  "microbiology.admin.astPanels.version": "Version",
  "microbiology.admin.astPanels.versionNotice": "L'enregistrement crée un nouveau panneau ; les exécutions AST existantes conservent leur version d'origine.",
  "microbiology.admin.astPanels.viewVersion": "Voir la version",
  "microbiology.admin.breakpoints.activate": "Activer le mode standard",
  "microbiology.admin.breakpoints.applyValid": "Appliquer les lignes valides",
  "microbiology.admin.breakpoints.archive": "Norme d'archivage",
  "microbiology.admin.breakpoints.archiveConfirm": "Cet étalon restera disponible pour les exécutions AST antérieures, mais ne pourra pas être sélectionné pour les nouveaux travaux.",
  "microbiology.admin.breakpoints.back": "Retour aux étalons",
  "microbiology.admin.breakpoints.breakpointType": "Type de point d'arrêt",
  "microbiology.admin.breakpoints.chooseFile": "Choisir un fichier CSV",
  "microbiology.admin.breakpoints.correction.add": "Ajouter une correction locale",
  "microbiology.admin.breakpoints.correction.edit": "Modifier la correction locale",
  "microbiology.admin.breakpoints.count.imported": "{count} importé",
  "microbiology.admin.breakpoints.count.skipped": "{count} sauté",
  "microbiology.admin.breakpoints.count.unchanged": "{count} inchangé",
  "microbiology.admin.breakpoints.count.valid": "{count} valide",
  "microbiology.admin.breakpoints.csv": "Fichier CSV « Breakpoint »",
  "microbiology.admin.breakpoints.description": "Les étalons de points d'arrêt ont été chargés, ainsi que la version active pour les nouvelles exécutions AST.",
  "microbiology.admin.breakpoints.detail": "Règles relatives aux points d'arrêt",
  "microbiology.admin.breakpoints.downloadRejected": "Télécharger les lignes rejetées",
  "microbiology.admin.breakpoints.effectiveDate": "Date d'entrée en vigueur",
  "microbiology.admin.breakpoints.import": "Importer un fichier CSV",
  "microbiology.admin.breakpoints.intermediate": "Niveau intermédiaire",
  "microbiology.admin.breakpoints.intermediateLower": "Niveau intermédiaire faible",
  "microbiology.admin.breakpoints.intermediateUpper": "Niveau intermédiaire supérieur",
  "microbiology.admin.breakpoints.groupOption": "Groupe : {name}",
  "microbiology.admin.breakpoints.method.all": "Toutes les méthodes",
  "microbiology.admin.breakpoints.method.zone": "Zone",
  "microbiology.admin.breakpoints.organism": "Organismes ou groupes",
  "microbiology.admin.breakpoints.organismGroup": "Groupe d'organismes",
  "microbiology.admin.breakpoints.publisher": "Éditeur",
  "microbiology.admin.breakpoints.resistant": "Résistant",
  "microbiology.admin.breakpoints.rowError": "Ligne {row}",
  "microbiology.admin.breakpoints.rules": "Règles",
  "microbiology.admin.breakpoints.source": "Source",
  "microbiology.admin.breakpoints.source.imported": "Importé",
  "microbiology.admin.breakpoints.source.local": "Correction locale",
  "microbiology.admin.breakpoints.source.manual": "Manuel",
  "microbiology.admin.breakpoints.specimen": "Contexte de l'échantillon",
  "microbiology.admin.breakpoints.specimen.any": "N'importe lequel des échantillons",
  "microbiology.admin.breakpoints.status.active": "Active",
  "microbiology.admin.breakpoints.status.archived": "Archivé",
  "microbiology.admin.breakpoints.status.loaded": "Chargé",
  "microbiology.admin.breakpoints.susceptible": "Susceptible",
  "microbiology.admin.breakpoints.title": "Étalons relatifs aux points d'arrêt",
  "microbiology.admin.breakpoints.units": "Unités",
  "microbiology.admin.breakpoints.view": "Voir le règlement",
  "microbiology.admin.filter.all": "Tous",
  "microbiology.admin.sort": "Trier",
  "microbiology.admin.sort.nameAsc": "Nom (A-Z)",
  "microbiology.admin.sort.nameDesc": "Nom Z-A",
  "microbiology.admin.deactivate.impact": "{name} est utilisé par {count, plural, one {# enregistrement de workflow existant} other {# enregistrements de workflow existants}}. La désactivation empêche toute nouvelle sélection mais préserve ces références historiques.",
  "microbiology.admin.deactivate.title": "Analyse de l'impact de la désactivation",
  "microbiology.admin.deactivated": "Référence désactivée",
  "microbiology.admin.empty": "Non de référence correspondant",
  "microbiology.admin.error.save": "L'enregistrement de référence n'a pas pu être enregistré.",
  "microbiology.admin.error.title": "Impossible de traiter votre demande",
  "microbiology.admin.field.active": "Disponible pour de nouveaux projets",
  "microbiology.admin.field.atmosphere": "Paramètres par défaut d'Atmosphere",
  "microbiology.admin.field.class": "Classe",
  "microbiology.admin.field.code": "Code Emplacement",
  "microbiology.admin.field.defaultPanel": "Panneau AST par défaut",
  "microbiology.admin.field.defaultPanelId": "IDENTIFIANT par défaut du panneau AST",
  "microbiology.admin.field.gramStain": "Coloration de Gram",
  "microbiology.admin.field.group": "Groupe d'organismes",
  "microbiology.admin.field.incubation": "Paramètres d'incubation par défaut",
  "microbiology.admin.field.incubationHours": "Intervalle de lecture de routine (heures)",
  "microbiology.admin.field.subcultureAtHours": "Subculture (horaires)",
  "microbiology.admin.field.maxIncubationDays": "Durée maximale d'incubation (jours)",
  "microbiology.admin.field.media": "Paramètres par défaut des médias",
  "microbiology.admin.field.method": "Méthodes",
  "microbiology.admin.field.methodId": "Identifiant de la méthode",
  "microbiology.admin.field.name": "Nom",
  "microbiology.admin.field.notes": "Notes",
  "microbiology.admin.field.oclCode": "Code OCL",
  "microbiology.admin.field.reportableAnalyteId": "IDENTIFIANT de l'analyte à déclarer",
  "microbiology.admin.field.route": "Itinéraire",
  "microbiology.admin.field.shortName": "Nom abrégé",
  "microbiology.admin.field.significance": "Signification initiale",
  "microbiology.admin.field.whonetCode": "Code Emplacement WHONET",
  "microbiology.admin.organisms.add": "Ajouter un organisme",
  "microbiology.admin.organisms.description": "Vocabulaire relatif aux organismes utilisé dans le cadre de l'identification par culture et des tests de sensibilité aux antibiotiques.",
  "microbiology.admin.organisms.edit": "Organismes",
  "microbiology.admin.organisms.title": "Organismes",
  "microbiology.admin.patientOrigins.description": "Options de sélection de l'origine du patient configurées, utilisées lors de la saisie des demandes d'analyses microbiologiques et de l'exportation vers WHONET.",
  "microbiology.admin.patientOrigins.title": "Origine des patients",
  "microbiology.admin.reactivated": "Référence réactivée",
  "microbiology.admin.route.both": "Par voie orale et intraveineuse",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "Oral",
  "microbiology.admin.route.topical": "D'actualité",
  "microbiology.admin.saved": "Référence enregistrée",
  "microbiology.admin.search": "Rechercher des données de référence",
  "microbiology.admin.sections": "Sections de référence en microbiologie",
  "microbiology.admin.significance.possible": "Agent pathogène potentiel",
  "microbiology.admin.significance.rare": "Agent pathogène rare",
  "microbiology.admin.significance.usually": "Généralement significatif",
  "microbiology.admin.status": "Statut",
  "microbiology.admin.status.active": "Active",
  "microbiology.admin.status.all": "Tous les statuts",
  "microbiology.admin.status.inactive": "Inactif",
  "microbiology.admin.title": "Données de référence en microbiologie",
  "button.add": "Ajouter",
  "button.remove": "Retirer",
  "sidenav.label.microbiology": "Microbiologie",
  "sidenav.label.microbiology.worklist": "Liste des analyses de microbiologie",
  "sidenav.label.microbiology.whonet": "Exportation WHONET",
  "microbiology.whonet.title": "Exportation WHONET",
  "microbiology.whonet.eyebrow": "Surveillance bactériologique de routine",
  "microbiology.whonet.subtitle": "Veuillez examiner les données finalisées relatives aux cultures et aux tests de sensibilité aux antibiotiques avant de générer le fichier CSV de surveillance OpenELIS actuel en vue de sa validation par WHONET.",
  "microbiology.whonet.progress": "État d'avancement de l'exportation WHONET",
  "microbiology.whonet.step.configure": "Configurer",
  "microbiology.whonet.step.preview": "Preview",
  "microbiology.whonet.step.generate": "Générer",
  "microbiology.whonet.configure.title": "Configurer l'exportation",
  "microbiology.whonet.configure.description": "Choisissez la période de référence et les isolats à inclure.",
  "microbiology.whonet.from": "From",
  "microbiology.whonet.to": "À",
  "microbiology.whonet.date.placeholder": "aaaa-mm-jj",
  "microbiology.whonet.period.invalid": "La date de fin doit être postérieure ou égale à la date de début.",
  "microbiology.whonet.period.preset": "Période de référence",
  "microbiology.whonet.period.thisMonth": "Ce mois",
  "microbiology.whonet.period.lastMonth": "Dernier mois",
  "microbiology.whonet.period.thisQuarter": "Ce trimestre",
  "microbiology.whonet.period.custom": "Personnalisé",
  "microbiology.whonet.source.worklist.title": "Portée définie par la liste de travail AST",
  "microbiology.whonet.source.worklist.description": "La période de référence et les filtres de surveillance structurés proviennent de la liste de travail AST. Ils restent modifiables ici.",
  "microbiology.whonet.source.worklist.clear": "Effacer la portée de la liste des tâches",
  "microbiology.whonet.significance": "Inclusion",
  "microbiology.whonet.significance.clinical": "Isolats cliniquement significatifs",
  "microbiology.whonet.significance.all": "Tous les isolats",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "Cliniquement significatif",
  "microbiology.whonet.significance.CONTAMINANT": "Contaminant",
  "microbiology.whonet.significance.NORMAL_FLORA": "Flore normale",
  "microbiology.whonet.significance.UNKNOWN": "Non classé",
  "microbiology.whonet.culturePurpose.description": "Les cultures cliniques sont incluses par défaut. Veuillez ajouter explicitement d'autres populations lorsque la question de surveillance l'exige.",
  "microbiology.whonet.culturePurpose.includeScreening": "Prévoir un dépistage actif ou des cultures de portage",
  "microbiology.whonet.culturePurpose.includeUnspecified": "Inclure les cultures historiques dont l'objectif n'est pas précisé",
  "microbiology.whonet.culturePurpose.title": "Objectif culturel",
  "microbiology.whonet.filter.specimen": "Types d'échantillons",
  "microbiology.whonet.filter.organism": "Organismes",
  "microbiology.whonet.filter.origin": "Origine des patients",
  "microbiology.whonet.filter.any": "N'importe lequel",
  "microbiology.whonet.filter.choose": "Choisissez des valeurs",
  "microbiology.whonet.dedup": "Déduplication",
  "microbiology.whonet.dedup.apply": "Appliquer la sélection « premier isolat »",
  "microbiology.whonet.dedup.apply.help": "Regroupez les isolats répétitifs correspondant à un même patient et au même micro-organisme dans la période sélectionnée.",
  "microbiology.whonet.dedup.advanced": "Ajuster la politique « d'isolement prioritaire »",
  "microbiology.whonet.dedup.window": "Longueur de la fenêtre",
  "microbiology.whonet.dedup.window.help": "Les répétitions survenant exactement à la limite du jour sélectionné ouvrent une nouvelle fenêtre.",
  "microbiology.whonet.dedup.sevenDay": "7 jours",
  "microbiology.whonet.dedup.fourteenDay": "14 jours",
  "microbiology.whonet.dedup.thirtyDay": "30 jours",
  "microbiology.whonet.dedup.basis": "Date de référence",
  "microbiology.whonet.dedup.basis.collection": "Date de prélèvement de l'échantillon",
  "microbiology.whonet.dedup.basis.release": "Date de publication des résultats définitifs",
  "microbiology.whonet.dedup.basis.help": "Choisissez si la fenêtre doit correspondre au prélèvement de l'échantillon ou à la publication du résultat final. La période de référence suit toujours la date de prélèvement.",
  "microbiology.whonet.dedup.scope": "Portée de la source des échantillons",
  "microbiology.whonet.dedup.scope.any": "N'importe lequel des échantillons",
  "microbiology.whonet.dedup.scope.same": "Uniquement à partir de la même source d’échantillons",
  "microbiology.whonet.dedup.scope.help": "N'importe laquelle des sources compare le patient et l'organisme entre les différents types d'échantillons ; la même source effectue des comparaisons au sein de chaque type d'échantillon.",
  "microbiology.whonet.dedup.contaminants": "Éliminez les contaminants potentiels avant de sélectionner",
  "microbiology.whonet.dedup.contaminants.help": "Retirez les contaminants potentiels avant de sélectionner le premier isolat représentatif.",
  "microbiology.whonet.dedup.profile": "Profil de sensibilité",
  "microbiology.whonet.dedup.profile.insensitive": "Ignorer les modifications apportées à S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "Considérez les S/I/R modifiés comme nouveaux",
  "microbiology.whonet.dedup.profile.help": "La sélection en fonction du profil considère tout profil de sensibilité/résistance/indifférence différent à un antibiotique, après réévaluation, comme un nouvel isolat au sein de la fenêtre.",
  "microbiology.whonet.dedup.none": "Non de déduplication",
  "microbiology.whonet.preview.action": "Aperçu de l'exportation",
  "microbiology.whonet.preview.title": "Preview",
  "microbiology.whonet.preview.description": "Ces nombres et ces lignes seront utilisés lors de la génération du fichier CSV.",
  "microbiology.whonet.generate.action": "Générer un fichier CSV",
  "microbiology.whonet.count.cases": "Affaires finalisées",
  "microbiology.whonet.count.clinicalPurpose": "Cultures cliniques",
  "microbiology.whonet.count.screeningPurpose": "Cultures de dépistage",
  "microbiology.whonet.count.unspecifiedPurpose": "Cultures non précisées",
  "microbiology.whonet.count.purposeIncluded": "Après la sélection en fonction de l'objectif de culture",
  "microbiology.whonet.count.isolates": "Isolats découverts",
  "microbiology.whonet.count.specimen": "Après le filtre à échantillons",
  "microbiology.whonet.count.organism": "Après le filtre biologique",
  "microbiology.whonet.count.origin": "Après le filtre d'origine",
  "microbiology.whonet.count.included": "Les isolats comprenaient",
  "microbiology.whonet.count.deduplicated": "Après la déduplication",
  "microbiology.whonet.count.mappable": "Isolats cartographiables",
  "microbiology.whonet.count.rows": "Lignes éligibles",
  "microbiology.whonet.count.excluded": "Lignes exclues",
  "microbiology.whonet.mapping.title": "Évaluation de l'état de préparation",
  "microbiology.whonet.mapping.excluded": "{count, plural, one {# ligne exclue de cet export.} many {# lignes exclues de cet export.} other {# lignes exclues de cet export.}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "Correction de la mise en correspondance des organismes",
  "microbiology.whonet.mapping.fixAntibiotic": "Correction de la mise en correspondance des antibiotiques",
  "microbiology.whonet.mapping.fixSpecimen": "Correction du mappage des échantillons",
  "microbiology.whonet.table.title": "Lignes AST éligibles",
  "microbiology.whonet.table.description": "Valeurs AST vérifiées et à communiquer, avec les correspondances requises par cette exportation.",
  "microbiology.whonet.table.accession": "Numéro laboratoire",
  "microbiology.whonet.table.specimen": "Échantillon",
  "microbiology.whonet.table.organism": "Organismes",
  "microbiology.whonet.table.antibiotic": "Antibiotique",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "Méthodes",
  "microbiology.whonet.error.title": "L'exportation WHONET n'a pas pu être terminée",
  "microbiology.whonet.error.invalidRequest": "Vérifiez la période couverte par le rapport et les options d'exportation, puis réessayez.",
  "microbiology.whonet.error.blocked": "Il ne reste plus aucune ligne valide. Veuillez résoudre les problèmes de préparation répertoriés avant de générer le fichier CSV.",
  "microbiology.whonet.error.network": "Le service d'exportation est inaccessible. Veuillez réessayer lorsque la connexion sera disponible.",
  "microbiology.whonet.error.generic": "La demande d'exportation n'a pas pu être traitée.",
  "microbiology.whonet.preview.loading": "Préparation de l'aperçu de l'exportation.",
  "microbiology.whonet.preview.announced": "Aperçu prêt avec {count, plural, one {# ligne éligible} other {# lignes éligibles}}.",
  "microbiology.whonet.generated.title": "Fichier CSV généré",
  "microbiology.whonet.generated.subtitle": "L'exportation validée a été téléchargée et son résumé d'audit a été enregistré.",
  "catalog.import.title": "Importer le catalogue (CSV)",
  "catalog.import.description": "Chargez des fichiers de catalogue de tests sans modifier les analyses une par une. L'aperçu vérifie chaque fichier par rapport au catalogue dans son état actuel et n'enregistre rien : une ligne qui nécessite une unité de laboratoire, un échantillon ou une analyse créés par un autre fichier du même envoi est donc indiquée comme ignorée jusqu'à ce que vous appliquiez. Appliquer charge les fichiers dans l'ordre et les enregistre avec la configuration, de sorte que le prochain redémarrage charge exactement ce que vous avez appliqué.",
  "catalog.import.dropzone": "Ajouter des fichiers CSV",
  "catalog.import.preview": "Preview",
  "catalog.import.apply": "Appliquer",
  "catalog.import.remove": "Retirer",
  "catalog.import.plan.title": "Effet de ces fichiers",
  "catalog.import.result.title": "Éléments chargés",
  "catalog.import.column.file": "Fichier",
  "catalog.import.column.domain": "Domaine du catalogue",
  "catalog.import.column.created": "Créé",
  "catalog.import.column.updated": "Mis à Jour ",
  "catalog.import.column.skipped": "Ignoré",
  "catalog.import.column.name": "Nom dans le fichier",
  "catalog.import.column.where": "Où il apparaît",
  "catalog.import.column.use": "Utiliser cet enregistrement",
  "catalog.import.file.error": "Ce fichier n'a pas pu être lu",
  "catalog.import.applied": "Les fichiers du catalogue ont été appliqués.",
  "catalog.import.applied.partial": "Certains fichiers du catalogue n'ont pas été chargés. Le tableau indique lesquels et pourquoi.",
  "catalog.import.apply.failed": "Les fichiers du catalogue n'ont pas été appliqués.",
  "catalog.import.apply.hint": "Prévisualisez d'abord les fichiers. Appliquer devient disponible dès que l'aperçu ne montre aucune erreur de fichier.",
  "catalog.import.failed": "Les fichiers du catalogue n'ont pas pu être envoyés.",
  "catalog.import.unresolved.title": "Décision requise",
  "catalog.import.unresolved.description": "Noms que l'importation n'a pas pu associer à un enregistrement. Associez chacun à l'enregistrement correspondant ou ignorez-le. Un nom mémorisé sera résolu automatiquement la prochaine fois.",
  "catalog.import.unresolved.empty": "Aucun élément n'attend de décision.",
  "catalog.import.remember": "Mémoriser ce nom",
  "catalog.import.resolve": "Utiliser",
  "catalog.import.skip": "Ignorer",
  "sidenav.label.admin.catalogImport": "Importer le catalogue (CSV)",
  "reporting.design.subtitle": "Créez un CSV pour une nouvelle question ou relancez un rapport habituel sur une nouvelle période.",
  "reporting.design.overview": "Aperçu de l'export",
  "reporting.design.newTitle": "Créer un nouvel export",
  "reporting.design.newHelp": "Choisissez le type de rapport, les champs nécessaires et une période. Votre travail reste disponible si vous consultez la file d'attente ou revenez plus tard.",
  "reporting.design.savedTitle": "Utiliser un rapport enregistré",
  "reporting.design.savedHelp": "Réutilisez les champs et filtres enregistrés, puis choisissez une nouvelle période.",
  "reporting.design.start": "Démarrer un nouvel export",
  "reporting.design.continue": "Poursuivre l'export en cours",
  "reporting.design.newExport": "Nouvel export",
  "reporting.design.useReport": "Utiliser le rapport",
  "reporting.design.savedFields": "{count} champs enregistrés · la période n'est jamais enregistrée",
  "reporting.design.steps": "Étapes de l'export",
  "reporting.design.chooseColumns": "Choisir les colonnes",
  "reporting.design.setFilters": "Définir les filtres",
  "reporting.design.reviewSubmit": "Vérifier et soumettre",
  "reporting.design.typeQuestion": "De quel type d'information avez-vous besoin ?",
  "reporting.design.typeHelp": "Choisissez un seul type de rapport afin que chaque ligne du CSV ait un sens clair. Vous pouvez changer de type tant que vous n'avez pas sélectionné de champs.",
  "reporting.design.type.SAMPLE_TESTING": "Échantillons et analyses",
  "reporting.design.type.REFERRALS": "Références",
  "reporting.design.type.NON_CONFORMANCE": "Non-conformité",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Demandes, résultats, patients et délais de traitement",
  "reporting.design.typeHelp.REFERRALS": "Analyses envoyées à d'autres laboratoires · conserve les résultats renvoyés et les envois en attente",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Échantillons rejetés et événements non conformes · conserve les échantillons liés et les occurrences distinctes",
  "reporting.design.pending": "Pas encore connecté",
  "reporting.design.building": "Vous créez un rapport {type}.",
  "reporting.design.changeType": "Changer de type et effacer les champs",
  "reporting.design.chooseType": "Choisissez un type de rapport pour afficher ses champs.",
  "reporting.design.configuredReports": "Rapports configurés",
  "reporting.design.chooseConfigured": "Choisir un rapport configuré",
  "reporting.design.available": "Champs disponibles",
  "reporting.design.findField": "Rechercher un champ",
  "reporting.design.searchPlaceholder": "Rechercher dans tous les champs et groupes…",
  "reporting.design.clearSearch": "Effacer la recherche",
  "reporting.design.fieldCount": "{count} champs répartis en {groups} groupes",
  "reporting.design.matchCount": "{count} champs correspondants répartis en {groups} groupes",
  "reporting.design.expansion": "Développer ou réduire les groupes de champs",
  "reporting.design.expandAll": "Tout développer",
  "reporting.design.collapseAll": "Tout réduire",
  "reporting.design.groupCount": "{added} / {total} ajoutés",
  "reporting.design.scrollCatalog": "Catalogue de champs défilant",
  "reporting.design.addShown": "Ajouter tous les champs affichés",
  "reporting.design.removeShown": "Retirer les champs affichés",
  "reporting.design.addShownGroup": "Ajouter tous les champs {group} affichés",
  "reporting.design.removeShownGroup": "Retirer tous les champs {group} affichés",
  "reporting.design.addField": "Ajouter {field}",
  "reporting.design.addedField": "{field} ajouté",
  "reporting.design.add": "+ Ajouter",
  "reporting.design.added": "Ajouté",
  "reporting.design.noFields": "Aucun champ ne correspond à votre recherche.",
  "reporting.design.selectedCount": "Vos colonnes CSV ({count})",
  "reporting.design.orderHelp": "Faites glisser une poignée pour modifier l'ordre des colonnes, ou utilisez les flèches. Les touches fléchées déplacent la poignée active ; Début et Fin la placent en première ou en dernière position.",
  "reporting.design.columnOrder": "Colonnes CSV dans l'ordre",
  "reporting.design.drag": "Faire glisser {field} pour le réordonner",
  "reporting.design.move": "Déplacer {field}",
  "reporting.design.emptyColumns": "Ajoutez des champs pour créer votre CSV.",
  "reporting.design.addedMessage": "{field} ajouté. {count} colonnes.",
  "reporting.design.removedMessage": "{field} retiré. {count} colonnes.",
  "reporting.design.columnViews": "Vues du générateur de colonnes",
  "reporting.design.yourColumns": "Vos colonnes ({count})",
  "reporting.design.csvPreview": "Aperçu CSV",
  "reporting.design.previewHelp": "Disposition des colonnes dans l'ordre où elles apparaîtront dans votre CSV téléchargé.",
  "reporting.design.scrollPreview": "Aperçu CSV défilant",
  "reporting.design.nextFilters": "Suivant : définir les filtres",
  "reporting.design.nextReview": "Suivant : vérifier et soumettre",
  "reporting.design.scopeFilters": "Filtres de périmètre (facultatif)",
  "reporting.design.periodDays": "{count, plural, one {# jour} many {# jours} other {# jours}}",
  "reporting.design.moreFilters": "Afficher plus de filtres",
  "reporting.design.hideFilters": "Masquer les filtres supplémentaires",
  "reporting.design.sampleStatus": "Statut de l'échantillon",
  "reporting.design.referringSite": "Site demandeur",
  "reporting.design.reviewConfiguration": "Vérifier la configuration",
  "reporting.design.dateFilters": "Plage de dates et filtres",
  "reporting.design.testStatus": "Analyse et statut",
  "reporting.design.change": "Modifications",
  "reporting.design.deliveryHelp": "Votre fichier CSV sera généré en arrière-plan. Téléchargez-le ici lorsqu'il sera prêt, ou revenez à Ma file de rapports.",
  "reporting.design.fileName": "Nom du fichier",
  "reporting.design.customFileName": "Nom de fichier personnalisé",
  "reporting.design.fileNamePending": "Un nom de fichier est généré automatiquement. Les noms personnalisés ne sont pas encore connectés.",
  "reporting.design.saveLater": "Enregistrer ces paramètres de rapport pour plus tard",
  "reporting.design.saveSettings": "Enregistrer les paramètres du rapport",
  "reporting.design.queueHelp": "Consultez et téléchargez vos exports CSV en file d'attente.",
  "reporting.design.queue.jobName": "Nom de la tâche",
  "reporting.design.queue.report": "Rapport",
  "reporting.design.queue.size": "Lignes / Taille du fichier",
  "reporting.design.queue.submitted": "Soumis le",
  "reporting.design.queuePending": "Les tâches actives sont actualisées automatiquement. Relancez les exports en échec, annulez les tâches en file d'attente ou relancez les rapports expirés avec de nouvelles dates. La suppression des tâches n'est pas encore connectée.",
  "reporting.design.details": "Détails",
  "reporting.design.expires": "Disponible jusqu'au {date}",
  "reporting.design.jobsShown": "{count} tâches affichées",
  "reporting.design.jobAction.EXPIRED": "Relancer",
  "reporting.design.labScope": "Périmètre du laboratoire",
  "reporting.design.reviewFields": "Champs sélectionnés ({count})",
  "reporting.recovery.cancelTitle": "Annuler l'export",
  "reporting.recovery.keepQueued": "Conserver en file d'attente",
  "reporting.recovery.cancelHelp": "Annuler cet export en file d'attente ? Si le traitement a déjà commencé, il se poursuivra et vous pourrez revenir à son résultat.",
  "reporting.job.cannotCancel": "Cet export a déjà commencé ou est terminé et ne peut pas être annulé.",
  "reporting.job.cannotRetry": "Seul un export en échec peut être relancé. Utilisez la tâche en cours ou démarrez un nouvel export.",
  "reporting.job.interrupted": "Le traitement a été interrompu. Relancez cet export pour générer un nouveau fichier.",
  "reporting.job.claimLost": "Cet export n'est plus attribué au processus de traitement actuel. Revenez à la file d'attente pour connaître son statut.",
  "sidenav.section.main": "Menu principal",
  "sidenav.section.patientOrders": "Patients et demandes",
  "sidenav.section.administration": "Administration",
  "sidenav.workflow.orderTest": "Demander une analyse",
  "sidenav.workflow.resultsValidation": "Validation des résultats",
  "sidenav.workflow.patientManagement": "Gestion des patients",
  "sidenav.moreTools": "Plus d'outils",
  "reporting.menu.otherReports": "Autres rapports",
  "reporting.menu.patientPrintQueue": "File d'impression des rapports patients",
  "common.icon": "Icône",
  "menu.presentation.style": "Afficher comme",
  "menu.presentation.item": "Élément de menu",
  "menu.presentation.section": "Titre de section",
  "menu.configuration.managed": "Géré par la configuration de l'instance",
  "menu.configuration.description": "Mettez à jour la visibilité des menus, les titres de section et les icônes. Les paramètres gérés par cette instance sont ici en lecture seule.",
  "menu.configuration.loadError": "Les paramètres du menu n'ont pas pu être chargés.",
  "menu.configuration.saved": "Paramètres du menu enregistrés.",
  "menu.presentation.sectionHint": "Les titres de section regroupent leurs éléments de menu enfants, sans lien.",
  "menu.presentation.sectionIconHint": "Les icônes s'affichent sur les éléments de menu, pas sur les titres de section.",
  "analyzer.action.copyMappings": "Copier les correspondances",
  "analyzer.action.delete": "Supprimer",
  "analyzer.action.edit": "Modifier",
  "analyzer.action.fieldMappings": "Correspondances de champs",
  "analyzer.action.qcRules": "Règles CQ",
  "analyzer.action.testConnection": "Test de connexion",
  "analyzer.copyMappings.confirmation.message": "Etes vous sûr de vouloir copier  {count} correspondances ? Les correspondances existantes seront écrasées.",
  "analyzer.copyMappings.confirmation.title": "Confirmer la copie des correspondances",
  "analyzer.copyMappings.copy": "Copier les correspondances",
  "analyzer.copyMappings.error": "Erreur lors de la copie des correspondances",
  "analyzer.copyMappings.error.noSourceMappings": "L'automate source n'a aucune correspondance active à copier. ",
  "analyzer.copyMappings.loading": "Copier les correspondances ...",
  "analyzer.copyMappings.source": "Automate d'origine",
  "analyzer.copyMappings.source.name": "Nom",
  "analyzer.copyMappings.source.type": "Type",
  "analyzer.copyMappings.subtitle": "Copier les mappages de champs de {source} vers {target}",
  "analyzer.copyMappings.success": "Successfully copied {count} mappings",
  "analyzer.copyMappings.success.viewTarget": "View Target Analyzer",
  "analyzer.copyMappings.summary": "Mapping Summary",
  "analyzer.copyMappings.summary.breakdown": "Field mappings: {fieldCount}, Unit conversions: {unitCount}, Qualitative mappings: {qualCount}",
  "analyzer.copyMappings.summary.count": "{count} mappings will be copied",
  "analyzer.copyMappings.target": "Analyseur cible",
  "analyzer.copyMappings.target.placeholder": "Sélectionner l'analyseur cible",
  "analyzer.copyMappings.target.required": "Target Analyzer *",
  "analyzer.copyMappings.title": "Copier les mappages de champs",
  "analyzer.copyMappings.warning": "Cela copiera tous les mappages de champs, y compris les conversions d'unités et les mappages de valeurs qualitatives. Les mappages existants seront écrasés.",
  "analyzer.delete.cancel": "Annuler",
  "analyzer.delete.delete": "Supprimer",
  "analyzer.delete.error": "Erreur",
  "analyzer.delete.error.noId": "Analyzer ID is required",
  "analyzer.delete.error.unknown": "An unknown error occurred while deleting the analyzer",
  "analyzer.delete.message": "Êtes-vous sûr de vouloir supprimer {name}? Cette action ne peut pas être annulée et supprimera toutes les données associées.",
  "analyzer.delete.success": "Analyseur supprimé",
  "analyzer.delete.title": "Supprimer l'analyseur",
  "analyzer.delete.unknown": "Unknown Analyzer",
  "analyzer.errorDashboard.acknowledgeAll": "Tout reconnaître",
  "analyzer.errorDashboard.action.acknowledge": "Accuser réception",
  "analyzer.errorDashboard.action.menu": "Error actions",
  "analyzer.errorDashboard.action.viewDetails": "Voir les détails",
  "analyzer.errorDashboard.errorType.connection": "Connexion",
  "analyzer.errorDashboard.errorType.mapping": "Mappage",
  "analyzer.errorDashboard.errorType.protocol": "Protocole",
  "analyzer.errorDashboard.errorType.timeout": "Délai d'attente",
  "analyzer.errorDashboard.errorType.validation": "Validation",
  "analyzer.errorDashboard.filter.analyzer": "Analyseur",
  "analyzer.errorDashboard.filter.analyzer.all": "Tous",
  "analyzer.errorDashboard.filter.search": "Rechercher des erreurs...",
  "analyzer.errorDashboard.filter.severity": "Gravité",
  "analyzer.errorDashboard.filter.severity.all": "Toutes les gravités",
  "analyzer.errorDashboard.filter.type": "Type d'erreur",
  "analyzer.errorDashboard.filter.type.all": "Tous les types",
  "analyzer.errorDashboard.severity.critical": "Critique",
  "analyzer.errorDashboard.severity.error": "Erreur",
  "analyzer.errorDashboard.severity.warning": "Avertissement",
  "analyzer.errorDashboard.stats.critical": "Critique",
  "analyzer.errorDashboard.stats.last24Hours": "Dernières 24 heures",
  "analyzer.errorDashboard.stats.total": "Total des erreurs",
  "analyzer.errorDashboard.stats.unacknowledged": "Non reconnue",
  "analyzer.errorDashboard.status.acknowledged": "Accusé de réception",
  "analyzer.errorDashboard.status.unacknowledged": "Non reconnue",
  "analyzer.errorDashboard.subtitle": "View and manage analyzer errors and alerts",
  "analyzer.errorDashboard.table.analyzer": "Analyseur",
  "analyzer.errorDashboard.table.message": "Message",
  "analyzer.errorDashboard.table.severity": "Gravité",
  "analyzer.errorDashboard.table.status": "Statut",
  "analyzer.errorDashboard.table.timestamp": "Horodatage",
  "analyzer.errorDashboard.table.type": "Type",
  "analyzer.errorDashboard.title": "Tableau de bord des erreurs",
  "analyzer.errorDetails.acknowledged": "Accusé de réception",
  "analyzer.errorDetails.acknowledgedBy": "Par {user} le {date}",
  "analyzer.errorDetails.analyzer": "Analyseur",
  "analyzer.errorDetails.analyzerId": "ID de l'analyseur",
  "analyzer.errorDetails.close": "Fermer",
  "analyzer.errorDetails.copy": "Copier",
  "analyzer.errorDetails.createMapping": "Créer un mappage",
  "analyzer.errorDetails.download": "Télécharger",
  "analyzer.errorDetails.errorId": "ID de l'erreur",
  "analyzer.errorDetails.errorMessage": "Error Message",
  "analyzer.errorDetails.errorType": "Type d'erreur",
  "analyzer.errorDetails.logs": "Journaux de l'analyseur ({count} entrées)",
  "analyzer.errorDetails.recommendedActions": "Actions recommandées",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Check IP address and port configuration in analyzer settings",
  "analyzer.errorDetails.recommendedActions.createMapping": "Create a mapping for the unmapped field to resolve this error",
  "analyzer.errorDetails.recommendedActions.testConnection": "Test connection using the 'Test Connection' feature",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verify analyzer is powered on and network cable is connected",
  "analyzer.errorDetails.severity": "Gravité",
  "analyzer.errorDetails.subtitle": "Informations détaillées et journaux de l'analyseur pour l'erreur {id}",
  "analyzer.errorDetails.timestamp": "Horodatage",
  "analyzer.errorDetails.title": "Détails de l'erreur",
  "analyzer.fieldMapping.activationModal.activate": "Activer les modifications",
  "analyzer.fieldMapping.activationModal.cancel": "Annuler",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "Je comprends que ces modifications s'appliqueront uniquement aux nouveaux messages",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Mapping changes detected. Another user has modified mappings for this analyzer. Please reload the page to see latest changes.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Cannot activate: Required mappings missing",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Missing required fields: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Reload Page",
  "analyzer.fieldMapping.activationModal.subtitle": "Confirmer l'activation des modifications de mappage pour l'analyseur '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Activer les modifications de mappage",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "View Pending Messages",
  "analyzer.fieldMapping.activationModal.warning": "Vous êtes sur le point d'activer les modifications de mappage pour l'analyseur '{name}'. Ces modifications s'appliqueront à tous les nouveaux messages reçus après l'activation. Les résultats existants ne seront pas affectés.",
  "analyzer.fieldMapping.activationModal.warningActive": "Cet analyseur est actuellement actif. L'activation des modifications peut affecter les résultats entrants.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "This analyzer has {count} pending messages in the error queue. Activating mapping changes may affect how these messages are reprocessed. Consider resolving errors first.",
  "analyzer.fieldMapping.back": "Back",
  "analyzer.fieldMapping.fieldType.controlTest": "Test de contrôle",
  "analyzer.fieldMapping.fieldType.custom": "Personnalisé",
  "analyzer.fieldMapping.fieldType.dateTime": "Date/Heure",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Point de fusion",
  "analyzer.fieldMapping.fieldType.numeric": "Numérique",
  "analyzer.fieldMapping.fieldType.qualitative": "Qualitatif",
  "analyzer.fieldMapping.fieldType.text": "Texte",
  "analyzer.fieldMapping.page.subtitle": "Configure field mappings between analyzer and OpenELIS",
  "analyzer.fieldMapping.page.title": "Correspondances de champs",
  "analyzer.fieldMapping.panel.mapping.active": "Active",
  "analyzer.fieldMapping.panel.mapping.retired": "Retired",
  "analyzer.fieldMapping.panel.retire": "Retire Mapping",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Cannot retire: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} fields available",
  "analyzer.fieldMapping.panel.source.search": "Search fields...",
  "analyzer.fieldMapping.panel.source.title": "Analyzer Fields ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Mapped",
  "analyzer.fieldMapping.panel.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.panel.statusFilter.active": "Active Only",
  "analyzer.fieldMapping.panel.statusFilter.all": "All Fields",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Draft Only",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filtrer par statut",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Mapped Only",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Unmapped Only",
  "analyzer.fieldMapping.panel.target.cancel": "Annuler",
  "analyzer.fieldMapping.panel.target.edit": "Modifier",
  "analyzer.fieldMapping.panel.target.remove": "Retirer",
  "analyzer.fieldMapping.panel.target.saveActivate": "Save and Activate",
  "analyzer.fieldMapping.panel.target.saveDraft": "Enregistrer comme brouillon",
  "analyzer.fieldMapping.panel.target.selectField": "Select a field from the left panel to view or create mappings.",
  "analyzer.fieldMapping.panel.target.summary": "Mappings Summary",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Unmapped Field - This field has no mapping configured",
  "analyzer.fieldMapping.pendingCodes.actions": "Actions",
  "analyzer.fieldMapping.pendingCodes.code": "Analyzer Code",
  "analyzer.fieldMapping.pendingCodes.empty": "No pending unmapped analyzer codes.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Ignore",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Mark Mapped",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Seen",
  "analyzer.fieldMapping.pendingCodes.status": "Statut",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Review and resolve unmapped analyzer test codes.",
  "analyzer.fieldMapping.pendingCodes.title": "Pending Unmapped Codes",
  "analyzer.fieldMapping.pluginConfig.title": "Plugin Configuration Snapshot",
  "analyzer.fieldMapping.queryAnalyzer": "Interroger l'analyseur",
  "analyzer.fieldMapping.retirementModal.cancel": "Annuler",
  "analyzer.fieldMapping.retirementModal.confirmation": "Are you sure you want to retire this mapping? Historical messages will still reference it for audit purposes.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Cannot retire: {count} pending messages use this mapping",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Retirement Reason (Optional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Optional: Reason for retiring this mapping",
  "analyzer.fieldMapping.retirementModal.retire": "Retire Mapping",
  "analyzer.fieldMapping.retirementModal.subtitle": "Confirm retirement of field mapping",
  "analyzer.fieldMapping.retirementModal.title": "Retire Mapping",
  "analyzer.fieldMapping.save": "Save Mappings",
  "analyzer.fieldMapping.stats.pendingCodes": "Pending Codes",
  "analyzer.fieldMapping.stats.required": "Required Mappings",
  "analyzer.fieldMapping.stats.total": "Total Mappings",
  "analyzer.fieldMapping.stats.unmapped": "Unmapped Fields",
  "analyzer.fieldMapping.status.active": "Active",
  "analyzer.fieldMapping.status.draft": "Brouillon",
  "analyzer.fieldMapping.status.retired": "Retired",
  "analyzer.fieldMapping.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.testMapping": "Test Mapping",
  "analyzer.fieldMapping.warning.missingRequired": "Required mappings are missing",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Some required fields are not mapped. Please map all required fields before activating.",
  "analyzer.navigation.errorDashboard": "Tableau de bord des erreurs",
  "analyzerType.column.name": "Nom",
  "analyzerType.column.description": "Description",
  "analyzerType.column.pluginClass": "Classe du plugin",
  "analyzerType.column.genericPlugin": "Module générique",
  "analyzerType.column.identifierPattern": "Modèle d’identifiant",
  "analyzerType.column.pluginLoaded": "Plugin Loaded",
  "analyzerType.column.instances": "Instances",
  "analyzerType.button.creating": "Création...",
  "analyzerType.modal.createTitle": "Créer un nouveau type d’analyseur",
  "analyzerType.field.name": "Nom",
  "analyzerType.field.description": "Description",
  "analyzerType.field.selectProtocol": "Sélectionner un protocole",
  "analyzerType.field.pluginClassName": "Nom de la classe du module",
  "analyzerType.field.identifierPattern": "Modèle d’identifiant",
  "analyzerType.field.identifierPatternHelper": " Expression régulière pour la reconnaissance des identifiants d’échantillons (ex. ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Module générique",
  "analyzerType.field.isActive": "Active",
  "analyzerType.error.nameRequired": "Le nom est obligatoire",
  "analyzerType.notification.createSuccess": "Type d’analyseur créé avec succès",
  "analyzerType.notification.createError": "Échec de la création du type d’analyseur",
  "analyzer.stat.pluginWarnings": "Avertissements du plugin",
  "analyzer.status.pending_registration": "En attente d’inscription",
  "analyzer.qcRules.modal.title": "Règles d'identification des échantillons CQ — {analyzerName}",
  "analyzer.qcRules.breadcrumb": "Règles d’identification des échantillons de CQ",
  "analyzer.qcRules.orSemantics": "Les règles utilisent une logique OU : un échantillon est marqué comme CQ si au moins une règle active correspond.",
  "analyzer.qcRules.addRule": "Ajouter une règle",
  "analyzer.qcRules.deleteRule": "Supprimer la règle",
  "analyzer.qcRules.noRules": "Aucune règle CQ configurée. Ajoutez au moins une règle avant d'activer cet analyseur.",
  "analyzer.qcRules.ruleType": "Type de règle",
  "analyzer.qcRules.targetField": "Référence du champ",
  "analyzer.qcRules.targetField.placeholder": "ex. : O.12, QC_TASK",
  "analyzer.qcRules.operand": "Valeur à rechercher",
  "analyzer.qcRules.operand.placeholder": "ex. : Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Échec du chargement des règles CQ",
  "analyzer.qcRules.error.saveFailed": "Échec de l'enregistrement de la règle CQ",
  "analyzer.qcRules.error.deleteFailed": "Échec de la suppression de la règle CQ",
  "analyzer.placement.instrumentSpecimen": "Envoyé par l'instrument : {id}",
  "analyzer.placement.state.RESOLVED": "Correspondance trouvée",
  "analyzer.placement.state.RETEST_CHOICE": "A déjà un résultat",
  "analyzer.placement.state.MULTI_TUBE": "Plusieurs correspondances",
  "analyzer.placement.state.UNORDERED_ONE_FITS": "Analyse non demandée",
  "analyzer.placement.state.UNORDERED_MANY_FIT": "Analyse non demandée",
  "analyzer.placement.state.UNORDERED_NONE_FIT": "Analyse non demandée",
  "analyzer.placement.state.NEW_SAMPLE": "Nouvel échantillon",
  "analyzer.placement.reason.RESOLVED": "Une analyse sur {tube} attend ce résultat.",
  "analyzer.placement.reason.RETEST_CHOICE": "L'analyse sur {tube} a déjà un résultat. L'enregistrement le remplace et le marque comme corrigé.",
  "analyzer.placement.reason.MULTI_TUBE": "Plusieurs analyses correspondent à cet identifiant. Choisissez celle à laquelle appartient ce résultat.",
  "analyzer.placement.reason.MULTI_TUBE_NO_ANALYSIS": "Plusieurs tubes portent cet identifiant. Corrigez les étiquettes de tubes en double, puis vérifiez de nouveau.",
  "analyzer.placement.reason.UNORDERED_ONE_FITS": "Cette analyse n'est pas demandée. L'enregistrement l'ajoute à {tube}.",
  "analyzer.placement.reason.UNORDERED_MANY_FIT": "Cette analyse n'est pas demandée et plusieurs tubes pourraient la recevoir. Choisissez le type d'échantillon ci-dessous.",
  "analyzer.placement.reason.UNORDERED_NONE_FIT": "Cette analyse n'est pas demandée et aucun tube de la demande ne peut la recevoir. L'enregistrement ajoute un nouveau tube du type d'échantillon de l'analyse.",
  "analyzer.placement.reason.NEW_SAMPLE": "Aucune demande ni aucun tube ne porte cet identifiant. L'enregistrement crée un nouvel échantillon.",
  "analyzer.placement.chooseAnalysis": "Analyse à laquelle appartient ce résultat",
  "analyzer.placement.chooseAnalysis.none": "Choisissez une analyse",
  "analyzer.placement.option": "{tube}, {status}",
  "analyzer.placement.option.awaiting": "en attente de résultat",
  "analyzer.placement.option.hasResult": "a un résultat",
  "analyzer.placement.tubeUnlabelled": "tube {id}",
  "analyzer.placement.viewBundle": "Voir le bundle",
  "analyzer.placement.bundleTitle": "Bundle de transmission",
  "analyzer.placement.bundleLoading": "Chargement du bundle de transmission",
  "analyzer.placement.bundleFailed": "Le bundle de transmission n'a pas pu être chargé.",
  "analyzer.placement.redirect.open": "Placer sur une autre demande",
  "analyzer.placement.redirect.accession": "Demande (numéro de laboratoire)",
  "analyzer.placement.redirect.reason": "Pourquoi ce résultat appartient à cette demande",
  "analyzer.placement.redirect.help": "Utilisez cette option lorsque l'instrument a mal lu l'identifiant de l'échantillon. Le motif est enregistré avec le résultat.",
  "analyzer.placement.redirect.reasonRequired": "Saisissez le motif avant d'enregistrer.",
  "analyzer.placement.patient.match": "Le patient {instrument} de l'instrument correspond au patient de la demande.",
  "analyzer.placement.patient.mismatch.tag": "Patient non concordant",
  "analyzer.placement.patient.mismatch": "L'instrument a indiqué le patient {instrument}, mais le patient de la demande est {order}. Ajoutez une note expliquant pourquoi avant d'enregistrer.",
  "analyzer.placement.patient.noOrderPatient": "L'instrument a indiqué le patient {instrument}. La demande n'a aucun identifiant patient avec lequel le comparer.",
  "instructions.qc.fail.blocks.validation": "Lorsque cette option est activée, les résultats concernés par un échec de contrôle qualité ouvert ne peuvent pas être acceptés dans Validation tant que la non-conformité n'est pas clôturée ; ils peuvent toujours être rejetés. Lorsqu'elle est désactivée, l'échec est seulement affiché sur la ligne comme avertissement.",
  "coldStorage.bacnetUdpPort": "BACnet UDP Port",
  "coldStorage.config.saveSuccess": "System configuration saved successfully",
  "coldStorage.configMoved": "Configuration Moved to Admin Panel",
  "coldStorage.configMovedDesc": "System-wide settings should be managed in the Admin UI where all global configurations are centralized. This page is read-only and will be removed in a future release.",
  "coldStorage.databaseVersion": "Database Version",
  "coldStorage.error.loadConfig": "Failed to load system configuration: ",
  "coldStorage.error.saveConfig": "Failed to save system configuration: ",
  "coldStorage.lastUpdate": "Dernière mise à jour",
  "coldStorage.loadingConfig": "Loading system configuration...",
  "coldStorage.modbusTcpPort": "Modbus TCP Port",
  "coldStorage.protocolConfiguration": "Protocol Configuration",
  "coldStorage.readOnlyMode": "Read-Only Mode",
  "coldStorage.readOnlyModeDesc": "To modify these settings, please navigate to Admin → System Configuration",
  "coldStorage.securitySettings": "Security Settings",
  "coldStorage.sessionTimeout": "Session Timeout",
  "coldStorage.systemConfiguration": "System Configuration",
  "coldStorage.systemInformation": "System Information",
  "coldStorage.systemVersion": "System Version",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Uptime",
  "customFieldType.page.hierarchy.management": "Types de champs personnalisés",
  "customFieldType.page.hierarchy.root": "Administration du système",
  "eqa.program.tests.helper": "La saisie des résultats de ce programme propose exactement ces analyses, dans la grille de résultats et dans son import CSV.",
  "eqa.program.tests.saveFailed": "Le programme a été enregistré, mais pas ses analyses. Rouvrez-le et définissez-les à nouveau.",
  "inventory.search.placeholder": "Recherche par nom d'article ou numéro de lot",
  "label.results.control.capture.pass": "Passer",
  "label.results.control.capture.fail": "ECHEC",
  "message.noPluginFound": "Aucun plugin trouvé",
  "nce.status.capa": "Actions correctives et préventives",
  "nce.status.completed": "Terminé",
  "nce.capa.add": "Ajouter",
  "plugin.files": "Plugin Files",
  "plugin.name": "Plugin Name",
  "sidenav.label.admin.analyzerTest": "Nom du test de l'automate",
  "sidenav.label.admin.Listplugin": "Page de la liste",
  "sidenav.label.admin.pluginFile": "Plugin Files",
  "label.testCatalog.accreditation.col.body": "Organisme d'accréditation",
  "label.testCatalog.accreditation.col.expires": "Expiration de l'accréditation",
  "label.testCatalog.accreditation.col.status": "Statut",
  "label.testCatalog.accreditation.col.actions": "Actions",
  "label.testCatalog.accreditation.remove.confirm": "Retirer",
  "qa.qiConfig.title": "Configuration des indicateurs qualité",
  "qa.qiConfig.error": "Impossible de charger la configuration des IQ.",
  "qa.qiConfig.column.indicator": "Indicateur",
  "qa.qiConfig.column.enabled": "Activée",
  "qa.qiConfig.column.target": "Cible",
  "qa.qiConfig.column.action": "Seuil d'action",
  "qa.qiConfig.column.actions": "Actions",
  "qa.qms.capaRegister.title": "Registre CAPA",
  "qa.qms.capaRegister.tile.open": "Ouvert",
  "qa.qms.capaRegister.tile.overdue": "En retard ",
  "qa.qms.capaRegister.filter.status": "Statut",
  "qa.qms.capaRegister.filter.status.all": "Tous",
  "qa.qms.capaRegister.column.nceNumber": "Numéro d'ENC",
  "qa.qms.capaRegister.column.actionType": "Type",
  "qa.qms.capaRegister.column.dueDate": "Date d'échéance",
  "qa.qms.capaRegister.column.completed": "Terminé",
  "qa.qms.capaRegister.column.status": "Statut",
  "qa.qms.accreditation.tile.active": "Active",
  "qa.qms.accreditation.tile.expiring": "Bientôt Expiration",
  "qa.qms.accreditation.tile.expired": "Expiré",
  "qa.qms.accreditation.body.column.code": "Code Emplacement",
  "qa.qms.accreditation.body.column.name": "Nom",
  "qa.qms.accreditation.body.column.enrolled": "Analyses inscrites",
  "qa.qms.accreditation.body.column.status": "Statut",
  "qa.qms.accreditation.body.column.actions": "Actions",
  "qa.qms.accreditation.body.field.code": "Code Emplacement",
  "qa.qms.accreditation.body.field.name": "Nom",
  "qa.qms.accreditation.body.field.displayOrder": "Ordre d'affichage",
  "qa.qms.accreditation.body.field.active": "Active",
  "qa.qms.accreditation.body.delete.confirm": "Supprimer",
  "qa.qms.accreditation.enrollment.column.test": "Test",
  "qa.qms.accreditation.enrollment.column.status": "Statut",
  "qa.qms.accreditation.enrollment.column.actions": "Actions",
  "qa.qms.accreditation.eqa.column.body": "Organisme d'accréditation",
  "qa.qms.accreditation.filter.status": "Statut",
  "qa.qms.accreditation.filter.all": "Tous",
  "qa.qms.accreditation.filter.search": "Analyses de recherche",
  "qa.qms.accreditation.enroll.field.body": "Organisme d'accréditation",
  "qa.qms.accreditation.enroll.field.tests": "Analyses",
  "qa.qms.accreditation.enrollment.delete.confirm": "Retirer",
  "qa.qms.esigLog.title": "Journal des signatures électroniques",
  "qa.qms.esigLog.column.signedAt": "Signé le",
  "qa.qms.esigLog.column.action": "Action",
  "qa.qms.esigLog.column.reason": "Motif",
  "qa.qms.esigLog.filter.from": "Plage de Date (De)",
  "qa.qms.esigLog.filter.to": "Plage de Date (à)",
  "qa.qms.esigLog.filter.action": "Action",
  "qa.qms.esigLog.filter.user": "Utilisateur",
  "qa.qms.esigLog.filter.all": "Tous",
  "qa.qms.esigLog.filter.clear": "Effacer les filtres",
  "qa.qms.esigLog.export.csv": "Exporter en CSV",
  "qa.qms.esigLog.export.pdf": "Exporter en PDF",
  "qa.qms.esigLog.export.confirm.confirm": "Exporter",
  "qa.qms.esigLog.export.confirm.cancel": "Annuler",
  "qa.qi.dashboard.title": "Tableau de bord des indicateurs qualité",
  "qa.qi.dashboard.refresh": "Actualiser",
  "qa.qi.dashboard.comingSoon": "Bientôt disponible : {ticket}",
  "qa.qi.amendment.filter.from": "From",
  "qa.qi.amendment.filter.to": "À",
  "qa.qi.amendment.column.labNumber": "Numéro laboratoire",
  "qa.qi.amendment.column.test": "Test",
  "qa.qi.amendment.empty": "Aucune correction sur cette période.",
  "qa.qi.amendment.error": "Les données de correction sont indisponibles.",
  "qa.qi.amendment.trend.title": "Tendance",
  "qa.qi.amendment.trend.series": "Taux de correction",
  "qa.qi.amendment.trend.interval": "Agrégation",
  "qa.qi.amendment.threshold.target": "Cible",
  "qa.qi.amendment.threshold.action": "Action",
  "qa.qi.amendment.breakdown.column.test": "Test",
  "qa.qi.amendment.breakdown.column.amended": "Modifié",
  "qa.qi.amendment.breakdown.column.released": "Publié",
  "qa.qi.rejection.filter.from": "From",
  "qa.qi.rejection.filter.to": "À",
  "qa.qi.rejection.column.labNumber": "Numéro laboratoire",
  "qa.qi.rejection.column.test": "Test",
  "qa.qi.rejection.column.reason": "Motif",
  "qa.qi.rejection.column.location": "Emplacement",
  "qa.qi.rejection.column.nce": "NCE",
  "qa.qi.rejection.error": "Les données de rejet sont indisponibles.",
  "qa.qi.rejection.trend.title": "Tendance",
  "qa.qi.rejection.trend.series": "Taux de rejet",
  "qa.qi.rejection.trend.interval": "Agrégation",
  "qa.qi.rejection.trend.empty": "Aucune donnée de tendance sur cette période.",
  "qa.qi.rejection.threshold.target": "Cible",
  "qa.qi.rejection.threshold.action": "Action",
  "qa.qi.rejection.reasons.column.reason": "Motif",
  "qa.qi.rejection.reasons.column.count": "Nombre",
  "qa.qi.rejection.breakdown.title": "Par analyse",
  "qa.qi.rejection.breakdown.column.test": "Test",
  "qa.qi.rejection.breakdown.column.rejected": "Rejeté",
  "qa.qi.rejection.breakdown.column.total": "Démarré",
  "qa.qi.rejection.breakdown.column.rate": "Taux",
  "qa.qi.callback.failures.column.reason": "Motif",
  "qa.qi.callback.failures.column.count": "Nombre",
  "qa.qi.callback.error": "Les données de rappel sont indisponibles.",
  "qa.qi.callback.column.releasedAt": "Publié",
  "qa.qi.callback.column.labNumber": "Numéro laboratoire",
  "qa.qi.callback.column.test": "Test",
  "qa.qi.callback.column.resultValue": "Résultat ",
  "qa.qi.callback.column.criticalRange": "Plage critique",
  "qa.qi.callback.column.recipient": "Personne avisée",
  "qa.comingSoon.subtitle": "Cette page est prévue mais pas encore développée.",
  "qa.overview.section.today": "Aujourd'hui",
  "qa.overview.tile.tat": "TAT moyen",
  "qa.overview.tile.rejectionRate": "Taux de rejet",
  "qa.overview.tile.amendmentRate": "Taux de correction",
  "qa.overview.tile.ncePulse": "Suivi des ENC",
  "qa.overview.ncePulse.criticalPending": "critiques en attente",
  "qa.overview.ncePulse.inCorrectiveAction": "{count} en action corrective",
  "qa.overview.activity.system": "Système",
  "storage.picker.backToSearch": "Retour à la recherche",
  "storage.picker.createNewLocation": "Créer un nouvel emplacement",
  "storage.picker.heading.moveSample": "Déplacer l'échantillon",
  "storage.picker.sample.accession": "Accession",
  "storage.picker.sample.heading": "Échantillon",
  "storage.picker.sample.status": "Statut",
  "storage.picker.sample.type": "Type",
  "storage.metrics.storage.locations": "Emplacements de stockage",
  "storage.tab.devices": "Devices",
  "storage.tab.racks": "Racks",
  "storage.tab.rooms": "Rooms",
  "storage.tab.shelves": "Shelves",
  "validation.label.qcHold": "Échec du contrôle QC",
  "validation.qcHold.blocked": "Certains résultats n'ont pas été libérés car un contrôle qualité les couvrant a échoué. Clôturez la non-conformité ou rejetez les résultats concernés.",
  "validation.qcHold.withheld": "{count, plural, one {1 résultat n'a pas été libéré ({accessions}). Un échec de CQ le couvrant est toujours ouvert. Vérifiez la non-conformité ou rejetez le résultat.} many {# résultats n'ont pas été libérés ({accessions}). Un échec de CQ les couvrant est toujours ouvert. Vérifiez la non-conformité ou rejetez les résultats.} other {# résultats n'ont pas été libérés ({accessions}). Un échec de CQ les couvrant est toujours ouvert. Vérifiez la non-conformité ou rejetez les résultats.}}",
  "qc.dashboard.export.button": "Exporter",
  "qc.dashboard.export.instrument": "Instrument",
  "qc.dashboard.export.level": "Niveau de contrôle",
  "qc.dashboard.export.startDate": "Date de début",
  "qc.dashboard.export.endDate": "Date de fin",
  "qc.dashboard.export.csv": "Exporter en CSV",
  "qc.dashboard.export.pdf": "Exporter en PDF",
  "qc.dashboard.export.cancel": "Annuler",
  "qc.instrument.tab.timeline": "Chronologie d'activité",
  "qc.instrument.tab.chart": "Graphique de contrôle",
  "qc.chart.stats.mean": "Moyenne",
  "qc.chart.stats.n": "N",
  "qc.chart.subtitle": "Carte de contrôle de Levey-Jennings",
  "qc.chart.filter.startDate": "Date de début",
  "qc.chart.filter.endDate": "Date de fin",
  "qc.chart.filter.controlLevel": "Niveau de contrôle",
  "qc.chart.filter.selectLevel": "Sélectionner le niveau",
  "qc.chart.filter.levelLow": "Bas",
  "qc.chart.filter.levelNormal": "Normal",
  "qc.chart.filter.levelHigh": "Haut",
  "qc.chart.filter.controlLot": "Lot de contrôle",
  "qc.chart.filter.allLots": "Tous les lots",
  "qc.chart.action.export": "Exporter",
  "qc.bench.source.label": "Source",
  "qc.bench.column.labUnit": "Unité de laboratoire",
  "qc.bench.column.test": "Test",
  "qc.bench.column.source": "Source",
  "qc.bench.column.failed": "Failed",
  "eqa.distribution.updateSuccess": "Brouillon de distribution mis à jour.",
  "banner.menu.eqa.myCycles": "Mes cycles",
  "banner.menu.eqa.labPerformance": "Performance du laboratoire",
  "banner.menu.eqa.followUpQueue": "Suivi de ce laboratoire",
  "banner.menu.eqa.analystCompetency": "Compétence des analystes",
  "banner.menu.eqa.provider": "Fournisseur d'EEQ",
  "eqa.participant.myCycles.title": "Mes cycles EEQ",
  "eqa.participant.myCycles.subtitle": "Cycles auxquels votre laboratoire participe. La saisie et la validation des résultats se font dans le circuit standard d'OpenELIS : cette page suit l'avancement et vous y redirige.",
  "eqa.participant.infoTitle": "Les résultats EEQ passent par la validation standard.",
  "eqa.participant.infoBody": "Cliquez sur un N° de laboratoire pour ouvrir la saisie standard des résultats de cet échantillon. Une fois la validation terminée, le cycle passe à Soumis (ou Prêt à soumettre si le programme exige une revue au niveau du cycle).",
  "eqa.kpi.active": "Cycles actifs",
  "eqa.kpi.active.hint": "en cours",
  "eqa.kpi.readyToSubmit": "Prêt à soumettre",
  "eqa.kpi.readyToSubmit.hint": "avec indicateur de revue activé",
  "eqa.kpi.awaiting": "En attente des scores",
  "eqa.kpi.awaiting.hint": "soumis à l'organisateur",
  "eqa.kpi.openNce": "ENC ouvertes liées à l'EEQ",
  "eqa.kpi.openNce.attention": "attention requise",
  "eqa.kpi.openNce.none": "aucune ouverte",
  "eqa.bucket.label": "Statut",
  "eqa.bucket.active": "Active",
  "eqa.bucket.awaiting": "En attente des scores",
  "eqa.bucket.completed": "Terminé",
  "eqa.bucket.all": "Tous",
  "eqa.bucket.active.hint": "Travail en cours : à venir, en analyse ou prêt à soumettre",
  "eqa.bucket.awaiting.hint": "Soumis au prestataire ; en attente de notation",
  "eqa.bucket.completed.hint": "Noté ou clôturé",
  "eqa.bucket.all.hint": "Tous les cycles traités par ce laboratoire",
  "eqa.filter.schemeType": "Type de programme",
  "eqa.schemeType.all": "Tous les types",
  "eqa.schemeType.international_pt": "Essai d'aptitude international",
  "eqa.schemeType.regional_pt": "Essai d'aptitude régional",
  "eqa.schemeType.inter_lab_split": "Échange interlaboratoires",
  "eqa.schemeType.in_house": "En interne",
  "eqa.filter.searchCycles": "Rechercher un programme, un organisateur ou un cycle",
  "eqa.filter.showing": "{shown} cycles affichés sur {total}",
  "eqa.filter.clear": "Effacer les filtres",
  "eqa.col.scheme": "Programme",
  "eqa.col.type": "Type",
  "eqa.col.cycle": "Cycle",
  "eqa.col.status": "Statut",
  "eqa.col.deadline": "Date limite",
  "eqa.col.progress": "Progrès",
  "eqa.cycle.status.planned": "Planifié",
  "eqa.cycle.status.panel_received": "Panel reçu",
  "eqa.cycle.status.testing": "Analyses en cours",
  "eqa.cycle.status.ready_to_submit": "Prêt à soumettre",
  "eqa.cycle.status.submitted": "Soumis",
  "eqa.cycle.status.scored": "Noté",
  "eqa.cycle.status.closed": "Fermé",
  "eqa.cycle.toggleDetails": "Afficher/masquer les détails du cycle",
  "eqa.cycle.emptyFiltered": "Aucun cycle ne correspond à ces filtres.",
  "eqa.cycle.nceBanner": "Score inacceptable pour {scheme}. Assurez le suivi dans le registre des ENC.",
  "eqa.cycle.perAnalyst.title": "Analyste requis par résultat",
  "eqa.cycle.perAnalyst.body": "Les analystes sont associés lors de l'inscription au programme. La colonne par analyste est visible sur la page standard de saisie des résultats.",
  "eqa.cycle.review.title": "Revue facultative au niveau du cycle activée pour ce programme.",
  "eqa.cycle.review.body": "Les {total} analytes ont tous été validés dans le circuit standard. La soumission se fait en un seul clic : la validation fait foi, sans nouvelle authentification.",
  "eqa.btn.reviewSubmit": "Vérifier et soumettre",
  "eqa.cycle.submitted.success": "Cycle soumis au prestataire, en attente des scores.",
  "eqa.cycle.submitted.error": "Échec de la soumission : le cycle n'a pas avancé. Vérifiez que tous les résultats sont validés, puis réessayez.",
  "eqa.progress.title": "Avancement des échantillons",
  "eqa.sample.labNo": "Lab No",
  "eqa.sample.providerId": "ID d'échantillon de l'organisateur",
  "eqa.sample.analytes": "Analytes",
  "eqa.sample.analyst": "Analyste affecté",
  "eqa.sample.entryStatus": "Statut de saisie",
  "eqa.labNo.tooltip": "Ouvrir la saisie des résultats pour ce numéro de laboratoire",
  "eqa.entry.entered": "Saisi",
  "eqa.entry.in_progress": "En cours",
  "eqa.entry.empty": "Non saisi",
  "eqa.cycle.scoredCopy": "Notation terminée. Les résultats notés apparaissent sous Performance du laboratoire.",
  "eqa.cycle.submittedCopy": "Soumis au prestataire, en attente des scores.",
  "eqa.cycle.closedCopy": "Cycle clôturé.",
  "eqa.cycle.panelReceivedCopy": "Panel reçu. Passez à la saisie standard des résultats pour commencer les analyses.",
  "eqa.cycle.plannedCopy": "Le panel n'a pas encore été reçu dans ce laboratoire. Ouvrez Ajouter une demande avec la case EEQ cochée pour enregistrer la réception.",
  "eqa.btn.receivePanel": "Recevoir le panel - ouvrir Ajouter une demande",
  "eqa.uncycled.title": "Demandes EEQ sans cycle",
  "eqa.uncycled.subtitle": "Demandes EEQ non liées à un cycle. Elles restent visibles ici pour que rien ne soit perdu.",
  "eqa.review.title": "Synthèse avant soumission",
  "eqa.review.subtitle": "Synthèse en lecture seule de tous les résultats validés, regroupés par échantillon. C'est ce qui sera soumis au prestataire.",
  "eqa.review.auditFootnote": "Chaque valeur ci-dessus a été validée dans le circuit standard, qui a consigné l'utilisateur validant dans la piste d'audit. La soumission enregistre uniquement l'accusé de prise en compte, sans signature distincte.",
  "eqa.sample.analyte": "Analyte",
  "eqa.sample.reportedValue": "Valeur rapportée",
  "eqa.sample.validatedAt": "Validé",
  "eqa.order.cycle": "Cycle EEQ",
  "eqa.order.receipt.title": "Réception du panel",
  "eqa.order.receipt.tempC": "Température à l'arrivée (°C)",
  "eqa.order.receipt.integrityOk": "Panel arrivé intact",
  "eqa.order.receipt.notes": "Notes sur l'intégrité",
  "eqa.order.receipt.recorded": "Réception du panel déjà enregistrée le {date}.",
  "eqa.cycle.status.prep_in_progress": "Préparation en cours",
  "eqa.cycle.status.ready_to_ship": "Prêt à expédier",
  "eqa.cycle.status.shipped": "Expédiés",
  "eqa.cycle.status.delivered": "Livré",
  "eqa.cycle.status.submissions_open": "Soumissions ouvertes",
  "eqa.cycle.status.submissions_closed": "Soumissions closes",
  "eqa.cycle.status.scoring": "Notation en cours",
  "eqa.provider.workbench.cycle": "Atelier du cycle",
  "eqa.provider.workbench.forCycle": "Préparation et expédition : {name}",
  "eqa.provider.workbench.tabs": "Ateliers",
  "eqa.provider.workbench.stateHint": "La préparation doit satisfaire au contrôle d'inventaire et de CQ avant toute expédition de panel.",
  "eqa.prep.tab": "Préparation",
  "eqa.prep.participants": "Participants",
  "eqa.prep.panels": "Panels",
  "eqa.prep.gate": "Conditions préalables à l'expédition",
  "eqa.prep.gate.clear": "Toutes les exigences de préparation sont remplies",
  "eqa.prep.noPanel.title": "Aucun panel préparé",
  "eqa.prep.noPanel.body": "Créez le panel du cycle et ses échantillons avant d'enregistrer l'avancement de la préparation.",
  "eqa.prep.needExplained": "Aliquotes nécessaires : {samples, plural, one {# échantillon} other {# échantillons}} x {participants, plural, one {# participant} other {# participants}} + {reserved} en réserve = {needed, plural, one {# aliquote} other {# aliquotes}} ; {shipped, plural, one {# aliquote expédiée} other {# aliquotes expédiées}} à ce jour.",
  "eqa.prep.produced": "Aliquotes produites",
  "eqa.prep.reserved": "Aliquotes réservées",
  "eqa.prep.shortfall": "{n} manquantes",
  "eqa.prep.homogeneity": "CQ d'homogénéité validé",
  "eqa.prep.homogeneityNotes": "Notes du CQ",
  "eqa.prep.save": "Enregistrer la préparation",
  "eqa.prep.saved": "Préparation mise à jour.",
  "eqa.prep.saveFailed": "La préparation n'a pas été enregistrée.",
  "eqa.prep.readyToShip": "Marquer le cycle prêt à expédier",
  "eqa.prep.readyToShip.success": "Cycle autorisé à l'expédition : enregistrez les détails du transporteur dans l'onglet Expéditions.",
  "eqa.prep.readyToShip.refused": "Le cycle n'a pas été autorisé à l'expédition. Réglez les éléments de préparation en suspens et réessayez.",
  "eqa.shipment.tab": "Expéditions",
  "eqa.shipment.participant": "Participant",
  "eqa.shipment.box": "Boîte",
  "eqa.shipment.courier": "Transporteur",
  "eqa.shipment.courierFor": "Transporteur pour {name}",
  "eqa.shipment.tracking": "Numéro de suivi",
  "eqa.shipment.trackingFor": "Numéro de suivi pour {name}",
  "eqa.shipment.expected": "Livraison prévue",
  "eqa.shipment.expectedFor": "Livraison prévue pour {name}",
  "eqa.shipment.selectAll": "Sélectionner tous les envois en attente",
  "eqa.shipment.selectRow": "Sélectionner {name} pour l'expédition",
  "eqa.shipment.markShipped": "Marquer {n} comme expédiés",
  "eqa.shipment.firstShipHint": "La première expédition fait passer le cycle à l'état Expédié.",
  "eqa.shipment.saved": "Détails de l'envoi enregistrés.",
  "eqa.shipment.saveFailed": "Les détails de l'envoi n'ont pas été enregistrés.",
  "eqa.shipment.shipped": "{n} envois aux participants expédiés.",
  "eqa.shipment.shipFailed": "Rien n'a été expédié.",
  "eqa.shipment.shippedOn": "Expédié le {date}",
  "eqa.shipment.packList": "Liste de colisage",
  "eqa.shipment.packList.noPanel": "Ce cycle n'a pas de panel : il n'y a donc rien à emballer.",
  "eqa.shipment.packList.unavailable": "Les échantillons du panel n'ont pas pu être lus : aucune liste de colisage n'a été produite. Rechargez et réessayez.",
  "eqa.shipment.packList.notes": "Matériel de panel EEQ : ne pas ouvrir avant la période d'analyse.",
  "eqa.shipment.label": "Etiquette",
  "eqa.shipment.noParticipants.title": "Aucun participant",
  "eqa.shipment.noParticipants.body": "Inscrivez des laboratoires participants à ce cycle avant d'expédier les panels.",
  "eqa.report.download": "Télécharger le rapport de performance",
  "banner.menu.eqa.inHouse": "Évaluation interne à l'aveugle",
  "eqa.inhouse.wizard.title": "Créer un panel interne anonymisé",
  "eqa.inhouse.step1": "Programme et cycle",
  "eqa.inhouse.step2": "Échantillons et préparation",
  "eqa.inhouse.step3": "Analystes",
  "eqa.inhouse.step4": "Confirmer et sceller",
  "eqa.inhouse.scheme": "Programme interne",
  "eqa.inhouse.cycleName": "Nom du cycle",
  "eqa.inhouse.plannedStart": "Date de début prévue",
  "eqa.inhouse.unblindDate": "Date de levée d'anonymat (date limite de soumission)",
  "eqa.inhouse.sample": "Échantillon",
  "eqa.inhouse.samples": "Échantillons",
  "eqa.inhouse.test": "Test",
  "eqa.inhouse.target": "Valeur cible",
  "eqa.inhouse.unit": "Unité",
  "eqa.inhouse.rangeLow": "Limite basse",
  "eqa.inhouse.rangeHigh": "Limite haute",
  "eqa.inhouse.addSample": "Ajouter un échantillon",
  "eqa.inhouse.analyst": "Analyste",
  "eqa.inhouse.roster": "Analystes du programme",
  "eqa.inhouse.roster.pick": "Sélectionner les analystes",
  "eqa.inhouse.roster.saveError": "Impossible d'enregistrer la liste des analystes",
  "eqa.inhouse.assign.manual": "Affecter les analystes manuellement (sinon par rotation)",
  "eqa.inhouse.assign.mode": "Mode d'affectation",
  "eqa.inhouse.assign.ROUND_ROBIN": "Rotation : un analyste par échantillon, attribué à tour de rôle",
  "eqa.inhouse.assign.IDENTICAL": "Ensemble identique : chaque analyste analyse les mêmes échantillons",
  "eqa.inhouse.assign.MANUAL": "Affectation manuelle par échantillon",
  "eqa.inhouse.assign.identicalNote": "Chaque analyste analyse chaque échantillon : {materials, plural, one {# échantillon} other {# échantillons}} × {analysts, plural, one {# analyste} other {# analystes}} = {aliquots, plural, one {# aliquote anonymisée} other {# aliquotes anonymisées}}, chacune avec son propre code d'anonymat.",
  "eqa.inhouse.assign.footnote": "Chaque affectation est enregistrée sur la demande anonymisée qu'elle crée et suit cette demande jusqu'à la saisie des résultats.",
  "eqa.inhouse.gate.identicalNeedsAnalysts": "Un ensemble identique nécessite au moins un analyste sur la liste du programme",
  "eqa.inhouse.samplesLeadIn": "{count, plural, one {# échantillon défini. Les valeurs cibles sont scellées à la fin de l'assistant ; elles ne sont jamais stockées en clair.} many {# échantillons définis. Les valeurs cibles sont scellées à la fin de l'assistant ; elles ne sont jamais stockées en clair.} other {# échantillons définis. Les valeurs cibles sont scellées à la fin de l'assistant ; elles ne sont jamais stockées en clair.}} defined. Target values are sealed when the wizard finishes; they are never stored in clear text.",
  "eqa.inhouse.confirm.aliquotRows": "Aliquotes anonymisées",
  "eqa.inhouse.confirm.sealWarning": "Le scellement chiffre les valeurs cibles",
  "eqa.inhouse.confirm.sealWarningBody": "Après le scellement, révéler une valeur cible nécessite le privilège de levée d'anonymat et est consigné dans la piste d'audit. Le panel ne peut plus être modifié ensuite.",
  "eqa.inhouse.confirm.afterSeal": "Le scellement crée une demande anonymisée par aliquote. Ces demandes apparaissent dans la saisie des résultats et dans le plan de travail sous leur code d'anonymat, comme toute autre demande.",
  "eqa.inhouse.prep.sourceType": "Source",
  "eqa.inhouse.prep.lotNumber": "Numéro de lot",
  "eqa.inhouse.prep.aliquots": "Aliquotes produites",
  "eqa.inhouse.prep.storageTemp": "Température de stockage",
  "eqa.inhouse.prep.expiration": "Date d'expiration",
  "eqa.inhouse.prep.homogeneity": "CQ d'homogénéité validé",
  "eqa.inhouse.prep.homogeneityNotes": "Notes du CQ d'homogénéité",
  "eqa.inhouse.gate.noSamples": "Ajoutez au moins un échantillon avant de continuer",
  "eqa.inhouse.gate.aliquots": "Les aliquotes produites doivent couvrir chaque échantillon anonymisé",
  "eqa.inhouse.gate.homogeneity": "Le CQ d'homogénéité n'est pas validé : la distribution nécessite donc une justification écrite",
  "eqa.inhouse.gate.targets": "Chaque échantillon nécessite une analyse et une valeur cible",
  "eqa.inhouse.confirm.samples": "Échantillons",
  "eqa.inhouse.confirm.labelNote": "Les feuilles d'étiquettes portent uniquement le code d'anonymat, le cycle et l'analyte, jamais une valeur cible.",
  "eqa.inhouse.seal": "Sceller le panel et distribuer",
  "eqa.inhouse.seal.error": "Impossible de sceller le panel",
  "eqa.inhouse.seal.cycleError": "Impossible de créer le cycle",
  "eqa.inhouse.seal.panelError": "Impossible de créer le panel",
  "eqa.inhouse.sealed.title": "Panel scellé et distribué",
  "eqa.inhouse.sealed.help": "Les demandes anonymisées portent désormais ces codes d'anonymat comme identifiants d'échantillon, dans la saisie des résultats et dans le plan de travail.",
  "eqa.inhouse.sealed.done": "Retour aux panels internes",
  "eqa.inhouse.panel": "Panel de matériel EEQ",
  "eqa.inhouse.panel.defaultName": "Panel interne",
  "eqa.inhouse.cycle": "Cycle",
  "eqa.inhouse.status": "Statut",
  "eqa.inhouse.actions": "Actions",
  "eqa.inhouse.launchWizard": "Lancer l'assistant d'anonymisation",
  "eqa.inhouse.noSchemes": "Aucun programme interne n'existe encore. Créez-en un d'abord dans la gestion des programmes EEQ.",
  "eqa.inhouse.labels.print": "Imprimer la feuille d'étiquettes",
  "eqa.inhouse.labels.error": "Impossible de générer la feuille d'étiquettes",
  "eqa.inhouse.unblind.now": "Lever l'anonymat maintenant",
  "eqa.inhouse.unblind.done": "Anonymat du panel levé et panel noté",
  "eqa.inhouse.unblind.error": "Impossible de lever l'anonymat de ce panel",
  "eqa.inhouse.targetValues": "Valeurs cibles",
  "eqa.inhouse.seal.sealed": "Scellé",
  "eqa.inhouse.seal.unsealed": "Non scellé",
  "eqa.inhouse.kpi.awaitingDistribution": "Scellés, en attente de distribution",
  "eqa.inhouse.kpi.inTesting": "En cours d'analyse",
  "eqa.inhouse.kpi.unblindingSoon": "Levée d'anonymat sous 7 jours",
  "eqa.inhouse.kpi.closed": "Noté ou clôturé",
  "eqa.inhouse.prep.title": "Détails de préparation et d'aliquotage",
  "eqa.inhouse.prep.subtitle": "Enregistrez les mêmes informations d'inventaire du panel que celles enregistrées par un prestataire.",
  "eqa.inhouse.prep.required": "Requis : {samples, plural, one {# échantillon} other {# échantillons}} = {samples, plural, one {# aliquote} other {# aliquotes}} minimum",
  "eqa.inhouse.back": "Back",
  "eqa.inhouse.next": "Suivante",
  "eqa.inhouse.cancel": "Annuler",
  "eqa.enrollment.testAnalytes": "Analyte rapporté par analyse",
  "eqa.enrollment.testAnalytes.help": "Définissez l'analyte que chaque analyse rapporte pour ce programme. Les résultats sont soumis au prestataire sous cet analyte ; une analyse sans analyte défini n'est pas soumise automatiquement.",
  "eqa.enrollment.selectAnalyte": "Choisir un analyte",
  "eqa.provider.schemes.title": "Programmes EEQ que nous fournissons",
  "eqa.provider.schemes.hint": "Développez un programme pour voir ses cycles, ou lancez un nouveau cycle pour définir son panel et ses participants.",
  "eqa.provider.schemes.none.title": "Aucun programme à fournir pour le moment",
  "eqa.provider.schemes.none.body": "Un programme apparaît ici dès qu'un autre laboratoire y est inscrit activement.",
  "eqa.provider.schemes.provider": "Page du prestataire",
  "eqa.provider.schemes.enrolled": "Laboratoires inscrits",
  "eqa.provider.schemes.cycles": "Cycles",
  "eqa.provider.schemes.expand": "Afficher les cycles",
  "eqa.provider.schemes.newCycle": "Nouveau cycle",
  "eqa.provider.schemes.noCycles": "Aucun cycle pour le moment. Lancez-en un pour définir son panel et ses participants.",
  "eqa.scheme.type.international_pt": "Essai d'aptitude international",
  "eqa.scheme.type.regional_pt": "Essai d'aptitude régional",
  "eqa.scheme.type.inter_lab_split": "Échange interlaboratoires",
  "eqa.scheme.type.in_house": "En interne",
  "eqa.panel.source.in_house_aliquoted": "Pool d'échantillons de patients, aliquoté en interne",
  "eqa.panel.source.vendor_sourced": "Matériel fourni par un fournisseur",
  "eqa.panel.source.mixed": "Sources mixtes",
  "eqa.panel.storage.ambient": "Température ambiante",
  "eqa.panel.storage.refrigerated_2_8c": "Réfrigéré, 2–8°C",
  "eqa.panel.storage.frozen_minus_20c": "Congelé, −20°C",
  "eqa.panel.storage.ultra_frozen_minus_80c": "Ultra-congelé, −80°C",
  "eqa.panel.storage.dry_ice": "Glace carbonique",
  "eqa.provider.wizard.title": "Nouveau cycle",
  "eqa.provider.wizard.forScheme": "Nouveau cycle : {name}",
  "eqa.provider.wizard.step.cycle": "Cycle",
  "eqa.provider.wizard.step.panel": "Panneau",
  "eqa.provider.wizard.step.distribution": "Distribution",
  "eqa.provider.wizard.cycleName": "Nom du cycle",
  "eqa.provider.wizard.cycleNumber": "Numéro du cycle",
  "eqa.provider.wizard.cycleNumber.hint": "Si ce champ est vide, le prochain numéro disponible pour ce programme est utilisé.",
  "eqa.provider.wizard.panelName": "Nom du panel",
  "eqa.provider.wizard.source": "Source du matériel",
  "eqa.provider.wizard.lot": "Numéro de lot",
  "eqa.provider.wizard.vendor": "Nom du fournisseur",
  "eqa.provider.wizard.vendorLot": "Lot du fournisseur",
  "eqa.provider.wizard.vendorCertificate": "Référence du certificat du fournisseur",
  "eqa.provider.wizard.sampleCode": "Code de l'échantillon",
  "eqa.provider.wizard.target": "Valeur cible",
  "eqa.provider.wizard.target.hint": "Une valeur cible est scellée et chiffrée au repos ; laissez-la vide si la cible n'est connue qu'au moment de la notation.",
  "eqa.provider.wizard.unit": "Unité",
  "eqa.provider.wizard.rangeLow": "Limite basse d'acceptation",
  "eqa.provider.wizard.rangeHigh": "Limite haute d'acceptation",
  "eqa.provider.wizard.addSample": "Ajouter un échantillon",
  "eqa.provider.wizard.removeSample": "Retirer",
  "eqa.provider.wizard.sampleCount": "Échantillons du panel",
  "eqa.provider.wizard.test": "Test",
  "eqa.provider.wizard.test.select": "Sélectionner un test",
  "eqa.provider.wizard.participants": "Laboratoires participants",
  "eqa.provider.wizard.participants.hint": "Seuls les laboratoires inscrits activement à ce programme peuvent participer, et seuls ceux choisis ici sont pris en compte par le contrôle de préparation.",
  "eqa.provider.wizard.storageTemp": "Température de stockage",
  "eqa.provider.wizard.storageTemp.hint": "Devient l'exigence de température de chaque boîte d'expédition.",
  "eqa.provider.wizard.storageTemp.select": "Sélectionner une température",
  "eqa.provider.wizard.expiration": "Expiration du matériel",
  "eqa.provider.wizard.reserve.hint": "Les aliquotes réservées aux analyses répétées sont enregistrées dans l'atelier de préparation, une fois le matériel disponible.",
  "eqa.provider.wizard.confirm.hint": "La création du cycle le fait passer directement en préparation, où le nombre d'aliquotes et le CQ d'homogénéité sont enregistrés.",
  "eqa.provider.wizard.create": "Créer le cycle et commencer la préparation",
  "eqa.provider.wizard.failed": "Le cycle n'a pas été créé.",
  "eqa.cycle.distributionMethod": "Méthode de distribution",
  "eqa.cycle.distributionMethod.fhir": "FHIR",
  "eqa.cycle.distributionMethod.csv": "Export CSV",
  "eqa.cycle.distributionMethod.mixed": "Mixte",
  "eqa.cycle.distributionMethod.hint": "FHIR connecté, fichiers exportés, ou les deux si les participants diffèrent. La chaîne du froid du panel est enregistrée avec sa source à l'étape 2.",
  "eqa.cycle.history": "Historique du cycle",
  "eqa.cycle.history.empty": "Aucun changement d'état enregistré pour ce cycle pour le moment.",
  "eqa.cycle.history.when": "Lorsque",
  "eqa.cycle.history.state": "État",
  "eqa.cycle.history.trigger": "Déclencheur",
  "eqa.cycle.history.reason": "Motif",
  "eqa.cycle.history.manual": "Manuel",
  "eqa.report.comments.tab": "Commentaires du rapport",
  "eqa.report.comments.hint": "Seuls les commentaires pré-approuvés peuvent être imprimés. Modifiez leur formulation sous Administration → Gestion du dictionnaire.",
  "eqa.report.comments.picker": "Commentaires approuvés",
  "eqa.report.comments.pickerLabel": "Sélectionner des commentaires",
  "eqa.report.comments.add": "Ajouter au rapport",
  "eqa.report.comments.added": "{count} commentaire(s) ajouté(s) au rapport",
  "eqa.report.comments.comment": "Commentaire",
  "eqa.report.comments.attribution": "Ajouté par",
  "eqa.report.comments.none": "Aucun commentaire sur le rapport de ce cycle pour le moment.",
  "eqa.report.comments.remove": "Retirer",
  "eqa.report.comments.emptyLibrary.title": "Aucun commentaire approuvé configuré",
  "eqa.report.comments.emptyLibrary.body": "Ajoutez des entrées à la catégorie de dictionnaire EQA Report Comment pour pouvoir les sélectionner ici.",
  "eqa.report.comments.addFailed": "Le commentaire n'a pas pu être ajouté au rapport.",
  "eqa.report.comments.removeFailed": "Le commentaire n'a pas pu être retiré du rapport.",
  "eqa.performance.ACCEPTABLE": "Acceptable",
  "eqa.performance.QUESTIONABLE": "Discutable",
  "eqa.performance.UNACCEPTABLE": "Inacceptable",
  "eqa.oversight.followUpQueue": "Suivi de ce laboratoire",
  "eqa.oversight.queueSubtitle": "Scores EEQ discutables de ce laboratoire en attente de revue corrective, provenant de prestataires externes et des programmes internes de ce laboratoire. La correspondance avec les laboratoires participant aux programmes fournis par ce laboratoire relève d'un autre registre :",
  "eqa.queue.policyTitle": "Règle d'ENC automatique active.",
  "eqa.queue.policyBody": "Les scores inacceptables de tout programme externe auquel ce laboratoire participe ouvrent automatiquement une ENC. Cette file contient la plage discutable (2 < |Z| ≤ 3) et les échecs internes, qui nécessitent un tri humain.",
  "eqa.queue.kpi.queued": "Éléments en file",
  "eqa.queue.kpi.questionable": "Discutable",
  "eqa.queue.kpi.questionable.hint": "2 < |Z| ≤ 3",
  "eqa.queue.kpi.inHouse": "Échecs internes",
  "eqa.queue.kpi.oldest": "Le plus ancien",
  "eqa.queue.kpi.days": "{days} jours",
  "eqa.queue.count": "File · {count, plural, one {# élément} other {# éléments}}",
  "eqa.queue.exportCsv": "Exporter en CSV",
  "eqa.queue.empty": "Rien en attente de tri. Les scores discutables et les échecs internes arrivent ici à mesure que les cycles sont notés.",
  "eqa.queue.cycle": "Cycle",
  "eqa.queue.cycleNumber": "Cycle {number}",
  "eqa.queue.analyte": "Analyte",
  "eqa.queue.analytePlus": "{first} +{more} autre(s)",
  "eqa.queue.zScore": "Score Z",
  "eqa.queue.reason": "Motif",
  "eqa.queue.enqueued": "Mis en file",
  "eqa.queue.source": "Source",
  "eqa.queue.source.external": "Organisateur externe",
  "eqa.queue.source.in_house": "En interne",
  "eqa.queue.source.inter_lab_split": "Échange interlaboratoires",
  "eqa.queue.reason.questionable": "Discutable",
  "eqa.queue.reason.inHouseFailure": "Échec interne",
  "eqa.queue.triage": "Tri",
  "eqa.queue.triageTitle": "Trier cet élément",
  "eqa.queue.triageHelp": "Transmettez si vous suspectez une réelle non-conformité. Classez sans suite avec un motif s'il s'agit d'un bruit : erreur de transcription ou problème d'équipement déjà documenté. Les entrées classées sans suite restent liées au cycle pour la traçabilité d'accréditation.",
  "eqa.queue.reported": "Rapporté",
  "eqa.queue.target": "Cible",
  "eqa.queue.verdict": "Verdict",
  "eqa.queue.escalate": "Transmettre en ENC",
  "eqa.queue.dismiss": "Classer sans suite avec motif",
  "eqa.queue.viewCycle": "Voir le cycle",
  "eqa.queue.escalated": "Transmis : ENC {nce} ouverte pour ce cycle.",
  "eqa.queue.escalateFailed": "La transmission a été refusée.",
  "eqa.queue.dismissed": "Classé sans suite. L'événement de compétence de cette catégorie est enregistré.",
  "eqa.queue.dismissFailed": "Le classement sans suite a été refusé.",
  "eqa.queue.dismissHeading": "Classer sans suite avec motif",
  "eqa.queue.dismissConfirm": "Ignorer",
  "eqa.queue.dismissHelp": "La catégorie détermine quel événement de compétence est enregistré pour chaque résultat couvert par cette entrée : choisissez celle qui décrit ce qui s'est passé.",
  "eqa.queue.cancel": "Annuler",
  "eqa.queue.category": "Catégorie",
  "eqa.queue.category.TRANSCRIPTION_ERROR": "Erreur de transcription",
  "eqa.queue.category.KNOWN_EQUIPMENT_ISSUE": "Problème d'équipement connu",
  "eqa.queue.category.PENDING_RE_TEST": "Reprise d'analyse en attente",
  "eqa.queue.category.ACCEPTABLE_ON_REVIEW": "Acceptable après revue",
  "eqa.queue.category.OTHER": "Autre",
  "eqa.queue.notes": "Notes",
  "eqa.labperf.title": "Performance du laboratoire",
  "eqa.labperf.coverage.title": "Performance EEQ du laboratoire : couverture",
  "eqa.labperf.coverage.subtitle": "Aperçu pour l'accréditation : indicateurs clés du laboratoire, puis couverture EEQ par section sur les quatre derniers cycles de chaque programme. Les sections sans essai d'aptitude actif sont candidates à l'évaluation alternative selon l'ISO 15189 §7.7.2.",
  "eqa.labperf.recent.title": "Performance EEQ du laboratoire : cycles récents",
  "eqa.labperf.recent.subtitle": "Cycles rapportés par ce laboratoire au cours des 12 derniers mois, avec le statut de notation et le verdict.",
  "eqa.labperf.tab.coverage": "Couverture",
  "eqa.labperf.tab.recent": "Cycles récents",
  "eqa.labperf.kpi.acceptance": "Taux d'acceptation (12 mois)",
  "eqa.labperf.kpi.delta": "{delta} par rapport à l'année précédente",
  "eqa.labperf.kpi.noPriorYear": "pas d'année précédente à comparer",
  "eqa.labperf.kpi.onTime": "Taux de soumission dans les délais",
  "eqa.labperf.kpi.late": "{late} en retard sur {total}",
  "eqa.labperf.kpi.nce": "ENC déclenchées par l'EEQ (12 mois)",
  "eqa.labperf.kpi.nceOpen": "{open} ouvertes → registre des ENC",
  "eqa.labperf.kpi.uncovered": "Analyses accréditées sans EEQ",
  "eqa.labperf.kpi.uncovered.hint": "Candidates au §7.7.2",
  "eqa.labperf.openNceRegister": "Ouvrir le registre des ENC filtré sur les événements déclenchés par l'EEQ",
  "eqa.labperf.legendIntro": "Les quatre derniers cycles de chaque programme, par section.",
  "eqa.labperf.legend.acceptable": "Acceptable",
  "eqa.labperf.legend.questionable": "Discutable",
  "eqa.labperf.legend.unacceptable": "Inacceptable",
  "eqa.labperf.legend.missing": "Non inscrit / manqué",
  "eqa.labperf.section": "Section",
  "eqa.labperf.unassignedSection": "Section non attribuée",
  "eqa.labperf.scheme": "Programme",
  "eqa.labperf.cycle": "Cycle",
  "eqa.labperf.cycleOffset": "Cycle −{n}",
  "eqa.labperf.mostRecent": "Le plus récent",
  "eqa.labperf.acceptanceRate": "Taux d'acceptation",
  "eqa.labperf.coverage.empty": "Aucun résultat EEQ noté pour le moment. La couverture apparaît dès qu'un cycle auquel ce laboratoire a participé a été noté.",
  "eqa.labperf.gapTitle": "Accrédité sans couverture EEQ :",
  "eqa.labperf.gapBody": "{tests} : aucune inscription EEQ active, une évaluation alternative selon l'ISO 15189 §7.7.2 est donc requise.",
  "eqa.labperf.filterScheme": "Filtrer par programme",
  "eqa.labperf.status": "Statut",
  "eqa.labperf.score": "Score",
  "eqa.labperf.scoreOf": "{acceptable} sur {scored}",
  "eqa.labperf.performance": "Performance",
  "eqa.labperf.submitted": "Soumis",
  "eqa.labperf.pending": "en attente",
  "eqa.labperf.verdict.acceptable": "Acceptable",
  "eqa.labperf.verdict.questionable": "Discutable",
  "eqa.labperf.verdict.unacceptable": "Inacceptable",
  "eqa.labperf.recent.empty": "Aucun cycle rapporté au cours des 12 derniers mois.",
  "nce.filter.source": "Source",
  "nce.filter.source.all": "Toutes les sources",
  "nce.filter.source.eqa": "Déclenché par l'EEQ",
  "eqa.receipt.tab": "Réceptions et notation",
  "eqa.receipt.hint": "Les soumissions s'ouvrent automatiquement dès que chaque participant a reçu son panel. En retard signifie deux jours ouvrés après la livraison prévue.",
  "eqa.receipt.noParticipants.body": "Les réceptions apparaissent ici une fois les panels expédiés aux laboratoires participants inscrits.",
  "eqa.receipt.condition": "État",
  "eqa.receipt.damaged": "Endommagé : {notes}",
  "eqa.receipt.tempOnArrival": "{temp} °C",
  "eqa.receipt.isRepeat": "Envoi de répétition",
  "eqa.receipt.markReceived": "Marquer comme reçu",
  "eqa.receipt.delivered": "Livraison enregistrée.",
  "eqa.receipt.deliveredFailed": "La livraison n'a pas pu être enregistrée.",
  "eqa.receipt.sendRepeat": "Envoyer une répétition",
  "eqa.receipt.repeatHeading": "Envoyer un panel de répétition",
  "eqa.receipt.repeatHelp": "La répétition est prélevée sur la réserve du panel. Si la réserve ne suffit pas, une justification écrite est requise avant d'utiliser du matériel non réservé.",
  "eqa.receipt.overrideNote": "Note de forçage",
  "eqa.receipt.repeatSent": "Panel de répétition expédié.",
  "eqa.receipt.repeatFailed": "La répétition a été refusée.",
  "eqa.receipt.status.NOT_SHIPPED": "Non expédié",
  "eqa.receipt.status.IN_TRANSIT": "En transit",
  "eqa.receipt.status.EXCEPTION": "Arrivé endommagé",
  "eqa.score.scoreCycle": "Noter le cycle",
  "eqa.score.scored": "Cycle noté. Les participants inacceptables figurent dans le registre de suivi.",
  "eqa.score.scoreFailed": "Le cycle n'a pas pu être noté.",
  "eqa.score.verdicts": "Scores",
  "eqa.score.counts": "{unacceptable} inacceptables sur {total}",
  "eqa.score.sendScores": "Envoyer les scores",
  "eqa.score.distributed": "Scores déposés dans l'entrepôt FHIR pour que le participant les récupère.",
  "eqa.score.distributeFailed": "Les scores n'ont pas pu être renvoyés.",
  "eqa.score.downloadCsv": "CSV des scores",
  "eqa.provider.followups.title": "Suivi des participants",
  "eqa.provider.followups.subtitle": "Laboratoires participant aux programmes fournis par ce laboratoire ayant rendu des résultats inacceptables. Le suivi est ici une correspondance avec un autre laboratoire : il n'ouvre jamais de non-conformité dans le registre de ce laboratoire.",
  "eqa.provider.followups.open": "Registre de suivi",
  "eqa.provider.followups.empty": "Aucun suivi des participants. Les entrées apparaissent ici à mesure que les cycles du prestataire sont notés.",
  "eqa.provider.followups.unknownOrg": "Laboratoire inconnu",
  "eqa.provider.followups.persistent": "Échec persistant",
  "eqa.provider.followups.response": "Réponse",
  "eqa.provider.followups.notify": "Notifier le laboratoire",
  "eqa.provider.followups.emailed": "Notification envoyée par e-mail à {to}.",
  "eqa.provider.followups.csvFallback": "Aucune adresse e-mail de contact enregistrée : la notification a été téléchargée en CSV pour un envoi manuel.",
  "eqa.provider.followups.flagRepeat": "Signaler pour répétition",
  "eqa.provider.followups.repeatSent": "Panel de répétition expédié à {name}.",
  "eqa.provider.followups.moved": "Suivi passé à {status}.",
  "eqa.provider.followups.failed": "L'action a été refusée.",
  "eqa.provider.followups.notesHelp": "Ce qui a été convenu avec le laboratoire. Enregistré sur l'entrée du registre pour la traçabilité d'accréditation.",
  "eqa.provider.followups.status.NOTIFIED": "Notifié",
  "eqa.provider.followups.status.RESPONSE_RECEIVED": "Réponse reçue",
  "eqa.provider.followups.status.UNDER_INVESTIGATION": "En cours d'investigation",
  "eqa.provider.followups.status.ESCALATED": "Transmis à un niveau supérieur",
  "eqa.provider.followups.status.REMOVED_FROM_PROGRAM": "Retiré du programme",
  "eqa.provider.followups.action.RESPONSE_RECEIVED": "Enregistrer la réponse",
  "eqa.provider.followups.action.UNDER_INVESTIGATION": "Ouvrir une investigation",
  "eqa.provider.followups.action.RESOLVED": "Résolu",
  "eqa.provider.followups.action.REMOVED_FROM_PROGRAM": "Retirer du programme",
  "eqa.competency.subtitle": "Tous les analystes affectés aux essais d'aptitude au cours des douze derniers mois, classés par analyte. Un analyste n'est déclaré compétent que si les éléments probants le confirment : moins de quatre échantillons évaluables signifie « en cours d'évaluation », et non une réussite.",
  "eqa.competency.band.competent": "Compétent",
  "eqa.competency.band.underReview": "En cours de vérification",
  "eqa.competency.band.notCompetent": "Non compétent",
  "eqa.competency.outcome.acceptable": "Acceptable",
  "eqa.competency.outcome.questionable": "Discutable",
  "eqa.competency.outcome.unacceptable": "Inacceptable",
  "eqa.competency.outcome.missed": "Délai dépassé",
  "eqa.competency.outcome.dismissed": "Classé sans suite au tri",
  "eqa.competency.event.scored": "Résultat noté",
  "eqa.competency.event.UNACCEPTABLE_SCORE": "Score inacceptable",
  "eqa.competency.event.QUESTIONABLE_SCORE": "Score discutable",
  "eqa.competency.event.EXTERNAL_MISSED_DEADLINE": "Délai de l'organisateur dépassé",
  "eqa.competency.event.IN_HOUSE_MISSED_DEADLINE": "Délai interne dépassé",
  "eqa.competency.event.ESCALATED_TO_NCE": "Transmis en non-conformité",
  "eqa.competency.event.DISMISSED_EQUIPMENT": "Classé sans suite : équipement",
  "eqa.competency.event.DISMISSED_TRANSCRIPTION": "Classé sans suite : transcription",
  "eqa.competency.event.DISMISSED_ACCEPTABLE_ON_REVIEW": "Classé sans suite : acceptable après revue",
  "eqa.competency.event.DISMISSED_OTHER": "Classé sans suite : autre",
  "eqa.competency.kpi.analysts": "Analystes évalués",
  "eqa.competency.kpi.samples": "{count} échantillons d'essai d'aptitude",
  "eqa.competency.kpi.notCompetent.hint": "ENC transmise ouverte",
  "eqa.competency.search": "Filtrer les analystes",
  "eqa.competency.export": "Exporter en CSV",
  "eqa.competency.analyst": "Analyste",
  "eqa.competency.samples": "Échantillons d'essai d'aptitude (12 mois)",
  "eqa.competency.recent": "Performance la plus récente",
  "eqa.competency.status": "Compétence",
  "eqa.competency.history": "Historique",
  "eqa.competency.viewHistory": "Afficher l'historique",
  "eqa.competency.empty": "Aucun analyste n'a été enregistré sur un résultat EEQ au cours des douze derniers mois. Les analystes apparaissent ici dès que les résultats comportent un analyste assigné.",
  "eqa.competency.analyteCount": "{count} analytes évalués",
  "eqa.competency.thisYear": "{count} cette année · {failures} en échec",
  "eqa.competency.byAnalyte": "Compétence par analyte",
  "eqa.competency.analyte": "Analyte",
  "eqa.competency.evaluable": "Évaluable",
  "eqa.competency.failures": "Échecs",
  "eqa.competency.latest": "Dernier",
  "eqa.competency.unnamedAnalyte": "Analyte sans nom",
  "eqa.competency.evidence": "Éléments probants · tous les événements de la période",
  "eqa.competency.date": "Date",
  "eqa.competency.scheme": "Programme",
  "eqa.competency.event": "Événement",
  "eqa.competency.outcome": "Résultat",
  "eqa.competency.counted": "Pris en compte",
  "eqa.competency.countsFail": "Échec",
  "eqa.competency.countsPass": "Évalué",
  "eqa.competency.countsExcused": "Excusé",
  "eqa.result.analyst": "Analyste (EEQ)",
  "eqa.result.analystChoose": "Choisir l'analyste",
  "eqa.result.analystRequired": "Ce programme EEQ enregistre qui a analysé chaque échantillon. Choisissez un analyste avant d'enregistrer.",
  "eqa.program.perAnalyst": "Enregistrer l'analyste sur chaque résultat",
  "eqa.program.perAnalyst.on": "Analyste enregistré",
  "eqa.program.perAnalyst.off": "Non enregistré",
  "eqa.result.analyst.tooltip": "Affiché parce que cette série comprend un échantillon EEQ dont le programme enregistre qui a analysé chaque échantillon. Choisissez l'utilisateur OpenELIS qui a analysé l'échantillon dans la liste des analystes du programme : cet enregistrement est distinct de la personne qui saisit ce résultat et de celle qui le valide. Les lignes non EEQ ne nécessitent aucune saisie.",
  "shipment.settings.siteOrgUnsetTitle": "Organisation du site non définie",
  "shipment.settings.siteOrgUnsetSubtitle": "Les envois entrants ne sont pas filtrés pour ce site et les boîtes sortantes n'indiquent aucun expéditeur. Sélectionnez l'organisation qui représente ce laboratoire.",
  "shipment.settings.siteOrgUnmatchedTitle": "Défini sur une organisation absente de cette instance",
  "shipment.settings.siteOrgUnmatchedSubtitle": "L'UUID ci-dessous est celui par lequel un partenaire désigne ce laboratoire, et il ne correspond à aucune organisation ici. Le filtrage fonctionne ; ne le modifiez pas, sauf si le partenaire le change.",
  "eqa.receipt.openSubmissions": "Ouvrir les soumissions",
  "eqa.receipt.openSubmissionsHeading": "Ouvrir les soumissions avec des panels non livrés",
  "eqa.receipt.openSubmissionsHelp": "Les participants qui n'ont pas reçu leur panel restent sur la liste comme en retard. Il s'agit d'un forçage manuel enregistré : indiquez le motif.",
  "eqa.receipt.openSubmissionsReason": "Motif",
  "eqa.receipt.submissionsOpened": "Les soumissions sont ouvertes.",
  "eqa.receipt.submissionsOpenFailed": "Impossible d'ouvrir les soumissions.",
  "eqa.provider.schemes.lastDistribution": "Dernière distribution",
  "eqa.provider.wizard.distributionDate": "Date de distribution",
  "eqa.provider.wizard.submissionDeadline": "Date limite de soumission",
  "eqa.provider.kpi.activeSchemes": "Programmes actifs",
  "eqa.provider.kpi.openCycles": "Cycles ouverts",
  "eqa.provider.kpi.enrolled": "Participants inscrits",
  "eqa.provider.kpi.followupsOpen": "Suivis ouverts",
  "eqa.provider.schemes.discipline": "Discipline",
  "eqa.cycle.history.actor": "Acteur",
  "eqa.cycle.history.systemActor": "Système",
  "eqa.prep.reserved.recommend": "{n} recommandées : max(10 % des participants, 5)",
  "eqa.provider.schemes.participantOnly.title": "Vue participant uniquement",
  "eqa.provider.schemes.participantOnly.body": "L'administration des programmes du prestataire nécessite le droit prestataire. La participation de votre laboratoire se trouve dans les pages ci-dessous.",
  "eqa.provider.schemes.link.myPrograms": "Mes inscriptions : programmes auxquels ce laboratoire participe",
  "eqa.provider.schemes.link.myCycles": "Mes cycles : panels, résultats et dates limites",
  "eqa.btn.newCycle": "Nouveau cycle",
  "eqa.cycle.new.heading": "Nouveau cycle EEQ",
  "eqa.cycle.new.help": "Pour un prestataire qui n'expédie pas d'envois vers cette instance OpenELIS : enregistrez le cycle auquel appartient le panel afin qu'il apparaisse ici avec « Recevoir le panel ». Les envois d'un prestataire OpenELIS ouvrent leur cycle à l'importation.",
  "eqa.cycle.new.scheme": "Programme (de Mes programmes EEQ)",
  "eqa.cycle.new.name": "Nom du cycle",
  "eqa.cycle.new.distributionDate": "Date de distribution",
  "eqa.cycle.new.deadline": "Date limite de soumission",
  "eqa.cycle.new.create": "Créer le cycle",
  "eqa.cycle.new.created": "Cycle créé. Il apparaît comme Planifié ; utilisez « Recevoir le panel » à l'arrivée du panel.",
  "eqa.cycle.new.error": "Impossible de créer le cycle",
  "eqa.cycle.new.noPrograms": "Inscrivez-vous d'abord à un programme dans Mes programmes EEQ.",
  "eqa.order.receipt.consignment": "Envoi entrant",
  "eqa.order.receipt.consignment.none": "Aucun : reçu hors du module d'expédition",
  "eqa.order.receipt.consignment.thisCycle": "ce cycle",
  "eqa.order.receipt.consignment.help": "Choisir l'envoi en enregistre la livraison et informe le prestataire de l'arrivée du panel.",
  "eqa.order.receipt.reference": "Référence de l'envoi",
  "eqa.order.receipt.referenceRecorded": "Envoi {code} reçu.",
  "eqa.intake.enterResults": "Saisir les résultats",
  "eqa.intake.heading": "Résultats de {lab}",
  "eqa.intake.help": "Saisissez les valeurs telles que le participant les a rapportées : nombres, ou mots comme Réactif. L'enregistrement remplace les données existantes pour cette analyse.",
  "eqa.intake.test": "Test",
  "eqa.intake.value": "Valeur rapportée",
  "eqa.intake.save": "Enregistrer les résultats",
  "eqa.intake.saved": "Résultats enregistrés pour {lab}.",
  "eqa.intake.failed": "Impossible d'enregistrer les résultats",
  "eqa.intake.csv": "Ou collez le lot d'export du participant (CSV)",
  "eqa.intake.import": "Importer un fichier CSV",
  "eqa.intake.imported": "{count, plural, one {# valeur importée.} many {# valeurs importées.} other {# valeurs importées.}}",
  "eqa.intake.noTests": "Aucune analyse n'est encore attribuée à ce programme.",
  "eqa.cycle.importScores": "Importer les scores (CSV)",
  "eqa.cycle.importScores.heading": "Importer les scores de l'organisateur",
  "eqa.cycle.importScores.help": "Collez le CSV des scores envoyé par le prestataire (colonnes analyte_name et performance_status). Les scores d'un prestataire utilisant OpenELIS arrivent automatiquement via l'entrepôt FHIR.",
  "eqa.cycle.importScores.csv": "CSV des scores",
  "eqa.cycle.importScores.import": "Importer les scores",
  "eqa.cycle.importScores.imported": "{count} scores enregistrés.",
  "eqa.cycle.importScores.unmapped": "Non reconnu ici : {names}",
  "eqa.cycle.importScores.failed": "Impossible d'importer les scores",
  "eqa.program.schemeType": "Type de programme",
  "eqa.program.schemeType.helper": "Les programmes internes sont gérés par ce laboratoire et ne nécessitent pas de prestataire ; tous les autres types en nécessitent un.",
  "eqa.order.receipt.notes.required": "Indiquez ce qui n'allait pas avec le matériel. Une réception marquée comme non intacte doit être accompagnée d'une note explicative.",
  "eqa.provider.wizard.cycleName.required": "Un cycle doit avoir un nom.",
  "eqa.provider.wizard.dates.required": "Un cycle nécessite une date de distribution et une date limite de soumission ; les rappels sont envoyés en fonction de la date limite.",
  "eqa.enrollment.scheme": "Programme",
  "eqa.enrollment.scheme.helper": "Choisissez un programme proposé par cette instance, ou choisissez Non répertorié et saisissez le nom.",
  "eqa.enrollment.scheme.frozen": "Cette inscription comporte des cycles : son programme et son prestataire ne peuvent donc pas être modifiés.",
  "eqa.enrollment.scheme.other": "Non répertorié - saisir le nom",
  "eqa.action.forbidden": "Cette action nécessite l'autorisation {grant}, dont votre compte ne dispose pas. Demandez-la à un administrateur.",
  "eqa.receipt.readOnly.title": "Vue en lecture seule des réceptions et des scores",
  "eqa.receipt.readOnly.body": "Enregistrer une livraison, expédier une répétition, saisir des résultats et renvoyer des scores nécessitent tous le droit prestataire ; noter le cycle nécessite le droit de gestion. Le tableau ci-dessous présente de toute façon l'ensemble du cycle.",
  "eqa.inhouse.readOnly.title": "Vue en lecture seule des panels internes",
  "eqa.inhouse.readOnly.body": "La conception et le scellement d'un panel anonymisé nécessitent le droit de gestion. Les panels ci-dessous donnent de toute façon une vue complète.",
  "eqa.score.downloadReport": "Rapport PDF",
  "eqa.labperf.exportCsv": "Exporter en CSV",
  "eqa.labperf.kpi.submitted": "Cycles soumis",
  "eqa.labperf.acceptableOf": "Acceptables sur notés",
  "eqa.labperf.kpi.lateCount": "Soumissions tardives",
  "eqa.labperf.kpi.nceOpenCount": "Parmi elles, encore ouvertes",
  "eqa.queue.source.all": "Toutes les sources",
  "eqa.queue.countFiltered": "File · {count} sur {total, plural, one {# élément} other {# éléments}}",
  "eqa.queue.emptyForSource": "Rien de cette source n'est en attente de tri. La file contient {total, plural, one {# élément} other {# éléments}} provenant d'autres sources.",
  "eqa.program.requiresCycleReview": "Mettre chaque cycle en attente de revue avant soumission",
  "eqa.program.requiresCycleReview.off": "Soumettre automatiquement",
  "eqa.program.requiresCycleReview.on": "Mettre en attente de revue",
  "eqa.cycle.submitManual": "Soumettre manuellement",
  "eqa.cycle.submitManual.heading": "Enregistrer une soumission manuelle",
  "eqa.cycle.submitManual.help": "Utilisez cette option lorsque les résultats sont parvenus au prestataire par un autre moyen. La référence qu'il vous a fournie fait de cette saisie un enregistrement et non une simple déclaration : elle est donc obligatoire.",
  "eqa.cycle.submitManual.reference": "Référence de l'organisateur",
  "eqa.cycle.submitManual.success": "Enregistré comme soumis manuellement, avec la référence du prestataire.",
  "eqa.cycle.retriesSpent.title": "La soumission automatique est arrêtée pour ce cycle.",
  "eqa.cycle.retriesSpent.body": "La soumission a échoué {attempts} fois et ne sera pas relancée. Envoyez vous-même les résultats au prestataire - le lot d'export se trouve sur la page du programme - et enregistrez ici sa référence.",
  "eqa.provider.wizard.sampleCode.duplicate": "Chaque code d'échantillon d'un panel doit être unique.",
  "eqa.provider.wizard.rangeHigh.backwards": "La limite haute d'un intervalle d'acceptation ne peut pas être inférieure à la limite basse.",
  "eqa.shipment.packList.panelColumn": "Panneau",
  "eqa.provider.schemes.performance": "Performance",
  "eqa.performance.title": "Performance des participants",
  "eqa.performance.subtitle": "Taux de réussite de chaque laboratoire sur ses quatre derniers cycles notés dans ce programme. Développez une ligne pour voir les cycles correspondants.",
  "eqa.performance.laboratory": "Laboratoire",
  "eqa.performance.region": "Région",
  "eqa.performance.enrollment": "Inscription",
  "eqa.performance.passRate": "Taux de réussite (4 derniers)",
  "eqa.performance.mostRecent": "Le plus récent",
  "eqa.performance.openFollowups": "Suivis ouverts",
  "eqa.performance.expand": "Historique du cycle",
  "eqa.performance.ofJudged": "{accepted} sur {judged}",
  "eqa.performance.noRate": "Aucun cycle noté pour le moment",
  "eqa.performance.noCycles": "Ce laboratoire n'a encore rapporté de résultats dans aucun cycle noté.",
  "eqa.performance.empty": "Aucun laboratoire n'est encore inscrit à ce programme.",
  "eqa.performance.loadFailed": "Impossible de charger la performance des participants",
  "eqa.myPrograms.group.active": "Inscriptions actives ({count})",
  "eqa.order.coverage.title": "Hors de l'inscription de ce laboratoire",
  "eqa.order.coverage.subtitle": "L'inscription à ce programme ne couvre pas : {tests}. Vous pouvez quand même enregistrer la demande.",
  "eqa.myPrograms.group.suspended": "Inscriptions suspendues ({count})",
  "eqa.myPrograms.group.withdrawn": "Inscriptions retirées ({count})",
  "eqa.enrollment.resume": "Reprendre",
  "eqa.enrollment.statusReason": "Motif",
  "eqa.enrollment.statusReasonPlaceholder": "Pourquoi le statut de cette inscription change-t-il ?",
  "eqa.enrollment.statusEffectiveDate": "En vigueur à partir du",
  "eqa.enrollment.withdrawIsFinal": "Le retrait est définitif. Pour participer de nouveau, ce laboratoire doit se réinscrire au programme.",
  "eqa.enrollment.statusChanged": "Cette inscription est désormais {status}",
  "eqa.enrollment.statusChangeFailed": "Impossible de modifier le statut de cette inscription",
  "eqa.enrollment.panels.help": "Ensembles d'analyses standard du catalogue. Ce sont les analyses dont votre laboratoire rend les résultats, et non le matériel EEQ envoyé par un prestataire.",
  "eqa.myPrograms.panels.help": "Panels d'analyses du catalogue couverts par cette inscription.",
  "eqa.score.scoredWithUnjudged": "Cycle noté, mais {count} résultat(s) n'ont reçu aucun verdict, pour {tests}. Ces analytes n'ont pas de valeur cible scellée et le cycle compte trop peu de pairs pour les situer.",
  "eqa.cycle.close": "Clôturer le cycle",
  "eqa.cycle.closeHeading": "Clôturer ce cycle",
  "eqa.cycle.closeHelp": "Un cycle clôturé est définitif : les participants le voient comme clôturé et aucun autre verdict ne peut y être enregistré. La clôture est refusée tant qu'un suivi est ouvert ou qu'un résultat hors délai attend encore une réponse.",
  "eqa.cycle.closeFailed": "Impossible de clôturer ce cycle",
  "eqa.prep.ofTotal": "{n} sur {total}",
  "eqa.prep.tile.participants": "Laboratoires inscrits sélectionnés pour ce cycle",
  "eqa.prep.tile.panels": "Panels de matériel préparés",
  "eqa.prep.dispatched": "Envois aux participants expédiés",
  "eqa.prep.readyToShip.blockedByGate": "La préparation est incomplète. Les conditions préalables à l'expédition ci-dessus indiquent ce qui reste à faire.",
  "eqa.prep.readyToShip.notInPrep": "État du cycle : {status}. L'autorisation d'expédition n'est proposée que pendant la préparation du cycle.",
  "eqa.prep.goToShipments": "Ouvrir l'onglet Expéditions",
  "eqa.competency.rule.meetsEvidence": "Éléments probants suffisants",
  "eqa.competency.rule.repeatedFailure": "Échecs répétés",
  "eqa.competency.rule.insufficientEvidence": "Éléments probants insuffisants",
  "eqa.competency.rule.openEscalation": "Non-conformité ouverte",
  "eqa.competency.reason.meetsEvidence": "{evaluable} échantillons évaluables avec {failures} échecs entre {from} et {to}, au moins égal au seuil minimal de {floor}. Aucune action requise.",
  "eqa.competency.reason.repeatedFailure": "{failures} échecs sur {evaluable} échantillons évaluables entre {from} et {to}. Il s'agit d'un problème de performance : revoyez les résultats en échec et ouvrez une non-conformité, ou classez-les sans suite au tri.",
  "eqa.competency.reason.insufficientEvidence": "{evaluable} échantillons évaluables entre {from} et {to}, en deçà du seuil minimal de {floor}. Il ne s'agit pas d'un problème de performance : attribuez davantage d'échantillons d'essai d'aptitude à cet analyste.",
  "eqa.competency.reason.openEscalation": "Une non-conformité transmise, ouverte entre {from} et {to}, est toujours en cours, sur {evaluable} échantillons évaluables avec {failures} échecs. Clôturez la non-conformité pour lever ce niveau.",
  "eqa.competency.whatIsAnAnalyst": "Un analyste est un compte utilisateur OpenELIS figurant sur la liste des analystes du programme, enregistré sur l'échantillon qu'il a analysé. Cet enregistrement est distinct de la personne qui a saisi le résultat et de celle qui l'a validé.",
  "eqa.inhouse.roster.help": "Les analystes sont des comptes utilisateur OpenELIS. Toute personne sélectionnée ici rejoint la liste des analystes de ce programme et peut se voir attribuer des échantillons à analyser ; cette liste est distincte des personnes qui saisissent et valident un résultat.",
  "banner.menu.eqa.providerFollowups": "Suivi des participants",
  "eqa.oversight.queueSubtitle.link": "Suivi des participants",
  "eqa.inhouse.sealed.deadline": "Date de levée d'anonymat, et date limite de soumission pour les analystes : {date}",
  "eqa.inhouse.sealed.analysts": "Analystes affectés : {names}",
  "eqa.inhouse.sealed.noAnalysts": "Aucun analyste n'est affecté à un échantillon de ce panel.",
  "eqa.inhouse.sealed.toMyCycles": "Ouvrir Mes cycles",
  "eqa.inhouse.sealed.toWorkplan": "Ouvrir le plan de travail",
  "analyzerType.editor.heading": "Paramètres du profil",
  "analyzerType.editor.choose": "Choisir…",
  "analyzerType.editor.version": "Version du profil",
  "analyzerType.editor.confidence": "Niveau de confiance des éléments probants",
  "analyzerType.editor.category": "Discipline de laboratoire",
  "analyzerType.editor.inboundResults": "Reçoit les résultats de l'analyseur",
  "analyzerType.editor.outboundOrders": "Envoie les demandes à l'analyseur",
  "analyzerType.editor.connectionTest": "Prend en charge un test de connexion",
  "analyzerType.editor.fileHeading": "Analyse syntaxique des fichiers",
  "analyzerType.editor.fileFormat": "Format de fichier du profil",
  "analyzerType.editor.defaultFileFormat": "Format de fichier par défaut",
  "analyzerType.editor.filePattern": "Modèle de nom de fichier",
  "analyzerType.editor.hasHeader": "La première ligne contient les noms de colonnes",
  "analyzerType.editor.delimiter": "Délimiteur de colonnes",
  "analyzerType.editor.encoding": "Encodage du texte",
  "analyzerType.editor.sheetIndex": "Numéro de feuille (à partir de zéro)",
  "analyzerType.editor.skipRows": "Lignes à ignorer",
  "analyzerType.editor.extensions": "Extensions de fichier prises en charge",
  "analyzerType.editor.columns": "Colonnes du fichier",
  "analyzerType.editor.columnsHelp": "Faites correspondre les noms de colonnes du fichier exporté aux champs de résultat ci-dessous. Conservez l'orthographe et la ponctuation.",
  "analyzerType.editor.columnNumber": "Colonne {number} du fichier",
  "analyzerType.editor.columnName": "Nom de la colonne dans le fichier",
  "analyzerType.editor.columnField": "Signification de la colonne",
  "analyzerType.editor.removeColumn": "Retirer la colonne",
  "analyzerType.editor.columnsInvalid": "Chaque colonne doit avoir un nom unique et une signification sélectionnée.",
  "analyzerType.editor.addColumn": "Ajouter une colonne",
  "analyzerType.editor.resultOrder": "Préférence de valeur de résultat (la première valeur disponible l'emporte)",
  "analyzerType.editor.communicationHeading": "Paramètres de communication par défaut",
  "analyzerType.editor.analyzerName": "Nom de l'instrument dans les messages",
  "analyzerType.editor.identifierPattern": "Modèle d'identifiant de l'analyseur",
  "analyzerType.editor.protocolVersion": "Version du protocole",
  "analyzerType.editor.lowerLayerVersion": "Version du tramage ASTM",
  "analyzerType.editor.msh3Pattern": "Modèle de l'application émettrice",
  "analyzerType.editor.communicationMode": "Qui initie la communication",
  "analyzerType.editor.lisInitiated": "Permet au système de laboratoire d'initier la communication",
  "analyzerType.editor.connectionRole": "Rôle de connexion par défaut",
  "analyzerType.editor.transport": "Transport par défaut",
  "analyzerType.editor.port": "Port sortant par défaut (facultatif)",
  "analyzerType.editor.aggregationMode": "Regroupement des résultats",
  "analyzerType.editor.aggregationWindowSeconds": "Fenêtre de regroupement des résultats en secondes",
  "analyzerType.editor.connectionFields": "Champs affichés lors de la configuration d'une connexion",
  "analyzerType.editor.connectionFieldsHelp": "Ces champs décrivent les paramètres fournis par un laboratoire pour chaque connexion. Une connexion FILE nécessite un champ de répertoire pour son dossier surveillé sur Bridge. Les libellés utilisent les clés de traduction de l'application. Les choix conservent leur type de valeur ; les conditions de visibilité font référence à un autre paramètre.",
  "analyzerType.editor.connectionFieldNumber": "Champ de connexion {number}",
  "analyzerType.editor.fieldKey": "Nom du paramètre",
  "analyzerType.editor.fieldLabel": "Clé de traduction du libellé",
  "analyzerType.editor.inputKind": "Type de saisie",
  "analyzerType.editor.required": "Obligatoire lors de la configuration de la connexion",
  "analyzerType.editor.addField": "Ajouter un champ de connexion",
  "analyzerType.editor.removeField": "Retirer le champ de connexion",
  "analyzerType.editor.save": "Enregistrer et valider les paramètres du profil",
  "analyzerType.editor.saved": "Paramètres du profil enregistrés",
  "analyzerType.editor.saveBeforeRecognition": "Enregistrez les paramètres du profil avant de modifier la reconnaissance des contrôles ou de publier.",
  "analyzerType.editor.loadError": "Impossible de recharger le brouillon. Vos modifications non enregistrées sont toujours là.",
  "analyzerType.editor.saveError": "Impossible d'enregistrer le brouillon. Vos modifications sont toujours là ; réessayez d'enregistrer.",
  "analyzerType.editor.conflict": "Le brouillon a été modifié depuis son ouverture. Vos modifications n'ont pas été envoyées. Rechargez le brouillon enregistré avant d'apporter d'autres modifications.",
  "analyzerType.editor.error": "Le profil n'a pas pu être enregistré",
  "analyzerType.editor.reload": "Recharger le brouillon enregistré et abandonner les modifications locales",
  "analyzerType.editor.validation": "Le profil nécessite votre attention",
  "analyzerType.editor.add": "Ajouter une valeur",
  "analyzerType.editor.remove": "Retirer la valeur",
  "analyzerType.editor.semantic.sampleId": "Identifiant de l'échantillon",
  "analyzerType.editor.semantic.testCode": "Code d'analyse de l'analyseur",
  "analyzerType.editor.semantic.qcTask": "Tâche de contrôle",
  "analyzerType.editor.semantic.ctValue": "Cycle seuil",
  "analyzerType.editor.inputKind.TEXT": "Texte",
  "analyzerType.editor.inputKind.NUMBER": "Nombre",
  "analyzerType.editor.inputKind.SELECT": "Liste de choix",
  "analyzerType.editor.inputKind.BOOLEAN": "Oui ou non",
  "analyzerType.editor.inputKind.SECRET": "Secret",
  "analyzerType.editor.inputKind.FILE_PATH": "Chemin de dossier ou de fichier",
  "analyzerType.editor.testDefinitions": "Définitions des analyses de l'analyseur",
  "analyzerType.editor.testDefinitionsHelp": "Énumérez les codes d'analyse et les valeurs de résultat rapportés par l'instrument. Ces définitions fournissent des suggestions de correspondance avec le catalogue du laboratoire ; elles ne créent ni ne modifient les analyses du laboratoire.",
  "analyzerType.editor.testNumber": "Analyse de l'analyseur {number}",
  "analyzerType.editor.testCode": "Code d'analyse de l'analyseur",
  "analyzerType.editor.testName": "Nom d'analyse suggéré",
  "analyzerType.editor.loinc": "Code LOINC",
  "analyzerType.editor.testUnit": "Unités rapportées",
  "analyzerType.editor.resultType": "Type de valeur rapportée",
  "analyzerType.editor.resultType.quantitative": "Mesure numérique",
  "analyzerType.editor.resultType.qualitative": "Résultat nommé",
  "analyzerType.editor.resultType.text": "Résultat en texte libre",
  "analyzerType.editor.testAliases": "Autres codes pour cette même analyse",
  "analyzerType.editor.testValues": "Valeurs de résultat rapportées par cette analyse",
  "analyzerType.editor.removeTest": "Retirer l'analyse de l'analyseur",
  "analyzerType.editor.addTest": "Ajouter une analyse de l'analyseur",
  "analyzerType.editor.choices": "Choix de connexion",
  "analyzerType.editor.choiceNumber": "Choix {number}",
  "analyzerType.editor.choiceValue": "Valeur du choix",
  "analyzerType.editor.addChoice": "Ajouter un choix",
  "analyzerType.editor.removeChoice": "Retirer le choix",
  "analyzerType.editor.visibility": "Afficher ce champ de connexion lorsque",
  "analyzerType.editor.controllingField": "Paramètre déterminant",
  "analyzerType.editor.comparison": "Comparaison",
  "analyzerType.editor.comparisonValue": "Valeur de comparaison",
  "analyzerType.editor.comparison.EQUALS": "Est égal à",
  "analyzerType.editor.comparison.NOT_EQUALS": "N'est pas égal à",
  "analyzerType.editor.comparison.IN": "Fait partie de",
  "analyzerType.editor.comparison.NOT_IN": "Ne fait pas partie de",
  "analyzerType.editor.addCondition": "Ajouter une condition de visibilité",
  "analyzerType.editor.removeCondition": "Retirer la condition de visibilité",
  "analyzerType.editor.valueType": "Type de valeur",
  "analyzerType.editor.valueType.string": "Valeur de texte",
  "analyzerType.editor.valueType.boolean": "Valeur booléenne",
  "analyzerType.editor.valueType.array": "Valeur de liste",
  "analyzerType.editor.valueType.object": "Valeur d'objet",
  "analyzerType.editor.valueType.null": "Valeur nulle",
  "analyzerType.editor.nullValue": "Ce choix a une valeur nulle.",
  "analyzerType.editor.invalidTypedValue": "Saisissez une valeur valide du type sélectionné.",
  "analyzerType.editor.structuredValueHelp": "Saisissez une liste ou un objet JSON correspondant au type sélectionné. Utilisez une liste pour les comparaisons « fait partie de ».",
  "analyzerType.editor.newProtocolHelp": "Choisissez FILE, ASTM ou HL7 et saisissez les paramètres pris en charge par l'instrument. Le protocole est figé après le premier enregistrement.",
  "analyzerType.editor.switchProtocol": "Changer de protocole et effacer ses paramètres",
  "analyzerType.editor.switchProtocolHelp": "Passer à {protocol} ? Cette action efface les paramètres non enregistrés de communication, d'analyse syntaxique, de champs de connexion et de reconnaissance des contrôles. L'identité du profil, les définitions d'analyses et les informations descriptives sont conservées.",
  "analyzerType.editor.keepProtocol": "Conserver le protocole actuel",
  "analyzerType.editor.supportedTransports": "Transports pris en charge",
  "analyzerType.editor.supportTransport": "Prendre en charge {transport}",
  "analyzerType.editor.transportSettings": "Paramètres {transport}",
  "analyzerType.editor.transportPortHelp": "Port de destination sortant facultatif pour ce transport. Laissez vide pour utiliser le port de repli de Bridge ; les messages entrants utilisent l'écouteur partagé.",
  "analyzerType.editor.serialSettings": "Paramètres de communication série",
  "analyzerType.editor.readTimeout": "Délai d'expiration de lecture série (millisecondes)",
  "analyzerType.editor.messageTimeout": "Délai d'expiration des messages série (millisecondes)",
  "analyzerType.editor.reconnectInterval": "Intervalle de reconnexion série (millisecondes)",
  "analyzerType.editor.maxReconnectAttempts": "Nombre maximal de tentatives de reconnexion série",
  "analyzerType.editor.rtsEnabled": "Activer RTS",
  "analyzerType.editor.dtrEnabled": "Activer DTR",
  "analyzerType.editor.resultRecords": "Enregistrements de résultats à analyser",
  "analyzerType.editor.resultRecords.ALL": "Tous les enregistrements de résultats",
  "analyzerType.editor.resultRecords.FIELD_NON_BLANK": "Enregistrements avec un champ renseigné",
  "analyzerType.editor.resultRecordField": "Champ ASTM obligatoire (record.field.component)",
  "analyzerType.editor.specimenPosition": "Position de l'échantillon HL7 par rapport aux résultats",
  "analyzerType.editor.dataFlow": "Sens de transfert des données par défaut",
  "analyzerType.editor.outboundPortMode": "Sélection du port sortant par défaut",
  "analyzerType.editor.clientProfilePort": "Port de connexion client enregistré dans ce profil (facultatif)",
  "eqa.intake.sample": "Échantillon {code}",
  "eqa.competency.countsFoldedTriage": "Décidé par le triage",
  "eqa.competency.countsFoldedScore": "Compté avec le score",
  "eqa.provider.followups.responseText": "Ce que le laboratoire a déclaré",
  "eqa.provider.followups.responseHelp": "La cause première identifiée par le laboratoire et l'action corrective qu'il a menée. Conservées avec le suivi.",
  "eqa.provider.followups.responseShown": "Réponse du laboratoire : {text}",
  "notification.organization.post.error": "L'organisation n'a pas été enregistrée. Vérifiez les champs et réessayez.",
  "organization.email": "Email du contact",
  "eqa.provider.followups.sendFailed": "Impossible d'envoyer un e-mail à {to}. La notification a été téléchargée en CSV pour un envoi manuel.",
  "label.validation.review.error.qcHold": "Publication bloquée : un contrôle de CQ en échec retient ce résultat jusqu'à la clôture de sa non-conformité.",
  "sidenav.label.admin.locations": "Lieux et organisations",
  "sidenav.label.admin.locations.organizations": "Organisations",
  "sidenav.label.admin.locations.sites": "Sites de prélèvement",
  "sidenav.label.admin.locations.areas": "Zones géographiques",
  "sidenav.label.admin.locations.import": "Importation / Exportation",
  "help.locations.page.organizations": "Les organisations sont les établissements de santé et laboratoires avec lesquels votre laboratoire travaille : les hôpitaux, cliniques et centres de santé qui vous envoient des échantillons de patients, et les laboratoires auxquels vous envoyez des échantillons. Les services et départements d'une organisation sont listés sous celle-ci. Les organisations apparaissent dans la saisie des demandes comme site demandeur et dans les envois comme laboratoire de destination.",
  "help.locations.page.sites": "Les sites de prélèvement sont des lieux fixes dans l'environnement où sont prélevés des échantillons qui ne proviennent pas d'un patient : une source d'eau, un piège à moustiques, un capteur d'air, une parcelle de sol. Un site ne demande pas d'analyses. Il enregistre l'endroit où un échantillon a été prélevé, afin de pouvoir comparer les résultats dans le temps au même endroit. Chaque site se trouve dans une zone géographique et peut avoir son propre point GPS et sa propre personne de contact.",
  "help.locations.page.areas": "Les zones géographiques sont les divisions administratives du pays, par exemple Région, Province, District et LLG. Elles servent aux adresses des patients et à indiquer où se trouve chaque organisation et chaque site de prélèvement. La plupart des déploiements les chargent une fois depuis la liste nationale, puis ajoutent ou corrigent des zones ici. Pour ajouter une zone à l'intérieur d'une autre, utilisez le bouton + sur la ligne parente : « + District » sur la province de Morobe ajoute un district dans Morobe. Utilisez « + Ajouter une région » en haut pour une nouvelle zone de premier niveau.",
  "help.locations.page.import": "Chargez ou mettez à jour les organisations, services / départements, sites de prélèvement et zones géographiques à partir de fichiers CSV, au même format que celui utilisé par le système à l'installation. Rien n'est enregistré tant que vous n'avez pas vérifié et appliqué l'aperçu.",
  "label.locations.page.compare": "Organisation ou site de prélèvement : de quoi ai-je besoin ?",
  "label.locations.page.compare.orgTitle": "Ajoutez une organisation lorsque...",
  "label.locations.page.compare.siteTitle": "Ajoutez un site de prélèvement lorsque...",
  "label.locations.page.compare.orgExamples": "Exemples : Port Moresby General Hospital, 9 Mile Urban Clinic, Central Public Health Laboratory",
  "label.locations.page.compare.siteExamples": "Exemples : piège lumineux de Bumbu Settlement, prise d'eau de la rivière Laloki, capteur d'air de Waigani",
  "help.locations.page.compare.org": "Ajoutez une organisation lorsque les échantillons proviennent de personnes vues sur place, lorsqu'elle demande des analyses ou reçoit des rapports ou des échantillons envoyés, ou lorsqu'elle comporte des services ou départements qui demandent des analyses.",
  "help.locations.page.compare.site": "Ajoutez un site de prélèvement lorsque les échantillons proviennent de l'environnement (eau, sol, air ou insectes), lorsque vous prélevez au même endroit fixe de manière répétée, ou lorsque vous voulez suivre sur une carte les résultats de cet endroit dans le temps.",
  "help.locations.page.compare.tip": "Un réservoir d'eau dans un hôpital reste un site de prélèvement : l'hôpital est une organisation, et le réservoir est un site placé dans la même zone.",
  "label.locations.kind.facility": "Établissement",
  "label.locations.kind.ward": "Service / Département",
  "label.locations.kind.wards": "services / départements",
  "label.locations.kind.site": "Site de prélèvement",
  "label.locations.kind.area": "Zone géographique",
  "label.locations.kind.records": "enregistrements",
  "label.locations.column.name": "Nom",
  "label.locations.column.code": "Code Emplacement",
  "label.locations.column.type": "Type",
  "label.locations.column.wards": "Services / Départements",
  "label.locations.column.location": "Emplacement",
  "label.locations.column.inUse": "Utilisé",
  "label.locations.column.level": "Niveau",
  "label.locations.column.children": "Sous-zones",
  "label.locations.column.siteType": "Type de site",
  "label.locations.column.active": "Active",
  "label.locations.column.actions": "Actions",
  "label.locations.column.serviceType": "Type de service",
  "label.locations.column.contact": "Nom du contact",
  "label.locations.column.phone": "Téléphone",
  "label.locations.column.email": "E-mail",
  "label.locations.column.gps": "GPS",
  "label.locations.open": "ouvert",
  "label.locations.openOrders": "demandes en cours",
  "label.locations.none": "Aucun",
  "label.locations.empty": "(vide)",
  "label.locations.location.notSet": "non défini",
  "label.locations.status.active": "Active",
  "label.locations.status.inactive": "Inactif",
  "label.locations.status.all": "Tous",
  "label.locations.source.registry": "Registre",
  "help.locations.registry": "Provient du registre des établissements. Le registre est la source de référence pour cet enregistrement.",
  "label.locations.filter.type": "Type",
  "label.locations.filter.type.all": "Tous les types",
  "label.locations.filter.location": "Emplacement (inclut les zones subordonnées)",
  "label.locations.filter.location.any": "Toute zone",
  "label.locations.filter.status": "Statut",
  "label.locations.filter.clear": "Effacer les filtres",
  "label.locations.filter.reviewOverdue": "Uniquement les laboratoires de référence en retard de revue ou dont l'accréditation a expiré",
  "label.locations.filter.category.all": "Toutes les catégories",
  "label.locations.filter.ownership.all": "Tous types de propriété",
  "label.locations.toolbar": "Filtres",
  "placeholder.locations.search": "Rechercher par nom, code ou tout identifiant",
  "placeholder.locations.area.search": "Rechercher des zones par nom ou code",
  "help.locations.status.inactive": "Les enregistrements inactifs sont masqués dans la saisie des demandes et les autres listes de sélection. Ils apparaissent toujours sur les demandes et rapports existants.",
  "help.locations.field.location": "Choisissez la zone la plus précise que vous connaissez. Un district suffit si vous ne connaissez pas le LLG.",
  "help.locations.field.gps": "Degrés décimaux, WGS84",
  "help.locations.field.siteDescription": "Indiquez l'itinéraire pour qu'une autre personne puisse trouver l'endroit exact",
  "help.locations.identifiers": "Saisissez n'importe quel libellé ou choisissez-en un déjà utilisé. Le code de rapport s'affiche comme Code dans les listes, les exports et les rapports. Chaque identifiant peut être recherché et sert à faire correspondre les lignes importées.",
  "help.locations.ward": "Services, départements ou cliniques de cette organisation",
  "help.locations.ward.gps": "Laissez le GPS vide pour utiliser l'emplacement de {parent}. L'adresse est toujours celle de {parent}.",
  "label.locations.ward.inheritedGps": "{lat}, {lng} hérités de {parent}",
  "label.locations.inherited": "hérité",
  "label.locations.inherits": "hérite",
  "label.locations.draft": "Brouillon",
  "label.locations.ward.namePlaceholder": "Nom du service / département",
  "label.locations.optional": "Optional",
  "warning.locations.registry.edit": "Cet enregistrement provient du registre des établissements. Les modifications apportées aux champs fournis par le registre seront écrasées lors de la prochaine synchronisation. Pour les modifier définitivement, mettez à jour le registre. Les services / départements et autres informations locales que vous ajoutez ici sont conservés.",
  "warning.locations.registry.deactivate": "Cet enregistrement provient du registre des établissements. La prochaine synchronisation pourrait le réactiver ; pour le fermer définitivement, mettez à jour le registre.",
  "label.locations.registry.field": "Provenant du registre",
  "button.locations.add": "Ajouter",
  "button.locations.import": "Importer",
  "button.locations.export": "Exporter",
  "button.locations.deactivate": "Désactiver",
  "button.locations.reactivate": "Réactiver",
  "button.locations.exportSelected": "Exporter la sélection",
  "button.locations.addWard": "Ajouter un service",
  "button.locations.saveWards": "Enregistrer {count} nouveau(x) service(s)",
  "button.locations.moveWard": "Déplacer",
  "button.locations.history": "Historique",
  "button.locations.history.hide": "Masquer l'historique",
  "button.locations.identifier.add": "Ajouter un identifiant",
  "button.locations.area.addChildLevel": "+ {level}",
  "button.locations.area.addTop": "Ajouter {level}",
  "button.locations.area.expandAll": "Tout développer",
  "button.locations.area.collapseAll": "Tout réduire",
  "button.locations.undo": "Annuler",
  "button.locations.template": "Télécharger le modèle",
  "button.locations.import.preview": "Preview",
  "button.locations.import.apply": "Appliquer",
  "button.locations.import.report": "Télécharger le rapport de résultats",
  "label.locations.selectAll": "Sélectionner toutes les lignes",
  "label.locations.select": "Sélectionner",
  "label.locations.section.identity": "Identité",
  "label.locations.section.identifiers": "Identifiants",
  "label.locations.section.location": "Emplacement",
  "label.locations.section.contact": "Contact",
  "label.locations.section.referral": "Laboratoire de référence",
  "label.locations.section.site": "Détails du site",
  "label.locations.section.wards": "Services / Départements",
  "label.locations.form.jump": "Aller à",
  "label.locations.field.types": "Type(s) d'organisation",
  "label.locations.field.shortName": "Nom abrégé",
  "label.locations.field.category": "Catégorie",
  "label.locations.field.ownership": "Type de propriété",
  "label.locations.field.description": "Description",
  "label.locations.field.location": "Emplacement",
  "label.locations.field.parentArea": "Zone parente",
  "label.locations.field.streetAddress": "Adresse",
  "label.locations.field.city": "Ville",
  "label.locations.field.state": "État / Province",
  "label.locations.field.zipCode": "Code postal",
  "label.locations.field.gpsLatitude": "Latitude GPS",
  "label.locations.field.gpsLongitude": "Longitude GPS",
  "label.locations.field.contactName": "Nom du contact",
  "label.locations.field.phone": "Téléphone",
  "label.locations.field.email": "E-mail",
  "label.locations.field.website": "Site web",
  "label.locations.field.serviceType": "Type de service",
  "label.locations.field.siteType": "Type de site",
  "label.locations.field.subtype": "Sous-type",
  "label.locations.field.zone": "Zone environnementale",
  "label.locations.identifier.label": "Etiquette",
  "label.locations.identifier.value": "Valeur",
  "label.locations.identifier.reporting": "Code de rapport",
  "label.locations.identifier.labelPlaceholder": "ex. ID DHIS2",
  "label.locations.referral.approval": "Statut d'approbation",
  "label.locations.referral.approved": "Approuvé",
  "label.locations.referral.evaluation": "En cours d'évaluation",
  "label.locations.referral.suspended": "Suspendu",
  "label.locations.referral.notApproved": "Non approuvé",
  "label.locations.referral.accreditationBody": "Organisme d'accréditation",
  "label.locations.referral.accreditationNumber": "Numéro d'accréditation",
  "label.locations.referral.accreditationExpiry": "Expiration de l'accréditation",
  "label.locations.referral.lastReview": "Date de la dernière revue",
  "label.locations.referral.nextReview": "Prochaine revue prévue",
  "label.locations.referral.notes": "Notes de revue",
  "label.locations.referral.overdue": "Revue en retard",
  "label.locations.referral.expired": "Accréditation expirée",
  "message.locations.referral.overdueSince": "Vérification en retard depuis le {date}. Enregistrez la vérification ci-dessous ou modifiez le statut d'approbation.",
  "label.locations.history.title": "Historique de {name}",
  "label.locations.history.filter": "Filtrer par action",
  "label.locations.history.allChanges": "Toutes les modifications",
  "help.locations.history.readOnly": "Lecture seule. Conservé tant que l'enregistrement existe.",
  "label.locations.history.formerly": "Anciennement {name}",
  "label.locations.history.action.created": "Créé",
  "label.locations.history.action.edited": "Modifié",
  "label.locations.history.action.deactivated": "Désactivé",
  "label.locations.history.action.reactivated": "Réactivé",
  "label.locations.history.action.moved": "Déplacé",
  "label.locations.history.action.identifiers": "Identifiants modifiés",
  "label.locations.history.action.referralReview": "Revue du laboratoire de référence",
  "label.locations.history.action.imported": "Importé",
  "label.locations.history.action.registrySync": "Mis à jour depuis le registre",
  "label.locations.search.ward": "Service / département : {name}",
  "error.locations.name.required": "Le nom est obligatoire",
  "error.locations.types.required": "Choisissez au moins un type d'organisation",
  "error.locations.gps.range": "Saisissez des degrés décimaux : latitude de -90 à 90, longitude de -180 à 180",
  "error.locations.parent.kind": "Le parent d'un service doit être un établissement",
  "error.locations.parent.required": "Choisissez la zone parente",
  "error.locations.referral.status": "Choisissez un statut d'approbation",
  "error.locations.identifier.duplicate": "{label} {value} est déjà utilisé par {name}",
  "error.locations.reactivate.parentInactive": "Réactivez d'abord {parent}.",
  "error.locations.save.conflict": "Un autre administrateur a enregistré cette fiche avant vous. Ses valeurs sont affichées ci-dessous ; réappliquez vos modifications et enregistrez de nouveau.",
  "error.locations.save.failed": "La fiche n'a pas été enregistrée.",
  "error.locations.request.failed": "La requête n'a pas pu aboutir : rien n'a été enregistré. Réessayez et, si l'échec persiste, contactez votre administrateur.",
  "error.locations.save.check": "Pas encore enregistré. Vérifiez : {fields}.",
  "error.locations.save.failedBecause": "La fiche n'a pas été enregistrée : {reason}",
  "error.locations.save.conflictKept": "Un autre administrateur a enregistré cette fiche avant vous. Vos modifications sont conservées, et les siennes ont été reportées là où vous n'aviez rien saisi ({fields}). Vérifiez le formulaire et enregistrez de nouveau.",
  "warning.locations.wards.unsaved": "{count, plural, one {# service est saisi mais pas encore enregistré. Enregistrez-le avec Enregistrer les services, ou retirez-le, puis enregistrez la fiche.} many {# services sont saisis mais pas encore enregistrés. Enregistrez-les avec Enregistrer les services, ou retirez-les, puis enregistrez la fiche.} other {# services sont saisis mais pas encore enregistrés. Enregistrez-les avec Enregistrer les services, ou retirez-les, puis enregistrez la fiche.}} typed but not saved yet. Save them with Save wards, or remove them, then save the record.",
  "error.locations.ward.notSaved": "{name} n'a pas été enregistré : {reason}",
  "message.locations.wards.saved": "{count, plural, one {# salle / service enregistré.} many {# salles / services enregistrés.} other {# salles / services enregistrés.}}",
  "warning.locations.import.ignoredColumns": "Ces colonnes ne sont pas importées et ont été ignorées : {columns}",
  "label.locations.import.run.applied": "Appliqué",
  "label.locations.import.run.preview": "Preview",
  "warning.locations.identifiers.shared": "Certains identifiants sont utilisés par plusieurs enregistrements. Attribuez à chaque enregistrement sa propre valeur.",
  "error.locations.load.failed": "La liste n'a pas pu être chargée. Réessayez.",
  "warning.locations.name.duplicate": "Un autre élément actif de type {kind} nommé \"{name}\" existe déjà",
  "message.locations.empty.none": "Aucun enregistrement pour le moment. Ajoutez-en un ou importez un fichier.",
  "message.locations.empty.filtered": "Aucun enregistrement ne correspond à ces filtres.",
  "message.locations.search.elsewhere": "Dans {view} : {count, plural, one {# correspondance} other {# correspondances}}",
  "message.locations.saved": "{name} enregistré.",
  "message.locations.added": "{name} ajouté.",
  "message.locations.deactivated": "{name} désactivé.",
  "message.locations.reactivated": "{name} réactivé.",
  "message.locations.undo.deactivated": "{name} désactivé.",
  "message.locations.deactivate.inUse": "{name} compte {open} demandes en cours et {children} {childKind} actifs.",
  "message.locations.deactivate.confirm": "Désactiver {name} ?",
  "button.locations.deactivate.record": "Désactiver {name}",
  "button.locations.deactivate.only": "Désactiver uniquement {name}",
  "button.locations.deactivate.withChildren": "Désactiver {name} et ses {count} {childKind}",
  "message.locations.area.inUse": "{name} contient encore des zones, organisations ou sites actifs. Désactivez-les ou déplacez-les d'abord.",
  "message.locations.area.searchContext": "{count, plural, one {# correspondance, affichée avec la zone où elle se trouve} many {# correspondances, affichées avec les zones où elles se trouvent} other {# correspondances, affichées avec les zones où elles se trouvent}}, shown with the areas they sit in",
  "message.locations.area.loadOnExpand": "Les éléments enfants se chargent lorsqu'une ligne est développée.",
  "label.locations.area.new": "Nouveau",
  "label.locations.area.topLevel": "niveau supérieur",
  "message.locations.unsaved": "Vous avez des modifications non enregistrées. Quitter sans enregistrer ?",
  "label.locations.import.mode": "Mode d'importation",
  "label.locations.import.mode.merge": "Ajouter et mettre à jour",
  "help.locations.import.mode.merge": "Ajoute les nouveaux enregistrements et met à jour ceux qui correspondent. Rien d'autre ne change.",
  "label.locations.import.mode.replace": "Remplacer",
  "help.locations.import.mode.replace": "Désactive également les enregistrements des types présents dans ce fichier que le fichier n'inclut pas. Rien n'est supprimé.",
  "label.locations.import.files": "Fichiers",
  "label.locations.import.drop": "Glissez les fichiers CSV ici ou cliquez pour parcourir (organizations-*.csv, *-levels.csv, *-values.csv)",
  "label.locations.import.area": "Zone",
  "label.locations.import.area.organizations": "Établissements, services et sites",
  "label.locations.import.area.levels": "Niveaux géographiques",
  "label.locations.import.area.values": "Zones géographiques",
  "label.locations.import.forThisFile": "Pour ce fichier :",
  "label.locations.import.replaceScope": "Ce fichier contient des lignes de type {types}. {untouched} ne changeront pas. Les services / départements ne seront remplacés que pour {parents}. Les enregistrements du registre ne sont jamais désactivés.",
  "label.locations.import.rename.title": "Renommages possibles",
  "label.locations.import.rename.same": "Même lieu, renommé",
  "label.locations.import.rename.different": "Lieux différents",
  "warning.locations.import.registryOverwrite": "Sera écrasé lors de la prochaine synchronisation avec le registre",
  "warning.locations.import.wardAddressIgnored": "Ligne {line} : l'adresse est ignorée pour les services / départements, qui utilisent l'adresse de leur organisation",
  "label.locations.import.outcome.new": "Nouveau",
  "label.locations.import.outcome.updated": "Mis à Jour ",
  "label.locations.import.outcome.unchanged": "Inchangé",
  "label.locations.import.outcome.reactivated": "Réactivé",
  "label.locations.import.outcome.deactivated": "Désactivé",
  "label.locations.import.outcome.decision": "Décision requise",
  "label.locations.import.outcome.rename": "Renommage possible",
  "label.locations.import.outcome.rejected": "Rejeté",
  "label.locations.import.decision.use": "Utiliser cet enregistrement",
  "label.locations.import.decision.new": "Créer un nouvel enregistrement",
  "label.locations.import.decision.skip": "Ignorer la ligne",
  "label.locations.import.decision.remember": "Mémoriser ce nom",
  "label.locations.import.willDeactivate": "Sera désactivé",
  "label.locations.import.rows": "Lignes",
  "label.locations.import.column.line": "Ligne",
  "label.locations.import.column.outcome": "Résultat",
  "label.locations.import.column.type": "Type",
  "label.locations.import.column.code": "Code Emplacement",
  "label.locations.import.column.name": "Nom",
  "label.locations.import.column.detail": "Détails",
  "message.locations.import.nothingSaved": "Rien n'a été enregistré.",
  "label.locations.import.confirm.title": "Appliquer cette importation ?",
  "label.locations.import.confirm.replace": "Je comprends que {count} enregistrements seront désactivés",
  "label.locations.import.complete": "Importation terminée",
  "label.locations.import.recent": "Importations récentes",
  "message.locations.export.done": "{count} enregistrements exportés au format d'importation.",
  "label.locations.import.working": "Lecture du fichier et rapprochement de chaque ligne. Les fichiers volumineux prennent un moment.",
  "message.locations.import.failed": "Le fichier d'importation n'a pas pu être lu : {reason}",
  "eqa.wizard.noSchemeTests": "Ce programme n'a aucune analyse utilisable par un panel.",
  "eqa.performance.titleForScheme": "Performance des participants : {scheme}",
  "eqa.cycle.trigger.first_shipment_sent": "Premier envoi expédié",
  "eqa.cycle.trigger.all_shipments_delivered": "Tous les envois livrés",
  "eqa.cycle.trigger.score_intake": "Scores enregistrés",
  "eqa.cycle.trigger.panel_receipt": "Panel reçu",
  "eqa.cycle.trigger.last_validated_result": "Dernier résultat validé",
  "eqa.cycle.trigger.fhir_submit_success": "Résultats soumis à l'organisateur",
  "eqa.cycle.trigger.panel_unblind": "Anonymat du panel levé",
  "eqa.cycle.trigger.v1_backfill": "Repris d'une distribution antérieure",
  "sampleAcceptance.banner.resampledFrom.accession": "Il s'agit d'un échantillon de remplacement créé par un rééchantillonnage de l'échantillon {accession}.",
  "label.results.sampleStatus.markUsedUpConfirm.title": "Marquer cet échantillon comme épuisé ?",
  "label.results.sampleStatus.markUsedUpConfirm.body": "Son volume restant est mis à zéro. L'échantillon reste en stockage jusqu'à son élimination.",
  "alerts.acknowledge.note": "Commentaire d'acquittement",
  "alerts.acknowledge.note.required": "Un commentaire est requis pour acquitter une alerte critique",
  "alerts.resolve.button": "Résolu",
  "alerts.resolve.title": "Résoudre l'alerte",
  "alerts.resolve.comment.required": "Un commentaire de résolution est requis",
  "alerts.resolve.error": "Échec de la résolution de l'alerte",
  "configuration.panel.manage": "Gérer les panels",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Voir le catalogue des tests",
  "compliance.parameterGroup.deleted": "Groupe de paramètres supprimé.",
  "compliance.parameterGroup.updated": "Groupe de paramètres mis à jour.",
  "compliance.parameterGroup.deleteError": "Impossible de supprimer le groupe de paramètres.",
  "compliance.validation.fillRequired": "Veuillez remplir tous les champs obligatoires.",
  "compliance.parameterGroup.moveError": "Impossible de réordonner le groupe de paramètres.",
  "compliance.parameterGroup.moved": "Groupe de paramètres réordonné.",
  "compliance.parameterGroup.created": "Groupe de paramètres ajouté.",
  "compliance.testEditor.thresholdsDone": "Seuils de conformité mis à jour pour cette analyse.",
  "compliance.testEditor.meta.loinc": "LOINC:",
  "compliance.testEditor.meta.resultType.select": "Sélectionner une liste",
  "compliance.testEditor.meta.resultType": "Type de résultat :",
  "compliance.testEditor.editHeader": "Test de modification :",
  "compliance.testEditor.meta.sampleType": "Type d'échantillon:",
  "compliance.testThresholds.comboboxPlaceholder": "Rechercher par nom, code ou LOINC…",
  "label.button.done": "Terminer",
  "compliance.testEditor.meta.resultType.numeric": "Numérique",
  "compliance.multiLimit.advisoryNote.placeholder": "par exemple : nouveau prélèvement requis sous 24 h",
  "compliance.multiLimit.advisoryNote": "Note d'avertissement",
  "compliance.inlineEdit.editingMapping": "modification du mappage de conformité",
  "label.loading.message": "Chargement en cours…",
  "compliance.linkedTest.unlinked": "Analyse retirée du groupe de paramètres.",
  "compliance.linkedTest.unlinkError": "Impossible de retirer cette analyse du groupe.",
  "compliance.threshold.testLinked": "Analyse associée au groupe de paramètres.",
  "compliance.inlineEdit.editingLimits": "modification de toutes les limites",
  "search.possibleMatches.title": "Correspondances possibles",
  "search.possibleMatches.intro": "Ces enregistrements ressemblent à celui que vous créez. Utilisez l'un d'eux ou créez un nouvel enregistrement.",
  "search.possibleMatches.use": "Utiliser celui-ci",
  "search.possibleMatches.createAnyway": "Créer quand même",
  "search.possibleMatches.confirm": "Créer un nouvel enregistrement alors que {count} enregistrements similaires existent ?",
  "search.possibleMatches.confirm.button": "Créer un nouvel enregistrement",
  "search.possibleMatches.back": "Back",
  "search.possibleMatches.matched": "Correspondance sur : {fields}",
  "search.possibleMatches.field.name": "nom",
  "search.possibleMatches.field.dateOfBirth": "date de naissance",
  "search.possibleMatches.field.identifier": "identifiant",
  "search.possibleMatches.field.code": "code",
  "search.possibleMatches.inactive": "Inactif",
  "search.possibleMatches.failed": "Les enregistrements similaires n'ont pas pu être vérifiés. Vous pouvez tout de même créer le nouvel enregistrement.",
  "search.possibleMatches.recordFailed": "Votre choix n'a pas pu être enregistré, rien n'a donc été créé. Réessayez.",
  "order.entry.patient.create": "Créer le patient",
  "order.entry.patient.willBeCreated": "Le nouveau patient est créé lors de l'enregistrement de la demande.",
  "provider.title.none": "Aucun titre",
  "order.billing.reference": "Référence de facturation",
  "sample.handling.title": "Manipulation",
  "sample.handling.noRequirement": "Aucune exigence",
  "sample.handling.processWithin": "à traiter sous {time}",
  "sample.handling.holding.minutes": "{minutes} min",
  "sample.handling.holding.hours": "{hours} h",
  "sample.handling.holding.hoursMinutes": "{hours} h {minutes} min",
  "sample.handling.requiredLabel": "Requis :",
  "sample.handling.storedAtLabel": "Stocké à :",
  "sample.handling.arrivedAs": "État à l'arrivée",
  "sample.handling.measuredTemp": "Température mesurée (°C)",
  "sample.handling.measuredTemp.invalid": "Saisissez une température comprise entre -100 et 60 °C.",
  "sample.handling.sameForAll": "Identique pour tous les échantillons",
  "sample.handling.notStored": "Pas encore stocké",
  "sample.handling.storedAt.temperature": "{location} ({degrees} °C)",
  "sample.handling.mismatch": "Écart de manipulation",
  "sample.handling.mismatch.detail": "Nécessite {required} ; {actual}",
  "sample.handling.actual.arrived": "arrivé à l'état : {condition}",
  "sample.handling.actual.measured": "{degrees} °C mesurés à l'arrivée",
  "sample.handling.actual.stored": "stocké à {degrees} °C",
  "sample.handling.reportNonConformity": "Déclarer une non-conformité",
  "sample.condition.roomTemp": "Température ambiante",
  "sample.condition.refrigerated": "Réfrigéré 2 à 8 °C",
  "sample.condition.frozen": "Congelé",
  "sample.condition.onIce": "Sur glace",
  "sample.condition.dryIce": "Glace carbonique",
  "common.notRecorded": "Non enregistré",
  "sample.legacy.recordedBefore": "Enregistré avant cette version",
  "order.continue.item.arrivalTemperature": "La température mesurée de {sample} est en dehors de la plage -100 à 60 °C",
  "order.entry.receivedBy.you": "Reçu par {name} (vous)",
  "order.entry.receivedBy.other": "Reçu par {name}",
  "order.entry.receivedBy.search": "Reçu par",
  "common.change": "Modifications",
  "common.moreActions": "Plus d'actions",
  "order.tests.action.markTestedElsewhere": "Marquer comme analysé ailleurs",
  "order.tests.action.unmarkTestedElsewhere": "Non analysé ailleurs",
  "order.tests.tag.testedElsewhere": "Analysé ailleurs",
  "order.tests.testedElsewhere.help": "Résultat rendu par un autre laboratoire",
  "order.tests.testedElsewhereAt": "Analysé ailleurs : {lab}",
  "order.tests.testedElsewhere.value": "Valeur rapportée",
  "order.tests.testedElsewhere.lab": "Laboratoire exécutant",
  "order.tests.testedElsewhere.saveFailed": "« Analysé ailleurs » n'a pas été enregistré : {reason}",
  "inventory.board.title": "Articles",
  "inventory.board.purpose": "Ce que vous avez et ce qu'il faut réapprovisionner. Développez une ligne pour voir ses lots et leur emplacement.",
  "inventory.board.column.item": "Élément",
  "inventory.board.column.onHand": "En stock",
  "inventory.board.column.runsOut": "Épuisement prévu",
  "inventory.board.byLocation": "Par emplacement :",
  "inventory.board.empty": "Aucun article en stock pour l'instant. Ajoutez un article pour commencer son suivi, puis réceptionnez du stock.",
  "inventory.board.noMatches": "Aucun article ne correspond à votre recherche et à vos filtres. Effacez-les pour voir tout le catalogue.",
  "inventory.board.error": "Impossible de charger le tableau des articles.",
  "inventory.filter.location": "Filtrer par emplacement",
  "inventory.projection.window": "{early} – {late}",
  "inventory.projection.windowOpen": "{early} ou plus tard",
  "inventory.projection.basis": "d'après la consommation jusqu'au {date}",
  "inventory.projection.stale": "À surveiller : les données de consommation sont peut-être obsolètes",
  "inventory.projection.insufficient": "Trop peu de jours de consommation pour projeter une date d'épuisement",
  "inventory.projection.outOfStock": "Rupture de stock",
  "inventory.projection.trend": "Tendance de consommation",
  "inventory.projection.trend.steady": "stable",
  "inventory.projection.trend.change": "{percent} % / {days} j",
  "inventory.projection.medianDailyUse": "Consommation quotidienne médiane : {rate} {units}/jour ({days} derniers jours ; la médiane lisse les pics ponctuels)",
  "inventory.orderBy.label": "Commander avant le",
  "inventory.orderBy.pastDue": "en retard",
  "inventory.orderBy.leadSet": "{days} j (défini)",
  "inventory.orderBy.leadObserved": "~{days} j (observé)",
  "inventory.orderBy.leadDefault": "{days} j (par défaut, à définir pour plus de précision)",
  "inventory.reorderStatus.now": "Réapprovisionner maintenant",
  "inventory.reorderStatus.soon": "Réapprovisionner bientôt",
  "inventory.reorderStatus.adequate": "Suffisant",
  "inventory.reorderStatus.buildingData": "Collecte de données en cours",
  "inventory.lots.useFirst": "À utiliser en premier",
  "inventory.lots.disposeFailedQc": "CQ échoué : éliminer",
  "inventory.lots.flag": "Drapeau",
  "inventory.lots.none": "Aucun lot enregistré pour cet article pour l'instant. Réceptionnez du stock pour commencer son suivi.",
  "inventory.actions.forItem": "Actions en faveur de l’{item}",
  "inventory.actions.forLot": "Actions pour le lot {lot}",
  "inventory.actions.editItem": "Modifier les détails de l'article",
  "inventory.actions.editLot": "Modifier le lot et l'emplacement",
  "inventory.lots.expiringInDays": "Expire dans {days} j",
  "inventory.logUsage.button": "Enregistrer la consommation",
  "inventory.logUsage.title": "Enregistrer la consommation",
  "inventory.logUsage.help": "Enregistrez le stock utilisé à la paillasse. Cela alimente la projection d'épuisement ; pour corriger un comptage, utilisez plutôt Ajuster le stock.",
  "inventory.logUsage.quantityWithUnits": "Quantité utilisée ({units})",
  "inventory.logUsage.onHand": "{quantity} {units} en stock. Les lots dont la péremption est la plus proche sont utilisés en premier.",
  "inventory.logUsage.error.noItem": "Choisissez un article pour lequel enregistrer la consommation.",
  "inventory.logUsage.error.wholeUnits": "Saisissez un nombre entier d'unités, au moins 1.",
  "inventory.receiveStock.button": "Réceptionner du stock",
  "label.testCatalog.basicInfo.opensMicrobiologyCase": "Ouvre un cas de microbiologie",
  "label.testCatalog.basicInfo.microbiologyCaseRole": "Rôle dans le cas",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CULTURE": "Culture",
  "label.testCatalog.basicInfo.microbiologyCaseRole.DIRECT": "Direct",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CASE": "Cas",
  "label.testCatalog.basicInfo.collectedInSets": "Prélevé par séries",
  "microbiology.sets.warning.SINGLE_BOTTLE": "Un seul flacon dans cette série",
  "microbiology.sets.warning.REPEATED_CONTAINER": "Type de contenant répété dans cette série",
  "microbiology.sets.warning.DIFFERENT_SITES": "Sites de prélèvement différents dans cette série",
  "microbiology.sets.warning.COLLECTION_INTERVAL": "Les heures de prélèvement sont espacées de plus de {minutes} minutes",
  "microbiology.sets.title": "Séries de culture",
  "microbiology.sets.count.sets": "{sets, plural, one {# série} many {# séries} other {# séries}}",
  "microbiology.sets.count.bottles": "{bottles, plural, one {# flacon} many {# flacons} other {# flacons}}",
  "microbiology.sets.count.summary": "{sets}, {bottles}",
  "microbiology.sets.number": "Série {number}",
  "microbiology.sets.unassigned": "Série non enregistrée",
  "order.microPreview.title": "Ce que cette demande va ouvrir",
  "order.microPreview.loading": "Mise à jour de l'aperçu de la demande…",
  "order.microPreview.failed": "Aperçu de la demande indisponible",
  "order.microPreview.failedDetail": "L'aperçu n'a pas pu être mis à jour. Vérifiez votre connexion et réessayez.",
  "order.microPreview.opens": "Ouvre un dossier",
  "order.microPreview.ordinary": "Reste dans Résultats",
  "order.microPreview.case": "Dossier {tests} dans {unit} : {samples}",
  "order.microPreview.sample": "Échantillon {type} {number}",
  "order.microPreview.stays": "{test} reste dans Résultats",
  "order.microPreview.splitTag": "Dossiers séparés",
  "order.microPreview.split": "L'échantillon {number} ouvre {count} dossiers : {units}.",
  "order.microPreview.reflex": "{name} : si {conditions}, peut ajouter {tests}.",
  "order.microPreview.component": "{test} - {component}",
  "order.microPreview.specimen": "{test} ({type})",
  "order.microPreview.and": " et ",
  "order.microPreview.or": " ou ",
  "order.microPreview.condition.EQUALS": "Le résultat de {subject} est égal à {value}",
  "order.microPreview.condition.NOT_EQUALS": "Le résultat de {subject} est différent de {value}",
  "order.microPreview.condition.LESS_THAN": "Le résultat de {subject} est inférieur à {value}",
  "order.microPreview.condition.LESS_THAN_OR_EQUAL": "Le résultat de {subject} est d'au plus {value}",
  "order.microPreview.condition.GREATER_THAN": "Le résultat de {subject} est supérieur à {value}",
  "order.microPreview.condition.GREATER_THAN_OR_EQUAL": "Le résultat de {subject} est d'au moins {value}",
  "order.microPreview.condition.BETWEEN": "Le résultat de {subject} est compris entre {value} et {value2}",
  "order.microPreview.condition.INSIDE_NORMAL_RANGE": "Le résultat de {subject} est dans l'intervalle de référence",
  "order.microPreview.condition.OUTSIDE_NORMAL_RANGE": "Le résultat de {subject} est hors de l'intervalle de référence",
  "order.microPreview.newUnitTag": "Nouvelle unité de laboratoire",
  "order.microPreview.newUnit": "{test} ouvre un dossier dans {unit} ; cette demande ne comporte aucun autre travail dans cette unité de laboratoire.",
  "dictionary.containerPopulation": "Population des flacons (contenants d'échantillons)",
  "dictionary.containerPopulation.unspecified": "Non spécifié",
  "dictionary.containerPopulation.ADULT": "Adulte",
  "dictionary.containerPopulation.PAEDIATRIC": "Pédiatrique",
  "microbiology.sets.warning.MIXED_POPULATIONS": "Cette série contient des flacons pédiatriques et adultes.",
  "order.cultureSetNumber": "Numéro de jeu",
  "order.cultureSetNumber.required": "Saisissez un numéro de jeu entier positif.",
  "order.cultureBottle.duplicate": "Flacon en double",
  "microbiology.sets.container": "Type de contenant",
  "microbiology.sets.bodySite": "Site anatomique",
  "inventory.reorder.suggestions": "Suggestions de réapprovisionnement",
  "inventory.reorder.help": "Articles au niveau de leur seuil ou en dessous, ou dont on prévoit qu'ils l'atteindront avant qu'une nouvelle commande puisse arriver. Marquer comme commandé enregistre qu'une commande a été passée ; cela ne passe pas la commande.",
  "inventory.reorder.none": "Rien à commander pour le moment.",
  "inventory.reorder.markOrdered": "Marquer comme commandé",
  "inventory.reorder.onOrder": "En commande",
  "inventory.reorder.note": "Remarque",
  "inventory.reorder.note.placeholder": "Référence de réquisition ou de bon de commande",
  "inventory.reorder.expectedDate": "Date prévue",
  "inventory.reorder.marked": "{count, plural, one {# article marqué comme commandé.} many {# articles marqués comme commandés.} other {# articles marqués comme commandés.}} marked as ordered.",
  "inventory.reorder.reviewAndOrder": "Vérifier et marquer comme commandé",
  "inventory.reorder.clearOrdered": "Finalement non commandé",
  "inventory.reorder.cleared": "{count, plural, one {# article marqué comme commandé.} many {# articles marqués comme commandés.} other {# articles marqués comme commandés.}} no longer marked as ordered.",
  "inventory.board.andMore": "et {count} de plus",
  "inventory.item.leadTime": "Délai de livraison (jours)",
  "inventory.item.leadTime.help": "Temps nécessaire pour que cet article arrive après sa commande. Laissez vide pour qu'il soit déduit de vos propres livraisons.",
  "inventory.item.leadTime.observedSuggest": "Vos dernières livraisons ont pris environ {days} jours.",
  "inventory.item.leadTime.useObserved": "Utiliser cette valeur",
  "inventory.item.tags": "Etiquettes ",
  "inventory.item.tags.help": "Manière dont cet article est regroupé, filtré et présenté dans les rapports. Un article peut avoir plusieurs étiquettes.",
  "inventory.item.tags.add": "Saisissez pour trouver ou ajouter une étiquette",
  "inventory.item.tags.remove": "Retirer l'étiquette {tag}",
  "inventory.item.autoConsume.help": "Il n'existe pas de paramètre de consommation automatique. Lier l'article à une analyse dans le Catalogue de tests permet à la paillasse d'enregistrer son utilisation lors de la saisie des résultats de cette analyse.",
  "inventory.search.placeholder.board": "Rechercher par nom d'article, code, étiquette ou numéro de lot",
  "inventory.filter.tags": "Filtrer par étiquettes",
  "inventory.filter.tags.clear": "Effacer les étiquettes",
  "inventory.tags.manage": "Gérer les étiquettes",
  "inventory.tags.help": "Organisez vos étiquettes. Désactiver une étiquette empêche qu'elle soit suggérée ou proposée comme filtre. Les articles qui la portent déjà la conservent.",
  "inventory.tags.tag": "Etiquette ",
  "inventory.tags.usage": "Articles",
  "inventory.tags.status": "Statut",
  "inventory.tags.active": "Active",
  "inventory.tags.deactivated": "Désactivé",
  "inventory.tags.deactivate": "Désactiver",
  "inventory.tags.reactivate": "Réactiver",
  "inventory.tags.showDeactivated": "Affichage désactivé",
  "inventory.tags.new": "Nouvelle étiquette",
  "inventory.tags.add": "Ajouter une étiquette",
  "inventory.tags.none": "Aucune étiquette pour l'instant. Ajoutez-en une ici ou étiquetez directement un article.",
  "inventory.tags.error.blank": "Une étiquette doit avoir un nom.",
  "inventory.item.new": "Nouvel article",
  "inventory.item.created": "Article défini. Réceptionnez du stock pour cet article afin de commencer le suivi des quantités.",
  "inventory.item.showDeactivated": "Affichage désactivé",
  "inventory.item.deactivated": "Désactivé",
  "inventory.item.deactivate": "Désactiver l'article",
  "inventory.item.reactivate": "Réactiver l'article",
  "inventory.item.reactivated": "{item} est de nouveau actif.",
  "inventory.item.deactivated.success": "{item} est désactivé. Utilisez Afficher les désactivés pour le retrouver.",
  "inventory.item.deactivate.confirm.title": "Désactiver cet article ?",
  "inventory.item.deactivate.confirm": "Désactiver {item} ?",
  "inventory.item.deactivate.implication.hidden": "Il disparaît du tableau et n'est plus proposé lors de la réception ou de l'enregistrement de la consommation.",
  "inventory.item.deactivate.implication.stock": "Ses lots et son historique sont conservés, et le stock qu'il contient encore n'est pas sorti des comptes.",
  "inventory.item.deactivate.implication.reversible": "Vous pouvez le réactiver à tout moment depuis Afficher les désactivés.",
  "catalog.item.catalogNumber": "Référence catalogue",
  "catalog.item.expirationAlertDays": "Avertir ce nombre de jours avant l'expiration",
  "catalog.item.trackLots": "Suivre les lots et l'expiration",
  "catalog.item.trackLots.help": "Activez cette option pour tout ce qui est reçu par lots avec une date d'expiration. Désactivez-la pour les consommables comptés comme un seul ensemble.",
  "catalog.item.form.help": "Ceci définit un type d'article. Pour ajouter des unités d'un article existant, utilisez Réceptionner du stock.",
  "inventory.item.form.title.add": "Nouvel article",
  "inventory.item.form.title.edit": "Modifier l'article",
  "inventory.count.enter": "Mode inventaire",
  "inventory.count.leave": "Quitter le mode inventaire",
  "inventory.count.confirm": "Confirmer l'inventaire",
  "inventory.count.expected": "sur {expected} {units}",
  "inventory.count.matches": "Concorde",
  "inventory.count.perLot": "Comptez chaque lot ci-dessous ({expected} {units} attendus ici)",
  "inventory.count.nothingHere": "Rien à compter ici",
  "inventory.count.countOf": "Quantité comptée pour {item}",
  "inventory.count.tally": "{counted, plural, =0 {Rien compté pour l'instant} one {# lot compté} other {# lots comptés}}",
  "inventory.count.scoped": "Inventaire de {location}. Seul le stock de cet emplacement est listé, et seul ce que vous saisissez est validé.",
  "inventory.count.unscoped": "Inventaire de tous les emplacements. Filtrez par emplacement pour compter une étagère à la fois. Seul ce que vous saisissez est validé.",
  "inventory.count.done": "Inventaire enregistré : {adjusted, plural, =0 {aucune correction} one {# correction} other {# corrections}}, {confirmed, plural, =0 {aucun confirmé} one {# lot confirmé} other {# lots confirmés}}.",
  "inventory.count.lastCounted": "Compté le {date}",
  "inventory.count.neverCounted": "Jamais compté",
  "inventory.count.column": "Dernier inventaire",
  "inventory.delivery.purpose": "Saisissez une livraison. Scannez un carton, indiquez la quantité arrivée, ajoutez-la, puis scannez le suivant. Rien n'est enregistré tant que vous n'avez pas confirmé l'ensemble de la livraison.",
  "inventory.delivery.scan": "Scanner le carton",
  "inventory.delivery.scan.help": "Une étiquette GS1 renseigne le produit, le lot et la date de péremption. Ce qu'elle ne contient pas peut être saisi ci-dessous.",
  "inventory.delivery.scan.unread": "Ce code n'a pas été reconnu. Saisissez la ligne manuellement.",
  "inventory.delivery.partialScan": "Partiellement scanné",
  "inventory.delivery.add": "Ajouter à la livraison",
  "inventory.delivery.remove": "Retirer",
  "inventory.delivery.confirm": "Réceptionner {count, plural, one {# ligne} other {# lignes}}",
  "inventory.delivery.discard": "Abandonner la livraison",
  "inventory.delivery.received": "{count, plural, one {# ligne réceptionnée.} many {# lignes réceptionnées.} other {# lignes réceptionnées.}} received.",
  "inventory.delivery.expired": "Ce lot a déjà dépassé sa date d'expiration",
  "inventory.delivery.expired.help": "Vous pouvez quand même le réceptionner. Un stock à péremption proche est une livraison normale, et le tableau le signalera.",
  "catalog.item.upc": "Code-barres du produit (UPC ou GTIN)",
  "catalog.item.upc.help": "Le code-barres du fabricant pour ce produit. Chaque boîte porte le même code : le scanner indique de quel article il s'agit, pas quel lot est arrivé.",
  "inventory.receive.title": "Réceptionner du stock",
  "inventory.receive.submit": "Réception",
  "inventory.receive.success": "{quantity} {units} réceptionné(s). Ce stock est compté en stock dès maintenant et pourra être utilisé une fois son CQ réussi.",
  "inventory.receive.help": "Ajoute du stock à un article qui existe déjà. Pour définir un nouvel article, utilisez Nouvel article.",
  "inventory.receive.scan": "Scanner un code-barres de produit",
  "inventory.receive.scan.help": "Scannez ou saisissez un code UPC pour choisir l'article sans le rechercher.",
  "inventory.receive.scan.unknown": "Aucun article ne porte ce code-barres",
  "inventory.receive.quantityWithUnits": "Quantité réceptionnée ({units})",
  "inventory.receive.lotNumber.help": "Laissez vide pour qu'un numéro soit généré à partir du code de l'article et de la date du jour.",
  "inventory.receive.location.optional": "Non attribué. Vous pouvez le définir maintenant ou plus tard depuis le lot.",
  "inventory.receive.error.noItem": "Choisissez l'article réceptionné.",
  "inventory.receive.error.quantity": "Indiquez la quantité arrivée.",
  "inventory.receive.error.locationAfterReceive": "Le stock a été réceptionné, mais l'emplacement de stockage n'a pas pu être attribué : {reason}",
  "reports.type.received": "Reçu",
  "reports.type.received.description": "Ce qui est arrivé sur la période, par article et par lot.",
  "reports.type.consumed": "Consommé",
  "reports.type.consumed.description": "Ce qui a été utilisé sur la période, totalisé par article.",
  "reports.type.stockOnHand": "Stock disponible",
  "reports.type.stockOnHand.description": "Ce que vous détenez, lot par lot, avec les dates de péremption.",
  "reports.type.expiring": "Expiration",
  "reports.type.expiring.description": "Lots dont la péremption tombe dans une période que vous choisissez.",
  "reports.asOfDate": "À la date du",
  "reports.asOfDate.help": "Laissez vide pour le stock actuel.",
  "reports.expiringFrom": "Péremption à partir du",
  "reports.expiringTo": "Péremption jusqu'au",
  "reports.tags": "Etiquettes ",
  "reports.tags.help": "Limiter le rapport aux articles portant l'une de ces étiquettes.",
  "reports.tags.placeholder": "Toute étiquette",
  "reports.run": "Exécuter le rapport",
  "reports.running": "Exécution en cours...",
  "reports.empty": "Aucun résultat ne correspond à ces filtres.",
  "reports.empty.stockOnHandAsOf": "Aucun mouvement de stock n'est enregistré à cette date ou avant, le stock de l'époque ne peut donc pas être reconstitué. Cela ne signifie pas qu'aucun stock n'était détenu.",
  "reports.asOfDate.basis": "Reconstitué à partir des mouvements de stock enregistrés jusqu'à cette date, et non à partir d'un inventaire physique.",
  "order.continue.item.eqaScheme": "Choisir le programme EEQ",
  "order.eqa.cycle": "Cycle",
  "order.eqa.cycle.none": "Aucun cycle",
  "order.eqa.cycleNotInScheme": "Le cycle choisi n'est pas un cycle ouvert de ce programme EEQ.",
  "order.eqa.newCycle": "Nouveau cycle",
  "order.eqa.noCycle.warning": "Cet échantillon n'est rattaché à aucun cycle : il ne sera ni soumis ni évalué depuis OpenELIS.",
  "order.eqa.noEnrollments.link": "S'inscrire dans Mes programmes EEQ",
  "order.eqa.noEnrollments.title": "Ce laboratoire n'est inscrit à aucun programme EEQ actif.",
  "order.eqa.providerSampleId.codes": "Codes de panel de ce cycle : {codes}",
  "order.eqa.providerSampleId.noMatch": "Ce code ne correspond à aucun code de panel du cycle ({codes}).",
  "order.eqa.scheme": "Programme EQE",
  "order.eqa.scheme.choose": "Choisissez un programme",
  "order.eqa.schemeRequired": "Choisissez le programme EEQ auquel appartient cet échantillon.",
  "order.eqa.schemeUnknown": "Le programme EEQ choisi ne fait pas partie des inscriptions actives de ce laboratoire.",
  "order.save.requirement.eqaScheme": "le programme EEQ",
  "save.order.success.labNumber": "La demande {labNumber} a été enregistrée.",
  "qc.status.error.required": "Sélectionnez un statut CQ.",
  "qc.status.error.notesRequired": "Indiquez pourquoi le CQ a échoué.",
  "disposal.error.reasonRequired": "Sélectionnez un motif d'élimination.",
  "common.error.notesRequiredForOther": "Ajoutez une note pour expliquer le motif choisi.",
  "adjustment.error.negativeQuantity": "La quantité ne peut pas être négative.",
  "adjustment.error.reasonRequired": "Sélectionnez un motif d'ajustement.",
  "lot.error.numberRequired": "Le numéro de lot est obligatoire.",
  "lot.error.locationRequired": "Attribuez un emplacement de stockage.",
  "lot.status.select": "Sélectionnez le statut du lot",
  "catalog.item.error.nameRequired": "Le nom de l'article est obligatoire.",
  "sidenav.label.inventory.items": "Articles",
  "sidenav.label.inventory.items.tooltip": "Ce que vous avez et ce qu'il faut recommander",
  "sidenav.label.inventory.receive": "Réception",
  "sidenav.label.inventory.receive.tooltip": "Saisir une livraison, en scannant ou en tapant chaque ligne",
  "sidenav.label.inventory.reports": "Rapports",
  "sidenav.label.inventory.reports.tooltip": "Reçu, consommé, stock disponible et lots arrivant à expiration",
  "inventory.import.button": "Import items",
  "inventory.import.title": "Import items from a file",
  "inventory.import.help": "Define many items at once from a CSV file. The preview shows what the file would do and saves nothing; only Apply writes anything. Re-importing a corrected file updates the same items rather than adding them again.",
  "inventory.import.template": "Download the template",
  "inventory.import.dropzone": "Add a CSV file",
  "inventory.import.preview": "Preview",
  "inventory.import.apply": "Appliquer",
  "inventory.import.plan.title": "What this file would do",
  "inventory.import.result.title": "What was imported",
  "inventory.import.column.line": "Ligne",
  "inventory.import.column.outcome": "Résultat",
  "inventory.import.column.reason": "Motif",
  "inventory.import.outcome.create": "Nouveau",
  "inventory.import.outcome.update": "Mis à Jour ",
  "inventory.import.outcome.unchanged": "Inchangé",
  "inventory.import.outcome.skip": "Ignoré",
  "inventory.import.count.created": "{count} new",
  "inventory.import.count.updated": "{count} mis(e) à jour",
  "inventory.import.count.unchanged": "{count} inchangé",
  "inventory.import.count.skipped": "{count} sauté",
  "inventory.import.error.rowsTitle": "Some rows cannot be used",
  "inventory.import.error.rowsMessage": "The rows listed below will be skipped. Applying saves the rest; fix those rows and add the file again to include them.",
  "inventory.import.error.unreadable": "That file could not be read.",
  "inventory.import.error.failed": "The file could not be imported.",
  "inventory.import.nothingToDo": "This file would change nothing",
  "inventory.import.nothingToDo.help": "Every item in it already matches what is stored.",
  "sidenav.label.reports.printQueue": "Report Print Queue",
  "reportQueue.title": "Report Print Queue",
  "reportQueue.subtitle": "Print, reprint and reissue released reports",
  "reportQueue.guidance.lead": "Reports land here when their first result is released.",
  "reportQueue.guidance.body": "Printed reports come back when more results are released or a printed result changes.",
  "reportQueue.legend.partial": "Some results are not released yet",
  "reportQueue.legend.final": "Every result is released",
  "reportQueue.legend.amended": "A printed result changed, or the report was reissued with a correction",
  "reportQueue.legend.unprinted": "The current content has not been printed yet",
  "reportQueue.legend.printed": "The last print matches what is released",
  "reportQueue.tile.toPrint": "To print",
  "reportQueue.tile.amendedToPrint": "Amended to print",
  "reportQueue.type.patient": "Patient report",
  "reportQueue.state.partial": "Partial {released}/{total}",
  "reportQueue.state.partialName": "Partial",
  "reportQueue.state.final": "Finale",
  "reportQueue.state.amended": "Modifié",
  "reportQueue.state.amendedPartial": "Amended {released}/{total}",
  "reportQueue.printStatus.unprinted": "Unprinted",
  "reportQueue.printStatus.printed": "Printed",
  "reportQueue.col.type": "Type",
  "reportQueue.col.labNoName": "Lab No / Name",
  "reportQueue.col.subject": "Objet",
  "reportQueue.col.details": "Détails",
  "reportQueue.col.released": "Released / Submitted",
  "reportQueue.col.state": "État",
  "reportQueue.col.printStatus": "Print status",
  "reportQueue.col.version": "Version",
  "reportQueue.version.none": "Not printed",
  "reportQueue.version.value": "v{n}",
  "reportQueue.action.print": "Imprimer",
  "reportQueue.print.disabled.nothingReleased": "Nothing released yet on this order",
  "reportQueue.print.success": "{count, plural, one {# report} other {# reports}} ready",
  "reportQueue.print.failed": "Could not prepare {count, plural, one {# report} other {# reports}}: {labNumbers}",
  "reportQueue.print.reprinted": "Reprinted version {n} of {labNumber}",
  "reportQueue.print.issued": "Printed version {n} of {labNumber}",
  "reportQueue.print.popupBlocked": "The browser blocked the report window for {labNumber}",
  "reportQueue.print.open": "Open the report",
  "reportQueue.filter.labNo.placeholder": "Scan or type lab number",
  "reportQueue.filter.labNo.helper": "Scanning a barcode applies the filter instantly",
  "reportQueue.filter.labNo.range": "Plage",
  "reportQueue.filter.labNo.to": "To lab number",
  "reportQueue.filter.patient": "Recherche par Patient",
  "reportQueue.filter.state": "État",
  "reportQueue.filter.printStatus": "Print status",
  "reportQueue.filter.window": "Time window",
  "reportQueue.filter.window.24h": "Last 24 hours",
  "reportQueue.filter.window.7d": "Last 7 days",
  "reportQueue.filter.window.30d": "Last 30 days",
  "reportQueue.filter.window.all": "All time",
  "reportQueue.filter.window.custom": "Custom range",
  "reportQueue.filter.window.to": "À",
  "reportQueue.filter.window.helper": "Applies to printed reports; unprinted ones always show",
  "reportQueue.filter.facility": "Établissement",
  "reportQueue.filter.ward": "Ward / Dept / Unit",
  "reportQueue.filter.ward.disabled": "Select a facility first",
  "reportQueue.filter.typeahead.helper": "Type 2 or more characters to search",
  "reportQueue.filter.clear": "Effacer les filtres",
  "reportQueue.search.active.labNo": "Lab No: {labNo}",
  "reportQueue.search.active.labRange": "Lab No: {from} to {to}",
  "reportQueue.search.active.patient": "Patient: {name}",
  "reportQueue.search.clear": "Effacer la recherche",
  "reportQueue.search.disabledHelper": "Other filters are off while you look up a specific order",
  "reportQueue.empty": "Nothing to print. Every released report in this view has been printed.",
  "reportQueue.error.load": "Could not load the queue.",
  "reportQueue.detail.tests": "Analyses",
  "reportQueue.detail.order": "Demande d'examen",
  "reportQueue.detail.validatedBy": "Validated by",
  "reportQueue.detail.awaitingValidation": "Awaiting validation",
  "reportQueue.detail.inProgress": "En cours",
  "reportQueue.history.title": "Version history",
  "reportQueue.history.issued": "Issued",
  "reportQueue.history.by": "Par",
  "reportQueue.history.change": "Modifications",
  "reportQueue.history.firstIssue": "First issue",
  "reportQueue.history.completeness": "Completeness",
  "reportQueue.history.fingerprint": "Fingerprint",
  "reportQueue.history.openPdf": "Open PDF",
  "reportQueue.history.reprinted": "Reprinted {date} by {user}",
  "reportQueue.history.notArchived": "Not archived (issued before {date})",
  "reportQueue.history.archiveFailed": "Archive failed",
  "reportQueue.history.none": "Nothing printed yet",
  "sidenav.label.reports.sentMessages": "Messages envoyés",
  "sidenav.label.admin.notifications": "Notifications",
  "sidenav.label.admin.notifications.channels": "Chaînes",
  "sidenav.label.admin.notifications.templates": "Modèles",
  "sidenav.label.admin.notifications.delivery": "Delivery Settings",
  "sidenav.label.admin.notifications.triggers": "Déclencheurs",
  "delivery.sent.title": "Messages envoyés",
  "delivery.sent.subtitle": "Every message the laboratory sent or tried to send: reports, alerts, notices, notification triggers and channel tests",
  "delivery.sent.empty": "Nothing sent in this period.",
  "delivery.sent.loadError": "The messages could not be loaded",
  "delivery.sent.resend": "Renvoyer",
  "delivery.sent.resend.done": "Message queued again.",
  "delivery.sent.resend.failed": "The message could not be queued again.",
  "delivery.sent.sentBy.auto": "Automatic",
  "delivery.sent.col.time": "Heure",
  "delivery.sent.col.product": "Product",
  "delivery.sent.col.labNo": "Numéro laboratoire",
  "delivery.sent.col.recipient": "Destinataire",
  "delivery.sent.col.channel": "Chaîne",
  "delivery.sent.col.status": "Statut",
  "delivery.sent.col.attempts": "Tentatives",
  "delivery.sent.col.sentBy": "Sent by",
  "delivery.sent.filter.product": "Product",
  "delivery.sent.filter.status": "Statut",
  "delivery.sent.filter.channel": "Chaîne",
  "delivery.sent.filter.to": "À",
  "delivery.sent.filter.recipient": "Destinataire",
  "delivery.sent.filter.all": "Tous",
  "delivery.sent.detail.subject": "Objet",
  "delivery.sent.detail.message": "Message",
  "delivery.sent.detail.attempts": "Tentatives",
  "delivery.sent.detail.noAttempts": "No attempt yet",
  "delivery.sent.detail.nextAttempt": "Next attempt {time}",
  "delivery.sent.detail.rule": "Règle",
  "delivery.sent.detail.report": "Report version {n}, {format}",
  "delivery.sent.detail.openOrder": "Open the order",
  "delivery.sent.detail.openQueue": "Open in the Report Print Queue",
  "delivery.sent.detail.loadError": "The message could not be loaded",
  "delivery.status.queued": "En file d'attente",
  "delivery.status.sent": "Envoyé",
  "delivery.status.failed": "Failed",
  "delivery.status.skipped": "Ignoré",
  "delivery.product.report": "Rapport",
  "delivery.product.alert": "Alert",
  "delivery.product.notice": "Ready notice",
  "delivery.product.trigger": "Notification",
  "delivery.product.test": "Test",
  "delivery.format.protected": "Protected full report",
  "delivery.format.masked": "Masked copy",
  "delivery.channel.email": "E-mail",
  "delivery.channel.sms": "SMS",
  "delivery.channel.whatsapp": "WhatsApp",
  "delivery.channel.title": "Chaînes",
  "delivery.channel.subtitle": "Email, SMS and WhatsApp are set up here once and used by every message the laboratory sends",
  "delivery.channel.status.ready": "Prêt",
  "delivery.channel.status.notSetUp": "Not set up",
  "delivery.channel.status.failing": "Failing",
  "delivery.channel.lastSuccess": "Last successful send",
  "delivery.channel.never": "Jamais",
  "delivery.channel.lastError": "Last error",
  "delivery.channel.active": "Active",
  "delivery.channel.host": "SMTP host",
  "delivery.channel.port": "Port",
  "delivery.channel.security": "Security",
  "delivery.channel.security.starttls": "STARTTLS",
  "delivery.channel.security.ssl": "SSL/TLS",
  "delivery.channel.security.none": "Aucun",
  "delivery.channel.username": "Nom d'utilisateur",
  "delivery.channel.password": "Mot de passe",
  "delivery.channel.secretSet": "Set",
  "delivery.channel.secretHelper": "A secret is stored. Leave this blank to keep it.",
  "delivery.channel.replace": "Remplacer",
  "delivery.channel.senderAddress": "Sender address",
  "delivery.channel.senderName": "Sender name",
  "delivery.channel.replyTo": "Reply-to address",
  "delivery.channel.whatsapp.accountSid": "Account SID",
  "delivery.channel.whatsapp.token": "Auth token",
  "delivery.channel.whatsapp.from": "Sending number",
  "delivery.channel.whatsapp.address": "API address (optional)",
  "delivery.channel.countryCode": "Default country code",
  "delivery.channel.gateway": "Gateway",
  "delivery.channel.sms.note": "The SMS gateway (BMP or SMPP) keeps its settings in the server properties until its own change lands; this row shows whether one is enabled.",
  "delivery.channel.save": "Sauvegarder",
  "delivery.channel.saved": "Channel saved.",
  "delivery.channel.saveFailed": "The channel could not be saved: check {field}.",
  "delivery.channel.sendTest": "Send test",
  "delivery.channel.test.title": "Send a test message",
  "delivery.channel.test.address": "Adresse",
  "delivery.channel.test.send": "Envoyer",
  "delivery.channel.test.sent": "Test message sent.",
  "delivery.channel.test.failed": "The test message was not sent.",
  "delivery.settings.title": "Delivery Settings",
  "delivery.settings.subtitle": "Lab-wide rules for how reports, alerts and notices are sent",
  "delivery.settings.retryDelays": "Retry after (minutes, in order)",
  "delivery.settings.retryDelays.helper": "For example 1,5,15: a failed send is tried again after 1, 5 and 15 minutes, then marked Failed",
  "delivery.settings.defaultFormat": "Format for recipients without a password",
  "delivery.settings.hold": "Wait before sending a new version (minutes)",
  "delivery.settings.partials": "Send partial reports automatically",
  "delivery.settings.contact": "Lab contact line",
  "delivery.settings.contact.helper": "Phone, email and opening hours, as printed in notices",
  "delivery.settings.location": "Where reports are sent from",
  "delivery.settings.location.local": "This lab",
  "delivery.settings.location.central": "Central delivery service",
  "delivery.settings.centralAddress": "Central delivery service address",
  "delivery.settings.centralConfirm": "Reports, alerts and patient notices for this lab will be sent by the central service at {address}. This lab will stop sending them.",
  "delivery.settings.links": "Secure links",
  "delivery.settings.linkDays": "Link lifetime (days)",
  "delivery.settings.countryCode": "Default country code",
  "delivery.settings.save": "Sauvegarder",
  "delivery.settings.saved": "Settings saved.",
  "delivery.settings.invalid": "The settings could not be saved: check {field}.",
  "externalconnections.password.set": "A password is stored. Leave this blank to keep it.",
  "notificationtrigger.referralrejected.name": "Referral result rejected",
  "notificationtrigger.referralrejected.description": "Sent when a result returned by the reference laboratory is rejected and the sample must be collected again.",
  "notificationtrigger.templates.referralrejected.description": "Sent to the ordering provider or the submitting user when a returned referral result is rejected.",
  "notificationtrigger.referralnudge.name": "Referral nudge",
  "notificationtrigger.referralnudge.description": "Sent to the reference laboratory's contact when a referral is overdue and a nudge is requested.",
  "notificationtrigger.templates.referralnudge.description": "Sent to the chain-of-custody contact at the reference laboratory when a result is awaited.",
  "notificationtrigger.sampleresampled.name": "Sample re-collection",
  "notificationtrigger.sampleresampled.description": "Sent when an order is marked for re-collection and a replacement order is created.",
  "notificationtrigger.templates.sampleresampled.description": "Sent to the ordering provider or the submitting user when a sample must be collected again.",
  "notificationtrigger.testresult.name": "Patient results ready",
  "notificationtrigger.testresult.description": "Sent to the patient or the provider when a test configured under Test Notifications has a released result.",
  "notificationtrigger.templates.testresult.description": "Sent to the patient or the provider when a configured test's result is released. It never names the patient."
}
